{
  "level": "nrt01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:nrt01",
    "objects": "AREAS.E3:nrt01.e3",
    "mesh": "TREES.E3:nrt01.e3"
  },
  "spawn_point": {
    "position": [
      517.6931416861568,
      1016.2609746449868,
      -66.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      517.6931416861568,
      1116.2609746449868,
      -66.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      367.0,
      715.0,
      -90.0
    ],
    "bbox_max": [
      633.0,
      1298.4000244140625,
      56.3599853515625
    ],
    "vertex_count": 3798,
    "vertices": [
      [
        568.604736328125,
        822.2566528320312,
        48.0
      ],
      [
        510.36480712890625,
        822.2566528320312,
        48.0
      ],
      [
        532.1715698242188,
        808.0,
        48.0
      ],
      [
        546.313720703125,
        808.0,
        48.0
      ],
      [
        546.313720703125,
        799.7999877929688,
        48.0
      ],
      [
        532.1715698242188,
        799.7999877929688,
        48.0
      ],
      [
        532.1715698242188,
        799.7999877929688,
        48.0
      ],
      [
        532.1715698242188,
        808.0,
        48.0
      ],
      [
        546.313720703125,
        808.0,
        48.0
      ],
      [
        546.313720703125,
        799.7999877929688,
        48.0
      ],
      [
        568.604736328125,
        822.2566528320312,
        48.0
      ],
      [
        570.9638061523438,
        824.5,
        48.0
      ],
      [
        510.36480712890625,
        822.2566528320312,
        48.0
      ],
      [
        508.0057373046875,
        824.5,
        48.0
      ],
      [
        597.5687866210938,
        827.0,
        48.0
      ],
      [
        597.5687866210938,
        867.9398803710938,
        48.0
      ],
      [
        481.4007873535156,
        867.9398803710938,
        48.0
      ],
      [
        481.4007873535156,
        827.0,
        48.0
      ],
      [
        538.780029296875,
        856.219970703125,
        56.3599853515625
      ],
      [
        538.780029296875,
        854.780029296875,
        56.3599853515625
      ],
      [
        538.780029296875,
        854.780029296875,
        54.91998291015625
      ],
      [
        538.780029296875,
        856.219970703125,
        54.91998291015625
      ],
      [
        540.219970703125,
        856.219970703125,
        54.91998291015625
      ],
      [
        540.219970703125,
        854.780029296875,
        54.91998291015625
      ],
      [
        540.219970703125,
        854.780029296875,
        56.3599853515625
      ],
      [
        540.219970703125,
        856.219970703125,
        56.3599853515625
      ],
      [
        528.7000122070312,
        854.780029296875,
        54.91998291015625
      ],
      [
        528.7000122070312,
        856.219970703125,
        54.91998291015625
      ],
      [
        528.7000122070312,
        856.219970703125,
        56.3599853515625
      ],
      [
        528.7000122070312,
        854.780029296875,
        56.3599853515625
      ],
      [
        531.5800170898438,
        854.780029296875,
        56.3599853515625
      ],
      [
        531.5800170898438,
        856.219970703125,
        56.3599853515625
      ],
      [
        531.5800170898438,
        856.219970703125,
        54.91998291015625
      ],
      [
        531.5800170898438,
        854.780029296875,
        54.91998291015625
      ],
      [
        547.4199829101562,
        853.9799194335938,
        53.0
      ],
      [
        547.4199829101562,
        857.0200805664062,
        53.0
      ],
      [
        549.3153686523438,
        857.0200805664062,
        53.0
      ],
      [
        549.3153686523438,
        853.9799194335938,
        53.0
      ],
      [
        547.4199829101562,
        857.0200805664062,
        53.0
      ],
      [
        549.3153686523438,
        857.0200805664062,
        53.0
      ],
      [
        549.3153686523438,
        853.9799194335938,
        53.0
      ],
      [
        547.4199829101562,
        853.9799194335938,
        53.0
      ],
      [
        541.0200805664062,
        863.4199829101562,
        53.0
      ],
      [
        537.9799194335938,
        863.4199829101562,
        53.0
      ],
      [
        537.9799194335938,
        865.3153686523438,
        53.0
      ],
      [
        541.0200805664062,
        865.3153686523438,
        53.0
      ],
      [
        537.9799194335938,
        863.4199829101562,
        53.0
      ],
      [
        537.9799194335938,
        865.3153686523438,
        53.0
      ],
      [
        541.0200805664062,
        865.3153686523438,
        53.0
      ],
      [
        541.0200805664062,
        863.4199829101562,
        53.0
      ],
      [
        531.5800170898438,
        857.0200805664062,
        53.0
      ],
      [
        531.5800170898438,
        853.9799194335938,
        53.0
      ],
      [
        529.6846313476562,
        853.9799194335938,
        53.0
      ],
      [
        529.6846313476562,
        857.0200805664062,
        53.0
      ],
      [
        529.6846313476562,
        857.0200805664062,
        53.0
      ],
      [
        531.5800170898438,
        857.0200805664062,
        53.0
      ],
      [
        531.5800170898438,
        853.9799194335938,
        53.0
      ],
      [
        529.6846313476562,
        853.9799194335938,
        53.0
      ],
      [
        541.0200805664062,
        845.6846313476562,
        53.0
      ],
      [
        537.9799194335938,
        845.6846313476562,
        53.0
      ],
      [
        537.9799194335938,
        847.5800170898438,
        53.0
      ],
      [
        541.0200805664062,
        847.5800170898438,
        53.0
      ],
      [
        537.9799194335938,
        845.6846313476562,
        53.0
      ],
      [
        537.9799194335938,
        847.5800170898438,
        53.0
      ],
      [
        541.0200805664062,
        847.5800170898438,
        53.0
      ],
      [
        541.0200805664062,
        845.6846313476562,
        53.0
      ],
      [
        553.61279296875,
        911.8958740234375,
        48.0
      ],
      [
        525.3568115234375,
        911.8958740234375,
        48.0
      ],
      [
        590.5465087890625,
        884.8936157226562,
        48.0
      ],
      [
        570.56640625,
        904.8734741210938,
        48.0
      ],
      [
        508.4031982421875,
        904.8734741210938,
        48.0
      ],
      [
        488.4231872558594,
        884.8936157226562,
        48.0
      ],
      [
        573.5927734375,
        827.0,
        48.0
      ],
      [
        597.5687866210938,
        827.0,
        48.0
      ],
      [
        481.4007873535156,
        827.0,
        48.0
      ],
      [
        505.3768005371094,
        827.0,
        48.0
      ],
      [
        573.5927734375,
        827.0,
        48.0
      ],
      [
        505.3768005371094,
        827.0,
        48.0
      ],
      [
        488.4231872558594,
        884.8936157226562,
        48.0
      ],
      [
        481.4007873535156,
        867.9398803710938,
        48.0
      ],
      [
        597.5687866210938,
        867.9398803710938,
        48.0
      ],
      [
        590.5465087890625,
        884.8936157226562,
        48.0
      ],
      [
        525.3568115234375,
        911.8958740234375,
        48.0
      ],
      [
        508.4031982421875,
        904.8734741210938,
        48.0
      ],
      [
        570.56640625,
        904.8734741210938,
        48.0
      ],
      [
        553.61279296875,
        911.8958740234375,
        48.0
      ],
      [
        546.313720703125,
        799.7999877929688,
        30.0
      ],
      [
        532.1715698242188,
        799.7999877929688,
        30.0
      ],
      [
        532.1715698242188,
        808.0,
        32.972023010253906
      ],
      [
        546.313720703125,
        808.0,
        32.97201919555664
      ],
      [
        532.1715698242188,
        799.7999877929688,
        30.0
      ],
      [
        532.1715698242188,
        808.0,
        32.97201919555664
      ],
      [
        532.1715698242188,
        805.1805419921875,
        30.0
      ],
      [
        546.313720703125,
        808.0,
        32.972023010253906
      ],
      [
        546.313720703125,
        799.7999877929688,
        30.0
      ],
      [
        546.313720703125,
        805.1805419921875,
        30.0
      ],
      [
        597.5687866210938,
        827.0,
        30.0
      ],
      [
        597.5687866210938,
        867.9398803710938,
        30.0
      ],
      [
        481.4007873535156,
        867.9398803710938,
        30.0
      ],
      [
        481.4007873535156,
        827.0,
        30.0
      ],
      [
        553.61279296875,
        911.8958740234375,
        30.0
      ],
      [
        525.3568115234375,
        911.8958740234375,
        30.0
      ],
      [
        590.5465087890625,
        884.8936157226562,
        30.0
      ],
      [
        570.56640625,
        904.8734741210938,
        30.0
      ],
      [
        508.4031982421875,
        904.8734741210938,
        30.0
      ],
      [
        488.4231872558594,
        884.8936157226562,
        30.0
      ],
      [
        573.5927734375,
        827.0,
        30.0
      ],
      [
        597.5687866210938,
        827.0,
        30.0
      ],
      [
        481.4007873535156,
        827.0,
        30.0
      ],
      [
        505.3768005371094,
        827.0,
        30.0
      ],
      [
        525.3568115234375,
        808.0,
        30.0
      ],
      [
        505.3768005371094,
        827.0,
        30.0
      ],
      [
        553.61279296875,
        808.0,
        30.0
      ],
      [
        573.5927734375,
        827.0,
        30.0
      ],
      [
        526.806396484375,
        808.0,
        30.0
      ],
      [
        525.3568115234375,
        808.0,
        30.0
      ],
      [
        553.61279296875,
        808.0,
        30.0
      ],
      [
        552.0601806640625,
        808.0,
        30.0
      ],
      [
        552.0601806640625,
        808.0,
        30.0
      ],
      [
        526.806396484375,
        808.0,
        30.0
      ],
      [
        532.1715698242188,
        808.0,
        30.0
      ],
      [
        546.313720703125,
        808.0,
        30.0
      ],
      [
        546.313720703125,
        808.0,
        30.0
      ],
      [
        532.1715698242188,
        808.0,
        30.0
      ],
      [
        488.4231872558594,
        884.8936157226562,
        30.0
      ],
      [
        481.4007873535156,
        867.9398803710938,
        30.0
      ],
      [
        597.5687866210938,
        867.9398803710938,
        30.0
      ],
      [
        590.5465087890625,
        884.8936157226562,
        30.0
      ],
      [
        525.3568115234375,
        911.8958740234375,
        30.0
      ],
      [
        508.4031982421875,
        904.8734741210938,
        30.0
      ],
      [
        570.56640625,
        904.8734741210938,
        30.0
      ],
      [
        553.61279296875,
        911.8958740234375,
        30.0
      ],
      [
        597.5687866210938,
        827.0,
        10.0
      ],
      [
        597.5687866210938,
        867.93994140625,
        10.0
      ],
      [
        481.4007873535156,
        867.93994140625,
        10.0
      ],
      [
        481.4007873535156,
        827.0,
        10.0
      ],
      [
        553.61279296875,
        911.8958740234375,
        10.000000953674316
      ],
      [
        525.3568115234375,
        911.8958740234375,
        10.0
      ],
      [
        590.5464477539062,
        884.8935546875,
        10.000000953674316
      ],
      [
        570.56640625,
        904.87353515625,
        10.0
      ],
      [
        508.4031982421875,
        904.87353515625,
        10.000000953674316
      ],
      [
        488.4232177734375,
        884.8935546875,
        10.0
      ],
      [
        525.3568115234375,
        808.0,
        10.0
      ],
      [
        505.3768005371094,
        827.0,
        10.0
      ],
      [
        481.4007873535156,
        827.0,
        10.0
      ],
      [
        505.3768005371094,
        827.0,
        10.0
      ],
      [
        533.9797973632812,
        799.7999877929688,
        30.0
      ],
      [
        532.1715698242188,
        799.7999877929688,
        10.0
      ],
      [
        533.9797973632812,
        799.7999877929688,
        10.0
      ],
      [
        532.1715698242188,
        799.7999877929688,
        10.0
      ],
      [
        532.1715698242188,
        801.51953125,
        30.0
      ],
      [
        532.1715698242188,
        801.51953125,
        10.0
      ],
      [
        553.61279296875,
        808.0,
        10.0
      ],
      [
        573.5928344726562,
        827.0,
        10.0
      ],
      [
        573.5927734375,
        827.0,
        10.0
      ],
      [
        597.5687866210938,
        827.0,
        10.0
      ],
      [
        546.313720703125,
        799.7999877929688,
        10.0
      ],
      [
        544.9898071289062,
        799.7999877929688,
        30.0
      ],
      [
        544.9898071289062,
        799.7999877929688,
        10.0
      ],
      [
        546.313720703125,
        801.0589599609375,
        30.0
      ],
      [
        546.313720703125,
        799.7999877929688,
        10.0
      ],
      [
        546.313720703125,
        801.0589599609375,
        10.0
      ],
      [
        488.4232177734375,
        884.8935546875,
        10.0
      ],
      [
        481.4007873535156,
        867.93994140625,
        10.0
      ],
      [
        597.5687866210938,
        867.93994140625,
        10.0
      ],
      [
        590.5464477539062,
        884.8935546875,
        10.0
      ],
      [
        525.3568115234375,
        911.8958740234375,
        10.0
      ],
      [
        508.4031982421875,
        904.87353515625,
        10.0
      ],
      [
        570.56640625,
        904.87353515625,
        10.0
      ],
      [
        553.61279296875,
        911.8958740234375,
        10.0
      ],
      [
        529.800048828125,
        808.0,
        10.0
      ],
      [
        527.7999877929688,
        808.0,
        10.0
      ],
      [
        532.1715698242188,
        808.0,
        10.0
      ],
      [
        525.3568115234375,
        808.0,
        10.0
      ],
      [
        546.313720703125,
        808.0,
        10.0
      ],
      [
        553.61279296875,
        808.0,
        10.0
      ],
      [
        546.313720703125,
        808.0,
        10.0
      ],
      [
        532.1715698242188,
        808.0,
        10.0
      ],
      [
        547.2000122070312,
        808.5,
        10.0
      ],
      [
        546.313720703125,
        808.5,
        10.0
      ],
      [
        531.2000122070312,
        808.5,
        10.0
      ],
      [
        532.1715698242188,
        808.5,
        10.0
      ],
      [
        531.2000122070312,
        808.0,
        19.0
      ],
      [
        531.2000122070312,
        808.5,
        19.0
      ],
      [
        547.2000122070312,
        808.0,
        19.0
      ],
      [
        547.2000122070312,
        808.5,
        19.0
      ],
      [
        532.1715698242188,
        808.0,
        10.0
      ],
      [
        532.1715698242188,
        808.5,
        10.0
      ],
      [
        531.2000122070312,
        808.0,
        10.0
      ],
      [
        531.2000122070312,
        808.5,
        10.0
      ],
      [
        547.2000122070312,
        808.0,
        10.0
      ],
      [
        547.2000122070312,
        808.5,
        10.0
      ],
      [
        546.313720703125,
        808.0,
        10.0
      ],
      [
        546.313720703125,
        808.5,
        10.0
      ],
      [
        553.5,
        812.7999877929688,
        10.0
      ],
      [
        550.5,
        809.7999877929688,
        10.0
      ],
      [
        550.5,
        809.7999877929688,
        10.0
      ],
      [
        553.5,
        812.7999877929688,
        10.0
      ],
      [
        552.0,
        811.2999877929688,
        17.0
      ],
      [
        552.0,
        811.2999877929688,
        10.0
      ],
      [
        550.5,
        812.7999877929688,
        10.0
      ],
      [
        552.0,
        811.2999877929688,
        17.0
      ],
      [
        550.5,
        812.7999877929688,
        10.0
      ],
      [
        552.0,
        811.2999877929688,
        10.0
      ],
      [
        553.5,
        809.7999877929688,
        10.0
      ],
      [
        553.5,
        809.7999877929688,
        10.0
      ],
      [
        549.0,
        1261.11767578125,
        -17.0
      ],
      [
        513.0,
        1278.6202392578125,
        -17.0
      ],
      [
        510.0,
        1294.4000244140625,
        -20.0
      ],
      [
        552.0,
        1294.4000244140625,
        -20.0
      ],
      [
        486.2350769042969,
        1291.6351318359375,
        -17.235069274902344
      ],
      [
        489.0,
        1294.4000244140625,
        -20.0
      ],
      [
        480.60308837890625,
        1294.4000244140625,
        -20.0
      ],
      [
        549.0,
        1261.1177978515625,
        -17.0
      ],
      [
        552.0,
        1259.688232421875,
        -20.0
      ],
      [
        552.0,
        1294.4000244140625,
        -20.0
      ],
      [
        531.0,
        1269.8690185546875,
        -17.0
      ],
      [
        531.0,
        1294.4000244140625,
        -20.0
      ],
      [
        531.0,
        1269.89794921875,
        -20.0
      ],
      [
        531.0,
        1294.4000244140625,
        -20.0
      ],
      [
        531.0,
        1269.8690185546875,
        -17.0
      ],
      [
        531.0,
        1269.89794921875,
        -20.0
      ],
      [
        513.0,
        1278.620361328125,
        -17.0
      ],
      [
        510.0,
        1294.4000244140625,
        -20.0
      ],
      [
        510.0,
        1280.1077880859375,
        -20.0
      ],
      [
        489.0,
        1290.317626953125,
        -20.0
      ],
      [
        489.0,
        1294.4000244140625,
        -20.0
      ],
      [
        486.2350769042969,
        1291.6351318359375,
        -17.235069274902344
      ],
      [
        517.4998779296875,
        1277.9000244140625,
        -20.0
      ],
      [
        518.5001220703125,
        1277.9000244140625,
        -20.0
      ],
      [
        518.5001220703125,
        1277.9000244140625,
        -20.0
      ],
      [
        518.5,
        1278.9000244140625,
        -20.0
      ],
      [
        517.4998779296875,
        1277.9000244140625,
        -20.0
      ],
      [
        517.5,
        1278.9000244140625,
        -20.0
      ],
      [
        518.5,
        1278.9000244140625,
        -20.0
      ],
      [
        517.5,
        1278.9000244140625,
        -20.0
      ],
      [
        542.4998779296875,
        1277.9000244140625,
        -20.0
      ],
      [
        543.5001220703125,
        1277.9000244140625,
        -20.0
      ],
      [
        542.4998779296875,
        1277.9000244140625,
        -20.0
      ],
      [
        542.5,
        1278.9000244140625,
        -20.0
      ],
      [
        543.5,
        1278.9000244140625,
        -20.0
      ],
      [
        542.5,
        1278.9000244140625,
        -20.0
      ],
      [
        550.53564453125,
        1260.4000244140625,
        -20.0
      ],
      [
        552.0,
        1260.4000244140625,
        -20.0
      ],
      [
        550.5059814453125,
        1260.4000244140625,
        -18.5059814453125
      ],
      [
        452.81463623046875,
        1262.0,
        -17.0
      ],
      [
        452.5,
        1261.8470458984375,
        -17.0
      ],
      [
        452.5,
        1261.8470458984375,
        -17.0
      ],
      [
        450.0,
        1260.631591796875,
        -17.0
      ],
      [
        486.0,
        1278.1341552734375,
        -17.0
      ],
      [
        462.5,
        1266.7088623046875,
        -17.0
      ],
      [
        486.0,
        1278.1341552734375,
        -17.0
      ],
      [
        450.0,
        1260.631591796875,
        -17.0
      ],
      [
        462.5,
        1266.602783203125,
        -6.0
      ],
      [
        453.0328369140625,
        1262.0,
        -6.0
      ],
      [
        462.5,
        1266.602783203125,
        -6.0
      ],
      [
        472.5,
        1271.464599609375,
        -6.0
      ],
      [
        453.0328369140625,
        1262.0,
        -6.0
      ],
      [
        452.81463623046875,
        1262.0,
        -17.0
      ],
      [
        462.5,
        1266.69921875,
        -16.0
      ],
      [
        472.5,
        1271.56103515625,
        -16.0
      ],
      [
        462.5,
        1266.7088623046875,
        -17.0
      ],
      [
        462.5,
        1266.69921875,
        -16.0
      ],
      [
        472.5,
        1271.56103515625,
        -16.0
      ],
      [
        472.5,
        1271.464599609375,
        -6.0
      ],
      [
        447.0,
        1294.4000244140625,
        -20.0
      ],
      [
        450.0,
        1260.6317138671875,
        -17.0
      ],
      [
        447.0,
        1294.4000244140625,
        -20.0
      ],
      [
        447.0,
        1259.2021484375,
        -20.0
      ],
      [
        468.0,
        1294.4000244140625,
        -20.0
      ],
      [
        468.0,
        1269.3829345703125,
        -17.0
      ],
      [
        468.0,
        1269.411865234375,
        -20.0
      ],
      [
        468.0,
        1269.3829345703125,
        -17.0
      ],
      [
        468.0,
        1294.4000244140625,
        -20.0
      ],
      [
        468.0,
        1269.411865234375,
        -20.0
      ],
      [
        486.0,
        1278.1341552734375,
        -17.0
      ],
      [
        489.0,
        1279.62158203125,
        -20.0
      ],
      [
        479.4998779296875,
        1277.9000244140625,
        -20.0
      ],
      [
        479.5,
        1278.9000244140625,
        -20.0
      ],
      [
        480.5,
        1278.9000244140625,
        -20.0
      ],
      [
        479.5,
        1278.9000244140625,
        -20.0
      ],
      [
        449.5140380859375,
        1260.4000244140625,
        -17.485946655273438
      ],
      [
        447.0,
        1260.4000244140625,
        -20.0
      ],
      [
        449.4641418457031,
        1260.4000244140625,
        -20.0
      ],
      [
        454.4998779296875,
        1277.9000244140625,
        -20.0
      ],
      [
        455.5001220703125,
        1277.9000244140625,
        -20.0
      ],
      [
        455.5001220703125,
        1277.9000244140625,
        -20.0
      ],
      [
        455.5,
        1278.9000244140625,
        -20.0
      ],
      [
        454.4998779296875,
        1277.9000244140625,
        -20.0
      ],
      [
        454.5,
        1278.9000244140625,
        -20.0
      ],
      [
        455.5,
        1278.9000244140625,
        -20.0
      ],
      [
        454.5,
        1278.9000244140625,
        -20.0
      ],
      [
        510.0,
        1260.4000244140625,
        -20.0
      ],
      [
        489.0,
        1260.4000244140625,
        -20.0
      ],
      [
        486.0,
        1260.4000244140625,
        -17.0
      ],
      [
        489.0,
        1258.4000244140625,
        -20.0
      ],
      [
        489.0,
        1260.4000244140625,
        -20.0
      ],
      [
        510.0,
        1258.4000244140625,
        -20.0
      ],
      [
        513.0,
        1260.4000244140625,
        -17.0
      ],
      [
        510.0,
        1260.4000244140625,
        -20.0
      ],
      [
        549.0,
        1260.4000244140625,
        -17.0
      ],
      [
        552.0,
        1258.4000244140625,
        -20.0
      ],
      [
        550.5062866210938,
        1260.4000244140625,
        -18.506275177001953
      ],
      [
        447.0,
        1258.4000244140625,
        -20.0
      ],
      [
        450.0,
        1260.4000244140625,
        -17.0
      ],
      [
        449.5137939453125,
        1260.4000244140625,
        -17.486209869384766
      ],
      [
        468.0,
        1260.4000244140625,
        -20.0
      ],
      [
        468.0,
        1260.4000244140625,
        -20.0
      ],
      [
        531.0,
        1260.4000244140625,
        -20.0
      ],
      [
        531.0,
        1260.4000244140625,
        -20.0
      ],
      [
        381.98297119140625,
        1203.5172119140625,
        -3.946122169494629
      ],
      [
        375.7594909667969,
        1211.5440673828125,
        -20.0
      ],
      [
        388.159423828125,
        1196.544189453125,
        10.0
      ],
      [
        381.98297119140625,
        1203.5172119140625,
        -3.9461231231689453
      ],
      [
        458.063720703125,
        1197.5174560546875,
        8.053512573242188
      ],
      [
        455.5875549316406,
        1208.273681640625,
        -13.458897590637207
      ],
      [
        384.67095947265625,
        1201.4000244140625,
        0.28832685947418213
      ],
      [
        384.10504150390625,
        1202.044189453125,
        -1.0
      ],
      [
        411.79962158203125,
        1226.15234375,
        -16.5
      ],
      [
        411.79962158203125,
        1226.15234375,
        -20.0
      ],
      [
        420.74871826171875,
        1230.6146240234375,
        -16.5
      ],
      [
        420.74871826171875,
        1230.6146240234375,
        -20.0
      ],
      [
        455.5875549316406,
        1208.273681640625,
        -13.458895683288574
      ],
      [
        454.9398193359375,
        1210.9742431640625,
        -18.86025047302246
      ],
      [
        454.9398193359375,
        1210.9742431640625,
        -18.86025047302246
      ],
      [
        454.8097839355469,
        1211.544189453125,
        -20.0
      ],
      [
        441.80908203125,
        1217.735107421875,
        -20.0
      ],
      [
        441.86590576171875,
        1217.810546875,
        -20.0
      ],
      [
        458.063720703125,
        1197.5174560546875,
        8.053512573242188
      ],
      [
        458.2629089355469,
        1196.544189453125,
        10.0
      ],
      [
        441.86590576171875,
        1217.810546875,
        -20.0
      ],
      [
        442.4842529296875,
        1217.285400390625,
        -20.0
      ],
      [
        442.4842529296875,
        1217.285400390625,
        -20.0
      ],
      [
        441.80908203125,
        1217.735107421875,
        -20.0
      ],
      [
        435.0279541015625,
        1222.895263671875,
        -16.268001556396484
      ],
      [
        442.1271667480469,
        1217.545654296875,
        -17.675912857055664
      ],
      [
        435.0279541015625,
        1222.895263671875,
        -16.268001556396484
      ],
      [
        442.1271667480469,
        1217.545654296875,
        -17.675912857055664
      ],
      [
        624.2405395507812,
        1211.5440673828125,
        -20.0
      ],
      [
        618.0169677734375,
        1203.51708984375,
        -3.946084976196289
      ],
      [
        611.840576171875,
        1196.544189453125,
        10.0
      ],
      [
        618.0169677734375,
        1203.51708984375,
        -3.946084976196289
      ],
      [
        544.4124145507812,
        1208.273681640625,
        -13.458895683288574
      ],
      [
        541.9362182617188,
        1197.5174560546875,
        8.053512573242188
      ],
      [
        586.700439453125,
        1226.15234375,
        -16.5
      ],
      [
        586.700439453125,
        1226.15234375,
        -20.0
      ],
      [
        577.7513427734375,
        1230.6146240234375,
        -16.5
      ],
      [
        577.7513427734375,
        1230.6146240234375,
        -20.0
      ],
      [
        614.0377197265625,
        1209.0443115234375,
        -15.0
      ],
      [
        614.8453979492188,
        1209.0443115234375,
        -15.0
      ],
      [
        614.2381591796875,
        1211.5440673828125,
        -20.0
      ],
      [
        615.2675170898438,
        1209.232177734375,
        -15.375886917114258
      ],
      [
        610.3048706054688,
        1210.544189453125,
        -18.0
      ],
      [
        609.859619140625,
        1211.544189453125,
        -20.0
      ],
      [
        613.1510009765625,
        1210.544189453125,
        -18.0
      ],
      [
        610.3048706054688,
        1210.544189453125,
        -18.0
      ],
      [
        613.1510009765625,
        1210.544189453125,
        -18.0
      ],
      [
        614.0377197265625,
        1209.0443115234375,
        -15.0
      ],
      [
        614.8453979492188,
        1209.0443115234375,
        -15.0
      ],
      [
        615.2675170898438,
        1209.232177734375,
        -15.375886917114258
      ],
      [
        596.7109985351562,
        1210.2943115234375,
        -17.5
      ],
      [
        603.137939453125,
        1210.294189453125,
        -17.5
      ],
      [
        603.137939453125,
        1210.294189453125,
        -17.5
      ],
      [
        602.6581420898438,
        1211.5440673828125,
        -20.0
      ],
      [
        596.231201171875,
        1211.5440673828125,
        -20.0
      ],
      [
        596.7109985351562,
        1210.2943115234375,
        -17.5
      ],
      [
        554.1498413085938,
        1223.1595458984375,
        -17.600006103515625
      ],
      [
        554.7442016601562,
        1223.2430419921875,
        -17.600006103515625
      ],
      [
        554.7442016601562,
        1223.2430419921875,
        -17.600006103515625
      ],
      [
        553.9556274414062,
        1223.105224609375,
        -18.0
      ],
      [
        554.1498413085938,
        1223.1595458984375,
        -17.600006103515625
      ],
      [
        545.0601806640625,
        1210.9742431640625,
        -18.86025047302246
      ],
      [
        544.4124145507812,
        1208.273681640625,
        -13.458897590637207
      ],
      [
        545.0601806640625,
        1210.9742431640625,
        -18.86025047302246
      ],
      [
        545.190185546875,
        1211.544189453125,
        -20.0
      ],
      [
        541.9362182617188,
        1197.5174560546875,
        8.053512573242188
      ],
      [
        541.737060546875,
        1196.544189453125,
        10.0
      ],
      [
        549.64697265625,
        1214.2071533203125,
        -8.0
      ],
      [
        549.64697265625,
        1214.2071533203125,
        -17.0
      ],
      [
        549.64697265625,
        1214.2071533203125,
        -8.0
      ],
      [
        549.64697265625,
        1214.2071533203125,
        -17.0
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -20.0
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -20.0
      ],
      [
        481.0,
        990.0,
        -20.0
      ],
      [
        465.0,
        990.0,
        -20.0
      ],
      [
        465.0,
        974.5999755859375,
        -20.0
      ],
      [
        481.0,
        974.5999755859375,
        -20.0
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -20.0
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -20.0
      ],
      [
        481.0,
        974.5999755859375,
        -20.0
      ],
      [
        481.0,
        990.0,
        -20.0
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -20.0
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -20.0
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -20.0
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -20.0
      ],
      [
        465.0,
        990.0,
        -20.0
      ],
      [
        465.0,
        974.5999755859375,
        -20.0
      ],
      [
        597.5687866210938,
        827.0,
        -3.0
      ],
      [
        597.5687866210938,
        867.93994140625,
        -3.0
      ],
      [
        481.4007873535156,
        867.93994140625,
        -3.0
      ],
      [
        481.4007873535156,
        827.0,
        -3.0
      ],
      [
        573.4251708984375,
        902.0146484375,
        5.0
      ],
      [
        587.5673828125,
        887.8726196289062,
        5.0
      ],
      [
        590.5464477539062,
        884.8935546875,
        5.0
      ],
      [
        570.56640625,
        904.87353515625,
        5.0
      ],
      [
        529.5,
        911.8958740234375,
        5.0
      ],
      [
        549.5,
        911.8958740234375,
        5.0
      ],
      [
        553.61279296875,
        911.8958740234375,
        5.0
      ],
      [
        525.3568115234375,
        911.8958740234375,
        5.0
      ],
      [
        491.1811828613281,
        887.651611328125,
        5.0
      ],
      [
        505.3320007324219,
        901.8023681640625,
        5.0
      ],
      [
        508.4031982421875,
        904.87353515625,
        5.0
      ],
      [
        488.4232177734375,
        884.8935546875,
        5.0
      ],
      [
        518.9696044921875,
        844.006591796875,
        -3.0
      ],
      [
        518.9696044921875,
        858.948974609375,
        -3.0
      ],
      [
        560.0,
        858.948974609375,
        -3.0
      ],
      [
        560.0,
        844.006591796875,
        -3.0
      ],
      [
        518.9696044921875,
        858.948974609375,
        -1.5
      ],
      [
        532.3468017578125,
        872.9349365234375,
        -1.5
      ],
      [
        546.622802734375,
        872.9349365234375,
        -1.5
      ],
      [
        560.0,
        858.948974609375,
        -1.5
      ],
      [
        532.3468017578125,
        872.9349365234375,
        -1.5
      ],
      [
        546.622802734375,
        872.9349365234375,
        -1.5
      ],
      [
        525.3568115234375,
        911.8958740234375,
        5.0
      ],
      [
        525.3568115234375,
        911.8958740234375,
        -1.5
      ],
      [
        518.9696044921875,
        909.250244140625,
        -1.5
      ],
      [
        518.9696044921875,
        909.250244140625,
        5.0
      ],
      [
        553.61279296875,
        911.8958740234375,
        -1.5
      ],
      [
        553.61279296875,
        911.8958740234375,
        5.0
      ],
      [
        560.0,
        909.250244140625,
        5.0
      ],
      [
        560.0,
        909.250244140625,
        -1.5
      ],
      [
        525.7142944335938,
        829.6143188476562,
        -3.0
      ],
      [
        525.7142944335938,
        859.3986206054688,
        -3.0
      ],
      [
        518.9696044921875,
        858.948974609375,
        -3.0
      ],
      [
        525.7142944335938,
        866.0006103515625,
        -3.0
      ],
      [
        527.0,
        867.3447875976562,
        -1.5
      ],
      [
        525.3568115234375,
        911.8958740234375,
        -3.0
      ],
      [
        518.9696044921875,
        909.250244140625,
        -3.0
      ],
      [
        553.2857055664062,
        859.3986206054688,
        -3.0
      ],
      [
        553.2857055664062,
        829.6143188476562,
        -3.0
      ],
      [
        553.2857055664062,
        865.9688110351562,
        -3.0
      ],
      [
        560.0,
        858.948974609375,
        -3.0
      ],
      [
        552.0,
        867.3130493164062,
        -1.5
      ],
      [
        560.0,
        909.250244140625,
        -3.0
      ],
      [
        553.61279296875,
        911.8958740234375,
        -3.0
      ],
      [
        553.2857055664062,
        829.6143188476562,
        -3.0
      ],
      [
        525.7142944335938,
        829.6143188476562,
        -3.0
      ],
      [
        530.8239135742188,
        865.7857055664062,
        -3.0
      ],
      [
        548.1760864257812,
        865.7857055664062,
        -3.0
      ],
      [
        532.3468017578125,
        872.9349365234375,
        -3.0
      ],
      [
        546.622802734375,
        872.9349365234375,
        -3.0
      ],
      [
        546.622802734375,
        872.9349365234375,
        -3.0
      ],
      [
        532.3468017578125,
        872.9349365234375,
        -3.0
      ],
      [
        548.1760864257812,
        865.7857055664062,
        -3.0
      ],
      [
        553.2857055664062,
        859.3986206054688,
        -3.0
      ],
      [
        525.7142944335938,
        859.3986206054688,
        -3.0
      ],
      [
        530.8239135742188,
        865.7857055664062,
        -3.0
      ],
      [
        595.8179321289062,
        827.0,
        -3.0
      ],
      [
        597.5687866210938,
        827.0,
        -3.0
      ],
      [
        573.5927734375,
        827.0,
        -3.0
      ],
      [
        575.3579711914062,
        827.0,
        -3.0
      ],
      [
        575.3579711914062,
        827.0,
        -3.0
      ],
      [
        595.8179321289062,
        827.0,
        -3.0
      ],
      [
        573.5927734375,
        827.0,
        5.0
      ],
      [
        597.5687866210938,
        827.0,
        5.0
      ],
      [
        573.0927734375,
        827.0,
        4.769879341125488
      ],
      [
        573.0927734375,
        827.0,
        5.0
      ],
      [
        573.5927734375,
        844.006591796875,
        -3.0
      ],
      [
        560.0,
        844.006591796875,
        -3.0
      ],
      [
        573.5928344726562,
        827.0,
        -3.0
      ],
      [
        573.5927734375,
        844.006591796875,
        -3.0
      ],
      [
        573.0927734375,
        843.7235107421875,
        -3.0
      ],
      [
        573.0927734375,
        844.0066528320312,
        -3.0
      ],
      [
        573.5927734375,
        844.006591796875,
        -3.0
      ],
      [
        573.5927734375,
        835.5032958984375,
        5.0
      ],
      [
        573.5927734375,
        852.5098876953125,
        -3.0
      ],
      [
        573.0927734375,
        852.3328857421875,
        -3.0
      ],
      [
        573.0927734375,
        835.1140747070312,
        5.0
      ],
      [
        573.0927734375,
        835.1140747070312,
        5.0
      ],
      [
        573.0927734375,
        852.3328857421875,
        -3.0
      ],
      [
        573.1935424804688,
        852.4327392578125,
        -3.0
      ],
      [
        573.459716796875,
        835.4776000976562,
        5.0
      ],
      [
        573.5927734375,
        852.5098876953125,
        -3.0
      ],
      [
        573.5927734375,
        835.5032958984375,
        5.0
      ],
      [
        573.459716796875,
        835.4776000976562,
        5.0
      ],
      [
        573.1935424804688,
        852.4327392578125,
        -3.0
      ],
      [
        570.56640625,
        904.87353515625,
        5.0
      ],
      [
        570.56640625,
        904.87353515625,
        -3.0
      ],
      [
        597.5687866210938,
        867.93994140625,
        5.0
      ],
      [
        597.5687866210938,
        867.93994140625,
        -3.0
      ],
      [
        590.5464477539062,
        884.8935546875,
        -3.0
      ],
      [
        590.5464477539062,
        884.8935546875,
        5.0
      ],
      [
        481.4007873535156,
        827.0,
        -3.0
      ],
      [
        483.12548828125,
        827.0,
        -3.0
      ],
      [
        503.58551025390625,
        827.0,
        -3.0
      ],
      [
        505.3768005371094,
        827.0,
        -3.0
      ],
      [
        483.12548828125,
        827.0,
        -3.0
      ],
      [
        503.58551025390625,
        827.0,
        -3.0
      ],
      [
        481.4007873535156,
        827.0,
        5.0
      ],
      [
        505.3768005371094,
        827.0,
        5.0
      ],
      [
        505.8768005371094,
        827.0,
        5.0
      ],
      [
        505.8768005371094,
        827.0,
        4.770325660705566
      ],
      [
        505.3768005371094,
        844.006591796875,
        -3.0
      ],
      [
        518.9696044921875,
        844.006591796875,
        -3.0
      ],
      [
        505.3768005371094,
        844.006591796875,
        -3.0
      ],
      [
        505.3768005371094,
        827.0,
        -3.0
      ],
      [
        505.8768005371094,
        844.0066528320312,
        -3.0
      ],
      [
        505.8768005371094,
        843.7239379882812,
        -3.0
      ],
      [
        505.3768005371094,
        852.5098876953125,
        -3.0
      ],
      [
        505.3768005371094,
        835.5032958984375,
        5.0
      ],
      [
        505.3768005371094,
        844.006591796875,
        -3.0
      ],
      [
        505.8768005371094,
        835.1148071289062,
        5.0
      ],
      [
        505.8768005371094,
        852.3330688476562,
        -3.0
      ],
      [
        505.8768005371094,
        852.3330688476562,
        -3.0
      ],
      [
        505.8768005371094,
        835.1148071289062,
        5.0
      ],
      [
        505.5098876953125,
        835.4776000976562,
        5.0
      ],
      [
        505.7760314941406,
        852.4327392578125,
        -3.0
      ],
      [
        505.3768005371094,
        835.5032958984375,
        5.0
      ],
      [
        505.3768005371094,
        852.5098876953125,
        -3.0
      ],
      [
        505.7760314941406,
        852.4327392578125,
        -3.0
      ],
      [
        505.5098876953125,
        835.4776000976562,
        5.0
      ],
      [
        508.4031982421875,
        904.87353515625,
        -3.0
      ],
      [
        508.4031982421875,
        904.87353515625,
        5.0
      ],
      [
        488.4232177734375,
        884.8935546875,
        5.0
      ],
      [
        488.4232177734375,
        884.8935546875,
        -3.0
      ],
      [
        481.4007873535156,
        867.93994140625,
        -3.0
      ],
      [
        481.4007873535156,
        867.93994140625,
        5.0
      ],
      [
        559.2000122070312,
        859.7853393554688,
        9.0
      ],
      [
        559.2000122070312,
        859.7853393554688,
        9.0
      ],
      [
        559.2000122070312,
        859.7853393554688,
        5.0
      ],
      [
        559.2000122070312,
        813.3131713867188,
        5.0
      ],
      [
        560.0,
        814.0739135742188,
        5.0
      ],
      [
        560.0,
        814.0739135742188,
        9.0
      ],
      [
        559.2000122070312,
        813.3131713867188,
        9.0
      ],
      [
        560.0,
        909.250244140625,
        5.0
      ],
      [
        559.2000122070312,
        909.5816040039062,
        5.0
      ],
      [
        559.2000122070312,
        909.5816040039062,
        9.0
      ],
      [
        560.0,
        909.250244140625,
        9.0
      ],
      [
        560.0,
        814.0739135742188,
        10.0
      ],
      [
        559.2000122070312,
        813.3131713867188,
        10.0
      ],
      [
        559.2000122070312,
        909.5816040039062,
        10.0
      ],
      [
        560.0,
        909.250244140625,
        10.0
      ],
      [
        519.7695922851562,
        859.7853393554688,
        9.0
      ],
      [
        519.7695922851562,
        859.7853393554688,
        5.0
      ],
      [
        519.7695922851562,
        859.7853393554688,
        9.0
      ],
      [
        518.9696044921875,
        814.0739135742188,
        9.0
      ],
      [
        518.9696044921875,
        814.0739135742188,
        5.0
      ],
      [
        519.7695922851562,
        813.3131713867188,
        5.0
      ],
      [
        519.7695922851562,
        813.3131713867188,
        9.0
      ],
      [
        519.7695922851562,
        909.5816040039062,
        5.0
      ],
      [
        518.9696044921875,
        909.250244140625,
        5.0
      ],
      [
        518.9696044921875,
        909.250244140625,
        9.0
      ],
      [
        519.7695922851562,
        909.5816040039062,
        9.0
      ],
      [
        519.7695922851562,
        813.3131713867188,
        10.0
      ],
      [
        518.9696044921875,
        814.0739135742188,
        10.0
      ],
      [
        518.9696044921875,
        909.250244140625,
        10.0
      ],
      [
        519.7695922851562,
        909.5816040039062,
        10.0
      ],
      [
        545.5157470703125,
        872.9349365234375,
        9.0
      ],
      [
        545.5157470703125,
        872.9349365234375,
        9.0
      ],
      [
        545.5157470703125,
        872.9349365234375,
        5.0
      ],
      [
        533.4537353515625,
        872.9349365234375,
        9.0
      ],
      [
        533.4537353515625,
        872.9349365234375,
        9.0
      ],
      [
        533.4537353515625,
        872.9349365234375,
        5.0
      ],
      [
        549.5999755859375,
        861.6000366210938,
        5.0
      ],
      [
        529.199951171875,
        861.6000366210938,
        5.0
      ],
      [
        537.89990234375,
        854.6718139648438,
        5.0
      ],
      [
        539.3999633789062,
        854.6718139648438,
        5.681838512420654
      ],
      [
        555.2000122070312,
        809.5093383789062,
        5.0
      ],
      [
        559.2000122070312,
        813.3131713867188,
        7.0
      ],
      [
        555.2000122070312,
        809.5093383789062,
        7.0
      ],
      [
        555.2000122070312,
        809.5093383789062,
        10.0
      ],
      [
        557.8267822265625,
        835.800048828125,
        7.399993896484375
      ],
      [
        557.8267211914062,
        835.199951171875,
        7.399993896484375
      ],
      [
        557.8267211914062,
        835.199951171875,
        7.399993896484375
      ],
      [
        557.800048828125,
        835.0,
        7.0
      ],
      [
        557.8267822265625,
        835.800048828125,
        7.399993896484375
      ],
      [
        519.7695922851562,
        813.3131713867188,
        7.0
      ],
      [
        523.7695922851562,
        809.5093383789062,
        5.0
      ],
      [
        523.7695922851562,
        809.5093383789062,
        7.0
      ],
      [
        523.7695922851562,
        809.5093383789062,
        10.0
      ],
      [
        521.142822265625,
        835.199951171875,
        7.399993896484375
      ],
      [
        521.142822265625,
        835.800048828125,
        7.399993896484375
      ],
      [
        521.142822265625,
        835.800048828125,
        7.399993896484375
      ],
      [
        521.1694946289062,
        835.0,
        7.0
      ],
      [
        521.142822265625,
        835.199951171875,
        7.399993896484375
      ],
      [
        552.0,
        811.2999877929688,
        8.0
      ],
      [
        552.0,
        811.2999877929688,
        10.0
      ],
      [
        552.0,
        811.2999877929688,
        8.0
      ],
      [
        552.0,
        811.2999877929688,
        10.0
      ],
      [
        573.0927734375,
        826.5244750976562,
        5.0
      ],
      [
        573.0927734375,
        826.5244750976562,
        8.990823745727539
      ],
      [
        573.0927734375,
        826.5244750976562,
        8.990823745727539
      ],
      [
        573.0927734375,
        827.0,
        5.0
      ],
      [
        573.0927734375,
        827.0,
        8.769878387451172
      ],
      [
        573.0927734375,
        827.0,
        8.769878387451172
      ],
      [
        505.8768005371094,
        826.5245971679688,
        8.991196632385254
      ],
      [
        505.8768005371094,
        826.5245971679688,
        5.0
      ],
      [
        505.8768005371094,
        826.5245971679688,
        8.991196632385254
      ],
      [
        505.8768005371094,
        827.0,
        8.770325660705566
      ],
      [
        505.8768005371094,
        827.0,
        5.0
      ],
      [
        505.8768005371094,
        827.0,
        8.770325660705566
      ],
      [
        619.8696899414062,
        973.0000610351562,
        -7.0
      ],
      [
        619.8696899414062,
        926.0867919921875,
        -7.0
      ],
      [
        459.1000061035156,
        926.0867309570312,
        -7.0
      ],
      [
        459.1000061035156,
        973.0,
        -7.0
      ],
      [
        487.19000244140625,
        973.0,
        -7.0
      ],
      [
        487.19000244140625,
        926.0867309570312,
        -7.0
      ],
      [
        591.7796020507812,
        926.0867919921875,
        -7.0
      ],
      [
        591.7796020507812,
        973.0000610351562,
        -7.0
      ],
      [
        524.0,
        860.0,
        -7.0
      ],
      [
        524.0,
        827.9000244140625,
        -7.0
      ],
      [
        508.4031982421875,
        904.87353515625,
        -7.0
      ],
      [
        487.19000244140625,
        926.0867309570312,
        -7.0
      ],
      [
        524.0,
        911.3338623046875,
        -7.0
      ],
      [
        508.4031982421875,
        904.87353515625,
        -7.0
      ],
      [
        524.0,
        911.3338623046875,
        -3.0
      ],
      [
        487.19000244140625,
        730.0,
        -4.0
      ],
      [
        487.19000244140625,
        715.0,
        -6.5
      ],
      [
        487.19000244140625,
        747.9749755859375,
        -5.595001220703125
      ],
      [
        487.19000244140625,
        740.0,
        -4.0
      ],
      [
        505.3768005371094,
        852.5098876953125,
        -7.0
      ],
      [
        505.3768005371094,
        858.948974609375,
        -7.0
      ],
      [
        505.3768005371094,
        852.5098876953125,
        -7.0
      ],
      [
        505.3768005371094,
        827.0,
        -7.0
      ],
      [
        524.0,
        809.5999755859375,
        -3.555555820465088
      ],
      [
        511.6000061035156,
        809.5999755859375,
        -7.0
      ],
      [
        511.6000061035156,
        795.0,
        -7.0
      ],
      [
        524.0,
        795.0,
        -3.555555820465088
      ],
      [
        518.9696044921875,
        848.1580810546875,
        -4.952878475189209
      ],
      [
        518.9696044921875,
        858.948974609375,
        -4.952878475189209
      ],
      [
        518.9696044921875,
        858.948974609375,
        -4.952878475189209
      ],
      [
        524.0,
        864.2083129882812,
        -3.55554461479187
      ],
      [
        524.0,
        864.2083129882812,
        -3.0
      ],
      [
        505.3768005371094,
        852.5098876953125,
        -7.0
      ],
      [
        511.5999450683594,
        852.5098876953125,
        -7.0
      ],
      [
        518.9696044921875,
        848.1580810546875,
        -4.952878475189209
      ],
      [
        505.8768005371094,
        852.5098876953125,
        -7.0
      ],
      [
        505.8768005371094,
        852.3330688476562,
        -7.0
      ],
      [
        505.8768005371094,
        844.0066528320312,
        -3.0
      ],
      [
        505.3768005371094,
        858.948974609375,
        -7.0
      ],
      [
        509.14666748046875,
        868.3443603515625,
        -7.0
      ],
      [
        505.8768005371094,
        858.8523559570312,
        -7.0
      ],
      [
        505.8768005371094,
        860.195068359375,
        -6.028999328613281
      ],
      [
        510.9801330566406,
        869.6163940429688,
        -7.0
      ],
      [
        511.01934814453125,
        869.5789184570312,
        -7.0
      ],
      [
        510.5984802246094,
        869.8622436523438,
        -7.0
      ],
      [
        510.9801330566406,
        869.6163940429688,
        -7.0
      ],
      [
        509.5747985839844,
        868.068603515625,
        -7.0
      ],
      [
        505.8768005371094,
        858.8523559570312,
        -7.0
      ],
      [
        509.14666748046875,
        868.3443603515625,
        -7.0
      ],
      [
        510.0747375488281,
        869.314697265625,
        -7.0
      ],
      [
        510.07476806640625,
        869.314697265625,
        -6.649725914001465
      ],
      [
        511.01934814453125,
        869.5789184570312,
        -7.0
      ],
      [
        509.5747985839844,
        868.068603515625,
        -7.0
      ],
      [
        510.5984802246094,
        869.8622436523438,
        -7.0
      ],
      [
        511.6000061035156,
        809.5999755859375,
        -7.0
      ],
      [
        524.0,
        809.5999755859375,
        -3.555555820465088
      ],
      [
        524.0,
        809.5999755859375,
        -7.0
      ],
      [
        518.9696044921875,
        852.5098876953125,
        -7.0
      ],
      [
        518.9696044921875,
        858.948974609375,
        -7.0
      ],
      [
        518.9696044921875,
        858.948974609375,
        -7.0
      ],
      [
        524.0,
        864.2083129882812,
        -7.0
      ],
      [
        518.9696044921875,
        852.5098876953125,
        -7.0
      ],
      [
        524.0,
        795.0,
        -3.555555820465088
      ],
      [
        511.6000061035156,
        795.0,
        -7.0
      ],
      [
        524.0,
        795.0,
        -7.0
      ],
      [
        501.1971130371094,
        827.0,
        -7.0
      ],
      [
        505.3768005371094,
        827.0,
        -7.0
      ],
      [
        487.19000244140625,
        827.0,
        -7.0
      ],
      [
        501.1971130371094,
        827.0,
        -7.0
      ],
      [
        487.19000244140625,
        827.0,
        -3.0
      ],
      [
        488.4232177734375,
        884.8935546875,
        -7.0
      ],
      [
        487.19000244140625,
        881.9163208007812,
        -7.0
      ],
      [
        487.19000244140625,
        881.9163208007812,
        -3.0
      ],
      [
        488.4232177734375,
        884.8935546875,
        -7.0
      ],
      [
        487.19000244140625,
        886.1267700195312,
        -3.0
      ],
      [
        487.19000244140625,
        886.1267700195312,
        -7.0
      ],
      [
        487.19000244140625,
        740.0,
        -4.0
      ],
      [
        487.19000244140625,
        730.0,
        -4.0
      ],
      [
        511.0,
        715.0,
        -7.0
      ],
      [
        487.19000244140625,
        715.0,
        -6.5
      ],
      [
        487.19000244140625,
        715.0,
        -7.0
      ],
      [
        511.0,
        740.0,
        -7.0
      ],
      [
        511.0,
        740.0,
        -7.0
      ],
      [
        511.0,
        730.0,
        -7.0
      ],
      [
        511.0,
        730.0,
        -7.0
      ],
      [
        511.0,
        715.0,
        -7.0
      ],
      [
        487.19000244140625,
        747.9749755859375,
        -7.0
      ],
      [
        487.19000244140625,
        747.9749755859375,
        -5.595001220703125
      ],
      [
        490.0,
        727.199951171875,
        -7.0
      ],
      [
        490.0,
        726.7999877929688,
        -7.0
      ],
      [
        490.0,
        733.2000122070312,
        -7.0
      ],
      [
        490.0,
        733.5999755859375,
        -7.0
      ],
      [
        490.0,
        739.5999755859375,
        -7.0
      ],
      [
        490.0,
        740.0,
        -7.0
      ],
      [
        490.0,
        733.5999755859375,
        -7.0
      ],
      [
        489.6000061035156,
        733.5999755859375,
        -7.0
      ],
      [
        489.6000061035156,
        733.2000122070312,
        -7.0
      ],
      [
        490.0,
        733.2000122070312,
        -7.0
      ],
      [
        489.6000061035156,
        733.5999755859375,
        -7.0
      ],
      [
        489.6000061035156,
        733.2000122070312,
        -7.0
      ],
      [
        490.0,
        727.199951171875,
        -7.0
      ],
      [
        489.6000061035156,
        727.199951171875,
        -7.0
      ],
      [
        489.6000061035156,
        727.199951171875,
        -7.0
      ],
      [
        489.6000061035156,
        726.7999877929688,
        -7.0
      ],
      [
        489.6000061035156,
        726.7999877929688,
        -7.0
      ],
      [
        490.0,
        726.7999877929688,
        -7.0
      ],
      [
        489.6000061035156,
        740.0,
        -7.0
      ],
      [
        489.6000061035156,
        739.5999755859375,
        -7.0
      ],
      [
        490.0,
        740.0,
        -7.0
      ],
      [
        489.6000061035156,
        740.0,
        -7.0
      ],
      [
        489.6000061035156,
        739.5999755859375,
        -7.0
      ],
      [
        490.0,
        739.5999755859375,
        -7.0
      ],
      [
        505.0,
        733.2000122070312,
        -7.0
      ],
      [
        505.3999938964844,
        733.2000122070312,
        -7.0
      ],
      [
        505.0,
        739.5999755859375,
        -7.0
      ],
      [
        505.3999938964844,
        739.5999755859375,
        -7.0
      ],
      [
        505.3999938964844,
        739.5999755859375,
        -7.0
      ],
      [
        505.3999938964844,
        740.0,
        -7.0
      ],
      [
        505.0,
        740.0,
        -7.0
      ],
      [
        505.0,
        739.5999755859375,
        -7.0
      ],
      [
        505.3999938964844,
        740.0,
        -7.0
      ],
      [
        505.0,
        740.0,
        -7.0
      ],
      [
        505.3999938964844,
        733.5999755859375,
        -7.0
      ],
      [
        505.0,
        733.5999755859375,
        -7.0
      ],
      [
        505.3999938964844,
        733.2000122070312,
        -7.0
      ],
      [
        505.3999938964844,
        733.5999755859375,
        -7.0
      ],
      [
        505.0,
        733.5999755859375,
        -7.0
      ],
      [
        505.0,
        733.2000122070312,
        -7.0
      ],
      [
        505.3999938964844,
        727.199951171875,
        -7.0
      ],
      [
        505.0,
        727.199951171875,
        -7.0
      ],
      [
        505.3999938964844,
        727.199951171875,
        -7.0
      ],
      [
        505.3999938964844,
        726.7999877929688,
        -7.0
      ],
      [
        505.0,
        727.199951171875,
        -7.0
      ],
      [
        505.0,
        726.7999877929688,
        -7.0
      ],
      [
        505.0,
        726.7999877929688,
        -7.0
      ],
      [
        505.3999938964844,
        726.7999877929688,
        -7.0
      ],
      [
        555.0,
        860.0,
        -7.0
      ],
      [
        555.0,
        827.9000244140625,
        -7.0
      ],
      [
        570.56640625,
        904.87353515625,
        -7.0
      ],
      [
        591.7796020507812,
        926.0867919921875,
        -7.0
      ],
      [
        570.56640625,
        904.87353515625,
        -7.0
      ],
      [
        555.0,
        911.3212890625,
        -7.0
      ],
      [
        555.0,
        911.3212890625,
        -3.0
      ],
      [
        591.7796020507812,
        715.0,
        -6.5
      ],
      [
        591.7796020507812,
        730.0,
        -4.0
      ],
      [
        591.7796020507812,
        740.0,
        -4.0
      ],
      [
        591.7796020507812,
        750.551025390625,
        -6.110198974609375
      ],
      [
        573.5927734375,
        858.948974609375,
        -7.0
      ],
      [
        573.5927734375,
        852.5098876953125,
        -7.0
      ],
      [
        573.5928344726562,
        827.0,
        -7.0
      ],
      [
        573.5927734375,
        852.5098876953125,
        -7.0
      ],
      [
        567.2999267578125,
        809.5999755859375,
        -7.0
      ],
      [
        555.0,
        809.5999755859375,
        -3.583359479904175
      ],
      [
        555.0,
        795.0,
        -3.583359479904175
      ],
      [
        567.2999267578125,
        795.0,
        -7.0
      ],
      [
        560.0,
        858.948974609375,
        -4.972262382507324
      ],
      [
        560.0,
        848.1992797851562,
        -4.972262382507324
      ],
      [
        560.0,
        858.948974609375,
        -4.972262382507324
      ],
      [
        555.0,
        864.176513671875,
        -3.0
      ],
      [
        555.0,
        864.176513671875,
        -3.583369255065918
      ],
      [
        573.5927734375,
        852.5098876953125,
        -7.0
      ],
      [
        560.0,
        848.1992797851562,
        -4.972262382507324
      ],
      [
        567.2998657226562,
        852.5098876953125,
        -7.0
      ],
      [
        573.0927734375,
        852.3328857421875,
        -7.0
      ],
      [
        573.0927734375,
        852.5098876953125,
        -7.0
      ],
      [
        573.0927734375,
        844.0066528320312,
        -3.0
      ],
      [
        569.8229370117188,
        868.3443603515625,
        -7.0
      ],
      [
        573.5927734375,
        858.948974609375,
        -7.0
      ],
      [
        573.0927734375,
        858.8523559570312,
        -7.0
      ],
      [
        573.0927734375,
        860.1951293945312,
        -6.028999328613281
      ],
      [
        567.9502563476562,
        869.5789184570312,
        -7.0
      ],
      [
        567.989501953125,
        869.6163940429688,
        -7.0
      ],
      [
        568.3711547851562,
        869.8622436523438,
        -7.0
      ],
      [
        567.989501953125,
        869.6163940429688,
        -7.0
      ],
      [
        569.3948364257812,
        868.068603515625,
        -7.0
      ],
      [
        573.0927734375,
        858.8523559570312,
        -7.0
      ],
      [
        568.8948364257812,
        869.3147583007812,
        -6.649760723114014
      ],
      [
        568.8948364257812,
        869.3147583007812,
        -7.0
      ],
      [
        569.8229370117188,
        868.3443603515625,
        -7.0
      ],
      [
        567.9502563476562,
        869.5789184570312,
        -7.0
      ],
      [
        569.3948364257812,
        868.068603515625,
        -7.0
      ],
      [
        568.3711547851562,
        869.8622436523438,
        -7.0
      ],
      [
        555.0,
        809.5999755859375,
        -3.583359479904175
      ],
      [
        567.2999267578125,
        809.5999755859375,
        -7.0
      ],
      [
        555.0,
        809.5999755859375,
        -7.0
      ],
      [
        560.0,
        858.948974609375,
        -7.0
      ],
      [
        560.0,
        852.5098876953125,
        -7.0
      ],
      [
        555.0,
        864.176513671875,
        -7.0
      ],
      [
        560.0,
        858.948974609375,
        -7.0
      ],
      [
        560.0,
        852.5098876953125,
        -7.0
      ],
      [
        555.0,
        795.0,
        -7.0
      ],
      [
        567.2999267578125,
        795.0,
        -7.0
      ],
      [
        555.0,
        795.0,
        -3.583359479904175
      ],
      [
        573.5927734375,
        827.0,
        -7.0
      ],
      [
        577.7115478515625,
        827.0,
        -7.0
      ],
      [
        577.7115478515625,
        827.0,
        -7.0
      ],
      [
        591.7796020507812,
        827.0,
        -7.0
      ],
      [
        591.7796020507812,
        827.0,
        -3.0
      ],
      [
        591.7796020507812,
        881.9164428710938,
        -7.0
      ],
      [
        590.5464477539062,
        884.8935546875,
        -7.0
      ],
      [
        591.7796020507812,
        881.9164428710938,
        -3.0
      ],
      [
        590.5464477539062,
        884.8935546875,
        -7.0
      ],
      [
        591.7796020507812,
        886.126708984375,
        -7.0
      ],
      [
        591.7796020507812,
        886.126708984375,
        -3.0
      ],
      [
        591.7796020507812,
        730.0,
        -4.0
      ],
      [
        591.7796020507812,
        740.0,
        -4.0
      ],
      [
        591.7796020507812,
        715.0,
        -6.5
      ],
      [
        569.0,
        715.0,
        -7.0
      ],
      [
        591.7796020507812,
        715.0,
        -7.0
      ],
      [
        569.0,
        740.0,
        -7.0
      ],
      [
        569.0,
        730.0,
        -7.0
      ],
      [
        569.0,
        740.0,
        -7.0
      ],
      [
        569.0,
        715.0,
        -7.0
      ],
      [
        569.0,
        730.0,
        -7.0
      ],
      [
        591.7796020507812,
        750.551025390625,
        -6.110198974609375
      ],
      [
        591.7796020507812,
        750.551025390625,
        -7.0
      ],
      [
        590.0,
        727.199951171875,
        -7.0
      ],
      [
        590.0,
        726.7999877929688,
        -7.0
      ],
      [
        590.0,
        733.5999755859375,
        -7.0
      ],
      [
        590.0,
        733.2000122070312,
        -7.0
      ],
      [
        590.0,
        740.0,
        -7.0
      ],
      [
        590.0,
        739.5999755859375,
        -7.0
      ],
      [
        590.4000244140625,
        733.5999755859375,
        -7.0
      ],
      [
        590.0,
        733.5999755859375,
        -7.0
      ],
      [
        590.0,
        733.2000122070312,
        -7.0
      ],
      [
        590.4000244140625,
        733.2000122070312,
        -7.0
      ],
      [
        590.4000244140625,
        733.2000122070312,
        -7.0
      ],
      [
        590.4000244140625,
        733.5999755859375,
        -7.0
      ],
      [
        590.4000244140625,
        727.199951171875,
        -7.0
      ],
      [
        590.0,
        727.199951171875,
        -7.0
      ],
      [
        590.4000244140625,
        727.199951171875,
        -7.0
      ],
      [
        590.4000244140625,
        726.7999877929688,
        -7.0
      ],
      [
        590.0,
        726.7999877929688,
        -7.0
      ],
      [
        590.4000244140625,
        726.7999877929688,
        -7.0
      ],
      [
        590.4000244140625,
        740.0,
        -7.0
      ],
      [
        590.0,
        740.0,
        -7.0
      ],
      [
        590.0,
        739.5999755859375,
        -7.0
      ],
      [
        590.4000244140625,
        739.5999755859375,
        -7.0
      ],
      [
        590.4000244140625,
        739.5999755859375,
        -7.0
      ],
      [
        590.4000244140625,
        740.0,
        -7.0
      ],
      [
        574.5999755859375,
        733.2000122070312,
        -7.0
      ],
      [
        575.0,
        733.2000122070312,
        -7.0
      ],
      [
        574.5999755859375,
        739.5999755859375,
        -7.0
      ],
      [
        575.0,
        739.5999755859375,
        -7.0
      ],
      [
        574.5999755859375,
        740.0,
        -7.0
      ],
      [
        574.5999755859375,
        739.5999755859375,
        -7.0
      ],
      [
        575.0,
        739.5999755859375,
        -7.0
      ],
      [
        575.0,
        740.0,
        -7.0
      ],
      [
        575.0,
        740.0,
        -7.0
      ],
      [
        574.5999755859375,
        740.0,
        -7.0
      ],
      [
        575.0,
        733.5999755859375,
        -7.0
      ],
      [
        574.5999755859375,
        733.5999755859375,
        -7.0
      ],
      [
        574.5999755859375,
        733.5999755859375,
        -7.0
      ],
      [
        574.5999755859375,
        733.2000122070312,
        -7.0
      ],
      [
        575.0,
        733.2000122070312,
        -7.0
      ],
      [
        575.0,
        733.5999755859375,
        -7.0
      ],
      [
        575.0,
        727.199951171875,
        -7.0
      ],
      [
        574.5999755859375,
        727.199951171875,
        -7.0
      ],
      [
        574.5999755859375,
        727.199951171875,
        -7.0
      ],
      [
        574.5999755859375,
        726.7999877929688,
        -7.0
      ],
      [
        575.0,
        727.199951171875,
        -7.0
      ],
      [
        575.0,
        726.7999877929688,
        -7.0
      ],
      [
        574.5999755859375,
        726.7999877929688,
        -7.0
      ],
      [
        575.0,
        726.7999877929688,
        -7.0
      ],
      [
        525.7142944335938,
        866.0006103515625,
        -3.0
      ],
      [
        524.0,
        864.2083129882812,
        -5.000023365020752
      ],
      [
        525.3568115234375,
        911.8958740234375,
        -3.4171111583709717
      ],
      [
        524.0,
        911.3338623046875,
        -5.000023365020752
      ],
      [
        525.542724609375,
        911.8958740234375,
        -3.2002060413360596
      ],
      [
        525.3568115234375,
        911.8958740234375,
        -3.4171111583709717
      ],
      [
        525.71435546875,
        911.8958740234375,
        -3.0
      ],
      [
        525.542724609375,
        911.8958740234375,
        -3.2002060413360596
      ],
      [
        555.0,
        864.176513671875,
        -5.000023365020752
      ],
      [
        553.2857055664062,
        865.9688720703125,
        -3.0
      ],
      [
        553.61279296875,
        911.8958740234375,
        -3.381613254547119
      ],
      [
        555.0,
        911.3212890625,
        -5.000023365020752
      ],
      [
        553.61279296875,
        911.8958740234375,
        -3.381613254547119
      ],
      [
        553.4468383789062,
        911.8958740234375,
        -3.1880204677581787
      ],
      [
        553.2857055664062,
        911.8958740234375,
        -3.0
      ],
      [
        553.4468383789062,
        911.8958740234375,
        -3.1880204677581787
      ],
      [
        555.0,
        827.9000244140625,
        -7.0
      ],
      [
        524.0,
        827.9000244140625,
        -7.0
      ],
      [
        553.61279296875,
        911.8958740234375,
        -7.0
      ],
      [
        550.0825805664062,
        911.8958740234375,
        -7.0
      ],
      [
        529.0713500976562,
        911.8958740234375,
        -7.0
      ],
      [
        525.3568115234375,
        911.8958740234375,
        -7.0
      ],
      [
        550.0825805664062,
        911.8958740234375,
        -7.0
      ],
      [
        529.0713500976562,
        911.8958740234375,
        -7.0
      ],
      [
        549.0,
        867.5,
        -7.0
      ],
      [
        530.0,
        867.5,
        -7.0
      ],
      [
        532.3468017578125,
        872.9349365234375,
        -7.0
      ],
      [
        546.622802734375,
        872.9349365234375,
        -7.0
      ],
      [
        546.622802734375,
        872.9349365234375,
        -7.0
      ],
      [
        551.8211669921875,
        867.5,
        -7.0
      ],
      [
        551.8212280273438,
        867.5,
        -3.0
      ],
      [
        527.1484375,
        867.5,
        -7.0
      ],
      [
        532.3468017578125,
        872.9349365234375,
        -7.0
      ],
      [
        527.1484375,
        867.5,
        -3.0
      ],
      [
        553.61279296875,
        911.8958740234375,
        -7.0
      ],
      [
        525.3568115234375,
        911.8958740234375,
        -7.0
      ],
      [
        553.375244140625,
        865.875244140625,
        -3.1044464111328125
      ],
      [
        551.8211669921875,
        867.5,
        -5.0
      ],
      [
        527.1484375,
        867.5,
        -5.0
      ],
      [
        525.6092529296875,
        865.8908081054688,
        -3.1225600242614746
      ],
      [
        530.0,
        867.5,
        -7.0
      ],
      [
        524.0,
        860.0,
        -7.0
      ],
      [
        555.0,
        860.0,
        -7.0
      ],
      [
        549.0,
        867.5,
        -7.0
      ],
      [
        597.5687866210938,
        827.0,
        -7.0
      ],
      [
        597.5687866210938,
        867.93994140625,
        -7.0
      ],
      [
        619.8696899414062,
        926.0867919921875,
        -7.0
      ],
      [
        611.7596435546875,
        906.1068115234375,
        -7.0
      ],
      [
        597.5687866210938,
        891.9158935546875,
        -7.0
      ],
      [
        611.7596435546875,
        906.1068115234375,
        -7.0
      ],
      [
        597.5687866210938,
        891.9158935546875,
        -3.0
      ],
      [
        619.8696899414062,
        973.0000610351562,
        -7.0
      ],
      [
        612.7496337890625,
        973.0000610351562,
        -7.0
      ],
      [
        597.5687866210938,
        973.0000610351562,
        -6.149724006652832
      ],
      [
        599.131591796875,
        973.0000610351562,
        -7.0
      ],
      [
        597.5687866210938,
        973.0000610351562,
        -7.0
      ],
      [
        612.7496337890625,
        973.0000610351562,
        -7.0
      ],
      [
        599.131591796875,
        973.0000610351562,
        -7.0
      ],
      [
        597.5687866210938,
        973.0000610351562,
        -6.149724006652832
      ],
      [
        597.5687866210938,
        973.0000610351562,
        -3.0
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -7.0
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -7.0
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -7.0
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -7.0
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -7.0
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -7.0
      ],
      [
        611.569580078125,
        974.6000366210938,
        -7.0
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -7.0
      ],
      [
        600.36962890625,
        974.6000366210938,
        -7.0
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -7.0
      ],
      [
        600.36962890625,
        974.6000366210938,
        -7.0
      ],
      [
        611.569580078125,
        974.6000366210938,
        -7.0
      ],
      [
        597.5687866210938,
        867.93994140625,
        -7.0
      ],
      [
        591.7796020507812,
        973.0000610351562,
        -7.0
      ],
      [
        596.0,
        730.0,
        -7.0
      ],
      [
        596.0,
        740.0,
        -7.0
      ],
      [
        596.0,
        715.0,
        -7.0
      ],
      [
        596.0,
        730.0,
        -7.0
      ],
      [
        596.0,
        827.0,
        -7.0
      ],
      [
        597.5687866210938,
        827.0,
        -7.0
      ],
      [
        596.0,
        827.0,
        -3.0
      ],
      [
        596.0,
        740.0,
        -7.0
      ],
      [
        593.4835205078125,
        827.0,
        -7.0
      ],
      [
        593.4835205078125,
        827.0,
        -7.0
      ],
      [
        596.0,
        715.0,
        -7.0
      ],
      [
        481.4007873535156,
        867.93994140625,
        -7.0
      ],
      [
        481.4007873535156,
        827.0,
        -7.0
      ],
      [
        467.21002197265625,
        906.1067504882812,
        -7.0
      ],
      [
        459.1000061035156,
        926.0867309570312,
        -7.0
      ],
      [
        481.4007873535156,
        891.916015625,
        -3.0
      ],
      [
        467.21002197265625,
        906.1067504882812,
        -7.0
      ],
      [
        481.4007873535156,
        891.916015625,
        -7.0
      ],
      [
        466.2200012207031,
        973.0,
        -7.0
      ],
      [
        459.1000061035156,
        973.0,
        -7.0
      ],
      [
        481.4007873535156,
        973.0,
        -7.0
      ],
      [
        479.8380126953125,
        973.0,
        -7.0
      ],
      [
        481.4007873535156,
        973.0,
        -6.149740219116211
      ],
      [
        481.4007873535156,
        973.0,
        -3.0
      ],
      [
        481.4007873535156,
        973.0,
        -6.149740695953369
      ],
      [
        479.8380126953125,
        973.0,
        -7.0
      ],
      [
        466.2200012207031,
        973.0,
        -7.0
      ],
      [
        481.0,
        990.0,
        -7.0
      ],
      [
        465.0,
        990.0,
        -7.0
      ],
      [
        465.0,
        974.5999755859375,
        -7.0
      ],
      [
        465.0,
        990.0,
        -7.0
      ],
      [
        481.0,
        990.0,
        -7.0
      ],
      [
        481.0,
        974.5999755859375,
        -7.0
      ],
      [
        465.0,
        974.5999755859375,
        -7.0
      ],
      [
        467.3999938964844,
        974.5999755859375,
        -7.0
      ],
      [
        481.0,
        974.5999755859375,
        -7.0
      ],
      [
        478.6000061035156,
        974.5999755859375,
        -7.0
      ],
      [
        467.3999938964844,
        974.5999755859375,
        -7.0
      ],
      [
        478.6000061035156,
        974.5999755859375,
        -7.0
      ],
      [
        481.4007873535156,
        867.93994140625,
        -7.0
      ],
      [
        487.19000244140625,
        973.0,
        -7.0
      ],
      [
        484.0,
        740.0,
        -7.0
      ],
      [
        484.0,
        730.0,
        -7.0
      ],
      [
        484.0,
        730.0,
        -7.0
      ],
      [
        484.0,
        715.0,
        -7.0
      ],
      [
        481.4007873535156,
        827.0,
        -7.0
      ],
      [
        484.0,
        827.0,
        -7.0
      ],
      [
        484.0,
        827.0,
        -4.521140098571777
      ],
      [
        484.0,
        827.0,
        -4.521140098571777
      ],
      [
        484.0,
        827.0,
        -3.0
      ],
      [
        484.0,
        740.0,
        -7.0
      ],
      [
        485.42510986328125,
        827.0,
        -7.0
      ],
      [
        485.42510986328125,
        827.0,
        -7.0
      ],
      [
        484.0,
        715.0,
        -7.0
      ],
      [
        494.1421203613281,
        765.0,
        -7.0
      ],
      [
        494.1421203613281,
        765.0,
        -19.0
      ],
      [
        585.8578491210938,
        765.0,
        -19.0
      ],
      [
        585.8578491210938,
        765.0,
        -7.0
      ],
      [
        549.2000122070312,
        911.8958740234375,
        -7.0
      ],
      [
        555.8999633789062,
        907.0999755859375,
        -7.0
      ],
      [
        555.8999633789062,
        907.0999755859375,
        -16.0
      ],
      [
        555.8999633789062,
        907.0999755859375,
        -7.0
      ],
      [
        555.8999633789062,
        907.0999755859375,
        -16.0
      ],
      [
        505.3768005371094,
        907.89990234375,
        -19.0
      ],
      [
        505.3768005371094,
        907.89990234375,
        -7.0
      ],
      [
        530.0,
        870.4813232421875,
        -17.426189422607422
      ],
      [
        530.0,
        870.4813232421875,
        -7.0
      ],
      [
        524.0,
        858.3070068359375,
        -19.0
      ],
      [
        524.0,
        858.3070068359375,
        -7.0
      ],
      [
        518.9696044921875,
        853.2766723632812,
        -7.360686779022217
      ],
      [
        518.202880859375,
        852.5098876953125,
        -7.0
      ],
      [
        512.810791015625,
        852.5098876953125,
        -7.0
      ],
      [
        518.9696044921875,
        853.2766723632812,
        -7.360686779022217
      ],
      [
        518.9696044921875,
        853.2766723632812,
        -7.0
      ],
      [
        530.0,
        875.1795654296875,
        -19.0
      ],
      [
        530.0,
        870.4813232421875,
        -17.426189422607422
      ],
      [
        505.8768005371094,
        858.8523559570312,
        -9.983526229858398
      ],
      [
        505.8768005371094,
        852.5098876953125,
        -7.0
      ],
      [
        505.91558837890625,
        858.948974609375,
        -10.028987884521484
      ],
      [
        505.8768005371094,
        858.8523559570312,
        -9.983526229858398
      ],
      [
        506.52471923828125,
        861.8098754882812,
        -7.0
      ],
      [
        509.5359802246094,
        867.971923828125,
        -10.028987884521484
      ],
      [
        506.9140625,
        861.4374389648438,
        -7.0
      ],
      [
        508.64666748046875,
        867.0982055664062,
        -7.0
      ],
      [
        508.64666748046875,
        867.0982055664062,
        -9.451353073120117
      ],
      [
        530.0,
        911.8958740234375,
        -7.0
      ],
      [
        522.7999877929688,
        907.0999755859375,
        -7.0
      ],
      [
        522.7999877929688,
        907.0999755859375,
        -16.0
      ],
      [
        522.7999877929688,
        907.0999755859375,
        -7.0
      ],
      [
        522.7999877929688,
        907.0999755859375,
        -16.0
      ],
      [
        532.3468017578125,
        872.9349365234375,
        -8.0
      ],
      [
        538.6278686523438,
        872.9349365234375,
        -8.0
      ],
      [
        538.6278686523438,
        872.9349365234375,
        -7.0
      ],
      [
        532.3468017578125,
        872.9349365234375,
        -8.0
      ],
      [
        530.0,
        870.4813232421875,
        -8.0
      ],
      [
        530.0,
        867.5,
        -8.0
      ],
      [
        533.1929321289062,
        867.5,
        -7.0
      ],
      [
        533.1929321289062,
        867.5,
        -8.0
      ],
      [
        534.75,
        934.9959716796875,
        -11.5
      ],
      [
        534.75,
        934.9959716796875,
        -18.0
      ],
      [
        538.25,
        934.9959716796875,
        -18.0
      ],
      [
        538.25,
        934.9959716796875,
        -11.5
      ],
      [
        534.75,
        934.9959716796875,
        -18.0
      ],
      [
        538.25,
        934.9959716796875,
        -18.0
      ],
      [
        538.25,
        934.9959716796875,
        -11.5
      ],
      [
        534.75,
        934.9959716796875,
        -11.5
      ],
      [
        534.0999755859375,
        915.0,
        -19.0
      ],
      [
        534.0999755859375,
        915.0,
        -15.400001525878906
      ],
      [
        533.1929321289062,
        867.5,
        -14.800000190734863
      ],
      [
        533.1929321289062,
        867.5,
        -8.0
      ],
      [
        533.1929321289062,
        867.5,
        -19.0
      ],
      [
        538.6278686523438,
        872.9349365234375,
        -19.0
      ],
      [
        555.0,
        864.176513671875,
        -13.382085800170898
      ],
      [
        555.0,
        880.947509765625,
        -19.0
      ],
      [
        555.0,
        795.0,
        -19.0
      ],
      [
        555.0,
        795.0,
        -7.0
      ],
      [
        555.0,
        780.0,
        -19.0
      ],
      [
        555.0,
        780.0,
        -7.0
      ],
      [
        573.5927734375,
        776.4407348632812,
        -19.0
      ],
      [
        573.5927734375,
        776.4407348632812,
        -7.0
      ],
      [
        555.0,
        809.5999755859375,
        -19.0
      ],
      [
        555.0,
        809.5999755859375,
        -7.0
      ],
      [
        573.5927734375,
        810.7153930664062,
        -10.028987884521484
      ],
      [
        573.5927734375,
        810.7153930664062,
        -19.0
      ],
      [
        570.89990234375,
        809.5999755859375,
        -10.028987884521484
      ],
      [
        562.7217407226562,
        852.5098876953125,
        -7.0
      ],
      [
        573.5927734375,
        810.7153930664062,
        -8.0
      ],
      [
        573.0927734375,
        858.8523559570312,
        -9.983526229858398
      ],
      [
        573.0927734375,
        852.5098876953125,
        -7.0
      ],
      [
        573.0540161132812,
        858.948974609375,
        -10.028987884521484
      ],
      [
        573.0927734375,
        858.8523559570312,
        -9.983526229858398
      ],
      [
        573.5927734375,
        809.5999755859375,
        -8.0
      ],
      [
        573.5927734375,
        810.7153930664062,
        -8.0
      ],
      [
        572.4448852539062,
        861.809814453125,
        -7.0
      ],
      [
        569.43359375,
        867.971923828125,
        -10.028987884521484
      ],
      [
        572.0555419921875,
        861.4373779296875,
        -7.0
      ],
      [
        573.5927734375,
        796.1154174804688,
        -8.0
      ],
      [
        573.5927734375,
        796.1154174804688,
        -19.0
      ],
      [
        573.5927734375,
        796.1154174804688,
        -8.0
      ],
      [
        570.3228759765625,
        867.098388671875,
        -9.451436996459961
      ],
      [
        570.3228759765625,
        867.098388671875,
        -7.0
      ],
      [
        555.0,
        864.176513671875,
        -13.382086753845215
      ],
      [
        555.0,
        864.176513671875,
        -7.0
      ],
      [
        591.7796020507812,
        814.2953491210938,
        -19.0
      ],
      [
        591.7796020507812,
        814.2953491210938,
        -8.0
      ],
      [
        591.7796020507812,
        827.0,
        -8.0
      ],
      [
        591.7796020507812,
        827.0,
        -7.0
      ],
      [
        591.7796020507812,
        827.0,
        -8.0
      ],
      [
        591.7796020507812,
        817.0,
        -8.0
      ],
      [
        591.7796020507812,
        814.2953491210938,
        -8.0
      ],
      [
        591.7796020507812,
        817.0,
        -8.0
      ],
      [
        591.7796020507812,
        881.9164428710938,
        -19.0
      ],
      [
        591.7796020507812,
        881.9164428710938,
        -7.0
      ],
      [
        591.7796020507812,
        886.126708984375,
        -19.0
      ],
      [
        591.7796020507812,
        886.126708984375,
        -7.0
      ],
      [
        524.0,
        795.0,
        -19.0
      ],
      [
        524.0,
        795.0,
        -7.0
      ],
      [
        505.3768005371094,
        776.013916015625,
        -7.0
      ],
      [
        505.3768005371094,
        776.013916015625,
        -19.0
      ],
      [
        524.0,
        780.0,
        -7.0
      ],
      [
        524.0,
        780.0,
        -19.0
      ],
      [
        524.0,
        809.5999755859375,
        -7.0
      ],
      [
        524.0,
        809.5999755859375,
        -19.0
      ],
      [
        505.3768005371094,
        810.6865234375,
        -19.0
      ],
      [
        505.3768005371094,
        810.6865234375,
        -8.0
      ],
      [
        505.3768005371094,
        810.6865234375,
        -8.0
      ],
      [
        505.3768005371094,
        809.5999755859375,
        -8.0
      ],
      [
        505.3768005371094,
        796.0865478515625,
        -8.0
      ],
      [
        505.3768005371094,
        796.0865478515625,
        -8.0
      ],
      [
        505.3768005371094,
        796.0865478515625,
        -19.0
      ],
      [
        551.8211669921875,
        867.5,
        -15.513869285583496
      ],
      [
        555.0,
        867.5,
        -14.495380401611328
      ],
      [
        551.8211669921875,
        867.5,
        -15.513870239257812
      ],
      [
        551.8211669921875,
        867.5,
        -7.0
      ],
      [
        546.5999755859375,
        847.4334106445312,
        -19.0
      ],
      [
        546.5999755859375,
        847.4334106445312,
        -14.0
      ],
      [
        546.5999755859375,
        844.4154052734375,
        -16.417285919189453
      ],
      [
        546.5999755859375,
        844.4154052734375,
        -19.0
      ],
      [
        546.5999755859375,
        847.4334106445312,
        -14.0
      ],
      [
        546.5999755859375,
        846.4334106445312,
        -14.0
      ],
      [
        546.5999755859375,
        846.4334106445312,
        -15.5
      ],
      [
        546.5999755859375,
        844.4154052734375,
        -16.417285919189453
      ],
      [
        546.5999755859375,
        846.4334106445312,
        -14.0
      ],
      [
        546.5999755859375,
        846.4334106445312,
        -15.5
      ],
      [
        532.4000244140625,
        847.4170532226562,
        -19.0
      ],
      [
        532.4000244140625,
        847.4170532226562,
        -14.0
      ],
      [
        532.4000244140625,
        844.4317626953125,
        -19.0
      ],
      [
        532.4000244140625,
        844.4317626953125,
        -16.402421951293945
      ],
      [
        532.4000244140625,
        847.4170532226562,
        -14.0
      ],
      [
        532.4000244140625,
        846.4170532226562,
        -14.0
      ],
      [
        532.4000244140625,
        844.4317626953125,
        -16.402421951293945
      ],
      [
        532.4000244140625,
        846.4170532226562,
        -15.5
      ],
      [
        532.4000244140625,
        846.4170532226562,
        -14.0
      ],
      [
        532.4000244140625,
        846.4170532226562,
        -15.5
      ],
      [
        537.60888671875,
        849.4243774414062,
        -15.5
      ],
      [
        487.19000244140625,
        814.1270751953125,
        -8.0
      ],
      [
        487.19000244140625,
        814.1270751953125,
        -19.0
      ],
      [
        487.19000244140625,
        827.0,
        -8.0
      ],
      [
        487.19000244140625,
        827.0,
        -7.0
      ],
      [
        487.19000244140625,
        827.0,
        -8.0
      ],
      [
        487.19000244140625,
        817.0,
        -8.0
      ],
      [
        487.19000244140625,
        817.0,
        -8.0
      ],
      [
        487.19000244140625,
        814.1270751953125,
        -8.0
      ],
      [
        487.19000244140625,
        881.9163208007812,
        -19.0
      ],
      [
        487.19000244140625,
        881.9163208007812,
        -7.0
      ],
      [
        487.19000244140625,
        886.1267700195312,
        -7.0
      ],
      [
        487.19000244140625,
        886.1267700195312,
        -19.0
      ],
      [
        597.5687866210938,
        891.9158935546875,
        -19.0
      ],
      [
        597.5687866210938,
        891.9158935546875,
        -7.0
      ],
      [
        613.9696044921875,
        973.0000610351562,
        -19.0
      ],
      [
        613.9696044921875,
        973.0000610351562,
        -7.0
      ],
      [
        597.9696044921875,
        973.0000610351562,
        -19.0
      ],
      [
        597.5687866210938,
        973.0000610351562,
        -19.0
      ],
      [
        597.5687866210938,
        973.0000610351562,
        -7.0
      ],
      [
        597.9696044921875,
        973.0000610351562,
        -7.0
      ],
      [
        592.89990234375,
        827.0,
        -7.0
      ],
      [
        481.4007873535156,
        891.916015625,
        -7.0
      ],
      [
        481.4007873535156,
        891.916015625,
        -19.0
      ],
      [
        465.0,
        973.0,
        -19.0
      ],
      [
        465.0,
        973.0,
        -7.0
      ],
      [
        481.4007873535156,
        973.0,
        -19.0
      ],
      [
        481.0,
        973.0,
        -19.0
      ],
      [
        481.0,
        973.0,
        -7.0
      ],
      [
        481.4007873535156,
        973.0,
        -7.0
      ],
      [
        486.0,
        827.0,
        -7.0
      ],
      [
        552.9733276367188,
        1205.3753662109375,
        -16.00027847290039
      ],
      [
        595.5333862304688,
        1184.6834716796875,
        -16.000276565551758
      ],
      [
        587.6471557617188,
        1176.0596923828125,
        3.119999885559082
      ],
      [
        550.0620727539062,
        1194.3328857421875,
        3.119999885559082
      ],
      [
        550.0620727539062,
        1194.3328857421875,
        3.119999885559082
      ],
      [
        552.9733276367188,
        1205.3753662109375,
        -16.00027847290039
      ],
      [
        595.5333862304688,
        1184.6834716796875,
        -16.000276565551758
      ],
      [
        587.6471557617188,
        1176.0596923828125,
        3.119999885559082
      ],
      [
        606.884521484375,
        1179.3255615234375,
        -15.99997329711914
      ],
      [
        606.884521484375,
        1179.3255615234375,
        -15.99997329711914
      ],
      [
        606.8853759765625,
        1179.3270263671875,
        -15.999969482421875
      ],
      [
        544.7171630859375,
        1209.544189453125,
        -16.000017166137695
      ],
      [
        553.0198974609375,
        1205.47119140625,
        -16.000076293945312
      ],
      [
        597.1610717773438,
        1169.612060546875,
        10.0
      ],
      [
        604.1470336914062,
        1187.2071533203125,
        -8.0
      ],
      [
        604.1470336914062,
        1187.2071533203125,
        -17.0
      ],
      [
        604.1470336914062,
        1187.2071533203125,
        -8.0
      ],
      [
        604.1470336914062,
        1187.2071533203125,
        -17.0
      ],
      [
        404.46661376953125,
        1184.683349609375,
        -16.0
      ],
      [
        447.0266418457031,
        1205.375244140625,
        -16.0
      ],
      [
        449.93365478515625,
        1194.341552734375,
        3.119999885559082
      ],
      [
        412.34857177734375,
        1176.068359375,
        3.119999885559082
      ],
      [
        412.34857177734375,
        1176.068359375,
        3.119999885559082
      ],
      [
        404.46661376953125,
        1184.683349609375,
        -16.0
      ],
      [
        447.0266418457031,
        1205.375244140625,
        -16.0
      ],
      [
        449.93365478515625,
        1194.341552734375,
        3.119999885559082
      ],
      [
        393.11541748046875,
        1179.3255615234375,
        -16.0
      ],
      [
        393.11541748046875,
        1179.3255615234375,
        -16.0
      ],
      [
        393.1145935058594,
        1179.3271484375,
        -16.0
      ],
      [
        455.2828369140625,
        1209.544189453125,
        -16.0
      ],
      [
        446.98004150390625,
        1205.47119140625,
        -16.0
      ],
      [
        402.8387145996094,
        1169.6124267578125,
        10.0
      ],
      [
        392.57171630859375,
        1198.4000244140625,
        -18.622888565063477
      ],
      [
        393.1719055175781,
        1198.4000244140625,
        -18.622896194458008
      ],
      [
        392.371826171875,
        1198.0,
        -18.596227645874023
      ],
      [
        392.57171630859375,
        1198.4000244140625,
        -18.622888565063477
      ],
      [
        393.1719055175781,
        1198.4000244140625,
        -18.622896194458008
      ],
      [
        449.9380187988281,
        1194.3326416015625,
        3.119999885559082
      ],
      [
        412.35296630859375,
        1176.059326171875,
        3.119999885559082
      ],
      [
        412.35296630859375,
        1176.059326171875,
        3.119999885559082
      ],
      [
        449.9380187988281,
        1194.3326416015625,
        3.119999885559082
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -66.0
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -66.0
      ],
      [
        558.0,
        1004.9035034179688,
        -60.0
      ],
      [
        558.0,
        1004.9035034179688,
        -66.0
      ],
      [
        552.0,
        1004.9035034179688,
        -66.0
      ],
      [
        552.0,
        1004.9035034179688,
        -60.0
      ],
      [
        558.0,
        1000.0,
        -66.0
      ],
      [
        558.0,
        1000.0,
        -60.0
      ],
      [
        552.0,
        1000.0,
        -60.0
      ],
      [
        552.0,
        1000.0,
        -66.0
      ],
      [
        558.0,
        1004.9035034179688,
        -66.0
      ],
      [
        558.0,
        1004.9035034179688,
        -60.0
      ],
      [
        558.0,
        1000.0,
        -60.0
      ],
      [
        558.0,
        1000.0,
        -66.0
      ],
      [
        552.0,
        1000.0,
        -66.0
      ],
      [
        552.0,
        1000.0,
        -60.0
      ],
      [
        552.0,
        1004.9035034179688,
        -60.0
      ],
      [
        552.0,
        1004.9035034179688,
        -66.0
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -66.0
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -66.0
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -66.0
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -66.0
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -66.0
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -66.0
      ],
      [
        541.0991821289062,
        1211.5440673828125,
        -40.0
      ],
      [
        607.5992431640625,
        1179.212890625,
        -40.0
      ],
      [
        493.0,
        1298.4000244140625,
        -40.0
      ],
      [
        443.0000915527344,
        1298.4000244140625,
        -40.0
      ],
      [
        556.0,
        1298.4000244140625,
        -40.0
      ],
      [
        506.0000915527344,
        1298.4000244140625,
        -40.0
      ],
      [
        506.5,
        1228.3656005859375,
        -27.0
      ],
      [
        493.5,
        1234.68603515625,
        -27.0
      ],
      [
        506.5,
        1228.3656005859375,
        -27.0
      ],
      [
        513.422607421875,
        1225.0,
        -27.0
      ],
      [
        493.5,
        1234.68603515625,
        -27.0
      ],
      [
        482.7755432128906,
        1239.9000244140625,
        -27.0
      ],
      [
        443.0,
        1260.4000244140625,
        -27.0
      ],
      [
        493.0,
        1260.4000244140625,
        -27.0
      ],
      [
        506.0,
        1260.4000244140625,
        -27.0
      ],
      [
        556.0,
        1260.4000244140625,
        -27.0
      ],
      [
        571.8140869140625,
        1218.70751953125,
        -27.0
      ],
      [
        577.7512817382812,
        1230.6146240234375,
        -27.0
      ],
      [
        493.0,
        1260.4000244140625,
        -24.0
      ],
      [
        489.0,
        1260.4000244140625,
        -20.0
      ],
      [
        556.0,
        1260.4000244140625,
        -24.0
      ],
      [
        552.0,
        1260.4000244140625,
        -20.0
      ],
      [
        510.0,
        1260.4000244140625,
        -20.0
      ],
      [
        506.0,
        1260.4000244140625,
        -24.0
      ],
      [
        506.0000305175781,
        1258.4000244140625,
        -27.0
      ],
      [
        506.0,
        1260.4000244140625,
        -24.0
      ],
      [
        506.0000305175781,
        1260.4000244140625,
        -27.0
      ],
      [
        556.0,
        1258.4000244140625,
        -27.0
      ],
      [
        556.0,
        1260.4000244140625,
        -27.0
      ],
      [
        556.0,
        1260.4000244140625,
        -24.0
      ],
      [
        444.72418212890625,
        1258.4000244140625,
        -22.27582359313965
      ],
      [
        447.0,
        1260.4000244140625,
        -20.0
      ],
      [
        443.0,
        1260.4000244140625,
        -24.0
      ],
      [
        443.0,
        1259.23828125,
        -24.0
      ],
      [
        493.0,
        1258.4000244140625,
        -27.0
      ],
      [
        493.0,
        1260.4000244140625,
        -27.0
      ],
      [
        493.0,
        1260.4000244140625,
        -24.0
      ],
      [
        443.0,
        1259.23828125,
        -24.0
      ],
      [
        443.0,
        1260.4000244140625,
        -24.0
      ],
      [
        443.0000305175781,
        1260.4000244140625,
        -27.0
      ],
      [
        443.0000305175781,
        1259.23828125,
        -27.0
      ],
      [
        586.700439453125,
        1226.15234375,
        -27.0
      ],
      [
        580.7632446289062,
        1214.2452392578125,
        -27.0
      ],
      [
        577.7512817382812,
        1230.6146240234375,
        -27.0
      ],
      [
        586.700439453125,
        1226.15234375,
        -27.0
      ],
      [
        580.7632446289062,
        1214.2452392578125,
        -27.0
      ],
      [
        571.8140869140625,
        1218.70751953125,
        -27.0
      ],
      [
        506.0000305175781,
        1298.4000244140625,
        -27.0
      ],
      [
        443.0000305175781,
        1298.4000244140625,
        -27.0
      ],
      [
        493.0,
        1298.4000244140625,
        -27.0
      ],
      [
        468.0,
        1260.4000244140625,
        -27.0
      ],
      [
        468.0,
        1298.4000244140625,
        -27.0
      ],
      [
        468.0,
        1298.4000244140625,
        -27.0
      ],
      [
        468.0,
        1260.4000244140625,
        -27.0
      ],
      [
        447.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        445.5,
        1296.4000244140625,
        -27.0
      ],
      [
        445.5,
        1296.4000244140625,
        -27.0
      ],
      [
        443.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        448.0,
        1298.4000244140625,
        -27.0
      ],
      [
        447.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        443.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        443.0000305175781,
        1298.4000244140625,
        -27.0
      ],
      [
        465.5,
        1296.4000244140625,
        -27.0
      ],
      [
        463.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        467.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        465.5,
        1296.4000244140625,
        -27.0
      ],
      [
        463.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        463.0,
        1298.4000244140625,
        -27.0
      ],
      [
        468.0,
        1298.4000244140625,
        -27.0
      ],
      [
        467.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        472.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        470.5,
        1296.4000244140625,
        -27.0
      ],
      [
        470.5,
        1296.4000244140625,
        -27.0
      ],
      [
        468.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        473.0,
        1298.4000244140625,
        -27.0
      ],
      [
        472.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        468.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        468.0,
        1298.4000244140625,
        -27.0
      ],
      [
        490.5,
        1296.4000244140625,
        -27.0
      ],
      [
        488.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        492.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        490.5,
        1296.4000244140625,
        -27.0
      ],
      [
        488.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        488.0,
        1298.4000244140625,
        -27.0
      ],
      [
        493.0,
        1298.4000244140625,
        -27.0
      ],
      [
        492.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        556.0,
        1298.4000244140625,
        -27.0
      ],
      [
        531.0,
        1260.4000244140625,
        -27.0
      ],
      [
        531.0,
        1298.4000244140625,
        -27.0
      ],
      [
        531.0,
        1298.4000244140625,
        -27.0
      ],
      [
        531.0,
        1260.4000244140625,
        -27.0
      ],
      [
        510.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        508.5,
        1296.4000244140625,
        -27.0
      ],
      [
        508.5,
        1296.4000244140625,
        -27.0
      ],
      [
        506.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        511.0,
        1298.4000244140625,
        -27.0
      ],
      [
        510.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        506.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        506.0000305175781,
        1298.4000244140625,
        -27.0
      ],
      [
        528.5,
        1296.4000244140625,
        -27.0
      ],
      [
        526.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        530.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        528.5,
        1296.4000244140625,
        -27.0
      ],
      [
        526.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        526.0,
        1298.4000244140625,
        -27.0
      ],
      [
        531.0,
        1298.4000244140625,
        -27.0
      ],
      [
        530.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        535.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        533.5,
        1296.4000244140625,
        -27.0
      ],
      [
        533.5,
        1296.4000244140625,
        -27.0
      ],
      [
        531.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        536.0,
        1298.4000244140625,
        -27.0
      ],
      [
        535.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        531.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        531.0,
        1298.4000244140625,
        -27.0
      ],
      [
        553.5,
        1296.4000244140625,
        -27.0
      ],
      [
        551.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        555.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        553.5,
        1296.4000244140625,
        -27.0
      ],
      [
        551.732177734375,
        1296.9857177734375,
        -27.0
      ],
      [
        551.0,
        1298.4000244140625,
        -27.0
      ],
      [
        556.0,
        1298.4000244140625,
        -27.0
      ],
      [
        555.267822265625,
        1296.9857177734375,
        -27.0
      ],
      [
        556.0,
        1225.0,
        -40.0
      ],
      [
        513.422607421875,
        1225.0,
        -27.0
      ],
      [
        513.422607421875,
        1225.0,
        -40.0
      ],
      [
        557.4915161132812,
        1224.7191162109375,
        -40.0
      ],
      [
        570.915283203125,
        1218.025634765625,
        -40.0
      ],
      [
        557.4915161132812,
        1224.7191162109375,
        -40.0
      ],
      [
        556.0,
        1225.0,
        -40.0
      ],
      [
        586.1258544921875,
        1225.0,
        -27.0
      ],
      [
        586.1258544921875,
        1225.0,
        -31.200000762939453
      ],
      [
        586.1258544921875,
        1225.0,
        -31.200000762939453
      ],
      [
        580.7632446289062,
        1214.2452392578125,
        -40.0
      ],
      [
        586.1258544921875,
        1225.0,
        -40.0
      ],
      [
        570.915283203125,
        1218.025634765625,
        -40.0
      ],
      [
        572.2590942382812,
        1220.7205810546875,
        -40.0
      ],
      [
        574.3929443359375,
        1225.0,
        -27.0
      ],
      [
        574.3929443359375,
        1225.0,
        -33.20000076293945
      ],
      [
        580.7632446289062,
        1214.2452392578125,
        -40.0
      ],
      [
        571.8140869140625,
        1218.70751953125,
        -40.0
      ],
      [
        572.70654296875,
        1220.4974365234375,
        -40.0
      ],
      [
        571.8140869140625,
        1218.70751953125,
        -40.0
      ],
      [
        574.95166015625,
        1225.0,
        -31.200000762939453
      ],
      [
        574.95166015625,
        1225.0,
        -33.20000076293945
      ],
      [
        574.95166015625,
        1225.0,
        -27.0
      ],
      [
        574.95166015625,
        1225.0,
        -31.200000762939453
      ],
      [
        572.2590942382812,
        1220.7205810546875,
        -40.0
      ],
      [
        572.70654296875,
        1220.4974365234375,
        -40.0
      ],
      [
        574.3929443359375,
        1225.0,
        -33.20000076293945
      ],
      [
        574.95166015625,
        1225.0,
        -33.20000076293945
      ],
      [
        493.0,
        1258.4000244140625,
        -40.0
      ],
      [
        493.0,
        1298.4000244140625,
        -40.0
      ],
      [
        556.0,
        1258.4000244140625,
        -40.0
      ],
      [
        556.0,
        1298.4000244140625,
        -40.0
      ],
      [
        564.4120483398438,
        1238.59814453125,
        -40.0
      ],
      [
        577.8358154296875,
        1231.9046630859375,
        -40.0
      ],
      [
        564.4120483398438,
        1238.59814453125,
        -40.0
      ],
      [
        556.0,
        1239.9000244140625,
        -40.0
      ],
      [
        576.411376953125,
        1229.0479736328125,
        -40.0
      ],
      [
        577.8358154296875,
        1231.9046630859375,
        -40.0
      ],
      [
        586.700439453125,
        1226.15234375,
        -40.0
      ],
      [
        577.7512817382812,
        1230.6146240234375,
        -40.0
      ],
      [
        586.700439453125,
        1226.15234375,
        -40.0
      ],
      [
        577.7512817382812,
        1230.6146240234375,
        -40.0
      ],
      [
        576.8588256835938,
        1228.8248291015625,
        -40.0
      ],
      [
        576.411376953125,
        1229.0479736328125,
        -40.0
      ],
      [
        576.8588256835938,
        1228.8248291015625,
        -40.0
      ],
      [
        506.0000915527344,
        1258.4000244140625,
        -40.0
      ],
      [
        506.0000915527344,
        1298.4000244140625,
        -40.0
      ],
      [
        493.5,
        1239.9000244140625,
        -40.0
      ],
      [
        493.0,
        1239.9000244140625,
        -40.0
      ],
      [
        493.0,
        1239.9000244140625,
        -27.074073791503906
      ],
      [
        506.0000915527344,
        1239.9000244140625,
        -40.0
      ],
      [
        493.5,
        1239.9000244140625,
        -40.0
      ],
      [
        506.0000305175781,
        1239.9000244140625,
        -27.0
      ],
      [
        493.0,
        1239.9000244140625,
        -27.0
      ],
      [
        493.0,
        1239.9000244140625,
        -27.074073791503906
      ],
      [
        533.0,
        1260.4000244140625,
        -40.0
      ],
      [
        529.0,
        1260.4000244140625,
        -40.0
      ],
      [
        519.0,
        1260.4000244140625,
        -40.0
      ],
      [
        506.0000915527344,
        1260.4000244140625,
        -40.0
      ],
      [
        556.0,
        1260.4000244140625,
        -40.0
      ],
      [
        543.0,
        1260.4000244140625,
        -40.0
      ],
      [
        533.0,
        1239.9000244140625,
        -40.0
      ],
      [
        529.0,
        1239.9000244140625,
        -40.0
      ],
      [
        519.0,
        1239.9000244140625,
        -40.0
      ],
      [
        506.5,
        1239.9000244140625,
        -40.0
      ],
      [
        556.0,
        1239.9000244140625,
        -40.0
      ],
      [
        543.0,
        1239.9000244140625,
        -40.0
      ],
      [
        506.5,
        1239.9000244140625,
        -40.0
      ],
      [
        529.0,
        1258.4000244140625,
        -40.0
      ],
      [
        529.0,
        1260.4000244140625,
        -40.0
      ],
      [
        529.0,
        1239.9000244140625,
        -40.0
      ],
      [
        529.0,
        1258.4000244140625,
        -40.0
      ],
      [
        543.0,
        1258.4000244140625,
        -40.0
      ],
      [
        543.0,
        1260.4000244140625,
        -40.0
      ],
      [
        543.0,
        1239.9000244140625,
        -40.0
      ],
      [
        543.0,
        1258.4000244140625,
        -40.0
      ],
      [
        533.0,
        1260.4000244140625,
        -40.0
      ],
      [
        533.0,
        1258.4000244140625,
        -40.0
      ],
      [
        533.0,
        1239.9000244140625,
        -40.0
      ],
      [
        533.0,
        1258.4000244140625,
        -40.0
      ],
      [
        519.0,
        1260.4000244140625,
        -40.0
      ],
      [
        519.0,
        1258.4000244140625,
        -40.0
      ],
      [
        519.0,
        1239.9000244140625,
        -40.0
      ],
      [
        519.0,
        1258.4000244140625,
        -40.0
      ],
      [
        531.0,
        1260.4000244140625,
        -40.0
      ],
      [
        531.0,
        1298.4000244140625,
        -40.0
      ],
      [
        531.0,
        1298.4000244140625,
        -40.0
      ],
      [
        531.0,
        1260.4000244140625,
        -40.0
      ],
      [
        506.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        506.0000915527344,
        1298.4000244140625,
        -40.0
      ],
      [
        508.5,
        1296.4000244140625,
        -40.0
      ],
      [
        506.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        526.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        526.0,
        1298.4000244140625,
        -40.0
      ],
      [
        528.5,
        1296.4000244140625,
        -40.0
      ],
      [
        526.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        530.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        528.5,
        1296.4000244140625,
        -40.0
      ],
      [
        531.0,
        1298.4000244140625,
        -40.0
      ],
      [
        530.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        511.0,
        1298.4000244140625,
        -40.0
      ],
      [
        510.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        510.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        508.5,
        1296.4000244140625,
        -40.0
      ],
      [
        513.0,
        1297.4000244140625,
        -40.0
      ],
      [
        524.0,
        1297.4000244140625,
        -40.0
      ],
      [
        524.0,
        1297.4000244140625,
        -40.0
      ],
      [
        524.0,
        1298.4000244140625,
        -40.0
      ],
      [
        513.0,
        1297.4000244140625,
        -40.0
      ],
      [
        513.0,
        1298.4000244140625,
        -40.0
      ],
      [
        529.666748046875,
        1284.9000244140625,
        -40.0
      ],
      [
        529.666748046875,
        1271.9000244140625,
        -40.0
      ],
      [
        529.666748046875,
        1271.9000244140625,
        -40.0
      ],
      [
        531.0,
        1271.9000244140625,
        -40.0
      ],
      [
        531.0,
        1284.9000244140625,
        -40.0
      ],
      [
        529.666748046875,
        1284.9000244140625,
        -40.0
      ],
      [
        506.0,
        1271.9000244140625,
        -40.0
      ],
      [
        507.333251953125,
        1271.9000244140625,
        -40.0
      ],
      [
        507.333251953125,
        1271.9000244140625,
        -40.0
      ],
      [
        507.333251953125,
        1284.9000244140625,
        -40.0
      ],
      [
        507.333251953125,
        1284.9000244140625,
        -40.0
      ],
      [
        506.0,
        1284.9000244140625,
        -40.0
      ],
      [
        508.19287109375,
        1263.0469970703125,
        -31.0
      ],
      [
        508.19287109375,
        1263.0469970703125,
        -40.0
      ],
      [
        508.19287109375,
        1263.0469970703125,
        -31.0
      ],
      [
        508.19287109375,
        1263.0469970703125,
        -40.0
      ],
      [
        556.0,
        1298.4000244140625,
        -40.0
      ],
      [
        555.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        555.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        553.5,
        1296.4000244140625,
        -40.0
      ],
      [
        536.0,
        1298.4000244140625,
        -40.0
      ],
      [
        535.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        535.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        533.5,
        1296.4000244140625,
        -40.0
      ],
      [
        533.5,
        1296.4000244140625,
        -40.0
      ],
      [
        531.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        531.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        531.0,
        1298.4000244140625,
        -40.0
      ],
      [
        551.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        551.0,
        1298.4000244140625,
        -40.0
      ],
      [
        553.5,
        1296.4000244140625,
        -40.0
      ],
      [
        551.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        538.0,
        1297.4000244140625,
        -40.0
      ],
      [
        549.0,
        1297.4000244140625,
        -40.0
      ],
      [
        538.0,
        1298.4000244140625,
        -40.0
      ],
      [
        538.0,
        1297.4000244140625,
        -40.0
      ],
      [
        549.0,
        1298.4000244140625,
        -40.0
      ],
      [
        549.0,
        1297.4000244140625,
        -40.0
      ],
      [
        532.333251953125,
        1271.9000244140625,
        -40.0
      ],
      [
        532.333251953125,
        1284.9000244140625,
        -40.0
      ],
      [
        531.0,
        1271.9000244140625,
        -40.0
      ],
      [
        532.333251953125,
        1271.9000244140625,
        -40.0
      ],
      [
        532.333251953125,
        1284.9000244140625,
        -40.0
      ],
      [
        531.0,
        1284.9000244140625,
        -40.0
      ],
      [
        554.666748046875,
        1271.9000244140625,
        -40.0
      ],
      [
        556.0,
        1271.9000244140625,
        -40.0
      ],
      [
        554.666748046875,
        1284.9000244140625,
        -40.0
      ],
      [
        554.666748046875,
        1271.9000244140625,
        -40.0
      ],
      [
        556.0,
        1284.9000244140625,
        -40.0
      ],
      [
        554.666748046875,
        1284.9000244140625,
        -40.0
      ],
      [
        553.80712890625,
        1263.0469970703125,
        -40.0
      ],
      [
        553.80712890625,
        1263.0469970703125,
        -31.0
      ],
      [
        553.80712890625,
        1263.0469970703125,
        -40.0
      ],
      [
        553.80712890625,
        1263.0469970703125,
        -31.0
      ],
      [
        443.0000915527344,
        1298.4000244140625,
        -40.0
      ],
      [
        443.0000915527344,
        1259.2381591796875,
        -40.0
      ],
      [
        470.0,
        1260.4000244140625,
        -40.0
      ],
      [
        466.0,
        1260.4000244140625,
        -40.0
      ],
      [
        456.0,
        1260.4000244140625,
        -40.0
      ],
      [
        443.0000915527344,
        1260.4000244140625,
        -40.0
      ],
      [
        493.0,
        1260.4000244140625,
        -40.0
      ],
      [
        480.0,
        1260.4000244140625,
        -40.0
      ],
      [
        480.0,
        1258.4000244140625,
        -40.0
      ],
      [
        480.0,
        1260.4000244140625,
        -40.0
      ],
      [
        480.0,
        1241.24951171875,
        -29.0
      ],
      [
        480.0,
        1241.24951171875,
        -40.0
      ],
      [
        480.0,
        1258.4000244140625,
        -40.0
      ],
      [
        482.7756042480469,
        1239.9000244140625,
        -40.0
      ],
      [
        482.7756042480469,
        1239.9000244140625,
        -28.58880043029785
      ],
      [
        482.7755126953125,
        1239.9000244140625,
        -27.0
      ],
      [
        482.7756042480469,
        1239.9000244140625,
        -28.58880043029785
      ],
      [
        470.0,
        1246.111328125,
        -29.0
      ],
      [
        480.0,
        1241.24951171875,
        -29.0
      ],
      [
        456.0,
        1252.9178466796875,
        -29.0
      ],
      [
        466.0,
        1248.0560302734375,
        -29.0
      ],
      [
        470.0,
        1260.4000244140625,
        -40.0
      ],
      [
        470.0,
        1258.4000244140625,
        -40.0
      ],
      [
        470.0,
        1246.111328125,
        -29.0
      ],
      [
        470.0,
        1258.4000244140625,
        -40.0
      ],
      [
        470.0,
        1246.111328125,
        -40.0
      ],
      [
        466.0,
        1258.4000244140625,
        -40.0
      ],
      [
        466.0,
        1260.4000244140625,
        -40.0
      ],
      [
        466.0,
        1248.0560302734375,
        -29.0
      ],
      [
        466.0,
        1248.0560302734375,
        -40.0
      ],
      [
        466.0,
        1258.4000244140625,
        -40.0
      ],
      [
        456.0,
        1260.4000244140625,
        -40.0
      ],
      [
        456.0,
        1258.4000244140625,
        -40.0
      ],
      [
        456.0,
        1252.9178466796875,
        -29.0
      ],
      [
        456.0,
        1258.4000244140625,
        -40.0
      ],
      [
        456.0,
        1252.9178466796875,
        -40.0
      ],
      [
        475.165283203125,
        1243.5999755859375,
        -29.0
      ],
      [
        473.70831298828125,
        1244.3082275390625,
        -29.354154586791992
      ],
      [
        473.0,
        1244.6527099609375,
        -29.0
      ],
      [
        473.70831298828125,
        1244.3082275390625,
        -29.354154586791992
      ],
      [
        468.0,
        1260.4000244140625,
        -40.0
      ],
      [
        468.0,
        1298.4000244140625,
        -40.0
      ],
      [
        468.0,
        1298.4000244140625,
        -40.0
      ],
      [
        468.0,
        1260.4000244140625,
        -40.0
      ],
      [
        443.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        443.0000915527344,
        1298.4000244140625,
        -40.0
      ],
      [
        445.5,
        1296.4000244140625,
        -40.0
      ],
      [
        443.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        463.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        463.0,
        1298.4000244140625,
        -40.0
      ],
      [
        465.5,
        1296.4000244140625,
        -40.0
      ],
      [
        463.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        467.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        465.5,
        1296.4000244140625,
        -40.0
      ],
      [
        468.0,
        1298.4000244140625,
        -40.0
      ],
      [
        467.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        448.0,
        1298.4000244140625,
        -40.0
      ],
      [
        447.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        447.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        445.5,
        1296.4000244140625,
        -40.0
      ],
      [
        450.0,
        1297.4000244140625,
        -40.0
      ],
      [
        461.0,
        1297.4000244140625,
        -40.0
      ],
      [
        461.0,
        1297.4000244140625,
        -40.0
      ],
      [
        461.0,
        1298.4000244140625,
        -40.0
      ],
      [
        450.0,
        1297.4000244140625,
        -40.0
      ],
      [
        450.0,
        1298.4000244140625,
        -40.0
      ],
      [
        466.666748046875,
        1284.9000244140625,
        -40.0
      ],
      [
        466.666748046875,
        1271.9000244140625,
        -40.0
      ],
      [
        466.666748046875,
        1271.9000244140625,
        -40.0
      ],
      [
        468.0,
        1271.9000244140625,
        -40.0
      ],
      [
        468.0,
        1284.9000244140625,
        -40.0
      ],
      [
        466.666748046875,
        1284.9000244140625,
        -40.0
      ],
      [
        443.0,
        1271.9000244140625,
        -40.0
      ],
      [
        444.333251953125,
        1271.9000244140625,
        -40.0
      ],
      [
        444.333251953125,
        1271.9000244140625,
        -40.0
      ],
      [
        444.333251953125,
        1284.9000244140625,
        -40.0
      ],
      [
        444.333251953125,
        1284.9000244140625,
        -40.0
      ],
      [
        443.0,
        1284.9000244140625,
        -40.0
      ],
      [
        445.19287109375,
        1263.0469970703125,
        -31.0
      ],
      [
        445.19287109375,
        1263.0469970703125,
        -40.0
      ],
      [
        445.19287109375,
        1263.0469970703125,
        -31.0
      ],
      [
        445.19287109375,
        1263.0469970703125,
        -40.0
      ],
      [
        493.0,
        1298.4000244140625,
        -40.0
      ],
      [
        492.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        492.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        490.5,
        1296.4000244140625,
        -40.0
      ],
      [
        473.0,
        1298.4000244140625,
        -40.0
      ],
      [
        472.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        472.267822265625,
        1296.9857177734375,
        -40.0
      ],
      [
        470.5,
        1296.4000244140625,
        -40.0
      ],
      [
        470.5,
        1296.4000244140625,
        -40.0
      ],
      [
        468.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        468.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        468.0,
        1298.4000244140625,
        -40.0
      ],
      [
        488.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        488.0,
        1298.4000244140625,
        -40.0
      ],
      [
        490.5,
        1296.4000244140625,
        -40.0
      ],
      [
        488.732177734375,
        1296.9857177734375,
        -40.0
      ],
      [
        475.0,
        1297.4000244140625,
        -40.0
      ],
      [
        486.0,
        1297.4000244140625,
        -40.0
      ],
      [
        475.0,
        1298.4000244140625,
        -40.0
      ],
      [
        475.0,
        1297.4000244140625,
        -40.0
      ],
      [
        486.0,
        1298.4000244140625,
        -40.0
      ],
      [
        486.0,
        1297.4000244140625,
        -40.0
      ],
      [
        469.333251953125,
        1271.9000244140625,
        -40.0
      ],
      [
        469.333251953125,
        1284.9000244140625,
        -40.0
      ],
      [
        468.0,
        1271.9000244140625,
        -40.0
      ],
      [
        469.333251953125,
        1271.9000244140625,
        -40.0
      ],
      [
        469.333251953125,
        1284.9000244140625,
        -40.0
      ],
      [
        468.0,
        1284.9000244140625,
        -40.0
      ],
      [
        491.666748046875,
        1271.9000244140625,
        -40.0
      ],
      [
        493.0,
        1271.9000244140625,
        -40.0
      ],
      [
        491.666748046875,
        1284.9000244140625,
        -40.0
      ],
      [
        491.666748046875,
        1271.9000244140625,
        -40.0
      ],
      [
        493.0,
        1284.9000244140625,
        -40.0
      ],
      [
        491.666748046875,
        1284.9000244140625,
        -40.0
      ],
      [
        490.8070983886719,
        1263.0469970703125,
        -40.0
      ],
      [
        490.8070983886719,
        1263.0469970703125,
        -31.0
      ],
      [
        490.8070983886719,
        1263.0469970703125,
        -40.0
      ],
      [
        490.8070983886719,
        1263.0469970703125,
        -31.0
      ],
      [
        458.9007263183594,
        1042.2559814453125,
        -40.0
      ],
      [
        392.4007263183594,
        1074.587158203125,
        -40.0
      ],
      [
        465.0,
        974.5999755859375,
        -40.0
      ],
      [
        481.0,
        974.5999755859375,
        -40.0
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -40.0
      ],
      [
        598.05810546875,
        974.6000366210938,
        -40.0
      ],
      [
        598.05810546875,
        974.6000366210938,
        -20.0
      ],
      [
        481.0,
        990.0,
        -40.0
      ],
      [
        465.0,
        990.0,
        -40.0
      ],
      [
        481.0,
        974.5999755859375,
        -40.0
      ],
      [
        481.0,
        990.0,
        -40.0
      ],
      [
        597.9696044921875,
        974.64306640625,
        -40.0
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -40.0
      ],
      [
        597.9696044921875,
        974.64306640625,
        -20.0
      ],
      [
        465.0,
        990.0,
        -40.0
      ],
      [
        465.0,
        974.5999755859375,
        -40.0
      ],
      [
        392.4007263183594,
        1179.212890625,
        -40.0
      ],
      [
        458.90069580078125,
        1211.5440673828125,
        -40.0
      ],
      [
        500.0,
        1231.52587890625,
        -27.0
      ],
      [
        493.5,
        1228.3656005859375,
        -27.0
      ],
      [
        493.5,
        1228.3656005859375,
        -27.0
      ],
      [
        486.57757568359375,
        1225.0,
        -27.0
      ],
      [
        420.74871826171875,
        1230.6146240234375,
        -27.0
      ],
      [
        426.6859130859375,
        1218.70751953125,
        -27.0
      ],
      [
        443.0000305175781,
        1258.4000244140625,
        -27.0
      ],
      [
        443.0000305175781,
        1259.23828125,
        -27.0
      ],
      [
        417.73675537109375,
        1214.2452392578125,
        -27.0
      ],
      [
        411.799560546875,
        1226.15234375,
        -27.0
      ],
      [
        411.799560546875,
        1226.15234375,
        -27.0
      ],
      [
        420.74871826171875,
        1230.6146240234375,
        -27.0
      ],
      [
        426.6859130859375,
        1218.70751953125,
        -27.0
      ],
      [
        417.73675537109375,
        1214.2452392578125,
        -27.0
      ],
      [
        486.57757568359375,
        1225.0,
        -27.0
      ],
      [
        442.5,
        1225.0,
        -40.0
      ],
      [
        486.57757568359375,
        1225.0,
        -40.0
      ],
      [
        427.584716796875,
        1218.025634765625,
        -40.0
      ],
      [
        441.00848388671875,
        1224.7191162109375,
        -40.0
      ],
      [
        442.5,
        1225.0,
        -40.0
      ],
      [
        441.00848388671875,
        1224.7191162109375,
        -40.0
      ],
      [
        412.3741455078125,
        1225.0,
        -27.0
      ],
      [
        412.3741455078125,
        1225.0,
        -31.200000762939453
      ],
      [
        412.3741455078125,
        1225.0,
        -40.0
      ],
      [
        417.73675537109375,
        1214.2452392578125,
        -40.0
      ],
      [
        412.3741455078125,
        1225.0,
        -31.200000762939453
      ],
      [
        426.24090576171875,
        1220.7205810546875,
        -40.0
      ],
      [
        427.584716796875,
        1218.025634765625,
        -40.0
      ],
      [
        424.1070556640625,
        1225.0,
        -33.20000076293945
      ],
      [
        424.1070861816406,
        1225.0,
        -27.0
      ],
      [
        426.6859130859375,
        1218.70751953125,
        -40.0
      ],
      [
        417.73675537109375,
        1214.2452392578125,
        -40.0
      ],
      [
        426.6859130859375,
        1218.70751953125,
        -40.0
      ],
      [
        425.79339599609375,
        1220.4974365234375,
        -40.0
      ],
      [
        423.5483093261719,
        1225.0,
        -33.20000076293945
      ],
      [
        423.5483093261719,
        1225.0,
        -31.200000762939453
      ],
      [
        423.5483093261719,
        1225.0,
        -27.0
      ],
      [
        423.5483093261719,
        1225.0,
        -31.200000762939453
      ],
      [
        425.79339599609375,
        1220.4974365234375,
        -40.0
      ],
      [
        426.24090576171875,
        1220.7205810546875,
        -40.0
      ],
      [
        423.5483093261719,
        1225.0,
        -33.20000076293945
      ],
      [
        424.1070556640625,
        1225.0,
        -33.20000076293945
      ],
      [
        470.0,
        1239.9000244140625,
        -40.0
      ],
      [
        466.0,
        1239.9000244140625,
        -40.0
      ],
      [
        480.0,
        1239.9000244140625,
        -40.0
      ],
      [
        456.0,
        1239.9000244140625,
        -40.0
      ],
      [
        442.5,
        1239.9000244140625,
        -40.0
      ],
      [
        456.0,
        1239.9000244140625,
        -40.0
      ],
      [
        443.0000915527344,
        1258.4000244140625,
        -40.0
      ],
      [
        466.0,
        1239.9000244140625,
        -40.0
      ],
      [
        470.0,
        1239.9000244140625,
        -40.0
      ],
      [
        480.0,
        1239.9000244140625,
        -40.0
      ],
      [
        420.6641845703125,
        1231.9046630859375,
        -40.0
      ],
      [
        434.08795166015625,
        1238.59814453125,
        -40.0
      ],
      [
        442.5,
        1239.9000244140625,
        -40.0
      ],
      [
        434.08795166015625,
        1238.59814453125,
        -40.0
      ],
      [
        420.6641845703125,
        1231.9046630859375,
        -40.0
      ],
      [
        422.088623046875,
        1229.0479736328125,
        -40.0
      ],
      [
        420.74871826171875,
        1230.6146240234375,
        -40.0
      ],
      [
        411.799560546875,
        1226.15234375,
        -40.0
      ],
      [
        411.799560546875,
        1226.15234375,
        -40.0
      ],
      [
        421.64117431640625,
        1228.8248291015625,
        -40.0
      ],
      [
        420.74871826171875,
        1230.6146240234375,
        -40.0
      ],
      [
        421.64117431640625,
        1228.8248291015625,
        -40.0
      ],
      [
        422.088623046875,
        1229.0479736328125,
        -40.0
      ],
      [
        458.9007263183594,
        1042.2559814453125,
        -40.0
      ],
      [
        478.6158447265625,
        1042.2559814453125,
        -40.0
      ],
      [
        511.1296691894531,
        1042.2559814453125,
        -40.0
      ],
      [
        541.0992431640625,
        1042.2559814453125,
        -40.0
      ],
      [
        478.6158447265625,
        1042.2559814453125,
        -40.0
      ],
      [
        511.1296691894531,
        1042.2559814453125,
        -40.0
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -40.0
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -40.0
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -40.0
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -40.0
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -40.0
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -40.0
      ],
      [
        541.0991821289062,
        1211.5440673828125,
        -40.0
      ],
      [
        506.5,
        1211.5440673828125,
        -40.0
      ],
      [
        493.5,
        1211.5440673828125,
        -40.0
      ],
      [
        458.90069580078125,
        1211.5440673828125,
        -40.0
      ],
      [
        506.5,
        1211.5440673828125,
        -40.0
      ],
      [
        506.5,
        1225.0,
        -40.0
      ],
      [
        506.5,
        1225.0,
        -40.0
      ],
      [
        493.5,
        1225.0,
        -30.0
      ],
      [
        486.57757568359375,
        1225.0,
        -30.0
      ],
      [
        493.5,
        1211.5440673828125,
        -40.0
      ],
      [
        493.5,
        1225.0,
        -40.0
      ],
      [
        493.5,
        1225.0,
        -40.0
      ],
      [
        567.0,
        1054.8485107421875,
        -40.0
      ],
      [
        585.0,
        1063.5997314453125,
        -40.0
      ],
      [
        592.6907348632812,
        1067.3388671875,
        -40.0
      ],
      [
        607.5992431640625,
        1074.587158203125,
        -40.0
      ],
      [
        541.0992431640625,
        1042.2559814453125,
        -40.0
      ],
      [
        559.119873046875,
        1051.017333984375,
        -40.0
      ],
      [
        559.119873046875,
        1051.017333984375,
        -40.0
      ],
      [
        592.6907348632812,
        1067.3388671875,
        -40.0
      ],
      [
        633.0,
        1126.9000244140625,
        -40.0
      ],
      [
        607.5992431640625,
        1074.587158203125,
        -40.0
      ],
      [
        607.5992431640625,
        1179.212890625,
        -40.0
      ],
      [
        633.0,
        1126.9000244140625,
        -40.0
      ],
      [
        367.0,
        1126.9000244140625,
        -40.0
      ],
      [
        392.4007263183594,
        1179.212890625,
        -40.0
      ],
      [
        392.4007263183594,
        1074.587158203125,
        -40.0
      ],
      [
        367.0,
        1126.9000244140625,
        -40.0
      ],
      [
        493.5,
        1190.243896484375,
        -40.0
      ],
      [
        506.5,
        1190.243896484375,
        -40.0
      ],
      [
        506.5,
        1186.3387451171875,
        -40.0
      ],
      [
        506.5,
        1190.243896484375,
        -40.0
      ],
      [
        493.5,
        1186.3387451171875,
        -40.0
      ],
      [
        493.5,
        1190.243896484375,
        -40.0
      ],
      [
        493.5,
        1186.3387451171875,
        -40.0
      ],
      [
        506.5,
        1186.3387451171875,
        -40.0
      ],
      [
        495.19219970703125,
        1152.494873046875,
        -27.0
      ],
      [
        493.5,
        1152.494873046875,
        -27.0
      ],
      [
        506.5,
        1152.494873046875,
        -27.0
      ],
      [
        504.80780029296875,
        1152.494873046875,
        -27.0
      ],
      [
        495.19219970703125,
        1152.494873046875,
        -27.0
      ],
      [
        504.80780029296875,
        1152.494873046875,
        -27.0
      ],
      [
        494.0,
        1155.9000244140625,
        -26.80793571472168
      ],
      [
        493.5,
        1155.2750244140625,
        -27.0
      ],
      [
        493.5,
        1155.2750244140625,
        -26.56786346435547
      ],
      [
        494.0,
        1155.9000244140625,
        -26.807937622070312
      ],
      [
        506.5,
        1155.2750244140625,
        -27.0
      ],
      [
        506.0,
        1155.9000244140625,
        -26.807937622070312
      ],
      [
        506.5,
        1155.2750244140625,
        -26.5678653717041
      ],
      [
        506.0,
        1155.9000244140625,
        -26.80793571472168
      ],
      [
        493.5,
        1143.641357421875,
        -27.0
      ],
      [
        493.5,
        1139.15869140625,
        -27.0
      ],
      [
        506.5,
        1139.15869140625,
        -27.0
      ],
      [
        506.5,
        1143.641357421875,
        -27.0
      ],
      [
        493.5,
        1143.641357421875,
        -27.0
      ],
      [
        493.5,
        1139.15869140625,
        -27.0
      ],
      [
        506.5,
        1139.15869140625,
        -27.0
      ],
      [
        506.5,
        1143.641357421875,
        -27.0
      ],
      [
        506.5,
        1126.4000244140625,
        -40.0
      ],
      [
        493.5,
        1126.4000244140625,
        -40.0
      ],
      [
        493.5,
        1156.4000244140625,
        -40.0
      ],
      [
        506.5,
        1156.4000244140625,
        -40.0
      ],
      [
        493.5,
        1127.5250244140625,
        -23.5
      ],
      [
        506.5,
        1127.5250244140625,
        -23.5
      ],
      [
        506.5,
        1127.5250244140625,
        -27.0
      ],
      [
        506.5,
        1127.5250244140625,
        -23.5
      ],
      [
        493.5,
        1127.5250244140625,
        -27.0
      ],
      [
        493.5,
        1127.5250244140625,
        -23.5
      ],
      [
        493.5,
        1126.4000244140625,
        -40.0
      ],
      [
        485.5,
        1136.4000244140625,
        -40.0
      ],
      [
        486.2106018066406,
        1147.288330078125,
        -23.5
      ],
      [
        485.5,
        1146.4000244140625,
        -40.0
      ],
      [
        493.5,
        1156.4000244140625,
        -40.0
      ],
      [
        485.5,
        1136.4000244140625,
        -40.0
      ],
      [
        485.5,
        1146.4000244140625,
        -40.0
      ],
      [
        486.2106018066406,
        1147.288330078125,
        -23.5
      ],
      [
        487.1105651855469,
        1147.2882080078125,
        -23.5
      ],
      [
        487.1105651855469,
        1147.2882080078125,
        -23.5
      ],
      [
        514.5,
        1136.4000244140625,
        -40.0
      ],
      [
        506.5,
        1126.4000244140625,
        -40.0
      ],
      [
        513.7893676757812,
        1147.288330078125,
        -23.5
      ],
      [
        506.5,
        1156.4000244140625,
        -40.0
      ],
      [
        514.5,
        1146.4000244140625,
        -40.0
      ],
      [
        514.5,
        1146.4000244140625,
        -40.0
      ],
      [
        514.5,
        1136.4000244140625,
        -40.0
      ],
      [
        513.7893676757812,
        1147.288330078125,
        -23.5
      ],
      [
        512.8894653320312,
        1147.2882080078125,
        -23.5
      ],
      [
        512.8894653320312,
        1147.2882080078125,
        -23.5
      ],
      [
        593.2686767578125,
        1068.1461181640625,
        -40.0
      ],
      [
        589.5020751953125,
        1066.31494140625,
        -40.0
      ],
      [
        558.4580078125,
        1051.2218017578125,
        -40.0
      ],
      [
        562.51708984375,
        1053.1951904296875,
        -40.0
      ],
      [
        589.7090454101562,
        1065.8892822265625,
        -40.0
      ],
      [
        589.5020751953125,
        1066.31494140625,
        -40.0
      ],
      [
        593.4756469726562,
        1067.720458984375,
        -40.0
      ],
      [
        593.2686767578125,
        1068.1461181640625,
        -40.0
      ],
      [
        558.4580078125,
        1051.2218017578125,
        -40.0
      ],
      [
        558.6649169921875,
        1050.796142578125,
        -40.0
      ],
      [
        562.51708984375,
        1053.1951904296875,
        -40.0
      ],
      [
        562.7239990234375,
        1052.76953125,
        -40.0
      ],
      [
        493.5,
        1209.800048828125,
        -40.0
      ],
      [
        493.5,
        1211.5440673828125,
        -40.0
      ],
      [
        490.9346008300781,
        1211.5440673828125,
        -40.0
      ],
      [
        490.9346008300781,
        1209.800048828125,
        -40.0
      ],
      [
        493.5,
        1209.800048828125,
        -40.0
      ],
      [
        490.9346008300781,
        1209.800048828125,
        -40.0
      ],
      [
        506.5,
        1211.5440673828125,
        -40.0
      ],
      [
        506.5,
        1209.800048828125,
        -40.0
      ],
      [
        509.0653991699219,
        1209.800048828125,
        -40.0
      ],
      [
        509.0653991699219,
        1211.5440673828125,
        -40.0
      ],
      [
        509.0653991699219,
        1209.800048828125,
        -40.0
      ],
      [
        506.5,
        1209.800048828125,
        -40.0
      ],
      [
        596.6741333007812,
        1052.0869140625,
        -60.0
      ],
      [
        596.6741333007812,
        1052.0869140625,
        -44.052040100097656
      ],
      [
        610.9696044921875,
        1003.2859497070312,
        -60.0
      ],
      [
        610.9696044921875,
        1003.2859497070312,
        -49.0
      ],
      [
        607.822998046875,
        1014.0276489257812,
        -49.0
      ],
      [
        610.4674682617188,
        1005.0000610351562,
        -49.0
      ],
      [
        607.822998046875,
        1014.0276489257812,
        -49.0
      ],
      [
        610.9696044921875,
        1003.2859497070312,
        -49.0
      ],
      [
        610.4674682617188,
        1005.0000610351562,
        -49.0
      ],
      [
        596.6741333007812,
        1052.0869140625,
        -44.052040100097656
      ],
      [
        584.590087890625,
        1027.1998291015625,
        -46.769935607910156
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -56.57497024536133
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -55.3919792175293
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -54.340267181396484
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -56.57497024536133
      ],
      [
        600.9696044921875,
        990.0000610351562,
        -53.379085540771484
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -53.157264709472656
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -54.340267181396484
      ],
      [
        610.9696044921875,
        990.0000610351562,
        -54.11845779418945
      ],
      [
        600.9696044921875,
        990.0000610351562,
        -53.379085540771484
      ],
      [
        600.9696044921875,
        1005.0000610351562,
        -51.20243835449219
      ],
      [
        600.9696044921875,
        1005.0000610351562,
        -51.20243835449219
      ],
      [
        600.3094482421875,
        1012.014404296875,
        -50.135772705078125
      ],
      [
        600.3094482421875,
        1012.014404296875,
        -50.135772705078125
      ],
      [
        610.9696044921875,
        990.0000610351562,
        -54.11845779418945
      ],
      [
        610.9696044921875,
        1003.2859497070312,
        -52.19053649902344
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -55.3919792175293
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -53.157264709472656
      ],
      [
        584.590087890625,
        1027.1998291015625,
        -46.769935607910156
      ],
      [
        584.590087890625,
        1027.1998291015625,
        -60.0
      ],
      [
        597.9696044921875,
        1015.5737915039062,
        -60.0
      ],
      [
        597.9696044921875,
        1015.5737915039062,
        -49.44625473022461
      ],
      [
        584.202880859375,
        1227.397705078125,
        -43.0
      ],
      [
        584.202880859375,
        1227.397705078125,
        -40.0
      ],
      [
        585.741455078125,
        1224.22900390625,
        -43.0
      ],
      [
        585.741455078125,
        1224.22900390625,
        -40.0
      ],
      [
        585.741455078125,
        1224.22900390625,
        -43.0
      ],
      [
        584.202880859375,
        1227.397705078125,
        -43.0
      ],
      [
        580.3946533203125,
        1192.4393310546875,
        -55.5
      ],
      [
        573.8358154296875,
        1178.94921875,
        -55.5
      ],
      [
        572.0,
        1179.841796875,
        -60.000038146972656
      ],
      [
        572.0,
        1179.841796875,
        -55.5
      ],
      [
        573.8358154296875,
        1178.94921875,
        -55.5
      ],
      [
        580.3946533203125,
        1192.4393310546875,
        -55.5
      ],
      [
        607.5992431640625,
        1179.212890625,
        -55.5
      ],
      [
        607.5992431640625,
        1074.587158203125,
        -55.5
      ],
      [
        589.158203125,
        1083.541259765625,
        -55.5
      ],
      [
        589.3895874023438,
        1082.873046875,
        -55.5
      ],
      [
        607.380859375,
        1074.1373291015625,
        -55.5
      ],
      [
        589.158203125,
        1083.541259765625,
        -55.5
      ],
      [
        589.3895874023438,
        1082.873046875,
        -55.5
      ],
      [
        607.027099609375,
        1074.3089599609375,
        -60.0
      ],
      [
        607.5992431640625,
        1074.587158203125,
        -55.5
      ],
      [
        607.027099609375,
        1074.3089599609375,
        -55.5
      ],
      [
        589.708984375,
        1065.8892822265625,
        -55.5
      ],
      [
        572.0,
        1037.0919189453125,
        -55.5
      ],
      [
        572.0,
        1037.0919189453125,
        -60.0
      ],
      [
        584.590087890625,
        1027.1998291015625,
        -55.5
      ],
      [
        589.708984375,
        1065.8892822265625,
        -55.5
      ],
      [
        596.5827026367188,
        1052.39892578125,
        -55.5
      ],
      [
        596.5827026367188,
        1052.39892578125,
        -55.5
      ],
      [
        596.6741333007812,
        1052.0869140625,
        -55.5
      ],
      [
        592.60107421875,
        1069.5191650390625,
        -55.5
      ],
      [
        588.83447265625,
        1067.6878662109375,
        -55.5
      ],
      [
        593.4755859375,
        1067.720458984375,
        -55.5
      ],
      [
        592.60107421875,
        1069.5191650390625,
        -55.5
      ],
      [
        589.708984375,
        1065.8892822265625,
        -55.5
      ],
      [
        588.83447265625,
        1067.6878662109375,
        -55.5
      ],
      [
        602.5125732421875,
        1109.9000244140625,
        -55.5
      ],
      [
        610.7670288085938,
        1126.9000244140625,
        -55.5
      ],
      [
        589.6079711914062,
        1083.3228759765625,
        -55.5
      ],
      [
        598.8709716796875,
        1102.4000244140625,
        -55.5
      ],
      [
        598.7784423828125,
        1150.4459228515625,
        -55.5
      ],
      [
        617.219482421875,
        1159.4000244140625,
        -55.5
      ],
      [
        617.0010986328125,
        1159.849853515625,
        -55.5
      ],
      [
        599.009765625,
        1151.1141357421875,
        -55.5
      ],
      [
        599.009765625,
        1151.1141357421875,
        -55.5
      ],
      [
        598.7784423828125,
        1150.4459228515625,
        -55.5
      ],
      [
        598.421142578125,
        1102.618408203125,
        -55.5
      ],
      [
        589.158203125,
        1083.541259765625,
        -55.5
      ],
      [
        610.3172607421875,
        1126.9000244140625,
        -55.5
      ],
      [
        602.0628662109375,
        1110.118408203125,
        -55.5
      ],
      [
        602.0628662109375,
        1110.118408203125,
        -55.5
      ],
      [
        602.5125732421875,
        1109.9000244140625,
        -55.5
      ],
      [
        602.0628051757812,
        1110.118408203125,
        -55.7249870300293
      ],
      [
        602.0628051757812,
        1110.118408203125,
        -60.0
      ],
      [
        610.7670288085938,
        1126.9000244140625,
        -55.5
      ],
      [
        610.5435791015625,
        1127.3602294921875,
        -55.5
      ],
      [
        610.5435791015625,
        1127.3602294921875,
        -60.0
      ],
      [
        598.8709716796875,
        1102.4000244140625,
        -55.5
      ],
      [
        598.421142578125,
        1102.618408203125,
        -55.5
      ],
      [
        598.4212036132812,
        1102.618408203125,
        -60.0
      ],
      [
        598.4212036132812,
        1102.618408203125,
        -55.724998474121094
      ],
      [
        598.4212036132812,
        1102.618408203125,
        -55.724998474121094
      ],
      [
        602.0628051757812,
        1110.118408203125,
        -55.7249870300293
      ],
      [
        610.4890747070312,
        1127.472412109375,
        -55.5
      ],
      [
        610.4890747070312,
        1127.472412109375,
        -60.0
      ],
      [
        610.2634887695312,
        1127.0078125,
        -55.5
      ],
      [
        610.3172607421875,
        1126.9000244140625,
        -55.5
      ],
      [
        610.2634887695312,
        1127.0078125,
        -60.0
      ],
      [
        606.882568359375,
        1134.9000244140625,
        -55.5
      ],
      [
        606.432861328125,
        1134.681640625,
        -55.5
      ],
      [
        603.033935546875,
        1141.681640625,
        -55.5
      ],
      [
        603.4837036132812,
        1141.9000244140625,
        -55.5
      ],
      [
        603.4837036132812,
        1141.9000244140625,
        -55.5
      ],
      [
        599.2281494140625,
        1150.664306640625,
        -55.5
      ],
      [
        598.7784423828125,
        1150.4459228515625,
        -55.5
      ],
      [
        603.033935546875,
        1141.681640625,
        -55.5
      ],
      [
        606.432861328125,
        1134.681640625,
        -55.5
      ],
      [
        606.882568359375,
        1134.9000244140625,
        -55.5
      ],
      [
        572.0,
        1196.5206298828125,
        -54.11140823364258
      ],
      [
        572.0,
        1196.5206298828125,
        -40.0
      ],
      [
        572.0,
        1218.6148681640625,
        -43.0
      ],
      [
        572.0,
        1219.080322265625,
        -43.0
      ],
      [
        572.0,
        1234.8145751953125,
        -43.0
      ],
      [
        572.0,
        1220.2010498046875,
        -43.0
      ],
      [
        572.0,
        1218.6148681640625,
        -40.0
      ],
      [
        572.0,
        1218.6148681640625,
        -43.0
      ],
      [
        572.0,
        1234.8145751953125,
        -40.0
      ],
      [
        572.0,
        1234.8145751953125,
        -43.0
      ],
      [
        572.0,
        1220.200927734375,
        -43.0
      ],
      [
        572.0,
        1220.200927734375,
        -40.0
      ],
      [
        572.0,
        1219.0804443359375,
        -43.0
      ],
      [
        572.0,
        1219.0804443359375,
        -40.0
      ],
      [
        572.0,
        1039.8734130859375,
        -44.0
      ],
      [
        572.0,
        1057.2794189453125,
        -44.0
      ],
      [
        572.0,
        1057.2794189453125,
        -41.0
      ],
      [
        572.0,
        1057.2794189453125,
        -40.0
      ],
      [
        607.5992431640625,
        1074.587158203125,
        -44.0
      ],
      [
        572.0,
        1057.2794189453125,
        -44.0
      ],
      [
        572.0,
        1057.2794189453125,
        -40.0
      ],
      [
        572.0,
        1039.8734130859375,
        -44.0
      ],
      [
        572.0,
        1037.0919189453125,
        -44.40361785888672
      ],
      [
        607.0271606445312,
        1074.30908203125,
        -49.5
      ],
      [
        607.0271606445312,
        1074.30908203125,
        -55.5
      ],
      [
        607.0271606445312,
        1074.30908203125,
        -49.5
      ],
      [
        572.0,
        1037.0919189453125,
        -44.40361785888672
      ],
      [
        572.0,
        1196.5206298828125,
        -54.11140823364258
      ],
      [
        572.0,
        1179.841796875,
        -55.19633483886719
      ],
      [
        572.0,
        1179.841796875,
        -55.19633483886719
      ],
      [
        610.5435791015625,
        1127.3602294921875,
        -49.5
      ],
      [
        610.5435791015625,
        1127.3602294921875,
        -55.5
      ],
      [
        610.4890747070312,
        1127.472412109375,
        -49.5
      ],
      [
        610.4890747070312,
        1127.472412109375,
        -55.5
      ],
      [
        610.2634887695312,
        1127.0078125,
        -49.5
      ],
      [
        610.2634887695312,
        1127.0078125,
        -55.5
      ],
      [
        610.25,
        1147.1500244140625,
        -55.5
      ],
      [
        610.25,
        1147.6500244140625,
        -55.5
      ],
      [
        612.25,
        1149.1500244140625,
        -55.5
      ],
      [
        612.25,
        1145.6500244140625,
        -55.5
      ],
      [
        612.25,
        1109.1500244140625,
        -55.5
      ],
      [
        612.25,
        1109.6500244140625,
        -55.5
      ],
      [
        614.25,
        1111.1500244140625,
        -55.5
      ],
      [
        614.25,
        1107.6500244140625,
        -55.5
      ],
      [
        601.75,
        1087.1500244140625,
        -55.5
      ],
      [
        601.75,
        1087.6500244140625,
        -55.5
      ],
      [
        603.75,
        1089.1500244140625,
        -55.5
      ],
      [
        603.75,
        1085.6500244140625,
        -55.5
      ],
      [
        619.25,
        1128.6500244140625,
        -55.5
      ],
      [
        619.25,
        1129.1500244140625,
        -55.5
      ],
      [
        621.25,
        1130.6500244140625,
        -55.5
      ],
      [
        621.25,
        1127.1500244140625,
        -55.5
      ],
      [
        571.5,
        925.0,
        -40.1620979309082
      ],
      [
        571.5,
        925.0,
        -60.0
      ],
      [
        571.5,
        925.0,
        -40.1620979309082
      ],
      [
        571.5,
        925.0,
        -40.0
      ],
      [
        571.5,
        1196.763671875,
        -54.02870178222656
      ],
      [
        571.5,
        1180.0848388671875,
        -55.11362838745117
      ],
      [
        571.5,
        1180.0848388671875,
        -60.000038146972656
      ],
      [
        571.5,
        1180.0848388671875,
        -55.11362838745117
      ],
      [
        571.5,
        1039.61865234375,
        -44.0
      ],
      [
        571.5,
        1057.036376953125,
        -44.0
      ],
      [
        571.5,
        1235.0638427734375,
        -43.0
      ],
      [
        571.5,
        1219.1982421875,
        -43.0
      ],
      [
        571.5,
        1057.036376953125,
        -44.0
      ],
      [
        572.0,
        1057.2794189453125,
        -43.0
      ],
      [
        571.5,
        1057.036376953125,
        -43.0
      ],
      [
        571.5,
        1196.763671875,
        -44.0
      ],
      [
        571.5,
        1196.763671875,
        -43.0
      ],
      [
        572.0,
        1196.5206298828125,
        -43.0
      ],
      [
        572.0,
        1196.5206298828125,
        -44.0
      ],
      [
        571.5,
        1057.036376953125,
        -41.0
      ],
      [
        571.5,
        1057.036376953125,
        -40.0
      ],
      [
        571.5,
        1057.036376953125,
        -40.0
      ],
      [
        571.5,
        1196.763671875,
        -40.0
      ],
      [
        571.5,
        1219.1982421875,
        -43.0
      ],
      [
        571.5,
        1219.1982421875,
        -40.0
      ],
      [
        571.5,
        1235.0638427734375,
        -40.0
      ],
      [
        571.5,
        1235.0638427734375,
        -43.0
      ],
      [
        571.5,
        1037.4847412109375,
        -44.30964279174805
      ],
      [
        571.5,
        1037.4847412109375,
        -60.0
      ],
      [
        571.5,
        1196.763671875,
        -54.02870178222656
      ],
      [
        571.5,
        1039.61865234375,
        -44.0
      ],
      [
        571.5,
        1037.4847412109375,
        -44.30964279174805
      ],
      [
        571.5,
        845.0,
        -40.0
      ],
      [
        571.5,
        845.0,
        -60.0
      ],
      [
        571.5,
        845.0,
        -53.0
      ],
      [
        571.5,
        855.0,
        -53.0
      ],
      [
        571.5,
        855.0,
        -53.0
      ],
      [
        571.5,
        855.0,
        -60.0
      ],
      [
        495.0,
        926.0,
        -44.0
      ],
      [
        459.1000061035156,
        926.0,
        -44.0
      ],
      [
        459.1000061035156,
        925.0,
        -50.04999542236328
      ],
      [
        459.1000061035156,
        926.0,
        -44.0
      ],
      [
        459.1000061035156,
        926.0,
        -50.04999542236328
      ],
      [
        495.0,
        925.0,
        -50.04999542236328
      ],
      [
        495.0,
        926.0,
        -50.04999542236328
      ],
      [
        495.0,
        926.0,
        -44.599998474121094
      ],
      [
        495.0,
        926.0,
        -44.0
      ],
      [
        495.0,
        926.0,
        -44.599998474121094
      ],
      [
        495.0,
        926.0,
        -60.0
      ],
      [
        459.1000061035156,
        926.0,
        -60.0
      ],
      [
        496.0,
        955.0,
        -44.0
      ],
      [
        496.0,
        953.0,
        -44.0
      ],
      [
        496.0,
        929.5999755859375,
        -44.0
      ],
      [
        496.0,
        926.0,
        -44.0
      ],
      [
        496.0,
        953.0,
        -44.0
      ],
      [
        496.0,
        929.5999755859375,
        -44.0
      ],
      [
        496.0,
        955.0,
        -44.0
      ],
      [
        496.0,
        1000.0,
        -44.0
      ],
      [
        481.0,
        990.0,
        -44.0
      ],
      [
        465.0,
        990.0,
        -44.0
      ],
      [
        465.0,
        974.5999755859375,
        -44.0
      ],
      [
        481.0,
        974.5999755859375,
        -44.0
      ],
      [
        465.0,
        990.0,
        -44.0
      ],
      [
        465.0,
        974.5999755859375,
        -44.0
      ],
      [
        481.0,
        974.5999755859375,
        -44.0
      ],
      [
        481.0,
        990.0,
        -44.0
      ],
      [
        509.6170349121094,
        1000.0,
        -44.0
      ],
      [
        496.0,
        1000.0,
        -44.0
      ],
      [
        545.8145141601562,
        1000.0,
        -40.0
      ],
      [
        545.8145751953125,
        1000.0,
        -44.0
      ],
      [
        509.6170349121094,
        1000.0,
        -44.0
      ],
      [
        561.5,
        948.5,
        -44.0
      ],
      [
        561.5,
        991.5,
        -44.0
      ],
      [
        562.0,
        949.0,
        -44.0
      ],
      [
        562.0,
        991.0,
        -44.0
      ],
      [
        562.0000610351562,
        948.5,
        -44.0
      ],
      [
        561.5,
        948.5,
        -44.0
      ],
      [
        561.5,
        991.5,
        -44.0
      ],
      [
        562.0000610351562,
        991.5,
        -44.0
      ],
      [
        571.5,
        987.5121459960938,
        -43.0
      ],
      [
        566.3828735351562,
        990.0,
        -43.0
      ],
      [
        567.5,
        950.0,
        -40.0
      ],
      [
        566.3828735351562,
        990.0,
        -43.0
      ],
      [
        566.3828735351562,
        990.0,
        -40.74473571777344
      ],
      [
        571.5,
        948.5,
        -44.0
      ],
      [
        562.0,
        949.0,
        -44.0
      ],
      [
        571.5,
        949.0,
        -44.0
      ],
      [
        566.3828735351562,
        990.0,
        -43.0
      ],
      [
        563.2976684570312,
        991.5,
        -44.0
      ],
      [
        566.3828735351562,
        990.0,
        -43.0
      ],
      [
        564.3260498046875,
        991.0,
        -44.0
      ],
      [
        562.0,
        991.0,
        -44.0
      ],
      [
        566.3828735351562,
        990.0,
        -40.0
      ],
      [
        392.9727783203125,
        1074.30908203125,
        -60.0
      ],
      [
        392.9727783203125,
        1074.30908203125,
        -49.5
      ],
      [
        392.9727783203125,
        1074.30908203125,
        -49.5
      ],
      [
        493.6907043457031,
        1025.3416748046875,
        -60.0
      ],
      [
        496.0,
        1023.0323486328125,
        -60.0
      ],
      [
        496.0,
        1023.0323486328125,
        -47.04999542236328
      ],
      [
        493.6907043457031,
        1025.3416748046875,
        -47.04999542236328
      ],
      [
        493.6907043457031,
        1025.3416748046875,
        -47.04999542236328
      ],
      [
        496.0,
        1023.0323486328125,
        -47.04999542236328
      ],
      [
        496.0,
        1024.218994140625,
        -47.04999542236328
      ],
      [
        481.8999938964844,
        958.5999755859375,
        -56.5
      ],
      [
        481.8999938964844,
        953.8551025390625,
        -56.5
      ],
      [
        481.8999938964844,
        953.8551025390625,
        -56.5
      ],
      [
        481.8999938964844,
        958.5999755859375,
        -56.5
      ],
      [
        481.8999938964844,
        959.2427368164062,
        -56.5
      ],
      [
        481.8999938964844,
        959.2427368164062,
        -56.5
      ],
      [
        481.8999938964844,
        959.2427368164062,
        -60.0
      ],
      [
        492.8999938964844,
        959.9000244140625,
        -56.0
      ],
      [
        492.8999938964844,
        959.699951171875,
        -56.0
      ],
      [
        493.0000305175781,
        959.7999877929688,
        -56.100032806396484
      ],
      [
        492.8999938964844,
        959.699951171875,
        -56.0
      ],
      [
        492.8999938964844,
        959.9000244140625,
        -56.0
      ],
      [
        491.0000305175781,
        960.4000244140625,
        -56.0
      ],
      [
        493.3999938964844,
        960.4000244140625,
        -56.5
      ],
      [
        493.3999938964844,
        960.2000122070312,
        -56.5
      ],
      [
        491.5000305175781,
        960.9000244140625,
        -56.5
      ],
      [
        491.0000305175781,
        960.4000244140625,
        -56.0
      ],
      [
        490.0,
        960.2000122070312,
        -56.5
      ],
      [
        490.5,
        959.699951171875,
        -56.0
      ],
      [
        490.5,
        959.699951171875,
        -56.0
      ],
      [
        490.5,
        959.9000854492188,
        -55.5
      ],
      [
        492.8999938964844,
        959.449951171875,
        -55.75
      ],
      [
        491.0000305175781,
        959.2000122070312,
        -55.5
      ],
      [
        561.0,
        947.0,
        -45.0
      ],
      [
        562.0000610351562,
        948.5,
        -44.0
      ],
      [
        560.2124633789062,
        993.0,
        -45.0
      ],
      [
        561.377685546875,
        992.4334716796875,
        -44.622310638427734
      ],
      [
        562.0000610351562,
        991.5,
        -44.0
      ],
      [
        561.0,
        947.0,
        -45.0
      ],
      [
        560.2124633789062,
        993.0,
        -45.0
      ],
      [
        560.2124633789062,
        993.0,
        -45.78753662109375
      ],
      [
        566.3828735351562,
        990.0,
        -57.5
      ],
      [
        571.5,
        987.5121459960938,
        -57.5
      ],
      [
        566.3828735351562,
        990.0,
        -57.5
      ],
      [
        566.3828735351562,
        990.0,
        -60.0
      ],
      [
        563.0,
        926.4000244140625,
        -57.5
      ],
      [
        571.0999755859375,
        926.4000854492188,
        -57.5
      ],
      [
        567.0799560546875,
        934.5999755859375,
        -57.5
      ],
      [
        563.0,
        930.5201416015625,
        -57.5
      ],
      [
        566.5,
        936.0,
        -57.5
      ],
      [
        566.5,
        942.0,
        -57.5
      ],
      [
        571.5,
        942.0,
        -57.5
      ],
      [
        566.5,
        942.0,
        -57.5
      ],
      [
        563.0,
        932.5,
        -60.0
      ],
      [
        566.5,
        936.0,
        -57.5
      ],
      [
        563.0,
        932.5,
        -57.5
      ],
      [
        571.0999755859375,
        926.4000854492188,
        -57.5
      ],
      [
        571.0999755859375,
        934.5999755859375,
        -57.5
      ],
      [
        571.0999755859375,
        934.5999755859375,
        -57.5
      ],
      [
        567.0799560546875,
        934.5999755859375,
        -57.5
      ],
      [
        563.0,
        947.0,
        -45.0
      ],
      [
        563.0,
        947.0,
        -46.0
      ],
      [
        563.0,
        947.0,
        -46.0
      ],
      [
        563.0,
        949.0,
        -44.0
      ],
      [
        563.0,
        947.0,
        -45.0
      ],
      [
        563.0,
        948.5,
        -44.0
      ],
      [
        569.4681396484375,
        988.5,
        -56.599998474121094
      ],
      [
        570.5,
        987.9983520507812,
        -56.599998474121094
      ],
      [
        569.4681396484375,
        988.5,
        -56.599998474121094
      ],
      [
        569.4681396484375,
        988.5,
        -57.5
      ],
      [
        563.0,
        991.6447143554688,
        -44.644718170166016
      ],
      [
        563.0,
        991.0,
        -44.0
      ],
      [
        563.0,
        991.6447143554688,
        -44.09648132324219
      ],
      [
        563.0,
        991.5,
        -44.0
      ],
      [
        563.0,
        926.0,
        -55.900001525878906
      ],
      [
        563.0,
        932.5,
        -55.900001525878906
      ],
      [
        563.0,
        931.0859375,
        -55.900001525878906
      ],
      [
        563.0,
        931.0859375,
        -55.900001525878906
      ],
      [
        563.0,
        932.5,
        -55.900001525878906
      ],
      [
        560.0,
        926.0,
        -55.900001525878906
      ],
      [
        560.0,
        931.0,
        -55.900001525878906
      ],
      [
        560.0,
        931.0,
        -55.900001525878906
      ],
      [
        560.0,
        931.0,
        -60.0
      ],
      [
        560.2124633789062,
        993.0,
        -46.0
      ],
      [
        560.2124633789062,
        993.0,
        -46.0
      ],
      [
        545.8145141601562,
        1000.0,
        -58.091552734375
      ],
      [
        545.8145141601562,
        1000.0,
        -50.51700973510742
      ],
      [
        545.8145751953125,
        1000.0,
        -60.0
      ],
      [
        545.8145141601562,
        1000.0,
        -58.091552734375
      ],
      [
        545.8145141601562,
        1000.0,
        -50.51700973510742
      ],
      [
        545.8145751953125,
        1000.0,
        -44.961151123046875
      ],
      [
        545.8145751953125,
        1000.0,
        -44.961151123046875
      ],
      [
        507.30755615234375,
        1018.721435546875,
        -60.0
      ],
      [
        507.30755615234375,
        1018.721435546875,
        -47.04999542236328
      ],
      [
        535.0,
        1005.2578125,
        -47.04999542236328
      ],
      [
        529.3597412109375,
        1008.0,
        -47.04999542236328
      ],
      [
        518.2674560546875,
        1013.392822265625,
        -47.04999542236328
      ],
      [
        518.8500366210938,
        1013.1095581054688,
        -47.04999542236328
      ],
      [
        518.8500366210938,
        1013.1095581054688,
        -47.04999542236328
      ],
      [
        529.3597412109375,
        1008.0,
        -47.04999542236328
      ],
      [
        518.2674560546875,
        1013.392822265625,
        -60.0
      ],
      [
        518.2674560546875,
        1013.392822265625,
        -47.04999542236328
      ],
      [
        535.0,
        1005.2578125,
        -60.0
      ],
      [
        535.0,
        1005.2578125,
        -47.04999542236328
      ],
      [
        526.6465454101562,
        1009.3190307617188,
        -47.5
      ],
      [
        527.7963256835938,
        1008.760009765625,
        -47.5
      ],
      [
        527.7963256835938,
        1008.760009765625,
        -47.5
      ],
      [
        528.3712158203125,
        1008.4805297851562,
        -47.04999923706055
      ],
      [
        526.0716552734375,
        1009.5985717773438,
        -47.04999923706055
      ],
      [
        526.6465454101562,
        1009.3190307617188,
        -47.5
      ],
      [
        498.6903076171875,
        1022.9110107421875,
        -47.04999542236328
      ],
      [
        507.30755615234375,
        1018.721435546875,
        -47.04999542236328
      ],
      [
        498.6903076171875,
        1022.9110107421875,
        -47.04999542236328
      ],
      [
        546.5,
        940.0,
        -50.04999542236328
      ],
      [
        546.5,
        940.0,
        -60.0
      ],
      [
        539.25,
        974.5,
        -53.0
      ],
      [
        539.25,
        974.5,
        -52.5
      ],
      [
        539.25,
        985.0,
        -53.0
      ],
      [
        539.25,
        985.0,
        -52.5
      ],
      [
        509.0,
        955.0,
        -60.0
      ],
      [
        509.0,
        955.0,
        -44.0
      ],
      [
        509.0,
        955.0,
        -44.0
      ],
      [
        509.0,
        955.0,
        -60.0
      ],
      [
        509.0,
        986.0,
        -60.0
      ],
      [
        509.0,
        986.0,
        -44.0
      ],
      [
        509.0,
        986.0,
        -44.0
      ],
      [
        509.0,
        986.0,
        -60.0
      ],
      [
        459.1000061035156,
        906.0,
        -60.0
      ],
      [
        459.1000061035156,
        906.0,
        -49.999996185302734
      ],
      [
        459.1000061035156,
        925.0,
        -49.999996185302734
      ],
      [
        540.0,
        906.0,
        -56.5
      ],
      [
        538.0,
        906.0,
        -56.5
      ],
      [
        519.0,
        906.0,
        -56.5
      ],
      [
        517.0,
        906.0,
        -56.5
      ],
      [
        560.5,
        906.0,
        -56.5
      ],
      [
        558.5,
        906.0,
        -56.5
      ],
      [
        536.0,
        906.0,
        -56.5
      ],
      [
        535.0,
        906.0,
        -56.5
      ],
      [
        535.0,
        908.0,
        -56.5
      ],
      [
        542.0,
        906.0,
        -56.5
      ],
      [
        543.0,
        908.0,
        -56.5
      ],
      [
        543.0,
        906.0,
        -56.5
      ],
      [
        515.0,
        906.0,
        -56.5
      ],
      [
        514.0,
        906.0,
        -56.5
      ],
      [
        514.0,
        908.0,
        -56.5
      ],
      [
        521.0,
        906.0,
        -56.5
      ],
      [
        522.0,
        908.0,
        -56.5
      ],
      [
        522.0,
        906.0,
        -56.5
      ],
      [
        556.5,
        906.0,
        -56.5
      ],
      [
        555.5,
        906.0,
        -56.5
      ],
      [
        555.5,
        908.0,
        -56.5
      ],
      [
        562.5,
        906.0,
        -56.5
      ],
      [
        563.5,
        908.0,
        -56.5
      ],
      [
        563.5,
        906.0,
        -56.5
      ],
      [
        535.0,
        906.0,
        -60.0
      ],
      [
        535.0,
        908.0,
        -60.0
      ],
      [
        535.0,
        908.0,
        -56.5
      ],
      [
        535.0,
        906.0,
        -56.5
      ],
      [
        555.5,
        906.0,
        -60.0
      ],
      [
        555.5,
        908.0,
        -60.0
      ],
      [
        555.5,
        908.0,
        -56.5
      ],
      [
        555.5,
        906.0,
        -56.5
      ],
      [
        563.5,
        906.0,
        -56.5
      ],
      [
        563.5,
        908.0,
        -56.5
      ],
      [
        563.5,
        908.0,
        -60.0
      ],
      [
        563.5,
        906.0,
        -60.0
      ],
      [
        558.5,
        906.0,
        -56.5
      ],
      [
        558.5,
        906.0,
        -57.0
      ],
      [
        562.5,
        906.0,
        -57.29999923706055
      ],
      [
        560.5,
        906.0,
        -57.0
      ],
      [
        562.5,
        906.0,
        -56.5
      ],
      [
        562.5,
        906.0,
        -57.29999923706055
      ],
      [
        560.5,
        906.0,
        -56.5
      ],
      [
        560.5,
        906.0,
        -57.0
      ],
      [
        558.5,
        906.0,
        -57.0
      ],
      [
        556.5,
        906.0,
        -57.29999923706055
      ],
      [
        556.5,
        906.0,
        -56.5
      ],
      [
        556.5,
        906.0,
        -57.29999923706055
      ],
      [
        543.0,
        906.0,
        -56.5
      ],
      [
        543.0,
        908.0,
        -56.5
      ],
      [
        543.0,
        908.0,
        -60.0
      ],
      [
        543.0,
        906.0,
        -60.0
      ],
      [
        538.0,
        906.0,
        -56.5
      ],
      [
        538.0,
        906.0,
        -57.0
      ],
      [
        542.0,
        906.0,
        -57.29999923706055
      ],
      [
        540.0,
        906.0,
        -57.0
      ],
      [
        542.0,
        906.0,
        -56.5
      ],
      [
        542.0,
        906.0,
        -57.29999923706055
      ],
      [
        540.0,
        906.0,
        -56.5
      ],
      [
        540.0,
        906.0,
        -57.0
      ],
      [
        538.0,
        906.0,
        -57.0
      ],
      [
        536.0,
        906.0,
        -57.29999923706055
      ],
      [
        536.0,
        906.0,
        -56.5
      ],
      [
        536.0,
        906.0,
        -57.29999923706055
      ],
      [
        514.0,
        906.0,
        -60.0
      ],
      [
        514.0,
        908.0,
        -60.0
      ],
      [
        514.0,
        908.0,
        -56.5
      ],
      [
        514.0,
        906.0,
        -56.5
      ],
      [
        522.0,
        906.0,
        -56.5
      ],
      [
        522.0,
        908.0,
        -56.5
      ],
      [
        522.0,
        908.0,
        -60.0
      ],
      [
        522.0,
        906.0,
        -60.0
      ],
      [
        517.0,
        906.0,
        -56.5
      ],
      [
        517.0,
        906.0,
        -57.0
      ],
      [
        521.0,
        906.0,
        -57.29999923706055
      ],
      [
        519.0,
        906.0,
        -57.0
      ],
      [
        521.0,
        906.0,
        -56.5
      ],
      [
        521.0,
        906.0,
        -57.29999923706055
      ],
      [
        519.0,
        906.0,
        -56.5
      ],
      [
        519.0,
        906.0,
        -57.0
      ],
      [
        517.0,
        906.0,
        -57.0
      ],
      [
        515.0,
        906.0,
        -57.29999923706055
      ],
      [
        515.0,
        906.0,
        -56.5
      ],
      [
        515.0,
        906.0,
        -57.29999923706055
      ],
      [
        538.0,
        906.0,
        -52.20000076293945
      ],
      [
        540.0,
        906.0,
        -52.20000076293945
      ],
      [
        517.0,
        906.0,
        -52.20000076293945
      ],
      [
        519.0,
        906.0,
        -52.20000076293945
      ],
      [
        558.5,
        906.0,
        -52.20000076293945
      ],
      [
        560.5,
        906.0,
        -52.20000076293945
      ],
      [
        538.0,
        906.0,
        -51.20000076293945
      ],
      [
        540.0,
        906.0,
        -51.20000076293945
      ],
      [
        517.0,
        906.0,
        -51.20000076293945
      ],
      [
        519.0,
        906.0,
        -51.20000076293945
      ],
      [
        558.5,
        906.0,
        -51.20000076293945
      ],
      [
        560.5,
        906.0,
        -51.20000076293945
      ],
      [
        538.0,
        906.0,
        -52.20000076293945
      ],
      [
        538.0,
        906.0,
        -51.20000076293945
      ],
      [
        558.5,
        906.0,
        -52.20000076293945
      ],
      [
        558.5,
        906.0,
        -51.20000076293945
      ],
      [
        560.5,
        906.0,
        -51.20000076293945
      ],
      [
        560.5,
        906.0,
        -52.20000076293945
      ],
      [
        540.0,
        906.0,
        -51.20000076293945
      ],
      [
        540.0,
        906.0,
        -52.20000076293945
      ],
      [
        517.0,
        906.0,
        -52.20000076293945
      ],
      [
        517.0,
        906.0,
        -51.20000076293945
      ],
      [
        519.0,
        906.0,
        -51.20000076293945
      ],
      [
        519.0,
        906.0,
        -52.20000076293945
      ],
      [
        538.0,
        906.0,
        -52.20000076293945
      ],
      [
        535.0,
        906.0,
        -54.0
      ],
      [
        535.0,
        908.0,
        -54.0
      ],
      [
        535.0,
        908.0,
        -54.0
      ],
      [
        535.0,
        906.0,
        -54.0
      ],
      [
        538.0,
        906.0,
        -52.20000076293945
      ],
      [
        558.5,
        906.0,
        -52.20000076293945
      ],
      [
        555.5,
        906.0,
        -54.0
      ],
      [
        555.5,
        908.0,
        -54.0
      ],
      [
        555.5,
        908.0,
        -54.0
      ],
      [
        555.5,
        906.0,
        -54.0
      ],
      [
        558.5,
        906.0,
        -52.20000076293945
      ],
      [
        563.5,
        906.0,
        -54.0
      ],
      [
        563.5,
        908.0,
        -54.0
      ],
      [
        560.5,
        906.0,
        -52.20000076293945
      ],
      [
        560.5,
        906.0,
        -52.20000076293945
      ],
      [
        563.5,
        908.0,
        -54.0
      ],
      [
        563.5,
        906.0,
        -54.0
      ],
      [
        543.0,
        906.0,
        -54.0
      ],
      [
        543.0,
        908.0,
        -54.0
      ],
      [
        540.0,
        906.0,
        -52.20000076293945
      ],
      [
        540.0,
        906.0,
        -52.20000076293945
      ],
      [
        543.0,
        908.0,
        -54.0
      ],
      [
        543.0,
        906.0,
        -54.0
      ],
      [
        517.0,
        906.0,
        -52.20000076293945
      ],
      [
        514.0,
        906.0,
        -54.0
      ],
      [
        514.0,
        908.0,
        -54.0
      ],
      [
        514.0,
        908.0,
        -54.0
      ],
      [
        514.0,
        906.0,
        -54.0
      ],
      [
        517.0,
        906.0,
        -52.20000076293945
      ],
      [
        522.0,
        906.0,
        -54.0
      ],
      [
        522.0,
        908.0,
        -54.0
      ],
      [
        519.0,
        906.0,
        -52.20000076293945
      ],
      [
        519.0,
        906.0,
        -52.20000076293945
      ],
      [
        522.0,
        908.0,
        -54.0
      ],
      [
        522.0,
        906.0,
        -54.0
      ],
      [
        459.1000061035156,
        906.0,
        -40.0
      ],
      [
        455.1000061035156,
        869.1000366210938,
        -56.0
      ],
      [
        455.1000061035156,
        869.1000366210938,
        -55.5
      ],
      [
        455.1000061035156,
        876.0,
        -55.5
      ],
      [
        455.1000061035156,
        876.0,
        -56.0
      ],
      [
        486.53564453125,
        874.5355224609375,
        -55.5
      ],
      [
        488.0,
        871.0,
        -55.5
      ],
      [
        455.1000061035156,
        869.1000366210938,
        -55.5
      ],
      [
        455.1000061035156,
        869.1000366210938,
        -56.0
      ],
      [
        458.1000061035156,
        866.1000366210938,
        -56.0
      ],
      [
        458.1000061035156,
        866.1000366210938,
        -55.5
      ],
      [
        483.0,
        866.0,
        -55.5
      ],
      [
        479.46435546875,
        867.4644775390625,
        -55.5
      ],
      [
        483.0,
        876.0,
        -55.5
      ],
      [
        486.53564453125,
        874.5355224609375,
        -55.5
      ],
      [
        479.46435546875,
        874.5355224609375,
        -55.5
      ],
      [
        483.0,
        876.0,
        -55.5
      ],
      [
        486.53564453125,
        867.4644775390625,
        -55.5
      ],
      [
        483.0,
        866.0,
        -55.5
      ],
      [
        478.0,
        871.0,
        -55.5
      ],
      [
        479.46435546875,
        874.5355224609375,
        -55.5
      ],
      [
        479.46435546875,
        867.4644775390625,
        -55.5
      ],
      [
        478.0,
        871.0,
        -55.5
      ],
      [
        488.0,
        871.0,
        -55.5
      ],
      [
        486.53564453125,
        867.4644775390625,
        -55.5
      ],
      [
        482.75,
        871.25,
        -56.0
      ],
      [
        482.75,
        870.75,
        -56.0
      ],
      [
        482.75,
        871.25,
        -56.0
      ],
      [
        483.25,
        871.25,
        -56.0
      ],
      [
        483.25,
        870.75,
        -56.0
      ],
      [
        483.25,
        871.25,
        -56.0
      ],
      [
        482.75,
        870.75,
        -56.0
      ],
      [
        483.25,
        870.75,
        -56.0
      ],
      [
        462.6000061035156,
        866.0999755859375,
        -56.0
      ],
      [
        462.6000061035156,
        866.0999755859375,
        -55.5
      ],
      [
        458.1000061035156,
        866.1000366210938,
        -55.5
      ],
      [
        458.1000061035156,
        866.1000366210938,
        -56.0
      ],
      [
        462.6000061035156,
        866.0999755859375,
        -55.5
      ],
      [
        462.6000061035156,
        866.0999755859375,
        -56.0
      ],
      [
        462.6000061035156,
        866.0,
        -56.0
      ],
      [
        462.6000061035156,
        866.0,
        -55.5
      ],
      [
        503.0,
        876.0,
        -55.5
      ],
      [
        506.53564453125,
        874.5355224609375,
        -55.5
      ],
      [
        499.46435546875,
        874.5355224609375,
        -55.5
      ],
      [
        503.0,
        876.0,
        -55.5
      ],
      [
        503.0,
        866.0,
        -55.5
      ],
      [
        499.46435546875,
        867.4644775390625,
        -55.5
      ],
      [
        506.53564453125,
        867.4644775390625,
        -55.5
      ],
      [
        503.0,
        866.0,
        -55.5
      ],
      [
        506.53564453125,
        874.5355224609375,
        -55.5
      ],
      [
        508.0,
        871.0,
        -55.5
      ],
      [
        498.0,
        871.0,
        -55.5
      ],
      [
        499.46435546875,
        874.5355224609375,
        -55.5
      ],
      [
        499.46435546875,
        867.4644775390625,
        -55.5
      ],
      [
        498.0,
        871.0,
        -55.5
      ],
      [
        508.0,
        871.0,
        -55.5
      ],
      [
        506.53564453125,
        867.4644775390625,
        -55.5
      ],
      [
        502.75,
        871.25,
        -56.0
      ],
      [
        502.75,
        870.75,
        -56.0
      ],
      [
        502.75,
        871.25,
        -56.0
      ],
      [
        503.25,
        871.25,
        -56.0
      ],
      [
        503.25,
        870.75,
        -56.0
      ],
      [
        503.25,
        871.25,
        -56.0
      ],
      [
        502.75,
        870.75,
        -56.0
      ],
      [
        503.25,
        870.75,
        -56.0
      ],
      [
        551.5999755859375,
        845.0,
        -55.5
      ],
      [
        551.5999755859375,
        845.0,
        -56.0
      ],
      [
        555.0103759765625,
        845.0,
        -56.0
      ],
      [
        555.0103759765625,
        845.0,
        -55.5
      ],
      [
        476.6000061035156,
        845.0,
        -55.5
      ],
      [
        476.6000061035156,
        845.0,
        -56.0
      ],
      [
        481.6000061035156,
        845.0,
        -56.0
      ],
      [
        481.6000061035156,
        845.0,
        -55.5
      ],
      [
        551.5999755859375,
        845.0,
        -55.5
      ],
      [
        551.5999755859375,
        845.0,
        -56.0
      ],
      [
        571.5,
        845.0,
        -56.0
      ],
      [
        571.5,
        845.0,
        -55.5
      ],
      [
        459.1000061035156,
        845.0,
        -55.5
      ],
      [
        459.1000061035156,
        845.0,
        -56.0
      ],
      [
        481.6000061035156,
        845.0,
        -56.0
      ],
      [
        481.6000061035156,
        845.0,
        -55.5
      ],
      [
        507.6000061035156,
        841.0,
        -56.0
      ],
      [
        507.6000061035156,
        841.0,
        -55.5
      ],
      [
        490.6000061035156,
        841.0,
        -55.5
      ],
      [
        490.6000061035156,
        841.0,
        -56.0
      ],
      [
        542.5999755859375,
        841.0,
        -56.0
      ],
      [
        542.5999755859375,
        841.0,
        -55.5
      ],
      [
        525.5999755859375,
        841.0,
        -55.5
      ],
      [
        525.5999755859375,
        841.0,
        -56.0
      ],
      [
        507.6000061035156,
        841.0,
        -55.5
      ],
      [
        507.6000061035156,
        841.0,
        -56.0
      ],
      [
        510.6000061035156,
        844.0,
        -56.0
      ],
      [
        510.6000061035156,
        844.0,
        -55.5
      ],
      [
        522.5999755859375,
        844.0,
        -55.5
      ],
      [
        522.5999755859375,
        844.0,
        -56.0
      ],
      [
        525.5999755859375,
        841.0,
        -56.0
      ],
      [
        525.5999755859375,
        841.0,
        -55.5
      ],
      [
        542.5999755859375,
        841.0,
        -55.5
      ],
      [
        542.5999755859375,
        841.0,
        -56.0
      ],
      [
        545.5999755859375,
        844.0,
        -56.0
      ],
      [
        545.5999755859375,
        844.0,
        -55.5
      ],
      [
        545.5999755859375,
        845.0,
        -55.5
      ],
      [
        545.5999755859375,
        844.0,
        -55.5
      ],
      [
        545.5999755859375,
        844.0,
        -56.0
      ],
      [
        545.5999755859375,
        845.0,
        -56.0
      ],
      [
        522.5999755859375,
        844.0,
        -56.0
      ],
      [
        522.5999755859375,
        844.0,
        -55.5
      ],
      [
        522.5999755859375,
        845.0,
        -55.5
      ],
      [
        522.5999755859375,
        845.0,
        -56.0
      ],
      [
        487.6000061035156,
        844.0,
        -55.5
      ],
      [
        487.6000061035156,
        844.0,
        -56.0
      ],
      [
        490.6000061035156,
        841.0,
        -56.0
      ],
      [
        490.6000061035156,
        841.0,
        -55.5
      ],
      [
        510.6000061035156,
        845.0,
        -55.5
      ],
      [
        510.6000061035156,
        844.0,
        -55.5
      ],
      [
        510.6000061035156,
        844.0,
        -56.0
      ],
      [
        510.6000061035156,
        845.0,
        -56.0
      ],
      [
        487.6000061035156,
        844.0,
        -56.0
      ],
      [
        487.6000061035156,
        844.0,
        -55.5
      ],
      [
        487.6000061035156,
        845.0,
        -55.5
      ],
      [
        487.6000061035156,
        845.0,
        -56.0
      ],
      [
        459.1000061035156,
        860.0999755859375,
        -55.5
      ],
      [
        459.1000061035156,
        860.0999755859375,
        -56.0
      ],
      [
        459.1000061035156,
        855.0999755859375,
        -56.0
      ],
      [
        459.1000061035156,
        855.0999755859375,
        -55.5
      ],
      [
        459.1000061035156,
        860.0999755859375,
        -55.5
      ],
      [
        459.1000061035156,
        860.0999755859375,
        -56.0
      ],
      [
        459.1000061035156,
        845.0,
        -56.0
      ],
      [
        459.1000061035156,
        845.0,
        -55.5
      ],
      [
        567.0,
        855.0,
        -56.0
      ],
      [
        567.0,
        855.0,
        -55.5
      ],
      [
        567.0,
        845.0,
        -55.5
      ],
      [
        567.0,
        845.0,
        -56.0
      ],
      [
        567.0,
        855.0,
        -55.5
      ],
      [
        567.0,
        855.0,
        -56.0
      ],
      [
        571.5,
        855.0,
        -56.0
      ],
      [
        571.5,
        855.0,
        -55.5
      ],
      [
        510.6000061035156,
        850.0,
        -55.5
      ],
      [
        510.6000061035156,
        850.0,
        -56.0
      ],
      [
        516.5999755859375,
        850.0,
        -56.0
      ],
      [
        516.5999755859375,
        850.0,
        -55.5
      ],
      [
        481.6000061035156,
        850.0,
        -55.5
      ],
      [
        481.6000061035156,
        850.0,
        -56.0
      ],
      [
        487.6000061035156,
        850.0,
        -56.0
      ],
      [
        487.6000061035156,
        850.0,
        -55.5
      ],
      [
        516.5999755859375,
        850.0,
        -55.5
      ],
      [
        516.5999755859375,
        850.0,
        -56.0
      ],
      [
        522.5999755859375,
        850.0,
        -56.0
      ],
      [
        522.5999755859375,
        850.0,
        -55.5
      ],
      [
        545.5999755859375,
        850.0,
        -55.5
      ],
      [
        545.5999755859375,
        850.0,
        -56.0
      ],
      [
        551.5999755859375,
        850.0,
        -56.0
      ],
      [
        551.5999755859375,
        850.0,
        -55.5
      ],
      [
        510.6000061035156,
        850.0,
        -56.0
      ],
      [
        510.6000061035156,
        850.0,
        -55.5
      ],
      [
        545.5999755859375,
        850.0,
        -56.0
      ],
      [
        545.5999755859375,
        850.0,
        -55.5
      ],
      [
        551.5999755859375,
        850.0,
        -55.5
      ],
      [
        551.5999755859375,
        850.0,
        -56.0
      ],
      [
        551.5999755859375,
        845.0,
        -56.0
      ],
      [
        551.5999755859375,
        845.0,
        -55.5
      ],
      [
        522.5999755859375,
        850.0,
        -55.5
      ],
      [
        522.5999755859375,
        850.0,
        -56.0
      ],
      [
        481.6000061035156,
        845.0,
        -55.5
      ],
      [
        481.6000061035156,
        845.0,
        -56.0
      ],
      [
        481.6000061035156,
        850.0,
        -56.0
      ],
      [
        481.6000061035156,
        850.0,
        -55.5
      ],
      [
        487.6000061035156,
        850.0,
        -55.5
      ],
      [
        487.6000061035156,
        850.0,
        -56.0
      ],
      [
        462.6000061035156,
        860.0999755859375,
        -56.0
      ],
      [
        462.6000061035156,
        860.0999755859375,
        -55.5
      ],
      [
        462.6000061035156,
        860.0999755859375,
        -55.5
      ],
      [
        462.6000061035156,
        860.0999755859375,
        -56.0
      ],
      [
        459.1000061035156,
        860.0999755859375,
        -56.0
      ],
      [
        459.1000061035156,
        860.0999755859375,
        -55.5
      ],
      [
        455.1000061035156,
        886.1000366210938,
        -55.5
      ],
      [
        455.1000061035156,
        886.1000366210938,
        -56.0
      ],
      [
        459.1000061035156,
        895.0999755859375,
        -56.0
      ],
      [
        459.1000061035156,
        895.0999755859375,
        -55.5
      ],
      [
        459.1000061035156,
        906.0,
        -55.5
      ],
      [
        459.1000061035156,
        906.0,
        -56.0
      ],
      [
        458.1000061035156,
        889.1000366210938,
        -55.5
      ],
      [
        458.1000061035156,
        889.1000366210938,
        -56.0
      ],
      [
        455.1000061035156,
        886.1000366210938,
        -56.0
      ],
      [
        455.1000061035156,
        886.1000366210938,
        -55.5
      ],
      [
        458.1000061035156,
        889.1000366210938,
        -56.0
      ],
      [
        458.1000061035156,
        889.1000366210938,
        -55.5
      ],
      [
        459.1000061035156,
        889.1000366210938,
        -55.5
      ],
      [
        459.1000061035156,
        889.1000366210938,
        -56.0
      ],
      [
        462.6000061035156,
        895.0999755859375,
        -55.5
      ],
      [
        462.6000061035156,
        895.0999755859375,
        -56.0
      ],
      [
        462.6000061035156,
        889.0999755859375,
        -56.0
      ],
      [
        462.6000061035156,
        889.0999755859375,
        -55.5
      ],
      [
        459.1000061035156,
        895.0999755859375,
        -55.5
      ],
      [
        459.1000061035156,
        895.0999755859375,
        -56.0
      ],
      [
        462.6000061035156,
        895.0999755859375,
        -56.0
      ],
      [
        462.6000061035156,
        895.0999755859375,
        -55.5
      ],
      [
        462.6000061035156,
        889.0999755859375,
        -55.5
      ],
      [
        462.6000061035156,
        889.0999755859375,
        -56.0
      ],
      [
        486.53564453125,
        888.4644775390625,
        -55.5
      ],
      [
        483.0,
        887.0,
        -55.5
      ],
      [
        483.0,
        897.0,
        -55.5
      ],
      [
        486.53564453125,
        895.5355224609375,
        -55.5
      ],
      [
        479.46435546875,
        895.5355224609375,
        -55.5
      ],
      [
        483.0,
        897.0,
        -55.5
      ],
      [
        483.0,
        887.0,
        -55.5
      ],
      [
        479.46435546875,
        888.4644775390625,
        -55.5
      ],
      [
        486.53564453125,
        895.5355224609375,
        -55.5
      ],
      [
        488.0,
        892.0,
        -55.5
      ],
      [
        478.0,
        892.0,
        -55.5
      ],
      [
        479.46435546875,
        895.5355224609375,
        -55.5
      ],
      [
        479.46435546875,
        888.4644775390625,
        -55.5
      ],
      [
        478.0,
        892.0,
        -55.5
      ],
      [
        488.0,
        892.0,
        -55.5
      ],
      [
        486.53564453125,
        888.4644775390625,
        -55.5
      ],
      [
        482.75,
        892.25,
        -56.0
      ],
      [
        482.75,
        891.75,
        -56.0
      ],
      [
        482.75,
        892.25,
        -56.0
      ],
      [
        483.25,
        892.25,
        -56.0
      ],
      [
        483.25,
        891.75,
        -56.0
      ],
      [
        483.25,
        892.25,
        -56.0
      ],
      [
        482.75,
        891.75,
        -56.0
      ],
      [
        483.25,
        891.75,
        -56.0
      ],
      [
        517.75,
        906.0,
        -56.0
      ],
      [
        517.75,
        906.0,
        -55.5
      ],
      [
        517.75,
        905.5,
        -55.5
      ],
      [
        517.75,
        905.5,
        -56.0
      ],
      [
        517.75,
        905.5,
        -56.0
      ],
      [
        517.75,
        905.5,
        -55.5
      ],
      [
        518.25,
        905.5,
        -55.5
      ],
      [
        518.25,
        905.5,
        -56.0
      ],
      [
        518.25,
        905.5,
        -56.0
      ],
      [
        518.25,
        905.5,
        -55.5
      ],
      [
        518.25,
        906.0,
        -55.5
      ],
      [
        518.25,
        906.0,
        -56.0
      ],
      [
        559.75,
        899.75,
        -55.5
      ],
      [
        559.75,
        899.75,
        -56.0
      ],
      [
        559.25,
        899.75,
        -56.0
      ],
      [
        559.25,
        899.75,
        -55.5
      ],
      [
        539.25,
        899.75,
        -55.5
      ],
      [
        539.25,
        899.75,
        -56.0
      ],
      [
        538.75,
        899.75,
        -56.0
      ],
      [
        538.75,
        899.75,
        -55.5
      ],
      [
        518.25,
        899.75,
        -55.5
      ],
      [
        518.25,
        899.75,
        -56.0
      ],
      [
        517.75,
        899.75,
        -56.0
      ],
      [
        517.75,
        899.75,
        -55.5
      ],
      [
        539.25,
        900.25,
        -56.0
      ],
      [
        539.25,
        900.25,
        -55.5
      ],
      [
        538.75,
        900.25,
        -55.5
      ],
      [
        538.75,
        900.25,
        -56.0
      ],
      [
        518.25,
        900.25,
        -56.0
      ],
      [
        518.25,
        900.25,
        -55.5
      ],
      [
        517.75,
        900.25,
        -55.5
      ],
      [
        517.75,
        900.25,
        -56.0
      ],
      [
        559.75,
        900.25,
        -56.0
      ],
      [
        559.75,
        900.25,
        -55.5
      ],
      [
        559.25,
        900.25,
        -55.5
      ],
      [
        559.25,
        900.25,
        -56.0
      ],
      [
        538.75,
        900.25,
        -56.0
      ],
      [
        538.75,
        900.25,
        -55.5
      ],
      [
        538.75,
        899.75,
        -55.5
      ],
      [
        538.75,
        899.75,
        -56.0
      ],
      [
        559.25,
        900.25,
        -56.0
      ],
      [
        559.25,
        900.25,
        -55.5
      ],
      [
        559.25,
        899.75,
        -55.5
      ],
      [
        559.25,
        899.75,
        -56.0
      ],
      [
        559.75,
        899.75,
        -56.0
      ],
      [
        559.75,
        899.75,
        -55.5
      ],
      [
        559.75,
        900.25,
        -55.5
      ],
      [
        559.75,
        900.25,
        -56.0
      ],
      [
        539.25,
        899.75,
        -56.0
      ],
      [
        539.25,
        899.75,
        -55.5
      ],
      [
        539.25,
        900.25,
        -55.5
      ],
      [
        539.25,
        900.25,
        -56.0
      ],
      [
        517.75,
        900.25,
        -56.0
      ],
      [
        517.75,
        900.25,
        -55.5
      ],
      [
        517.75,
        899.75,
        -55.5
      ],
      [
        517.75,
        899.75,
        -56.0
      ],
      [
        518.25,
        899.75,
        -56.0
      ],
      [
        518.25,
        899.75,
        -55.5
      ],
      [
        518.25,
        900.25,
        -55.5
      ],
      [
        518.25,
        900.25,
        -56.0
      ],
      [
        559.25,
        906.0,
        -56.0
      ],
      [
        559.25,
        906.0,
        -55.5
      ],
      [
        559.25,
        905.5,
        -55.5
      ],
      [
        559.25,
        905.5,
        -56.0
      ],
      [
        559.25,
        905.5,
        -56.0
      ],
      [
        559.25,
        905.5,
        -55.5
      ],
      [
        559.75,
        905.5,
        -55.5
      ],
      [
        559.75,
        905.5,
        -56.0
      ],
      [
        559.75,
        905.5,
        -56.0
      ],
      [
        559.75,
        905.5,
        -55.5
      ],
      [
        559.75,
        906.0,
        -55.5
      ],
      [
        559.75,
        906.0,
        -56.0
      ],
      [
        538.75,
        906.0,
        -56.0
      ],
      [
        538.75,
        906.0,
        -55.5
      ],
      [
        538.75,
        905.5,
        -55.5
      ],
      [
        538.75,
        905.5,
        -56.0
      ],
      [
        538.75,
        905.5,
        -56.0
      ],
      [
        538.75,
        905.5,
        -55.5
      ],
      [
        539.25,
        905.5,
        -55.5
      ],
      [
        539.25,
        905.5,
        -56.0
      ],
      [
        539.25,
        905.5,
        -56.0
      ],
      [
        539.25,
        905.5,
        -55.5
      ],
      [
        539.25,
        906.0,
        -55.5
      ],
      [
        539.25,
        906.0,
        -56.0
      ],
      [
        538.75,
        894.5,
        -56.0
      ],
      [
        538.75,
        894.5,
        -55.5
      ],
      [
        538.75,
        894.0,
        -55.5
      ],
      [
        538.75,
        894.0,
        -56.0
      ],
      [
        559.25,
        894.5,
        -56.0
      ],
      [
        559.25,
        894.5,
        -55.5
      ],
      [
        559.25,
        894.0,
        -55.5
      ],
      [
        559.25,
        894.0,
        -56.0
      ],
      [
        559.75,
        894.5,
        -56.0
      ],
      [
        559.75,
        894.5,
        -55.5
      ],
      [
        559.25,
        894.5,
        -55.5
      ],
      [
        559.25,
        894.5,
        -56.0
      ],
      [
        559.75,
        894.0,
        -56.0
      ],
      [
        559.75,
        894.0,
        -55.5
      ],
      [
        559.75,
        894.5,
        -55.5
      ],
      [
        559.75,
        894.5,
        -56.0
      ],
      [
        559.75,
        894.0,
        -55.5
      ],
      [
        559.75,
        894.0,
        -56.0
      ],
      [
        559.25,
        894.0,
        -56.0
      ],
      [
        559.25,
        894.0,
        -55.5
      ],
      [
        539.25,
        894.5,
        -56.0
      ],
      [
        539.25,
        894.5,
        -55.5
      ],
      [
        538.75,
        894.5,
        -55.5
      ],
      [
        538.75,
        894.5,
        -56.0
      ],
      [
        539.25,
        894.0,
        -56.0
      ],
      [
        539.25,
        894.0,
        -55.5
      ],
      [
        539.25,
        894.5,
        -55.5
      ],
      [
        539.25,
        894.5,
        -56.0
      ],
      [
        539.25,
        894.0,
        -55.5
      ],
      [
        539.25,
        894.0,
        -56.0
      ],
      [
        538.75,
        894.0,
        -56.0
      ],
      [
        538.75,
        894.0,
        -55.5
      ],
      [
        517.75,
        894.5,
        -56.0
      ],
      [
        517.75,
        894.5,
        -55.5
      ],
      [
        517.75,
        894.0,
        -55.5
      ],
      [
        517.75,
        894.0,
        -56.0
      ],
      [
        518.25,
        894.5,
        -56.0
      ],
      [
        518.25,
        894.5,
        -55.5
      ],
      [
        517.75,
        894.5,
        -55.5
      ],
      [
        517.75,
        894.5,
        -56.0
      ],
      [
        518.25,
        894.0,
        -56.0
      ],
      [
        518.25,
        894.0,
        -55.5
      ],
      [
        518.25,
        894.5,
        -55.5
      ],
      [
        518.25,
        894.5,
        -56.0
      ],
      [
        518.25,
        894.0,
        -55.5
      ],
      [
        518.25,
        894.0,
        -56.0
      ],
      [
        517.75,
        894.0,
        -56.0
      ],
      [
        517.75,
        894.0,
        -55.5
      ],
      [
        508.6000061035156,
        845.0,
        -58.0
      ],
      [
        510.6000061035156,
        845.0,
        -58.0
      ],
      [
        487.6000061035156,
        845.0,
        -58.0
      ],
      [
        489.6000061035156,
        845.0,
        -58.0
      ],
      [
        522.5999755859375,
        845.0,
        -58.0
      ],
      [
        524.5999755859375,
        845.0,
        -58.0
      ],
      [
        543.5999755859375,
        845.0,
        -58.0
      ],
      [
        545.5999755859375,
        845.0,
        -58.0
      ],
      [
        543.5999755859375,
        845.0,
        -58.0
      ],
      [
        543.5999755859375,
        845.0,
        -60.0
      ],
      [
        524.5999755859375,
        845.0,
        -60.0
      ],
      [
        524.5999755859375,
        845.0,
        -58.0
      ],
      [
        508.6000061035156,
        845.0,
        -58.0
      ],
      [
        508.6000061035156,
        845.0,
        -60.0
      ],
      [
        489.6000061035156,
        845.0,
        -60.0
      ],
      [
        489.6000061035156,
        845.0,
        -58.0
      ],
      [
        509.6000061035156,
        843.0,
        -58.0
      ],
      [
        509.6000061035156,
        843.0,
        -56.0
      ],
      [
        543.5999755859375,
        845.0,
        -56.5
      ],
      [
        524.5999755859375,
        845.0,
        -56.5
      ],
      [
        524.5999755859375,
        845.0,
        -56.0
      ],
      [
        524.5999755859375,
        845.0,
        -56.5
      ],
      [
        545.5999755859375,
        844.0,
        -56.5
      ],
      [
        544.5999755859375,
        843.0,
        -56.0
      ],
      [
        544.5999755859375,
        843.0,
        -56.5
      ],
      [
        545.5999755859375,
        845.0,
        -56.5
      ],
      [
        545.5999755859375,
        845.0,
        -56.0
      ],
      [
        545.5999755859375,
        844.0,
        -56.5
      ],
      [
        543.5999755859375,
        845.0,
        -56.5
      ],
      [
        543.5999755859375,
        845.0,
        -56.0
      ],
      [
        522.5999755859375,
        844.0,
        -56.5
      ],
      [
        523.5999755859375,
        843.0,
        -56.5
      ],
      [
        523.5999755859375,
        843.0,
        -56.0
      ],
      [
        522.5999755859375,
        844.0,
        -56.5
      ],
      [
        522.5999755859375,
        845.0,
        -56.0
      ],
      [
        522.5999755859375,
        845.0,
        -56.5
      ],
      [
        523.5999755859375,
        843.0,
        -58.0
      ],
      [
        544.5999755859375,
        843.0,
        -58.0
      ],
      [
        545.5999755859375,
        845.0,
        -58.0
      ],
      [
        522.5999755859375,
        845.0,
        -58.0
      ],
      [
        508.6000061035156,
        845.0,
        -56.5
      ],
      [
        489.6000061035156,
        845.0,
        -56.5
      ],
      [
        489.6000061035156,
        845.0,
        -56.0
      ],
      [
        489.6000061035156,
        845.0,
        -56.5
      ],
      [
        510.6000061035156,
        845.0,
        -56.5
      ],
      [
        510.6000061035156,
        845.0,
        -56.0
      ],
      [
        510.6000061035156,
        844.0,
        -56.5
      ],
      [
        508.6000061035156,
        845.0,
        -56.5
      ],
      [
        508.6000061035156,
        845.0,
        -56.0
      ],
      [
        487.6000061035156,
        844.0,
        -56.5
      ],
      [
        488.6000061035156,
        843.0,
        -56.5
      ],
      [
        488.6000061035156,
        843.0,
        -56.0
      ],
      [
        487.6000061035156,
        844.0,
        -56.5
      ],
      [
        487.6000061035156,
        845.0,
        -56.0
      ],
      [
        487.6000061035156,
        845.0,
        -56.5
      ],
      [
        488.6000061035156,
        843.0,
        -58.0
      ],
      [
        510.6000061035156,
        845.0,
        -58.0
      ],
      [
        487.6000061035156,
        845.0,
        -58.0
      ],
      [
        455.1000061035156,
        869.1000366210938,
        -56.5
      ],
      [
        455.1000061035156,
        886.1000366210938,
        -56.5
      ],
      [
        462.6000061035156,
        866.0999755859375,
        -56.5
      ],
      [
        462.6000061035156,
        860.0999755859375,
        -56.5
      ],
      [
        462.6000061035156,
        895.0999755859375,
        -56.5
      ],
      [
        462.6000061035156,
        889.0999755859375,
        -56.5
      ],
      [
        459.1000061035156,
        860.0999755859375,
        -56.5
      ],
      [
        459.1000061035156,
        855.0999755859375,
        -56.5
      ],
      [
        459.1000061035156,
        860.0999755859375,
        -56.5
      ],
      [
        459.1000061035156,
        845.0,
        -56.5
      ],
      [
        459.1000061035156,
        895.0999755859375,
        -56.5
      ],
      [
        459.1000061035156,
        906.0,
        -56.5
      ],
      [
        459.1000061035156,
        887.1000366210938,
        -56.0
      ],
      [
        459.1000061035156,
        887.1000366210938,
        -56.5
      ],
      [
        459.1000061035156,
        868.1000366210938,
        -56.5
      ],
      [
        459.1000061035156,
        868.1000366210938,
        -56.0
      ],
      [
        458.1000061035156,
        889.1000366210938,
        -56.5
      ],
      [
        457.1000061035156,
        888.1000366210938,
        -56.5
      ],
      [
        457.1000061035156,
        888.1000366210938,
        -56.0
      ],
      [
        458.1000061035156,
        889.1000366210938,
        -56.5
      ],
      [
        459.1000061035156,
        889.1000366210938,
        -56.0
      ],
      [
        459.1000061035156,
        889.1000366210938,
        -56.5
      ],
      [
        457.1000061035156,
        867.1000366210938,
        -56.5
      ],
      [
        458.1000061035156,
        866.1000366210938,
        -56.5
      ],
      [
        457.1000061035156,
        867.1000366210938,
        -56.0
      ],
      [
        459.1000061035156,
        866.1000366210938,
        -56.0
      ],
      [
        458.1000061035156,
        866.1000366210938,
        -56.5
      ],
      [
        459.1000061035156,
        866.1000366210938,
        -56.5
      ],
      [
        462.6000061035156,
        860.0999755859375,
        -56.5
      ],
      [
        459.1000061035156,
        860.0999755859375,
        -56.5
      ],
      [
        462.6000061035156,
        866.0999755859375,
        -56.5
      ],
      [
        459.1000061035156,
        895.0999755859375,
        -56.5
      ],
      [
        462.6000061035156,
        895.0999755859375,
        -56.5
      ],
      [
        462.6000061035156,
        889.0999755859375,
        -56.5
      ],
      [
        461.1999816894531,
        848.75,
        -56.5
      ],
      [
        462.1999816894531,
        850.48193359375,
        -56.5
      ],
      [
        462.1999816894531,
        847.01806640625,
        -56.5
      ],
      [
        461.1999816894531,
        848.75,
        -56.5
      ],
      [
        462.6000061035156,
        847.26806640625,
        -56.0
      ],
      [
        462.3442687988281,
        847.26806640625,
        -56.5
      ],
      [
        462.6000061035156,
        847.26806640625,
        -56.5
      ],
      [
        462.6000061035156,
        847.01806640625,
        -56.0
      ],
      [
        462.6000061035156,
        847.01806640625,
        -56.5
      ],
      [
        462.1999816894531,
        847.01806640625,
        -56.5
      ],
      [
        461.4885559082031,
        848.75,
        -56.5
      ],
      [
        462.3442687988281,
        847.26806640625,
        -56.5
      ],
      [
        462.6000061035156,
        850.23193359375,
        -56.0
      ],
      [
        462.6000061035156,
        850.23193359375,
        -56.5
      ],
      [
        462.3442687988281,
        850.23193359375,
        -56.5
      ],
      [
        462.6000061035156,
        850.48193359375,
        -56.0
      ],
      [
        462.1999816894531,
        850.48193359375,
        -56.5
      ],
      [
        462.6000061035156,
        850.48193359375,
        -56.5
      ],
      [
        462.3442687988281,
        850.23193359375,
        -56.5
      ],
      [
        461.4885559082031,
        848.75,
        -56.5
      ],
      [
        510.6000061035156,
        850.0,
        -56.5
      ],
      [
        516.5999755859375,
        850.0,
        -56.5
      ],
      [
        481.6000061035156,
        850.0,
        -56.5
      ],
      [
        487.6000061035156,
        850.0,
        -56.5
      ],
      [
        516.5999755859375,
        850.0,
        -56.5
      ],
      [
        522.5999755859375,
        850.0,
        -56.5
      ],
      [
        545.5999755859375,
        850.0,
        -56.5
      ],
      [
        551.5999755859375,
        850.0,
        -56.5
      ],
      [
        545.5999755859375,
        850.0,
        -56.5
      ],
      [
        545.5999755859375,
        845.0,
        -56.5
      ],
      [
        551.5999755859375,
        850.0,
        -56.5
      ],
      [
        551.5999755859375,
        845.0,
        -56.5
      ],
      [
        567.0,
        850.0,
        -56.0
      ],
      [
        567.0,
        845.0,
        -56.5
      ],
      [
        567.0,
        850.0,
        -56.5
      ],
      [
        510.6000061035156,
        850.0,
        -56.5
      ],
      [
        510.6000061035156,
        845.0,
        -56.5
      ],
      [
        522.5999755859375,
        850.0,
        -56.5
      ],
      [
        522.5999755859375,
        845.0,
        -56.5
      ],
      [
        481.6000061035156,
        845.0,
        -56.5
      ],
      [
        481.6000061035156,
        850.0,
        -56.5
      ],
      [
        487.6000061035156,
        850.0,
        -56.5
      ],
      [
        487.6000061035156,
        845.0,
        -56.5
      ],
      [
        465.1999816894531,
        848.75,
        -56.5
      ],
      [
        464.1999816894531,
        847.01806640625,
        -56.5
      ],
      [
        464.0556945800781,
        847.26806640625,
        -56.5
      ],
      [
        464.1999816894531,
        847.01806640625,
        -56.5
      ],
      [
        464.1896057128906,
        850.0,
        -56.0
      ],
      [
        464.9114074707031,
        848.75,
        -56.5
      ],
      [
        464.1896057128906,
        850.0,
        -56.5
      ],
      [
        464.4782409667969,
        850.0,
        -56.0
      ],
      [
        464.4782409667969,
        850.0,
        -56.5
      ],
      [
        465.1999816894531,
        848.75,
        -56.5
      ],
      [
        464.0556945800781,
        847.26806640625,
        -56.5
      ],
      [
        464.9114074707031,
        848.75,
        -56.5
      ],
      [
        525.0,
        870.2000122070312,
        -56.5
      ],
      [
        525.0,
        872.0,
        -56.5
      ],
      [
        524.0,
        872.0,
        -56.5
      ],
      [
        525.0,
        872.0,
        -56.5
      ],
      [
        483.25,
        870.75,
        -56.5
      ],
      [
        483.25,
        871.25,
        -56.5
      ],
      [
        464.1999816894531,
        850.48193359375,
        -56.5
      ],
      [
        464.0556945800781,
        850.23193359375,
        -56.5
      ],
      [
        464.1999816894531,
        850.48193359375,
        -56.5
      ],
      [
        464.0556945800781,
        850.23193359375,
        -56.5
      ],
      [
        482.75,
        871.25,
        -56.5
      ],
      [
        482.75,
        870.75,
        -56.5
      ],
      [
        482.75,
        871.25,
        -56.5
      ],
      [
        483.25,
        871.25,
        -56.5
      ],
      [
        482.75,
        870.75,
        -56.5
      ],
      [
        483.25,
        870.75,
        -56.5
      ],
      [
        524.0,
        872.0,
        -56.5
      ],
      [
        524.0,
        870.2000122070312,
        -56.5
      ],
      [
        524.0,
        870.2000122070312,
        -56.5
      ],
      [
        525.0,
        870.2000122070312,
        -56.5
      ],
      [
        502.75,
        871.25,
        -56.5
      ],
      [
        502.75,
        870.75,
        -56.5
      ],
      [
        502.75,
        871.25,
        -56.5
      ],
      [
        503.25,
        871.25,
        -56.5
      ],
      [
        503.25,
        870.75,
        -56.5
      ],
      [
        503.25,
        871.25,
        -56.5
      ],
      [
        502.75,
        870.75,
        -56.5
      ],
      [
        503.25,
        870.75,
        -56.5
      ],
      [
        482.75,
        892.25,
        -56.5
      ],
      [
        483.25,
        892.25,
        -56.5
      ],
      [
        482.75,
        892.25,
        -56.5
      ],
      [
        482.75,
        891.75,
        -56.5
      ],
      [
        483.25,
        891.75,
        -56.5
      ],
      [
        483.25,
        892.25,
        -56.5
      ],
      [
        482.75,
        891.75,
        -56.5
      ],
      [
        483.25,
        891.75,
        -56.5
      ],
      [
        567.0,
        855.0,
        -56.5
      ],
      [
        567.0,
        855.0,
        -56.5
      ],
      [
        571.5,
        855.0,
        -56.5
      ],
      [
        551.0,
        872.0,
        -56.5
      ],
      [
        551.0,
        870.2000122070312,
        -56.5
      ],
      [
        552.0,
        870.2000122070312,
        -56.5
      ],
      [
        552.0,
        872.0,
        -56.5
      ],
      [
        551.0,
        872.0,
        -56.5
      ],
      [
        552.0,
        872.0,
        -56.5
      ],
      [
        551.0,
        870.2000122070312,
        -56.5
      ],
      [
        552.0,
        870.2000122070312,
        -56.5
      ],
      [
        455.1000061035156,
        886.1000366210938,
        -56.5
      ],
      [
        455.1000061035156,
        869.1000366210938,
        -56.5
      ],
      [
        540.0,
        890.0,
        -60.0
      ],
      [
        538.0,
        890.0,
        -60.0
      ],
      [
        538.0,
        890.0,
        -56.5
      ],
      [
        540.0,
        890.0,
        -56.5
      ],
      [
        540.0,
        890.0,
        -57.0
      ],
      [
        543.0,
        890.0,
        -57.44999313354492
      ],
      [
        542.0,
        890.0,
        -56.5
      ],
      [
        542.0,
        890.0,
        -57.29999542236328
      ],
      [
        535.0,
        890.0,
        -57.45001220703125
      ],
      [
        538.0,
        890.0,
        -57.00000762939453
      ],
      [
        536.0,
        890.0,
        -56.5
      ],
      [
        536.0,
        890.0,
        -57.300010681152344
      ],
      [
        558.5,
        890.0,
        -60.0
      ],
      [
        558.5,
        890.0,
        -56.69999694824219
      ],
      [
        563.5,
        890.0,
        -57.44999313354492
      ],
      [
        562.5,
        890.0,
        -56.5
      ],
      [
        562.5,
        890.0,
        -57.29999542236328
      ],
      [
        558.5,
        890.0,
        -56.5
      ],
      [
        560.5,
        890.0,
        -56.5
      ],
      [
        560.5,
        890.0,
        -56.999996185302734
      ],
      [
        555.5,
        890.0,
        -57.44999694824219
      ],
      [
        558.5,
        890.0,
        -56.99999237060547
      ],
      [
        556.5,
        890.0,
        -56.5
      ],
      [
        556.5,
        890.0,
        -57.29999542236328
      ],
      [
        514.0,
        850.0,
        -59.133338928222656
      ],
      [
        514.0,
        850.0,
        -60.0
      ],
      [
        522.0,
        850.0,
        -58.19999313354492
      ],
      [
        522.0,
        850.0,
        -60.0
      ],
      [
        514.0,
        850.0,
        -59.133338928222656
      ],
      [
        514.0,
        850.0,
        -56.5
      ],
      [
        522.0,
        850.0,
        -58.19999313354492
      ],
      [
        522.0,
        850.0,
        -56.5
      ],
      [
        457.1000061035156,
        867.1000366210938,
        -58.0
      ],
      [
        457.1000061035156,
        888.1000366210938,
        -58.0
      ],
      [
        457.1000061035156,
        888.1000366210938,
        -58.0
      ],
      [
        457.1000061035156,
        888.1000366210938,
        -56.5
      ],
      [
        457.1000061035156,
        867.1000366210938,
        -58.0
      ],
      [
        457.1000061035156,
        867.1000366210938,
        -56.5
      ],
      [
        504.75,
        871.25,
        -60.0
      ],
      [
        502.75,
        869.25,
        -60.0
      ],
      [
        502.75,
        870.75,
        -58.66667556762695
      ],
      [
        502.75,
        872.75,
        -60.0
      ],
      [
        483.25,
        869.25,
        -60.0
      ],
      [
        482.75,
        869.25,
        -60.0
      ],
      [
        484.75,
        871.25,
        -60.0
      ],
      [
        481.25,
        871.25,
        -60.0
      ],
      [
        483.25,
        890.25,
        -60.0
      ],
      [
        482.75,
        890.25,
        -60.0
      ],
      [
        484.75,
        892.25,
        -60.0
      ],
      [
        482.75,
        893.75,
        -60.0
      ],
      [
        510.6000061035156,
        845.0,
        -54.0
      ],
      [
        487.6000061035156,
        845.0,
        -54.0
      ],
      [
        522.5999755859375,
        845.0,
        -54.0
      ],
      [
        545.5999755859375,
        845.0,
        -54.0
      ],
      [
        545.5999755859375,
        845.0,
        -54.0
      ],
      [
        545.5999755859375,
        845.0,
        -55.5
      ],
      [
        522.5999755859375,
        845.0,
        -54.0
      ],
      [
        522.5999755859375,
        845.0,
        -55.5
      ],
      [
        510.6000061035156,
        845.0,
        -54.0
      ],
      [
        510.6000061035156,
        845.0,
        -55.5
      ],
      [
        487.6000061035156,
        845.0,
        -54.0
      ],
      [
        487.6000061035156,
        845.0,
        -55.5
      ],
      [
        459.1000061035156,
        889.1000366210938,
        -54.0
      ],
      [
        459.1000061035156,
        866.1000366210938,
        -54.0
      ],
      [
        459.1000061035156,
        866.1000366210938,
        -54.0
      ],
      [
        459.1000061035156,
        866.1000366210938,
        -55.5
      ],
      [
        459.1000061035156,
        889.1000366210938,
        -54.0
      ],
      [
        459.1000061035156,
        889.1000366210938,
        -55.5
      ],
      [
        522.0,
        845.0,
        -54.0
      ],
      [
        522.0,
        850.0,
        -54.0
      ],
      [
        522.5999755859375,
        850.0,
        -54.3599853515625
      ],
      [
        522.5999755859375,
        845.0,
        -54.3599853515625
      ],
      [
        522.5999755859375,
        850.0,
        -54.3599853515625
      ],
      [
        522.0,
        850.0,
        -54.0
      ],
      [
        514.0,
        850.0,
        -54.0
      ],
      [
        514.0,
        845.0,
        -54.0
      ],
      [
        514.0,
        850.0,
        -54.0
      ],
      [
        511.5,
        850.0,
        -55.5
      ],
      [
        461.5201110839844,
        1298.4000244140625,
        -43.0
      ],
      [
        483.94342041015625,
        1298.4000244140625,
        -40.0
      ],
      [
        501.73199462890625,
        1215.6890869140625,
        -43.0
      ],
      [
        497.20526123046875,
        1225.0,
        -43.0
      ],
      [
        506.5,
        1218.0072021484375,
        -43.0
      ],
      [
        497.20526123046875,
        1225.0,
        -43.0
      ],
      [
        493.5,
        1232.6212158203125,
        -43.0
      ],
      [
        461.5200500488281,
        1298.4000244140625,
        -43.0
      ],
      [
        468.0,
        1285.0716552734375,
        -43.0
      ],
      [
        479.9947204589844,
        1260.4000244140625,
        -43.0
      ],
      [
        468.0,
        1285.0716552734375,
        -43.0
      ],
      [
        520.8829956054688,
        1225.0,
        -43.0
      ],
      [
        551.530029296875,
        1239.9000244140625,
        -43.0
      ],
      [
        493.5,
        1232.6212158203125,
        -43.0
      ],
      [
        489.9612731933594,
        1239.9000244140625,
        -43.0
      ],
      [
        493.2065124511719,
        1211.5440673828125,
        -49.0
      ],
      [
        493.20648193359375,
        1211.5440673828125,
        -44.410240173339844
      ],
      [
        468.7555847167969,
        1211.5440673828125,
        -47.68153381347656
      ],
      [
        493.0,
        1258.4000244140625,
        -41.390113830566406
      ],
      [
        493.0,
        1279.771728515625,
        -40.0
      ],
      [
        493.5,
        1239.9000244140625,
        -42.526554107666016
      ],
      [
        493.0,
        1239.9000244140625,
        -43.0
      ],
      [
        493.0,
        1239.9000244140625,
        -42.593448638916016
      ],
      [
        506.0001220703125,
        1239.9000244140625,
        -43.0
      ],
      [
        493.5,
        1239.9000244140625,
        -42.526554107666016
      ],
      [
        506.0001220703125,
        1239.9000244140625,
        -40.854164123535156
      ],
      [
        468.0,
        1285.0716552734375,
        -43.0
      ],
      [
        468.0,
        1298.4000244140625,
        -42.13304901123047
      ],
      [
        468.0,
        1298.4000244140625,
        -42.13304901123047
      ],
      [
        468.0,
        1285.0716552734375,
        -43.0
      ],
      [
        493.0,
        1260.4000244140625,
        -41.2600212097168
      ],
      [
        489.9612731933594,
        1239.9000244140625,
        -43.0
      ],
      [
        489.0,
        1271.9000244140625,
        -41.047176361083984
      ],
      [
        489.0,
        1270.9000244140625,
        -41.112213134765625
      ],
      [
        489.0,
        1272.625244140625,
        -41.0
      ],
      [
        489.0,
        1271.9000244140625,
        -41.047176361083984
      ],
      [
        489.0,
        1272.625244140625,
        -41.0
      ],
      [
        489.35260009765625,
        1271.9000244140625,
        -41.0
      ],
      [
        489.8387145996094,
        1270.9000244140625,
        -41.0
      ],
      [
        489.0,
        1270.9000244140625,
        -41.112213134765625
      ],
      [
        492.63812255859375,
        1264.161376953125,
        -41.06377410888672
      ],
      [
        490.800048828125,
        1265.1881103515625,
        -41.24290466308594
      ],
      [
        490.800048828125,
        1265.1881103515625,
        -41.24290466308594
      ],
      [
        489.0423889160156,
        1264.11474609375,
        -41.547882080078125
      ],
      [
        489.06378173828125,
        1262.0975341796875,
        -41.67622756958008
      ],
      [
        490.800048828125,
        1261.0634765625,
        -41.511199951171875
      ],
      [
        489.0423889160156,
        1264.11474609375,
        -41.547882080078125
      ],
      [
        489.06378173828125,
        1262.0975341796875,
        -41.67622756958008
      ],
      [
        492.267822265625,
        1296.9857177734375,
        -41.0
      ],
      [
        490.5,
        1296.4000244140625,
        -41.0
      ],
      [
        493.0,
        1298.4000244140625,
        -41.0
      ],
      [
        492.267822265625,
        1296.9857177734375,
        -41.0
      ],
      [
        490.5,
        1296.4000244140625,
        -41.0
      ],
      [
        489.0,
        1296.89697265625,
        -43.0
      ],
      [
        489.0,
        1296.89697265625,
        -41.0
      ],
      [
        491.666748046875,
        1282.5140380859375,
        -40.0
      ],
      [
        491.6203308105469,
        1271.9000244140625,
        -40.696598052978516
      ],
      [
        492.43951416015625,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        491.61968994140625,
        1271.753173828125,
        -40.70623779296875
      ],
      [
        492.7312316894531,
        1271.0999755859375,
        -40.600006103515625
      ],
      [
        491.60009765625,
        1270.9000244140625,
        -41.0
      ],
      [
        491.6164855957031,
        1271.02294921875,
        -40.75415802001953
      ],
      [
        492.43951416015625,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        492.7312316894531,
        1271.0999755859375,
        -40.600006103515625
      ],
      [
        491.6203308105469,
        1271.9000244140625,
        -40.696598052978516
      ],
      [
        493.0,
        1271.9000244140625,
        -40.51200866699219
      ],
      [
        489.35260009765625,
        1271.9000244140625,
        -41.0
      ],
      [
        489.8387145996094,
        1270.9000244140625,
        -41.0
      ],
      [
        489.0,
        1296.89697265625,
        -40.0
      ],
      [
        472.0,
        1284.9000244140625,
        -42.47599792480469
      ],
      [
        472.0,
        1285.9000244140625,
        -42.41096115112305
      ],
      [
        472.0,
        1284.9000244140625,
        -42.47599792480469
      ],
      [
        472.0,
        1276.8441162109375,
        -43.0
      ],
      [
        468.0,
        1285.9000244140625,
        -42.946128845214844
      ],
      [
        472.0,
        1285.9000244140625,
        -42.41096115112305
      ],
      [
        470.5,
        1296.4000244140625,
        -41.92867660522461
      ],
      [
        468.732177734375,
        1296.9857177734375,
        -42.12709426879883
      ],
      [
        472.0,
        1296.89697265625,
        -43.0
      ],
      [
        470.5,
        1296.4000244140625,
        -41.92867660522461
      ],
      [
        472.0,
        1296.89697265625,
        -41.69565963745117
      ],
      [
        468.732177734375,
        1296.9857177734375,
        -42.12709426879883
      ],
      [
        468.0,
        1298.4000244140625,
        -42.13304901123047
      ],
      [
        475.0,
        1297.4000244140625,
        -41.261566162109375
      ],
      [
        484.4295349121094,
        1297.4000244140625,
        -40.0
      ],
      [
        475.0,
        1298.4000244140625,
        -41.19652557373047
      ],
      [
        475.0,
        1297.4000244140625,
        -41.261566162109375
      ],
      [
        473.0,
        1298.4000244140625,
        -41.46411895751953
      ],
      [
        472.4822998046875,
        1297.4000244140625,
        -43.0
      ],
      [
        472.4822998046875,
        1297.4000244140625,
        -41.59841537475586
      ],
      [
        488.5177001953125,
        1297.4000244140625,
        -43.0
      ],
      [
        488.5177001953125,
        1297.4000244140625,
        -40.0
      ],
      [
        472.267822265625,
        1296.9857177734375,
        -41.654052734375
      ],
      [
        472.267822265625,
        1296.9857177734375,
        -41.654052734375
      ],
      [
        467.267822265625,
        1296.9857177734375,
        -42.32301330566406
      ],
      [
        465.5,
        1296.4000244140625,
        -42.59761047363281
      ],
      [
        465.5,
        1296.4000244140625,
        -42.59761047363281
      ],
      [
        463.732177734375,
        1296.9857177734375,
        -42.79602813720703
      ],
      [
        468.0,
        1298.4000244140625,
        -42.13304901123047
      ],
      [
        467.267822265625,
        1296.9857177734375,
        -42.32301330566406
      ],
      [
        463.732177734375,
        1296.9857177734375,
        -42.79602813720703
      ],
      [
        463.0,
        1298.4000244140625,
        -42.8020133972168
      ],
      [
        467.59735107421875,
        1285.9000244140625,
        -43.0
      ],
      [
        468.0,
        1285.9000244140625,
        -42.946128845214844
      ],
      [
        519.0,
        1225.0,
        -40.08409881591797
      ],
      [
        506.5,
        1225.0,
        -41.7564697265625
      ],
      [
        519.0,
        1225.0,
        -43.0
      ],
      [
        506.5,
        1218.0072021484375,
        -43.0
      ],
      [
        506.5,
        1225.0,
        -41.7564697265625
      ],
      [
        506.5,
        1218.0072021484375,
        -42.21131134033203
      ],
      [
        506.5,
        1239.9000244140625,
        -40.78728485107422
      ],
      [
        512.3844604492188,
        1239.9000244140625,
        -40.0
      ],
      [
        506.5,
        1239.9000244140625,
        -40.78728485107422
      ],
      [
        513.0,
        1297.4000244140625,
        -41.0
      ],
      [
        516.0,
        1297.4000244140625,
        -40.0
      ],
      [
        516.0,
        1297.4000244140625,
        -41.0
      ],
      [
        513.0,
        1297.4000244140625,
        -41.0
      ],
      [
        513.0,
        1298.4000244140625,
        -41.0
      ],
      [
        516.0,
        1297.4000244140625,
        -43.0
      ],
      [
        519.0,
        1297.4000244140625,
        -43.0
      ],
      [
        519.0,
        1297.4000244140625,
        -40.0
      ],
      [
        508.5,
        1296.4000244140625,
        -41.0
      ],
      [
        506.732177734375,
        1296.9857177734375,
        -41.0
      ],
      [
        506.732177734375,
        1296.9857177734375,
        -41.0
      ],
      [
        506.0000915527344,
        1298.4000244140625,
        -41.0
      ],
      [
        510.0,
        1296.89697265625,
        -43.0
      ],
      [
        508.5,
        1296.4000244140625,
        -41.0
      ],
      [
        510.0,
        1296.89697265625,
        -41.0
      ],
      [
        507.3732604980469,
        1271.0999755859375,
        -40.600006103515625
      ],
      [
        507.37322998046875,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        507.37322998046875,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        510.0,
        1296.89697265625,
        -40.0
      ],
      [
        530.267822265625,
        1296.9857177734375,
        -41.0
      ],
      [
        528.5,
        1296.4000244140625,
        -41.0
      ],
      [
        531.0,
        1298.4000244140625,
        -41.0
      ],
      [
        530.267822265625,
        1296.9857177734375,
        -41.0
      ],
      [
        528.5,
        1296.4000244140625,
        -41.0
      ],
      [
        527.0,
        1296.89697265625,
        -43.0
      ],
      [
        527.0,
        1296.89697265625,
        -41.0
      ],
      [
        529.6267700195312,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        529.6267700195312,
        1271.0999755859375,
        -40.600006103515625
      ],
      [
        529.6267700195312,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        527.0,
        1296.89697265625,
        -40.0
      ],
      [
        531.0,
        1239.9000244140625,
        -43.0
      ],
      [
        531.0,
        1239.9000244140625,
        -40.0
      ],
      [
        531.0,
        1260.4000244140625,
        -40.0
      ],
      [
        531.0,
        1260.4000244140625,
        -43.0
      ],
      [
        520.8829345703125,
        1225.0,
        -40.0
      ],
      [
        519.6286010742188,
        1225.0,
        -40.0
      ],
      [
        520.8829956054688,
        1225.0,
        -43.0
      ],
      [
        551.530029296875,
        1239.9000244140625,
        -43.0
      ],
      [
        551.530029296875,
        1239.9000244140625,
        -40.0
      ],
      [
        555.6487426757812,
        1264.16748046875,
        -41.0
      ],
      [
        553.800048828125,
        1265.23486328125,
        -41.0
      ],
      [
        552.0,
        1262.0606689453125,
        -41.29345703125
      ],
      [
        552.0,
        1262.004150390625,
        -41.0
      ],
      [
        553.800048828125,
        1260.965087890625,
        -41.0
      ],
      [
        553.800048828125,
        1265.23486328125,
        -41.0
      ],
      [
        552.0,
        1264.19580078125,
        -41.0
      ],
      [
        552.0,
        1264.1392822265625,
        -41.29345703125
      ],
      [
        552.0,
        1264.1392822265625,
        -41.29345703125
      ],
      [
        552.0,
        1262.0606689453125,
        -41.29345703125
      ],
      [
        554.6267700195312,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        554.626708984375,
        1271.0999755859375,
        -40.600006103515625
      ],
      [
        554.6267700195312,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        552.0,
        1264.38818359375,
        -40.0
      ],
      [
        552.0,
        1261.811767578125,
        -40.0
      ],
      [
        543.0,
        1297.4000244140625,
        -40.0
      ],
      [
        543.0,
        1297.4000244140625,
        -43.0
      ],
      [
        533.5,
        1296.4000244140625,
        -41.0
      ],
      [
        531.732177734375,
        1296.9857177734375,
        -41.0
      ],
      [
        531.732177734375,
        1296.9857177734375,
        -41.0
      ],
      [
        531.0,
        1298.4000244140625,
        -41.0
      ],
      [
        535.0,
        1296.89697265625,
        -43.0
      ],
      [
        533.5,
        1296.4000244140625,
        -41.0
      ],
      [
        535.0,
        1296.89697265625,
        -41.0
      ],
      [
        532.373291015625,
        1271.0999755859375,
        -40.600006103515625
      ],
      [
        532.3732299804688,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        532.3732299804688,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        535.0,
        1296.89697265625,
        -40.0
      ],
      [
        506.5,
        1211.5440673828125,
        -42.6317024230957
      ],
      [
        526.1705322265625,
        1211.5440673828125,
        -40.0
      ],
      [
        503.7471923828125,
        1211.5440673828125,
        -43.0
      ],
      [
        503.7471923828125,
        1211.5440673828125,
        -43.0
      ],
      [
        506.5,
        1211.5440673828125,
        -42.6317024230957
      ],
      [
        458.985595703125,
        1042.2559814453125,
        -60.0
      ],
      [
        485.5653991699219,
        1042.2559814453125,
        -56.44390106201172
      ],
      [
        500.5653991699219,
        1042.2559814453125,
        -54.43705368041992
      ],
      [
        541.0992431640625,
        1042.2559814453125,
        -49.014041900634766
      ],
      [
        545.8145141601562,
        1000.0,
        -51.13173294067383
      ],
      [
        547.1674194335938,
        1000.0,
        -50.95072937011719
      ],
      [
        571.5,
        1000.0,
        -47.695274353027344
      ],
      [
        561.785400390625,
        1000.0,
        -48.9949836730957
      ],
      [
        561.785400390625,
        1000.0,
        -48.9949836730957
      ],
      [
        547.1674194335938,
        1000.0,
        -50.95072937011719
      ],
      [
        531.650634765625,
        1020.5,
        -51.693294525146484
      ],
      [
        535.0,
        1008.0,
        -52.05824279785156
      ],
      [
        568.0809936523438,
        1042.2559814453125,
        -60.0
      ],
      [
        569.8525390625,
        1038.7791748046875,
        -45.393306732177734
      ],
      [
        568.0809936523438,
        1042.2559814453125,
        -45.404170989990234
      ],
      [
        569.8525390625,
        1038.7791748046875,
        -45.393306732177734
      ],
      [
        571.5,
        1037.4847412109375,
        -45.25708770751953
      ],
      [
        522.5,
        1029.650634765625,
        -52.32233810424805
      ],
      [
        531.650634765625,
        1020.5,
        -51.69329071044922
      ],
      [
        505.25,
        1034.272705078125,
        -54.3295783996582
      ],
      [
        510.0,
        1033.0,
        -53.77685546875
      ],
      [
        510.0,
        1033.0,
        -53.77685546875
      ],
      [
        522.5,
        1029.650634765625,
        -52.32233810424805
      ],
      [
        501.77276611328125,
        1037.75,
        -54.5686149597168
      ],
      [
        505.25,
        1034.272705078125,
        -54.3295783996582
      ],
      [
        501.77276611328125,
        1037.75,
        -54.5686149597168
      ],
      [
        500.5653991699219,
        1042.2559814453125,
        -54.43705368041992
      ],
      [
        486.3473205566406,
        1039.3377685546875,
        -56.52910232543945
      ],
      [
        485.5653991699219,
        1042.2559814453125,
        -56.44390106201172
      ],
      [
        486.3473205566406,
        1039.3377685546875,
        -60.0
      ],
      [
        488.7823791503906,
        1030.25,
        -56.794437408447266
      ],
      [
        535.0,
        1008.0,
        -52.05824279785156
      ],
      [
        535.0,
        1005.2578125,
        -52.23660659790039
      ],
      [
        510.0,
        1018.0,
        -54.752532958984375
      ],
      [
        515.0,
        1016.6602783203125,
        -54.170711517333984
      ],
      [
        510.0,
        1018.0,
        -54.75252914428711
      ],
      [
        507.30755615234375,
        1018.721435546875,
        -55.065826416015625
      ],
      [
        515.0,
        1016.6602783203125,
        -54.170711517333984
      ],
      [
        518.2674560546875,
        1013.392822265625,
        -53.94609832763672
      ],
      [
        488.7823791503906,
        1030.25,
        -56.794437408447266
      ],
      [
        493.6907043457031,
        1025.3416748046875,
        -56.45701217651367
      ],
      [
        550.0,
        1000.0,
        -50.5717658996582
      ],
      [
        550.0,
        999.0,
        -50.636802673339844
      ],
      [
        550.536376953125,
        1000.0,
        -50.5
      ],
      [
        551.0225219726562,
        999.0,
        -50.5
      ],
      [
        550.0,
        999.0,
        -50.636802673339844
      ],
      [
        550.1206665039062,
        999.0,
        -50.620662689208984
      ],
      [
        550.1206665039062,
        999.0,
        -50.620662689208984
      ],
      [
        551.0225219726562,
        999.0,
        -50.5
      ],
      [
        531.2444458007812,
        1211.5440673828125,
        -47.68156051635742
      ],
      [
        519.54052734375,
        1205.3468017578125,
        -43.0
      ],
      [
        506.7938232421875,
        1211.5440673828125,
        -43.0
      ],
      [
        519.54052734375,
        1205.3468017578125,
        -43.0
      ],
      [
        509.0653991699219,
        1210.4395751953125,
        -43.0
      ],
      [
        509.0653991699219,
        1210.4395751953125,
        -42.36032485961914
      ],
      [
        509.0653991699219,
        1211.5440673828125,
        -42.288490295410156
      ],
      [
        480.45941162109375,
        1198.053955078125,
        -46.993125915527344
      ],
      [
        510.3056945800781,
        1198.053955078125,
        -43.0
      ],
      [
        480.45941162109375,
        1198.053955078125,
        -46.993125915527344
      ],
      [
        503.7471618652344,
        1211.5440673828125,
        -43.0
      ],
      [
        510.3056945800781,
        1198.053955078125,
        -43.0
      ],
      [
        509.0653991699219,
        1209.800048828125,
        -42.401920318603516
      ],
      [
        506.5,
        1209.800048828125,
        -42.74515151977539
      ],
      [
        506.5,
        1211.5440673828125,
        -42.6317024230957
      ],
      [
        506.5,
        1209.800048828125,
        -42.74515151977539
      ],
      [
        509.0653991699219,
        1209.800048828125,
        -42.40192413330078
      ],
      [
        541.0992431640625,
        1042.2559814453125,
        -49.0140380859375
      ],
      [
        562.7239990234375,
        1052.76953125,
        -45.43702697753906
      ],
      [
        571.411376953125,
        1056.9932861328125,
        -44.0
      ],
      [
        571.5,
        1057.036376953125,
        -43.98534393310547
      ],
      [
        562.7239990234375,
        1052.76953125,
        -45.43702697753906
      ],
      [
        571.5,
        1056.81103515625,
        -44.0
      ],
      [
        571.411376953125,
        1056.9932861328125,
        -44.0
      ],
      [
        476.0269470214844,
        1068.7000732421875,
        -56.0
      ],
      [
        475.5,
        1068.6778564453125,
        -56.07194519042969
      ],
      [
        504.4652404785156,
        1062.5,
        -56.0
      ],
      [
        511.1171875,
        1062.5,
        -56.0
      ],
      [
        504.4652404785156,
        1062.5,
        -56.0
      ],
      [
        504.35162353515625,
        1062.5,
        -56.0
      ],
      [
        478.4091491699219,
        1063.800048828125,
        -56.0
      ],
      [
        476.0269470214844,
        1068.7000732421875,
        -56.0
      ],
      [
        473.0181884765625,
        1064.126708984375,
        -56.70000076293945
      ],
      [
        473.6935119628906,
        1062.73779296875,
        -56.70000076293945
      ],
      [
        504.35162353515625,
        1062.5,
        -56.70000076293945
      ],
      [
        499.5,
        1063.800048828125,
        -56.70000076293945
      ],
      [
        475.5,
        1063.800048828125,
        -56.70000076293945
      ],
      [
        499.5,
        1068.483642578125,
        -56.70000076293945
      ],
      [
        506.7917785644531,
        1066.5296630859375,
        -56.70000076293945
      ],
      [
        506.7917785644531,
        1066.5296630859375,
        -56.70000076293945
      ],
      [
        509.0145568847656,
        1063.800048828125,
        -57.900001525878906
      ],
      [
        509.52142333984375,
        1063.800048828125,
        -56.70000076293945
      ],
      [
        507.2217102050781,
        1063.800048828125,
        -60.0
      ],
      [
        509.0145568847656,
        1063.800048828125,
        -57.900001525878906
      ],
      [
        469.5542907714844,
        1063.800048828125,
        -57.20000076293945
      ],
      [
        469.41107177734375,
        1063.859375,
        -57.20000076293945
      ],
      [
        469.5542907714844,
        1063.800048828125,
        -57.18470001220703
      ],
      [
        468.20001220703125,
        1065.756103515625,
        -57.23863983154297
      ],
      [
        471.72125244140625,
        1064.2974853515625,
        -56.8624153137207
      ],
      [
        468.20001220703125,
        1065.756103515625,
        -57.23863983154297
      ],
      [
        465.809326171875,
        1066.800048828125,
        -60.0
      ],
      [
        462.80364990234375,
        1068.112548828125,
        -57.900028228759766
      ],
      [
        462.7425842285156,
        1068.13916015625,
        -57.81378173828125
      ],
      [
        471.72125244140625,
        1064.2974853515625,
        -56.8624153137207
      ],
      [
        473.0182189941406,
        1064.126708984375,
        -56.70000076293945
      ],
      [
        475.5,
        1063.800048828125,
        -56.70000076293945
      ],
      [
        472.9219665527344,
        1063.800048828125,
        -57.20000076293945
      ],
      [
        471.58795166015625,
        1063.800048828125,
        -57.20000076293945
      ],
      [
        469.41107177734375,
        1063.859375,
        -57.20000076293945
      ],
      [
        469.5542907714844,
        1063.800048828125,
        -57.20000076293945
      ],
      [
        471.58795166015625,
        1063.800048828125,
        -57.20000076293945
      ],
      [
        468.56170654296875,
        1065.6063232421875,
        -57.20000076293945
      ],
      [
        504.35162353515625,
        1062.5,
        -57.20000076293945
      ],
      [
        499.5,
        1063.800048828125,
        -57.20000076293945
      ],
      [
        499.5,
        1063.800048828125,
        -56.70000076293945
      ],
      [
        504.35162353515625,
        1062.5,
        -56.70000076293945
      ],
      [
        504.35162353515625,
        1062.5,
        -57.20000076293945
      ],
      [
        510.61029052734375,
        1062.5,
        -57.20000076293945
      ],
      [
        510.8215026855469,
        1062.5,
        -56.70000076293945
      ],
      [
        509.31024169921875,
        1063.800048828125,
        -57.20000076293945
      ],
      [
        471.384765625,
        1063.041748046875,
        -56.98911666870117
      ],
      [
        473.6935119628906,
        1062.73779296875,
        -56.70000076293945
      ],
      [
        471.384765625,
        1063.041748046875,
        -56.98911666870117
      ],
      [
        504.35162353515625,
        1062.5,
        -60.0
      ],
      [
        508.521728515625,
        1062.5,
        -60.0
      ],
      [
        510.3146057128906,
        1062.5,
        -57.900001525878906
      ],
      [
        510.3146057128906,
        1062.5,
        -57.900001525878906
      ],
      [
        475.5,
        1063.800048828125,
        -56.38921356201172
      ],
      [
        478.4091491699219,
        1063.800048828125,
        -56.0
      ],
      [
        509.52142333984375,
        1063.800048828125,
        -56.70000076293945
      ],
      [
        509.817138671875,
        1063.800048828125,
        -56.0
      ],
      [
        475.5,
        1063.800048828125,
        -56.38921356201172
      ],
      [
        504.35162353515625,
        1062.5,
        -56.0
      ],
      [
        511.1171875,
        1062.5,
        -56.0
      ],
      [
        557.7904663085938,
        1052.5948486328125,
        -46.108428955078125
      ],
      [
        561.8495483398438,
        1054.5682373046875,
        -45.43699645996094
      ],
      [
        562.7239990234375,
        1052.76953125,
        -45.43702697753906
      ],
      [
        561.8495483398438,
        1054.5682373046875,
        -45.43699645996094
      ],
      [
        557.7904663085938,
        1052.5948486328125,
        -46.108428955078125
      ],
      [
        558.6649169921875,
        1050.796142578125,
        -46.108428955078125
      ],
      [
        471.5,
        1042.2559814453125,
        -58.325706481933594
      ],
      [
        471.5,
        1047.2559814453125,
        -58.0004768371582
      ],
      [
        471.5,
        1047.2559814453125,
        -58.0004768371582
      ],
      [
        460.0517578125,
        1047.2559814453125,
        -59.53213882446289
      ],
      [
        455.4723205566406,
        1049.482421875,
        -60.0
      ],
      [
        460.0517578125,
        1047.2559814453125,
        -59.53213882446289
      ],
      [
        485.5653991699219,
        1042.2559814453125,
        -56.44389724731445
      ],
      [
        485.5653991699219,
        1044.0,
        -56.33045196533203
      ],
      [
        483.0,
        1044.0,
        -56.67368698120117
      ],
      [
        485.5653991699219,
        1044.0,
        -56.33045196533203
      ],
      [
        483.0,
        1044.0,
        -56.67368698120117
      ],
      [
        483.0,
        1042.2559814453125,
        -56.78712463378906
      ],
      [
        509.3999938964844,
        1061.6217041015625,
        -60.0
      ],
      [
        509.3999938964844,
        1062.5,
        -58.97128677368164
      ],
      [
        508.1000061035156,
        1058.7515869140625,
        -56.70000076293945
      ],
      [
        508.1000061035156,
        1058.7515869140625,
        -57.20000076293945
      ],
      [
        500.5653991699219,
        1044.0,
        -56.0
      ],
      [
        503.13079833984375,
        1044.0,
        -56.0
      ],
      [
        500.5653991699219,
        1044.0,
        -56.0
      ],
      [
        500.5653991699219,
        1042.2559814453125,
        -56.0
      ],
      [
        503.13079833984375,
        1042.2559814453125,
        -56.0
      ],
      [
        503.13079833984375,
        1044.0,
        -56.0
      ],
      [
        500.5653991699219,
        1044.0,
        -54.32361602783203
      ],
      [
        503.13079833984375,
        1044.0,
        -53.98038101196289
      ],
      [
        503.13079833984375,
        1042.2559814453125,
        -54.09382247924805
      ],
      [
        503.13079833984375,
        1044.0,
        -53.98038101196289
      ],
      [
        500.5653991699219,
        1044.0,
        -54.32361602783203
      ],
      [
        500.5653991699219,
        1042.2559814453125,
        -54.43705368041992
      ],
      [
        472.95770263671875,
        1068.912109375,
        -56.396827697753906
      ],
      [
        472.92340087890625,
        1068.7840576171875,
        -56.82561111450195
      ],
      [
        475.5,
        1068.6778564453125,
        -56.07194519042969
      ],
      [
        462.6883850097656,
        1068.162841796875,
        -57.81949234008789
      ],
      [
        472.92340087890625,
        1068.7840576171875,
        -56.82561111450195
      ],
      [
        472.95770263671875,
        1068.912109375,
        -56.396827697753906
      ],
      [
        472.6441345214844,
        1069.0306396484375,
        -56.43107223510742
      ],
      [
        459.03826904296875,
        1074.43310546875,
        -57.900001525878906
      ],
      [
        439.98992919921875,
        1081.32763671875,
        -60.0
      ],
      [
        441.997802734375,
        1077.19775390625,
        -60.0
      ],
      [
        470.5479736328125,
        1069.8228759765625,
        -56.65998840332031
      ],
      [
        459.03826904296875,
        1074.43310546875,
        -57.900001525878906
      ],
      [
        470.5479736328125,
        1069.8228759765625,
        -56.65998840332031
      ],
      [
        472.8503723144531,
        1068.511474609375,
        -57.73802185058594
      ],
      [
        472.8503723144531,
        1068.511474609375,
        -57.73802185058594
      ],
      [
        473.60797119140625,
        1068.6055908203125,
        -57.11106491088867
      ],
      [
        506.5,
        1156.4000244140625,
        -46.218563079833984
      ],
      [
        514.5,
        1146.4000244140625,
        -45.79868698120117
      ],
      [
        493.5,
        1156.4000244140625,
        -47.95780944824219
      ],
      [
        506.5,
        1156.4000244140625,
        -46.218563079833984
      ],
      [
        514.5,
        1136.4000244140625,
        -46.44913864135742
      ],
      [
        506.5,
        1126.4000244140625,
        -48.16991424560547
      ],
      [
        514.5,
        1146.4000244140625,
        -45.79868698120117
      ],
      [
        514.5,
        1136.4000244140625,
        -46.44913864135742
      ],
      [
        506.5,
        1126.4000244140625,
        -48.16991424560547
      ],
      [
        493.5,
        1126.4000244140625,
        -49.9091682434082
      ],
      [
        485.5,
        1146.4000244140625,
        -49.678585052490234
      ],
      [
        493.5,
        1156.4000244140625,
        -47.95780944824219
      ],
      [
        493.5,
        1126.4000244140625,
        -49.9091682434082
      ],
      [
        485.5,
        1136.4000244140625,
        -50.329036712646484
      ],
      [
        485.5,
        1136.4000244140625,
        -50.329036712646484
      ],
      [
        485.5,
        1146.4000244140625,
        -49.678585052490234
      ],
      [
        473.76385498046875,
        1068.56494140625,
        -57.176063537597656
      ],
      [
        499.0940856933594,
        1198.053955078125,
        -44.5
      ],
      [
        506.5,
        1195.8480224609375,
        -43.65266036987305
      ],
      [
        506.5,
        1198.053955078125,
        -43.50917434692383
      ],
      [
        506.5,
        1195.8480224609375,
        -43.65266036987305
      ],
      [
        493.5,
        1228.3656005859375,
        -43.0
      ],
      [
        495.1734313964844,
        1229.17919921875,
        -43.0
      ],
      [
        493.5,
        1228.3656005859375,
        -43.0
      ],
      [
        486.57757568359375,
        1225.0,
        -43.0
      ],
      [
        486.57757568359375,
        1225.0,
        -40.0
      ],
      [
        486.57757568359375,
        1225.0,
        -43.0
      ],
      [
        412.3741455078125,
        1225.0,
        -43.0
      ],
      [
        412.3741455078125,
        1225.0,
        -40.0
      ],
      [
        427.1334533691406,
        1218.9306640625,
        -43.0
      ],
      [
        427.1334533691406,
        1218.9306640625,
        -40.0
      ],
      [
        421.1961975097656,
        1230.837646484375,
        -43.0
      ],
      [
        421.1961975097656,
        1230.837646484375,
        -40.0
      ],
      [
        443.0001220703125,
        1239.9000244140625,
        -43.0
      ],
      [
        443.0000915527344,
        1239.9000244140625,
        -40.0
      ],
      [
        450.0,
        1297.4000244140625,
        -41.0
      ],
      [
        453.0,
        1297.4000244140625,
        -40.0
      ],
      [
        453.0,
        1297.4000244140625,
        -41.0
      ],
      [
        450.0,
        1297.4000244140625,
        -41.0
      ],
      [
        450.0,
        1298.4000244140625,
        -41.0
      ],
      [
        453.0,
        1297.4000244140625,
        -43.0
      ],
      [
        456.0,
        1297.4000244140625,
        -43.0
      ],
      [
        456.0,
        1297.4000244140625,
        -40.0
      ],
      [
        445.5,
        1296.4000244140625,
        -41.0
      ],
      [
        443.732177734375,
        1296.9857177734375,
        -41.0
      ],
      [
        443.732177734375,
        1296.9857177734375,
        -41.0
      ],
      [
        443.0000915527344,
        1298.4000244140625,
        -41.0
      ],
      [
        447.0,
        1296.89697265625,
        -43.0
      ],
      [
        445.5,
        1296.4000244140625,
        -41.0
      ],
      [
        447.0,
        1296.89697265625,
        -41.0
      ],
      [
        444.3732604980469,
        1271.0999755859375,
        -40.600006103515625
      ],
      [
        444.37322998046875,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        444.37322998046875,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        447.0,
        1296.89697265625,
        -40.0
      ],
      [
        467.267822265625,
        1296.9857177734375,
        -41.0
      ],
      [
        465.5,
        1296.4000244140625,
        -41.0
      ],
      [
        465.5,
        1296.4000244140625,
        -41.0
      ],
      [
        464.0,
        1296.89697265625,
        -42.765968322753906
      ],
      [
        464.0,
        1296.89697265625,
        -41.0
      ],
      [
        468.0,
        1298.4000244140625,
        -41.0
      ],
      [
        467.267822265625,
        1296.9857177734375,
        -41.0
      ],
      [
        466.62677001953125,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        466.6267395019531,
        1271.0999755859375,
        -40.600006103515625
      ],
      [
        466.62677001953125,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        464.0,
        1296.89697265625,
        -40.0
      ],
      [
        468.0,
        1239.9000244140625,
        -43.0
      ],
      [
        468.0,
        1239.9000244140625,
        -40.0
      ],
      [
        468.0,
        1260.4000244140625,
        -40.0
      ],
      [
        468.0,
        1260.4000244140625,
        -43.0
      ],
      [
        493.0,
        1239.9000244140625,
        -42.593448638916016
      ],
      [
        493.0,
        1239.9000244140625,
        -40.0
      ],
      [
        480.0,
        1297.4000244140625,
        -40.0
      ],
      [
        480.0,
        1297.4000244140625,
        -40.592620849609375
      ],
      [
        491.62677001953125,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        491.62677001953125,
        1271.0999755859375,
        -40.600006103515625
      ],
      [
        491.61968994140625,
        1271.753173828125,
        -40.70623779296875
      ],
      [
        491.62677001953125,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        470.5,
        1296.4000244140625,
        -41.0
      ],
      [
        468.732177734375,
        1296.9857177734375,
        -41.0
      ],
      [
        468.732177734375,
        1296.9857177734375,
        -41.0
      ],
      [
        468.0,
        1298.4000244140625,
        -41.0
      ],
      [
        472.0,
        1296.89697265625,
        -41.69565963745117
      ],
      [
        470.5,
        1296.4000244140625,
        -41.0
      ],
      [
        472.0,
        1296.89697265625,
        -41.0
      ],
      [
        469.37322998046875,
        1271.0999755859375,
        -40.600006103515625
      ],
      [
        469.37322998046875,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        469.37322998046875,
        1271.7000732421875,
        -40.600006103515625
      ],
      [
        472.0,
        1296.89697265625,
        -40.0
      ],
      [
        425.1593017578125,
        1063.7752685546875,
        -55.5
      ],
      [
        459.9596862792969,
        1046.85595703125,
        -55.5
      ],
      [
        458.9007263183594,
        1042.2559814453125,
        -55.5
      ],
      [
        470.3360595703125,
        1042.2559814453125,
        -58.48143005371094
      ],
      [
        470.3361511230469,
        1042.2559814453125,
        -56.700294494628906
      ],
      [
        469.4210510253906,
        1042.2559814453125,
        -55.5
      ],
      [
        488.7823791503906,
        1030.25,
        -55.5
      ],
      [
        493.6907043457031,
        1025.3416748046875,
        -55.5
      ],
      [
        488.7823791503906,
        1030.25,
        -55.5
      ],
      [
        487.9835510253906,
        1033.2313232421875,
        -55.5
      ],
      [
        487.8473815917969,
        1033.739501953125,
        -56.69255447387695
      ],
      [
        398.6940002441406,
        1077.0870361328125,
        -60.0
      ],
      [
        392.9727783203125,
        1074.30908203125,
        -55.5
      ],
      [
        398.2362060546875,
        1076.86474609375,
        -55.5
      ],
      [
        398.6939697265625,
        1077.0870361328125,
        -56.700172424316406
      ],
      [
        398.1219482421875,
        1077.3651123046875,
        -60.0
      ],
      [
        398.1219177246094,
        1077.3651123046875,
        -56.7000732421875
      ],
      [
        397.6641845703125,
        1077.142822265625,
        -55.5
      ],
      [
        392.4007263183594,
        1074.587158203125,
        -55.5
      ],
      [
        425.1593017578125,
        1063.7752685546875,
        -55.5
      ],
      [
        423.0706481933594,
        1059.6759033203125,
        -55.5
      ],
      [
        399.9525451660156,
        1077.6981201171875,
        -60.0
      ],
      [
        399.380615234375,
        1077.976318359375,
        -60.0
      ],
      [
        462.0110778808594,
        1047.2559814453125,
        -59.27000045776367
      ],
      [
        471.568359375,
        1042.2559814453125,
        -58.316558837890625
      ],
      [
        471.5,
        1042.2559814453125,
        -58.22688293457031
      ],
      [
        471.5,
        1042.291748046875,
        -58.32337951660156
      ],
      [
        472.9768371582031,
        1068.9835205078125,
        -56.0
      ],
      [
        475.5,
        1067.8817138671875,
        -56.0
      ],
      [
        472.9768371582031,
        1068.9835205078125,
        -56.0
      ],
      [
        421.788818359375,
        1084.6131591796875,
        -56.0
      ],
      [
        425.58245849609375,
        1082.95654296875,
        -56.0
      ],
      [
        425.58245849609375,
        1082.95654296875,
        -56.0
      ],
      [
        427.7278137207031,
        1082.0196533203125,
        -56.0
      ],
      [
        475.5,
        1067.8817138671875,
        -56.0
      ],
      [
        476.6740417480469,
        1067.3690185546875,
        -56.0
      ],
      [
        427.7273254394531,
        1082.02001953125,
        -57.20000076293945
      ],
      [
        468.20001220703125,
        1065.756103515625,
        -57.20000076293945
      ],
      [
        431.55902099609375,
        1081.756103515625,
        -57.20000076293945
      ],
      [
        430.33111572265625,
        1086.004638671875,
        -57.20000076293945
      ],
      [
        433.823486328125,
        1085.6783447265625,
        -57.20000076293945
      ],
      [
        424.625732421875,
        1086.527099609375,
        -57.20000076293945
      ],
      [
        430.33111572265625,
        1086.004638671875,
        -57.20000076293945
      ],
      [
        424.625732421875,
        1086.527099609375,
        -57.20000076293945
      ],
      [
        423.0268859863281,
        1085.48193359375,
        -56.418636322021484
      ],
      [
        423.2517395019531,
        1085.3836669921875,
        -57.20000076293945
      ],
      [
        422.9023132324219,
        1085.536376953125,
        -56.0
      ],
      [
        423.0268859863281,
        1085.48193359375,
        -56.418636322021484
      ],
      [
        468.20001220703125,
        1065.756103515625,
        -57.20000076293945
      ],
      [
        468.5616455078125,
        1065.6063232421875,
        -57.20000076293945
      ],
      [
        471.4625244140625,
        1064.33154296875,
        -56.70000076293945
      ],
      [
        471.7023010253906,
        1064.226806640625,
        -56.70000076293945
      ],
      [
        473.3110656738281,
        1063.5242919921875,
        -56.70000076293945
      ],
      [
        471.7023010253906,
        1064.226806640625,
        -56.70000076293945
      ],
      [
        402.6357116699219,
        1099.2969970703125,
        -57.20000076293945
      ],
      [
        402.3877868652344,
        1099.8076171875,
        -56.0
      ],
      [
        405.66192626953125,
        1093.0645751953125,
        -56.0
      ],
      [
        405.66192626953125,
        1093.0645751953125,
        -57.20000076293945
      ],
      [
        406.3673095703125,
        1092.756591796875,
        -56.0
      ],
      [
        403.09320068359375,
        1099.49951171875,
        -56.0
      ],
      [
        403.34112548828125,
        1098.9888916015625,
        -57.20000076293945
      ],
      [
        406.3672790527344,
        1092.756591796875,
        -57.20000076293945
      ],
      [
        427.7273254394531,
        1082.02001953125,
        -56.70000076293945
      ],
      [
        431.55902099609375,
        1081.756103515625,
        -56.70000076293945
      ],
      [
        431.55902099609375,
        1081.756103515625,
        -57.20000076293945
      ],
      [
        427.7278137207031,
        1082.0196533203125,
        -57.20000076293945
      ],
      [
        427.7278137207031,
        1082.0196533203125,
        -56.70000076293945
      ],
      [
        407.2356262207031,
        1090.96826171875,
        -57.20000076293945
      ],
      [
        407.2356262207031,
        1090.96826171875,
        -56.70000076293945
      ],
      [
        406.3672790527344,
        1092.756591796875,
        -56.70000076293945
      ],
      [
        406.5302429199219,
        1091.2762451171875,
        -56.70000076293945
      ],
      [
        406.5302429199219,
        1091.2762451171875,
        -57.20000076293945
      ],
      [
        405.66192626953125,
        1093.0645751953125,
        -56.70000076293945
      ],
      [
        422.0168762207031,
        1084.53857421875,
        -56.70000076293945
      ],
      [
        421.9986267089844,
        1084.521484375,
        -56.705081939697266
      ],
      [
        422.14111328125,
        1084.4593505859375,
        -57.20000076293945
      ],
      [
        423.10784912109375,
        1085.446533203125,
        -56.70000076293945
      ],
      [
        421.9971008300781,
        1084.5220947265625,
        -56.70000076293945
      ],
      [
        421.9986267089844,
        1084.521484375,
        -56.705081939697266
      ],
      [
        422.0168762207031,
        1084.53857421875,
        -56.70000076293945
      ],
      [
        427.7278137207031,
        1082.0196533203125,
        -56.0
      ],
      [
        407.2356262207031,
        1090.96826171875,
        -56.0
      ],
      [
        406.5302429199219,
        1091.2762451171875,
        -56.0
      ],
      [
        421.788818359375,
        1084.6131591796875,
        -56.0
      ],
      [
        424.67755126953125,
        1084.7611083984375,
        -60.0
      ],
      [
        423.6718444824219,
        1085.2001953125,
        -58.263404846191406
      ],
      [
        423.2517395019531,
        1085.3836669921875,
        -57.20000076293945
      ],
      [
        423.4454040527344,
        1085.299072265625,
        -57.872406005859375
      ],
      [
        423.4533386230469,
        1085.295654296875,
        -57.900001525878906
      ],
      [
        423.6718444824219,
        1085.2001953125,
        -58.263404846191406
      ],
      [
        423.4533386230469,
        1085.295654296875,
        -57.900001525878906
      ],
      [
        405.66192626953125,
        1093.0645751953125,
        -60.0
      ],
      [
        403.6573486328125,
        1097.1929931640625,
        -60.0
      ],
      [
        402.7803649902344,
        1098.9991455078125,
        -57.900115966796875
      ],
      [
        405.66192626953125,
        1093.0645751953125,
        -57.20000076293945
      ],
      [
        404.3627624511719,
        1096.8848876953125,
        -60.0
      ],
      [
        406.3673095703125,
        1092.756591796875,
        -60.0
      ],
      [
        406.3672790527344,
        1092.756591796875,
        -57.20000076293945
      ],
      [
        403.4858093261719,
        1098.69091796875,
        -57.90028762817383
      ],
      [
        403.2142333984375,
        1098.1055908203125,
        -60.0
      ],
      [
        403.9196472167969,
        1097.7974853515625,
        -60.0
      ],
      [
        427.7278137207031,
        1082.0196533203125,
        -60.0
      ],
      [
        407.2356262207031,
        1090.96826171875,
        -60.0
      ],
      [
        406.5302429199219,
        1091.2762451171875,
        -60.0
      ],
      [
        422.3426208496094,
        1084.371337890625,
        -57.900001525878906
      ],
      [
        422.7586975097656,
        1084.1895751953125,
        -58.59199905395508
      ],
      [
        422.3426208496094,
        1084.371337890625,
        -57.900001525878906
      ],
      [
        423.5740966796875,
        1083.83349609375,
        -60.0
      ],
      [
        422.7586975097656,
        1084.1895751953125,
        -58.59199905395508
      ],
      [
        402.28448486328125,
        1100.0203857421875,
        -55.5
      ],
      [
        406.5302429199219,
        1091.2762451171875,
        -55.5
      ],
      [
        407.2356262207031,
        1090.96826171875,
        -55.5
      ],
      [
        402.9898986816406,
        1099.7122802734375,
        -55.5
      ],
      [
        382.780517578125,
        1159.4000244140625,
        -55.5
      ],
      [
        401.2215881347656,
        1150.4459228515625,
        -55.5
      ],
      [
        400.9902038574219,
        1151.1141357421875,
        -55.5
      ],
      [
        382.9989013671875,
        1159.849853515625,
        -55.5
      ],
      [
        401.2215881347656,
        1150.4459228515625,
        -55.5
      ],
      [
        400.9902038574219,
        1151.1141357421875,
        -55.5
      ],
      [
        389.23297119140625,
        1126.9000244140625,
        -55.5
      ],
      [
        397.4873962402344,
        1109.9000244140625,
        -55.5
      ],
      [
        401.1290588378906,
        1102.4000244140625,
        -55.5
      ],
      [
        397.9371643066406,
        1110.118408203125,
        -55.5
      ],
      [
        389.6827392578125,
        1126.9000244140625,
        -55.5
      ],
      [
        397.4873962402344,
        1109.9000244140625,
        -55.5
      ],
      [
        397.9371643066406,
        1110.118408203125,
        -55.5
      ],
      [
        397.93719482421875,
        1110.118408203125,
        -60.0
      ],
      [
        397.93719482421875,
        1110.118408203125,
        -55.72500228881836
      ],
      [
        389.4563903808594,
        1127.360107421875,
        -60.0
      ],
      [
        389.4563903808594,
        1127.360107421875,
        -55.5
      ],
      [
        389.23297119140625,
        1126.9000244140625,
        -55.5
      ],
      [
        401.5788269042969,
        1102.618408203125,
        -55.5
      ],
      [
        401.1290588378906,
        1102.4000244140625,
        -55.5
      ],
      [
        401.6170654296875,
        1102.636962890625,
        -55.744117736816406
      ],
      [
        401.6170654296875,
        1102.636962890625,
        -60.0
      ],
      [
        401.5788269042969,
        1102.618408203125,
        -55.5
      ],
      [
        397.93719482421875,
        1110.118408203125,
        -55.72500228881836
      ],
      [
        401.6170654296875,
        1102.636962890625,
        -55.744117736816406
      ],
      [
        393.5671691894531,
        1134.681640625,
        -55.5
      ],
      [
        393.1174011230469,
        1134.9000244140625,
        -55.5
      ],
      [
        396.51629638671875,
        1141.9000244140625,
        -55.5
      ],
      [
        396.966064453125,
        1141.681640625,
        -55.5
      ],
      [
        396.966064453125,
        1141.681640625,
        -55.5
      ],
      [
        401.2215881347656,
        1150.4459228515625,
        -55.5
      ],
      [
        400.7718200683594,
        1150.664306640625,
        -55.5
      ],
      [
        396.51629638671875,
        1141.9000244140625,
        -55.5
      ],
      [
        389.6827392578125,
        1126.9000244140625,
        -55.5
      ],
      [
        393.5671691894531,
        1134.681640625,
        -55.5
      ],
      [
        393.1174011230469,
        1134.9000244140625,
        -55.5
      ],
      [
        485.5653991699219,
        1042.2559814453125,
        -55.5
      ],
      [
        485.5653991699219,
        1042.2559814453125,
        -55.5
      ],
      [
        410.841796875,
        1083.541259765625,
        -55.5
      ],
      [
        410.61041259765625,
        1082.873046875,
        -55.5
      ],
      [
        410.61041259765625,
        1082.873046875,
        -55.5
      ],
      [
        410.841796875,
        1083.541259765625,
        -55.5
      ],
      [
        459.9596862792969,
        1046.85595703125,
        -55.5
      ],
      [
        471.5,
        1046.85595703125,
        -55.5
      ],
      [
        471.5,
        1042.2559814453125,
        -55.5
      ],
      [
        471.5,
        1046.85595703125,
        -55.5
      ],
      [
        483.0,
        1044.0,
        -55.5
      ],
      [
        485.5653991699219,
        1044.0,
        -55.5
      ],
      [
        483.0,
        1044.0,
        -55.5
      ],
      [
        483.0,
        1042.2559814453125,
        -55.5
      ],
      [
        485.5653991699219,
        1042.2559814453125,
        -55.5
      ],
      [
        485.5653991699219,
        1044.0,
        -55.5
      ],
      [
        410.39202880859375,
        1083.3228759765625,
        -55.5
      ],
      [
        410.841796875,
        1083.541259765625,
        -55.5
      ],
      [
        568.0809936523438,
        1042.2559814453125,
        -44.0
      ],
      [
        571.5,
        1042.2559814453125,
        -44.0
      ],
      [
        568.0809936523438,
        1042.2559814453125,
        -44.0
      ],
      [
        568.0809936523438,
        1042.2559814453125,
        -45.404170989990234
      ],
      [
        495.5047912597656,
        1036.884033203125,
        -47.04999923706055
      ],
      [
        494.96612548828125,
        1037.0283203125,
        -47.5
      ],
      [
        494.96612548828125,
        1037.0283203125,
        -47.5
      ],
      [
        493.8887634277344,
        1037.3170166015625,
        -47.5
      ],
      [
        520.3659057617188,
        1022.2225341796875,
        -47.5
      ],
      [
        465.76171875,
        1042.2559814453125,
        -50.70000076293945
      ],
      [
        392.9727783203125,
        1074.30908203125,
        -50.70000076293945
      ],
      [
        396.4053039550781,
        1075.975830078125,
        -50.70000076293945
      ],
      [
        398.2362060546875,
        1076.86474609375,
        -55.5
      ],
      [
        392.4007263183594,
        1074.587158203125,
        -50.70000076293945
      ],
      [
        397.6641845703125,
        1077.142822265625,
        -55.5
      ],
      [
        395.833251953125,
        1076.25390625,
        -50.70000076293945
      ],
      [
        395.94757080078125,
        1075.7535400390625,
        -49.5
      ],
      [
        395.3755187988281,
        1076.0316162109375,
        -49.5
      ],
      [
        395.3755187988281,
        1076.0316162109375,
        -49.5
      ],
      [
        395.94757080078125,
        1075.7535400390625,
        -49.5
      ],
      [
        389.7365417480469,
        1127.0078125,
        -49.5
      ],
      [
        389.5108947753906,
        1127.472412109375,
        -49.5
      ],
      [
        410.39202880859375,
        1083.3228759765625,
        -49.5
      ],
      [
        410.39202880859375,
        1083.3228759765625,
        -49.5
      ],
      [
        410.39202880859375,
        1083.3228759765625,
        -55.5
      ],
      [
        389.4564208984375,
        1127.3602294921875,
        -49.5
      ],
      [
        389.4564208984375,
        1127.3602294921875,
        -55.5
      ],
      [
        389.5108947753906,
        1127.472412109375,
        -49.5
      ],
      [
        389.5108947753906,
        1127.472412109375,
        -55.5
      ],
      [
        389.7365417480469,
        1127.0078125,
        -49.5
      ],
      [
        389.7365417480469,
        1127.0078125,
        -55.5
      ],
      [
        387.75,
        1149.1500244140625,
        -55.5
      ],
      [
        388.25,
        1149.1500244140625,
        -55.5
      ],
      [
        386.25,
        1147.1500244140625,
        -55.5
      ],
      [
        389.75,
        1147.1500244140625,
        -55.5
      ],
      [
        387.75,
        1109.6500244140625,
        -55.5
      ],
      [
        387.75,
        1109.1500244140625,
        -55.5
      ],
      [
        385.75,
        1111.1500244140625,
        -55.5
      ],
      [
        385.75,
        1107.6500244140625,
        -55.5
      ],
      [
        396.75,
        1087.1500244140625,
        -54.16667175292969
      ],
      [
        396.25,
        1087.1500244140625,
        -54.16667175292969
      ],
      [
        380.75,
        1129.1500244140625,
        -55.5
      ],
      [
        380.75,
        1128.6500244140625,
        -55.5
      ],
      [
        378.75,
        1130.6500244140625,
        -55.5
      ],
      [
        378.75,
        1127.1500244140625,
        -55.5
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -70.0
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -70.0
      ],
      [
        558.0,
        1004.9035034179688,
        -70.0
      ],
      [
        552.0,
        1004.9035034179688,
        -70.0
      ],
      [
        558.0,
        1000.0,
        -70.0
      ],
      [
        552.0,
        1000.0,
        -70.0
      ],
      [
        558.0,
        1004.9035034179688,
        -70.0
      ],
      [
        558.0,
        1000.0,
        -70.0
      ],
      [
        552.0,
        1000.0,
        -70.0
      ],
      [
        552.0,
        1004.9035034179688,
        -70.0
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -70.0
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -70.0
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -70.0
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -70.0
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -70.0
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -70.0
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -75.0
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -75.0
      ],
      [
        613.9696044921875,
        974.6000366210938,
        -75.0
      ],
      [
        613.9696044921875,
        990.0000610351562,
        -75.0
      ],
      [
        597.9696044921875,
        990.0000610351562,
        -75.0
      ],
      [
        597.9696044921875,
        974.6000366210938,
        -75.0
      ],
      [
        558.0,
        1004.9035034179688,
        -75.0
      ],
      [
        552.0,
        1004.9035034179688,
        -75.0
      ],
      [
        558.0,
        1000.0,
        -75.0
      ],
      [
        552.0,
        1000.0,
        -75.0
      ],
      [
        558.0,
        1004.9035034179688,
        -75.0
      ],
      [
        558.0,
        1000.0,
        -75.0
      ],
      [
        552.0,
        1000.0,
        -75.0
      ],
      [
        552.0,
        1004.9035034179688,
        -75.0
      ],
      [
        537.6188354492188,
        1072.612548828125,
        -86.0
      ],
      [
        572.8811645507812,
        1072.612548828125,
        -86.0
      ],
      [
        537.6188354492188,
        1072.612548828125,
        -86.0
      ],
      [
        537.6188354492188,
        1072.612548828125,
        -90.0
      ],
      [
        572.8811645507812,
        1072.612548828125,
        -86.0
      ],
      [
        572.8811645507812,
        1072.612548828125,
        -90.0
      ],
      [
        558.0,
        1000.0,
        -86.19999694824219
      ],
      [
        558.0,
        1000.0,
        -85.69999694824219
      ],
      [
        552.0,
        1000.0,
        -85.69999694824219
      ],
      [
        552.0,
        1000.0,
        -86.19999694824219
      ],
      [
        558.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      [
        558.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      [
        558.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      [
        558.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      [
        558.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      [
        558.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      [
        558.0,
        1000.0,
        -85.69999694824219
      ],
      [
        558.0,
        1000.0,
        -86.19999694824219
      ],
      [
        558.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      [
        558.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      [
        562.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      [
        562.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      [
        558.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      [
        558.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      [
        560.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      [
        560.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      [
        560.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      [
        560.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      [
        560.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      [
        560.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      [
        552.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      [
        552.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      [
        552.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      [
        552.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      [
        552.0,
        1000.0,
        -86.19999694824219
      ],
      [
        552.0,
        1000.0,
        -85.69999694824219
      ],
      [
        552.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      [
        552.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      [
        552.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      [
        552.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      [
        548.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      [
        548.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      [
        552.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      [
        552.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      [
        550.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      [
        550.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      [
        550.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      [
        550.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      [
        550.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      [
        550.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      [
        548.0,
        1004.9035034179688,
        -76.78352355957031
      ],
      [
        562.0,
        1004.9035034179688,
        -77.28077697753906
      ],
      [
        562.0,
        1004.9035034179688,
        -75.0
      ],
      [
        548.0,
        1004.9035034179688,
        -75.0
      ],
      [
        548.0,
        1004.9035034179688,
        -76.78352355957031
      ],
      [
        562.0,
        1004.9035034179688,
        -77.28077697753906
      ],
      [
        548.0,
        1004.9035034179688,
        -89.28659057617188
      ],
      [
        562.0,
        1004.9035034179688,
        -89.08768463134766
      ],
      [
        562.0,
        1004.9035034179688,
        -89.08768463134766
      ],
      [
        548.0,
        1004.9035034179688,
        -89.28659057617188
      ],
      [
        548.0,
        1004.9035034179688,
        -90.0
      ],
      [
        562.0,
        1004.9035034179688,
        -90.0
      ],
      [
        553.5,
        1005.8999633789062,
        -88.79999542236328
      ],
      [
        553.5,
        1005.8999633789062,
        -90.0
      ],
      [
        556.5,
        1005.8999633789062,
        -90.0
      ],
      [
        556.5,
        1005.8999633789062,
        -88.79999542236328
      ],
      [
        556.5,
        1005.8999633789062,
        -87.0
      ],
      [
        553.5,
        1005.8999633789062,
        -87.0
      ],
      [
        556.5,
        1004.9035034179688,
        -87.0
      ],
      [
        553.5,
        1004.9035034179688,
        -87.0
      ],
      [
        553.5,
        1005.8999633789062,
        -87.0
      ],
      [
        556.5,
        1005.8999633789062,
        -87.0
      ],
      [
        600.9696044921875,
        974.6000366210938,
        -90.0
      ],
      [
        600.9696044921875,
        974.6000366210938,
        -75.0
      ],
      [
        600.9696044921875,
        990.0000610351562,
        -75.0
      ],
      [
        610.9696044921875,
        974.6000366210938,
        -90.0
      ],
      [
        610.9696044921875,
        974.6000366210938,
        -75.0
      ],
      [
        610.9696044921875,
        990.0000610351562,
        -75.0
      ],
      [
        610.9696044921875,
        974.6000366210938,
        -79.0
      ],
      [
        600.9696044921875,
        974.6000366210938,
        -79.0
      ],
      [
        584.9406127929688,
        1050.0,
        -75.0
      ],
      [
        584.9403686523438,
        1050.0,
        -90.0
      ],
      [
        582.5,
        1069.699951171875,
        -78.0
      ],
      [
        582.5,
        1069.699951171875,
        -87.0
      ],
      [
        582.5,
        1069.699951171875,
        -78.0
      ],
      [
        582.5,
        1069.699951171875,
        -87.0
      ],
      [
        582.5,
        1023.699951171875,
        -78.0
      ],
      [
        582.5,
        1023.699951171875,
        -87.0
      ],
      [
        582.5,
        1023.699951171875,
        -78.0
      ],
      [
        582.5,
        1023.699951171875,
        -87.0
      ],
      [
        618.1246948242188,
        1041.4000244140625,
        -87.60000610351562
      ],
      [
        618.124755859375,
        1040.7999267578125,
        -87.60000610351562
      ],
      [
        618.0980224609375,
        1041.5999755859375,
        -88.0
      ],
      [
        618.1246948242188,
        1041.4000244140625,
        -87.60000610351562
      ],
      [
        618.124755859375,
        1040.7999267578125,
        -87.60000610351562
      ],
      [
        618.1246948242188,
        1066.9000244140625,
        -87.60000610351562
      ],
      [
        618.124755859375,
        1066.2999267578125,
        -87.60000610351562
      ],
      [
        618.0980224609375,
        1067.0999755859375,
        -88.0
      ],
      [
        618.1246948242188,
        1066.9000244140625,
        -87.60000610351562
      ],
      [
        618.124755859375,
        1066.2999267578125,
        -87.60000610351562
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -20.0,
      "bbox_min": [
        330.0,
        715.0,
        -90.0
      ],
      "bbox_max": [
        750.0,
        1298.4000244140625,
        120.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": -715.989013671875,
      "bbox_min": [
        481.4007873535156,
        792.0,
        48.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7254803776741028,
        -0.6882427930831909
      ],
      "plane_d": -563.4954223632812,
      "bbox_min": [
        505.3768005371094,
        792.0,
        48.0
      ],
      "bbox_max": [
        573.5927734375,
        827.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 84.0,
      "bbox_min": [
        521.5,
        792.0,
        48.0
      ],
      "bbox_max": [
        557.5,
        818.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        48.0
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -799.7999877929688,
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        48.0
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -532.1715698242188,
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        48.0
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 546.313720703125,
      "bbox_min": [
        546.313720703125,
        799.7999877929688,
        48.0
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6891108751296997,
        0.7246559858322144,
        0.0
      ],
      "plane_d": -204.02142333984375,
      "bbox_min": [
        505.3768005371094,
        822.2566528320312,
        48.0
      ],
      "bbox_max": [
        573.5927734375,
        827.0,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6891113519668579,
        0.7246554493904114,
        0.0
      ],
      "plane_d": -947.5509643554688,
      "bbox_min": [
        505.3768005371094,
        822.2566528320312,
        48.0
      ],
      "bbox_max": [
        510.36480712890625,
        827.0,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 65.0,
      "bbox_min": [
        481.4007873535156,
        824.5,
        48.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 597.5687866210938,
      "bbox_min": [
        481.4007873535156,
        824.5,
        48.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -481.4007873535156,
      "bbox_min": [
        481.4007873535156,
        824.5,
        48.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 53.0,
      "bbox_min": [
        481.4007873535156,
        824.5,
        48.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        65.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -428.3204040527344,
      "bbox_min": [
        505.3768005371094,
        827.0,
        53.0
      ],
      "bbox_max": [
        573.5927734375,
        887.919921875,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271206855774,
        -0.0,
        -0.4472135603427887
      ],
      "plane_d": 536.7392578125,
      "bbox_min": [
        505.3768005371094,
        827.0,
        53.0
      ],
      "bbox_max": [
        573.5927734375,
        887.919921875,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324558258056641,
        -0.6324548721313477,
        -0.4472140967845917
      ],
      "plane_d": 253.00662231445312,
      "bbox_min": [
        505.3768005371094,
        844.7000122070312,
        53.0
      ],
      "bbox_max": [
        573.5927734375,
        887.919921875,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324564218521118,
        -0.632454514503479,
        -0.4472137689590454
      ],
      "plane_d": 935.4072265625,
      "bbox_min": [
        525.3568115234375,
        844.7000122070312,
        53.0
      ],
      "bbox_max": [
        573.5927734375,
        887.919921875,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 817.8820190429688,
      "bbox_min": [
        525.3568115234375,
        844.7000122070312,
        53.0
      ],
      "bbox_max": [
        553.61279296875,
        887.919921875,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 54.91998291015625,
      "bbox_min": [
        528.7000122070312,
        844.7000122070312,
        53.0
      ],
      "bbox_max": [
        550.2999877929688,
        866.2999877929688,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 547.4199829101562,
      "bbox_min": [
        528.7000122070312,
        844.7000122070312,
        54.91998291015625
      ],
      "bbox_max": [
        550.2999877929688,
        866.2999877929688,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -550.2999877929688,
      "bbox_min": [
        547.4199829101562,
        853.3400268554688,
        54.91998291015625
      ],
      "bbox_max": [
        550.2999877929688,
        857.6599731445312,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 853.3400268554688,
      "bbox_min": [
        547.4199829101562,
        853.3400268554688,
        54.91998291015625
      ],
      "bbox_max": [
        550.2999877929688,
        857.6599731445312,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -857.6599731445312,
      "bbox_min": [
        547.4199829101562,
        857.6599731445312,
        54.91998291015625
      ],
      "bbox_max": [
        550.2999877929688,
        857.6599731445312,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 854.780029296875,
      "bbox_min": [
        528.7000122070312,
        844.7000122070312,
        54.91998291015625
      ],
      "bbox_max": [
        547.4199829101562,
        866.2999877929688,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -856.219970703125,
      "bbox_min": [
        528.7000122070312,
        854.780029296875,
        54.91998291015625
      ],
      "bbox_max": [
        547.4199829101562,
        866.2999877929688,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.780029296875,
      "bbox_min": [
        528.7000122070312,
        854.780029296875,
        54.91998291015625
      ],
      "bbox_max": [
        540.219970703125,
        856.219970703125,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -540.219970703125,
      "bbox_min": [
        540.219970703125,
        854.780029296875,
        54.91998291015625
      ],
      "bbox_max": [
        540.219970703125,
        856.219970703125,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 528.7000122070312,
      "bbox_min": [
        528.7000122070312,
        854.780029296875,
        54.91998291015625
      ],
      "bbox_max": [
        531.5800170898438,
        856.219970703125,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -531.5800170898438,
      "bbox_min": [
        531.5800170898438,
        854.780029296875,
        54.91998291015625
      ],
      "bbox_max": [
        531.5800170898438,
        856.219970703125,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 863.4199829101562,
      "bbox_min": [
        528.7000122070312,
        856.219970703125,
        54.91998291015625
      ],
      "bbox_max": [
        541.6599731445312,
        866.2999877929688,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -866.2999877929688,
      "bbox_min": [
        537.3400268554688,
        863.4199829101562,
        54.91998291015625
      ],
      "bbox_max": [
        541.6599731445312,
        866.2999877929688,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -541.6599731445312,
      "bbox_min": [
        537.3400268554688,
        863.4199829101562,
        54.91998291015625
      ],
      "bbox_max": [
        541.6599731445312,
        866.2999877929688,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 537.3400268554688,
      "bbox_min": [
        537.3400268554688,
        863.4199829101562,
        54.91998291015625
      ],
      "bbox_max": [
        537.3400268554688,
        866.2999877929688,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.780029296875,
      "bbox_min": [
        528.7000122070312,
        856.219970703125,
        54.91998291015625
      ],
      "bbox_max": [
        540.219970703125,
        863.4199829101562,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -540.219970703125,
      "bbox_min": [
        540.219970703125,
        856.219970703125,
        54.91998291015625
      ],
      "bbox_max": [
        540.219970703125,
        863.4199829101562,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -857.6599731445312,
      "bbox_min": [
        528.7000122070312,
        856.219970703125,
        54.91998291015625
      ],
      "bbox_max": [
        531.5800170898438,
        857.6599731445312,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 528.7000122070312,
      "bbox_min": [
        528.7000122070312,
        856.219970703125,
        54.91998291015625
      ],
      "bbox_max": [
        531.5800170898438,
        857.6599731445312,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -531.5800170898438,
      "bbox_min": [
        531.5800170898438,
        856.219970703125,
        54.91998291015625
      ],
      "bbox_max": [
        531.5800170898438,
        857.6599731445312,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -847.5800170898438,
      "bbox_min": [
        528.7000122070312,
        844.7000122070312,
        54.91998291015625
      ],
      "bbox_max": [
        541.6599731445312,
        854.780029296875,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 844.7000122070312,
      "bbox_min": [
        537.3400268554688,
        844.7000122070312,
        54.91998291015625
      ],
      "bbox_max": [
        541.6599731445312,
        847.5800170898438,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -541.6599731445312,
      "bbox_min": [
        537.3400268554688,
        844.7000122070312,
        54.91998291015625
      ],
      "bbox_max": [
        541.6599731445312,
        847.5800170898438,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 537.3400268554688,
      "bbox_min": [
        537.3400268554688,
        844.7000122070312,
        54.91998291015625
      ],
      "bbox_max": [
        537.3400268554688,
        847.5800170898438,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.780029296875,
      "bbox_min": [
        528.7000122070312,
        847.5800170898438,
        54.91998291015625
      ],
      "bbox_max": [
        540.219970703125,
        854.780029296875,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -540.219970703125,
      "bbox_min": [
        540.219970703125,
        847.5800170898438,
        54.91998291015625
      ],
      "bbox_max": [
        540.219970703125,
        854.780029296875,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 853.3400268554688,
      "bbox_min": [
        528.7000122070312,
        853.3400268554688,
        54.91998291015625
      ],
      "bbox_max": [
        531.5800170898438,
        854.780029296875,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 528.7000122070312,
      "bbox_min": [
        528.7000122070312,
        853.3400268554688,
        54.91998291015625
      ],
      "bbox_max": [
        531.5800170898438,
        854.780029296875,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -531.5800170898438,
      "bbox_min": [
        531.5800170898438,
        853.3400268554688,
        54.91998291015625
      ],
      "bbox_max": [
        531.5800170898438,
        854.780029296875,
        56.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 547.419921875,
      "bbox_min": [
        528.7000122070312,
        844.7000122070312,
        53.0
      ],
      "bbox_max": [
        550.2999877929688,
        866.2999877929688,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8898183703422546,
        0.0,
        -0.4563150107860565
      ],
      "plane_d": -464.6062316894531,
      "bbox_min": [
        547.4199829101562,
        853.3400268554688,
        53.0
      ],
      "bbox_max": [
        550.2999877929688,
        857.6599731445312,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486989378929138,
        -0.3161810040473938
      ],
      "plane_d": -796.2965087890625,
      "bbox_min": [
        547.4199829101562,
        853.3400268554688,
        53.0
      ],
      "bbox_max": [
        550.2999877929688,
        857.6599731445312,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486989378929138,
        -0.3161810040473938
      ],
      "plane_d": 826.927490234375,
      "bbox_min": [
        547.4199829101562,
        853.3400268554688,
        53.0
      ],
      "bbox_max": [
        550.2999877929688,
        853.9799194335938,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 863.419921875,
      "bbox_min": [
        528.7000122070312,
        844.7000122070312,
        53.0
      ],
      "bbox_max": [
        541.6599731445312,
        866.2999877929688,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8898183703422546,
        -0.4563150107860565
      ],
      "plane_d": -745.7888793945312,
      "bbox_min": [
        537.3400268554688,
        863.4199829101562,
        53.0
      ],
      "bbox_max": [
        541.6599731445312,
        866.2999877929688,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486989378929138,
        0.0,
        -0.3161810040473938
      ],
      "plane_d": 527.1385498046875,
      "bbox_min": [
        537.3400268554688,
        863.4199829101562,
        53.0
      ],
      "bbox_max": [
        541.6599731445312,
        866.2999877929688,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486989378929138,
        0.0,
        -0.3161810040473938
      ],
      "plane_d": -496.5075988769531,
      "bbox_min": [
        541.0200805664062,
        863.4199829101562,
        53.0
      ],
      "bbox_max": [
        541.6599731445312,
        866.2999877929688,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -531.5799560546875,
      "bbox_min": [
        528.7000122070312,
        844.7000122070312,
        53.0
      ],
      "bbox_max": [
        541.6599731445312,
        857.6599731445312,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8898183703422546,
        0.0,
        -0.4563150107860565
      ],
      "plane_d": 495.5078125,
      "bbox_min": [
        528.7000122070312,
        853.3400268554688,
        53.0
      ],
      "bbox_max": [
        531.5800170898438,
        857.6599731445312,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486989378929138,
        -0.3161810040473938
      ],
      "plane_d": -796.2965087890625,
      "bbox_min": [
        528.7000122070312,
        853.3400268554688,
        53.0
      ],
      "bbox_max": [
        531.5800170898438,
        857.6599731445312,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9486989378929138,
        -0.3161810040473938
      ],
      "plane_d": 826.927490234375,
      "bbox_min": [
        528.7000122070312,
        853.3400268554688,
        53.0
      ],
      "bbox_max": [
        531.5800170898438,
        853.9799194335938,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8898183703422546,
        -0.4563150107860565
      ],
      "plane_d": 776.6903686523438,
      "bbox_min": [
        537.3400268554688,
        844.7000122070312,
        53.0
      ],
      "bbox_max": [
        541.6599731445312,
        847.5800170898438,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -847.5799560546875,
      "bbox_min": [
        537.3400268554688,
        844.7000122070312,
        53.0
      ],
      "bbox_max": [
        541.6599731445312,
        847.5800170898438,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486989378929138,
        0.0,
        -0.3161810040473938
      ],
      "plane_d": 527.1385498046875,
      "bbox_min": [
        537.3400268554688,
        844.7000122070312,
        53.0
      ],
      "bbox_max": [
        541.6599731445312,
        847.5800170898438,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486989378929138,
        0.0,
        -0.3161810040473938
      ],
      "plane_d": -496.5075988769531,
      "bbox_min": [
        541.0200805664062,
        844.7000122070312,
        53.0
      ],
      "bbox_max": [
        541.6599731445312,
        847.5800170898438,
        54.91998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 911.8958740234375,
      "bbox_min": [
        481.4007873535156,
        824.5,
        48.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071056962013245,
        -0.7071078419685364,
        1.5413704659295036e-06
      ],
      "plane_d": 1043.2939453125,
      "bbox_min": [
        481.4007873535156,
        824.5,
        48.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        -7.706853466515895e-07
      ],
      "plane_d": 280.346923828125,
      "bbox_min": [
        481.4007873535156,
        824.5,
        48.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        481.4007873535156,
        824.5,
        48.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        53.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6891108751296997,
        0.7246559858322144,
        0.0
      ],
      "plane_d": -204.02142333984375,
      "bbox_min": [
        505.3768005371094,
        824.5,
        48.0
      ],
      "bbox_max": [
        573.5927734375,
        827.0,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6891113519668579,
        0.7246554493904114,
        0.0
      ],
      "plane_d": -947.5509643554688,
      "bbox_min": [
        505.3768005371094,
        824.5,
        48.0
      ],
      "bbox_max": [
        508.0057373046875,
        827.0,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238793253898621,
        -0.3826841115951538,
        7.159964638958627e-07
      ],
      "plane_d": -112.609375,
      "bbox_min": [
        481.4007873535156,
        845.6846313476562,
        48.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238811135292053,
        -0.38267987966537476,
        -3.244017250381148e-07
      ],
      "plane_d": 884.2257080078125,
      "bbox_min": [
        508.4031982421875,
        845.6846313476562,
        48.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        508.4031982421875,
        845.6846313476562,
        48.0
      ],
      "bbox_max": [
        570.56640625,
        911.8958740234375,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        529.6846313476562,
        845.6846313476562,
        48.0
      ],
      "bbox_max": [
        570.56640625,
        911.8958740234375,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486989378929138,
        -0.3161810040473938
      ],
      "plane_d": -796.2965087890625,
      "bbox_min": [
        529.6846313476562,
        845.6846313476562,
        49.30394744873047
      ],
      "bbox_max": [
        549.3153686523438,
        865.3153686523438,
        53.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9486989378929138,
        -0.3161810040473938
      ],
      "plane_d": 826.927490234375,
      "bbox_min": [
        529.6846313476562,
        845.6846313476562,
        49.30394744873047
      ],
      "bbox_max": [
        549.3153686523438,
        857.0200805664062,
        53.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8898183703422546,
        0.0,
        -0.4563150107860565
      ],
      "plane_d": -464.6062316894531,
      "bbox_min": [
        529.6846313476562,
        853.9799194335938,
        49.30394744873047
      ],
      "bbox_max": [
        549.3153686523438,
        857.0200805664062,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8898183703422546,
        0.0,
        -0.4563150107860565
      ],
      "plane_d": 495.5078125,
      "bbox_min": [
        529.6846313476562,
        853.9799194335938,
        49.30394744873047
      ],
      "bbox_max": [
        547.4199829101562,
        857.0200805664062,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 547.419921875,
      "bbox_min": [
        531.5800170898438,
        853.9799194335938,
        49.30394744873047
      ],
      "bbox_max": [
        547.4199829101562,
        857.0200805664062,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -531.5799560546875,
      "bbox_min": [
        531.5800170898438,
        853.9799194335938,
        49.30394744873047
      ],
      "bbox_max": [
        531.5800170898438,
        857.0200805664062,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8898183703422546,
        -0.4563150107860565
      ],
      "plane_d": 776.6903686523438,
      "bbox_min": [
        537.9799194335938,
        845.6846313476562,
        49.30394744873047
      ],
      "bbox_max": [
        541.0200805664062,
        847.5800170898438,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -847.5799560546875,
      "bbox_min": [
        537.9799194335938,
        845.6846313476562,
        49.30394744873047
      ],
      "bbox_max": [
        541.0200805664062,
        847.5800170898438,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486989378929138,
        0.0,
        -0.3161810040473938
      ],
      "plane_d": 527.1385498046875,
      "bbox_min": [
        537.9799194335938,
        845.6846313476562,
        49.30394744873047
      ],
      "bbox_max": [
        541.0200805664062,
        847.5800170898438,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486989378929138,
        0.0,
        -0.3161810040473938
      ],
      "plane_d": -496.5075988769531,
      "bbox_min": [
        539.7882690429688,
        845.6846313476562,
        49.30394744873047
      ],
      "bbox_max": [
        541.0200805664062,
        847.5800170898438,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8898183703422546,
        -0.4563150107860565
      ],
      "plane_d": -745.7888793945312,
      "bbox_min": [
        537.9799194335938,
        863.4199829101562,
        49.30394744873047
      ],
      "bbox_max": [
        541.0200805664062,
        865.3153686523438,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 863.419921875,
      "bbox_min": [
        537.9799194335938,
        863.4199829101562,
        49.30394744873047
      ],
      "bbox_max": [
        541.0200805664062,
        865.3153686523438,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486989378929138,
        0.0,
        -0.3161810040473938
      ],
      "plane_d": 527.1385498046875,
      "bbox_min": [
        537.9799194335938,
        863.4199829101562,
        49.30394744873047
      ],
      "bbox_max": [
        541.0200805664062,
        865.3153686523438,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486989378929138,
        0.0,
        -0.3161810040473938
      ],
      "plane_d": -496.5075988769531,
      "bbox_min": [
        539.7882690429688,
        863.4199829101562,
        49.30394744873047
      ],
      "bbox_max": [
        541.0200805664062,
        865.3153686523438,
        53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        367.0,
        715.0,
        -20.0
      ],
      "bbox_max": [
        633.0,
        1294.4000244140625,
        48.0
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 30.0,
      "bbox_min": [
        403.67474365234375,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        597.5687866210938,
        1181.5440673828125,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7254803776741028,
        -0.6882427930831909
      ],
      "plane_d": -563.4954223632812,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        30.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -799.7999877929688,
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        30.0
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        30.0
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -532.1715698242188,
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        30.0
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -481.4007873535156,
      "bbox_min": [
        481.4007873535156,
        805.1805419921875,
        30.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 911.8958740234375,
      "bbox_min": [
        481.4007873535156,
        805.1805419921875,
        30.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071056962013245,
        -0.7071078419685364,
        1.5413704659295036e-06
      ],
      "plane_d": 1043.2939453125,
      "bbox_min": [
        481.4007873535156,
        805.1805419921875,
        30.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        -7.706853466515895e-07
      ],
      "plane_d": 280.346923828125,
      "bbox_min": [
        481.4007873535156,
        805.1805419921875,
        30.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        481.4007873535156,
        805.1805419921875,
        30.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        48.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6891113519668579,
        0.7246554493904114,
        0.0
      ],
      "plane_d": -947.5509643554688,
      "bbox_min": [
        505.3768005371094,
        805.1805419921875,
        30.0
      ],
      "bbox_max": [
        573.5927734375,
        827.0,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6891108751296997,
        0.7246559858322144,
        0.0
      ],
      "plane_d": -204.02142333984375,
      "bbox_min": [
        525.3568115234375,
        805.1805419921875,
        30.0
      ],
      "bbox_max": [
        573.5927734375,
        827.0,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -807.9999389648438,
      "bbox_min": [
        525.3568115234375,
        805.1805419921875,
        30.0
      ],
      "bbox_max": [
        553.61279296875,
        808.0,
        32.972023010253906
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 546.313720703125,
      "bbox_min": [
        532.1715698242188,
        805.1805419921875,
        30.0
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        32.972023010253906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        508.4031982421875,
        904.8734741210938,
        30.0
      ],
      "bbox_max": [
        570.56640625,
        911.8958740234375,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        553.61279296875,
        904.8734741210938,
        30.0
      ],
      "bbox_max": [
        570.56640625,
        911.8958740234375,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3754224479198456,
        0.7064404487609863,
        -0.5999997854232788
      ],
      "plane_d": -930.6943359375,
      "bbox_min": [
        403.67474365234375,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        597.5687866210938,
        1181.5440673828125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 597.5687866210938,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -481.4007873535156,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 911.8958740234375,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071056962013245,
        -0.7071078419685364,
        1.5413704659295036e-06
      ],
      "plane_d": 1043.2939453125,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        -7.706853466515895e-07
      ],
      "plane_d": 280.346923828125,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6891113519668579,
        0.7246554493904114,
        0.0
      ],
      "plane_d": -947.5509643554688,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        533.9797973632812,
        827.0,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -799.7999877929688,
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        533.9797973632812,
        801.51953125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -532.1715698242188,
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        532.1715698242188,
        801.51953125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6891108751296997,
        0.7246559858322144,
        0.0
      ],
      "plane_d": -204.02142333984375,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        544.9898071289062,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        597.5687866210938,
        827.0,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -799.7999877929688,
      "bbox_min": [
        544.9898071289062,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        546.313720703125,
        801.0589599609375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 546.313720703125,
      "bbox_min": [
        546.313720703125,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        546.313720703125,
        801.0589599609375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238793253898621,
        -0.3826841115951538,
        7.159964638958627e-07
      ],
      "plane_d": -112.609375,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238811135292053,
        -0.38267987966537476,
        -3.244017250381148e-07
      ],
      "plane_d": 884.2257080078125,
      "bbox_min": [
        508.4031982421875,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        508.4031982421875,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        570.56640625,
        911.8958740234375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        525.3568115234375,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        570.56640625,
        911.8958740234375,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -807.9999389648438,
      "bbox_min": [
        525.3568115234375,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        553.61279296875,
        812.7999877929688,
        30.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -799.7999877929688,
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        10.0
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 546.313720703125,
      "bbox_min": [
        532.1715698242188,
        801.0589599609375,
        10.0
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -532.1715698242188,
      "bbox_min": [
        532.1715698242188,
        801.51953125,
        10.0
      ],
      "bbox_max": [
        532.1715698242188,
        808.0,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -20.0,
      "bbox_min": [
        531.2000122070312,
        808.0,
        10.0
      ],
      "bbox_max": [
        553.5,
        812.7999877929688,
        20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -808.5,
      "bbox_min": [
        531.2000122070312,
        808.0,
        10.0
      ],
      "bbox_max": [
        553.5,
        812.7999877929688,
        20.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 19.0,
      "bbox_min": [
        531.2000122070312,
        808.0,
        10.0
      ],
      "bbox_max": [
        547.2000122070312,
        808.5,
        20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 531.2000122070312,
      "bbox_min": [
        531.2000122070312,
        808.0,
        19.0
      ],
      "bbox_max": [
        547.2000122070312,
        808.5,
        20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -547.2000122070312,
      "bbox_min": [
        547.2000122070312,
        808.0,
        19.0
      ],
      "bbox_max": [
        547.2000122070312,
        808.5,
        20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -532.1715698242188,
      "bbox_min": [
        531.2000122070312,
        808.0,
        10.0
      ],
      "bbox_max": [
        547.2000122070312,
        808.5,
        19.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 531.2000122070312,
      "bbox_min": [
        531.2000122070312,
        808.0,
        10.0
      ],
      "bbox_max": [
        531.2000122070312,
        808.5,
        19.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -547.2000122070312,
      "bbox_min": [
        546.313720703125,
        808.0,
        10.0
      ],
      "bbox_max": [
        547.2000122070312,
        808.5,
        19.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 546.313720703125,
      "bbox_min": [
        546.313720703125,
        808.0,
        10.0
      ],
      "bbox_max": [
        546.313720703125,
        808.5,
        19.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 183.35281372070312,
      "bbox_min": [
        550.5,
        809.7999877929688,
        10.0
      ],
      "bbox_max": [
        553.5,
        812.7999877929688,
        17.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 963.998779296875,
      "bbox_min": [
        550.5,
        811.2999877929688,
        10.0
      ],
      "bbox_max": [
        552.0,
        812.7999877929688,
        17.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.37542256712913513,
        -0.7064406871795654,
        -0.5999996066093445
      ],
      "plane_d": 661.4813842773438,
      "bbox_min": [
        403.67474365234375,
        1072.2559814453125,
        10.0
      ],
      "bbox_max": [
        596.3252563476562,
        1181.5440673828125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37542256712913513,
        0.7064406871795654,
        -0.5999996066093445
      ],
      "plane_d": -555.2720947265625,
      "bbox_min": [
        403.67474365234375,
        1072.2559814453125,
        10.0
      ],
      "bbox_max": [
        596.3252563476562,
        1181.5440673828125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7999999523162842,
        -0.5999999642372131
      ],
      "plane_d": 951.2351684570312,
      "bbox_min": [
        403.67474365234375,
        1072.2559814453125,
        10.0
      ],
      "bbox_max": [
        596.3252563476562,
        1181.5440673828125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7999999523162842,
        -0.5999999642372131
      ],
      "plane_d": -851.8047485351562,
      "bbox_min": [
        403.67474365234375,
        1072.2559814453125,
        10.0
      ],
      "bbox_max": [
        596.3252563476562,
        1152.9921875,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6689647436141968,
        0.0,
        -0.7432941794395447
      ],
      "plane_d": 344.1324157714844,
      "bbox_min": [
        403.67474365234375,
        1100.807861328125,
        10.0
      ],
      "bbox_max": [
        596.3252563476562,
        1152.9921875,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6689647436141968,
        0.0,
        -0.7432941794395447
      ],
      "plane_d": -324.8323059082031,
      "bbox_min": [
        481.0920104980469,
        1100.807861328125,
        10.0
      ],
      "bbox_max": [
        596.3252563476562,
        1152.9921875,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 25.5,
      "bbox_min": [
        481.0920104980469,
        1105.2559814453125,
        25.5
      ],
      "bbox_max": [
        518.907958984375,
        1148.5440673828125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6689647436141968,
        -0.7432941794395447
      ],
      "plane_d": -746.0366821289062,
      "bbox_min": [
        481.0920104980469,
        1105.2559814453125,
        25.5
      ],
      "bbox_max": [
        518.907958984375,
        1148.5440673828125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6689647436141968,
        -0.7432941794395447
      ],
      "plane_d": 761.6760864257812,
      "bbox_min": [
        481.0920104980469,
        1105.2559814453125,
        25.5
      ],
      "bbox_max": [
        518.907958984375,
        1110.2559814453125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6354905366897583,
        0.4859541952610016,
        -0.600000262260437
      ],
      "plane_d": -162.66275024414062,
      "bbox_min": [
        542.0,
        1100.807861328125,
        10.0
      ],
      "bbox_max": [
        596.3252563476562,
        1152.9921875,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6354907751083374,
        -0.4859543442726135,
        -0.5999999046325684
      ],
      "plane_d": 932.5811767578125,
      "bbox_min": [
        542.0,
        1119.3397216796875,
        10.0
      ],
      "bbox_max": [
        596.3252563476562,
        1152.9921875,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8436113595962524,
        0.4870578646659851,
        -0.22604088485240936
      ],
      "plane_d": -1016.7296142578125,
      "bbox_min": [
        542.0,
        1119.3397216796875,
        20.0
      ],
      "bbox_max": [
        562.0,
        1136.6602783203125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9741159677505493,
        -0.22604914009571075
      ],
      "plane_d": -1100.4573974609375,
      "bbox_min": [
        542.0,
        1119.3397216796875,
        20.0
      ],
      "bbox_max": [
        562.0,
        1136.6602783203125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8436105847358704,
        0.4870574176311493,
        -0.22604477405548096
      ],
      "plane_d": -85.38250732421875,
      "bbox_min": [
        542.0,
        1119.3397216796875,
        20.0
      ],
      "bbox_max": [
        562.0,
        1136.6602783203125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8436113595962524,
        -0.4870578646659851,
        -0.22604088485240936
      ],
      "plane_d": 1013.4197998046875,
      "bbox_min": [
        542.0,
        1119.3397216796875,
        20.0
      ],
      "bbox_max": [
        562.0,
        1135.5,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9741159677505493,
        -0.22604914009571075
      ],
      "plane_d": 1097.148193359375,
      "bbox_min": [
        543.3397216796875,
        1119.3397216796875,
        20.0
      ],
      "bbox_max": [
        562.0,
        1135.5,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8436105847358704,
        -0.4870574176311493,
        -0.22604477405548096
      ],
      "plane_d": 82.072998046875,
      "bbox_min": [
        543.3397216796875,
        1119.3397216796875,
        20.0
      ],
      "bbox_max": [
        562.0,
        1135.5,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.755923867225647,
        -0.6546594500541687
      ],
      "plane_d": -841.9850463867188,
      "bbox_min": [
        543.3397216796875,
        1120.5,
        20.0
      ],
      "bbox_max": [
        560.6602783203125,
        1135.5,
        25.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.755923867225647,
        -0.6546594500541687
      ],
      "plane_d": 863.3792114257812,
      "bbox_min": [
        543.3397216796875,
        1120.5,
        20.0
      ],
      "bbox_max": [
        560.6602783203125,
        1135.5,
        25.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6546515226364136,
        0.3779642581939697,
        -0.654655933380127
      ],
      "plane_d": -777.014404296875,
      "bbox_min": [
        543.3397216796875,
        1120.5,
        20.0
      ],
      "bbox_max": [
        560.6602783203125,
        1135.5,
        25.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6546499133110046,
        0.3779633343219757,
        -0.6546580791473389
      ],
      "plane_d": -54.27886962890625,
      "bbox_min": [
        543.3397216796875,
        1120.5,
        20.0
      ],
      "bbox_max": [
        560.6602783203125,
        1135.5,
        25.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6546515226364136,
        -0.3779642581939697,
        -0.654655933380127
      ],
      "plane_d": 798.4082641601562,
      "bbox_min": [
        543.3397216796875,
        1120.5,
        20.0
      ],
      "bbox_max": [
        560.6602783203125,
        1132.330078125,
        25.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6546499133110046,
        -0.3779633343219757,
        -0.6546580791473389
      ],
      "plane_d": 75.67288208007812,
      "bbox_min": [
        547.0,
        1120.5,
        20.0
      ],
      "bbox_max": [
        560.6602783203125,
        1132.330078125,
        25.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25597697496414185,
        0.14779004454612732,
        -0.9553187489509583
      ],
      "plane_d": -288.90008544921875,
      "bbox_min": [
        547.0,
        1123.669921875,
        20.0
      ],
      "bbox_max": [
        557.0,
        1132.330078125,
        21.339746475219727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2955798804759979,
        -0.9553179740905762
      ],
      "plane_d": -314.3077392578125,
      "bbox_min": [
        547.0,
        1123.669921875,
        20.0
      ],
      "bbox_max": [
        557.0,
        1132.330078125,
        21.339746475219727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25597697496414185,
        0.14779004454612732,
        -0.9553186893463135
      ],
      "plane_d": -6.301513671875,
      "bbox_min": [
        547.0,
        1123.669921875,
        20.0
      ],
      "bbox_max": [
        557.0,
        1132.330078125,
        21.339746475219727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25597697496414185,
        -0.14779004454612732,
        -0.9553187489509583
      ],
      "plane_d": 327.1128234863281,
      "bbox_min": [
        547.0,
        1123.669921875,
        20.0
      ],
      "bbox_max": [
        557.0,
        1128.0,
        21.339746475219727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2955798804759979,
        -0.9553179740905762
      ],
      "plane_d": 352.52044677734375,
      "bbox_min": [
        549.5,
        1123.669921875,
        20.0
      ],
      "bbox_max": [
        557.0,
        1128.0,
        21.339746475219727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25597697496414185,
        -0.14779004454612732,
        -0.9553186893463135
      ],
      "plane_d": 44.514251708984375,
      "bbox_min": [
        552.0,
        1123.669921875,
        20.0
      ],
      "bbox_max": [
        557.0,
        1128.0,
        21.339746475219727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.635491132736206,
        -0.4859538972377777,
        -0.5999997854232788
      ],
      "plane_d": 297.0897216796875,
      "bbox_min": [
        403.67474365234375,
        1100.807861328125,
        10.0
      ],
      "bbox_max": [
        459.0,
        1152.9921875,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.635491132736206,
        0.4859538972377777,
        -0.5999999046325684
      ],
      "plane_d": -798.1531982421875,
      "bbox_min": [
        403.67474365234375,
        1100.807861328125,
        10.0
      ],
      "bbox_max": [
        459.0,
        1136.6602783203125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8436113595962524,
        0.4870578646659851,
        -0.22604088485240936
      ],
      "plane_d": -929.837646484375,
      "bbox_min": [
        439.0,
        1119.3397216796875,
        20.0
      ],
      "bbox_max": [
        459.0,
        1136.6602783203125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9741159677505493,
        -0.22604914009571075
      ],
      "plane_d": -1100.4573974609375,
      "bbox_min": [
        439.0,
        1119.3397216796875,
        20.0
      ],
      "bbox_max": [
        459.0,
        1136.6602783203125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8436113595962524,
        -0.4870578646659851,
        -0.22604088485240936
      ],
      "plane_d": 926.52783203125,
      "bbox_min": [
        439.0,
        1119.3397216796875,
        20.0
      ],
      "bbox_max": [
        459.0,
        1136.6602783203125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9741159677505493,
        -0.22604914009571075
      ],
      "plane_d": 1097.148193359375,
      "bbox_min": [
        439.0,
        1119.3397216796875,
        20.0
      ],
      "bbox_max": [
        459.0,
        1136.6602783203125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8436105847358704,
        -0.4870574176311493,
        -0.22604477405548096
      ],
      "plane_d": 168.96487426757812,
      "bbox_min": [
        439.0,
        1119.3397216796875,
        20.0
      ],
      "bbox_max": [
        459.0,
        1136.6602783203125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8436105847358704,
        0.4870574176311493,
        -0.22604477405548096
      ],
      "plane_d": -172.27438354492188,
      "bbox_min": [
        439.0,
        1120.5,
        20.0
      ],
      "bbox_max": [
        457.6602783203125,
        1136.6602783203125,
        30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.755923867225647,
        -0.6546594500541687
      ],
      "plane_d": -841.9850463867188,
      "bbox_min": [
        440.3397216796875,
        1120.5,
        20.0
      ],
      "bbox_max": [
        457.6602783203125,
        1135.5,
        25.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.755923867225647,
        -0.6546594500541687
      ],
      "plane_d": 863.3792114257812,
      "bbox_min": [
        440.3397216796875,
        1120.5,
        20.0
      ],
      "bbox_max": [
        457.6602783203125,
        1135.5,
        25.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6546515226364136,
        0.3779642581939697,
        -0.654655933380127
      ],
      "plane_d": -709.5853271484375,
      "bbox_min": [
        440.3397216796875,
        1120.5,
        20.0
      ],
      "bbox_max": [
        457.6602783203125,
        1135.5,
        25.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6546499133110046,
        0.3779633343219757,
        -0.6546580791473389
      ],
      "plane_d": -121.70782470703125,
      "bbox_min": [
        440.3397216796875,
        1120.5,
        20.0
      ],
      "bbox_max": [
        457.6602783203125,
        1135.5,
        25.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6546515226364136,
        -0.3779642581939697,
        -0.654655933380127
      ],
      "plane_d": 730.9791259765625,
      "bbox_min": [
        440.3397216796875,
        1120.5,
        20.0
      ],
      "bbox_max": [
        457.6602783203125,
        1132.330078125,
        25.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6546499133110046,
        -0.3779633343219757,
        -0.6546580791473389
      ],
      "plane_d": 143.10183715820312,
      "bbox_min": [
        444.0,
        1120.5,
        20.0
      ],
      "bbox_max": [
        457.6602783203125,
        1132.330078125,
        25.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25597697496414185,
        0.14779004454612732,
        -0.9553187489509583
      ],
      "plane_d": -262.5344543457031,
      "bbox_min": [
        444.0,
        1123.669921875,
        20.0
      ],
      "bbox_max": [
        454.0,
        1132.330078125,
        21.339746475219727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2955798804759979,
        -0.9553179740905762
      ],
      "plane_d": -314.3077392578125,
      "bbox_min": [
        444.0,
        1123.669921875,
        20.0
      ],
      "bbox_max": [
        454.0,
        1132.330078125,
        21.339746475219727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25597697496414185,
        0.14779004454612732,
        -0.9553186893463135
      ],
      "plane_d": -32.667137145996094,
      "bbox_min": [
        444.0,
        1123.669921875,
        20.0
      ],
      "bbox_max": [
        454.0,
        1132.330078125,
        21.339746475219727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25597697496414185,
        -0.14779004454612732,
        -0.9553187489509583
      ],
      "plane_d": 300.7471923828125,
      "bbox_min": [
        444.0,
        1123.669921875,
        20.0
      ],
      "bbox_max": [
        454.0,
        1128.0,
        21.339746475219727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2955798804759979,
        -0.9553179740905762
      ],
      "plane_d": 352.52044677734375,
      "bbox_min": [
        446.5,
        1123.669921875,
        20.0
      ],
      "bbox_max": [
        454.0,
        1128.0,
        21.339746475219727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25597697496414185,
        -0.14779004454612732,
        -0.9553186893463135
      ],
      "plane_d": 70.87987518310547,
      "bbox_min": [
        449.0,
        1123.669921875,
        20.0
      ],
      "bbox_max": [
        454.0,
        1128.0,
        21.339746475219727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1074.69384765625,
      "bbox_min": [
        367.0,
        715.0,
        -20.0
      ],
      "bbox_max": [
        633.0,
        1294.4000244140625,
        10.000000953674316
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43722808361053467,
        -0.8993088006973267,
        -0.008673583157360554
      ],
      "plane_d": 1374.0250244140625,
      "bbox_min": [
        370.38604736328125,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        629.6138916015625,
        1294.4000244140625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -17.0,
      "bbox_min": [
        480.60308837890625,
        1259.688232421875,
        -20.0
      ],
      "bbox_max": [
        552.0,
        1294.4000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 331.63311767578125,
      "bbox_min": [
        486.2350769042969,
        1290.317626953125,
        -20.0
      ],
      "bbox_max": [
        489.0,
        1294.4000244140625,
        -17.235069274902344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0001220703125,
        0.0
      ],
      "plane_d": 517.3438720703125,
      "bbox_min": [
        517.4998779296875,
        1277.9000244140625,
        -20.0
      ],
      "bbox_max": [
        518.5,
        1278.9000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1278.9000244140625,
      "bbox_min": [
        517.5,
        1278.9000244140625,
        -20.0
      ],
      "bbox_max": [
        518.5,
        1278.9000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1277.9000244140625,
      "bbox_min": [
        542.4998779296875,
        1260.4000244140625,
        -20.0
      ],
      "bbox_max": [
        552.0,
        1278.9000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0001220703125,
        0.0
      ],
      "plane_d": 542.3438720703125,
      "bbox_min": [
        542.4998779296875,
        1277.9000244140625,
        -20.0
      ],
      "bbox_max": [
        543.5,
        1278.9000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1278.9000244140625,
      "bbox_min": [
        542.5,
        1278.9000244140625,
        -20.0
      ],
      "bbox_max": [
        543.5,
        1278.9000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1260.39990234375,
      "bbox_min": [
        550.5059814453125,
        1260.4000244140625,
        -20.0
      ],
      "bbox_max": [
        552.0,
        1260.4000244140625,
        -18.5059814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -17.0,
      "bbox_min": [
        447.0,
        1259.2021484375,
        -20.0
      ],
      "bbox_max": [
        489.0,
        1294.4000244140625,
        -6.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -452.5,
      "bbox_min": [
        452.5,
        1262.0,
        -17.0
      ],
      "bbox_max": [
        472.5,
        1272.0,
        -6.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1272.0,
      "bbox_min": [
        452.5,
        1262.0,
        -17.0
      ],
      "bbox_max": [
        472.5,
        1272.0,
        -6.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -6.0,
      "bbox_min": [
        452.5,
        1262.0,
        -17.0
      ],
      "bbox_max": [
        472.5,
        1272.0,
        -6.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1262.0,
      "bbox_min": [
        452.5,
        1262.0,
        -17.0
      ],
      "bbox_max": [
        472.5,
        1272.0,
        -6.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 16.0,
      "bbox_min": [
        462.5,
        1266.69921875,
        -17.0
      ],
      "bbox_max": [
        472.5,
        1272.0,
        -6.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 462.5,
      "bbox_min": [
        462.5,
        1266.69921875,
        -17.0
      ],
      "bbox_max": [
        462.5,
        1272.0,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 472.5,
      "bbox_min": [
        472.5,
        1271.464599609375,
        -16.0
      ],
      "bbox_max": [
        472.5,
        1272.0,
        -6.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -330.2188720703125,
      "bbox_min": [
        447.0,
        1259.2021484375,
        -20.0
      ],
      "bbox_max": [
        489.0,
        1294.4000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0001220703125,
        0.0
      ],
      "plane_d": 479.3438720703125,
      "bbox_min": [
        479.4998779296875,
        1277.9000244140625,
        -20.0
      ],
      "bbox_max": [
        480.5,
        1278.9000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1278.9000244140625,
      "bbox_min": [
        479.5,
        1278.9000244140625,
        -20.0
      ],
      "bbox_max": [
        480.5,
        1278.9000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1260.39990234375,
      "bbox_min": [
        447.0,
        1260.4000244140625,
        -20.0
      ],
      "bbox_max": [
        455.5001220703125,
        1278.9000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0001220703125,
        -0.0
      ],
      "plane_d": -455.6561279296875,
      "bbox_min": [
        454.4998779296875,
        1277.9000244140625,
        -20.0
      ],
      "bbox_max": [
        455.5001220703125,
        1278.9000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0001220703125,
        0.0
      ],
      "plane_d": 454.3438720703125,
      "bbox_min": [
        454.4998779296875,
        1277.9000244140625,
        -20.0
      ],
      "bbox_max": [
        455.5,
        1278.9000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1278.9000244140625,
      "bbox_min": [
        454.5,
        1278.9000244140625,
        -20.0
      ],
      "bbox_max": [
        455.5,
        1278.9000244140625,
        -16.999984741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8697719573974609,
        -0.474076509475708,
        -0.1369238793849945
      ],
      "plane_d": 101.07553100585938,
      "bbox_min": [
        370.38604736328125,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        629.6138916015625,
        1280.1077880859375,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.86977219581604,
        -0.4740760922431946,
        -0.1369236409664154
      ],
      "plane_d": 970.8470458984375,
      "bbox_min": [
        370.38604736328125,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        567.6607666015625,
        1280.1077880859375,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.875601589679718,
        -0.45198971033096313,
        -0.17037416994571686
      ],
      "plane_d": 946.054443359375,
      "bbox_min": [
        432.33917236328125,
        1213.15283203125,
        -20.0
      ],
      "bbox_max": [
        567.6607666015625,
        1280.1077880859375,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8756012320518494,
        -0.4519902169704437,
        -0.17037415504455566
      ],
      "plane_d": 70.45370483398438,
      "bbox_min": [
        447.0,
        1213.15283203125,
        -20.0
      ],
      "bbox_max": [
        567.6607666015625,
        1280.1077880859375,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -17.0,
      "bbox_min": [
        447.0,
        1258.4000244140625,
        -20.0
      ],
      "bbox_max": [
        552.0,
        1280.1077880859375,
        -6.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1262.0,
      "bbox_min": [
        452.81463623046875,
        1262.0,
        -17.0
      ],
      "bbox_max": [
        472.5,
        1271.56103515625,
        -6.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 472.5,
      "bbox_min": [
        453.0328369140625,
        1262.0,
        -17.0
      ],
      "bbox_max": [
        472.5,
        1271.56103515625,
        -6.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 16.0,
      "bbox_min": [
        453.0328369140625,
        1262.0,
        -17.0
      ],
      "bbox_max": [
        472.5,
        1271.56103515625,
        -6.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 462.5,
      "bbox_min": [
        462.5,
        1262.0,
        -17.0
      ],
      "bbox_max": [
        462.5,
        1266.7088623046875,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -6.0,
      "bbox_min": [
        453.0328369140625,
        1262.0,
        -6.0
      ],
      "bbox_max": [
        472.5,
        1271.464599609375,
        -6.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 331.63311767578125,
      "bbox_min": [
        447.0,
        1258.4000244140625,
        -20.0
      ],
      "bbox_max": [
        552.0,
        1260.4000244140625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -374.7666015625,
      "bbox_min": [
        510.0,
        1258.4000244140625,
        -20.0
      ],
      "bbox_max": [
        552.0,
        1260.4000244140625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 376.18084716796875,
      "bbox_min": [
        549.0,
        1258.4000244140625,
        -20.0
      ],
      "bbox_max": [
        552.0,
        1260.4000244140625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -330.2188720703125,
      "bbox_min": [
        447.0,
        1258.4000244140625,
        -20.0
      ],
      "bbox_max": [
        450.0,
        1260.4000244140625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -374.7666015625,
      "bbox_min": [
        449.5137939453125,
        1260.4000244140625,
        -20.0
      ],
      "bbox_max": [
        550.5062866210938,
        1280.1077880859375,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 331.63311767578125,
      "bbox_min": [
        449.5137939453125,
        1260.4000244140625,
        -20.0
      ],
      "bbox_max": [
        489.0,
        1279.62158203125,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -330.2188720703125,
      "bbox_min": [
        449.5137939453125,
        1260.4000244140625,
        -17.486209869384766
      ],
      "bbox_max": [
        450.0,
        1260.6317138671875,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 376.18084716796875,
      "bbox_min": [
        549.0,
        1260.4000244140625,
        -18.506275177001953
      ],
      "bbox_max": [
        550.5062866210938,
        1261.1177978515625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39352136850357056,
        0.8033435344696045,
        0.4469677209854126
      ],
      "plane_d": -785.3597412109375,
      "bbox_min": [
        379.06719970703125,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        461.5716857910156,
        1231.0621337890625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949184417724609,
        0.44622981548309326,
        0.0
      ],
      "plane_d": -926.1727294921875,
      "bbox_min": [
        379.06719970703125,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        461.5716857910156,
        1231.0621337890625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -403.5,
      "bbox_min": [
        379.06719970703125,
        1201.4000244140625,
        -20.0
      ],
      "bbox_max": [
        427.13336181640625,
        1231.0621337890625,
        2.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 17.0,
      "bbox_min": [
        379.06719970703125,
        1201.4000244140625,
        -20.0
      ],
      "bbox_max": [
        403.5,
        1230.4000244140625,
        2.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 393.5,
      "bbox_min": [
        393.5,
        1216.9000244140625,
        -20.0
      ],
      "bbox_max": [
        403.5,
        1230.4000244140625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1216.9000244140625,
      "bbox_min": [
        393.5,
        1216.9000244140625,
        -20.0
      ],
      "bbox_max": [
        403.5,
        1230.4000244140625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1230.4000244140625,
      "bbox_min": [
        393.5,
        1230.4000244140625,
        -20.0
      ],
      "bbox_max": [
        403.5,
        1230.4000244140625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.877301037311554,
        0.4528670608997345,
        -0.15891622006893158
      ],
      "plane_d": -881.5008544921875,
      "bbox_min": [
        379.06719970703125,
        1201.4000244140625,
        -5.0
      ],
      "bbox_max": [
        384.98101806640625,
        1210.4000244140625,
        2.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8949184417724609,
        -0.44622981548309326,
        -0.0
      ],
      "plane_d": 915.1727294921875,
      "bbox_min": [
        411.35211181640625,
        1214.0220947265625,
        -20.0
      ],
      "bbox_max": [
        427.13336181640625,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 16.5,
      "bbox_min": [
        411.35211181640625,
        1214.0220947265625,
        -20.0
      ],
      "bbox_max": [
        427.13336181640625,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8949184417724609,
        0.44622981548309326,
        0.0
      ],
      "plane_d": -915.6727905273438,
      "bbox_min": [
        411.35211181640625,
        1214.0220947265625,
        -20.0
      ],
      "bbox_max": [
        427.13336181640625,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4462345540523529,
        -0.8949160575866699,
        0.0
      ],
      "plane_d": 913.5442504882812,
      "bbox_min": [
        411.35211181640625,
        1214.0220947265625,
        -20.0
      ],
      "bbox_max": [
        417.73675537109375,
        1226.599853515625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9483505487442017,
        0.3172244727611542,
        0.0
      ],
      "plane_d": 1.211273193359375,
      "bbox_min": [
        411.35211181640625,
        1225.92919921875,
        -20.0
      ],
      "bbox_max": [
        411.5764465332031,
        1226.599853515625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4462856650352478,
        -0.8948906064033508,
        0.0
      ],
      "plane_d": 900.186767578125,
      "bbox_min": [
        417.289306640625,
        1214.0220947265625,
        -20.0
      ],
      "bbox_max": [
        417.73675537109375,
        1214.2452392578125,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8949184417724609,
        -0.44622981548309326,
        -0.0
      ],
      "plane_d": 925.6727294921875,
      "bbox_min": [
        411.5764465332031,
        1218.70751953125,
        -20.0
      ],
      "bbox_max": [
        427.13336181640625,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4462345540523529,
        -0.8949160575866699,
        0.0
      ],
      "plane_d": 913.5442504882812,
      "bbox_min": [
        420.5256042480469,
        1218.70751953125,
        -20.0
      ],
      "bbox_max": [
        427.13336181640625,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31730222702026367,
        0.9483245611190796,
        0.0
      ],
      "plane_d": -1300.880126953125,
      "bbox_min": [
        420.5256042480469,
        1230.8377685546875,
        -20.0
      ],
      "bbox_max": [
        421.1961669921875,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4462856650352478,
        -0.8948906064033508,
        0.0
      ],
      "plane_d": 900.18603515625,
      "bbox_min": [
        426.6859130859375,
        1218.70751953125,
        -20.0
      ],
      "bbox_max": [
        427.13336181640625,
        1218.9306640625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.446229487657547,
        0.89491868019104,
        0.0
      ],
      "plane_d": -914.0494995117188,
      "bbox_min": [
        411.5764465332031,
        1226.15234375,
        -20.0
      ],
      "bbox_max": [
        420.74871826171875,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4462345540523529,
        -0.8949160575866699,
        0.0
      ],
      "plane_d": 913.5442504882812,
      "bbox_min": [
        411.79962158203125,
        1226.15234375,
        -20.0
      ],
      "bbox_max": [
        420.74871826171875,
        1230.6146240234375,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39011093974113464,
        0.803998589515686,
        0.44877588748931885
      ],
      "plane_d": -787.6806030273438,
      "bbox_min": [
        433.7689514160156,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        461.5716857910156,
        1224.3790283203125,
        10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.788802444934845,
        0.5944059491157532,
        0.15643593668937683
      ],
      "plane_d": -372.20025634765625,
      "bbox_min": [
        433.7689514160156,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        461.5716857910156,
        1224.3790283203125,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3919530212879181,
        0.8061851859092712,
        0.4432135820388794
      ],
      "plane_d": -789.4508056640625,
      "bbox_min": [
        440.7665710449219,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        461.5716857910156,
        1219.275634765625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5332207083702087,
        0.2157275676727295,
        0.8180081844329834
      ],
      "plane_d": -485.89691162109375,
      "bbox_min": [
        440.7665710449219,
        1214.48046875,
        -20.0
      ],
      "bbox_max": [
        445.5126953125,
        1219.275634765625,
        -15.429447174072266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7233107089996338,
        0.6900440454483032,
        -0.02570810727775097
      ],
      "plane_d": -1162.4051513671875,
      "bbox_min": [
        440.7665710449219,
        1214.48046875,
        -20.0
      ],
      "bbox_max": [
        445.5126953125,
        1219.275634765625,
        -15.429447174072266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4639289975166321,
        -0.8854988217353821,
        -0.025722727179527283
      ],
      "plane_d": 1280.815185546875,
      "bbox_min": [
        440.7665710449219,
        1214.48046875,
        -20.0
      ],
      "bbox_max": [
        445.5126953125,
        1219.275634765625,
        -15.429447174072266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06042308360338211,
        -0.5720618367195129,
        0.8179819583892822
      ],
      "plane_d": 735.7452392578125,
      "bbox_min": [
        440.7665710449219,
        1214.48046875,
        -20.0
      ],
      "bbox_max": [
        445.5126953125,
        1219.275634765625,
        -15.429447174072266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31976068019866943,
        0.3765711486339569,
        -0.8694522976875305
      ],
      "plane_d": -617.272705078125,
      "bbox_min": [
        440.7665710449219,
        1214.48046875,
        -20.0
      ],
      "bbox_max": [
        445.5126953125,
        1219.275634765625,
        -16.46903419494629
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2738654613494873,
        -0.41121962666511536,
        -0.8694228529930115
      ],
      "plane_d": 604.3643798828125,
      "bbox_min": [
        440.7665710449219,
        1214.48046875,
        -20.0
      ],
      "bbox_max": [
        445.5126953125,
        1217.735107421875,
        -16.46903419494629
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7888012528419495,
        -0.5944049954414368,
        -0.1564454883337021
      ],
      "plane_d": 369.19940185546875,
      "bbox_min": [
        443.469970703125,
        1214.48046875,
        -19.92594337463379
      ],
      "bbox_max": [
        445.5126953125,
        1217.06591796875,
        -16.46903419494629
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.51388019323349,
        -0.4981364607810974,
        -0.6984177231788635
      ],
      "plane_d": 821.359130859375,
      "bbox_min": [
        433.7689514160156,
        1215.9990234375,
        -19.386953353881836
      ],
      "bbox_max": [
        443.33477783203125,
        1224.3790283203125,
        -14.556978225708008
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3372011184692383,
        -0.6312897801399231,
        0.6984042525291443
      ],
      "plane_d": 930.0548706054688,
      "bbox_min": [
        435.0279541015625,
        1215.9990234375,
        -19.317264556884766
      ],
      "bbox_max": [
        443.33477783203125,
        1224.06591796875,
        -14.626785278320312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3655370771884918,
        0.9210941195487976,
        0.13404597342014313
      ],
      "plane_d": -958.3477783203125,
      "bbox_min": [
        441.3384094238281,
        1218.14013671875,
        -19.317264556884766
      ],
      "bbox_max": [
        443.33477783203125,
        1219.029296875,
        -16.034696578979492
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6096806526184082,
        0.47266262769699097,
        0.6363015174865723
      ],
      "plane_d": -295.5460510253906,
      "bbox_min": [
        441.301025390625,
        1215.9990234375,
        -17.519546508789062
      ],
      "bbox_max": [
        443.33477783203125,
        1218.71630859375,
        -15.964887619018555
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3372011184692383,
        -0.6312897801399231,
        0.6984042525291443
      ],
      "plane_d": 930.0548706054688,
      "bbox_min": [
        433.7689514160156,
        1215.9990234375,
        -19.386953353881836
      ],
      "bbox_max": [
        442.9197082519531,
        1222.895263671875,
        -15.964887619018555
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.736558198928833,
        0.5682645440101624,
        -0.3668208420276642
      ],
      "plane_d": -373.5809326171875,
      "bbox_min": [
        440.8681640625,
        1216.3251953125,
        -19.386953353881836
      ],
      "bbox_max": [
        442.9197082519531,
        1219.029296875,
        -17.519546508789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9840177297592163,
        0.115555539727211,
        0.1354837268590927
      ],
      "plane_d": 295.8955993652344,
      "bbox_min": [
        440.8681640625,
        1215.9990234375,
        -19.386953353881836
      ],
      "bbox_max": [
        441.3384094238281,
        1218.14013671875,
        -15.964887619018555
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.88276207447052,
        0.45568668842315674,
        -0.11437126249074936
      ],
      "plane_d": -3.31610107421875,
      "bbox_min": [
        538.4282836914062,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        629.6138916015625,
        1249.748046875,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8683816194534302,
        0.4733186662197113,
        -0.1479288637638092
      ],
      "plane_d": -33.55621337890625,
      "bbox_min": [
        538.4282836914062,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        626.387451171875,
        1249.748046875,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3935222327709198,
        0.8033431768417358,
        0.4469676613807678
      ],
      "plane_d": -1178.881103515625,
      "bbox_min": [
        538.4282836914062,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        615.2675170898438,
        1249.748046875,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4383743703365326,
        -0.898792564868927,
        -0.0
      ],
      "plane_d": 1369.79833984375,
      "bbox_min": [
        538.4282836914062,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        615.2675170898438,
        1249.748046875,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8987908959388733,
        -0.4383777678012848,
        0.0
      ],
      "plane_d": 21.35333251953125,
      "bbox_min": [
        570.5112915039062,
        1227.0228271484375,
        -20.0
      ],
      "bbox_max": [
        611.192626953125,
        1249.748046875,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8987948298454285,
        0.43836966156959534,
        -2.703265238324093e-07
      ],
      "plane_d": -33.34100341796875,
      "bbox_min": [
        570.5112915039062,
        1240.5228271484375,
        -20.0
      ],
      "bbox_max": [
        583.1763305664062,
        1249.748046875,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 4.0,
      "bbox_min": [
        570.5112915039062,
        1240.5228271484375,
        -4.0
      ],
      "bbox_max": [
        583.1763305664062,
        1249.623291015625,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4383743703365326,
        -0.898792564868927,
        -0.0
      ],
      "plane_d": 1369.939208984375,
      "bbox_min": [
        598.5112915039062,
        1227.0228271484375,
        -20.0
      ],
      "bbox_max": [
        611.192626953125,
        1236.1566162109375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8987873196601868,
        -0.4383849799633026,
        0.0
      ],
      "plane_d": -9.7198486328125,
      "bbox_min": [
        598.5112915039062,
        1227.0228271484375,
        -20.0
      ],
      "bbox_max": [
        611.192626953125,
        1236.1566162109375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8987969756126404,
        0.4383653402328491,
        3.1165554901235737e-06
      ],
      "plane_d": -2.2501220703125,
      "bbox_min": [
        598.5112915039062,
        1227.0228271484375,
        -20.0
      ],
      "bbox_max": [
        611.1317138671875,
        1236.1566162109375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 4.0,
      "bbox_min": [
        598.5112915039062,
        1227.0228271484375,
        -4.0
      ],
      "bbox_max": [
        611.1317138671875,
        1236.0318603515625,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8949184417724609,
        0.44622981548309326,
        0.0
      ],
      "plane_d": -32.5966796875,
      "bbox_min": [
        538.4282836914062,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        615.2675170898438,
        1231.0621337890625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949184417724609,
        -0.44622981548309326,
        0.0
      ],
      "plane_d": 21.5966796875,
      "bbox_min": [
        571.3666381835938,
        1209.0443115234375,
        -20.0
      ],
      "bbox_max": [
        615.2675170898438,
        1231.0621337890625,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 16.5,
      "bbox_min": [
        571.3666381835938,
        1214.0220947265625,
        -20.0
      ],
      "bbox_max": [
        587.1478881835938,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8949184417724609,
        0.44622981548309326,
        0.0
      ],
      "plane_d": -22.0966796875,
      "bbox_min": [
        571.3666381835938,
        1214.0220947265625,
        -20.0
      ],
      "bbox_max": [
        587.1478881835938,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4462345540523529,
        -0.8949160575866699,
        -0.0
      ],
      "plane_d": 1359.109375,
      "bbox_min": [
        580.7632446289062,
        1214.0220947265625,
        -20.0
      ],
      "bbox_max": [
        587.1478881835938,
        1226.599853515625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9483634829521179,
        0.317185640335083,
        0.0
      ],
      "plane_d": -945.6767578125,
      "bbox_min": [
        586.923583984375,
        1225.92919921875,
        -20.0
      ],
      "bbox_max": [
        587.1478881835938,
        1226.599853515625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4462856650352478,
        -0.8948906064033508,
        0.0
      ],
      "plane_d": 1345.802978515625,
      "bbox_min": [
        580.7632446289062,
        1214.0220947265625,
        -20.0
      ],
      "bbox_max": [
        581.210693359375,
        1214.2452392578125,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949184417724609,
        -0.44622981548309326,
        0.0
      ],
      "plane_d": 32.096649169921875,
      "bbox_min": [
        571.3666381835938,
        1218.70751953125,
        -20.0
      ],
      "bbox_max": [
        586.923583984375,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4462345540523529,
        -0.8949160575866699,
        -0.0
      ],
      "plane_d": 1359.109375,
      "bbox_min": [
        571.3666381835938,
        1218.70751953125,
        -20.0
      ],
      "bbox_max": [
        577.9744262695312,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31728923320770264,
        0.9483287930488586,
        0.0
      ],
      "plane_d": -984.0665893554688,
      "bbox_min": [
        577.3038330078125,
        1230.8377685546875,
        -20.0
      ],
      "bbox_max": [
        577.9744262695312,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4462856650352478,
        -0.8948906064033508,
        0.0
      ],
      "plane_d": 1345.80224609375,
      "bbox_min": [
        571.3666381835938,
        1218.70751953125,
        -20.0
      ],
      "bbox_max": [
        571.8140869140625,
        1218.9306640625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.446229487657547,
        0.89491868019104,
        0.0
      ],
      "plane_d": -1359.6097412109375,
      "bbox_min": [
        577.7513427734375,
        1226.15234375,
        -20.0
      ],
      "bbox_max": [
        586.923583984375,
        1231.0621337890625,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4462345540523529,
        -0.8949160575866699,
        -0.0
      ],
      "plane_d": 1359.109375,
      "bbox_min": [
        577.7513427734375,
        1226.15234375,
        -20.0
      ],
      "bbox_max": [
        586.700439453125,
        1230.6146240234375,
        -16.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 15.0,
      "bbox_min": [
        595.6241455078125,
        1209.0443115234375,
        -20.0
      ],
      "bbox_max": [
        615.2675170898438,
        1222.0218505859375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9135449528694153,
        0.4067377746105194,
        -0.0
      ],
      "plane_d": -1053.9149169921875,
      "bbox_min": [
        595.6241455078125,
        1209.0443115234375,
        -20.0
      ],
      "bbox_max": [
        615.2675170898438,
        1222.0218505859375,
        -15.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9135449528694153,
        -0.4067377746105194,
        -0.0
      ],
      "plane_d": 1049.9149169921875,
      "bbox_min": [
        595.6241455078125,
        1209.0443115234375,
        -20.0
      ],
      "bbox_max": [
        615.2675170898438,
        1222.0218505859375,
        -15.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 18.0,
      "bbox_min": [
        605.9190063476562,
        1209.0443115234375,
        -20.0
      ],
      "bbox_max": [
        615.2675170898438,
        1222.0218505859375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40673866868019104,
        0.9135445952415466,
        0.0
      ],
      "plane_d": -868.4344482421875,
      "bbox_min": [
        605.9190063476562,
        1220.3948974609375,
        -20.0
      ],
      "bbox_max": [
        609.5731811523438,
        1222.0218505859375,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40670478343963623,
        0.9135596752166748,
        0.0
      ],
      "plane_d": -867.4735107421875,
      "bbox_min": [
        605.9190063476562,
        1209.0443115234375,
        -18.0
      ],
      "bbox_max": [
        615.2675170898438,
        1222.0218505859375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9115225672721863,
        -0.40583735704421997,
        0.066503144800663
      ],
      "plane_d": 1051.382080078125,
      "bbox_min": [
        608.7010498046875,
        1209.0443115234375,
        -18.0
      ],
      "bbox_max": [
        615.2675170898438,
        1220.6202392578125,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40670478343963623,
        -0.9135596752166748,
        -8.258625712187495e-06
      ],
      "plane_d": 854.4734497070312,
      "bbox_min": [
        614.8453979492188,
        1209.0443115234375,
        -15.375886917114258
      ],
      "bbox_max": [
        615.2675170898438,
        1209.232177734375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3638257086277008,
        0.8171610832214355,
        0.44707798957824707
      ],
      "plane_d": -768.7628784179688,
      "bbox_min": [
        605.9190063476562,
        1219.4813232421875,
        -18.0
      ],
      "bbox_max": [
        609.9799194335938,
        1222.0218505859375,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 17.600006103515625,
      "bbox_min": [
        606.0003662109375,
        1219.4813232421875,
        -18.0
      ],
      "bbox_max": [
        609.9799194335938,
        1221.8392333984375,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36377546191215515,
        -0.8170985579490662,
        0.44723308086395264
      ],
      "plane_d": 783.920166015625,
      "bbox_min": [
        606.2444458007812,
        1219.4813232421875,
        -18.0
      ],
      "bbox_max": [
        609.9799194335938,
        1221.291015625,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 17.5,
      "bbox_min": [
        595.6241455078125,
        1210.294189453125,
        -20.0
      ],
      "bbox_max": [
        603.137939453125,
        1215.27587890625,
        -17.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35837575793266296,
        0.9335775375366211,
        0.0
      ],
      "plane_d": -919.089599609375,
      "bbox_min": [
        595.6241455078125,
        1210.294189453125,
        -20.0
      ],
      "bbox_max": [
        603.137939453125,
        1215.27587890625,
        -17.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9335796236991882,
        0.358370304107666,
        0.0
      ],
      "plane_d": -996.810791015625,
      "bbox_min": [
        595.6241455078125,
        1210.294189453125,
        -20.0
      ],
      "bbox_max": [
        603.137939453125,
        1215.27587890625,
        -17.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9335796236991882,
        -0.358370304107666,
        0.0
      ],
      "plane_d": 990.810791015625,
      "bbox_min": [
        595.6241455078125,
        1210.2943115234375,
        -20.0
      ],
      "bbox_max": [
        596.7109985351562,
        1213.1256103515625,
        -17.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13916972279548645,
        -0.9902685284614563,
        0.0
      ],
      "plane_d": 1131.5087890625,
      "bbox_min": [
        538.4282836914062,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        569.1714477539062,
        1226.5791015625,
        10.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.13916972279548645,
        0.9902685284614563,
        0.0
      ],
      "plane_d": -1135.5086669921875,
      "bbox_min": [
        553.7608032226562,
        1220.5303955078125,
        -20.0
      ],
      "bbox_max": [
        569.1714477539062,
        1226.5791015625,
        -15.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 18.0,
      "bbox_min": [
        553.7608032226562,
        1220.5303955078125,
        -20.0
      ],
      "bbox_max": [
        569.1714477539062,
        1226.5791015625,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.990268349647522,
        -0.13917161524295807,
        0.0
      ],
      "plane_d": 718.7862548828125,
      "bbox_min": [
        553.7608032226562,
        1220.5303955078125,
        -20.0
      ],
      "bbox_max": [
        569.1714477539062,
        1226.5791015625,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9902677536010742,
        0.13917581737041473,
        0.0
      ],
      "plane_d": -733.791015625,
      "bbox_min": [
        568.61474609375,
        1222.6180419921875,
        -20.0
      ],
      "bbox_max": [
        569.1714477539062,
        1226.5791015625,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 15.0,
      "bbox_min": [
        553.7608032226562,
        1220.5303955078125,
        -18.0
      ],
      "bbox_max": [
        569.1714477539062,
        1226.5791015625,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8858278393745422,
        -0.12445741146802902,
        0.4470118582248688
      ],
      "plane_d": 663.5035400390625,
      "bbox_min": [
        553.7608032226562,
        1220.5303955078125,
        -18.0
      ],
      "bbox_max": [
        569.1714477539062,
        1226.5791015625,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 17.600006103515625,
      "bbox_min": [
        567.822509765625,
        1222.5067138671875,
        -18.0
      ],
      "bbox_max": [
        569.1714477539062,
        1226.5791015625,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8858222961425781,
        0.12449667602777481,
        0.4470118582248688
      ],
      "plane_d": -648.3504028320312,
      "bbox_min": [
        568.4168090820312,
        1222.5902099609375,
        -18.0
      ],
      "bbox_max": [
        569.1714477539062,
        1226.5791015625,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13887086510658264,
        -0.9880751967430115,
        0.06650067865848541
      ],
      "plane_d": 1132.7886962890625,
      "bbox_min": [
        553.7608032226562,
        1220.5303955078125,
        -18.0
      ],
      "bbox_max": [
        567.8193359375,
        1226.43994140625,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9902755618095398,
        -0.13911989331245422,
        0.0
      ],
      "plane_d": 719.7269287109375,
      "bbox_min": [
        553.7608032226562,
        1223.105224609375,
        -18.0
      ],
      "bbox_max": [
        567.8193359375,
        1226.43994140625,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9902738928794861,
        0.13913191854953766,
        -1.5652927686460316e-05
      ],
      "plane_d": -732.7410278320312,
      "bbox_min": [
        567.6245727539062,
        1225.0537109375,
        -18.0
      ],
      "bbox_max": [
        567.8193359375,
        1226.43994140625,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 17.600006103515625,
      "bbox_min": [
        553.7608032226562,
        1223.105224609375,
        -18.0
      ],
      "bbox_max": [
        554.9458618164062,
        1224.6307373046875,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8856674432754517,
        0.1244334802031517,
        0.44733625650405884
      ],
      "plane_d": -635.658203125,
      "bbox_min": [
        553.7608032226562,
        1223.105224609375,
        -18.0
      ],
      "bbox_max": [
        554.9458618164062,
        1224.6307373046875,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8858227729797363,
        -0.12449290603399277,
        0.4470118284225464
      ],
      "plane_d": 651.0206298828125,
      "bbox_min": [
        553.7608032226562,
        1223.105224609375,
        -18.0
      ],
      "bbox_max": [
        554.1498413085938,
        1224.5194091796875,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 17.600006103515625,
      "bbox_min": [
        553.9556274414062,
        1220.5303955078125,
        -18.0
      ],
      "bbox_max": [
        555.3078002929688,
        1223.244384765625,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8858227729797363,
        -0.12449290603399277,
        0.4470118284225464
      ],
      "plane_d": 651.0206298828125,
      "bbox_min": [
        553.9556274414062,
        1220.5303955078125,
        -18.0
      ],
      "bbox_max": [
        555.3078002929688,
        1223.244384765625,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8856674432754517,
        0.1244334802031517,
        0.44733625650405884
      ],
      "plane_d": -635.658203125,
      "bbox_min": [
        554.7442016601562,
        1220.641845703125,
        -18.0
      ],
      "bbox_max": [
        555.3078002929688,
        1223.244384765625,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39011192321777344,
        0.8039982318878174,
        0.4487758278846741
      ],
      "plane_d": -1177.7916259765625,
      "bbox_min": [
        538.4282836914062,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        552.02734375,
        1216.2154541015625,
        10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 17.0,
      "bbox_min": [
        538.4282836914062,
        1196.544189453125,
        -20.0
      ],
      "bbox_max": [
        552.02734375,
        1216.2154541015625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542449474334717,
        -0.4931878447532654,
        -0.16441155970096588
      ],
      "plane_d": 1063.6240234375,
      "bbox_min": [
        547.37255859375,
        1212.1844482421875,
        -20.0
      ],
      "bbox_max": [
        552.02734375,
        1216.2154541015625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": 124.4674072265625,
      "bbox_min": [
        547.37255859375,
        1212.1844482421875,
        -20.0
      ],
      "bbox_max": [
        552.02734375,
        1216.2154541015625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9863938689231873,
        -0.16439898312091827
      ],
      "plane_d": 1192.896484375,
      "bbox_min": [
        547.37255859375,
        1212.1844482421875,
        -20.0
      ],
      "bbox_max": [
        552.02734375,
        1216.2154541015625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9863938689231873,
        -0.16439898312091827
      ],
      "plane_d": -1202.4622802734375,
      "bbox_min": [
        547.37255859375,
        1214.2000732421875,
        -20.0
      ],
      "bbox_max": [
        552.02734375,
        1216.2154541015625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -1073.231201171875,
      "bbox_min": [
        547.37255859375,
        1214.2000732421875,
        -20.0
      ],
      "bbox_max": [
        552.02734375,
        1216.2154541015625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542194962501526,
        0.4932328462600708,
        -0.1644088178873062
      ],
      "plane_d": -134.10195922851562,
      "bbox_min": [
        547.37255859375,
        1214.2000732421875,
        -20.0
      ],
      "bbox_max": [
        548.824951171875,
        1216.2154541015625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3919532001018524,
        0.8061860799789429,
        0.4432118833065033
      ],
      "plane_d": -1181.405029296875,
      "bbox_min": [
        538.4282836914062,
        1196.544189453125,
        -17.0
      ],
      "bbox_max": [
        551.37939453125,
        1215.9395751953125,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071195244789124,
        -0.7070940732955933,
        -0.0
      ],
      "plane_d": 1247.224853515625,
      "bbox_min": [
        547.9146728515625,
        1212.5452880859375,
        -17.0
      ],
      "bbox_max": [
        551.37939453125,
        1215.9395751953125,
        -8.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 469.9150390625,
      "bbox_min": [
        547.9146728515625,
        1212.5452880859375,
        -17.0
      ],
      "bbox_max": [
        551.37939453125,
        1215.9395751953125,
        -8.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660718202590942
      ],
      "plane_d": -593.14892578125,
      "bbox_min": [
        547.9146728515625,
        1214.2071533203125,
        -17.0
      ],
      "bbox_max": [
        551.37939453125,
        1215.9395751953125,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -252.51980590820312,
      "bbox_min": [
        549.6470947265625,
        1212.5452880859375,
        -17.0
      ],
      "bbox_max": [
        551.37939453125,
        1215.9395751953125,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 469.9150390625,
      "bbox_min": [
        547.9146728515625,
        1212.5452880859375,
        -17.0
      ],
      "bbox_max": [
        551.308837890625,
        1215.9395751953125,
        -8.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": 305.7345886230469,
      "bbox_min": [
        547.9146728515625,
        1212.5455322265625,
        -17.0
      ],
      "bbox_max": [
        549.6470947265625,
        1215.9395751953125,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156153440475464,
        0.8568202257156372
      ],
      "plane_d": 639.7937622070312,
      "bbox_min": [
        547.9853515625,
        1212.5452880859375,
        -17.0
      ],
      "bbox_max": [
        551.308837890625,
        1214.2071533203125,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": -941.1664428710938,
      "bbox_min": [
        367.0,
        715.0,
        -20.0
      ],
      "bbox_max": [
        633.0,
        1211.544189453125,
        10.000000953674316
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 990.0000610351562,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -20.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -19.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.5999755859375,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -20.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -19.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 481.0,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -20.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -19.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 613.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -20.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -19.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -20.0
      ],
      "bbox_max": [
        597.9696044921875,
        990.0000610351562,
        -19.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -20.0
      ],
      "bbox_max": [
        465.0,
        990.0,
        -19.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -3.0,
      "bbox_min": [
        459.1000061035156,
        715.0,
        -19.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        10.000000953674316
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 597.5687866210938,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        -3.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        10.000000953674316
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -481.4007873535156,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        -3.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        10.000000953674316
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -5.0,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        -3.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        10.000000953674316
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071056962013245,
        -0.7071078419685364,
        1.5413704659295036e-06
      ],
      "plane_d": 1043.2939453125,
      "bbox_min": [
        481.4007873535156,
        826.5046997070312,
        -3.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        5.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 911.8958740234375,
      "bbox_min": [
        481.4007873535156,
        826.5046997070312,
        -3.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        5.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        -7.706853466515895e-07
      ],
      "plane_d": 280.346923828125,
      "bbox_min": [
        481.4007873535156,
        826.5046997070312,
        -3.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        5.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 518.9696044921875,
      "bbox_min": [
        481.4007873535156,
        826.5046997070312,
        -3.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        518.9696044921875,
        826.5046997070312,
        -3.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -1.5,
      "bbox_min": [
        518.9696044921875,
        829.6143188476562,
        -3.0
      ],
      "bbox_max": [
        560.0,
        911.8958740234375,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -218.67095947265625,
      "bbox_min": [
        518.9696044921875,
        858.948974609375,
        -1.5
      ],
      "bbox_max": [
        560.0,
        911.8958740234375,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -998.3984985351562,
      "bbox_min": [
        532.3468017578125,
        858.948974609375,
        -1.5
      ],
      "bbox_max": [
        560.0,
        872.9349365234375,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -872.9349365234375,
      "bbox_min": [
        532.3468017578125,
        872.9349365234375,
        -1.5
      ],
      "bbox_max": [
        546.622802734375,
        872.9349365234375,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        518.9696044921875,
        909.250244140625,
        -1.5
      ],
      "bbox_max": [
        560.0,
        911.8958740234375,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        553.61279296875,
        909.250244140625,
        -1.5
      ],
      "bbox_max": [
        560.0,
        911.8958740234375,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7592566013336182,
        0.0,
        -0.6507914066314697
      ],
      "plane_d": -401.10443115234375,
      "bbox_min": [
        518.9696044921875,
        829.6143188476562,
        -3.0
      ],
      "bbox_max": [
        560.0,
        911.8958740234375,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -218.67095947265625,
      "bbox_min": [
        518.9696044921875,
        858.948974609375,
        -3.0
      ],
      "bbox_max": [
        527.0,
        911.8958740234375,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        518.9696044921875,
        909.250244140625,
        -3.0
      ],
      "bbox_max": [
        525.3568115234375,
        911.8958740234375,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7592565417289734,
        -0.0,
        -0.650791347026825
      ],
      "plane_d": 418.1334228515625,
      "bbox_min": [
        525.7142944335938,
        829.6143188476562,
        -3.0
      ],
      "bbox_max": [
        560.0,
        911.8958740234375,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -998.3984985351562,
      "bbox_min": [
        552.0,
        858.948974609375,
        -3.0
      ],
      "bbox_max": [
        560.0,
        911.8958740234375,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        553.61279296875,
        909.250244140625,
        -3.0
      ],
      "bbox_max": [
        560.0,
        911.8958740234375,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7592566013336182,
        -0.6507914066314697
      ],
      "plane_d": -631.842529296875,
      "bbox_min": [
        525.7142944335938,
        829.6143188476562,
        -3.0
      ],
      "bbox_max": [
        553.2857055664062,
        872.9349365234375,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7592566609382629,
        -0.6507914066314697
      ],
      "plane_d": 655.4011840820312,
      "bbox_min": [
        525.7142944335938,
        858.9476318359375,
        -3.0
      ],
      "bbox_max": [
        553.2857055664062,
        872.9349365234375,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -872.9349365234375,
      "bbox_min": [
        525.7142944335938,
        865.9688110351562,
        -3.0
      ],
      "bbox_max": [
        553.2857055664062,
        872.9349365234375,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -998.3984985351562,
      "bbox_min": [
        525.7142944335938,
        865.9688110351562,
        -3.0
      ],
      "bbox_max": [
        553.2857055664062,
        872.9349365234375,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -218.67095947265625,
      "bbox_min": [
        525.7142944335938,
        866.0006103515625,
        -3.0
      ],
      "bbox_max": [
        532.3468017578125,
        872.9349365234375,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.592878520488739,
        -0.4743027985095978,
        -0.6507933139801025
      ],
      "plane_d": 733.6940307617188,
      "bbox_min": [
        525.7142944335938,
        858.9476318359375,
        -3.0
      ],
      "bbox_max": [
        553.2857055664062,
        865.7857055664062,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.592878520488739,
        -0.4743027687072754,
        -0.6507933735847473
      ],
      "plane_d": 93.97805786132812,
      "bbox_min": [
        525.7142944335938,
        858.9476318359375,
        -3.0
      ],
      "bbox_max": [
        531.44189453125,
        865.7857055664062,
        -1.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        560.0,
        826.5046997070312,
        -3.0
      ],
      "bbox_max": [
        597.5687866210938,
        909.250244140625,
        5.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 573.0927124023438,
      "bbox_min": [
        573.0927734375,
        826.5046997070312,
        4.769879341125488
      ],
      "bbox_max": [
        573.0927734375,
        827.0,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.42566201090812683,
        0.9048822522163391
      ],
      "plane_d": -356.5469055175781,
      "bbox_min": [
        560.0,
        827.0,
        -3.0
      ],
      "bbox_max": [
        597.5687866210938,
        909.250244140625,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -573.5927734375,
      "bbox_min": [
        573.0927734375,
        827.0,
        -3.0
      ],
      "bbox_max": [
        573.5928344726562,
        844.0066528320312,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 573.0927124023438,
      "bbox_min": [
        573.0927734375,
        827.0,
        -3.0
      ],
      "bbox_max": [
        573.0927734375,
        844.0066528320312,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.910394757942413e-06,
        -0.0
      ],
      "plane_d": -573.5944213867188,
      "bbox_min": [
        560.0,
        827.0,
        -3.0
      ],
      "bbox_max": [
        597.5687866210938,
        909.250244140625,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38518548011779785,
        0.38884031772613525,
        0.8369202017784119
      ],
      "plane_d": -108.16363525390625,
      "bbox_min": [
        573.0927734375,
        835.1140747070312,
        -3.0
      ],
      "bbox_max": [
        573.5927734375,
        852.5098876953125,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0819769874215126,
        0.42422959208488464,
        0.9018364548683167
      ],
      "plane_d": -311.9330139160156,
      "bbox_min": [
        573.1935424804688,
        835.4776000976562,
        -3.0
      ],
      "bbox_max": [
        573.5927734375,
        852.5098876953125,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        560.0,
        904.87353515625,
        -3.0
      ],
      "bbox_max": [
        570.56640625,
        909.250244140625,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238811135292053,
        -0.38267987966537476,
        -3.244017250381148e-07
      ],
      "plane_d": 884.2257080078125,
      "bbox_min": [
        590.5464477539062,
        867.93994140625,
        -3.0
      ],
      "bbox_max": [
        597.5687866210938,
        884.8935546875,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        481.4007873535156,
        826.5056762695312,
        -3.0
      ],
      "bbox_max": [
        518.9696044921875,
        909.250244140625,
        5.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -505.87677001953125,
      "bbox_min": [
        505.8768005371094,
        826.5056762695312,
        4.770325660705566
      ],
      "bbox_max": [
        505.8768005371094,
        827.0,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.42566201090812683,
        0.9048822522163391
      ],
      "plane_d": -356.5469055175781,
      "bbox_min": [
        481.4007873535156,
        827.0,
        -3.0
      ],
      "bbox_max": [
        518.9696044921875,
        909.250244140625,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 505.3768005371094,
      "bbox_min": [
        505.3768005371094,
        827.0,
        -3.0
      ],
      "bbox_max": [
        505.8768005371094,
        844.0066528320312,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -505.87677001953125,
      "bbox_min": [
        505.8768005371094,
        827.0,
        -3.0
      ],
      "bbox_max": [
        505.8768005371094,
        844.0066528320312,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 505.3768005371094,
      "bbox_min": [
        481.4007873535156,
        827.0,
        -3.0
      ],
      "bbox_max": [
        518.9696044921875,
        909.250244140625,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38454654812812805,
        0.3889622688293457,
        0.8371573090553284
      ],
      "plane_d": -523.547119140625,
      "bbox_min": [
        505.3768005371094,
        835.1148071289062,
        -3.0
      ],
      "bbox_max": [
        505.8768005371094,
        852.5098876953125,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0819769874215126,
        0.42422959208488464,
        0.9018364548683167
      ],
      "plane_d": -400.3836364746094,
      "bbox_min": [
        505.3768005371094,
        835.4776000976562,
        -3.0
      ],
      "bbox_max": [
        505.7760314941406,
        852.5098876953125,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        508.4031982421875,
        904.87353515625,
        -3.0
      ],
      "bbox_max": [
        518.9696044921875,
        909.250244140625,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238793253898621,
        -0.3826841115951538,
        7.159964638958627e-07
      ],
      "plane_d": -112.609375,
      "bbox_min": [
        481.4007873535156,
        867.93994140625,
        -3.0
      ],
      "bbox_max": [
        488.4232177734375,
        884.8935546875,
        5.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 518.9696044921875,
      "bbox_min": [
        481.4007873535156,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        10.000000953674316
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        518.9696044921875,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        597.5687866210938,
        911.8958740234375,
        10.000000953674316
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 911.8958740234375,
      "bbox_min": [
        518.9696044921875,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        560.0,
        911.8958740234375,
        10.000000953674316
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 559.2000122070312,
      "bbox_min": [
        518.9696044921875,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        560.0,
        911.8958740234375,
        10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -9.0,
      "bbox_min": [
        559.2000122070312,
        813.3131713867188,
        5.0
      ],
      "bbox_max": [
        560.0,
        909.5816040039062,
        10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6891108751296997,
        0.7246559858322144,
        0.0
      ],
      "plane_d": -204.02142333984375,
      "bbox_min": [
        559.2000122070312,
        813.3131713867188,
        5.0
      ],
      "bbox_max": [
        560.0,
        827.0,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 827.0,
      "bbox_min": [
        559.2000122070312,
        827.0,
        5.0
      ],
      "bbox_max": [
        560.0,
        827.0,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        559.2000122070312,
        909.250244140625,
        5.0
      ],
      "bbox_max": [
        560.0,
        909.5816040039062,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6891108751296997,
        0.7246559858322144,
        0.0
      ],
      "plane_d": -204.02142333984375,
      "bbox_min": [
        559.2000122070312,
        813.3131713867188,
        9.0
      ],
      "bbox_max": [
        560.0,
        909.5816040039062,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        559.2000122070312,
        909.250244140625,
        9.0
      ],
      "bbox_max": [
        560.0,
        909.5816040039062,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -519.7695922851562,
      "bbox_min": [
        518.9696044921875,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        911.8958740234375,
        10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -9.0,
      "bbox_min": [
        518.9696044921875,
        813.3131713867188,
        5.0
      ],
      "bbox_max": [
        519.7695922851562,
        909.5816040039062,
        10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6891113519668579,
        0.7246554493904114,
        0.0
      ],
      "plane_d": -947.5509643554688,
      "bbox_min": [
        518.9696044921875,
        813.3131713867188,
        5.0
      ],
      "bbox_max": [
        519.7695922851562,
        827.0,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 827.0,
      "bbox_min": [
        518.9696044921875,
        827.0,
        5.0
      ],
      "bbox_max": [
        519.7695922851562,
        827.0,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        518.9696044921875,
        909.250244140625,
        5.0
      ],
      "bbox_max": [
        519.7695922851562,
        909.5816040039062,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6891113519668579,
        0.7246554493904114,
        0.0
      ],
      "plane_d": -947.5509643554688,
      "bbox_min": [
        518.9696044921875,
        813.3131713867188,
        9.0
      ],
      "bbox_max": [
        519.7695922851562,
        909.5816040039062,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        518.9696044921875,
        909.250244140625,
        9.0
      ],
      "bbox_max": [
        519.7695922851562,
        909.5816040039062,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -218.67095947265625,
      "bbox_min": [
        519.7695922851562,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        911.8958740234375,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -998.3984985351562,
      "bbox_min": [
        519.7695922851562,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        872.9349365234375,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226603031158447,
        -0.6912033557891846,
        -0.0
      ],
      "plane_d": 997.59814453125,
      "bbox_min": [
        519.7695922851562,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        872.9349365234375,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -9.0,
      "bbox_min": [
        545.5157470703125,
        858.6279296875,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        872.9349365234375,
        9.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -9.0,
      "bbox_min": [
        519.7695922851562,
        858.6279296875,
        5.0
      ],
      "bbox_max": [
        533.4537353515625,
        872.9349365234375,
        9.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 872.1349487304688,
      "bbox_min": [
        519.7695922851562,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        872.9349365234375,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -9.0,
      "bbox_min": [
        532.6886596679688,
        872.1349487304688,
        5.0
      ],
      "bbox_max": [
        546.2809448242188,
        872.9349365234375,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -872.9349365234375,
      "bbox_min": [
        533.4537353515625,
        872.9349365234375,
        5.0
      ],
      "bbox_max": [
        545.5157470703125,
        872.9349365234375,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 851.9005126953125,
      "bbox_min": [
        519.7695922851562,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        861.6000366210938,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866024911403656,
        -0.5000009536743164,
        0.0
      ],
      "plane_d": -46.032440185546875,
      "bbox_min": [
        528.199951171875,
        851.9005126953125,
        5.0
      ],
      "bbox_max": [
        550.5999755859375,
        861.6000366210938,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660272359848022,
        -0.4999968409538269,
        0.0
      ],
      "plane_d": 888.2328491210938,
      "bbox_min": [
        528.199951171875,
        851.9005126953125,
        5.0
      ],
      "bbox_max": [
        550.5999755859375,
        861.6000366210938,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -852.7665405273438,
      "bbox_min": [
        528.199951171875,
        852.7665405273438,
        5.0
      ],
      "bbox_max": [
        550.5999755859375,
        861.6000366210938,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660247921943665,
        0.5000011324882507,
        0.0
      ],
      "plane_d": 45.16619873046875,
      "bbox_min": [
        528.199951171875,
        852.7665405273438,
        5.0
      ],
      "bbox_max": [
        550.5999755859375,
        861.6000366210938,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -861.6000366210938,
      "bbox_min": [
        549.5999755859375,
        861.6000366210938,
        5.0
      ],
      "bbox_max": [
        550.5999755859375,
        861.6000366210938,
        10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660273551940918,
        0.4999966323375702,
        0.0
      ],
      "plane_d": -889.0987548828125,
      "bbox_min": [
        528.199951171875,
        852.7665405273438,
        5.0
      ],
      "bbox_max": [
        549.5999755859375,
        861.6000366210938,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -861.6000366210938,
      "bbox_min": [
        528.199951171875,
        861.6000366210938,
        5.0
      ],
      "bbox_max": [
        529.199951171875,
        861.6000366210938,
        10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -861.6000366210938,
      "bbox_min": [
        547.3999633789062,
        861.6000366210938,
        5.0
      ],
      "bbox_max": [
        549.5999755859375,
        861.6000366210938,
        8.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -854.6718139648438,
      "bbox_min": [
        537.89990234375,
        854.6718139648438,
        5.0
      ],
      "bbox_max": [
        543.3999633789062,
        854.6718139648438,
        7.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660261034965515,
        0.4999989867210388,
        0.0
      ],
      "plane_d": -891.00537109375,
      "bbox_min": [
        529.199951171875,
        854.6718139648438,
        5.0
      ],
      "bbox_max": [
        539.3999633789062,
        861.6000366210938,
        8.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -861.6000366210938,
      "bbox_min": [
        529.199951171875,
        861.6000366210938,
        5.0
      ],
      "bbox_max": [
        531.3999633789062,
        861.6000366210938,
        8.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -854.6718139648438,
      "bbox_min": [
        535.3999633789062,
        854.6718139648438,
        5.681838512420654
      ],
      "bbox_max": [
        543.3999633789062,
        854.6718139648438,
        7.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -854.6718139648438,
      "bbox_min": [
        535.3999633789062,
        854.6718139648438,
        7.5
      ],
      "bbox_max": [
        543.3999633789062,
        854.6718139648438,
        8.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 555.2000122070312,
      "bbox_min": [
        519.7695922851562,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        850.0,
        10.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -7.0,
      "bbox_min": [
        555.2000122070312,
        809.5093383789062,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        850.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6891108751296997,
        0.7246559858322144,
        0.0
      ],
      "plane_d": -204.02142333984375,
      "bbox_min": [
        555.2000122070312,
        809.5093383789062,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        850.0,
        7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 835.0,
      "bbox_min": [
        555.2000122070312,
        835.0,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        850.0,
        7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        555.2000122070312,
        850.0,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        850.0,
        7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6891108751296997,
        0.7246559858322144,
        0.0
      ],
      "plane_d": -204.02142333984375,
      "bbox_min": [
        555.2000122070312,
        809.5093383789062,
        7.0
      ],
      "bbox_max": [
        559.2000122070312,
        850.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 756.2736206054688,
      "bbox_min": [
        555.2000122070312,
        835.0,
        7.0
      ],
      "bbox_max": [
        559.2000122070312,
        850.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -7.399993896484375,
      "bbox_min": [
        555.2000122070312,
        849.199951171875,
        7.0
      ],
      "bbox_max": [
        559.2000122070312,
        850.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -763.427978515625,
      "bbox_min": [
        555.2000122070312,
        849.800048828125,
        7.0
      ],
      "bbox_max": [
        559.2000122070312,
        850.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977863430976868,
        0.0,
        0.06650284677743912
      ],
      "plane_d": 556.0997924804688,
      "bbox_min": [
        555.2000122070312,
        835.0,
        7.0
      ],
      "bbox_max": [
        559.2000122070312,
        849.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 836.0,
      "bbox_min": [
        557.800048828125,
        835.0,
        7.0
      ],
      "bbox_max": [
        559.2000122070312,
        849.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -849.0,
      "bbox_min": [
        557.8001098632812,
        849.0,
        7.0
      ],
      "bbox_max": [
        559.2000122070312,
        849.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -7.399993896484375,
      "bbox_min": [
        557.800048828125,
        835.0,
        7.0
      ],
      "bbox_max": [
        559.2000122070312,
        836.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 743.7510375976562,
      "bbox_min": [
        557.800048828125,
        835.0,
        7.0
      ],
      "bbox_max": [
        559.2000122070312,
        836.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -750.9053955078125,
      "bbox_min": [
        557.8001098632812,
        835.800048828125,
        7.0
      ],
      "bbox_max": [
        559.2000122070312,
        836.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 743.7510375976562,
      "bbox_min": [
        555.2000122070312,
        835.0,
        7.0
      ],
      "bbox_max": [
        557.8267822265625,
        836.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -750.9053955078125,
      "bbox_min": [
        555.2000122070312,
        835.800048828125,
        7.0
      ],
      "bbox_max": [
        557.8267822265625,
        836.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -523.7695922851562,
      "bbox_min": [
        519.7695922851562,
        799.7999877929688,
        5.0
      ],
      "bbox_max": [
        555.2000122070312,
        850.0,
        10.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -7.0,
      "bbox_min": [
        519.7695922851562,
        809.5093383789062,
        5.0
      ],
      "bbox_max": [
        523.7695922851562,
        850.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6891113519668579,
        0.7246554493904114,
        0.0
      ],
      "plane_d": -947.5509643554688,
      "bbox_min": [
        519.7695922851562,
        809.5093383789062,
        5.0
      ],
      "bbox_max": [
        523.7695922851562,
        850.0,
        7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 835.0,
      "bbox_min": [
        519.7695922851562,
        835.0,
        5.0
      ],
      "bbox_max": [
        523.7695922851562,
        850.0,
        7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        519.7695922851562,
        850.0,
        5.0
      ],
      "bbox_max": [
        523.7695922851562,
        850.0,
        7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6891113519668579,
        0.7246554493904114,
        0.0
      ],
      "plane_d": -947.5509643554688,
      "bbox_min": [
        519.7695922851562,
        809.5093383789062,
        7.0
      ],
      "bbox_max": [
        523.7695922851562,
        850.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 756.2736206054688,
      "bbox_min": [
        519.7695922851562,
        835.0,
        7.0
      ],
      "bbox_max": [
        523.7695922851562,
        850.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -7.399993896484375,
      "bbox_min": [
        519.7695922851562,
        849.199951171875,
        7.0
      ],
      "bbox_max": [
        523.7695922851562,
        850.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -763.427978515625,
      "bbox_min": [
        519.7695922851562,
        849.800048828125,
        7.0
      ],
      "bbox_max": [
        523.7695922851562,
        850.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977863430976868,
        -0.0,
        0.06650284677743912
      ],
      "plane_d": -520.4813232421875,
      "bbox_min": [
        519.7695922851562,
        835.0,
        7.0
      ],
      "bbox_max": [
        523.7695922851562,
        849.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 836.0,
      "bbox_min": [
        519.7695922851562,
        835.0,
        7.0
      ],
      "bbox_max": [
        521.1694946289062,
        849.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -849.0,
      "bbox_min": [
        519.7695922851562,
        849.0,
        7.0
      ],
      "bbox_max": [
        521.1694946289062,
        849.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -7.399993896484375,
      "bbox_min": [
        519.7695922851562,
        835.0,
        7.0
      ],
      "bbox_max": [
        521.1694946289062,
        836.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -750.9053955078125,
      "bbox_min": [
        519.7695922851562,
        835.0,
        7.0
      ],
      "bbox_max": [
        521.1694946289062,
        836.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 743.7510375976562,
      "bbox_min": [
        519.7695922851562,
        835.0,
        7.0
      ],
      "bbox_max": [
        521.1694946289062,
        835.199951171875,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -7.399993896484375,
      "bbox_min": [
        521.142822265625,
        835.0,
        7.0
      ],
      "bbox_max": [
        523.7695922851562,
        836.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 743.7510375976562,
      "bbox_min": [
        521.142822265625,
        835.0,
        7.0
      ],
      "bbox_max": [
        523.7695922851562,
        836.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -750.9053955078125,
      "bbox_min": [
        521.142822265625,
        835.800048828125,
        7.0
      ],
      "bbox_max": [
        523.7695922851562,
        836.0,
        7.399993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -808.0,
      "bbox_min": [
        546.313720703125,
        808.0,
        5.0
      ],
      "bbox_max": [
        555.2000122070312,
        813.3082275390625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6891108751296997,
        0.7246559858322144,
        0.0
      ],
      "plane_d": -204.02142333984375,
      "bbox_min": [
        546.313720703125,
        808.0,
        5.0
      ],
      "bbox_max": [
        555.2000122070312,
        813.3082275390625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -547.2000122070312,
      "bbox_min": [
        547.2000122070312,
        808.0,
        5.0
      ],
      "bbox_max": [
        547.2000122070312,
        808.5,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -8.0,
      "bbox_min": [
        549.7255859375,
        809.2772216796875,
        5.0
      ],
      "bbox_max": [
        554.38037109375,
        813.3082275390625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542449474334717,
        -0.4931878447532654,
        -0.16441155970096588
      ],
      "plane_d": 871.035400390625,
      "bbox_min": [
        549.7255859375,
        809.2772216796875,
        5.0
      ],
      "bbox_max": [
        554.38037109375,
        813.3082275390625,
        8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": -72.14175415039062,
      "bbox_min": [
        549.7255859375,
        809.2772216796875,
        5.0
      ],
      "bbox_max": [
        554.38037109375,
        813.3082275390625,
        8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9863938689231873,
        -0.16439898312091827
      ],
      "plane_d": -800.927001953125,
      "bbox_min": [
        549.7255859375,
        811.2928466796875,
        5.0
      ],
      "bbox_max": [
        554.38037109375,
        813.3082275390625,
        8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -872.4039306640625,
      "bbox_min": [
        549.7255859375,
        811.2928466796875,
        5.0
      ],
      "bbox_max": [
        554.38037109375,
        813.3082275390625,
        8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542194962501526,
        0.4932328462600708,
        -0.1644088178873062
      ],
      "plane_d": 70.74530029296875,
      "bbox_min": [
        549.7255859375,
        811.2928466796875,
        5.0
      ],
      "bbox_max": [
        551.177978515625,
        813.3082275390625,
        8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 183.35281372070312,
      "bbox_min": [
        550.5,
        809.7999877929688,
        8.0
      ],
      "bbox_max": [
        553.5,
        812.7999877929688,
        10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -457.5167236328125,
      "bbox_min": [
        550.5,
        811.2999877929688,
        8.0
      ],
      "bbox_max": [
        553.5,
        812.7999877929688,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001361846924,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 298.7060241699219,
      "bbox_min": [
        550.5,
        809.7999877929688,
        8.0
      ],
      "bbox_max": [
        552.0,
        812.7999877929688,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 963.998779296875,
      "bbox_min": [
        550.5,
        809.7999877929688,
        8.0
      ],
      "bbox_max": [
        553.5,
        812.7999877929688,
        10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -808.0,
      "bbox_min": [
        523.7695922851562,
        808.0,
        5.0
      ],
      "bbox_max": [
        532.1715698242188,
        809.5093383789062,
        10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6891113519668579,
        0.7246554493904114,
        0.0
      ],
      "plane_d": -947.5509643554688,
      "bbox_min": [
        523.7695922851562,
        808.0,
        5.0
      ],
      "bbox_max": [
        532.1715698242188,
        809.5093383789062,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 531.2000122070312,
      "bbox_min": [
        531.2000122070312,
        808.0,
        5.0
      ],
      "bbox_max": [
        531.2000122070312,
        808.5,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        519.7695922851562,
        909.5816040039062,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        911.8958740234375,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        553.61279296875,
        909.5816040039062,
        5.0
      ],
      "bbox_max": [
        559.2000122070312,
        911.8958740234375,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071056962013245,
        -0.7071078419685364,
        1.5413704659295036e-06
      ],
      "plane_d": 1043.2939453125,
      "bbox_min": [
        560.0,
        814.0739135742188,
        5.0
      ],
      "bbox_max": [
        597.5687866210938,
        909.250244140625,
        10.000000953674316
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        560.0,
        814.0739135742188,
        5.0
      ],
      "bbox_max": [
        597.5687866210938,
        909.250244140625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6891108751296997,
        0.7246559858322144,
        0.0
      ],
      "plane_d": -204.02142333984375,
      "bbox_min": [
        560.0,
        814.0739135742188,
        5.0
      ],
      "bbox_max": [
        573.5928344726562,
        827.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38518548011779785,
        0.38884031772613525,
        0.8369202017784119
      ],
      "plane_d": -108.16363525390625,
      "bbox_min": [
        573.0927734375,
        826.5046997070312,
        8.990823745727539
      ],
      "bbox_max": [
        573.5927734375,
        827.0,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38518548011779785,
        0.38884031772613525,
        0.8369202017784119
      ],
      "plane_d": -108.16363525390625,
      "bbox_min": [
        573.0927734375,
        826.5244750976562,
        8.769878387451172
      ],
      "bbox_max": [
        573.5927734375,
        827.0,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238811135292053,
        -0.38267987966537476,
        -3.244017250381148e-07
      ],
      "plane_d": 884.2257080078125,
      "bbox_min": [
        560.0,
        827.0,
        5.0
      ],
      "bbox_max": [
        597.5687866210938,
        909.250244140625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        560.0,
        827.0,
        5.0
      ],
      "bbox_max": [
        573.5928344726562,
        909.250244140625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.910394757942413e-06,
        -0.0
      ],
      "plane_d": -573.5944213867188,
      "bbox_min": [
        573.0927734375,
        827.0,
        5.0
      ],
      "bbox_max": [
        573.5928344726562,
        835.5032958984375,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38518548011779785,
        0.38884031772613525,
        0.8369202017784119
      ],
      "plane_d": -108.16363525390625,
      "bbox_min": [
        573.0927734375,
        827.0,
        5.0
      ],
      "bbox_max": [
        573.5927734375,
        835.4776000976562,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        481.4007873535156,
        814.0739135742188,
        5.0
      ],
      "bbox_max": [
        518.9696044921875,
        909.250244140625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6891113519668579,
        0.7246554493904114,
        0.0
      ],
      "plane_d": -947.5509643554688,
      "bbox_min": [
        505.3768005371094,
        814.0739135742188,
        5.0
      ],
      "bbox_max": [
        518.9696044921875,
        827.0,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38454654812812805,
        0.3889622688293457,
        0.8371573090553284
      ],
      "plane_d": -523.547119140625,
      "bbox_min": [
        505.3768005371094,
        826.5056762695312,
        8.991196632385254
      ],
      "bbox_max": [
        505.8768005371094,
        827.0,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38454654812812805,
        0.3889622688293457,
        0.8371573090553284
      ],
      "plane_d": -523.547119140625,
      "bbox_min": [
        505.3768005371094,
        826.5245971679688,
        8.770325660705566
      ],
      "bbox_max": [
        505.8768005371094,
        827.0,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238793253898621,
        -0.3826841115951538,
        7.159964638958627e-07
      ],
      "plane_d": -112.609375,
      "bbox_min": [
        481.4007873535156,
        827.0,
        5.0
      ],
      "bbox_max": [
        518.9696044921875,
        909.250244140625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        505.3768005371094,
        827.0,
        5.0
      ],
      "bbox_max": [
        518.9696044921875,
        909.250244140625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 505.3768005371094,
      "bbox_min": [
        505.3768005371094,
        827.0,
        5.0
      ],
      "bbox_max": [
        505.8768005371094,
        835.5032958984375,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38454654812812805,
        0.3889622688293457,
        0.8371573090553284
      ],
      "plane_d": -523.547119140625,
      "bbox_min": [
        505.3768005371094,
        827.0,
        5.0
      ],
      "bbox_max": [
        505.8768005371094,
        835.4776000976562,
        9.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -505.87677001953125,
      "bbox_min": [
        505.8768005371094,
        827.0,
        5.0
      ],
      "bbox_max": [
        505.8768005371094,
        835.1148071289062,
        8.770325660705566
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -7.0,
      "bbox_min": [
        459.1000061035156,
        715.0,
        -19.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -3.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 619.8696899414062,
      "bbox_min": [
        459.1000061035156,
        715.0,
        -7.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -459.1000061035156,
      "bbox_min": [
        459.1000061035156,
        715.0,
        -7.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 487.19000244140625,
      "bbox_min": [
        459.1000061035156,
        715.0,
        -7.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -591.7796020507812,
      "bbox_min": [
        487.19000244140625,
        715.0,
        -7.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -524.0,
      "bbox_min": [
        487.19000244140625,
        715.0,
        -7.0
      ],
      "bbox_max": [
        591.7796020507812,
        926.0867919921875,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 999.337646484375,
      "bbox_min": [
        487.19000244140625,
        715.0,
        -7.0
      ],
      "bbox_max": [
        524.0,
        926.0867309570312,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        508.4031982421875,
        904.87353515625,
        -7.0
      ],
      "bbox_max": [
        524.0,
        911.3338623046875,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.16439899802207947,
        -0.9863939881324768
      ],
      "plane_d": -123.95684814453125,
      "bbox_min": [
        487.19000244140625,
        715.0,
        -7.0
      ],
      "bbox_max": [
        524.0,
        886.1267700195312,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161494255066,
        -0.9805806875228882
      ],
      "plane_d": 141.20362854003906,
      "bbox_min": [
        487.19000244140625,
        715.0,
        -7.0
      ],
      "bbox_max": [
        524.0,
        886.1267700195312,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 505.3768005371094,
      "bbox_min": [
        487.19000244140625,
        795.0,
        -7.0
      ],
      "bbox_max": [
        524.0,
        886.1267700195312,
        -3.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.26764383912086487,
        0.0,
        -0.9635179042816162
      ],
      "plane_d": -143.67120361328125,
      "bbox_min": [
        505.3768005371094,
        795.0,
        -7.0
      ],
      "bbox_max": [
        524.0,
        869.8622436523438,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 518.9696044921875,
      "bbox_min": [
        505.3768005371094,
        843.7239379882812,
        -7.0
      ],
      "bbox_max": [
        524.0,
        869.8622436523438,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -218.67095947265625,
      "bbox_min": [
        518.9696044921875,
        858.948974609375,
        -4.952878475189209
      ],
      "bbox_max": [
        524.0,
        864.2083129882812,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.42566201090812683,
        0.9048822522163391
      ],
      "plane_d": -356.5469055175781,
      "bbox_min": [
        505.3768005371094,
        843.7239379882812,
        -7.0
      ],
      "bbox_max": [
        518.9696044921875,
        869.8622436523438,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -505.87677001953125,
      "bbox_min": [
        505.8768005371094,
        843.7239379882812,
        -7.0
      ],
      "bbox_max": [
        505.8768005371094,
        852.5098876953125,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9280772805213928,
        0.3723878860473633,
        0.0
      ],
      "plane_d": 149.16653442382812,
      "bbox_min": [
        505.3768005371094,
        844.0066528320312,
        -7.0
      ],
      "bbox_max": [
        511.01934814453125,
        869.8622436523438,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -505.87677001953125,
      "bbox_min": [
        505.3768005371094,
        844.0066528320312,
        -7.0
      ],
      "bbox_max": [
        511.01934814453125,
        869.8622436523438,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0819769874215126,
        0.42422959208488464,
        0.9018364548683167
      ],
      "plane_d": -400.3836364746094,
      "bbox_min": [
        505.3768005371094,
        852.3330688476562,
        -6.028999328613281
      ],
      "bbox_max": [
        505.8768005371094,
        860.195068359375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38454654812812805,
        0.3889622688293457,
        0.8371573090553284
      ],
      "plane_d": -523.547119140625,
      "bbox_min": [
        505.7760314941406,
        852.3330688476562,
        -6.028999328613281
      ],
      "bbox_max": [
        505.8768005371094,
        858.8523559570312,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 6.028998851776123,
      "bbox_min": [
        505.3768005371094,
        858.8523559570312,
        -6.028999328613281
      ],
      "bbox_max": [
        505.8768005371094,
        860.195068359375,
        -6.028999328613281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 6.028998851776123,
      "bbox_min": [
        505.8768005371094,
        858.8523559570312,
        -7.0
      ],
      "bbox_max": [
        511.01934814453125,
        869.8622436523438,
        -6.028999328613281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2306719720363617,
        0.35813379287719727,
        0.9047268629074097
      ],
      "plane_d": -422.9747314453125,
      "bbox_min": [
        505.8768005371094,
        858.8523559570312,
        -7.0
      ],
      "bbox_max": [
        511.01934814453125,
        869.8622436523438,
        -6.028999328613281
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9280769228935242,
        -0.37238869071006775,
        -7.080685463733971e-06
      ],
      "plane_d": -149.66571044921875,
      "bbox_min": [
        505.8768005371094,
        858.8523559570312,
        -7.0
      ],
      "bbox_max": [
        511.01934814453125,
        869.8622436523438,
        -6.028999328613281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7226598858833313,
        -0.6912038326263428,
        0.0
      ],
      "plane_d": 231.7630615234375,
      "bbox_min": [
        509.5747985839844,
        868.068603515625,
        -7.0
      ],
      "bbox_max": [
        511.01934814453125,
        869.8622436523438,
        -6.028999328613281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -232.26373291015625,
      "bbox_min": [
        510.0747375488281,
        869.314697265625,
        -7.0
      ],
      "bbox_max": [
        510.5984802246094,
        869.8622436523438,
        -6.649725914001465
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 518.9696044921875,
      "bbox_min": [
        511.5999450683594,
        848.1580810546875,
        -7.0
      ],
      "bbox_max": [
        524.0,
        864.2083129882812,
        -3.55554461479187
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -218.67095947265625,
      "bbox_min": [
        518.9696044921875,
        858.948974609375,
        -7.0
      ],
      "bbox_max": [
        524.0,
        864.2083129882812,
        -3.55554461479187
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.42566201090812683,
        0.9048822522163391
      ],
      "plane_d": -356.5469055175781,
      "bbox_min": [
        511.5999450683594,
        848.1580810546875,
        -7.0
      ],
      "bbox_max": [
        518.9696044921875,
        852.5098876953125,
        -4.952878475189209
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238793253898621,
        -0.3826841115951538,
        7.159964638958627e-07
      ],
      "plane_d": -112.609375,
      "bbox_min": [
        487.19000244140625,
        881.9163208007812,
        -7.0
      ],
      "bbox_max": [
        488.4232177734375,
        886.1267700195312,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -971.0816650390625,
      "bbox_min": [
        487.19000244140625,
        884.8935546875,
        -7.0
      ],
      "bbox_max": [
        488.4232177734375,
        886.1267700195312,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -715.0,
      "bbox_min": [
        487.19000244140625,
        715.0,
        -7.0
      ],
      "bbox_max": [
        511.0,
        755.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        -0.371390700340271,
        -0.0
      ],
      "plane_d": 749.28076171875,
      "bbox_min": [
        487.19000244140625,
        715.0,
        -7.0
      ],
      "bbox_max": [
        511.0,
        755.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 511.0,
      "bbox_min": [
        487.19000244140625,
        715.0,
        -7.0
      ],
      "bbox_max": [
        511.0,
        755.0,
        -4.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -174.55361938476562,
      "bbox_min": [
        487.19000244140625,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        755.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        489.6000061035156,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        740.0,
        -4.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -733.5999755859375,
      "bbox_min": [
        489.6000061035156,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        490.0,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 733.2000122070312,
      "bbox_min": [
        489.6000061035156,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        490.0,
        733.5999755859375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 489.6000061035156,
      "bbox_min": [
        489.6000061035156,
        733.2000122070312,
        -7.0
      ],
      "bbox_max": [
        489.6000061035156,
        733.5999755859375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -727.199951171875,
      "bbox_min": [
        489.6000061035156,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        490.0,
        727.199951171875,
        -4.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 489.5999755859375,
      "bbox_min": [
        489.6000061035156,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        490.0,
        727.199951171875,
        -4.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 726.7999877929688,
      "bbox_min": [
        489.6000061035156,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        490.0,
        726.7999877929688,
        -4.533335208892822
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 489.6000061035156,
      "bbox_min": [
        489.6000061035156,
        739.5999755859375,
        -7.0
      ],
      "bbox_max": [
        490.0,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        489.6000061035156,
        739.5999755859375,
        -7.0
      ],
      "bbox_max": [
        490.0,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 739.5999755859375,
      "bbox_min": [
        489.6000061035156,
        739.5999755859375,
        -7.0
      ],
      "bbox_max": [
        490.0,
        739.5999755859375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 733.2000122070312,
      "bbox_min": [
        505.0,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 739.5999755859375,
      "bbox_min": [
        505.0,
        733.2000122070312,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -505.3999938964844,
      "bbox_min": [
        505.0,
        739.5999755859375,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 505.0,
      "bbox_min": [
        505.0,
        739.5999755859375,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        505.0,
        740.0,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -733.5999755859375,
      "bbox_min": [
        505.0,
        733.2000122070312,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        733.5999755859375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -505.3999938964844,
      "bbox_min": [
        505.0,
        733.2000122070312,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        733.5999755859375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 505.0,
      "bbox_min": [
        505.0,
        733.2000122070312,
        -7.0
      ],
      "bbox_max": [
        505.0,
        733.5999755859375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -727.199951171875,
      "bbox_min": [
        505.0,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        727.199951171875,
        -4.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -505.3999938964844,
      "bbox_min": [
        505.0,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        727.199951171875,
        -4.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 504.9999694824219,
      "bbox_min": [
        505.0,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        727.199951171875,
        -4.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 726.7999877929688,
      "bbox_min": [
        505.0,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        505.3999938964844,
        726.7999877929688,
        -4.533335208892822
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 555.0,
      "bbox_min": [
        524.0,
        715.0,
        -7.0
      ],
      "bbox_max": [
        591.7796020507812,
        926.0867919921875,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071077823638916,
        -0.7071057558059692,
        0.0
      ],
      "plane_d": 236.38937377929688,
      "bbox_min": [
        555.0,
        715.0,
        -7.0
      ],
      "bbox_max": [
        591.7796020507812,
        926.0867919921875,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        555.0,
        904.87353515625,
        -7.0
      ],
      "bbox_max": [
        570.56640625,
        911.3212890625,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.16439899802207947,
        -0.9863939881324768
      ],
      "plane_d": -123.95684814453125,
      "bbox_min": [
        555.0,
        715.0,
        -7.0
      ],
      "bbox_max": [
        591.7796020507812,
        886.126708984375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161494255066,
        -0.9805806875228882
      ],
      "plane_d": 141.20362854003906,
      "bbox_min": [
        555.0,
        715.0,
        -7.0
      ],
      "bbox_max": [
        591.7796020507812,
        886.126708984375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -573.5927734375,
      "bbox_min": [
        555.0,
        795.0,
        -7.0
      ],
      "bbox_max": [
        591.7796020507812,
        886.126708984375,
        -3.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.26764383912086487,
        -0.0,
        -0.9635179042816162
      ],
      "plane_d": 145.08969116210938,
      "bbox_min": [
        555.0,
        795.0,
        -7.0
      ],
      "bbox_max": [
        573.5927734375,
        869.8622436523438,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        555.0,
        843.7235107421875,
        -7.0
      ],
      "bbox_max": [
        573.5927734375,
        869.8622436523438,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -998.3984985351562,
      "bbox_min": [
        555.0,
        858.948974609375,
        -4.972262382507324
      ],
      "bbox_max": [
        560.0,
        864.176513671875,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.42566201090812683,
        0.9048822522163391
      ],
      "plane_d": -356.5469055175781,
      "bbox_min": [
        560.0,
        843.7235107421875,
        -7.0
      ],
      "bbox_max": [
        573.5927734375,
        869.8622436523438,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 573.0927124023438,
      "bbox_min": [
        573.0927734375,
        843.7235107421875,
        -7.0
      ],
      "bbox_max": [
        573.0927734375,
        852.5098876953125,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9280782341957092,
        0.37238526344299316,
        0.0
      ],
      "plane_d": -852.198974609375,
      "bbox_min": [
        567.9502563476562,
        844.0066528320312,
        -7.0
      ],
      "bbox_max": [
        573.5927734375,
        869.8622436523438,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 573.0927124023438,
      "bbox_min": [
        567.9502563476562,
        844.0066528320312,
        -7.0
      ],
      "bbox_max": [
        573.5927734375,
        869.8622436523438,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0819769874215126,
        0.42422959208488464,
        0.9018364548683167
      ],
      "plane_d": -311.9330139160156,
      "bbox_min": [
        573.0927734375,
        852.3328857421875,
        -6.028999328613281
      ],
      "bbox_max": [
        573.5927734375,
        860.1951293945312,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38518548011779785,
        0.38884031772613525,
        0.8369202017784119
      ],
      "plane_d": -108.16363525390625,
      "bbox_min": [
        573.0927734375,
        852.3328857421875,
        -6.028999328613281
      ],
      "bbox_max": [
        573.1935424804688,
        858.8523559570312,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 6.028999328613281,
      "bbox_min": [
        573.0927734375,
        858.8523559570312,
        -6.028999328613281
      ],
      "bbox_max": [
        573.5927734375,
        860.1951293945312,
        -6.028999328613281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 6.028999328613281,
      "bbox_min": [
        567.9502563476562,
        858.8523559570312,
        -7.0
      ],
      "bbox_max": [
        573.0927734375,
        869.8622436523438,
        -6.028999328613281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2306823879480362,
        0.35812443494796753,
        0.9047277569770813
      ],
      "plane_d": -174.07261657714844,
      "bbox_min": [
        567.9502563476562,
        858.8523559570312,
        -7.0
      ],
      "bbox_max": [
        573.0927734375,
        869.8622436523438,
        -6.028999328613281
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9280790090560913,
        -0.3723834156990051,
        0.0
      ],
      "plane_d": 851.69775390625,
      "bbox_min": [
        567.9502563476562,
        858.8523559570312,
        -7.0
      ],
      "bbox_max": [
        573.0927734375,
        869.8622436523438,
        -6.028999328613281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226590514183044,
        -0.6912046670913696,
        -0.0
      ],
      "plane_d": 1011.4913940429688,
      "bbox_min": [
        567.9502563476562,
        868.068603515625,
        -7.0
      ],
      "bbox_max": [
        569.3948364257812,
        869.8622436523438,
        -6.028999328613281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.6912043690681458,
        0.0
      ],
      "plane_d": -1011.9913330078125,
      "bbox_min": [
        568.3711547851562,
        869.3147583007812,
        -7.0
      ],
      "bbox_max": [
        568.8948364257812,
        869.8622436523438,
        -6.649760723114014
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        555.0,
        848.1992797851562,
        -7.0
      ],
      "bbox_max": [
        567.2998657226562,
        864.176513671875,
        -3.583369255065918
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -998.3984985351562,
      "bbox_min": [
        555.0,
        858.948974609375,
        -7.0
      ],
      "bbox_max": [
        560.0,
        864.176513671875,
        -3.583369255065918
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.42566201090812683,
        0.9048822522163391
      ],
      "plane_d": -356.5469055175781,
      "bbox_min": [
        560.0,
        848.1992797851562,
        -7.0
      ],
      "bbox_max": [
        567.2998657226562,
        852.5098876953125,
        -4.972262382507324
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238811135292053,
        -0.38267987966537476,
        -3.244017250381148e-07
      ],
      "plane_d": 884.2257080078125,
      "bbox_min": [
        590.5464477539062,
        881.9164428710938,
        -7.0
      ],
      "bbox_max": [
        591.7796020507812,
        886.126708984375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071077823638916,
        0.7071057558059692,
        0.0
      ],
      "plane_d": -208.13333129882812,
      "bbox_min": [
        590.5464477539062,
        884.8935546875,
        -7.0
      ],
      "bbox_max": [
        591.7796020507812,
        886.126708984375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -715.0,
      "bbox_min": [
        569.0,
        715.0,
        -7.0
      ],
      "bbox_max": [
        591.7796020507812,
        755.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -253.47415161132812,
      "bbox_min": [
        569.0,
        715.0,
        -7.0
      ],
      "bbox_max": [
        591.7796020507812,
        755.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -569.0,
      "bbox_min": [
        569.0,
        715.0,
        -7.0
      ],
      "bbox_max": [
        591.7796020507812,
        755.0,
        -4.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        -0.371390700340271,
        -0.0
      ],
      "plane_d": 828.2012939453125,
      "bbox_min": [
        574.5999755859375,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        591.7796020507812,
        755.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 590.0,
      "bbox_min": [
        574.5999755859375,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        590.4000244140625,
        740.0,
        -4.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -733.5999755859375,
      "bbox_min": [
        590.0,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        590.4000244140625,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 733.2000122070312,
      "bbox_min": [
        590.0,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        590.4000244140625,
        733.5999755859375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -590.4000244140625,
      "bbox_min": [
        590.4000244140625,
        733.2000122070312,
        -7.0
      ],
      "bbox_max": [
        590.4000244140625,
        733.5999755859375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -727.199951171875,
      "bbox_min": [
        590.0,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        590.4000244140625,
        727.199951171875,
        -4.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -590.4000244140625,
      "bbox_min": [
        590.0,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        590.4000244140625,
        727.199951171875,
        -4.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 726.7999877929688,
      "bbox_min": [
        590.0,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        590.4000244140625,
        726.7999877929688,
        -4.533335208892822
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        590.0,
        739.5999755859375,
        -7.0
      ],
      "bbox_max": [
        590.4000244140625,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 739.5999755859375,
      "bbox_min": [
        590.0,
        739.5999755859375,
        -7.0
      ],
      "bbox_max": [
        590.4000244140625,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -590.4000244140625,
      "bbox_min": [
        590.4000244140625,
        739.5999755859375,
        -7.0
      ],
      "bbox_max": [
        590.4000244140625,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 733.2000122070312,
      "bbox_min": [
        574.5999755859375,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        575.0,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 739.5999755859375,
      "bbox_min": [
        574.5999755859375,
        733.2000122070312,
        -7.0
      ],
      "bbox_max": [
        575.0,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 574.5999755859375,
      "bbox_min": [
        574.5999755859375,
        739.5999755859375,
        -7.0
      ],
      "bbox_max": [
        575.0,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -575.0,
      "bbox_min": [
        574.5999755859375,
        739.5999755859375,
        -7.0
      ],
      "bbox_max": [
        575.0,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        574.5999755859375,
        740.0,
        -7.0
      ],
      "bbox_max": [
        575.0,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -733.5999755859375,
      "bbox_min": [
        574.5999755859375,
        733.2000122070312,
        -7.0
      ],
      "bbox_max": [
        575.0,
        733.5999755859375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 574.5999755859375,
      "bbox_min": [
        574.5999755859375,
        733.2000122070312,
        -7.0
      ],
      "bbox_max": [
        575.0,
        733.5999755859375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -575.0,
      "bbox_min": [
        575.0,
        733.2000122070312,
        -7.0
      ],
      "bbox_max": [
        575.0,
        733.5999755859375,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -727.199951171875,
      "bbox_min": [
        574.5999755859375,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        575.0,
        727.199951171875,
        -4.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 574.5999145507812,
      "bbox_min": [
        574.5999755859375,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        575.0,
        727.199951171875,
        -4.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -575.0,
      "bbox_min": [
        574.5999755859375,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        575.0,
        727.199951171875,
        -4.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 726.7999877929688,
      "bbox_min": [
        574.5999755859375,
        726.7999877929688,
        -7.0
      ],
      "bbox_max": [
        575.0,
        726.7999877929688,
        -4.533335208892822
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7592566013336182,
        -0.6507914066314697
      ],
      "plane_d": -631.842529296875,
      "bbox_min": [
        524.0,
        795.0,
        -7.0
      ],
      "bbox_max": [
        555.0,
        911.8958740234375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        524.0,
        795.0,
        -7.0
      ],
      "bbox_max": [
        555.0,
        809.5999755859375,
        -3.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 809.5999755859375,
      "bbox_min": [
        524.0,
        795.0,
        -7.0
      ],
      "bbox_max": [
        555.0,
        809.5999755859375,
        -3.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.26764383912086487,
        -0.0,
        -0.9635179042816162
      ],
      "plane_d": 145.08969116210938,
      "bbox_min": [
        524.0,
        795.0,
        -3.583359479904175
      ],
      "bbox_max": [
        555.0,
        809.5999755859375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26764383912086487,
        0.0,
        -0.9635179042816162
      ],
      "plane_d": -143.67120361328125,
      "bbox_min": [
        524.0,
        795.0,
        -3.555555820465088
      ],
      "bbox_max": [
        526.0,
        809.5999755859375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7592566013336182,
        0.0,
        -0.6507914066314697
      ],
      "plane_d": -401.10443115234375,
      "bbox_min": [
        524.0,
        827.9000244140625,
        -7.0
      ],
      "bbox_max": [
        555.0,
        911.8958740234375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -218.67095947265625,
      "bbox_min": [
        524.0,
        864.2083129882812,
        -5.000023365020752
      ],
      "bbox_max": [
        525.71435546875,
        911.8958740234375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 911.8958740234375,
      "bbox_min": [
        525.3568115234375,
        911.8958740234375,
        -3.4171111583709717
      ],
      "bbox_max": [
        525.71435546875,
        911.8958740234375,
        -3.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7592565417289734,
        -0.0,
        -0.650791347026825
      ],
      "plane_d": 418.1334228515625,
      "bbox_min": [
        524.0,
        827.9000244140625,
        -7.0
      ],
      "bbox_max": [
        555.0,
        911.8958740234375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -998.3984985351562,
      "bbox_min": [
        553.2857055664062,
        864.176513671875,
        -5.000023365020752
      ],
      "bbox_max": [
        555.0,
        911.8958740234375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 911.8958740234375,
      "bbox_min": [
        553.2857055664062,
        911.8958740234375,
        -3.381613254547119
      ],
      "bbox_max": [
        553.61279296875,
        911.8958740234375,
        -3.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -827.9000244140625,
      "bbox_min": [
        524.0,
        827.9000244140625,
        -7.0
      ],
      "bbox_max": [
        555.0,
        911.8958740234375,
        -3.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 911.8958740234375,
      "bbox_min": [
        524.0,
        859.3986206054688,
        -7.0
      ],
      "bbox_max": [
        555.0,
        911.8958740234375,
        -3.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        524.0,
        859.3986206054688,
        -7.0
      ],
      "bbox_max": [
        555.0,
        911.8958740234375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -872.9349365234375,
      "bbox_min": [
        524.0,
        867.5,
        -7.0
      ],
      "bbox_max": [
        555.0,
        911.8958740234375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -998.3984985351562,
      "bbox_min": [
        527.1484375,
        867.5,
        -7.0
      ],
      "bbox_max": [
        551.8212280273438,
        872.9349365234375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -218.67095947265625,
      "bbox_min": [
        527.1484375,
        867.5,
        -7.0
      ],
      "bbox_max": [
        532.3468017578125,
        872.9349365234375,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        524.0,
        911.3212890625,
        -7.0
      ],
      "bbox_max": [
        555.0,
        911.8958740234375,
        -3.381613254547119
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        524.0,
        911.3338623046875,
        -7.0
      ],
      "bbox_max": [
        525.3568115234375,
        911.8958740234375,
        -3.4171111583709717
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7592566609382629,
        -0.6507914066314697
      ],
      "plane_d": 655.4011840820312,
      "bbox_min": [
        524.0,
        859.3986206054688,
        -7.0
      ],
      "bbox_max": [
        555.0,
        867.5,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -998.3984985351562,
      "bbox_min": [
        525.6092529296875,
        865.875244140625,
        -5.0
      ],
      "bbox_max": [
        553.375244140625,
        867.5,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -218.67095947265625,
      "bbox_min": [
        525.6092529296875,
        865.8908081054688,
        -5.0
      ],
      "bbox_max": [
        527.1484375,
        867.5,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688879013062,
        -0.6246950626373291,
        0.0
      ],
      "plane_d": 128.06246948242188,
      "bbox_min": [
        524.0,
        859.3986206054688,
        -7.0
      ],
      "bbox_max": [
        555.0,
        867.5,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688879013062,
        -0.6246950626373291,
        -0.0
      ],
      "plane_d": 970.6199951171875,
      "bbox_min": [
        524.0,
        859.3986206054688,
        -7.0
      ],
      "bbox_max": [
        555.0,
        867.5,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -998.3984985351562,
      "bbox_min": [
        551.8211669921875,
        864.176513671875,
        -7.0
      ],
      "bbox_max": [
        555.0,
        867.5,
        -3.1044464111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.592878520488739,
        -0.4743027985095978,
        -0.6507933139801025
      ],
      "plane_d": 733.6940307617188,
      "bbox_min": [
        524.0,
        859.3986206054688,
        -5.0
      ],
      "bbox_max": [
        555.0,
        867.5,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.592878520488739,
        -0.4743027687072754,
        -0.6507933735847473
      ],
      "plane_d": 93.97805786132812,
      "bbox_min": [
        524.0,
        859.3986206054688,
        -5.0
      ],
      "bbox_max": [
        530.8239135742188,
        867.5,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 597.5687866210938,
      "bbox_min": [
        591.7796020507812,
        715.0,
        -7.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9265769124031067,
        0.37610557675361633,
        0.0
      ],
      "plane_d": 226.05050659179688,
      "bbox_min": [
        597.5687866210938,
        891.9158935546875,
        -7.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071077823638916,
        0.7071057558059692,
        0.0
      ],
      "plane_d": -208.13333129882812,
      "bbox_min": [
        597.5687866210938,
        891.9158935546875,
        -7.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 973.0000610351562,
      "bbox_min": [
        597.5687866210938,
        973.0000610351562,
        -7.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -3.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 613.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -7.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -597.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -7.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.6000366210938,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -7.0
      ],
      "bbox_max": [
        613.9696044921875,
        974.6000366210938,
        -3.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.16439899802207947,
        -0.9863939881324768
      ],
      "plane_d": -123.95684814453125,
      "bbox_min": [
        591.7796020507812,
        715.0,
        -7.0
      ],
      "bbox_max": [
        597.5687866210938,
        973.0000610351562,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238811135292053,
        -0.38267987966537476,
        -3.244017250381148e-07
      ],
      "plane_d": 884.2257080078125,
      "bbox_min": [
        591.7796020507812,
        715.0,
        -7.0
      ],
      "bbox_max": [
        597.5687866210938,
        973.0000610351562,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071077823638916,
        0.7071057558059692,
        0.0
      ],
      "plane_d": -208.13333129882812,
      "bbox_min": [
        591.7796020507812,
        886.126708984375,
        -7.0
      ],
      "bbox_max": [
        597.5687866210938,
        973.0000610351562,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 973.0000610351562,
      "bbox_min": [
        591.7796020507812,
        973.0000610351562,
        -7.0
      ],
      "bbox_max": [
        597.5687866210938,
        973.0000610351562,
        -3.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 596.0,
      "bbox_min": [
        591.7796020507812,
        715.0,
        -7.0
      ],
      "bbox_max": [
        597.5687866210938,
        827.0,
        -3.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        596.0,
        827.0,
        -7.0
      ],
      "bbox_max": [
        597.5687866210938,
        827.0,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        -0.371390700340271,
        -0.0
      ],
      "plane_d": 828.2012939453125,
      "bbox_min": [
        591.7796020507812,
        715.0,
        -7.0
      ],
      "bbox_max": [
        596.0,
        827.0,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        591.7796020507812,
        827.0,
        -7.0
      ],
      "bbox_max": [
        596.0,
        827.0,
        -3.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161494255066,
        -0.9805806875228882
      ],
      "plane_d": 141.20362854003906,
      "bbox_min": [
        591.7796020507812,
        715.0,
        -7.0
      ],
      "bbox_max": [
        596.0,
        750.551025390625,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -4.0,
      "bbox_min": [
        591.7796020507812,
        715.0,
        -7.0
      ],
      "bbox_max": [
        596.0,
        740.0,
        -4.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -715.0,
      "bbox_min": [
        591.7796020507812,
        715.0,
        -7.0
      ],
      "bbox_max": [
        596.0,
        715.0,
        -6.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -971.0816650390625,
      "bbox_min": [
        459.1000061035156,
        891.916015625,
        -7.0
      ],
      "bbox_max": [
        481.4007873535156,
        990.0,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 973.0,
      "bbox_min": [
        459.1000061035156,
        973.0,
        -7.0
      ],
      "bbox_max": [
        481.4007873535156,
        990.0,
        -3.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -7.0
      ],
      "bbox_max": [
        481.0,
        990.0,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 481.0,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -7.0
      ],
      "bbox_max": [
        481.0,
        990.0,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -974.5999755859375,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -7.0
      ],
      "bbox_max": [
        481.0,
        974.5999755859375,
        -3.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9238793253898621,
        -0.3826841115951538,
        7.159964638958627e-07
      ],
      "plane_d": -112.609375,
      "bbox_min": [
        481.4007873535156,
        715.0,
        -7.0
      ],
      "bbox_max": [
        487.19000244140625,
        973.0,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -971.0816650390625,
      "bbox_min": [
        481.4007873535156,
        886.1267700195312,
        -7.0
      ],
      "bbox_max": [
        487.19000244140625,
        973.0,
        -3.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 973.0,
      "bbox_min": [
        481.4007873535156,
        973.0,
        -7.0
      ],
      "bbox_max": [
        487.19000244140625,
        973.0,
        -3.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -484.0,
      "bbox_min": [
        481.4007873535156,
        715.0,
        -7.0
      ],
      "bbox_max": [
        487.19000244140625,
        827.0,
        -3.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        481.4007873535156,
        827.0,
        -7.0
      ],
      "bbox_max": [
        484.0,
        827.0,
        -3.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -715.0,
      "bbox_min": [
        484.0,
        715.0,
        -7.0
      ],
      "bbox_max": [
        487.19000244140625,
        715.0,
        -6.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        459.1000061035156,
        715.0,
        -19.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -7.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -715.0,
      "bbox_min": [
        484.0,
        715.0,
        -19.0
      ],
      "bbox_max": [
        596.0,
        765.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -253.47415161132812,
      "bbox_min": [
        484.0,
        715.0,
        -19.0
      ],
      "bbox_max": [
        596.0,
        765.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -922.9849243164062,
      "bbox_min": [
        505.0,
        755.0,
        -19.0
      ],
      "bbox_max": [
        575.0,
        765.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        0.0
      ],
      "plane_d": -820.15869140625,
      "bbox_min": [
        505.0,
        755.0,
        -19.0
      ],
      "bbox_max": [
        575.0,
        762.071044921875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": 177.63296508789062,
      "bbox_min": [
        505.0,
        755.0,
        -19.0
      ],
      "bbox_max": [
        507.9289245605469,
        762.071044921875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 511.0,
      "bbox_min": [
        484.0,
        715.0,
        -19.0
      ],
      "bbox_max": [
        511.0,
        765.0,
        -7.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -484.0,
      "bbox_min": [
        484.0,
        715.0,
        -19.0
      ],
      "bbox_max": [
        511.0,
        765.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238796830177307,
        -0.3826832175254822,
        0.0
      ],
      "plane_d": -163.77520751953125,
      "bbox_min": [
        484.0,
        715.0,
        -19.0
      ],
      "bbox_max": [
        511.0,
        765.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -727.199951171875,
      "bbox_min": [
        484.0,
        715.0,
        -19.0
      ],
      "bbox_max": [
        511.0,
        740.0,
        -7.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 726.7999877929688,
      "bbox_min": [
        484.0,
        715.0,
        -19.0
      ],
      "bbox_max": [
        511.0,
        727.199951171875,
        -7.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        484.0,
        726.7999877929688,
        -19.0
      ],
      "bbox_max": [
        511.0,
        727.199951171875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 489.5999755859375,
      "bbox_min": [
        484.0,
        726.7999877929688,
        -19.0
      ],
      "bbox_max": [
        489.6000061035156,
        727.199951171875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        484.0,
        726.7999877929688,
        -10.0
      ],
      "bbox_max": [
        489.6000061035156,
        727.199951171875,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -505.3999938964844,
      "bbox_min": [
        505.0,
        726.7999877929688,
        -19.0
      ],
      "bbox_max": [
        511.0,
        727.199951171875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 504.9999694824219,
      "bbox_min": [
        505.0,
        726.7999877929688,
        -19.0
      ],
      "bbox_max": [
        505.0,
        727.199951171875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        505.3999938964844,
        726.7999877929688,
        -10.0
      ],
      "bbox_max": [
        511.0,
        727.199951171875,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 721.51806640625,
      "bbox_min": [
        484.79998779296875,
        715.0,
        -19.0
      ],
      "bbox_max": [
        506.5999755859375,
        724.98193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -724.98193359375,
      "bbox_min": [
        484.79998779296875,
        721.51806640625,
        -19.0
      ],
      "bbox_max": [
        488.79998779296875,
        724.98193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -784.949462890625,
      "bbox_min": [
        484.79998779296875,
        721.51806640625,
        -19.0
      ],
      "bbox_max": [
        488.79998779296875,
        724.98193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": 58.19866943359375,
      "bbox_min": [
        484.79998779296875,
        721.51806640625,
        -19.0
      ],
      "bbox_max": [
        488.79998779296875,
        724.98193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        -0.5000253915786743,
        -0.0
      ],
      "plane_d": 781.4853515625,
      "bbox_min": [
        484.79998779296875,
        721.51806640625,
        -19.0
      ],
      "bbox_max": [
        488.79998779296875,
        724.98193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": -61.6627197265625,
      "bbox_min": [
        484.79998779296875,
        721.51806640625,
        -19.0
      ],
      "bbox_max": [
        488.79998779296875,
        724.98193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 15.0,
      "bbox_min": [
        484.79998779296875,
        721.51806640625,
        -19.0
      ],
      "bbox_max": [
        488.79998779296875,
        724.98193359375,
        -15.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -721.76806640625,
      "bbox_min": [
        485.08856201171875,
        721.76806640625,
        -19.0
      ],
      "bbox_max": [
        488.51141357421875,
        724.73193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 724.73193359375,
      "bbox_min": [
        485.08856201171875,
        721.76806640625,
        -19.0
      ],
      "bbox_max": [
        488.51141357421875,
        724.73193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659955263137817,
        -0.5000517964363098,
        -0.0
      ],
      "plane_d": 784.711181640625,
      "bbox_min": [
        485.08856201171875,
        721.76806640625,
        -19.0
      ],
      "bbox_max": [
        488.51141357421875,
        724.73193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659955263137817,
        0.5000517964363098,
        0.0
      ],
      "plane_d": 61.38623046875,
      "bbox_min": [
        485.08856201171875,
        721.76806640625,
        -19.0
      ],
      "bbox_max": [
        488.51141357421875,
        724.73193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659955263137817,
        0.5000517964363098,
        0.0
      ],
      "plane_d": -781.7469482421875,
      "bbox_min": [
        485.08856201171875,
        721.76806640625,
        -19.0
      ],
      "bbox_max": [
        485.94427490234375,
        724.73193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659955263137817,
        -0.5000517964363098,
        0.0
      ],
      "plane_d": -58.42205810546875,
      "bbox_min": [
        485.08856201171875,
        723.25,
        -19.0
      ],
      "bbox_max": [
        485.94427490234375,
        724.73193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4103623628616333,
        -0.9119225740432739
      ],
      "plane_d": -309.9604797363281,
      "bbox_min": [
        488.0999755859375,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        506.5999755859375,
        717.0,
        -17.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 17.0,
      "bbox_min": [
        488.0999755859375,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        506.5999755859375,
        717.0,
        -17.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -717.0,
      "bbox_min": [
        488.0999755859375,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        506.5999755859375,
        717.0,
        -17.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 495.5999755859375,
      "bbox_min": [
        488.0999755859375,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        502.5999755859375,
        717.0,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -499.5999755859375,
      "bbox_min": [
        499.5999755859375,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        502.5999755859375,
        717.0,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 502.5999755859375,
      "bbox_min": [
        502.5999755859375,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        502.5999755859375,
        717.0,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -492.0999755859375,
      "bbox_min": [
        488.0999755859375,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        492.0999755859375,
        717.0,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 488.0999755859375,
      "bbox_min": [
        488.0999755859375,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        488.0999755859375,
        717.0,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        484.0,
        728.8499755859375,
        -19.0
      ],
      "bbox_max": [
        511.0,
        740.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -733.5999755859375,
      "bbox_min": [
        484.0,
        728.8499755859375,
        -19.0
      ],
      "bbox_max": [
        490.0,
        740.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 733.2000122070312,
      "bbox_min": [
        484.0,
        728.8499755859375,
        -19.0
      ],
      "bbox_max": [
        490.0,
        733.5999755859375,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 489.6000061035156,
      "bbox_min": [
        484.0,
        733.2000122070312,
        -19.0
      ],
      "bbox_max": [
        489.6000061035156,
        733.5999755859375,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        484.0,
        733.2000122070312,
        -10.0
      ],
      "bbox_max": [
        489.6000061035156,
        733.5999755859375,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 16.850000381469727,
      "bbox_min": [
        484.0,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        486.5599670410156,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284818768501282,
        -0.3713776469230652
      ],
      "plane_d": -685.302978515625,
      "bbox_min": [
        484.0,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        486.5599670410156,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.928481936454773,
        -0.3713776469230652
      ],
      "plane_d": 670.46630859375,
      "bbox_min": [
        484.0,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        486.5599670410156,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7133024334907532,
        0.5943824648857117,
        -0.37136131525039673
      ],
      "plane_d": -787.5530395507812,
      "bbox_min": [
        485.7599792480469,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        486.5599670410156,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7132997512817383,
        -0.5943801403045654,
        -0.37136998772621155
      ],
      "plane_d": 80.36367797851562,
      "bbox_min": [
        485.7599792480469,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        486.5599670410156,
        730.55859375,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284819960594177,
        0.0,
        -0.3713776767253876
      ],
      "plane_d": -458.0198974609375,
      "bbox_min": [
        486.2599792480469,
        729.6414184570312,
        -17.600000381469727
      ],
      "bbox_max": [
        486.5599670410156,
        730.55859375,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 739.5999755859375,
      "bbox_min": [
        484.0,
        735.1499633789062,
        -19.0
      ],
      "bbox_max": [
        490.0,
        740.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 489.6000061035156,
      "bbox_min": [
        484.0,
        739.5999755859375,
        -19.0
      ],
      "bbox_max": [
        490.0,
        740.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        489.6000061035156,
        740.0,
        -19.0
      ],
      "bbox_max": [
        490.0,
        740.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        484.0,
        739.5999755859375,
        -18.0
      ],
      "bbox_max": [
        489.6000061035156,
        740.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        484.0,
        739.5999755859375,
        -10.0
      ],
      "bbox_max": [
        489.6000061035156,
        740.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 16.850000381469727,
      "bbox_min": [
        484.0,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        486.5599670410156,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284818768501282,
        -0.3713776469230652
      ],
      "plane_d": -691.1524047851562,
      "bbox_min": [
        484.0,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        486.5599670410156,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.928481936454773,
        -0.3713776469230652
      ],
      "plane_d": 676.3157348632812,
      "bbox_min": [
        484.0,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        486.5599670410156,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7133024334907532,
        0.5943824648857117,
        -0.37136131525039673
      ],
      "plane_d": -791.2976684570312,
      "bbox_min": [
        485.7599792480469,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        486.5599670410156,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7132997512817383,
        -0.5943801403045654,
        -0.37136998772621155
      ],
      "plane_d": 84.1082763671875,
      "bbox_min": [
        485.7599792480469,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        486.5599670410156,
        736.8585815429688,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284819960594177,
        0.0,
        -0.3713776767253876
      ],
      "plane_d": -458.0198974609375,
      "bbox_min": [
        486.2599792480469,
        735.94140625,
        -17.600000381469727
      ],
      "bbox_max": [
        486.5599670410156,
        736.8585815429688,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -733.5999755859375,
      "bbox_min": [
        505.0,
        728.8499755859375,
        -19.0
      ],
      "bbox_max": [
        511.0,
        740.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 733.2000122070312,
      "bbox_min": [
        505.0,
        728.8499755859375,
        -19.0
      ],
      "bbox_max": [
        511.0,
        733.5999755859375,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -505.3999938964844,
      "bbox_min": [
        505.0,
        733.2000122070312,
        -19.0
      ],
      "bbox_max": [
        511.0,
        733.5999755859375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 505.0,
      "bbox_min": [
        505.0,
        733.2000122070312,
        -19.0
      ],
      "bbox_max": [
        505.0,
        733.5999755859375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        505.3999938964844,
        733.2000122070312,
        -10.0
      ],
      "bbox_max": [
        511.0,
        733.5999755859375,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 16.850000381469727,
      "bbox_min": [
        508.4400329589844,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        511.0,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.928481936454773,
        -0.3713776469230652
      ],
      "plane_d": -685.3030395507812,
      "bbox_min": [
        508.4400329589844,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        511.0,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284818768501282,
        -0.3713776469230652
      ],
      "plane_d": 670.4662475585938,
      "bbox_min": [
        508.4400329589844,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        511.0,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7133048176765442,
        0.5943748950958252,
        -0.3713688552379608
      ],
      "plane_d": -77.810546875,
      "bbox_min": [
        508.4400329589844,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        509.2400207519531,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7133068442344666,
        -0.5943765640258789,
        -0.37136223912239075
      ],
      "plane_d": 790.0980224609375,
      "bbox_min": [
        508.4400329589844,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        509.2400207519531,
        730.55859375,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284819960594177,
        -0.0,
        -0.3713776767253876
      ],
      "plane_d": 465.8197021484375,
      "bbox_min": [
        508.4400329589844,
        729.6414184570312,
        -17.600000381469727
      ],
      "bbox_max": [
        508.7400207519531,
        730.55859375,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 739.5999755859375,
      "bbox_min": [
        505.0,
        735.1499633789062,
        -19.0
      ],
      "bbox_max": [
        511.0,
        740.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -505.3999938964844,
      "bbox_min": [
        505.0,
        739.5999755859375,
        -19.0
      ],
      "bbox_max": [
        511.0,
        740.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 505.0,
      "bbox_min": [
        505.0,
        739.5999755859375,
        -19.0
      ],
      "bbox_max": [
        505.3999938964844,
        740.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        505.0,
        740.0,
        -19.0
      ],
      "bbox_max": [
        505.3999938964844,
        740.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        505.3999938964844,
        739.5999755859375,
        -18.0
      ],
      "bbox_max": [
        511.0,
        740.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        505.3999938964844,
        739.5999755859375,
        -10.0
      ],
      "bbox_max": [
        511.0,
        740.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 16.850000381469727,
      "bbox_min": [
        508.4400329589844,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        511.0,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.928481936454773,
        -0.3713776469230652
      ],
      "plane_d": -691.1524658203125,
      "bbox_min": [
        508.4400329589844,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        511.0,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284818768501282,
        -0.3713776469230652
      ],
      "plane_d": 676.315673828125,
      "bbox_min": [
        508.4400329589844,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        511.0,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7133048176765442,
        0.5943748950958252,
        -0.3713688552379608
      ],
      "plane_d": -81.55511474609375,
      "bbox_min": [
        508.4400329589844,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        509.2400207519531,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7133068442344666,
        -0.5943765640258789,
        -0.37136223912239075
      ],
      "plane_d": 793.8426513671875,
      "bbox_min": [
        508.4400329589844,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        509.2400207519531,
        736.8585815429688,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284819960594177,
        -0.0,
        -0.3713776767253876
      ],
      "plane_d": 465.8197021484375,
      "bbox_min": [
        508.4400329589844,
        735.94140625,
        -17.600000381469727
      ],
      "bbox_max": [
        508.7400207519531,
        736.8585815429688,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -569.0,
      "bbox_min": [
        569.0,
        715.0,
        -19.0
      ],
      "bbox_max": [
        596.0,
        765.0,
        -7.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 596.0,
      "bbox_min": [
        569.0,
        715.0,
        -19.0
      ],
      "bbox_max": [
        596.0,
        765.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238796830177307,
        -0.3826832175254822,
        0.0
      ],
      "plane_d": 834.0148315429688,
      "bbox_min": [
        569.0,
        715.0,
        -19.0
      ],
      "bbox_max": [
        596.0,
        765.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 733.2000122070312,
      "bbox_min": [
        569.0,
        715.0,
        -19.0
      ],
      "bbox_max": [
        596.0,
        753.9338989257812,
        -7.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 739.5999755859375,
      "bbox_min": [
        569.0,
        733.2000122070312,
        -19.0
      ],
      "bbox_max": [
        596.0,
        753.9338989257812,
        -7.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        569.0,
        739.5999755859375,
        -19.0
      ],
      "bbox_max": [
        596.0,
        753.9338989257812,
        -7.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 590.0,
      "bbox_min": [
        569.0,
        739.5999755859375,
        -19.0
      ],
      "bbox_max": [
        596.0,
        740.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -590.4000244140625,
      "bbox_min": [
        590.4000244140625,
        739.5999755859375,
        -19.0
      ],
      "bbox_max": [
        596.0,
        740.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        590.4000244140625,
        739.5999755859375,
        -18.0
      ],
      "bbox_max": [
        596.0,
        740.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -18.0,
      "bbox_min": [
        590.4000244140625,
        739.5999755859375,
        -18.0
      ],
      "bbox_max": [
        596.0,
        740.0,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 574.5999755859375,
      "bbox_min": [
        569.0,
        739.5999755859375,
        -19.0
      ],
      "bbox_max": [
        575.0,
        740.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -575.0,
      "bbox_min": [
        575.0,
        739.5999755859375,
        -19.0
      ],
      "bbox_max": [
        575.0,
        740.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        569.0,
        739.5999755859375,
        -18.0
      ],
      "bbox_max": [
        574.5999755859375,
        740.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -18.0,
      "bbox_min": [
        569.0,
        739.5999755859375,
        -18.0
      ],
      "bbox_max": [
        574.5999755859375,
        740.0,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9271836876869202,
        -0.3746072053909302,
        0.0
      ],
      "plane_d": -254.15786743164062,
      "bbox_min": [
        570.4139404296875,
        742.1065673828125,
        -19.0
      ],
      "bbox_max": [
        578.144775390625,
        753.9338989257812,
        -14.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 17.0,
      "bbox_min": [
        570.4139404296875,
        742.1065673828125,
        -19.0
      ],
      "bbox_max": [
        578.144775390625,
        753.9338989257812,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3746069073677063,
        0.9271837472915649,
        0.0
      ],
      "plane_d": -914.2744750976562,
      "bbox_min": [
        570.4139404296875,
        742.1065673828125,
        -19.0
      ],
      "bbox_max": [
        578.144775390625,
        753.9338989257812,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37460651993751526,
        -0.927183985710144,
        0.0
      ],
      "plane_d": 903.074462890625,
      "bbox_min": [
        570.4139404296875,
        742.1065673828125,
        -19.0
      ],
      "bbox_max": [
        573.94921875,
        743.534912109375,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 14.0,
      "bbox_min": [
        570.4139404296875,
        742.1065673828125,
        -17.0
      ],
      "bbox_max": [
        578.144775390625,
        753.9338989257812,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3350837826728821,
        -0.8293617963790894,
        0.44707706570625305
      ],
      "plane_d": 824.5200805664062,
      "bbox_min": [
        570.4139404296875,
        742.1065673828125,
        -17.0
      ],
      "bbox_max": [
        578.144775390625,
        753.9338989257812,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 16.600006103515625,
      "bbox_min": [
        574.2764282226562,
        751.7492065429688,
        -17.0
      ],
      "bbox_max": [
        578.144775390625,
        753.9338989257812,
        -16.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33506521582603455,
        0.8293147087097168,
        0.44717830419540405
      ],
      "plane_d": -810.166015625,
      "bbox_min": [
        574.499267578125,
        752.3056030273438,
        -17.0
      ],
      "bbox_max": [
        578.144775390625,
        753.9338989257812,
        -16.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37461572885513306,
        -0.9271802306175232,
        0.0
      ],
      "plane_d": 904.076904296875,
      "bbox_min": [
        570.4139404296875,
        742.1065673828125,
        -17.0
      ],
      "bbox_max": [
        575.3594360351562,
        753.0054321289062,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9251307845115662,
        -0.37378042936325073,
        0.0664927288889885
      ],
      "plane_d": -249.86843872070312,
      "bbox_min": [
        571.7276611328125,
        744.0077514648438,
        -17.0
      ],
      "bbox_max": [
        575.3594360351562,
        753.0054321289062,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37461748719215393,
        0.9271793961524963,
        8.92506886884803e-06
      ],
      "plane_d": -913.2772216796875,
      "bbox_min": [
        574.2021484375,
        752.537841796875,
        -17.0
      ],
      "bbox_max": [
        575.3594360351562,
        753.0054321289062,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3350833058357239,
        -0.8293620347976685,
        0.44707706570625305
      ],
      "plane_d": 815.3961181640625,
      "bbox_min": [
        570.4139404296875,
        742.1065673828125,
        -17.0
      ],
      "bbox_max": [
        574.3237915039062,
        744.46337890625,
        -16.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 16.600006103515625,
      "bbox_min": [
        570.4882202148438,
        742.2919311523438,
        -17.0
      ],
      "bbox_max": [
        574.3237915039062,
        744.46337890625,
        -16.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33507975935935974,
        0.8293634057044983,
        0.44707706570625305
      ],
      "plane_d": -801.0889282226562,
      "bbox_min": [
        570.7110595703125,
        742.8483276367188,
        -17.0
      ],
      "bbox_max": [
        574.3237915039062,
        744.46337890625,
        -16.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -733.5999755859375,
      "bbox_min": [
        569.0,
        733.2000122070312,
        -19.0
      ],
      "bbox_max": [
        596.0,
        737.6500244140625,
        -7.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 590.0,
      "bbox_min": [
        569.0,
        733.2000122070312,
        -19.0
      ],
      "bbox_max": [
        596.0,
        733.5999755859375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -590.4000244140625,
      "bbox_min": [
        590.4000244140625,
        733.2000122070312,
        -19.0
      ],
      "bbox_max": [
        596.0,
        733.5999755859375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        590.4000244140625,
        733.2000122070312,
        -18.0
      ],
      "bbox_max": [
        596.0,
        733.5999755859375,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -18.0,
      "bbox_min": [
        590.4000244140625,
        733.2000122070312,
        -18.0
      ],
      "bbox_max": [
        596.0,
        733.5999755859375,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 574.5999755859375,
      "bbox_min": [
        569.0,
        733.2000122070312,
        -19.0
      ],
      "bbox_max": [
        575.0,
        733.5999755859375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -575.0,
      "bbox_min": [
        575.0,
        733.2000122070312,
        -19.0
      ],
      "bbox_max": [
        575.0,
        733.5999755859375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        569.0,
        733.2000122070312,
        -18.0
      ],
      "bbox_max": [
        574.5999755859375,
        733.5999755859375,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -18.0,
      "bbox_min": [
        569.0,
        733.2000122070312,
        -18.0
      ],
      "bbox_max": [
        574.5999755859375,
        733.5999755859375,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 16.850000381469727,
      "bbox_min": [
        569.0,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        596.0,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7133476138114929,
        -0.5943554639816284,
        -0.37131741642951965
      ],
      "plane_d": 854.483154296875,
      "bbox_min": [
        569.0,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        596.0,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284818768501282,
        -0.3713776469230652
      ],
      "plane_d": -691.1524047851562,
      "bbox_min": [
        593.4400634765625,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        596.0,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.928481936454773,
        -0.3713776767253876
      ],
      "plane_d": 676.3157348632812,
      "bbox_min": [
        593.4400634765625,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        596.0,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7133339643478394,
        0.5943440794944763,
        -0.37136197090148926
      ],
      "plane_d": -20.884033203125,
      "bbox_min": [
        593.4400634765625,
        735.94140625,
        -17.600000381469727
      ],
      "bbox_max": [
        594.239990234375,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9285079836845398,
        -0.0,
        -0.3713124990463257
      ],
      "plane_d": 544.7572021484375,
      "bbox_min": [
        593.4400634765625,
        735.94140625,
        -17.600000381469727
      ],
      "bbox_max": [
        593.739990234375,
        736.8585815429688,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.928481936454773,
        -0.3713776767253876
      ],
      "plane_d": -691.1524658203125,
      "bbox_min": [
        569.0,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        571.5599365234375,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284818768501282,
        -0.3713776469230652
      ],
      "plane_d": 676.315673828125,
      "bbox_min": [
        569.0,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        571.5599365234375,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7133178114891052,
        0.5943952202796936,
        -0.3713112473487854
      ],
      "plane_d": -851.9456787109375,
      "bbox_min": [
        570.760009765625,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        571.5599365234375,
        737.6500244140625,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7132997512817383,
        -0.5943801403045654,
        -0.37136998772621155
      ],
      "plane_d": 23.477783203125,
      "bbox_min": [
        570.760009765625,
        735.1499633789062,
        -17.600000381469727
      ],
      "bbox_max": [
        571.5599365234375,
        736.8585815429688,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9285079836845398,
        0.0,
        -0.3713124990463257
      ],
      "plane_d": -536.95458984375,
      "bbox_min": [
        571.260009765625,
        735.94140625,
        -17.600000381469727
      ],
      "bbox_max": [
        571.5599365234375,
        736.8585815429688,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 726.7999877929688,
      "bbox_min": [
        569.0,
        715.0,
        -19.0
      ],
      "bbox_max": [
        596.0,
        731.3500366210938,
        -7.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -727.199951171875,
      "bbox_min": [
        569.0,
        726.7999877929688,
        -19.0
      ],
      "bbox_max": [
        596.0,
        731.3500366210938,
        -7.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 589.9999389648438,
      "bbox_min": [
        569.0,
        726.7999877929688,
        -19.0
      ],
      "bbox_max": [
        596.0,
        727.199951171875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -590.4000244140625,
      "bbox_min": [
        590.4000244140625,
        726.7999877929688,
        -19.0
      ],
      "bbox_max": [
        596.0,
        727.199951171875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        590.4000244140625,
        726.7999877929688,
        -18.0
      ],
      "bbox_max": [
        596.0,
        727.199951171875,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -18.0,
      "bbox_min": [
        590.4000244140625,
        726.7999877929688,
        -18.0
      ],
      "bbox_max": [
        596.0,
        727.199951171875,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 574.5999145507812,
      "bbox_min": [
        569.0,
        726.7999877929688,
        -19.0
      ],
      "bbox_max": [
        575.0,
        727.199951171875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -575.0,
      "bbox_min": [
        575.0,
        726.7999877929688,
        -19.0
      ],
      "bbox_max": [
        575.0,
        727.199951171875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        569.0,
        726.7999877929688,
        -18.0
      ],
      "bbox_max": [
        574.5999755859375,
        727.199951171875,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -18.0,
      "bbox_min": [
        569.0,
        726.7999877929688,
        -18.0
      ],
      "bbox_max": [
        574.5999755859375,
        727.199951171875,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 16.850000381469727,
      "bbox_min": [
        569.0,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        596.0,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7133476138114929,
        -0.5943554639816284,
        -0.37131741642951965
      ],
      "plane_d": 850.7387084960938,
      "bbox_min": [
        569.0,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        596.0,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284818768501282,
        -0.3713776469230652
      ],
      "plane_d": -685.302978515625,
      "bbox_min": [
        593.4400634765625,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        596.0,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.928481936454773,
        -0.3713776767253876
      ],
      "plane_d": 670.46630859375,
      "bbox_min": [
        593.4400634765625,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        596.0,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7133339643478394,
        0.5943440794944763,
        -0.37136197090148926
      ],
      "plane_d": -17.139678955078125,
      "bbox_min": [
        593.4400634765625,
        729.6414184570312,
        -17.600000381469727
      ],
      "bbox_max": [
        594.239990234375,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9285079836845398,
        -0.0,
        -0.3713124990463257
      ],
      "plane_d": 544.7572021484375,
      "bbox_min": [
        593.4400634765625,
        729.6414184570312,
        -17.600000381469727
      ],
      "bbox_max": [
        593.739990234375,
        730.55859375,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.928481936454773,
        -0.3713776767253876
      ],
      "plane_d": -685.3030395507812,
      "bbox_min": [
        569.0,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        571.5599365234375,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284818768501282,
        -0.3713776469230652
      ],
      "plane_d": 670.4662475585938,
      "bbox_min": [
        569.0,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        571.5599365234375,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7133178114891052,
        0.5943952202796936,
        -0.3713112473487854
      ],
      "plane_d": -848.2009887695312,
      "bbox_min": [
        570.760009765625,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        571.5599365234375,
        731.3500366210938,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7132997512817383,
        -0.5943801403045654,
        -0.37136998772621155
      ],
      "plane_d": 19.733184814453125,
      "bbox_min": [
        570.760009765625,
        728.8499755859375,
        -17.600000381469727
      ],
      "bbox_max": [
        571.5599365234375,
        730.55859375,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9285079836845398,
        0.0,
        -0.3713124990463257
      ],
      "plane_d": -536.95458984375,
      "bbox_min": [
        571.260009765625,
        729.6414184570312,
        -17.600000381469727
      ],
      "bbox_max": [
        571.5599365234375,
        730.55859375,
        -16.850000381469727
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 721.51806640625,
      "bbox_min": [
        573.4000244140625,
        715.0,
        -19.0
      ],
      "bbox_max": [
        595.2000122070312,
        724.98193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -724.98193359375,
      "bbox_min": [
        591.2000122070312,
        721.51806640625,
        -19.0
      ],
      "bbox_max": [
        595.2000122070312,
        724.98193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": 150.34222412109375,
      "bbox_min": [
        591.2000122070312,
        721.51806640625,
        -19.0
      ],
      "bbox_max": [
        595.2000122070312,
        724.98193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        0.5000253915786743,
        -0.0
      ],
      "plane_d": -877.093017578125,
      "bbox_min": [
        591.2000122070312,
        721.51806640625,
        -19.0
      ],
      "bbox_max": [
        595.2000122070312,
        724.98193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": -153.8062744140625,
      "bbox_min": [
        591.2000122070312,
        721.51806640625,
        -19.0
      ],
      "bbox_max": [
        595.2000122070312,
        724.98193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": 873.6289672851562,
      "bbox_min": [
        591.2000122070312,
        721.51806640625,
        -19.0
      ],
      "bbox_max": [
        595.2000122070312,
        724.98193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 15.0,
      "bbox_min": [
        591.2000122070312,
        721.51806640625,
        -19.0
      ],
      "bbox_max": [
        595.2000122070312,
        724.98193359375,
        -15.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -721.76806640625,
      "bbox_min": [
        591.4885864257812,
        721.76806640625,
        -19.0
      ],
      "bbox_max": [
        594.9114379882812,
        724.73193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 724.73193359375,
      "bbox_min": [
        591.4885864257812,
        721.76806640625,
        -19.0
      ],
      "bbox_max": [
        594.9114379882812,
        724.73193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659955263137817,
        -0.5000517964363098,
        0.0
      ],
      "plane_d": -150.56402587890625,
      "bbox_min": [
        591.4885864257812,
        721.76806640625,
        -19.0
      ],
      "bbox_max": [
        594.9114379882812,
        724.73193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659955263137817,
        0.5000517964363098,
        -0.0
      ],
      "plane_d": -873.888916015625,
      "bbox_min": [
        591.4885864257812,
        721.76806640625,
        -19.0
      ],
      "bbox_max": [
        594.9114379882812,
        724.73193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659955263137817,
        0.5000517964363098,
        0.0
      ],
      "plane_d": 153.52816772460938,
      "bbox_min": [
        594.0557250976562,
        721.76806640625,
        -19.0
      ],
      "bbox_max": [
        594.9114379882812,
        724.73193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659955263137817,
        -0.5000517964363098,
        0.0
      ],
      "plane_d": 876.8531494140625,
      "bbox_min": [
        594.0557250976562,
        723.25,
        -19.0
      ],
      "bbox_max": [
        594.9114379882812,
        724.73193359375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4103623628616333,
        -0.9119225740432739
      ],
      "plane_d": -309.9604797363281,
      "bbox_min": [
        573.4000244140625,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        591.9000244140625,
        717.0,
        -17.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 17.0,
      "bbox_min": [
        573.4000244140625,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        591.9000244140625,
        717.0,
        -17.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -717.0,
      "bbox_min": [
        573.4000244140625,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        591.9000244140625,
        717.0,
        -17.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 580.4000244140625,
      "bbox_min": [
        573.4000244140625,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        591.9000244140625,
        717.0,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 587.9000244140625,
      "bbox_min": [
        584.4000244140625,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        591.9000244140625,
        717.0,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -591.9000244140625,
      "bbox_min": [
        591.9000244140625,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        591.9000244140625,
        717.0,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -584.4000244140625,
      "bbox_min": [
        584.4000244140625,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        584.4000244140625,
        717.0,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 573.4000244140625,
      "bbox_min": [
        573.4000244140625,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        577.4000244140625,
        717.0,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -577.4000244140625,
      "bbox_min": [
        577.4000244140625,
        715.0,
        -18.149993896484375
      ],
      "bbox_max": [
        577.4000244140625,
        717.0,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 619.8696899414062,
      "bbox_min": [
        459.1000061035156,
        765.0,
        -19.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -459.1000061035156,
      "bbox_min": [
        459.1000061035156,
        765.0,
        -19.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 487.19000244140625,
      "bbox_min": [
        459.1000061035156,
        765.0,
        -19.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -591.7796020507812,
      "bbox_min": [
        487.19000244140625,
        765.0,
        -19.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 505.3768005371094,
      "bbox_min": [
        487.19000244140625,
        765.0,
        -19.0
      ],
      "bbox_max": [
        591.7796020507812,
        942.9959716796875,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071077823638916,
        -0.7071057558059692,
        0.0
      ],
      "plane_d": 236.38937377929688,
      "bbox_min": [
        505.3768005371094,
        765.0,
        -19.0
      ],
      "bbox_max": [
        591.7796020507812,
        942.9959716796875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 549.2000122070312,
      "bbox_min": [
        505.3768005371094,
        852.3330688476562,
        -19.0
      ],
      "bbox_max": [
        570.56640625,
        942.9959716796875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267987966537476,
        -0.9238811135292053,
        -7.831837365301908e-07
      ],
      "plane_d": 1054.33984375,
      "bbox_min": [
        549.2000122070312,
        904.87353515625,
        -19.0
      ],
      "bbox_max": [
        570.56640625,
        911.8958740234375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 911.8958740234375,
      "bbox_min": [
        549.2000122070312,
        905.0772094726562,
        -19.0
      ],
      "bbox_max": [
        558.2803344726562,
        911.8958740234375,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 16.0,
      "bbox_min": [
        553.6255493164062,
        905.0772094726562,
        -19.0
      ],
      "bbox_max": [
        558.2803344726562,
        909.1082153320312,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542449474334717,
        -0.4931878447532654,
        -0.16441155970096588
      ],
      "plane_d": 917.6683959960938,
      "bbox_min": [
        553.6255493164062,
        905.0772094726562,
        -19.0
      ],
      "bbox_max": [
        558.2803344726562,
        909.1082153320312,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": -32.171539306640625,
      "bbox_min": [
        553.6255493164062,
        905.0772094726562,
        -19.0
      ],
      "bbox_max": [
        558.2803344726562,
        909.1082153320312,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9863938689231873,
        -0.16439898312091827
      ],
      "plane_d": 890.1322021484375,
      "bbox_min": [
        553.6255493164062,
        905.0772094726562,
        -19.0
      ],
      "bbox_max": [
        558.2803344726562,
        909.1082153320312,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9863938689231873,
        -0.16439898312091827
      ],
      "plane_d": -899.369140625,
      "bbox_min": [
        553.6255493164062,
        907.0928344726562,
        -19.0
      ],
      "bbox_max": [
        558.2803344726562,
        909.1082153320312,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -926.932861328125,
      "bbox_min": [
        553.6255493164062,
        907.0928344726562,
        -19.0
      ],
      "bbox_max": [
        558.2803344726562,
        909.1082153320312,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542194962501526,
        0.4932328462600708,
        -0.1644088178873062
      ],
      "plane_d": 22.879180908203125,
      "bbox_min": [
        553.6255493164062,
        907.0928344726562,
        -19.0
      ],
      "bbox_max": [
        555.0779418945312,
        909.1082153320312,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 248.33596801757812,
      "bbox_min": [
        554.3999633789062,
        905.5999755859375,
        -16.0
      ],
      "bbox_max": [
        557.3999633789062,
        908.5999755859375,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1034.4971923828125,
      "bbox_min": [
        554.3999633789062,
        905.5999755859375,
        -16.0
      ],
      "bbox_max": [
        557.3999633789062,
        908.5999755859375,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -490.6877746582031,
      "bbox_min": [
        554.3999633789062,
        907.0999755859375,
        -16.0
      ],
      "bbox_max": [
        557.3999633789062,
        908.5999755859375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001361846924,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 320.8385314941406,
      "bbox_min": [
        554.3999633789062,
        905.5999755859375,
        -16.0
      ],
      "bbox_max": [
        555.8999633789062,
        908.5999755859375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1034.4971923828125,
      "bbox_min": [
        554.3999633789062,
        905.5999755859375,
        -16.0
      ],
      "bbox_max": [
        557.3999633789062,
        908.5999755859375,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -295.8770751953125,
      "bbox_min": [
        555.8999633789062,
        905.5999755859375,
        -16.0
      ],
      "bbox_max": [
        557.3999633789062,
        908.5999755859375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 515.6492919921875,
      "bbox_min": [
        554.3999633789062,
        905.5999755859375,
        -16.0
      ],
      "bbox_max": [
        557.3999633789062,
        907.0999755859375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        505.3768005371094,
        852.3330688476562,
        -19.0
      ],
      "bbox_max": [
        549.2000122070312,
        942.9959716796875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267987966537476,
        -0.9238811135292053,
        0.0
      ],
      "plane_d": 641.43994140625,
      "bbox_min": [
        505.3768005371094,
        852.3330688476562,
        -19.0
      ],
      "bbox_max": [
        530.0,
        911.8958740234375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 999.337646484375,
      "bbox_min": [
        505.3768005371094,
        904.87353515625,
        -19.0
      ],
      "bbox_max": [
        508.4031982421875,
        907.89990234375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.42566201090812683,
        0.9048822522163391
      ],
      "plane_d": -356.5469055175781,
      "bbox_min": [
        512.810791015625,
        852.5098876953125,
        -10.028987884521484
      ],
      "bbox_max": [
        518.9696044921875,
        858.948974609375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 518.9696044921875,
      "bbox_min": [
        518.9696044921875,
        853.2766723632812,
        -10.028987884521484
      ],
      "bbox_max": [
        518.9696044921875,
        858.948974609375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688879013062,
        -0.6246950626373291,
        0.0
      ],
      "plane_d": 128.06246948242188,
      "bbox_min": [
        524.0,
        860.0,
        -19.0
      ],
      "bbox_max": [
        530.0,
        867.5,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2906869053840637,
        0.3039150536060333,
        0.9072688817977905
      ],
      "plane_d": -402.80621337890625,
      "bbox_min": [
        505.3768005371094,
        852.3330688476562,
        -19.0
      ],
      "bbox_max": [
        530.0,
        882.330322265625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 10.028987884521484,
      "bbox_min": [
        505.3768005371094,
        852.3330688476562,
        -19.0
      ],
      "bbox_max": [
        518.9696044921875,
        868.3443603515625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9280772805213928,
        0.3723878860473633,
        0.0
      ],
      "plane_d": 149.16653442382812,
      "bbox_min": [
        505.3768005371094,
        858.948974609375,
        -19.0
      ],
      "bbox_max": [
        509.14666748046875,
        868.3443603515625,
        -10.028987884521484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.42566201090812683,
        0.9048822522163391
      ],
      "plane_d": -356.5469055175781,
      "bbox_min": [
        505.3768005371094,
        852.3330688476562,
        -10.028987884521484
      ],
      "bbox_max": [
        518.9696044921875,
        868.3443603515625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -505.87677001953125,
      "bbox_min": [
        505.8768005371094,
        852.3330688476562,
        -10.028987884521484
      ],
      "bbox_max": [
        505.91558837890625,
        858.948974609375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9280769228935242,
        -0.37238869071006775,
        -7.080685463733971e-06
      ],
      "plane_d": -149.66571044921875,
      "bbox_min": [
        505.8768005371094,
        858.8523559570312,
        -10.028987884521484
      ],
      "bbox_max": [
        505.91558837890625,
        858.948974609375,
        -9.983526229858398
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9280772805213928,
        0.3723878860473633,
        0.0
      ],
      "plane_d": 149.16653442382812,
      "bbox_min": [
        505.3768005371094,
        852.5098876953125,
        -10.028987884521484
      ],
      "bbox_max": [
        509.5359802246094,
        868.3443603515625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -505.87677001953125,
      "bbox_min": [
        505.8768005371094,
        852.5098876953125,
        -9.983526229858398
      ],
      "bbox_max": [
        505.8768005371094,
        858.8523559570312,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2912347614765167,
        0.30450543761253357,
        0.906895101070404
      ],
      "plane_d": -407.26983642578125,
      "bbox_min": [
        508.64666748046875,
        867.0982055664062,
        -19.0
      ],
      "bbox_max": [
        522.8851928710938,
        882.330322265625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.691183865070343,
        0.7226790189743042,
        -0.0
      ],
      "plane_d": -998.8016357421875,
      "bbox_min": [
        508.64666748046875,
        867.0982055664062,
        -19.0
      ],
      "bbox_max": [
        522.8851928710938,
        882.330322265625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9280769228935242,
        -0.37238869071006775,
        -7.080685463733971e-06
      ],
      "plane_d": -149.66571044921875,
      "bbox_min": [
        506.52471923828125,
        861.4374389648438,
        -10.028987884521484
      ],
      "bbox_max": [
        509.5747985839844,
        868.068603515625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 16.0,
      "bbox_min": [
        520.5255737304688,
        905.0772094726562,
        -19.0
      ],
      "bbox_max": [
        525.1803588867188,
        909.1082153320312,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542449474334717,
        -0.4931878447532654,
        -0.16441155970096588
      ],
      "plane_d": 889.3929443359375,
      "bbox_min": [
        520.5255737304688,
        905.0772094726562,
        -19.0
      ],
      "bbox_max": [
        525.1803588867188,
        909.1082153320312,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": -3.89599609375,
      "bbox_min": [
        520.5255737304688,
        905.0772094726562,
        -19.0
      ],
      "bbox_max": [
        525.1803588867188,
        909.1082153320312,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9863938689231873,
        -0.16439898312091827
      ],
      "plane_d": 890.1322021484375,
      "bbox_min": [
        520.5255737304688,
        905.0772094726562,
        -19.0
      ],
      "bbox_max": [
        525.1803588867188,
        909.1082153320312,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9863938689231873,
        -0.16439898312091827
      ],
      "plane_d": -899.369140625,
      "bbox_min": [
        520.5255737304688,
        907.0928344726562,
        -19.0
      ],
      "bbox_max": [
        525.1803588867188,
        909.1082153320312,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -898.658203125,
      "bbox_min": [
        520.5255737304688,
        907.0928344726562,
        -19.0
      ],
      "bbox_max": [
        525.1803588867188,
        909.1082153320312,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542194962501526,
        0.4932328462600708,
        -0.1644088178873062
      ],
      "plane_d": -5.39544677734375,
      "bbox_min": [
        520.5255737304688,
        907.0928344726562,
        -19.0
      ],
      "bbox_max": [
        521.9779663085938,
        909.1082153320312,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 271.7411804199219,
      "bbox_min": [
        521.2999877929688,
        905.5999755859375,
        -16.0
      ],
      "bbox_max": [
        524.2999877929688,
        908.5999755859375,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1011.092041015625,
      "bbox_min": [
        521.2999877929688,
        905.5999755859375,
        -16.0
      ],
      "bbox_max": [
        524.2999877929688,
        908.5999755859375,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -490.6877746582031,
      "bbox_min": [
        521.2999877929688,
        907.0999755859375,
        -16.0
      ],
      "bbox_max": [
        524.2999877929688,
        908.5999755859375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001361846924,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 302.47796630859375,
      "bbox_min": [
        521.2999877929688,
        905.5999755859375,
        -16.0
      ],
      "bbox_max": [
        522.7999877929688,
        908.5999755859375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1011.092041015625,
      "bbox_min": [
        521.2999877929688,
        905.5999755859375,
        -16.0
      ],
      "bbox_max": [
        524.2999877929688,
        908.5999755859375,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -277.5165100097656,
      "bbox_min": [
        522.7999877929688,
        905.5999755859375,
        -16.0
      ],
      "bbox_max": [
        524.2999877929688,
        908.5999755859375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 515.6492919921875,
      "bbox_min": [
        521.2999877929688,
        905.5999755859375,
        -16.0
      ],
      "bbox_max": [
        524.2999877929688,
        907.0999755859375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -8.0,
      "bbox_min": [
        530.0,
        867.5,
        -19.0
      ],
      "bbox_max": [
        549.2000122070312,
        942.9959716796875,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 911.8958740234375,
      "bbox_min": [
        530.0,
        867.5,
        -8.0
      ],
      "bbox_max": [
        549.2000122070312,
        911.8958740234375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -872.9349365234375,
      "bbox_min": [
        530.0,
        867.5,
        -8.0
      ],
      "bbox_max": [
        538.6278686523438,
        872.9349365234375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -218.67095947265625,
      "bbox_min": [
        530.0,
        867.5,
        -8.0
      ],
      "bbox_max": [
        533.1929321289062,
        872.9349365234375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        530.0,
        867.5,
        -8.0
      ],
      "bbox_max": [
        533.1929321289062,
        867.5,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 911.8958740234375,
      "bbox_min": [
        530.0,
        867.5,
        -19.0
      ],
      "bbox_max": [
        549.2000122070312,
        942.9959716796875,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 525.298828125,
      "bbox_min": [
        530.0,
        911.8958740234375,
        -19.0
      ],
      "bbox_max": [
        549.2000122070312,
        942.9959716796875,
        -8.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 931.9959716796875,
      "bbox_min": [
        530.0,
        931.9959716796875,
        -19.0
      ],
      "bbox_max": [
        549.2000122070312,
        942.9959716796875,
        -8.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 934.9959716796875,
      "bbox_min": [
        530.0,
        931.9959716796875,
        -19.0
      ],
      "bbox_max": [
        549.2000122070312,
        942.9959716796875,
        -8.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -534.75,
      "bbox_min": [
        534.75,
        934.9959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        942.9959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.25,
      "bbox_min": [
        534.75,
        934.9959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        942.9959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 18.0,
      "bbox_min": [
        534.75,
        934.9959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        942.9959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -11.5,
      "bbox_min": [
        534.75,
        934.9959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        942.9959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 942.9959716796875,
      "bbox_min": [
        534.75,
        942.9959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        942.9959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -538.75,
      "bbox_min": [
        530.5,
        931.9959716796875,
        -19.0
      ],
      "bbox_max": [
        548.7000122070312,
        934.9959716796875,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 934.4959716796875,
      "bbox_min": [
        530.5,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        934.9959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -534.75,
      "bbox_min": [
        534.75,
        934.4959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        934.9959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.25,
      "bbox_min": [
        534.75,
        934.4959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        934.9959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 18.0,
      "bbox_min": [
        534.75,
        934.4959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        934.9959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -11.5,
      "bbox_min": [
        534.75,
        934.4959716796875,
        -11.5
      ],
      "bbox_max": [
        538.25,
        934.9959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -534.75,
      "bbox_min": [
        530.5,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        934.4959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -530.5,
      "bbox_min": [
        530.5,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        534.0,
        934.4959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 534.0,
      "bbox_min": [
        530.5,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        534.0,
        934.4959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -11.5,
      "bbox_min": [
        530.5,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        534.0,
        934.4959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 18.0,
      "bbox_min": [
        530.5,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        534.0,
        934.4959716796875,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.25,
      "bbox_min": [
        534.75,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        934.4959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -11.5,
      "bbox_min": [
        534.75,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        934.4959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 18.0,
      "bbox_min": [
        534.75,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        934.4959716796875,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 540.4500122070312,
      "bbox_min": [
        540.4500122070312,
        931.9959716796875,
        -19.0
      ],
      "bbox_max": [
        548.7000122070312,
        934.9959716796875,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 934.4959716796875,
      "bbox_min": [
        540.9500122070312,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        548.7000122070312,
        934.4959716796875,
        -11.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -545.2000122070312,
      "bbox_min": [
        540.9500122070312,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        548.7000122070312,
        934.4959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -540.9500122070312,
      "bbox_min": [
        540.9500122070312,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        544.4500122070312,
        934.4959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 544.4500122070312,
      "bbox_min": [
        540.9500122070312,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        544.4500122070312,
        934.4959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -11.5,
      "bbox_min": [
        540.9500122070312,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        544.4500122070312,
        934.4959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 18.0,
      "bbox_min": [
        540.9500122070312,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        544.4500122070312,
        934.4959716796875,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 548.7000122070312,
      "bbox_min": [
        545.2000122070312,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        548.7000122070312,
        934.4959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -11.5,
      "bbox_min": [
        545.2000122070312,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        548.7000122070312,
        934.4959716796875,
        -11.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 18.0,
      "bbox_min": [
        545.2000122070312,
        931.9959716796875,
        -18.0
      ],
      "bbox_max": [
        548.7000122070312,
        934.4959716796875,
        -18.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 15.400001525878906,
      "bbox_min": [
        534.0999755859375,
        911.8958740234375,
        -19.0
      ],
      "bbox_max": [
        549.2000122070312,
        918.0,
        -15.400001525878906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -915.0,
      "bbox_min": [
        534.0999755859375,
        911.8958740234375,
        -19.0
      ],
      "bbox_max": [
        549.2000122070312,
        918.0,
        -15.400001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 534.0999755859375,
      "bbox_min": [
        534.0999755859375,
        911.8958740234375,
        -19.0
      ],
      "bbox_max": [
        534.0999755859375,
        915.0,
        -15.400001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 534.0999755859375,
      "bbox_min": [
        534.0999755859375,
        915.0,
        -19.0
      ],
      "bbox_max": [
        537.0,
        918.0,
        -15.400001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -537.0,
      "bbox_min": [
        534.0999755859375,
        915.0,
        -19.0
      ],
      "bbox_max": [
        537.0,
        918.0,
        -15.400001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -918.0,
      "bbox_min": [
        534.0999755859375,
        918.0,
        -19.0
      ],
      "bbox_max": [
        537.0,
        918.0,
        -15.400001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -872.9349365234375,
      "bbox_min": [
        532.3468017578125,
        872.9349365234375,
        -19.0
      ],
      "bbox_max": [
        538.6278686523438,
        872.9349365234375,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -573.5927734375,
      "bbox_min": [
        555.0,
        765.0,
        -19.0
      ],
      "bbox_max": [
        591.7796020507812,
        886.126708984375,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -1011.9912719726562,
      "bbox_min": [
        555.0,
        776.4407348632812,
        -19.0
      ],
      "bbox_max": [
        573.5927734375,
        882.330322265625,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2906869053840637,
        0.3039150536060333,
        0.9072688817977905
      ],
      "plane_d": -89.16386413574219,
      "bbox_min": [
        555.0,
        776.4407348632812,
        -19.0
      ],
      "bbox_max": [
        573.5927734375,
        882.330322265625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        555.0,
        776.4407348632812,
        -19.0
      ],
      "bbox_max": [
        573.5927734375,
        868.3443603515625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826832175254822,
        -0.9238796830177307,
        0.0
      ],
      "plane_d": 936.8421630859375,
      "bbox_min": [
        565.0,
        776.4407348632812,
        -19.0
      ],
      "bbox_max": [
        573.5927734375,
        780.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 809.5999755859375,
      "bbox_min": [
        555.0,
        795.0,
        -19.0
      ],
      "bbox_max": [
        573.5927734375,
        868.3443603515625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9280782341957092,
        0.37238526344299316,
        0.0
      ],
      "plane_d": -852.198974609375,
      "bbox_min": [
        569.8229370117188,
        809.5999755859375,
        -19.0
      ],
      "bbox_max": [
        573.5927734375,
        868.3443603515625,
        -10.028987884521484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826877772808075,
        -0.9238777756690979,
        0.0
      ],
      "plane_d": 529.4949951171875,
      "bbox_min": [
        570.89990234375,
        809.5999755859375,
        -19.0
      ],
      "bbox_max": [
        573.5927734375,
        810.7153930664062,
        -10.028987884521484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826877772808075,
        -0.9238777756690979,
        0.0
      ],
      "plane_d": 529.4949951171875,
      "bbox_min": [
        570.89990234375,
        809.5999755859375,
        -10.028987884521484
      ],
      "bbox_max": [
        573.5927734375,
        858.948974609375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 573.0927124023438,
      "bbox_min": [
        573.0540161132812,
        852.3328857421875,
        -10.028987884521484
      ],
      "bbox_max": [
        573.0927734375,
        858.948974609375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9280790090560913,
        -0.3723834156990051,
        0.0
      ],
      "plane_d": 851.69775390625,
      "bbox_min": [
        573.0540161132812,
        858.8523559570312,
        -10.028987884521484
      ],
      "bbox_max": [
        573.0927734375,
        858.948974609375,
        -9.983526229858398
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": -8.0,
      "bbox_min": [
        570.89990234375,
        809.5999755859375,
        -8.0
      ],
      "bbox_max": [
        573.5927734375,
        810.7153930664062,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9280782341957092,
        0.37238526344299316,
        0.0
      ],
      "plane_d": -852.198974609375,
      "bbox_min": [
        569.43359375,
        852.5098876953125,
        -10.028987884521484
      ],
      "bbox_max": [
        573.5927734375,
        868.3443603515625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 573.0927124023438,
      "bbox_min": [
        573.0927734375,
        852.5098876953125,
        -9.983526229858398
      ],
      "bbox_max": [
        573.0927734375,
        858.8523559570312,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": -8.0,
      "bbox_min": [
        567.2999267578125,
        795.0,
        -19.0
      ],
      "bbox_max": [
        573.5927734375,
        809.5999755859375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26764383912086487,
        -0.0,
        -0.9635179042816162
      ],
      "plane_d": 145.08969116210938,
      "bbox_min": [
        567.2999267578125,
        795.0,
        -8.0
      ],
      "bbox_max": [
        570.89990234375,
        809.5999755859375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268446922302246,
        0.9238792061805725,
        0.0
      ],
      "plane_d": -516.0093994140625,
      "bbox_min": [
        570.89990234375,
        795.0,
        -19.0
      ],
      "bbox_max": [
        573.5927734375,
        796.1154174804688,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7226590514183044,
        -0.6912046670913696,
        -0.0
      ],
      "plane_d": 1011.4913940429688,
      "bbox_min": [
        555.0,
        852.5098876953125,
        -19.0
      ],
      "bbox_max": [
        572.4448852539062,
        882.330322265625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2306823879480362,
        0.35812443494796753,
        0.9047277569770813
      ],
      "plane_d": -174.07261657714844,
      "bbox_min": [
        556.0844116210938,
        867.098388671875,
        -19.0
      ],
      "bbox_max": [
        570.3228759765625,
        882.330322265625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2912345230579376,
        0.30450519919395447,
        0.9068952798843384
      ],
      "plane_d": -93.03627014160156,
      "bbox_min": [
        556.0844116210938,
        867.098388671875,
        -19.0
      ],
      "bbox_max": [
        570.3228759765625,
        882.330322265625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.691183865070343,
        0.7226790189743042,
        0.0
      ],
      "plane_d": -253.0352783203125,
      "bbox_min": [
        556.0844116210938,
        867.098388671875,
        -19.0
      ],
      "bbox_max": [
        570.3228759765625,
        882.330322265625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9280782341957092,
        0.37238526344299316,
        0.0
      ],
      "plane_d": -852.198974609375,
      "bbox_min": [
        569.8229370117188,
        867.098388671875,
        -10.028987884521484
      ],
      "bbox_max": [
        570.3228759765625,
        868.3443603515625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        560.0,
        852.5098876953125,
        -10.028987884521484
      ],
      "bbox_max": [
        560.0,
        858.948974609375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9280790090560913,
        -0.3723834156990051,
        0.0
      ],
      "plane_d": 851.69775390625,
      "bbox_min": [
        569.3948364257812,
        861.4373779296875,
        -10.028987884521484
      ],
      "bbox_max": [
        572.4448852539062,
        868.068603515625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826832175254822,
        -0.9238796830177307,
        0.0
      ],
      "plane_d": 936.8421630859375,
      "bbox_min": [
        573.5927734375,
        765.0,
        -19.0
      ],
      "bbox_max": [
        585.8578491210938,
        776.4407348632812,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238796830177307,
        -0.3826832175254822,
        0.0
      ],
      "plane_d": 834.0148315429688,
      "bbox_min": [
        582.6776733398438,
        765.0,
        -19.0
      ],
      "bbox_max": [
        585.8578491210938,
        772.6776733398438,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        0.38268446922302246,
        0.0
      ],
      "plane_d": 235.11465454101562,
      "bbox_min": [
        573.5927734375,
        796.1154174804688,
        -19.0
      ],
      "bbox_max": [
        591.7796020507812,
        886.126708984375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        573.5927734375,
        796.1154174804688,
        -19.0
      ],
      "bbox_max": [
        591.7796020507812,
        886.126708984375,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": -8.0,
      "bbox_min": [
        573.5927734375,
        796.1154174804688,
        -19.0
      ],
      "bbox_max": [
        591.7796020507812,
        827.0,
        -8.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -578.2999267578125,
      "bbox_min": [
        573.5927734375,
        810.7153930664062,
        -19.0
      ],
      "bbox_max": [
        578.2999267578125,
        827.0,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238755106925964,
        -0.38269317150115967,
        0.0
      ],
      "plane_d": -221.6168212890625,
      "bbox_min": [
        573.5927734375,
        810.7153930664062,
        -19.0
      ],
      "bbox_max": [
        578.2999267578125,
        817.0,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826877772808075,
        -0.9238777756690979,
        0.0
      ],
      "plane_d": 529.4949951171875,
      "bbox_min": [
        573.5927734375,
        810.7153930664062,
        -19.0
      ],
      "bbox_max": [
        576.1324462890625,
        811.7673950195312,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238811135292053,
        -0.38267987966537476,
        -3.244017250381148e-07
      ],
      "plane_d": 884.2257080078125,
      "bbox_min": [
        590.5464477539062,
        881.9164428710938,
        -19.0
      ],
      "bbox_max": [
        591.7796020507812,
        886.126708984375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071077823638916,
        0.7071057558059692,
        0.0
      ],
      "plane_d": -208.13333129882812,
      "bbox_min": [
        590.5464477539062,
        884.8935546875,
        -19.0
      ],
      "bbox_max": [
        591.7796020507812,
        886.126708984375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -524.0,
      "bbox_min": [
        505.3768005371094,
        776.013916015625,
        -19.0
      ],
      "bbox_max": [
        555.0,
        880.947509765625,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        515.0,
        780.0,
        -19.0
      ],
      "bbox_max": [
        524.0,
        780.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 809.5999755859375,
      "bbox_min": [
        505.3768005371094,
        795.0,
        -19.0
      ],
      "bbox_max": [
        524.0,
        853.2766723632812,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.42566201090812683,
        0.9048822522163391
      ],
      "plane_d": -356.5469055175781,
      "bbox_min": [
        518.202880859375,
        852.5098876953125,
        -7.360686779022217
      ],
      "bbox_max": [
        518.9696044921875,
        853.2766723632812,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 518.9696044921875,
      "bbox_min": [
        518.9696044921875,
        852.5098876953125,
        -7.360686779022217
      ],
      "bbox_max": [
        518.9696044921875,
        853.2766723632812,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -8.0,
      "bbox_min": [
        505.3768005371094,
        809.5999755859375,
        -8.0
      ],
      "bbox_max": [
        508.0,
        810.6865234375,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -8.0,
      "bbox_min": [
        505.3768005371094,
        795.0,
        -19.0
      ],
      "bbox_max": [
        511.6000061035156,
        809.5999755859375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26764383912086487,
        0.0,
        -0.9635179042816162
      ],
      "plane_d": -143.67120361328125,
      "bbox_min": [
        508.0,
        795.0,
        -8.0
      ],
      "bbox_max": [
        511.6000061035156,
        809.5999755859375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268446922302246,
        0.9238792061805725,
        0.0
      ],
      "plane_d": -928.8876953125,
      "bbox_min": [
        505.3768005371094,
        795.0,
        -19.0
      ],
      "bbox_max": [
        508.0,
        796.0865478515625,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -872.9349365234375,
      "bbox_min": [
        538.6278686523438,
        867.5,
        -19.0
      ],
      "bbox_max": [
        551.8211669921875,
        872.9349365234375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688879013062,
        -0.6246950626373291,
        -0.0
      ],
      "plane_d": 970.6199951171875,
      "bbox_min": [
        546.5999755859375,
        780.0,
        -19.0
      ],
      "bbox_max": [
        555.0,
        867.5,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7226594090461731,
        0.691204309463501,
        0.0
      ],
      "plane_d": -998.3984985351562,
      "bbox_min": [
        551.8211669921875,
        864.176513671875,
        -15.513870239257812
      ],
      "bbox_max": [
        555.0,
        867.5,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2906869053840637,
        0.3039150536060333,
        0.9072688817977905
      ],
      "plane_d": -89.16386413574219,
      "bbox_min": [
        551.8211669921875,
        864.176513671875,
        -15.513869285583496
      ],
      "bbox_max": [
        555.0,
        867.5,
        -13.382085800170898
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        546.5999755859375,
        780.0,
        -19.0
      ],
      "bbox_max": [
        555.0,
        780.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 809.5999755859375,
      "bbox_min": [
        546.5999755859375,
        809.5999755859375,
        -19.0
      ],
      "bbox_max": [
        555.0,
        809.5999755859375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000009536743164,
        0.866024911403656,
        -0.0
      ],
      "plane_d": -1007.198974609375,
      "bbox_min": [
        546.5999755859375,
        844.4154052734375,
        -19.0
      ],
      "bbox_max": [
        549.2136840820312,
        847.4334106445312,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49998825788497925,
        -0.8660322427749634,
        0.0
      ],
      "plane_d": 457.99737548828125,
      "bbox_min": [
        546.5999755859375,
        844.4154052734375,
        -19.0
      ],
      "bbox_max": [
        549.2136840820312,
        847.4334106445312,
        -14.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 14.0,
      "bbox_min": [
        546.5999755859375,
        844.4154052734375,
        -16.417285919189453
      ],
      "bbox_max": [
        549.2136840820312,
        847.4334106445312,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2323693484067917,
        -0.4024743139743805,
        0.8854484558105469
      ],
      "plane_d": 481.40521240234375,
      "bbox_min": [
        546.5999755859375,
        844.4154052734375,
        -16.417285919189453
      ],
      "bbox_max": [
        548.34765625,
        846.4334106445312,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000011324882507,
        -0.8660247921943665,
        -0.0
      ],
      "plane_d": 1006.3329467773438,
      "bbox_min": [
        546.5999755859375,
        845.4243774414062,
        -15.5
      ],
      "bbox_max": [
        548.34765625,
        846.4334106445312,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -532.4000244140625,
      "bbox_min": [
        524.0,
        780.0,
        -19.0
      ],
      "bbox_max": [
        546.5999755859375,
        851.5244140625,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.9000244140625,
      "bbox_min": [
        524.0,
        780.0,
        -19.0
      ],
      "bbox_max": [
        532.4000244140625,
        847.4170532226562,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        524.0,
        780.0,
        -19.0
      ],
      "bbox_max": [
        532.4000244140625,
        780.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 809.5999755859375,
      "bbox_min": [
        524.0,
        809.5999755859375,
        -19.0
      ],
      "bbox_max": [
        532.4000244140625,
        809.5999755859375,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        0.866024911403656,
        0.0
      ],
      "plane_d": -467.68377685546875,
      "bbox_min": [
        526.0,
        828.0000610351562,
        -19.0
      ],
      "bbox_max": [
        532.4000244140625,
        847.4170532226562,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999162554740906,
        -0.8660303354263306,
        0.0
      ],
      "plane_d": 997.4990844726562,
      "bbox_min": [
        526.0,
        828.0000610351562,
        -19.0
      ],
      "bbox_max": [
        532.4000244140625,
        847.4170532226562,
        -14.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 14.0,
      "bbox_min": [
        529.8146362304688,
        844.4317626953125,
        -16.402421951293945
      ],
      "bbox_max": [
        532.4000244140625,
        847.4170532226562,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2323712557554245,
        -0.4024776518344879,
        0.8854463696479797
      ],
      "plane_d": 230.67391967773438,
      "bbox_min": [
        530.6806640625,
        844.4317626953125,
        -16.402421951293945
      ],
      "bbox_max": [
        532.4000244140625,
        846.4170532226562,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000011324882507,
        -0.8660247921943665,
        0.0
      ],
      "plane_d": 466.8175048828125,
      "bbox_min": [
        530.6806640625,
        845.4243774414062,
        -15.5
      ],
      "bbox_max": [
        532.4000244140625,
        846.4170532226562,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -828.0000610351562,
      "bbox_min": [
        526.0,
        828.0000610351562,
        -16.0
      ],
      "bbox_max": [
        529.0,
        828.0000610351562,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        0.866024911403656,
        0.0
      ],
      "plane_d": -467.68377685546875,
      "bbox_min": [
        532.4000244140625,
        844.3244018554688,
        -19.0
      ],
      "bbox_max": [
        546.5999755859375,
        851.5244140625,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000009536743164,
        0.866024911403656,
        -0.0
      ],
      "plane_d": -1007.198974609375,
      "bbox_min": [
        532.4000244140625,
        844.3244018554688,
        -19.0
      ],
      "bbox_max": [
        546.5999755859375,
        851.5244140625,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 14.0,
      "bbox_min": [
        532.4000244140625,
        844.3244018554688,
        -19.0
      ],
      "bbox_max": [
        546.5999755859375,
        851.5244140625,
        -14.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5000011324882507,
        -0.8660247921943665,
        0.0
      ],
      "plane_d": 466.8175048828125,
      "bbox_min": [
        532.4000244140625,
        844.3244018554688,
        -19.0
      ],
      "bbox_max": [
        546.5999755859375,
        850.5244140625,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000011324882507,
        -0.8660247921943665,
        -0.0
      ],
      "plane_d": 1006.3329467773438,
      "bbox_min": [
        532.4000244140625,
        844.3244018554688,
        -19.0
      ],
      "bbox_max": [
        546.5999755859375,
        850.5244140625,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999989867210388,
        -0.8660261034965515,
        -0.0
      ],
      "plane_d": 1004.4276123046875,
      "bbox_min": [
        532.4000244140625,
        844.3244018554688,
        -19.0
      ],
      "bbox_max": [
        546.5999755859375,
        850.5244140625,
        -14.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2323693484067917,
        -0.4024743139743805,
        0.8854484558105469
      ],
      "plane_d": 481.40521240234375,
      "bbox_min": [
        537.60888671875,
        844.3244018554688,
        -19.0
      ],
      "bbox_max": [
        546.5999755859375,
        850.5244140625,
        -15.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49998825788497925,
        -0.8660322427749634,
        0.0
      ],
      "plane_d": 457.99737548828125,
      "bbox_min": [
        546.4423828125,
        844.3244018554688,
        -19.0
      ],
      "bbox_max": [
        546.5999755859375,
        844.4154052734375,
        -16.417285919189453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2323712557554245,
        -0.4024776518344879,
        0.8854463696479797
      ],
      "plane_d": 230.67391967773438,
      "bbox_min": [
        537.60888671875,
        848.3244018554688,
        -16.5
      ],
      "bbox_max": [
        539.51416015625,
        850.5244140625,
        -15.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999989867210388,
        -0.8660261034965515,
        0.0
      ],
      "plane_d": 464.91455078125,
      "bbox_min": [
        532.4000244140625,
        844.3244018554688,
        -19.0
      ],
      "bbox_max": [
        539.51416015625,
        849.4243774414062,
        -14.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2323712557554245,
        -0.4024776518344879,
        0.8854463696479797
      ],
      "plane_d": 230.67391967773438,
      "bbox_min": [
        532.4000244140625,
        844.3244018554688,
        -19.0
      ],
      "bbox_max": [
        539.51416015625,
        849.4243774414062,
        -15.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999162554740906,
        -0.8660303354263306,
        0.0
      ],
      "plane_d": 997.4990844726562,
      "bbox_min": [
        532.4000244140625,
        844.3244018554688,
        -19.0
      ],
      "bbox_max": [
        532.5859375,
        844.4317626953125,
        -16.402421951293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 999.337646484375,
      "bbox_min": [
        487.19000244140625,
        765.0,
        -19.0
      ],
      "bbox_max": [
        505.3768005371094,
        926.0867309570312,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826832175254822,
        -0.9238796830177307,
        0.0
      ],
      "plane_d": 523.5443115234375,
      "bbox_min": [
        494.1421203613281,
        765.0,
        -19.0
      ],
      "bbox_max": [
        505.3768005371094,
        776.013916015625,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238796830177307,
        -0.3826832175254822,
        0.0
      ],
      "plane_d": -163.77520751953125,
      "bbox_min": [
        494.1421203613281,
        765.0,
        -19.0
      ],
      "bbox_max": [
        497.32232666015625,
        772.6776733398438,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.38268446922302246,
        0.0
      ],
      "plane_d": -761.6585083007812,
      "bbox_min": [
        487.19000244140625,
        796.0865478515625,
        -19.0
      ],
      "bbox_max": [
        505.3768005371094,
        886.1267700195312,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        487.19000244140625,
        796.0865478515625,
        -19.0
      ],
      "bbox_max": [
        505.3768005371094,
        886.1267700195312,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -8.0,
      "bbox_min": [
        487.19000244140625,
        796.0865478515625,
        -19.0
      ],
      "bbox_max": [
        505.3768005371094,
        827.0,
        -8.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 500.6000061035156,
      "bbox_min": [
        500.6000061035156,
        810.6865234375,
        -19.0
      ],
      "bbox_max": [
        505.3768005371094,
        827.0,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238793253898621,
        -0.38268396258354187,
        0.0
      ],
      "plane_d": 775.1467895507812,
      "bbox_min": [
        500.6000061035156,
        810.6865234375,
        -19.0
      ],
      "bbox_max": [
        505.3768005371094,
        817.0,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826858699321747,
        -0.92387855052948,
        0.0
      ],
      "plane_d": 942.37646484375,
      "bbox_min": [
        502.7674255371094,
        810.6865234375,
        -19.0
      ],
      "bbox_max": [
        505.3768005371094,
        811.7673950195312,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -971.0816650390625,
      "bbox_min": [
        487.19000244140625,
        884.8935546875,
        -19.0
      ],
      "bbox_max": [
        488.4232177734375,
        886.1267700195312,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071077823638916,
        0.7071057558059692,
        0.0
      ],
      "plane_d": -208.13333129882812,
      "bbox_min": [
        597.5687866210938,
        891.9158935546875,
        -19.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 613.9696044921875,
      "bbox_min": [
        597.5687866210938,
        973.0000610351562,
        -19.0
      ],
      "bbox_max": [
        619.8696899414062,
        990.0000610351562,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 973.0000610351562,
      "bbox_min": [
        613.9696044921875,
        973.0000610351562,
        -19.0
      ],
      "bbox_max": [
        619.8696899414062,
        973.0000610351562,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -597.9696044921875,
      "bbox_min": [
        597.5687866210938,
        973.0000610351562,
        -19.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 973.0000610351562,
      "bbox_min": [
        597.5687866210938,
        973.0000610351562,
        -19.0
      ],
      "bbox_max": [
        597.9696044921875,
        973.0000610351562,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 973.0000610351562,
      "bbox_min": [
        597.9696044921875,
        973.0000610351562,
        -19.0
      ],
      "bbox_max": [
        613.9696044921875,
        974.6499633789062,
        -7.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.6000366210938,
      "bbox_min": [
        597.9696044921875,
        973.0000610351562,
        -19.0
      ],
      "bbox_max": [
        613.9696044921875,
        974.6499633789062,
        -7.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 610.9696044921875,
      "bbox_min": [
        600.9696044921875,
        973.0000610351562,
        -19.0
      ],
      "bbox_max": [
        610.9696044921875,
        974.6000366210938,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -600.9696044921875,
      "bbox_min": [
        600.9696044921875,
        973.0000610351562,
        -19.0
      ],
      "bbox_max": [
        610.9696044921875,
        974.6000366210938,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -8.0,
      "bbox_min": [
        600.9696044921875,
        973.0000610351562,
        -8.0
      ],
      "bbox_max": [
        610.9696044921875,
        974.6000366210938,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -974.6499633789062,
      "bbox_min": [
        598.3800048828125,
        974.6499633789062,
        -16.5
      ],
      "bbox_max": [
        600.5799560546875,
        974.6499633789062,
        -13.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238811135292053,
        -0.38267987966537476,
        -3.244017250381148e-07
      ],
      "plane_d": 884.2257080078125,
      "bbox_min": [
        591.7796020507812,
        814.2953491210938,
        -19.0
      ],
      "bbox_max": [
        597.5687866210938,
        973.0000610351562,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 973.0000610351562,
      "bbox_min": [
        591.7796020507812,
        973.0000610351562,
        -19.0
      ],
      "bbox_max": [
        597.5687866210938,
        973.0000610351562,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        592.89990234375,
        827.0,
        -19.0
      ],
      "bbox_max": [
        597.5687866210938,
        827.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        0.38268446922302246,
        0.0
      ],
      "plane_d": 235.11465454101562,
      "bbox_min": [
        591.7796020507812,
        814.2953491210938,
        -19.0
      ],
      "bbox_max": [
        592.89990234375,
        827.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -8.0,
      "bbox_min": [
        591.7796020507812,
        814.2953491210938,
        -8.0
      ],
      "bbox_max": [
        592.89990234375,
        827.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        591.7796020507812,
        827.0,
        -8.0
      ],
      "bbox_max": [
        592.89990234375,
        827.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -971.0816650390625,
      "bbox_min": [
        459.1000061035156,
        891.916015625,
        -19.0
      ],
      "bbox_max": [
        481.4007873535156,
        990.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        459.1000061035156,
        973.0,
        -19.0
      ],
      "bbox_max": [
        481.4007873535156,
        990.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 973.0,
      "bbox_min": [
        459.1000061035156,
        973.0,
        -19.0
      ],
      "bbox_max": [
        465.0,
        973.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 481.0,
      "bbox_min": [
        465.0,
        973.0,
        -19.0
      ],
      "bbox_max": [
        481.4007873535156,
        990.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 973.0,
      "bbox_min": [
        481.0,
        973.0,
        -19.0
      ],
      "bbox_max": [
        481.4007873535156,
        973.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 973.0,
      "bbox_min": [
        465.0,
        973.0,
        -19.0
      ],
      "bbox_max": [
        481.0,
        974.5999755859375,
        -7.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.5999755859375,
      "bbox_min": [
        465.0,
        973.0,
        -19.0
      ],
      "bbox_max": [
        481.0,
        974.5999755859375,
        -7.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -468.0,
      "bbox_min": [
        468.0,
        973.0,
        -19.0
      ],
      "bbox_max": [
        478.0,
        974.5999755859375,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 478.0,
      "bbox_min": [
        468.0,
        973.0,
        -19.0
      ],
      "bbox_max": [
        478.0,
        974.5999755859375,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -8.0,
      "bbox_min": [
        468.0,
        973.0,
        -8.0
      ],
      "bbox_max": [
        478.0,
        974.5999755859375,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238793253898621,
        -0.3826841115951538,
        7.159964638958627e-07
      ],
      "plane_d": -112.609375,
      "bbox_min": [
        481.4007873535156,
        814.1270751953125,
        -19.0
      ],
      "bbox_max": [
        487.19000244140625,
        973.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 973.0,
      "bbox_min": [
        481.4007873535156,
        973.0,
        -19.0
      ],
      "bbox_max": [
        487.19000244140625,
        973.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        481.4007873535156,
        827.0,
        -19.0
      ],
      "bbox_max": [
        486.0,
        827.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.38268446922302246,
        0.0
      ],
      "plane_d": -761.6585083007812,
      "bbox_min": [
        486.0,
        814.1270751953125,
        -19.0
      ],
      "bbox_max": [
        487.19000244140625,
        827.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -8.0,
      "bbox_min": [
        486.0,
        814.1270751953125,
        -8.0
      ],
      "bbox_max": [
        487.19000244140625,
        827.0,
        -7.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -827.0,
      "bbox_min": [
        486.0,
        827.0,
        -8.0
      ],
      "bbox_max": [
        487.19000244140625,
        827.0,
        -7.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3910849392414093,
        -0.8043984770774841,
        -0.4472087025642395
      ],
      "plane_d": 1177.23583984375,
      "bbox_min": [
        367.0,
        1074.587158203125,
        -20.0
      ],
      "bbox_max": [
        633.0,
        1211.544189453125,
        10.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.3911505937576294,
        0.8045321702957153,
        0.4469107389450073
      ],
      "plane_d": -1179.03955078125,
      "bbox_min": [
        541.737060546875,
        1169.6009521484375,
        -20.0
      ],
      "bbox_max": [
        624.2405395507812,
        1211.544189453125,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3919532001018524,
        0.8061860799789429,
        0.4432118833065033
      ],
      "plane_d": -1181.405029296875,
      "bbox_min": [
        541.737060546875,
        1169.6009521484375,
        -20.0
      ],
      "bbox_max": [
        608.3814086914062,
        1210.9742431640625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0008344935486093163,
        -0.0017153091030195355,
        0.9999982714653015
      ],
      "plane_d": 18.529294967651367,
      "bbox_min": [
        550.0620727539062,
        1176.0596923828125,
        -16.0034122467041
      ],
      "bbox_max": [
        595.5333862304688,
        1205.3753662109375,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 3.119999885559082,
      "bbox_min": [
        550.0620727539062,
        1176.0596923828125,
        -16.0034122467041
      ],
      "bbox_max": [
        595.5333862304688,
        1205.3753662109375,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8933931589126587,
        -0.4343589246273041,
        -0.11480818688869476
      ],
      "plane_d": 27.705596923828125,
      "bbox_min": [
        550.0620727539062,
        1176.0596923828125,
        -16.0034122467041
      ],
      "bbox_max": [
        595.5333862304688,
        1205.3753662109375,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8860724568367004,
        0.4307996928691864,
        -0.17113511264324188
      ],
      "plane_d": 14.58575439453125,
      "bbox_min": [
        587.6471557617188,
        1176.0596923828125,
        -16.003389358520508
      ],
      "bbox_max": [
        595.5333862304688,
        1184.6834716796875,
        3.119999885559082
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39011192321777344,
        0.8039982318878174,
        0.4487758278846741
      ],
      "plane_d": -1177.7916259765625,
      "bbox_min": [
        544.7171630859375,
        1205.507080078125,
        -18.86025047302246
      ],
      "bbox_max": [
        553.037353515625,
        1210.9742431640625,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3911891281604767,
        0.8043363690376282,
        0.44722938537597656
      ],
      "plane_d": -1178.825439453125,
      "bbox_min": [
        541.9362182617188,
        1169.6009521484375,
        -16.00027847290039
      ],
      "bbox_max": [
        606.8853759765625,
        1209.544189453125,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8859508037567139,
        0.4311008155345917,
        -0.17100664973258972
      ],
      "plane_d": 14.1591796875,
      "bbox_min": [
        588.4124755859375,
        1177.6337890625,
        -16.000276565551758
      ],
      "bbox_max": [
        595.597412109375,
        1184.8150634765625,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3935222327709198,
        0.8033431768417358,
        0.4469676613807678
      ],
      "plane_d": -1178.881103515625,
      "bbox_min": [
        541.9362182617188,
        1195.906982421875,
        -16.00027847290039
      ],
      "bbox_max": [
        553.037353515625,
        1209.544189453125,
        8.053512573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8933931589126587,
        -0.4343589246273041,
        -0.11480818688869476
      ],
      "plane_d": 27.705596923828125,
      "bbox_min": [
        550.827392578125,
        1195.906982421875,
        -16.00027847290039
      ],
      "bbox_max": [
        553.0198974609375,
        1205.47119140625,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39011192321777344,
        0.8039982318878174,
        0.4487758278846741
      ],
      "plane_d": -1177.7916259765625,
      "bbox_min": [
        544.4124145507812,
        1195.906982421875,
        -16.000076293945312
      ],
      "bbox_max": [
        553.037353515625,
        1209.544189453125,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8683816194534302,
        0.4733186662197113,
        -0.1479288637638092
      ],
      "plane_d": -33.55621337890625,
      "bbox_min": [
        597.1549682617188,
        1169.6009521484375,
        -15.99997329711914
      ],
      "bbox_max": [
        606.8853759765625,
        1179.3270263671875,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35837575793266296,
        -0.9335775375366211,
        0.0
      ],
      "plane_d": 913.0895385742188,
      "bbox_min": [
        596.231201171875,
        1185.1844482421875,
        -20.0
      ],
      "bbox_max": [
        615.6742553710938,
        1211.544189453125,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 17.5,
      "bbox_min": [
        596.231201171875,
        1207.524169921875,
        -20.0
      ],
      "bbox_max": [
        603.3758544921875,
        1211.5440673828125,
        -17.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9335796236991882,
        -0.358370304107666,
        0.0
      ],
      "plane_d": 990.810791015625,
      "bbox_min": [
        596.231201171875,
        1207.524169921875,
        -20.0
      ],
      "bbox_max": [
        603.3758544921875,
        1211.5440673828125,
        -17.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9335796236991882,
        0.358370304107666,
        0.0
      ],
      "plane_d": -996.810791015625,
      "bbox_min": [
        602.6581420898438,
        1209.6744384765625,
        -20.0
      ],
      "bbox_max": [
        603.3758544921875,
        1211.5440673828125,
        -17.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40673866868019104,
        -0.9135445952415466,
        0.0
      ],
      "plane_d": 853.4344482421875,
      "bbox_min": [
        601.87255859375,
        1185.1844482421875,
        -20.0
      ],
      "bbox_max": [
        615.6742553710938,
        1211.544189453125,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9135449528694153,
        0.4067377746105194,
        -0.0
      ],
      "plane_d": -1053.9149169921875,
      "bbox_min": [
        609.859619140625,
        1206.6917724609375,
        -20.0
      ],
      "bbox_max": [
        615.6742553710938,
        1211.544189453125,
        -15.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9135449528694153,
        -0.4067377746105194,
        -0.0
      ],
      "plane_d": 1049.9149169921875,
      "bbox_min": [
        609.859619140625,
        1206.6917724609375,
        -20.0
      ],
      "bbox_max": [
        615.6742553710938,
        1211.544189453125,
        -15.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 18.0,
      "bbox_min": [
        610.3048706054688,
        1206.6917724609375,
        -18.0
      ],
      "bbox_max": [
        615.6742553710938,
        1210.544189453125,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.363804429769516,
        0.8171948194503784,
        0.4470335841178894
      ],
      "plane_d": -756.2944946289062,
      "bbox_min": [
        611.6133422851562,
        1206.6917724609375,
        -18.0
      ],
      "bbox_max": [
        615.6742553710938,
        1210.544189453125,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 17.600006103515625,
      "bbox_min": [
        611.6946411132812,
        1206.6917724609375,
        -18.0
      ],
      "bbox_max": [
        615.6742553710938,
        1209.049560546875,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3638257086277008,
        -0.8171610832214355,
        0.44707798957824707
      ],
      "plane_d": 771.4403686523438,
      "bbox_min": [
        611.938720703125,
        1206.6917724609375,
        -18.0
      ],
      "bbox_max": [
        615.6742553710938,
        1208.5013427734375,
        -17.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9115225672721863,
        -0.40583735704421997,
        0.066503144800663
      ],
      "plane_d": 1051.382080078125,
      "bbox_min": [
        613.1510009765625,
        1208.662841796875,
        -18.0
      ],
      "bbox_max": [
        615.2675170898438,
        1210.544189453125,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40670478343963623,
        -0.9135596752166748,
        -8.258625712187495e-06
      ],
      "plane_d": 854.4734497070312,
      "bbox_min": [
        613.9886474609375,
        1208.662841796875,
        -18.0
      ],
      "bbox_max": [
        615.2675170898438,
        1209.232177734375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 15.0,
      "bbox_min": [
        614.0377197265625,
        1208.744140625,
        -15.0
      ],
      "bbox_max": [
        614.8453979492188,
        1209.0443115234375,
        -15.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 17.0,
      "bbox_min": [
        601.87255859375,
        1185.1844482421875,
        -20.0
      ],
      "bbox_max": [
        606.52734375,
        1189.2154541015625,
        -8.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542449474334717,
        -0.4931878447532654,
        -0.16441155970096588
      ],
      "plane_d": 1096.8642578125,
      "bbox_min": [
        601.87255859375,
        1185.1844482421875,
        -20.0
      ],
      "bbox_max": [
        606.52734375,
        1189.2154541015625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": 64.59490966796875,
      "bbox_min": [
        601.87255859375,
        1185.1844482421875,
        -20.0
      ],
      "bbox_max": [
        606.52734375,
        1189.2154541015625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9863938689231873,
        -0.16439898312091827
      ],
      "plane_d": 1166.263916015625,
      "bbox_min": [
        601.87255859375,
        1185.1844482421875,
        -20.0
      ],
      "bbox_max": [
        606.52734375,
        1189.2154541015625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9863938689231873,
        -0.16439898312091827
      ],
      "plane_d": -1175.82958984375,
      "bbox_min": [
        601.87255859375,
        1187.2000732421875,
        -20.0
      ],
      "bbox_max": [
        606.52734375,
        1189.2154541015625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -1106.468994140625,
      "bbox_min": [
        601.87255859375,
        1187.2000732421875,
        -20.0
      ],
      "bbox_max": [
        606.52734375,
        1189.2154541015625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542194962501526,
        0.4932328462600708,
        -0.1644088178873062
      ],
      "plane_d": -74.22967529296875,
      "bbox_min": [
        601.87255859375,
        1187.2000732421875,
        -20.0
      ],
      "bbox_max": [
        603.324951171875,
        1189.2154541015625,
        -17.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071195244789124,
        -0.7070940732955933,
        -0.0
      ],
      "plane_d": 1266.67138671875,
      "bbox_min": [
        602.4146728515625,
        1185.5452880859375,
        -17.0
      ],
      "bbox_max": [
        605.87939453125,
        1188.9395751953125,
        -8.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -412.28582763671875,
      "bbox_min": [
        602.4146728515625,
        1185.5452880859375,
        -17.0
      ],
      "bbox_max": [
        605.87939453125,
        1188.9395751953125,
        -8.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -280.4807434082031,
      "bbox_min": [
        604.1470947265625,
        1185.5452880859375,
        -17.0
      ],
      "bbox_max": [
        605.87939453125,
        1188.9395751953125,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660718202590942
      ],
      "plane_d": -579.6510620117188,
      "bbox_min": [
        602.4146728515625,
        1187.2071533203125,
        -17.0
      ],
      "bbox_max": [
        605.87939453125,
        1188.9395751953125,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -412.28582763671875,
      "bbox_min": [
        602.4146728515625,
        1185.5452880859375,
        -17.0
      ],
      "bbox_max": [
        605.808837890625,
        1188.9395751953125,
        -8.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156153440475464,
        0.8568202257156372
      ],
      "plane_d": 625.8742065429688,
      "bbox_min": [
        602.4853515625,
        1185.5452880859375,
        -17.0
      ],
      "bbox_max": [
        605.808837890625,
        1187.2071533203125,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": 333.12432861328125,
      "bbox_min": [
        602.4146728515625,
        1185.5455322265625,
        -17.0
      ],
      "bbox_max": [
        604.1470947265625,
        1188.9395751953125,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39115041494369507,
        -0.8045331239700317,
        -0.4469091296195984
      ],
      "plane_d": 786.2899780273438,
      "bbox_min": [
        367.0,
        1074.587158203125,
        -20.0
      ],
      "bbox_max": [
        633.0,
        1211.544189453125,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.391153484582901,
        0.8045374751091003,
        0.44689875841140747
      ],
      "plane_d": -787.894287109375,
      "bbox_min": [
        375.7594909667969,
        1169.6009521484375,
        -20.0
      ],
      "bbox_max": [
        458.2629089355469,
        1211.544189453125,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3919530212879181,
        0.8061851859092712,
        0.4432135820388794
      ],
      "plane_d": -789.4508056640625,
      "bbox_min": [
        391.6185607910156,
        1169.6009521484375,
        -20.0
      ],
      "bbox_max": [
        458.2629089355469,
        1210.9742431640625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 16.0,
      "bbox_min": [
        404.46661376953125,
        1176.068359375,
        -16.0
      ],
      "bbox_max": [
        449.93365478515625,
        1205.375244140625,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 3.119999885559082,
      "bbox_min": [
        404.46661376953125,
        1176.068359375,
        -16.0
      ],
      "bbox_max": [
        449.93365478515625,
        1205.375244140625,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.886067807674408,
        0.4307974576950073,
        -0.17116455733776093
      ],
      "plane_d": -871.4820556640625,
      "bbox_min": [
        404.46661376953125,
        1176.068359375,
        -16.0
      ],
      "bbox_max": [
        449.93365478515625,
        1205.375244140625,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8933910727500916,
        -0.4343579411506653,
        -0.1148284301161766
      ],
      "plane_d": 921.0967407226562,
      "bbox_min": [
        447.0266418457031,
        1194.341552734375,
        -16.0
      ],
      "bbox_max": [
        449.93365478515625,
        1205.375244140625,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 16.0,
      "bbox_min": [
        391.6185607910156,
        1169.6009521484375,
        -20.0
      ],
      "bbox_max": [
        458.063720703125,
        1210.9742431640625,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3911891281604767,
        0.8043363690376282,
        0.44722938537597656
      ],
      "plane_d": -787.6362915039062,
      "bbox_min": [
        391.6185607910156,
        1179.3255615234375,
        -20.0
      ],
      "bbox_max": [
        455.2828369140625,
        1210.9742431640625,
        -16.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.39011093974113464,
        0.803998589515686,
        0.44877588748931885
      ],
      "plane_d": -787.6806030273438,
      "bbox_min": [
        446.96258544921875,
        1205.507080078125,
        -18.86025047302246
      ],
      "bbox_max": [
        455.2828369140625,
        1210.9742431640625,
        -16.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3911891281604767,
        0.8043363690376282,
        0.44722938537597656
      ],
      "plane_d": -787.6362915039062,
      "bbox_min": [
        393.1145935058594,
        1169.6009521484375,
        -16.0
      ],
      "bbox_max": [
        458.063720703125,
        1209.544189453125,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.886067807674408,
        0.4307974576950073,
        -0.17116455733776093
      ],
      "plane_d": -871.4820556640625,
      "bbox_min": [
        404.4025573730469,
        1177.6337890625,
        -16.0
      ],
      "bbox_max": [
        411.5874938964844,
        1184.8150634765625,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39352136850357056,
        0.8033435344696045,
        0.4469677209854126
      ],
      "plane_d": -785.3597412109375,
      "bbox_min": [
        446.96258544921875,
        1195.906982421875,
        -16.0
      ],
      "bbox_max": [
        458.063720703125,
        1209.544189453125,
        8.053512573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8933910727500916,
        -0.4343579411506653,
        -0.1148284301161766
      ],
      "plane_d": 921.0967407226562,
      "bbox_min": [
        446.98004150390625,
        1195.906982421875,
        -16.0
      ],
      "bbox_max": [
        449.17254638671875,
        1205.47119140625,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39011093974113464,
        0.803998589515686,
        0.44877588748931885
      ],
      "plane_d": -787.6806030273438,
      "bbox_min": [
        446.96258544921875,
        1195.906982421875,
        -16.0
      ],
      "bbox_max": [
        455.5875549316406,
        1209.544189453125,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8683817982673645,
        0.4733181893825531,
        -0.1479291170835495
      ],
      "plane_d": -901.9373779296875,
      "bbox_min": [
        393.1145935058594,
        1169.6009521484375,
        -16.0
      ],
      "bbox_max": [
        402.8450012207031,
        1179.3271484375,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1196.0,
      "bbox_min": [
        381.9288330078125,
        1196.0,
        -19.99622917175293
      ],
      "bbox_max": [
        407.37176513671875,
        1202.4000244140625,
        0.28832685947418213
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.374540028744377e-06,
        0.0,
        1.0
      ],
      "plane_d": 15.997538566589355,
      "bbox_min": [
        381.9288330078125,
        1196.0,
        -19.99622917175293
      ],
      "bbox_max": [
        407.37176513671875,
        1202.4000244140625,
        0.28832685947418213
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1198.0,
      "bbox_min": [
        392.371826171875,
        1196.0,
        -19.99622917175293
      ],
      "bbox_max": [
        407.37176513671875,
        1201.0,
        -15.99610710144043
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 392.371826171875,
      "bbox_min": [
        392.371826171875,
        1196.0,
        -19.9962158203125
      ],
      "bbox_max": [
        407.37176513671875,
        1198.0,
        -15.99610710144043
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -7.629414540133439e-06
      ],
      "plane_d": -407.37188720703125,
      "bbox_min": [
        407.3717346191406,
        1196.0,
        -19.996156692504883
      ],
      "bbox_max": [
        407.37176513671875,
        1198.0,
        -15.996167182922363
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1201.0,
      "bbox_min": [
        392.371826171875,
        1198.0,
        -19.99622917175293
      ],
      "bbox_max": [
        407.37176513671875,
        1201.0,
        -15.99610710144043
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8945363759994507,
        0.44699519872665405,
        -1.9501503629726358e-05
      ],
      "plane_d": -171.98614501953125,
      "bbox_min": [
        392.371826171875,
        1198.0,
        -19.99622917175293
      ],
      "bbox_max": [
        407.37176513671875,
        1201.0,
        -15.99610710144043
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1198.4000244140625,
      "bbox_min": [
        406.57171630859375,
        1198.0,
        -19.996170043945312
      ],
      "bbox_max": [
        407.37176513671875,
        1198.4000244140625,
        -15.996153831481934
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8945363759994507,
        0.44699519872665405,
        -6.8247923081798945e-06
      ],
      "plane_d": -899.9092407226562,
      "bbox_min": [
        407.1718444824219,
        1198.0,
        -19.996156692504883
      ],
      "bbox_max": [
        407.37176513671875,
        1198.4000244140625,
        -15.996153831481934
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.855774361407384e-06,
        0.0665009543299675,
        0.9977864027023315
      ],
      "plane_d": -61.115379333496094,
      "bbox_min": [
        392.371826171875,
        1198.0,
        -19.99622917175293
      ],
      "bbox_max": [
        406.371826171875,
        1201.0,
        -15.99610710144043
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -4.359756349003874e-05
      ],
      "plane_d": 393.3709716796875,
      "bbox_min": [
        392.371826171875,
        1198.0,
        -19.99622917175293
      ],
      "bbox_max": [
        406.371826171875,
        1201.0,
        -18.596227645874023
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -8.719613106222823e-06,
        2.1800682588946074e-05
      ],
      "plane_d": -406.3609313964844,
      "bbox_min": [
        406.3717956542969,
        1198.0,
        -19.99615478515625
      ],
      "bbox_max": [
        406.371826171875,
        1201.0,
        -18.596309661865234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1198.4000244140625,
      "bbox_min": [
        392.371826171875,
        1198.0,
        -19.99622917175293
      ],
      "bbox_max": [
        393.3718566894531,
        1198.4000244140625,
        -18.596227645874023
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8945363759994507,
        0.44699519872665405,
        0.0
      ],
      "plane_d": -184.50936889648438,
      "bbox_min": [
        392.371826171875,
        1198.0,
        -19.99622917175293
      ],
      "bbox_max": [
        393.3718566894531,
        1198.4000244140625,
        -18.596227645874023
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944000005722046,
        0.44726821780204773,
        3.1492712878389284e-05
      ],
      "plane_d": -887.6586303710938,
      "bbox_min": [
        393.1717834472656,
        1198.0,
        -19.996212005615234
      ],
      "bbox_max": [
        393.3718566894531,
        1198.4000244140625,
        -18.596233367919922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8945363759994507,
        0.44699519872665405,
        0.0
      ],
      "plane_d": -184.50936889648438,
      "bbox_min": [
        392.371826171875,
        1198.0,
        -18.622896194458008
      ],
      "bbox_max": [
        393.3718566894531,
        1198.4000244140625,
        -15.99610710144043
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944000005722046,
        0.44726821780204773,
        3.1492712878389284e-05
      ],
      "plane_d": -887.6586303710938,
      "bbox_min": [
        393.17181396484375,
        1198.0,
        -18.622896194458008
      ],
      "bbox_max": [
        393.3718566894531,
        1198.4000244140625,
        -15.996211051940918
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.877301037311554,
        0.4528670608997345,
        -0.15891622006893158
      ],
      "plane_d": -881.5009155273438,
      "bbox_min": [
        381.9288330078125,
        1199.4000244140625,
        -12.0
      ],
      "bbox_max": [
        384.67095947265625,
        1202.4000244140625,
        0.28832685947418213
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8045952320098877,
        -0.39067497849464417,
        -0.44721293449401855
      ],
      "plane_d": 940.6162109375,
      "bbox_min": [
        367.0,
        1074.587158203125,
        -20.0
      ],
      "bbox_max": [
        633.0,
        1211.5440673828125,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8045949339866638,
        0.3906748294830322,
        -0.4472138285636902
      ],
      "plane_d": 60.11285400390625,
      "bbox_min": [
        367.0,
        1074.587158203125,
        -20.0
      ],
      "bbox_max": [
        633.0,
        1211.5440673828125,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8045951128005981,
        -0.3906744718551636,
        -0.44721394777297974
      ],
      "plane_d": 136.02041625976562,
      "bbox_min": [
        367.0,
        1074.587158203125,
        -20.0
      ],
      "bbox_max": [
        594.8152465820312,
        1211.5440673828125,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8045954704284668,
        0.3906746208667755,
        -0.4472128748893738
      ],
      "plane_d": -744.4820556640625,
      "bbox_min": [
        367.0,
        1074.587158203125,
        -20.0
      ],
      "bbox_max": [
        594.8152465820312,
        1211.5440673828125,
        10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910848796367645,
        -0.8043990731239319,
        -0.44720762968063354
      ],
      "plane_d": 786.1513671875,
      "bbox_min": [
        392.4007263183594,
        1167.9921875,
        -20.0
      ],
      "bbox_max": [
        594.8152465820312,
        1211.5440673828125,
        10.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 3.119999885559082,
      "bbox_min": [
        405.1847229003906,
        1176.059326171875,
        -16.0
      ],
      "bbox_max": [
        449.9380187988281,
        1203.8983154296875,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.886067807674408,
        0.4307974576950073,
        -0.17116455733776093
      ],
      "plane_d": -871.4820556640625,
      "bbox_min": [
        405.1847229003906,
        1176.059326171875,
        -16.0
      ],
      "bbox_max": [
        449.9380187988281,
        1203.8983154296875,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8933910727500916,
        -0.4343579411506653,
        -0.1148284301161766
      ],
      "plane_d": 921.0967407226562,
      "bbox_min": [
        447.7447509765625,
        1194.3326416015625,
        -16.0
      ],
      "bbox_max": [
        449.9380187988281,
        1203.8983154296875,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 3.119999885559082,
      "bbox_min": [
        405.1847229003906,
        1176.0250244140625,
        -16.0034122467041
      ],
      "bbox_max": [
        594.8152465820312,
        1203.8983154296875,
        3.119999885559082
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8933910727500916,
        -0.4343579411506653,
        -0.1148284301161766
      ],
      "plane_d": 921.0967407226562,
      "bbox_min": [
        447.7447509765625,
        1194.2982177734375,
        -16.0
      ],
      "bbox_max": [
        449.9547119140625,
        1203.8983154296875,
        3.119999885559082
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 990.0000610351562,
      "bbox_min": [
        552.0,
        974.6000366210938,
        -66.0
      ],
      "bbox_max": [
        613.9696044921875,
        1004.9035034179688,
        -60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1004.9035034179688,
      "bbox_min": [
        552.0,
        1000.0,
        -66.0
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        552.0,
        1000.0,
        -66.0
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 558.0,
      "bbox_min": [
        552.0,
        1000.0,
        -66.0
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -552.0,
      "bbox_min": [
        552.0,
        1000.0,
        -66.0
      ],
      "bbox_max": [
        552.0,
        1004.9035034179688,
        -60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.6000366210938,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -66.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 613.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -66.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -66.0
      ],
      "bbox_max": [
        597.9696044921875,
        990.0000610351562,
        -60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -40.0,
      "bbox_min": [
        367.0,
        840.0,
        -60.000038146972656
      ],
      "bbox_max": [
        633.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.4372446537017822,
        -0.8993426561355591,
        9.20251579827891e-07
      ],
      "plane_d": 1326.18603515625,
      "bbox_min": [
        367.0,
        974.5999755859375,
        -40.0
      ],
      "bbox_max": [
        633.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1298.4000244140625,
      "bbox_min": [
        443.0,
        1214.2452392578125,
        -40.0
      ],
      "bbox_max": [
        586.700439453125,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -27.0,
      "bbox_min": [
        443.0,
        1214.2452392578125,
        -40.0
      ],
      "bbox_max": [
        586.700439453125,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 901.1368408203125,
      "bbox_min": [
        443.0,
        1214.2452392578125,
        -27.0
      ],
      "bbox_max": [
        586.700439453125,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1260.39990234375,
      "bbox_min": [
        443.0,
        1214.2452392578125,
        -27.0
      ],
      "bbox_max": [
        586.700439453125,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8949184417724609,
        -0.44622981548309326,
        0.0
      ],
      "plane_d": 32.096649169921875,
      "bbox_min": [
        443.0,
        1214.2452392578125,
        -27.0
      ],
      "bbox_max": [
        586.700439453125,
        1260.4000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -330.2188720703125,
      "bbox_min": [
        443.0,
        1258.4000244140625,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1260.4000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 493.0,
      "bbox_min": [
        443.0,
        1258.4000244140625,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1260.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        6.424753337341826e-06
      ],
      "plane_d": -442.9998474121094,
      "bbox_min": [
        443.0,
        1259.23828125,
        -27.0
      ],
      "bbox_max": [
        443.0000305175781,
        1260.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8949184417724609,
        0.44622981548309326,
        0.0
      ],
      "plane_d": -22.0966796875,
      "bbox_min": [
        571.8140869140625,
        1214.2452392578125,
        -27.0
      ],
      "bbox_max": [
        586.700439453125,
        1230.6146240234375,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.446229487657547,
        -0.89491868019104,
        -0.0
      ],
      "plane_d": 1359.1097412109375,
      "bbox_min": [
        571.8140869140625,
        1214.2452392578125,
        -27.0
      ],
      "bbox_max": [
        586.700439453125,
        1230.6146240234375,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.446229487657547,
        0.89491868019104,
        0.0
      ],
      "plane_d": -1345.804443359375,
      "bbox_min": [
        571.8140869140625,
        1214.2452392578125,
        -27.0
      ],
      "bbox_max": [
        580.7632446289062,
        1218.70751953125,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        6.424753337341826e-06
      ],
      "plane_d": -442.9998474121094,
      "bbox_min": [
        443.0,
        1260.4000244140625,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 493.0,
      "bbox_min": [
        443.0,
        1260.4000244140625,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -468.0,
      "bbox_min": [
        443.0,
        1260.4000244140625,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -330.2188720703125,
      "bbox_min": [
        443.0,
        1260.4000244140625,
        -27.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": -22.09998893737793,
      "bbox_min": [
        443.0,
        1273.4000244140625,
        -27.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1277.9000244140625,
      "bbox_min": [
        454.4998779296875,
        1277.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        455.5001220703125,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0001220703125,
        -0.0
      ],
      "plane_d": -455.6561279296875,
      "bbox_min": [
        454.4998779296875,
        1277.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        455.5001220703125,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0001220703125,
        0.0
      ],
      "plane_d": 454.3438720703125,
      "bbox_min": [
        454.4998779296875,
        1277.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        455.5,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1278.9000244140625,
      "bbox_min": [
        454.5,
        1278.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        455.5,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 24.0,
      "bbox_min": [
        443.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1090.5103759765625,
      "bbox_min": [
        443.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1370.72705078125,
      "bbox_min": [
        443.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        448.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 199.0782470703125,
      "bbox_min": [
        443.0,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        448.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880849480628967,
        -0.45967939496040344,
        0.0
      ],
      "plane_d": 990.26953125,
      "bbox_min": [
        443.0,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        443.732177734375,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1377.0169677734375,
      "bbox_min": [
        463.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1084.220458984375,
      "bbox_min": [
        463.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        -0.0
      ],
      "plane_d": 1008.0950927734375,
      "bbox_min": [
        463.0,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 181.31716918945312,
      "bbox_min": [
        467.267822265625,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 331.63311767578125,
      "bbox_min": [
        468.0,
        1260.4000244140625,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": -22.09998893737793,
      "bbox_min": [
        468.0,
        1273.4000244140625,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0001220703125,
        0.0
      ],
      "plane_d": 479.3438720703125,
      "bbox_min": [
        479.4998779296875,
        1277.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        480.5,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1278.9000244140625,
      "bbox_min": [
        479.5,
        1278.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        480.5,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 24.0,
      "bbox_min": [
        468.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1082.64794921875,
      "bbox_min": [
        468.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1378.5894775390625,
      "bbox_min": [
        468.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        473.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 176.87689208984375,
      "bbox_min": [
        468.0,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        473.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 1012.535400390625,
      "bbox_min": [
        468.0,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        468.732177734375,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1384.87939453125,
      "bbox_min": [
        488.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1076.358154296875,
      "bbox_min": [
        488.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        -0.0
      ],
      "plane_d": 1030.29638671875,
      "bbox_min": [
        488.0,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 159.11581420898438,
      "bbox_min": [
        492.267822265625,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 556.0,
      "bbox_min": [
        506.0,
        1260.4000244140625,
        -27.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -531.0,
      "bbox_min": [
        506.0,
        1260.4000244140625,
        -27.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -374.7666015625,
      "bbox_min": [
        506.0,
        1260.4000244140625,
        -27.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": -22.09998893737793,
      "bbox_min": [
        506.0,
        1273.4000244140625,
        -27.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1277.9000244140625,
      "bbox_min": [
        517.4998779296875,
        1277.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        518.5001220703125,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0001220703125,
        -0.0
      ],
      "plane_d": -518.6561279296875,
      "bbox_min": [
        517.4998779296875,
        1277.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        518.5001220703125,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0001220703125,
        0.0
      ],
      "plane_d": 517.3438720703125,
      "bbox_min": [
        517.4998779296875,
        1277.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        518.5,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1278.9000244140625,
      "bbox_min": [
        517.5,
        1278.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        518.5,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 24.0,
      "bbox_min": [
        506.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1070.6971435546875,
      "bbox_min": [
        506.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1390.5404052734375,
      "bbox_min": [
        506.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        511.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 143.130859375,
      "bbox_min": [
        506.0,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        511.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880849480628967,
        -0.45967939496040344,
        0.0
      ],
      "plane_d": 1046.2188720703125,
      "bbox_min": [
        506.0,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        506.732177734375,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1396.830322265625,
      "bbox_min": [
        526.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1064.4072265625,
      "bbox_min": [
        526.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        -0.0
      ],
      "plane_d": 1064.04248046875,
      "bbox_min": [
        526.0,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 125.36978149414062,
      "bbox_min": [
        530.267822265625,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 376.18084716796875,
      "bbox_min": [
        531.0,
        1260.4000244140625,
        -27.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": -22.09998893737793,
      "bbox_min": [
        531.0,
        1273.4000244140625,
        -27.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -20.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1277.9000244140625,
      "bbox_min": [
        542.4998779296875,
        1277.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        543.5001220703125,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0001220703125,
        0.0
      ],
      "plane_d": 542.3438720703125,
      "bbox_min": [
        542.4998779296875,
        1277.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        543.5,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1278.9000244140625,
      "bbox_min": [
        542.5,
        1278.9000244140625,
        -22.099990844726562
      ],
      "bbox_max": [
        543.5,
        1278.9000244140625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 24.0,
      "bbox_min": [
        531.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1062.834716796875,
      "bbox_min": [
        531.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1398.40283203125,
      "bbox_min": [
        531.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        536.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 120.92950439453125,
      "bbox_min": [
        531.0,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        536.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 1068.4827880859375,
      "bbox_min": [
        531.0,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        531.732177734375,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1404.692626953125,
      "bbox_min": [
        551.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1056.5447998046875,
      "bbox_min": [
        551.0,
        1296.4000244140625,
        -27.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        -0.0
      ],
      "plane_d": 1086.243896484375,
      "bbox_min": [
        551.0,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 103.16845703125,
      "bbox_min": [
        555.267822265625,
        1296.9857177734375,
        -27.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -24.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        443.0,
        1214.2452392578125,
        -40.0
      ],
      "bbox_max": [
        586.700439453125,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18506789207458496,
        0.9827257990837097,
        0.0
      ],
      "plane_d": -1306.7369384765625,
      "bbox_min": [
        556.0,
        1224.7191162109375,
        -40.0
      ],
      "bbox_max": [
        557.4915161132812,
        1225.0,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8949185013771057,
        0.44622984528541565,
        0.0
      ],
      "plane_d": -22.0966796875,
      "bbox_min": [
        570.915283203125,
        1214.2452392578125,
        -40.0
      ],
      "bbox_max": [
        586.1258544921875,
        1225.0,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4462294578552246,
        0.8949186205863953,
        0.0
      ],
      "plane_d": -1345.8043212890625,
      "bbox_min": [
        571.8140869140625,
        1214.2452392578125,
        -40.0
      ],
      "bbox_max": [
        580.7632446289062,
        1225.0,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8949270844459534,
        -0.4462123513221741,
        0.0
      ],
      "plane_d": 32.070465087890625,
      "bbox_min": [
        571.8140869140625,
        1218.70751953125,
        -40.0
      ],
      "bbox_max": [
        574.95166015625,
        1225.0,
        -27.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -33.20000076293945,
      "bbox_min": [
        572.2590942382812,
        1220.4974365234375,
        -33.20000076293945
      ],
      "bbox_max": [
        574.95166015625,
        1225.0,
        -33.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 493.0,
      "bbox_min": [
        443.0,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        586.700439453125,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 556.0,
      "bbox_min": [
        493.0,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        586.700439453125,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4462319314479828,
        -0.8949174284934998,
        -0.0
      ],
      "plane_d": 1360.3017578125,
      "bbox_min": [
        556.0,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        586.700439453125,
        1239.9000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1529429405927658,
        -0.9882351160049438,
        0.0
      ],
      "plane_d": 1310.3489990234375,
      "bbox_min": [
        556.0,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        586.700439453125,
        1239.9000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8949161171913147,
        0.4462343454360962,
        0.0
      ],
      "plane_d": -32.6036376953125,
      "bbox_min": [
        574.3929443359375,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        586.700439453125,
        1231.9046630859375,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4462294578552246,
        -0.8949186205863953,
        0.0
      ],
      "plane_d": 1359.1094970703125,
      "bbox_min": [
        574.3929443359375,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        586.700439453125,
        1230.6146240234375,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8949185013771057,
        0.44622984528541565,
        0.0
      ],
      "plane_d": -22.0966796875,
      "bbox_min": [
        574.3929443359375,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        586.700439453125,
        1230.6146240234375,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8949150443077087,
        -0.446236789226532,
        0.0
      ],
      "plane_d": 32.107177734375,
      "bbox_min": [
        574.3929443359375,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        577.7512817382812,
        1230.6146240234375,
        -27.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -33.20000076293945,
      "bbox_min": [
        574.3929443359375,
        1225.0,
        -33.20000076293945
      ],
      "bbox_max": [
        576.8588256835938,
        1229.0479736328125,
        -33.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        6.424753337341826e-06
      ],
      "plane_d": -505.9998474121094,
      "bbox_min": [
        493.0,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1239.9000244140625,
      "bbox_min": [
        493.0,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        506.0000915527344,
        1239.9000244140625,
        -27.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1260.39990234375,
      "bbox_min": [
        506.0,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1239.9000244140625,
      "bbox_min": [
        506.0000305175781,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        556.0,
        1260.4000244140625,
        -27.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 529.0,
      "bbox_min": [
        519.0,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        543.0,
        1260.4000244140625,
        -29.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 543.0,
      "bbox_min": [
        533.0,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        543.0,
        1260.4000244140625,
        -29.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -533.0,
      "bbox_min": [
        533.0,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        543.0,
        1260.4000244140625,
        -29.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -29.0,
      "bbox_min": [
        533.0,
        1239.9000244140625,
        -29.5
      ],
      "bbox_max": [
        543.0,
        1260.4000244140625,
        -29.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 533.9730224609375,
      "bbox_min": [
        536.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        540.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": -587.1914672851562,
      "bbox_min": [
        536.0,
        1252.0,
        -29.5
      ],
      "bbox_max": [
        540.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 213.76809692382812,
      "bbox_min": [
        536.0,
        1252.0,
        -29.5
      ],
      "bbox_max": [
        540.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": -267.4337463378906,
      "bbox_min": [
        537.0,
        1252.0,
        -29.5
      ],
      "bbox_max": [
        540.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -29.5,
      "bbox_min": [
        537.0,
        1253.0,
        -29.5
      ],
      "bbox_max": [
        539.0,
        1254.0,
        -29.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 530.2163696289062,
      "bbox_min": [
        536.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        540.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": -583.4348754882812,
      "bbox_min": [
        536.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        540.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 213.76809692382812,
      "bbox_min": [
        536.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        540.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": -267.4337463378906,
      "bbox_min": [
        537.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        540.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -29.5,
      "bbox_min": [
        537.0,
        1244.5999755859375,
        -29.5
      ],
      "bbox_max": [
        539.0,
        1245.5999755859375,
        -29.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -519.0,
      "bbox_min": [
        519.0,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        529.0,
        1260.4000244140625,
        -29.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -29.0,
      "bbox_min": [
        519.0,
        1239.9000244140625,
        -29.5
      ],
      "bbox_max": [
        529.0,
        1260.4000244140625,
        -29.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 533.9730224609375,
      "bbox_min": [
        522.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        526.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": -587.1914672851562,
      "bbox_min": [
        522.0,
        1252.0,
        -29.5
      ],
      "bbox_max": [
        526.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": -261.1727294921875,
      "bbox_min": [
        522.0,
        1252.0,
        -29.5
      ],
      "bbox_max": [
        526.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 207.50711059570312,
      "bbox_min": [
        522.0,
        1252.0,
        -29.5
      ],
      "bbox_max": [
        525.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -29.5,
      "bbox_min": [
        523.0,
        1253.0,
        -29.5
      ],
      "bbox_max": [
        525.0,
        1254.0,
        -29.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 530.2163696289062,
      "bbox_min": [
        522.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        526.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": -583.4348754882812,
      "bbox_min": [
        522.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        526.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": -261.1727294921875,
      "bbox_min": [
        522.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        526.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 207.50711059570312,
      "bbox_min": [
        522.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        525.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -29.5,
      "bbox_min": [
        523.0,
        1244.5999755859375,
        -29.5
      ],
      "bbox_max": [
        525.0,
        1245.5999755859375,
        -29.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -531.0,
      "bbox_min": [
        506.0,
        1260.4000244140625,
        -40.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8880849480628967,
        -0.45967939496040344,
        0.0
      ],
      "plane_d": 1046.2188720703125,
      "bbox_min": [
        506.0,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1390.5404052734375,
      "bbox_min": [
        506.732177734375,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        -0.0
      ],
      "plane_d": 1064.04248046875,
      "bbox_min": [
        508.5,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1396.830322265625,
      "bbox_min": [
        526.732177734375,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1064.4072265625,
      "bbox_min": [
        528.5,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 125.36978149414062,
      "bbox_min": [
        530.267822265625,
        1296.9857177734375,
        -40.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 143.130859375,
      "bbox_min": [
        508.5,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        524.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1070.6971435546875,
      "bbox_min": [
        508.5,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        510.267822265625,
        1296.9857177734375,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        513.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        524.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 39.0,
      "bbox_min": [
        513.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        524.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -524.0,
      "bbox_min": [
        513.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        524.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 513.0,
      "bbox_min": [
        513.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        513.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977863430976868,
        0.0,
        0.06650284677743912
      ],
      "plane_d": 531.1543579101562,
      "bbox_min": [
        529.666748046875,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        531.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 38.0,
      "bbox_min": [
        529.666748046875,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        531.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        529.666748046875,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        531.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        529.666748046875,
        1284.9000244140625,
        -40.0
      ],
      "bbox_max": [
        531.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        506.0,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        509.854736328125,
        1284.9000244140625,
        -31.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977863430976868,
        -0.0,
        0.06650284677743912
      ],
      "plane_d": -503.5500793457031,
      "bbox_min": [
        506.0,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        507.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 38.0,
      "bbox_min": [
        506.0,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        507.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        506.0,
        1284.9000244140625,
        -40.0
      ],
      "bbox_max": [
        507.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 533.7625122070312,
      "bbox_min": [
        506.46044921875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        509.854736328125,
        1264.7794189453125,
        -31.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1252.455810546875,
      "bbox_min": [
        506.46044921875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        509.854736328125,
        1264.7794189453125,
        -31.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49991968274116516,
        0.0,
        0.8660717606544495
      ],
      "plane_d": 287.8324279785156,
      "bbox_min": [
        506.46044921875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        508.19287109375,
        1264.7794189453125,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010555333457887173,
        0.5077883005142212,
        0.8614171743392944
      ],
      "plane_d": -613.1293334960938,
      "bbox_min": [
        506.46044921875,
        1263.0469970703125,
        -40.0
      ],
      "bbox_max": [
        509.854736328125,
        1264.7794189453125,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1252.455810546875,
      "bbox_min": [
        506.46044921875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        509.854736328125,
        1264.7088623046875,
        -31.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.010593190789222717,
        -0.5078163743019104,
        0.861400306224823
      ],
      "plane_d": 669.6071166992188,
      "bbox_min": [
        506.46044921875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        509.8544921875,
        1263.0469970703125,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5156153440475464,
        -3.787668902077712e-05,
        0.8568202257156372
      ],
      "plane_d": -228.56820678710938,
      "bbox_min": [
        508.19287109375,
        1261.3853759765625,
        -40.0
      ],
      "bbox_max": [
        509.854736328125,
        1264.7088623046875,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 103.16845703125,
      "bbox_min": [
        531.0,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1056.5447998046875,
      "bbox_min": [
        531.0,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        555.267822265625,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 120.92950439453125,
      "bbox_min": [
        531.0,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        553.5,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1062.834716796875,
      "bbox_min": [
        531.0,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        535.267822265625,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1398.40283203125,
      "bbox_min": [
        531.0,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        533.5,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 1068.4827880859375,
      "bbox_min": [
        531.0,
        1296.9857177734375,
        -40.0
      ],
      "bbox_max": [
        531.732177734375,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        -0.0
      ],
      "plane_d": 1086.243896484375,
      "bbox_min": [
        538.0,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        553.5,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1404.692626953125,
      "bbox_min": [
        551.732177734375,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        553.5,
        1296.9857177734375,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        538.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        549.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 39.0,
      "bbox_min": [
        538.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        549.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 538.0,
      "bbox_min": [
        538.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        549.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -549.0,
      "bbox_min": [
        549.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        549.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977863430976868,
        -0.0,
        0.06650284677743912
      ],
      "plane_d": -528.4947509765625,
      "bbox_min": [
        531.0,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        532.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 38.0,
      "bbox_min": [
        531.0,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        532.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        531.0,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        532.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        531.0,
        1284.9000244140625,
        -40.0
      ],
      "bbox_max": [
        532.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        552.145263671875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        556.0,
        1284.9000244140625,
        -31.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977863430976868,
        0.0,
        0.06650284677743912
      ],
      "plane_d": 556.0989990234375,
      "bbox_min": [
        554.666748046875,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        556.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 38.0,
      "bbox_min": [
        554.666748046875,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        556.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        554.666748046875,
        1284.9000244140625,
        -40.0
      ],
      "bbox_max": [
        556.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1284.7099609375,
      "bbox_min": [
        552.145263671875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        555.53955078125,
        1264.7794189453125,
        -31.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 501.50836181640625,
      "bbox_min": [
        552.145263671875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        555.53955078125,
        1264.7794189453125,
        -31.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.010555334389209747,
        0.5077883005142212,
        0.861417293548584
      ],
      "plane_d": -601.9195556640625,
      "bbox_min": [
        552.145263671875,
        1263.0469970703125,
        -40.0
      ],
      "bbox_max": [
        555.53955078125,
        1264.7794189453125,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49991968274116516,
        0.0,
        0.8660717606544495
      ],
      "plane_d": -243.08229064941406,
      "bbox_min": [
        553.80712890625,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        555.53955078125,
        1264.7794189453125,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -501.5083312988281,
      "bbox_min": [
        552.145263671875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        555.53955078125,
        1264.7088623046875,
        -31.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.010593204759061337,
        -0.5078163146972656,
        0.8614001870155334
      ],
      "plane_d": 680.8570556640625,
      "bbox_min": [
        552.1455078125,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        555.53955078125,
        1263.0469970703125,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5156152844429016,
        -3.787668174481951e-05,
        0.8568201661109924
      ],
      "plane_d": 319.0152587890625,
      "bbox_min": [
        552.145263671875,
        1261.3853759765625,
        -40.0
      ],
      "bbox_max": [
        553.80712890625,
        1264.7088623046875,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        6.424753337341826e-06
      ],
      "plane_d": -442.9998474121094,
      "bbox_min": [
        443.0,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1260.39990234375,
      "bbox_min": [
        443.0,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        456.0,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        493.0,
        1260.4000244140625,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1239.9000244140625,
      "bbox_min": [
        482.7755126953125,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        493.0,
        1239.9000244140625,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -29.0,
      "bbox_min": [
        456.0,
        1241.24951171875,
        -40.0
      ],
      "bbox_max": [
        480.0,
        1260.4000244140625,
        -29.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        456.0,
        1243.5999755859375,
        -40.0
      ],
      "bbox_max": [
        477.0,
        1260.4000244140625,
        -29.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 466.0,
      "bbox_min": [
        456.0,
        1248.0560302734375,
        -40.0
      ],
      "bbox_max": [
        466.0,
        1260.4000244140625,
        -29.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -456.0,
      "bbox_min": [
        456.0,
        1252.0,
        -40.0
      ],
      "bbox_max": [
        463.0,
        1260.4000244140625,
        -29.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": -587.1914672851562,
      "bbox_min": [
        459.0,
        1252.0,
        -29.5
      ],
      "bbox_max": [
        463.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": -232.99827575683594,
      "bbox_min": [
        459.0,
        1252.0,
        -29.5
      ],
      "bbox_max": [
        463.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 179.33265686035156,
      "bbox_min": [
        459.0,
        1252.0,
        -29.5
      ],
      "bbox_max": [
        462.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -29.5,
      "bbox_min": [
        460.0,
        1253.0,
        -29.5
      ],
      "bbox_max": [
        462.0,
        1254.0,
        -29.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 533.9730224609375,
      "bbox_min": [
        473.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        477.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": -587.1914672851562,
      "bbox_min": [
        473.0,
        1252.0,
        -29.5
      ],
      "bbox_max": [
        477.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 185.59364318847656,
      "bbox_min": [
        473.0,
        1252.0,
        -29.5
      ],
      "bbox_max": [
        477.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": -239.25926208496094,
      "bbox_min": [
        474.0,
        1252.0,
        -29.5
      ],
      "bbox_max": [
        477.0,
        1255.0,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -29.5,
      "bbox_min": [
        474.0,
        1253.0,
        -29.5
      ],
      "bbox_max": [
        476.0,
        1254.0,
        -29.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": -583.4348754882812,
      "bbox_min": [
        473.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        477.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": -239.25926208496094,
      "bbox_min": [
        473.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        477.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 530.2163696289062,
      "bbox_min": [
        473.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        477.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -29.5,
      "bbox_min": [
        473.0,
        1244.3082275390625,
        -29.5
      ],
      "bbox_max": [
        476.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 185.59364318847656,
      "bbox_min": [
        473.0,
        1244.3082275390625,
        -29.5
      ],
      "bbox_max": [
        474.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -468.0,
      "bbox_min": [
        443.0,
        1260.4000244140625,
        -40.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8880849480628967,
        -0.45967939496040344,
        0.0
      ],
      "plane_d": 990.26953125,
      "bbox_min": [
        443.0,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1370.72705078125,
      "bbox_min": [
        443.732177734375,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        -0.0
      ],
      "plane_d": 1008.0950927734375,
      "bbox_min": [
        445.5,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1377.0169677734375,
      "bbox_min": [
        463.732177734375,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1084.220458984375,
      "bbox_min": [
        465.5,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 181.31716918945312,
      "bbox_min": [
        467.267822265625,
        1296.9857177734375,
        -40.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 199.0782470703125,
      "bbox_min": [
        445.5,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        461.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1090.5103759765625,
      "bbox_min": [
        445.5,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        447.267822265625,
        1296.9857177734375,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        450.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        461.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 39.0,
      "bbox_min": [
        450.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        461.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -461.0,
      "bbox_min": [
        450.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        461.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 450.0,
      "bbox_min": [
        450.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        450.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977863430976868,
        0.0,
        0.06650284677743912
      ],
      "plane_d": 468.2938232421875,
      "bbox_min": [
        466.666748046875,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        468.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 38.0,
      "bbox_min": [
        466.666748046875,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        468.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        466.666748046875,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        468.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        466.666748046875,
        1284.9000244140625,
        -40.0
      ],
      "bbox_max": [
        468.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        443.0,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        446.854736328125,
        1284.9000244140625,
        -31.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977863430976868,
        -0.0,
        0.06650284677743912
      ],
      "plane_d": -440.6895446777344,
      "bbox_min": [
        443.0,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        444.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 38.0,
      "bbox_min": [
        443.0,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        444.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        443.0,
        1284.9000244140625,
        -40.0
      ],
      "bbox_max": [
        444.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 578.3102416992188,
      "bbox_min": [
        443.46044921875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        446.854736328125,
        1264.7794189453125,
        -31.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1207.9080810546875,
      "bbox_min": [
        443.46044921875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        446.854736328125,
        1264.7794189453125,
        -31.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49991968274116516,
        0.0,
        0.8660717606544495
      ],
      "plane_d": 256.3374938964844,
      "bbox_min": [
        443.46044921875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        445.19287109375,
        1264.7794189453125,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010555333457887173,
        0.5077883005142212,
        0.8614171743392944
      ],
      "plane_d": -612.46435546875,
      "bbox_min": [
        443.46044921875,
        1263.0469970703125,
        -40.0
      ],
      "bbox_max": [
        446.854736328125,
        1264.7794189453125,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1207.9080810546875,
      "bbox_min": [
        443.46044921875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        446.854736328125,
        1264.7088623046875,
        -31.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.010593190789222717,
        -0.5078163743019104,
        0.861400306224823
      ],
      "plane_d": 670.2745361328125,
      "bbox_min": [
        443.46044921875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        446.8544921875,
        1263.0469970703125,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5156153440475464,
        -3.787668902077712e-05,
        0.8568202257156372
      ],
      "plane_d": -196.08444213867188,
      "bbox_min": [
        445.19287109375,
        1261.3853759765625,
        -40.0
      ],
      "bbox_max": [
        446.854736328125,
        1264.7088623046875,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 159.11581420898438,
      "bbox_min": [
        468.0,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1076.358154296875,
      "bbox_min": [
        468.0,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        492.267822265625,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 176.87689208984375,
      "bbox_min": [
        468.0,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        490.5,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1082.64794921875,
      "bbox_min": [
        468.0,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        472.267822265625,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1378.5894775390625,
      "bbox_min": [
        468.0,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        470.5,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 1012.535400390625,
      "bbox_min": [
        468.0,
        1296.9857177734375,
        -40.0
      ],
      "bbox_max": [
        468.732177734375,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        -0.0
      ],
      "plane_d": 1030.29638671875,
      "bbox_min": [
        475.0,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        490.5,
        1298.4000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1384.87939453125,
      "bbox_min": [
        488.732177734375,
        1296.4000244140625,
        -40.0
      ],
      "bbox_max": [
        490.5,
        1296.9857177734375,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        475.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        486.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 39.0,
      "bbox_min": [
        475.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        486.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 475.0,
      "bbox_min": [
        475.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        486.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -486.0,
      "bbox_min": [
        486.0,
        1297.4000244140625,
        -40.0
      ],
      "bbox_max": [
        486.0,
        1298.4000244140625,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977863430976868,
        -0.0,
        0.06650284677743912
      ],
      "plane_d": -465.6341857910156,
      "bbox_min": [
        468.0,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        469.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 38.0,
      "bbox_min": [
        468.0,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        469.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        468.0,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        469.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        468.0,
        1284.9000244140625,
        -40.0
      ],
      "bbox_max": [
        469.333251953125,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        489.145263671875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        493.0,
        1284.9000244140625,
        -31.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977863430976868,
        0.0,
        0.06650284677743912
      ],
      "plane_d": 493.2384948730469,
      "bbox_min": [
        491.666748046875,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        493.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 38.0,
      "bbox_min": [
        491.666748046875,
        1271.9000244140625,
        -40.0
      ],
      "bbox_max": [
        493.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        491.666748046875,
        1284.9000244140625,
        -40.0
      ],
      "bbox_max": [
        493.0,
        1284.9000244140625,
        -38.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1240.1622314453125,
      "bbox_min": [
        489.145263671875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        492.53955078125,
        1264.7794189453125,
        -31.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -546.0560302734375,
      "bbox_min": [
        489.145263671875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        492.53955078125,
        1264.7794189453125,
        -31.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49991968274116516,
        0.0,
        0.8660717606544495
      ],
      "plane_d": -211.58734130859375,
      "bbox_min": [
        490.80712890625,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        492.53955078125,
        1264.7794189453125,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.010555334389209747,
        0.5077883005142212,
        0.861417293548584
      ],
      "plane_d": -602.5845947265625,
      "bbox_min": [
        489.145263671875,
        1263.0469970703125,
        -40.0
      ],
      "bbox_max": [
        492.53955078125,
        1264.7794189453125,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -546.0560302734375,
      "bbox_min": [
        489.145263671875,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        492.53955078125,
        1264.7088623046875,
        -31.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.010593204759061337,
        -0.5078163146972656,
        0.8614001870155334
      ],
      "plane_d": 680.189697265625,
      "bbox_min": [
        489.1455078125,
        1261.3145751953125,
        -40.0
      ],
      "bbox_max": [
        492.53955078125,
        1263.0469970703125,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5156152844429016,
        -3.787668174481951e-05,
        0.8568201661109924
      ],
      "plane_d": 286.531494140625,
      "bbox_min": [
        489.145263671875,
        1261.3853759765625,
        -40.0
      ],
      "bbox_max": [
        490.80712890625,
        1264.7088623046875,
        -39.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43724513053894043,
        0.8993424773216248,
        -0.0
      ],
      "plane_d": -1137.9971923828125,
      "bbox_min": [
        367.0,
        974.5999755859375,
        -40.0
      ],
      "bbox_max": [
        633.0,
        1259.23828125,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.5999755859375,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -40.0
      ],
      "bbox_max": [
        598.05810546875,
        990.0,
        -20.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -40.0
      ],
      "bbox_max": [
        597.9696044921875,
        990.0,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 481.0,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -40.0
      ],
      "bbox_max": [
        597.9696044921875,
        990.0,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -40.0
      ],
      "bbox_max": [
        597.9696044921875,
        974.64306640625,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -40.0
      ],
      "bbox_max": [
        465.0,
        990.0,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43724513053894043,
        -0.8993424773216248,
        0.0
      ],
      "plane_d": 888.94091796875,
      "bbox_min": [
        367.0,
        974.6000366210938,
        -40.0
      ],
      "bbox_max": [
        633.0,
        1259.23828125,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -27.0,
      "bbox_min": [
        411.799560546875,
        1214.2452392578125,
        -40.0
      ],
      "bbox_max": [
        500.0,
        1259.23828125,
        -20.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        6.424753337341826e-06
      ],
      "plane_d": -442.9998474121094,
      "bbox_min": [
        441.80908203125,
        1217.285400390625,
        -27.0
      ],
      "bbox_max": [
        444.72418212890625,
        1259.23828125,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2738654613494873,
        -0.41121962666511536,
        -0.8694228529930115
      ],
      "plane_d": 604.3643798828125,
      "bbox_min": [
        441.80908203125,
        1217.285400390625,
        -20.02692413330078
      ],
      "bbox_max": [
        442.4842529296875,
        1217.810546875,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.788802444934845,
        0.5944059491157532,
        0.15643593668937683
      ],
      "plane_d": -372.20025634765625,
      "bbox_min": [
        441.80908203125,
        1217.735107421875,
        -20.02692413330078
      ],
      "bbox_max": [
        441.86590576171875,
        1217.810546875,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -330.2188720703125,
      "bbox_min": [
        443.0,
        1258.4000244140625,
        -24.0
      ],
      "bbox_max": [
        444.72418212890625,
        1259.23828125,
        -22.27582359313965
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949184417724609,
        0.44622981548309326,
        0.0
      ],
      "plane_d": -915.6727905273438,
      "bbox_min": [
        411.799560546875,
        1214.2452392578125,
        -27.0
      ],
      "bbox_max": [
        426.6859130859375,
        1230.6146240234375,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.446229487657547,
        -0.89491868019104,
        0.0
      ],
      "plane_d": 913.549560546875,
      "bbox_min": [
        411.799560546875,
        1214.2452392578125,
        -27.0
      ],
      "bbox_max": [
        426.6859130859375,
        1230.6146240234375,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.446229487657547,
        0.89491868019104,
        0.0
      ],
      "plane_d": -900.2443237304688,
      "bbox_min": [
        417.73675537109375,
        1214.2452392578125,
        -27.0
      ],
      "bbox_max": [
        426.6859130859375,
        1218.70751953125,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        411.799560546875,
        1214.2452392578125,
        -40.0
      ],
      "bbox_max": [
        486.57757568359375,
        1259.23828125,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18506789207458496,
        0.9827257990837097,
        0.0
      ],
      "plane_d": -1121.9466552734375,
      "bbox_min": [
        441.00848388671875,
        1224.7191162109375,
        -40.0
      ],
      "bbox_max": [
        442.5,
        1225.0,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949185013771057,
        0.44622984528541565,
        -0.0
      ],
      "plane_d": -915.6727905273438,
      "bbox_min": [
        412.3741455078125,
        1214.2452392578125,
        -40.0
      ],
      "bbox_max": [
        427.584716796875,
        1225.0,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4462294578552246,
        0.8949186205863953,
        0.0
      ],
      "plane_d": -900.2442016601562,
      "bbox_min": [
        417.73675537109375,
        1214.2452392578125,
        -40.0
      ],
      "bbox_max": [
        426.6859130859375,
        1225.0,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8949149250984192,
        -0.44623681902885437,
        0.0
      ],
      "plane_d": 925.6797485351562,
      "bbox_min": [
        423.5483093261719,
        1218.70751953125,
        -40.0
      ],
      "bbox_max": [
        426.6859130859375,
        1225.0,
        -27.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -33.20000076293945,
      "bbox_min": [
        423.5483093261719,
        1220.4974365234375,
        -33.20000076293945
      ],
      "bbox_max": [
        426.24090576171875,
        1225.0,
        -33.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1239.89990234375,
      "bbox_min": [
        411.799560546875,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        482.7756042480469,
        1259.23828125,
        -27.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -456.0,
      "bbox_min": [
        443.0000305175781,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        480.0,
        1259.23828125,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        6.424753337341826e-06
      ],
      "plane_d": -442.9998474121094,
      "bbox_min": [
        443.0000305175781,
        1258.4000244140625,
        -40.0
      ],
      "bbox_max": [
        443.0000915527344,
        1259.23828125,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -29.0,
      "bbox_min": [
        456.0,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        480.0,
        1252.9178466796875,
        -29.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 466.0,
      "bbox_min": [
        459.0,
        1239.9000244140625,
        -40.0
      ],
      "bbox_max": [
        480.0,
        1248.0560302734375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 185.59364318847656,
      "bbox_min": [
        473.0,
        1243.5999755859375,
        -29.354154586791992
      ],
      "bbox_max": [
        473.70831298828125,
        1244.6527099609375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 530.2163696289062,
      "bbox_min": [
        459.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        463.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": -583.4348754882812,
      "bbox_min": [
        459.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        463.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": -232.99827575683594,
      "bbox_min": [
        459.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        463.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 179.33265686035156,
      "bbox_min": [
        459.0,
        1243.5999755859375,
        -29.5
      ],
      "bbox_max": [
        462.0,
        1246.5999755859375,
        -29.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -29.5,
      "bbox_min": [
        460.0,
        1244.5999755859375,
        -29.5
      ],
      "bbox_max": [
        462.0,
        1245.5999755859375,
        -29.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4462319314479828,
        -0.8949174284934998,
        0.0
      ],
      "plane_d": 914.7391967773438,
      "bbox_min": [
        411.799560546875,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        442.5,
        1239.9000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1529429405927658,
        -0.9882351160049438,
        0.0
      ],
      "plane_d": 1157.635498046875,
      "bbox_min": [
        411.799560546875,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        442.5,
        1239.9000244140625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949162364006042,
        0.44623440504074097,
        -0.0
      ],
      "plane_d": -926.177490234375,
      "bbox_min": [
        411.799560546875,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        424.1070861816406,
        1231.9046630859375,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4462294578552246,
        -0.8949186205863953,
        0.0
      ],
      "plane_d": 913.5494384765625,
      "bbox_min": [
        411.799560546875,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        424.1070556640625,
        1230.6146240234375,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8949185013771057,
        0.44622984528541565,
        -0.0
      ],
      "plane_d": -915.6727905273438,
      "bbox_min": [
        411.799560546875,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        424.1070556640625,
        1230.6146240234375,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.894914984703064,
        -0.4462367296218872,
        -0.0
      ],
      "plane_d": 925.6798095703125,
      "bbox_min": [
        420.74871826171875,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        424.1070556640625,
        1230.6146240234375,
        -27.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -33.20000076293945,
      "bbox_min": [
        421.64117431640625,
        1225.0,
        -33.20000076293945
      ],
      "bbox_max": [
        424.1070556640625,
        1229.0479736328125,
        -33.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1042.2559814453125,
      "bbox_min": [
        367.0,
        974.6000366210938,
        -40.0
      ],
      "bbox_max": [
        633.0,
        1231.52587890625,
        -20.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 990.0000610351562,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -40.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.6000366210938,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -40.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 613.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -40.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.64306640625,
        -40.0
      ],
      "bbox_max": [
        597.9696044921875,
        990.0000610351562,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1211.5440673828125,
      "bbox_min": [
        367.0,
        1042.2559814453125,
        -40.0
      ],
      "bbox_max": [
        633.0,
        1231.52587890625,
        -20.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 506.5,
      "bbox_min": [
        486.57757568359375,
        1211.5440673828125,
        -40.0
      ],
      "bbox_max": [
        513.422607421875,
        1231.52587890625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        506.5,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        513.422607421875,
        1228.3656005859375,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -27.0,
      "bbox_min": [
        506.5,
        1225.0,
        -27.0
      ],
      "bbox_max": [
        513.422607421875,
        1228.3656005859375,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -30.0,
      "bbox_min": [
        486.57757568359375,
        1211.5440673828125,
        -40.0
      ],
      "bbox_max": [
        506.5,
        1231.52587890625,
        -27.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        486.57757568359375,
        1225.0,
        -30.0
      ],
      "bbox_max": [
        506.5,
        1231.52587890625,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -27.0,
      "bbox_min": [
        486.57757568359375,
        1225.0,
        -27.0
      ],
      "bbox_max": [
        506.5,
        1231.52587890625,
        -27.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        486.57757568359375,
        1225.0,
        -40.0
      ],
      "bbox_max": [
        493.5,
        1225.0,
        -30.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43724510073661804,
        0.89934241771698,
        -1.6030845699788188e-06
      ],
      "plane_d": -700.7520751953125,
      "bbox_min": [
        367.0,
        1042.2559814453125,
        -40.0
      ],
      "bbox_max": [
        633.0,
        1211.5440673828125,
        -20.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8995646238327026,
        0.43678781390190125,
        0.0
      ],
      "plane_d": 77.20819091796875,
      "bbox_min": [
        367.0,
        1050.796142578125,
        -40.0
      ],
      "bbox_max": [
        633.0,
        1211.5440673828125,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995646238327026,
        -0.43678781390190125,
        0.0
      ],
      "plane_d": 1061.640625,
      "bbox_min": [
        367.0,
        1050.796142578125,
        -40.0
      ],
      "bbox_max": [
        633.0,
        1211.5440673828125,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995648622512817,
        -0.4367873966693878,
        0.0
      ],
      "plane_d": 162.07540893554688,
      "bbox_min": [
        367.0,
        1050.796142578125,
        -40.0
      ],
      "bbox_max": [
        593.4756469726562,
        1211.5440673828125,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995648622512817,
        0.4367873966693878,
        -0.0
      ],
      "plane_d": -822.3560180664062,
      "bbox_min": [
        367.0,
        1050.796142578125,
        -40.0
      ],
      "bbox_max": [
        593.4756469726562,
        1211.5440673828125,
        -20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3585740923881531,
        0.9335013031959534
      ],
      "plane_d": -389.4505615234375,
      "bbox_min": [
        485.5,
        1050.796142578125,
        -40.0
      ],
      "bbox_max": [
        593.4756469726562,
        1211.5440673828125,
        -21.899999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -506.5,
      "bbox_min": [
        485.5,
        1050.796142578125,
        -40.0
      ],
      "bbox_max": [
        593.4756469726562,
        1190.243896484375,
        -21.899999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 493.5,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -40.0
      ],
      "bbox_max": [
        506.5,
        1190.243896484375,
        -21.899999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3585740923881531,
        -0.9335013031959534
      ],
      "plane_d": 388.05029296875,
      "bbox_min": [
        493.5,
        1126.4000244140625,
        -40.0
      ],
      "bbox_max": [
        506.5,
        1186.3387451171875,
        -21.899999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 27.0,
      "bbox_min": [
        493.5,
        1152.494873046875,
        -27.0
      ],
      "bbox_max": [
        506.5,
        1156.4000244140625,
        -26.56786346435547
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7808688282966614,
        -0.6246950626373291,
        0.0
      ],
      "plane_d": 336.3358154296875,
      "bbox_min": [
        493.5,
        1155.2750244140625,
        -27.0
      ],
      "bbox_max": [
        506.5,
        1156.4000244140625,
        -26.56786346435547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.5487365722656,
      "bbox_min": [
        506.0,
        1155.9000244140625,
        -27.0
      ],
      "bbox_max": [
        506.5,
        1156.4000244140625,
        -26.80793571472168
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 27.0,
      "bbox_min": [
        493.5,
        1126.4000244140625,
        -40.0
      ],
      "bbox_max": [
        506.5,
        1156.4000244140625,
        -21.899999618530273
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1128.9000244140625,
      "bbox_min": [
        493.5,
        1126.4000244140625,
        -27.0
      ],
      "bbox_max": [
        506.5,
        1133.2000732421875,
        -21.899999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1129.4000244140625,
      "bbox_min": [
        495.6000061035156,
        1128.9000244140625,
        -27.0
      ],
      "bbox_max": [
        504.3999938964844,
        1133.2000732421875,
        -21.899999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 21.899999618530273,
      "bbox_min": [
        495.6000061035156,
        1128.9000244140625,
        -27.0
      ],
      "bbox_max": [
        504.3999938964844,
        1129.4000244140625,
        -21.899999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -504.3999938964844,
      "bbox_min": [
        495.6000061035156,
        1128.9000244140625,
        -27.0
      ],
      "bbox_max": [
        504.3999938964844,
        1129.4000244140625,
        -21.899999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 495.6000061035156,
      "bbox_min": [
        495.6000061035156,
        1128.9000244140625,
        -27.0
      ],
      "bbox_max": [
        495.6000061035156,
        1129.4000244140625,
        -21.899999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.30112800002098083,
        0.9535836577415466
      ],
      "plane_d": -317.78009033203125,
      "bbox_min": [
        495.6000061035156,
        1129.4000244140625,
        -27.0
      ],
      "bbox_max": [
        504.3999938964844,
        1133.2000732421875,
        -23.399999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1133.2000732421875,
      "bbox_min": [
        495.6000061035156,
        1129.4000244140625,
        -27.0
      ],
      "bbox_max": [
        504.3999938964844,
        1133.2000732421875,
        -23.399999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9670754075050354,
        0.2544902563095093,
        0.0
      ],
      "plane_d": 191.86129760742188,
      "bbox_min": [
        495.6000061035156,
        1129.4000244140625,
        -27.0
      ],
      "bbox_max": [
        504.3999938964844,
        1133.2000732421875,
        -23.399999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670752882957458,
        0.2544902265071869,
        0.0
      ],
      "plane_d": -775.2139892578125,
      "bbox_min": [
        503.3999938964844,
        1129.4000244140625,
        -27.0
      ],
      "bbox_max": [
        504.3999938964844,
        1133.2000732421875,
        -23.399999618530273
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1133.2000732421875,
      "bbox_min": [
        496.6000061035156,
        1133.2000732421875,
        -24.600000381469727
      ],
      "bbox_max": [
        503.3999938964844,
        1133.2000732421875,
        -23.719999313354492
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 23.499998092651367,
      "bbox_min": [
        493.5,
        1126.4000244140625,
        -27.0
      ],
      "bbox_max": [
        506.5,
        1127.5250244140625,
        -23.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.6246950626373291,
        -0.0
      ],
      "plane_d": -1089.718017578125,
      "bbox_min": [
        493.5,
        1126.9000244140625,
        -27.0
      ],
      "bbox_max": [
        494.0,
        1127.5250244140625,
        -23.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        -0.6246950626373291,
        -0.0
      ],
      "plane_d": 1089.015380859375,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -40.0
      ],
      "bbox_max": [
        493.5,
        1156.4000244140625,
        -23.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.6246950626373291,
        0.0
      ],
      "plane_d": -337.03863525390625,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -40.0
      ],
      "bbox_max": [
        493.5,
        1156.4000244140625,
        -23.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 485.5,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -40.0
      ],
      "bbox_max": [
        493.5,
        1156.4000244140625,
        -23.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 26.999998092651367,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -27.0
      ],
      "bbox_max": [
        493.5,
        1156.4000244140625,
        -23.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.6246950626373291,
        -0.0
      ],
      "plane_d": -1089.718017578125,
      "bbox_min": [
        486.0,
        1127.5250244140625,
        -27.0
      ],
      "bbox_max": [
        493.5,
        1155.2750244140625,
        -23.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        -0.6246950626373291,
        0.0
      ],
      "plane_d": 336.3358154296875,
      "bbox_min": [
        486.0,
        1136.9000244140625,
        -27.0
      ],
      "bbox_max": [
        493.5,
        1155.2750244140625,
        -23.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -486.0,
      "bbox_min": [
        486.0,
        1136.9000244140625,
        -27.0
      ],
      "bbox_max": [
        486.0,
        1145.9000244140625,
        -23.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        -0.6246950626373291,
        0.0
      ],
      "plane_d": 308.146484375,
      "bbox_min": [
        506.5,
        1050.796142578125,
        -40.0
      ],
      "bbox_max": [
        593.4756469726562,
        1156.4000244140625,
        -23.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.6246950626373291,
        0.0
      ],
      "plane_d": -1117.907470703125,
      "bbox_min": [
        506.5,
        1126.4000244140625,
        -40.0
      ],
      "bbox_max": [
        514.5,
        1156.4000244140625,
        -23.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -514.5,
      "bbox_min": [
        506.5,
        1126.4000244140625,
        -40.0
      ],
      "bbox_max": [
        514.5,
        1156.4000244140625,
        -23.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": 26.999998092651367,
      "bbox_min": [
        506.5,
        1126.4000244140625,
        -27.0
      ],
      "bbox_max": [
        514.5,
        1156.4000244140625,
        -23.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.6246950626373291,
        0.0
      ],
      "plane_d": -308.8492431640625,
      "bbox_min": [
        506.5,
        1127.5250244140625,
        -27.0
      ],
      "bbox_max": [
        514.0,
        1155.2750244140625,
        -23.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        -0.6246950626373291,
        0.0
      ],
      "plane_d": 1117.20458984375,
      "bbox_min": [
        506.5,
        1136.9000244140625,
        -27.0
      ],
      "bbox_max": [
        514.0,
        1155.2750244140625,
        -23.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 514.0,
      "bbox_min": [
        514.0,
        1136.9000244140625,
        -27.0
      ],
      "bbox_max": [
        514.0,
        1145.9000244140625,
        -23.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40848979353904724,
        0.8402265906333923,
        0.35658860206604004
      ],
      "plane_d": -640.8765869140625,
      "bbox_min": [
        558.4580078125,
        1050.796142578125,
        -40.0
      ],
      "bbox_max": [
        593.4756469726562,
        1068.1461181640625,
        -38.7599983215332
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8993402719497681,
        -0.43724966049194336,
        0.0
      ],
      "plane_d": 996.4088134765625,
      "bbox_min": [
        558.4580078125,
        1050.796142578125,
        -40.0
      ],
      "bbox_max": [
        593.4756469726562,
        1068.1461181640625,
        -38.7599983215332
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8993402719497681,
        0.43724966049194336,
        -0.0
      ],
      "plane_d": -1000.596923828125,
      "bbox_min": [
        593.2686767578125,
        1067.720458984375,
        -40.0
      ],
      "bbox_max": [
        593.4756469726562,
        1068.1461181640625,
        -38.7599983215332
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8993522524833679,
        -0.43722495436668396,
        1.594967002915837e-08
      ],
      "plane_d": 961.870849609375,
      "bbox_min": [
        558.4580078125,
        1050.796142578125,
        -40.0
      ],
      "bbox_max": [
        562.7239990234375,
        1053.1951904296875,
        -38.7599983215332
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8993522524833679,
        0.43722495436668396,
        -1.594967002915837e-08
      ],
      "plane_d": -966.3842163085938,
      "bbox_min": [
        562.51708984375,
        1052.76953125,
        -40.0
      ],
      "bbox_max": [
        562.7239990234375,
        1053.1951904296875,
        -38.7599983215332
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.6246950626373291,
        0.0
      ],
      "plane_d": -337.03863525390625,
      "bbox_min": [
        486.2106018066406,
        1147.2882080078125,
        -40.0
      ],
      "bbox_max": [
        513.7893676757812,
        1211.5440673828125,
        -23.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 23.5,
      "bbox_min": [
        506.0,
        1147.2882080078125,
        -27.0
      ],
      "bbox_max": [
        513.7893676757812,
        1156.4000244140625,
        -23.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.5487365722656,
      "bbox_min": [
        506.0,
        1155.9000244140625,
        -27.0
      ],
      "bbox_max": [
        506.5,
        1156.4000244140625,
        -23.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 23.5,
      "bbox_min": [
        486.2106018066406,
        1147.2882080078125,
        -27.0
      ],
      "bbox_max": [
        494.0,
        1156.4000244140625,
        -23.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1166.655517578125,
      "bbox_min": [
        493.5,
        1155.9000244140625,
        -27.0
      ],
      "bbox_max": [
        494.0,
        1156.4000244140625,
        -23.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1209.800048828125,
      "bbox_min": [
        490.9346008300781,
        1209.800048828125,
        -40.0
      ],
      "bbox_max": [
        493.5,
        1211.5440673828125,
        -27.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8201528191566467,
        0.572144627571106
      ],
      "plane_d": 1009.38525390625,
      "bbox_min": [
        490.9346008300781,
        1209.800048828125,
        -30.0
      ],
      "bbox_max": [
        493.5,
        1211.5440673828125,
        -27.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 506.4999694824219,
      "bbox_min": [
        506.5,
        1209.800048828125,
        -40.0
      ],
      "bbox_max": [
        509.0653991699219,
        1211.5440673828125,
        -27.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -509.0653991699219,
      "bbox_min": [
        506.5,
        1209.800048828125,
        -40.0
      ],
      "bbox_max": [
        509.0653991699219,
        1211.5440673828125,
        -27.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1209.800048828125,
      "bbox_min": [
        506.5,
        1209.800048828125,
        -40.0
      ],
      "bbox_max": [
        509.0653991699219,
        1211.5440673828125,
        -27.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8201528191566467,
        0.572144627571106
      ],
      "plane_d": 1009.38525390625,
      "bbox_min": [
        506.5,
        1209.800048828125,
        -30.0
      ],
      "bbox_max": [
        509.0653991699219,
        1211.5440673828125,
        -27.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 572.0,
      "bbox_min": [
        367.0,
        840.0,
        -60.000038146972656
      ],
      "bbox_max": [
        633.0,
        1298.4000244140625,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995646238327026,
        0.43678781390190125,
        0.0
      ],
      "plane_d": 77.20819091796875,
      "bbox_min": [
        572.0,
        974.6000366210938,
        -60.000038146972656
      ],
      "bbox_max": [
        633.0,
        1234.8145751953125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.959672212600708,
        -0.28112170100212097,
        0.0
      ],
      "plane_d": 868.3760375976562,
      "bbox_min": [
        584.590087890625,
        974.6000366210938,
        -60.0
      ],
      "bbox_max": [
        613.9696044921875,
        1052.0869140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9946115612983704,
        -0.1036728098988533,
        -0.0
      ],
      "plane_d": 711.8685913085938,
      "bbox_min": [
        605.3653564453125,
        1003.2859497070312,
        -60.0
      ],
      "bbox_max": [
        610.9696044921875,
        1022.4173583984375,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8616250157356262,
        -0.5075455904006958,
        -0.0
      ],
      "plane_d": 1040.5213623046875,
      "bbox_min": [
        605.3653564453125,
        1003.2859497070312,
        -60.0
      ],
      "bbox_max": [
        610.9696044921875,
        1022.4173583984375,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 610.9696044921875,
      "bbox_min": [
        605.3653564453125,
        1003.2859497070312,
        -60.0
      ],
      "bbox_max": [
        610.9696044921875,
        1022.4173583984375,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -49.0,
      "bbox_min": [
        605.3653564453125,
        1003.2859497070312,
        -49.0
      ],
      "bbox_max": [
        610.9696044921875,
        1022.4173583984375,
        -49.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.6000366210938,
      "bbox_min": [
        596.4552612304688,
        974.6000366210938,
        -56.57497024536133
      ],
      "bbox_max": [
        613.9696044921875,
        1022.4173583984375,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 613.9696044921875,
      "bbox_min": [
        596.4552612304688,
        974.6000366210938,
        -56.57497024536133
      ],
      "bbox_max": [
        613.9696044921875,
        1022.4173583984375,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 990.0000610351562,
      "bbox_min": [
        596.4552612304688,
        974.6000366210938,
        -55.3919792175293
      ],
      "bbox_max": [
        613.9696044921875,
        1022.4173583984375,
        -40.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -49.0,
      "bbox_min": [
        596.4552612304688,
        990.0000610351562,
        -54.11845779418945
      ],
      "bbox_max": [
        610.9696044921875,
        1022.4173583984375,
        -49.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9956004023551941,
        0.09370112419128418,
        -0.0
      ],
      "plane_d": -692.4952392578125,
      "bbox_min": [
        596.4552612304688,
        1005.0000610351562,
        -51.20243835449219
      ],
      "bbox_max": [
        600.9696044921875,
        1017.87744140625,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8356181979179382,
        0.5493106842041016,
        -0.0
      ],
      "plane_d": -1057.539794921875,
      "bbox_min": [
        596.4552612304688,
        1012.014404296875,
        -50.135772705078125
      ],
      "bbox_max": [
        600.3094482421875,
        1017.87744140625,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 610.9696044921875,
      "bbox_min": [
        610.9696044921875,
        990.0000610351562,
        -54.11845779418945
      ],
      "bbox_max": [
        610.9696044921875,
        1003.2859497070312,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -597.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -55.3919792175293
      ],
      "bbox_max": [
        597.9696044921875,
        990.0000610351562,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6178141236305237,
        0.786324143409729,
        0.0
      ],
      "plane_d": -1168.880126953125,
      "bbox_min": [
        584.590087890625,
        974.6000366210938,
        -60.0
      ],
      "bbox_max": [
        613.9696044921875,
        1027.1998291015625,
        -46.769935607910156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.6000366210938,
      "bbox_min": [
        596.4552612304688,
        974.6000366210938,
        -60.0
      ],
      "bbox_max": [
        613.9696044921875,
        1017.87744140625,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -600.9696044921875,
      "bbox_min": [
        596.4552612304688,
        974.6000366210938,
        -60.0
      ],
      "bbox_max": [
        613.9696044921875,
        1017.87744140625,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -597.9696044921875,
      "bbox_min": [
        596.4552612304688,
        974.6000366210938,
        -60.0
      ],
      "bbox_max": [
        600.9696044921875,
        1017.87744140625,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8356181979179382,
        0.5493106842041016,
        -0.0
      ],
      "plane_d": -1057.539794921875,
      "bbox_min": [
        596.4552612304688,
        1015.5737915039062,
        -60.0
      ],
      "bbox_max": [
        597.9696044921875,
        1017.87744140625,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9956004023551941,
        0.09370112419128418,
        -0.0
      ],
      "plane_d": -692.4952392578125,
      "bbox_min": [
        597.9696044921875,
        989.9500732421875,
        -60.0
      ],
      "bbox_max": [
        600.9696044921875,
        1015.5737915039062,
        -49.44625473022461
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8356181979179382,
        0.5493106842041016,
        -0.0
      ],
      "plane_d": -1057.539794921875,
      "bbox_min": [
        597.9696044921875,
        989.9500732421875,
        -60.0
      ],
      "bbox_max": [
        600.9696044921875,
        1015.5737915039062,
        -49.44625473022461
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 989.9500732421875,
      "bbox_min": [
        598.3800048828125,
        989.9500732421875,
        -57.5
      ],
      "bbox_max": [
        600.5799560546875,
        989.9500732421875,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 613.9696044921875,
      "bbox_min": [
        610.9696044921875,
        974.6000366210938,
        -60.0
      ],
      "bbox_max": [
        613.9696044921875,
        1003.2859497070312,
        -52.19053649902344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 610.9696044921875,
      "bbox_min": [
        610.9696044921875,
        989.9500732421875,
        -60.0
      ],
      "bbox_max": [
        613.9696044921875,
        1003.2859497070312,
        -52.19053649902344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 989.9500732421875,
      "bbox_min": [
        611.3800048828125,
        989.9500732421875,
        -57.5
      ],
      "bbox_max": [
        613.5799560546875,
        989.9500732421875,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995646238327026,
        -0.43678781390190125,
        0.0
      ],
      "plane_d": 1061.640625,
      "bbox_min": [
        572.0,
        1027.1998291015625,
        -60.000038146972656
      ],
      "bbox_max": [
        633.0,
        1234.8145751953125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4462294578552246,
        -0.8949186205863953,
        0.0
      ],
      "plane_d": 1359.1094970703125,
      "bbox_min": [
        584.202880859375,
        1224.22900390625,
        -43.0
      ],
      "bbox_max": [
        586.700439453125,
        1227.397705078125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8949185013771057,
        0.44622984528541565,
        0.0
      ],
      "plane_d": -22.0966796875,
      "bbox_min": [
        584.202880859375,
        1224.22900390625,
        -43.0
      ],
      "bbox_max": [
        586.700439453125,
        1227.397705078125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 43.0,
      "bbox_min": [
        584.202880859375,
        1224.22900390625,
        -43.0
      ],
      "bbox_max": [
        586.700439453125,
        1227.397705078125,
        -43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 55.5,
      "bbox_min": [
        572.0,
        1027.1998291015625,
        -60.000038146972656
      ],
      "bbox_max": [
        633.0,
        1234.8145751953125,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.13233178853988647,
        -0.06434018909931183,
        0.9891151189804077
      ],
      "plane_d": 54.81299591064453,
      "bbox_min": [
        572.0,
        1027.1998291015625,
        -60.000038146972656
      ],
      "bbox_max": [
        617.219482421875,
        1192.4393310546875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43724513053894043,
        -0.8993424773216248,
        -2.4261203179776203e-06
      ],
      "plane_d": 1311.18603515625,
      "bbox_min": [
        572.0,
        1165.7227783203125,
        -60.000038146972656
      ],
      "bbox_max": [
        601.0405883789062,
        1179.841796875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4367866516113281,
        -0.8995651602745056,
        -0.0
      ],
      "plane_d": 1231.5523681640625,
      "bbox_min": [
        572.0,
        1027.1998291015625,
        -60.0
      ],
      "bbox_max": [
        607.5992431640625,
        1083.541259765625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449512362480164,
        -0.3272113502025604,
        -0.0
      ],
      "plane_d": 911.2727661132812,
      "bbox_min": [
        589.158203125,
        1074.3089599609375,
        -60.0
      ],
      "bbox_max": [
        607.5992431640625,
        1083.541259765625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4372453987598419,
        0.8993422389030457,
        1.6679588270562817e-06
      ],
      "plane_d": -700.7515869140625,
      "bbox_min": [
        607.027099609375,
        1074.3089599609375,
        -60.0
      ],
      "bbox_max": [
        607.5992431640625,
        1074.587158203125,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8910055756568909,
        -0.4539925754070282,
        3.3989165331149707e-06
      ],
      "plane_d": 1009.340087890625,
      "bbox_min": [
        589.708984375,
        1052.0869140625,
        -60.0
      ],
      "bbox_max": [
        596.6741333007812,
        1065.8892822265625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.959672212600708,
        -0.28112170100212097,
        0.0
      ],
      "plane_d": 868.3760375976562,
      "bbox_min": [
        596.5827026367188,
        1052.0869140625,
        -60.0
      ],
      "bbox_max": [
        596.6741333007812,
        1052.39892578125,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8993165493011475,
        -0.43729832768440247,
        3.4306203815503977e-06
      ],
      "plane_d": 996.4468383789062,
      "bbox_min": [
        588.8344116210938,
        1065.8892822265625,
        -60.0
      ],
      "bbox_max": [
        589.708984375,
        1067.6878662109375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995646238327026,
        -0.4367879033088684,
        0.0
      ],
      "plane_d": -57.208160400390625,
      "bbox_min": [
        589.158203125,
        1083.3228759765625,
        -60.0
      ],
      "bbox_max": [
        617.219482421875,
        1159.849853515625,
        -55.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.43678659200668335,
        -0.8995652794837952,
        0.0
      ],
      "plane_d": 773.3628540039062,
      "bbox_min": [
        589.158203125,
        1083.541259765625,
        -60.0
      ],
      "bbox_max": [
        617.219482421875,
        1159.849853515625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43678542971611023,
        0.8995656967163086,
        0.0
      ],
      "plane_d": -773.864013671875,
      "bbox_min": [
        598.7784423828125,
        1150.4459228515625,
        -60.0
      ],
      "bbox_max": [
        617.0010986328125,
        1159.849853515625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.944977879524231,
        0.32713428139686584,
        0.0
      ],
      "plane_d": 189.4820556640625,
      "bbox_min": [
        598.7784423828125,
        1150.4459228515625,
        -60.0
      ],
      "bbox_max": [
        599.009765625,
        1151.1141357421875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995656967163086,
        0.4367855191230774,
        0.0
      ],
      "plane_d": 56.711395263671875,
      "bbox_min": [
        589.158203125,
        1083.541259765625,
        -60.0
      ],
      "bbox_max": [
        610.7670288085938,
        1150.664306640625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.897325873374939,
        0.44136878848075867,
        0.0
      ],
      "plane_d": 50.274932861328125,
      "bbox_min": [
        598.421142578125,
        1102.4000244140625,
        -60.0
      ],
      "bbox_max": [
        610.7670288085938,
        1127.472412109375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4368305802345276,
        -0.899543821811676,
        -0.0
      ],
      "plane_d": 1261.599609375,
      "bbox_min": [
        598.421142578125,
        1102.4000244140625,
        -60.0
      ],
      "bbox_max": [
        610.7670288085938,
        1127.3602294921875,
        -55.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8995635509490967,
        0.436789870262146,
        0.0
      ],
      "plane_d": -1041.642333984375,
      "bbox_min": [
        610.5435791015625,
        1126.9000244140625,
        -60.0
      ],
      "bbox_max": [
        610.7670288085938,
        1127.3602294921875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3691483736038208,
        0.1792418360710144,
        0.9119220972061157
      ],
      "plane_d": 74.08772277832031,
      "bbox_min": [
        598.4212036132812,
        1102.4000244140625,
        -55.724998474121094
      ],
      "bbox_max": [
        602.5125732421875,
        1110.118408203125,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995635509490967,
        0.436789870262146,
        0.0
      ],
      "plane_d": -1041.642333984375,
      "bbox_min": [
        610.2634887695312,
        1126.9000244140625,
        -60.0
      ],
      "bbox_max": [
        610.5435791015625,
        1127.472412109375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8947218060493469,
        -0.4466240406036377,
        -0.0
      ],
      "plane_d": 1049.36474609375,
      "bbox_min": [
        610.2634887695312,
        1126.9000244140625,
        -60.0
      ],
      "bbox_max": [
        610.3172607421875,
        1127.0078125,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.436790406703949,
        0.8995633721351624,
        7.262421775067196e-08
      ],
      "plane_d": -763.6155395507812,
      "bbox_min": [
        594.488037109375,
        1130.5321044921875,
        -60.0
      ],
      "bbox_max": [
        606.882568359375,
        1150.664306640625,
        -55.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.36914917826652527,
        -0.17924439907073975,
        0.9119212627410889
      ],
      "plane_d": 478.0662841796875,
      "bbox_min": [
        594.488037109375,
        1130.5321044921875,
        -60.0
      ],
      "bbox_max": [
        606.882568359375,
        1141.9000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995639085769653,
        0.4367891252040863,
        0.0
      ],
      "plane_d": -1041.6416015625,
      "bbox_min": [
        598.7784423828125,
        1141.681640625,
        -60.0
      ],
      "bbox_max": [
        603.4837036132812,
        1150.664306640625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995664119720459,
        -0.4367840588092804,
        -0.0
      ],
      "plane_d": 1041.137451171875,
      "bbox_min": [
        598.7784423828125,
        1141.681640625,
        -60.0
      ],
      "bbox_max": [
        603.033935546875,
        1150.4459228515625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4367927610874176,
        0.8995621204376221,
        -7.262389090101351e-08
      ],
      "plane_d": -1261.59716796875,
      "bbox_min": [
        589.8753051757812,
        1102.618408203125,
        -60.0
      ],
      "bbox_max": [
        610.4890747070312,
        1134.9000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3691483736038208,
        0.1792418360710144,
        0.9119220972061157
      ],
      "plane_d": 74.08772277832031,
      "bbox_min": [
        589.8753051757812,
        1102.618408203125,
        -60.0
      ],
      "bbox_max": [
        602.0628051757812,
        1114.2679443359375,
        -55.7249870300293
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.436790406703949,
        -0.8995633721351624,
        7.262421775067196e-08
      ],
      "plane_d": 1253.259765625,
      "bbox_min": [
        589.8753051757812,
        1102.618408203125,
        -60.0
      ],
      "bbox_max": [
        598.4212036132812,
        1106.7679443359375,
        -55.724998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995635509490967,
        0.436789870262146,
        0.0
      ],
      "plane_d": -1041.642333984375,
      "bbox_min": [
        606.882568359375,
        1127.472412109375,
        -60.0
      ],
      "bbox_max": [
        610.4890747070312,
        1134.9000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4372446537017822,
        -0.8993426561355591,
        9.20251579827891e-07
      ],
      "plane_d": 1326.18603515625,
      "bbox_min": [
        572.0,
        1027.1998291015625,
        -55.5
      ],
      "bbox_max": [
        626.0,
        1234.8145751953125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 43.0,
      "bbox_min": [
        572.0,
        1214.2452392578125,
        -43.0
      ],
      "bbox_max": [
        585.741455078125,
        1234.8145751953125,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4462294578552246,
        0.8949186205863953,
        0.0
      ],
      "plane_d": -1345.8043212890625,
      "bbox_min": [
        572.0,
        1214.2452392578125,
        -43.0
      ],
      "bbox_max": [
        584.202880859375,
        1234.8145751953125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4462294578552246,
        -0.8949186205863953,
        0.0
      ],
      "plane_d": 1359.1094970703125,
      "bbox_min": [
        572.0,
        1219.0804443359375,
        -43.0
      ],
      "bbox_max": [
        584.202880859375,
        1230.6146240234375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949150443077087,
        -0.446236789226532,
        0.0
      ],
      "plane_d": 32.107177734375,
      "bbox_min": [
        572.0,
        1219.0804443359375,
        -43.0
      ],
      "bbox_max": [
        577.7512817382812,
        1230.6146240234375,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4462856650352478,
        0.8948906064033508,
        -0.0
      ],
      "plane_d": -1347.8023681640625,
      "bbox_min": [
        572.2590942382812,
        1220.4974365234375,
        -43.0
      ],
      "bbox_max": [
        572.70654296875,
        1220.7205810546875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -44.0,
      "bbox_min": [
        572.0,
        1027.1998291015625,
        -55.5
      ],
      "bbox_max": [
        626.0,
        1196.5206298828125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43724510073661804,
        0.89934241771698,
        -1.6030845699788188e-06
      ],
      "plane_d": -700.7520751953125,
      "bbox_min": [
        572.0,
        1057.2794189453125,
        -44.0
      ],
      "bbox_max": [
        607.5992431640625,
        1074.587158203125,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.40848594903945923,
        0.8402268290519714,
        0.35659274458885193
      ],
      "plane_d": -640.87939453125,
      "bbox_min": [
        588.8345336914062,
        1065.8892822265625,
        -44.0
      ],
      "bbox_max": [
        593.4756469726562,
        1069.5191650390625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8993402719497681,
        0.43724966049194336,
        -0.0
      ],
      "plane_d": -1000.596923828125,
      "bbox_min": [
        588.8345336914062,
        1065.8892822265625,
        -44.0
      ],
      "bbox_max": [
        593.4756469726562,
        1069.5191650390625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8993402719497681,
        -0.43724966049194336,
        0.0
      ],
      "plane_d": 996.4088134765625,
      "bbox_min": [
        588.8345336914062,
        1065.8892822265625,
        -44.0
      ],
      "bbox_max": [
        589.7090454101562,
        1067.68798828125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07297588139772415,
        0.1432233303785324,
        -0.9869963526725769
      ],
      "plane_d": -150.61978149414062,
      "bbox_min": [
        572.0,
        1027.1998291015625,
        -55.5
      ],
      "bbox_max": [
        626.0,
        1196.5206298828125,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43678659200668335,
        0.8995652794837952,
        0.0
      ],
      "plane_d": -1232.052490234375,
      "bbox_min": [
        572.0,
        1027.1998291015625,
        -55.5
      ],
      "bbox_max": [
        626.0,
        1196.5206298828125,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4372453987598419,
        0.8993422389030457,
        1.6679588270562817e-06
      ],
      "plane_d": -700.7515869140625,
      "bbox_min": [
        572.0,
        1027.1998291015625,
        -55.5
      ],
      "bbox_max": [
        607.5992431640625,
        1083.541259765625,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4367866516113281,
        -0.8995651602745056,
        -0.0
      ],
      "plane_d": 1231.5523681640625,
      "bbox_min": [
        607.0271606445312,
        1074.1373291015625,
        -55.5
      ],
      "bbox_max": [
        607.5992431640625,
        1074.587158203125,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.959672212600708,
        -0.28112170100212097,
        0.0
      ],
      "plane_d": 868.3760375976562,
      "bbox_min": [
        596.5827026367188,
        1052.0869140625,
        -55.5
      ],
      "bbox_max": [
        596.6741333007812,
        1052.39892578125,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 49.5,
      "bbox_min": [
        589.158203125,
        1074.30908203125,
        -55.5
      ],
      "bbox_max": [
        607.5992431640625,
        1083.541259765625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449512362480164,
        -0.3272113502025604,
        -0.0
      ],
      "plane_d": 911.2727661132812,
      "bbox_min": [
        589.158203125,
        1082.873046875,
        -55.5
      ],
      "bbox_max": [
        589.3895874023438,
        1083.541259765625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43722936511039734,
        0.8993500471115112,
        3.3357960091962013e-06
      ],
      "plane_d": -702.7694091796875,
      "bbox_min": [
        588.83447265625,
        1065.8892822265625,
        -55.5
      ],
      "bbox_max": [
        593.4756469726562,
        1069.5191650390625,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8993402719497681,
        0.43724966049194336,
        -6.861421752546448e-06
      ],
      "plane_d": -1000.5972900390625,
      "bbox_min": [
        588.83447265625,
        1065.8892822265625,
        -55.5
      ],
      "bbox_max": [
        593.4756469726562,
        1069.5191650390625,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8993165493011475,
        -0.43729832768440247,
        3.4306203815503977e-06
      ],
      "plane_d": 996.4468383789062,
      "bbox_min": [
        588.83447265625,
        1065.8892822265625,
        -55.5
      ],
      "bbox_max": [
        589.7090454101562,
        1067.68798828125,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995646238327026,
        -0.4367879033088684,
        0.0
      ],
      "plane_d": -57.208160400390625,
      "bbox_min": [
        572.0,
        1082.4000244140625,
        -55.5
      ],
      "bbox_max": [
        626.0,
        1196.5206298828125,
        -49.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.43678659200668335,
        -0.8995652794837952,
        0.0
      ],
      "plane_d": 773.3628540039062,
      "bbox_min": [
        572.0,
        1083.3228759765625,
        -55.5
      ],
      "bbox_max": [
        617.219482421875,
        1196.5206298828125,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43678542971611023,
        0.8995656967163086,
        0.0
      ],
      "plane_d": -773.864013671875,
      "bbox_min": [
        572.0,
        1150.4459228515625,
        -55.5
      ],
      "bbox_max": [
        617.219482421875,
        1196.5206298828125,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 49.5,
      "bbox_min": [
        598.7784423828125,
        1150.4459228515625,
        -55.5
      ],
      "bbox_max": [
        617.219482421875,
        1159.849853515625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.944977879524231,
        0.32713428139686584,
        0.0
      ],
      "plane_d": 189.4820556640625,
      "bbox_min": [
        598.7784423828125,
        1150.4459228515625,
        -55.5
      ],
      "bbox_max": [
        599.009765625,
        1151.1141357421875,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13233178853988647,
        -0.06434018909931183,
        0.9891151189804077
      ],
      "plane_d": 54.81299591064453,
      "bbox_min": [
        572.0,
        1178.94921875,
        -55.5
      ],
      "bbox_max": [
        580.3946533203125,
        1196.5206298828125,
        -54.11140823364258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43724513053894043,
        -0.8993424773216248,
        -2.4261203179776203e-06
      ],
      "plane_d": 1311.18603515625,
      "bbox_min": [
        572.0,
        1178.94921875,
        -55.5
      ],
      "bbox_max": [
        573.8358154296875,
        1179.841796875,
        -55.19633483886719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 49.5,
      "bbox_min": [
        589.158203125,
        1083.3228759765625,
        -55.5
      ],
      "bbox_max": [
        617.0,
        1152.4000244140625,
        -49.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8995656967163086,
        0.4367855191230774,
        0.0
      ],
      "plane_d": 56.711395263671875,
      "bbox_min": [
        589.158203125,
        1083.541259765625,
        -55.5
      ],
      "bbox_max": [
        617.0,
        1152.4000244140625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.897325873374939,
        0.44136878848075867,
        0.0
      ],
      "plane_d": 50.274932861328125,
      "bbox_min": [
        598.421142578125,
        1102.4000244140625,
        -55.5
      ],
      "bbox_max": [
        610.7670288085938,
        1127.472412109375,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4368305802345276,
        -0.899543821811676,
        -0.0
      ],
      "plane_d": 1261.599609375,
      "bbox_min": [
        598.421142578125,
        1102.4000244140625,
        -55.5
      ],
      "bbox_max": [
        610.7670288085938,
        1127.3602294921875,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995635509490967,
        0.436789870262146,
        0.0
      ],
      "plane_d": -1041.642333984375,
      "bbox_min": [
        610.5435791015625,
        1126.9000244140625,
        -55.5
      ],
      "bbox_max": [
        610.7670288085938,
        1127.3602294921875,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8947218060493469,
        -0.4466240406036377,
        -0.0
      ],
      "plane_d": 1049.36474609375,
      "bbox_min": [
        610.2634887695312,
        1126.9000244140625,
        -55.5
      ],
      "bbox_max": [
        610.3172607421875,
        1127.0078125,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995639085769653,
        0.4367891252040863,
        0.0
      ],
      "plane_d": -1041.6416015625,
      "bbox_min": [
        598.7784423828125,
        1127.0078125,
        -55.5
      ],
      "bbox_max": [
        617.0,
        1152.4000244140625,
        -49.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8947218060493469,
        -0.4466240406036377,
        -0.0
      ],
      "plane_d": 1049.36474609375,
      "bbox_min": [
        603.033935546875,
        1127.0078125,
        -55.5
      ],
      "bbox_max": [
        610.2634887695312,
        1141.9000244140625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4368305802345276,
        0.899543821811676,
        0.0
      ],
      "plane_d": -755.7874755859375,
      "bbox_min": [
        606.432861328125,
        1134.681640625,
        -55.5
      ],
      "bbox_max": [
        606.882568359375,
        1134.9000244140625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": -51.405696868896484,
      "bbox_min": [
        607.0,
        1142.4000244140625,
        -55.5
      ],
      "bbox_max": [
        617.0,
        1152.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 50.905696868896484,
      "bbox_min": [
        607.0,
        1142.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        617.0,
        1152.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -830.4849853515625,
      "bbox_min": [
        607.0,
        1142.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        617.0,
        1152.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        -0.0
      ],
      "plane_d": -1298.880126953125,
      "bbox_min": [
        607.0,
        1142.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        617.0,
        1152.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 821.2461547851562,
      "bbox_min": [
        607.0,
        1142.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        617.0,
        1150.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 1289.641357421875,
      "bbox_min": [
        607.0,
        1142.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        617.0,
        1150.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": 121.7369384765625,
      "bbox_min": [
        607.0,
        1143.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        617.0,
        1150.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        -0.0
      ],
      "plane_d": -1009.1036376953125,
      "bbox_min": [
        607.0,
        1143.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        617.0,
        1150.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": -130.975830078125,
      "bbox_min": [
        607.0,
        1143.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        617.0,
        1147.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": 999.86474609375,
      "bbox_min": [
        607.0,
        1143.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        608.46435546875,
        1147.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -612.25,
      "bbox_min": [
        610.25,
        1145.6500244140625,
        -55.5
      ],
      "bbox_max": [
        613.75,
        1149.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.1500244140625,
      "bbox_min": [
        610.25,
        1145.6500244140625,
        -55.5
      ],
      "bbox_max": [
        612.25,
        1149.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.6500244140625,
      "bbox_min": [
        610.25,
        1147.1500244140625,
        -55.5
      ],
      "bbox_max": [
        612.25,
        1149.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 611.75,
      "bbox_min": [
        610.25,
        1147.1500244140625,
        -55.5
      ],
      "bbox_max": [
        611.75,
        1147.6500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 384.6845703125,
      "bbox_min": [
        610.25,
        1147.1500244140625,
        -55.5
      ],
      "bbox_max": [
        611.75,
        1147.6500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -591.2549438476562,
      "bbox_min": [
        610.25,
        1147.6500244140625,
        -55.5
      ],
      "bbox_max": [
        612.25,
        1149.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -294.2684631347656,
      "bbox_min": [
        612.25,
        1145.6500244140625,
        -55.5
      ],
      "bbox_max": [
        613.75,
        1149.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 681.6710815429688,
      "bbox_min": [
        612.25,
        1145.6500244140625,
        -55.5
      ],
      "bbox_max": [
        613.75,
        1147.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": -51.405696868896484,
      "bbox_min": [
        598.5,
        1082.4000244140625,
        -55.5
      ],
      "bbox_max": [
        626.0,
        1133.9000244140625,
        -50.90570068359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 50.905696868896484,
      "bbox_min": [
        598.5,
        1082.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        626.0,
        1133.9000244140625,
        -50.90570068359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -794.6121215820312,
      "bbox_min": [
        598.5,
        1082.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        626.0,
        1133.9000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -778.3046875,
      "bbox_min": [
        598.5,
        1082.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        619.0,
        1114.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        -0.0
      ],
      "plane_d": -1240.1944580078125,
      "bbox_min": [
        598.5,
        1082.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        608.5,
        1092.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 769.06591796875,
      "bbox_min": [
        598.5,
        1082.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        608.5,
        1090.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 1230.95556640625,
      "bbox_min": [
        598.5,
        1082.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        608.5,
        1090.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": 136.84344482421875,
      "bbox_min": [
        598.5,
        1083.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        608.5,
        1090.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        -0.0
      ],
      "plane_d": -978.2909545898438,
      "bbox_min": [
        598.5,
        1083.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        608.5,
        1090.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": -146.08233642578125,
      "bbox_min": [
        598.5,
        1083.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        608.5,
        1087.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": 969.0520629882812,
      "bbox_min": [
        598.5,
        1083.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        599.96435546875,
        1087.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        -0.0
      ],
      "plane_d": -1264.537841796875,
      "bbox_min": [
        609.0,
        1104.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        619.0,
        1114.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 785.3731689453125,
      "bbox_min": [
        609.0,
        1104.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        619.0,
        1112.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 1255.299072265625,
      "bbox_min": [
        609.0,
        1104.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        619.0,
        1112.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": 138.12579345703125,
      "bbox_min": [
        609.0,
        1105.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        619.0,
        1112.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        -0.0
      ],
      "plane_d": -996.4103393554688,
      "bbox_min": [
        609.0,
        1105.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        619.0,
        1112.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": -147.36468505859375,
      "bbox_min": [
        609.0,
        1105.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        619.0,
        1109.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": 987.1714477539062,
      "bbox_min": [
        609.0,
        1105.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        610.46435546875,
        1109.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -809.948974609375,
      "bbox_min": [
        616.0,
        1123.9000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        626.0,
        1133.9000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        -0.0
      ],
      "plane_d": -1285.232421875,
      "bbox_min": [
        616.0,
        1123.9000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        626.0,
        1133.9000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 800.7101440429688,
      "bbox_min": [
        616.0,
        1123.9000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        626.0,
        1132.435546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 1275.99365234375,
      "bbox_min": [
        616.0,
        1123.9000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        626.0,
        1132.435546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": 137.13116455078125,
      "bbox_min": [
        616.0,
        1125.364501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        626.0,
        1132.435546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        -0.0
      ],
      "plane_d": -1010.3394165039062,
      "bbox_min": [
        616.0,
        1125.364501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        626.0,
        1132.435546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": -146.37005615234375,
      "bbox_min": [
        616.0,
        1125.364501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        626.0,
        1128.9000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": 1001.1005249023438,
      "bbox_min": [
        616.0,
        1125.364501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        617.46435546875,
        1128.9000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -614.25,
      "bbox_min": [
        601.75,
        1085.6500244140625,
        -55.5
      ],
      "bbox_max": [
        622.75,
        1130.6500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1109.1500244140625,
      "bbox_min": [
        601.75,
        1085.6500244140625,
        -55.5
      ],
      "bbox_max": [
        614.25,
        1111.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1109.6500244140625,
      "bbox_min": [
        612.25,
        1109.1500244140625,
        -55.5
      ],
      "bbox_max": [
        614.25,
        1111.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 613.75,
      "bbox_min": [
        612.25,
        1109.1500244140625,
        -55.5
      ],
      "bbox_max": [
        613.75,
        1109.6500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 385.7939758300781,
      "bbox_min": [
        612.25,
        1109.1500244140625,
        -55.5
      ],
      "bbox_max": [
        613.75,
        1109.6500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -570.1763305664062,
      "bbox_min": [
        612.25,
        1109.6500244140625,
        -55.5
      ],
      "bbox_max": [
        614.25,
        1111.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 385.7939758300781,
      "bbox_min": [
        612.25,
        1107.6500244140625,
        -55.5
      ],
      "bbox_max": [
        613.75,
        1109.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1087.6500244140625,
      "bbox_min": [
        601.75,
        1087.1500244140625,
        -55.5
      ],
      "bbox_max": [
        603.75,
        1089.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 603.25,
      "bbox_min": [
        601.75,
        1087.1500244140625,
        -55.5
      ],
      "bbox_max": [
        603.25,
        1087.6500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 379.9696350097656,
      "bbox_min": [
        601.75,
        1087.1500244140625,
        -55.5
      ],
      "bbox_max": [
        603.25,
        1087.6500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -557.9729614257812,
      "bbox_min": [
        601.75,
        1087.6500244140625,
        -55.5
      ],
      "bbox_max": [
        603.75,
        1089.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -289.5534973144531,
      "bbox_min": [
        603.75,
        1085.6500244140625,
        -55.5
      ],
      "bbox_max": [
        605.25,
        1089.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -557.9729614257812,
      "bbox_min": [
        603.75,
        1085.6500244140625,
        -55.5
      ],
      "bbox_max": [
        605.25,
        1089.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -570.1763305664062,
      "bbox_min": [
        614.25,
        1107.6500244140625,
        -55.5
      ],
      "bbox_max": [
        615.75,
        1111.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1128.6500244140625,
      "bbox_min": [
        619.25,
        1127.1500244140625,
        -55.5
      ],
      "bbox_max": [
        621.25,
        1130.6500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1129.1500244140625,
      "bbox_min": [
        619.25,
        1128.6500244140625,
        -55.5
      ],
      "bbox_max": [
        621.25,
        1130.6500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 620.75,
      "bbox_min": [
        619.25,
        1128.6500244140625,
        -55.5
      ],
      "bbox_max": [
        620.75,
        1129.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 389.6768798828125,
      "bbox_min": [
        619.25,
        1128.6500244140625,
        -55.5
      ],
      "bbox_max": [
        620.75,
        1129.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -580.9929809570312,
      "bbox_min": [
        619.25,
        1129.1500244140625,
        -55.5
      ],
      "bbox_max": [
        621.25,
        1130.6500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -299.2607421875,
      "bbox_min": [
        621.25,
        1127.1500244140625,
        -55.5
      ],
      "bbox_max": [
        622.75,
        1130.6500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 671.4091186523438,
      "bbox_min": [
        621.25,
        1127.1500244140625,
        -55.5
      ],
      "bbox_max": [
        622.75,
        1128.6500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 571.5,
      "bbox_min": [
        367.0,
        840.0,
        -60.000038146972656
      ],
      "bbox_max": [
        572.0,
        1298.4000244140625,
        -39.99999237060547
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 924.9999389648438,
      "bbox_min": [
        571.5,
        845.0,
        -60.000038146972656
      ],
      "bbox_max": [
        572.0,
        1235.0638427734375,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.13233178853988647,
        -0.06434018909931183,
        0.9891151189804077
      ],
      "plane_d": 54.81299591064453,
      "bbox_min": [
        571.5,
        1037.0919189453125,
        -60.000038146972656
      ],
      "bbox_max": [
        572.0,
        1235.0638427734375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43724513053894043,
        -0.8993424773216248,
        -2.4261203179776203e-06
      ],
      "plane_d": 1311.18603515625,
      "bbox_min": [
        571.5,
        1179.841796875,
        -60.000038146972656
      ],
      "bbox_max": [
        572.0,
        1180.0848388671875,
        -55.11362838745117
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -44.0,
      "bbox_min": [
        571.5,
        1037.0919189453125,
        -60.0
      ],
      "bbox_max": [
        572.0,
        1235.0638427734375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 43.0,
      "bbox_min": [
        571.5,
        1057.036376953125,
        -44.0
      ],
      "bbox_max": [
        572.0,
        1235.0638427734375,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.43724510073661804,
        0.89934241771698,
        -1.6030845699788188e-06
      ],
      "plane_d": -700.7520751953125,
      "bbox_min": [
        571.5,
        1057.036376953125,
        -44.0
      ],
      "bbox_max": [
        572.0,
        1196.763671875,
        -43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4372446537017822,
        -0.8993426561355591,
        9.20251579827891e-07
      ],
      "plane_d": 1326.18603515625,
      "bbox_min": [
        571.5,
        1196.5206298828125,
        -44.0
      ],
      "bbox_max": [
        572.0,
        1196.763671875,
        -43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4462294578552246,
        0.8949186205863953,
        0.0
      ],
      "plane_d": -1345.8043212890625,
      "bbox_min": [
        571.5,
        1057.036376953125,
        -43.0
      ],
      "bbox_max": [
        572.0,
        1235.0638427734375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43724510073661804,
        0.89934241771698,
        -1.6030845699788188e-06
      ],
      "plane_d": -700.7520751953125,
      "bbox_min": [
        571.5,
        1057.036376953125,
        -43.0
      ],
      "bbox_max": [
        572.0,
        1196.763671875,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4372446537017822,
        -0.8993426561355591,
        9.20251579827891e-07
      ],
      "plane_d": 1326.18603515625,
      "bbox_min": [
        571.5,
        1196.5206298828125,
        -43.0
      ],
      "bbox_max": [
        572.0,
        1196.763671875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8949131369590759,
        0.44624048471450806,
        0.0
      ],
      "plane_d": -32.612762451171875,
      "bbox_min": [
        571.5,
        1218.70751953125,
        -43.0
      ],
      "bbox_max": [
        572.0,
        1235.0638427734375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949270844459534,
        -0.4462123513221741,
        0.0
      ],
      "plane_d": 32.070465087890625,
      "bbox_min": [
        571.8140869140625,
        1218.70751953125,
        -43.0
      ],
      "bbox_max": [
        572.0,
        1219.0804443359375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4372446537017822,
        -0.8993426561355591,
        9.20251579827891e-07
      ],
      "plane_d": 1326.18603515625,
      "bbox_min": [
        571.5,
        1037.0919189453125,
        -54.11140823364258
      ],
      "bbox_max": [
        572.0,
        1196.763671875,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07297588139772415,
        0.1432233303785324,
        -0.9869963526725769
      ],
      "plane_d": -150.61978149414062,
      "bbox_min": [
        571.5,
        1037.0919189453125,
        -44.40361785888672
      ],
      "bbox_max": [
        572.0,
        1039.8734130859375,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        571.5,
        845.0,
        -60.0
      ],
      "bbox_max": [
        572.0,
        855.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 53.0,
      "bbox_min": [
        571.5,
        845.0,
        -60.0
      ],
      "bbox_max": [
        572.0,
        855.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -855.0,
      "bbox_min": [
        571.5,
        855.0,
        -60.0
      ],
      "bbox_max": [
        572.0,
        855.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43724513053894043,
        0.8993424773216248,
        -0.0
      ],
      "plane_d": -1137.9971923828125,
      "bbox_min": [
        367.0,
        840.0,
        -60.000038146972656
      ],
      "bbox_max": [
        571.5,
        1298.4000244140625,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 925.0,
      "bbox_min": [
        392.4007263183594,
        840.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1074.587158203125,
        -39.99999237060547
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -926.0,
      "bbox_min": [
        392.4007263183594,
        925.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1074.587158203125,
        -39.99999237060547
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -44.0,
      "bbox_min": [
        459.1000061035156,
        925.0,
        -60.0
      ],
      "bbox_max": [
        541.0,
        926.0,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -50.04999542236328,
      "bbox_min": [
        459.1000061035156,
        925.0,
        -60.0
      ],
      "bbox_max": [
        541.0,
        926.0,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -459.1000061035156,
      "bbox_min": [
        459.1000061035156,
        925.0,
        -50.04999542236328
      ],
      "bbox_max": [
        495.0,
        926.0,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        495.0,
        925.0,
        -50.04999542236328
      ],
      "bbox_max": [
        495.0,
        926.0,
        -44.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        520.0,
        925.0,
        -60.0
      ],
      "bbox_max": [
        520.0,
        926.0,
        -50.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -459.1000061035156,
      "bbox_min": [
        459.1000061035156,
        925.0,
        -60.0
      ],
      "bbox_max": [
        459.1000061035156,
        926.0,
        -50.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -44.0,
      "bbox_min": [
        392.4007263183594,
        926.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1074.587158203125,
        -39.99999237060547
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -496.0,
      "bbox_min": [
        465.0,
        926.0,
        -44.0
      ],
      "bbox_max": [
        571.5,
        1000.0,
        -39.99999237060547
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -44.0
      ],
      "bbox_max": [
        481.0,
        990.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.5999755859375,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -44.0
      ],
      "bbox_max": [
        481.0,
        990.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        465.0,
        974.5999755859375,
        -44.0
      ],
      "bbox_max": [
        481.0,
        990.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 481.0,
      "bbox_min": [
        481.0,
        974.5999755859375,
        -44.0
      ],
      "bbox_max": [
        481.0,
        990.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        496.0,
        937.0,
        -44.0
      ],
      "bbox_max": [
        571.5,
        1000.0,
        -39.99999237060547
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -428.5067138671875,
      "bbox_min": [
        561.5,
        948.5,
        -44.0
      ],
      "bbox_max": [
        571.5,
        991.5,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 562.7433471679688,
      "bbox_min": [
        561.5,
        948.5,
        -44.0
      ],
      "bbox_max": [
        563.0,
        991.5,
        -43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -513.3750610351562,
      "bbox_min": [
        561.5,
        990.0,
        -44.0
      ],
      "bbox_max": [
        563.0,
        991.5,
        -43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -43.0,
      "bbox_min": [
        562.0,
        948.5,
        -44.0
      ],
      "bbox_max": [
        571.5,
        991.5,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        563.0,
        950.0,
        -43.0
      ],
      "bbox_max": [
        571.5,
        990.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -990.0,
      "bbox_min": [
        563.0,
        990.0,
        -43.0
      ],
      "bbox_max": [
        566.3828735351562,
        990.0,
        -40.74473571777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 562.7433471679688,
      "bbox_min": [
        562.0,
        948.5,
        -44.0
      ],
      "bbox_max": [
        571.5,
        991.5,
        -43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -702.156982421875,
      "bbox_min": [
        562.0,
        949.0,
        -44.0
      ],
      "bbox_max": [
        571.5,
        991.5,
        -43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -513.3750610351562,
      "bbox_min": [
        562.0,
        990.0,
        -44.0
      ],
      "bbox_max": [
        566.3828735351562,
        991.5,
        -43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        563.0,
        950.0,
        -43.0
      ],
      "bbox_max": [
        567.5,
        990.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -990.0,
      "bbox_min": [
        563.0,
        990.0,
        -43.0
      ],
      "bbox_max": [
        566.3828735351562,
        990.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -959.0,
      "bbox_min": [
        496.0,
        937.0,
        -44.0
      ],
      "bbox_max": [
        558.0,
        975.0,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 956.0,
      "bbox_min": [
        496.0,
        937.0,
        -44.0
      ],
      "bbox_max": [
        558.0,
        959.0,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        510.0,
        956.0,
        -44.0
      ],
      "bbox_max": [
        510.0,
        959.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": -42.999996185302734,
      "bbox_min": [
        518.5,
        937.0,
        -43.0
      ],
      "bbox_max": [
        558.0,
        947.0,
        -39.99999237060547
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 552.5,
      "bbox_min": [
        523.0,
        941.4998779296875,
        -43.0
      ],
      "bbox_max": [
        553.5,
        942.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001220703125,
        -1.0,
        0.0
      ],
      "plane_d": 941.4324340820312,
      "bbox_min": [
        552.5,
        941.4998779296875,
        -43.0
      ],
      "bbox_max": [
        553.5,
        942.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001220703125,
        1.0,
        0.0
      ],
      "plane_d": -942.5675659179688,
      "bbox_min": [
        552.5,
        941.5,
        -43.0
      ],
      "bbox_max": [
        553.5,
        942.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -553.5,
      "bbox_min": [
        553.5,
        941.5,
        -43.0
      ],
      "bbox_max": [
        553.5,
        942.5,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 523.0,
      "bbox_min": [
        523.0,
        941.4998779296875,
        -43.0
      ],
      "bbox_max": [
        524.0,
        942.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001220703125,
        -1.0,
        0.0
      ],
      "plane_d": 941.43603515625,
      "bbox_min": [
        523.0,
        941.4998779296875,
        -43.0
      ],
      "bbox_max": [
        524.0,
        942.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001220703125,
        1.0,
        0.0
      ],
      "plane_d": -942.56396484375,
      "bbox_min": [
        523.0,
        941.5,
        -43.0
      ],
      "bbox_max": [
        524.0,
        942.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -524.0,
      "bbox_min": [
        524.0,
        941.5,
        -43.0
      ],
      "bbox_max": [
        524.0,
        942.5,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38267987966537476,
        0.9238809943199158
      ],
      "plane_d": -329.1108703613281,
      "bbox_min": [
        502.0,
        959.0,
        -44.0
      ],
      "bbox_max": [
        558.0,
        975.0,
        -39.99999237060547
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 506.0,
      "bbox_min": [
        502.0,
        959.0,
        -44.0
      ],
      "bbox_max": [
        508.0,
        962.0,
        -41.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9238823652267456,
        0.38267654180526733
      ],
      "plane_d": -871.9370727539062,
      "bbox_min": [
        506.0,
        959.0,
        -44.0
      ],
      "bbox_max": [
        508.0,
        962.0,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -508.0,
      "bbox_min": [
        506.0,
        959.0,
        -44.0
      ],
      "bbox_max": [
        508.0,
        962.0,
        -41.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9238730072975159,
        -0.38269925117492676
      ],
      "plane_d": 870.079345703125,
      "bbox_min": [
        506.0,
        959.0,
        -44.0
      ],
      "bbox_max": [
        508.0,
        960.0,
        -43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.38268932700157166,
        -0.9238771796226501
      ],
      "plane_d": 327.2723388671875,
      "bbox_min": [
        506.0,
        959.0,
        -43.29289245605469
      ],
      "bbox_max": [
        508.0,
        959.7070922851562,
        -43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9238823652267456,
        0.38267654180526733
      ],
      "plane_d": -871.9370727539062,
      "bbox_min": [
        502.0,
        959.0,
        -44.0
      ],
      "bbox_max": [
        504.0,
        962.0,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -504.0,
      "bbox_min": [
        502.0,
        959.0,
        -44.0
      ],
      "bbox_max": [
        504.0,
        962.0,
        -41.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 502.0,
      "bbox_min": [
        502.0,
        959.0,
        -44.0
      ],
      "bbox_max": [
        502.0,
        962.0,
        -41.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": -42.999996185302734,
      "bbox_min": [
        518.5,
        965.0,
        -43.0
      ],
      "bbox_max": [
        558.0,
        975.0,
        -39.99999237060547
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 552.5,
      "bbox_min": [
        523.0,
        969.4998779296875,
        -43.0
      ],
      "bbox_max": [
        553.5,
        970.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001220703125,
        -1.0,
        0.0
      ],
      "plane_d": 969.4324340820312,
      "bbox_min": [
        552.5,
        969.4998779296875,
        -43.0
      ],
      "bbox_max": [
        553.5,
        970.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001220703125,
        1.0,
        0.0
      ],
      "plane_d": -970.5675659179688,
      "bbox_min": [
        552.5,
        969.5,
        -43.0
      ],
      "bbox_max": [
        553.5,
        970.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -553.5,
      "bbox_min": [
        553.5,
        969.5,
        -43.0
      ],
      "bbox_max": [
        553.5,
        970.5,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 523.0,
      "bbox_min": [
        523.0,
        969.4998779296875,
        -43.0
      ],
      "bbox_max": [
        524.0,
        970.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001220703125,
        -1.0,
        0.0
      ],
      "plane_d": 969.43603515625,
      "bbox_min": [
        523.0,
        969.4998779296875,
        -43.0
      ],
      "bbox_max": [
        524.0,
        970.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -524.0,
      "bbox_min": [
        523.0,
        969.5,
        -43.0
      ],
      "bbox_max": [
        524.0,
        970.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001220703125,
        1.0,
        0.0
      ],
      "plane_d": -970.56396484375,
      "bbox_min": [
        523.0,
        970.5,
        -43.0
      ],
      "bbox_max": [
        524.0,
        970.5001220703125,
        -39.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -459.1000061035156,
      "bbox_min": [
        392.4007263183594,
        926.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1074.587158203125,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43678605556488037,
        -0.8995654582977295,
        0.0
      ],
      "plane_d": 794.7662353515625,
      "bbox_min": [
        392.4007263183594,
        1074.1373291015625,
        -60.0
      ],
      "bbox_max": [
        392.9727783203125,
        1074.587158203125,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 49.499996185302734,
      "bbox_min": [
        392.4007263183594,
        1074.1373291015625,
        -49.5
      ],
      "bbox_max": [
        392.9727783203125,
        1074.587158203125,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -496.0,
      "bbox_min": [
        459.1000061035156,
        926.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1025.3416748046875,
        -44.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 973.0,
      "bbox_min": [
        459.1000061035156,
        926.0,
        -60.0
      ],
      "bbox_max": [
        496.0,
        1025.3416748046875,
        -44.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        465.0,
        973.0,
        -60.0
      ],
      "bbox_max": [
        496.0,
        1025.3416748046875,
        -44.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071080207824707,
        0.7071055769920349,
        -0.0
      ],
      "plane_d": -1074.117431640625,
      "bbox_min": [
        493.6907043457031,
        1023.0323486328125,
        -60.0
      ],
      "bbox_max": [
        496.0,
        1025.3416748046875,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -47.04999542236328,
      "bbox_min": [
        493.6907043457031,
        1023.0323486328125,
        -47.04999542236328
      ],
      "bbox_max": [
        496.0,
        1025.3416748046875,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 481.0,
      "bbox_min": [
        465.0,
        973.0,
        -60.0
      ],
      "bbox_max": [
        481.0,
        990.0,
        -44.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        465.0,
        973.0,
        -60.0
      ],
      "bbox_max": [
        481.0,
        990.0,
        -44.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.5999755859375,
      "bbox_min": [
        465.0,
        973.0,
        -60.0
      ],
      "bbox_max": [
        481.0,
        974.5999755859375,
        -44.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -468.0,
      "bbox_min": [
        468.0,
        973.0,
        -60.0
      ],
      "bbox_max": [
        478.0,
        974.5999755859375,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 478.0,
      "bbox_min": [
        468.0,
        973.0,
        -60.0
      ],
      "bbox_max": [
        478.0,
        974.5999755859375,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -49.0,
      "bbox_min": [
        468.0,
        973.0,
        -49.0
      ],
      "bbox_max": [
        478.0,
        974.5999755859375,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        478.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        496.0,
        973.0,
        -44.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -50.0,
      "bbox_min": [
        495.0,
        935.0,
        -60.0
      ],
      "bbox_max": [
        496.0,
        950.0,
        -50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -935.0,
      "bbox_min": [
        495.0,
        935.0,
        -60.0
      ],
      "bbox_max": [
        496.0,
        950.0,
        -50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        495.0,
        950.0,
        -60.0
      ],
      "bbox_max": [
        496.0,
        950.0,
        -50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 478.0,
      "bbox_min": [
        478.0,
        930.0,
        -60.0
      ],
      "bbox_max": [
        495.0,
        973.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -481.8999938964844,
      "bbox_min": [
        478.0,
        930.0,
        -60.0
      ],
      "bbox_max": [
        495.0,
        973.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 56.5,
      "bbox_min": [
        478.0,
        930.0,
        -60.0
      ],
      "bbox_max": [
        481.8999938964844,
        959.2427368164062,
        -54.688751220703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.831470251083374,
        0.5555692911148071,
        0.0
      ],
      "plane_d": -132.41763305664062,
      "bbox_min": [
        478.0,
        930.0,
        -60.0
      ],
      "bbox_max": [
        481.8999938964844,
        959.2427368164062,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        478.0,
        930.0,
        -60.0
      ],
      "bbox_max": [
        481.8999938964844,
        959.2427368164062,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555663108825684,
        0.8314723372459412,
        0.0
      ],
      "plane_d": -529.8563232421875,
      "bbox_min": [
        481.51470947265625,
        958.9852905273438,
        -60.0
      ],
      "bbox_max": [
        481.8999938964844,
        959.2427368164062,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 479.5265197753906,
      "bbox_min": [
        479.5265197753906,
        930.3223266601562,
        -56.5
      ],
      "bbox_max": [
        481.70001220703125,
        933.5826416015625,
        -54.688751220703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -481.70001220703125,
      "bbox_min": [
        479.5265197753906,
        930.3223266601562,
        -56.5
      ],
      "bbox_max": [
        481.70001220703125,
        933.5826416015625,
        -54.688751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547083020210266,
        -0.0,
        0.8320448994636536
      ],
      "plane_d": -220.69480895996094,
      "bbox_min": [
        479.5265197753906,
        930.3223266601562,
        -56.5
      ],
      "bbox_max": [
        481.70001220703125,
        933.5826416015625,
        -54.688751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40613341331481934,
        -0.0,
        0.9138138294219971
      ],
      "plane_d": -144.7764129638672,
      "bbox_min": [
        479.5265197753906,
        930.3223266601562,
        -56.5
      ],
      "bbox_max": [
        481.70001220703125,
        933.5826416015625,
        -54.688751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7682173252105713,
        0.6401891708374023
      ],
      "plane_d": 750.4739379882812,
      "bbox_min": [
        479.5265197753906,
        930.3223266601562,
        -56.5
      ],
      "bbox_max": [
        481.70001220703125,
        933.5826416015625,
        -54.688751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7682173252105713,
        0.6401891708374023
      ],
      "plane_d": -681.41015625,
      "bbox_min": [
        479.5265197753906,
        930.3223266601562,
        -56.5
      ],
      "bbox_max": [
        481.70001220703125,
        933.5826416015625,
        -54.688751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 930.3223266601562,
      "bbox_min": [
        479.5265197753906,
        930.3223266601562,
        -56.5
      ],
      "bbox_max": [
        481.70001220703125,
        933.5826416015625,
        -55.8962516784668
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -933.5826416015625,
      "bbox_min": [
        479.5265197753906,
        933.5826416015625,
        -56.5
      ],
      "bbox_max": [
        481.70001220703125,
        933.5826416015625,
        -55.8962516784668
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19494764506816864,
        0.877263605594635,
        0.43863874673843384
      ],
      "plane_d": -887.9623413085938,
      "bbox_min": [
        479.5265197753906,
        932.9788818359375,
        -55.8962516784668
      ],
      "bbox_max": [
        480.61328125,
        933.5826416015625,
        -54.688751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19494763016700745,
        -0.877263605594635,
        0.43863871693611145
      ],
      "plane_d": 747.1736450195312,
      "bbox_min": [
        479.5265197753906,
        930.3223266601562,
        -55.8962516784668
      ],
      "bbox_max": [
        480.61328125,
        930.9260864257812,
        -54.688751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.363003649312304e-06,
        1.0,
        0.0
      ],
      "plane_d": -961.5896606445312,
      "bbox_min": [
        481.8999938964844,
        950.5,
        -60.0
      ],
      "bbox_max": [
        495.0,
        973.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 56.5,
      "bbox_min": [
        481.8999938964844,
        950.5,
        -60.0
      ],
      "bbox_max": [
        495.0,
        961.5865478515625,
        -52.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5555663108825684,
        0.8314723372459412,
        0.0
      ],
      "plane_d": -529.8563232421875,
      "bbox_min": [
        481.8999938964844,
        959.2427368164062,
        -60.0
      ],
      "bbox_max": [
        485.4078063964844,
        961.5865478515625,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555822849273682,
        -0.8314616084098816,
        0.0
      ],
      "plane_d": 526.0133056640625,
      "bbox_min": [
        481.8999938964844,
        950.5,
        -60.0
      ],
      "bbox_max": [
        486.9002685546875,
        957.9834594726562,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807852506637573,
        -0.19509102404117584,
        0.0
      ],
      "plane_d": -287.2064208984375,
      "bbox_min": [
        481.8999938964844,
        950.5,
        -60.0
      ],
      "bbox_max": [
        484.2724304199219,
        956.2275390625,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314675092697144,
        -0.5555734038352966,
        0.0
      ],
      "plane_d": 128.5977783203125,
      "bbox_min": [
        482.5165710449219,
        953.5997314453125,
        -60.0
      ],
      "bbox_max": [
        484.2724304199219,
        956.2275390625,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 958.7000122070312,
      "bbox_min": [
        490.0,
        958.7000122070312,
        -56.5
      ],
      "bbox_max": [
        493.3999938964844,
        960.9000244140625,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -960.9000244140625,
      "bbox_min": [
        490.0,
        958.7000122070312,
        -56.5
      ],
      "bbox_max": [
        493.3999938964844,
        960.9000244140625,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 52.5,
      "bbox_min": [
        490.0,
        958.7000122070312,
        -56.5
      ],
      "bbox_max": [
        493.3999938964844,
        960.9000244140625,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 490.0,
      "bbox_min": [
        490.0,
        958.7000122070312,
        -56.5
      ],
      "bbox_max": [
        493.3999938964844,
        960.9000244140625,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -493.3999938964844,
      "bbox_min": [
        490.0,
        958.7000122070312,
        -56.5
      ],
      "bbox_max": [
        493.3999938964844,
        960.9000244140625,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 639.0123901367188,
      "bbox_min": [
        490.0,
        958.7000122070312,
        -56.5
      ],
      "bbox_max": [
        493.3999938964844,
        960.9000244140625,
        -55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 307.5914611816406,
      "bbox_min": [
        490.0,
        958.7000122070312,
        -56.5
      ],
      "bbox_max": [
        493.3999938964844,
        960.9000244140625,
        -55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -718.3497924804688,
      "bbox_min": [
        490.0,
        958.7000122070312,
        -56.5
      ],
      "bbox_max": [
        493.3999938964844,
        960.9000244140625,
        -55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -387.77734375,
      "bbox_min": [
        492.8999938964844,
        958.7000122070312,
        -56.100032806396484
      ],
      "bbox_max": [
        493.3999938964844,
        960.9000244140625,
        -55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -492.8999938964844,
      "bbox_min": [
        492.8999938964844,
        959.2000122070312,
        -56.100032806396484
      ],
      "bbox_max": [
        493.0000305175781,
        960.4000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -308.9349365234375,
      "bbox_min": [
        492.8999938964844,
        959.699951171875,
        -56.100032806396484
      ],
      "bbox_max": [
        493.0000305175781,
        959.9000244140625,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -308.9349365234375,
      "bbox_min": [
        492.8999938964844,
        959.7999877929688,
        -56.5
      ],
      "bbox_max": [
        493.3999938964844,
        960.4000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -492.8999938964844,
      "bbox_min": [
        492.8999938964844,
        959.9000244140625,
        -56.0
      ],
      "bbox_max": [
        492.8999938964844,
        960.4000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -308.9349365234375,
      "bbox_min": [
        492.8999938964844,
        960.4000244140625,
        -56.5
      ],
      "bbox_max": [
        493.3999938964844,
        960.9000244140625,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 386.4338684082031,
      "bbox_min": [
        490.0,
        959.2000122070312,
        -56.5
      ],
      "bbox_max": [
        490.5,
        960.9000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 490.5,
      "bbox_min": [
        490.5,
        959.2000122070312,
        -56.0
      ],
      "bbox_max": [
        490.5,
        960.4000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -960.4000244140625,
      "bbox_min": [
        490.5,
        959.9000854492188,
        -56.0
      ],
      "bbox_max": [
        491.0000305175781,
        960.4000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 717.8547973632812,
      "bbox_min": [
        490.0,
        958.7000122070312,
        -56.5
      ],
      "bbox_max": [
        493.3999938964844,
        960.2000122070312,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -308.9349365234375,
      "bbox_min": [
        492.8999938964844,
        958.7000122070312,
        -56.5
      ],
      "bbox_max": [
        493.3999938964844,
        960.2000122070312,
        -55.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -492.8999938964844,
      "bbox_min": [
        492.8999938964844,
        959.2000122070312,
        -56.0
      ],
      "bbox_max": [
        492.8999938964844,
        959.699951171875,
        -55.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 959.2000122070312,
      "bbox_min": [
        490.5,
        959.2000122070312,
        -56.0
      ],
      "bbox_max": [
        492.8999938964844,
        959.449951171875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 490.5,
      "bbox_min": [
        490.5,
        959.2000122070312,
        -56.0
      ],
      "bbox_max": [
        490.5,
        959.699951171875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        490.0,
        970.0,
        -60.0
      ],
      "bbox_max": [
        494.0,
        973.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -494.0,
      "bbox_min": [
        490.0,
        970.0,
        -60.0
      ],
      "bbox_max": [
        494.0,
        973.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 55.999996185302734,
      "bbox_min": [
        490.0,
        970.0,
        -56.5
      ],
      "bbox_max": [
        494.0,
        973.0,
        -56.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 56.5,
      "bbox_min": [
        490.5,
        970.5,
        -56.5
      ],
      "bbox_max": [
        493.5,
        972.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -970.5,
      "bbox_min": [
        490.5,
        970.5,
        -56.5
      ],
      "bbox_max": [
        493.5,
        972.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 972.5,
      "bbox_min": [
        490.5,
        970.5,
        -56.5
      ],
      "bbox_max": [
        493.5,
        972.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.5,
      "bbox_min": [
        490.5,
        970.5,
        -56.5
      ],
      "bbox_max": [
        493.5,
        972.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 493.5,
      "bbox_min": [
        493.5,
        970.5,
        -56.5
      ],
      "bbox_max": [
        493.5,
        972.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        484.5,
        970.0,
        -60.0
      ],
      "bbox_max": [
        488.5,
        973.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 484.5,
      "bbox_min": [
        484.5,
        970.0,
        -60.0
      ],
      "bbox_max": [
        488.5,
        973.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -488.5,
      "bbox_min": [
        484.5,
        970.0,
        -60.0
      ],
      "bbox_max": [
        488.5,
        973.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 55.999996185302734,
      "bbox_min": [
        484.5,
        970.0,
        -57.0
      ],
      "bbox_max": [
        488.5,
        973.0,
        -56.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 57.0,
      "bbox_min": [
        485.0,
        970.5,
        -57.0
      ],
      "bbox_max": [
        488.0,
        972.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -970.5,
      "bbox_min": [
        485.0,
        970.5,
        -57.0
      ],
      "bbox_max": [
        488.0,
        972.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 972.5,
      "bbox_min": [
        485.0,
        970.5,
        -57.0
      ],
      "bbox_max": [
        488.0,
        972.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -485.0,
      "bbox_min": [
        485.0,
        970.5,
        -57.0
      ],
      "bbox_max": [
        488.0,
        972.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 488.0,
      "bbox_min": [
        488.0,
        970.5,
        -57.0
      ],
      "bbox_max": [
        488.0,
        972.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 560.0,
      "bbox_min": [
        496.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1024.218994140625,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 348.0743713378906,
      "bbox_min": [
        560.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        993.0,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -428.5067138671875,
      "bbox_min": [
        560.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        993.0,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 562.7433471679688,
      "bbox_min": [
        560.0,
        947.0,
        -46.0
      ],
      "bbox_max": [
        562.0000610351562,
        993.0,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 947.0,
      "bbox_min": [
        560.0,
        947.0,
        -46.0
      ],
      "bbox_max": [
        561.0,
        993.0,
        -45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -993.0,
      "bbox_min": [
        560.0,
        993.0,
        -46.0
      ],
      "bbox_max": [
        560.2124633789062,
        993.0,
        -45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 563.0,
      "bbox_min": [
        560.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        993.0,
        -44.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 57.5,
      "bbox_min": [
        563.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        991.6447143554688,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        563.0,
        926.4000244140625,
        -60.0
      ],
      "bbox_max": [
        571.5,
        990.0,
        -57.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -990.0,
      "bbox_min": [
        563.0,
        990.0,
        -60.0
      ],
      "bbox_max": [
        566.3828735351562,
        990.0,
        -57.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424241065979,
        0.24253560602664948
      ],
      "plane_d": -884.7941284179688,
      "bbox_min": [
        563.0,
        926.4000244140625,
        -60.0
      ],
      "bbox_max": [
        571.5,
        942.0,
        -57.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6859792470932007,
        -0.6860171556472778,
        0.24251386523246765
      ],
      "plane_d": 266.0910949707031,
      "bbox_min": [
        563.0,
        926.4000854492188,
        -60.0
      ],
      "bbox_max": [
        571.5,
        942.0,
        -57.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 566.5,
      "bbox_min": [
        563.0,
        932.5,
        -60.0
      ],
      "bbox_max": [
        571.5,
        942.0,
        -57.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -942.0,
      "bbox_min": [
        566.5,
        942.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        942.0,
        -57.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -261.2759704589844,
      "bbox_min": [
        563.0,
        932.5,
        -60.0
      ],
      "bbox_max": [
        566.5,
        936.0,
        -57.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701426029205322,
        0.0,
        0.24253565073013306
      ],
      "plane_d": 567.9942626953125,
      "bbox_min": [
        567.0799560546875,
        926.4000854492188,
        -57.900001525878906
      ],
      "bbox_max": [
        571.0999755859375,
        934.5999755859375,
        -57.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 920.6409912109375,
      "bbox_min": [
        567.0799560546875,
        934.5,
        -57.900001525878906
      ],
      "bbox_max": [
        571.0999755859375,
        934.5999755859375,
        -57.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 947.0,
      "bbox_min": [
        563.0,
        926.0,
        -57.5
      ],
      "bbox_max": [
        571.5,
        991.6447143554688,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 562.7433471679688,
      "bbox_min": [
        563.0,
        947.0,
        -45.0
      ],
      "bbox_max": [
        571.5,
        948.5,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 56.599998474121094,
      "bbox_min": [
        563.0,
        986.5,
        -57.5
      ],
      "bbox_max": [
        570.5,
        991.6447143554688,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -988.5,
      "bbox_min": [
        564.5,
        986.5,
        -57.5
      ],
      "bbox_max": [
        569.4681396484375,
        988.5,
        -56.599998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 564.5,
      "bbox_min": [
        564.5,
        986.5,
        -57.5
      ],
      "bbox_max": [
        564.5,
        988.5,
        -56.599998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -513.3750610351562,
      "bbox_min": [
        563.0,
        991.5,
        -44.09648132324219
      ],
      "bbox_max": [
        563.2976684570312,
        991.6447143554688,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 564.5,
      "bbox_min": [
        564.5,
        974.25,
        -57.5
      ],
      "bbox_max": [
        564.5,
        976.25,
        -56.599998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 57.0,
      "bbox_min": [
        564.0,
        977.2000122070312,
        -57.5
      ],
      "bbox_max": [
        571.0,
        983.7999877929688,
        -55.77313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36376598477363586,
        -0.9314904808998108,
        -0.0
      ],
      "plane_d": 1117.590087890625,
      "bbox_min": [
        565.025146484375,
        978.1665649414062,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        982.8334350585938,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36376598477363586,
        -0.9314904808998108,
        0.0
      ],
      "plane_d": 704.7156372070312,
      "bbox_min": [
        565.025146484375,
        978.1665649414062,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        982.8334350585938,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36376598477363586,
        0.9314904808998108,
        0.0
      ],
      "plane_d": -709.0628051757812,
      "bbox_min": [
        565.025146484375,
        978.8499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        982.8334350585938,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36376598477363586,
        0.9314904808998108,
        0.0
      ],
      "plane_d": -1121.937255859375,
      "bbox_min": [
        565.025146484375,
        978.8499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        982.8334350585938,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9155516624450684,
        0.4022006094455719,
        0.0
      ],
      "plane_d": 122.95199584960938,
      "bbox_min": [
        565.025146484375,
        978.8499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        982.1500244140625,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9155516624450684,
        -0.4022006094455719,
        -0.0
      ],
      "plane_d": 911.6673583984375,
      "bbox_min": [
        565.025146484375,
        978.8499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        982.1500244140625,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155516624450684,
        -0.4022006094455719,
        0.0
      ],
      "plane_d": -127.48373413085938,
      "bbox_min": [
        569.25,
        978.8499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        982.1500244140625,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155516624450684,
        0.4022006094455719,
        0.0
      ],
      "plane_d": -916.1990966796875,
      "bbox_min": [
        569.25,
        980.5,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        982.1500244140625,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2932906448841095,
        -0.7509692907333374,
        -0.5916297435760498
      ],
      "plane_d": 534.40771484375,
      "bbox_min": [
        564.0,
        977.2000122070312,
        -57.0
      ],
      "bbox_max": [
        571.0,
        983.7999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.293278306722641,
        -0.7509936094284058,
        0.5916048288345337
      ],
      "plane_d": 605.3876953125,
      "bbox_min": [
        564.0,
        977.2000122070312,
        -57.0
      ],
      "bbox_max": [
        571.0,
        983.7999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.29329603910446167,
        -0.7509831190109253,
        -0.5916094779968262
      ],
      "plane_d": 867.310302734375,
      "bbox_min": [
        564.0,
        977.2000122070312,
        -57.0
      ],
      "bbox_max": [
        571.0,
        983.7999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.29327067732810974,
        -0.7509741187095642,
        0.5916335582733154
      ],
      "plane_d": 938.2366943359375,
      "bbox_min": [
        564.0,
        978.1665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        983.7999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7271744608879089,
        0.31946906447410583,
        -0.607582688331604
      ],
      "plane_d": 63.000213623046875,
      "bbox_min": [
        564.0,
        978.1665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        982.8334350585938,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7271612882614136,
        -0.3194632828235626,
        -0.6076016426086426
      ],
      "plane_d": 689.46484375,
      "bbox_min": [
        564.0,
        978.1665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        982.8334350585938,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7271663546562195,
        0.3194431960582733,
        0.6076059341430664
      ],
      "plane_d": 135.88604736328125,
      "bbox_min": [
        569.25,
        978.1665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        982.8334350585938,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7271851897239685,
        -0.3194514811038971,
        0.607579231262207
      ],
      "plane_d": 762.3314208984375,
      "bbox_min": [
        569.25,
        980.5,
        -57.0
      ],
      "bbox_max": [
        571.0,
        982.8334350585938,
        -55.77313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -954.25,
      "bbox_min": [
        564.0,
        952.25,
        -57.5
      ],
      "bbox_max": [
        571.0,
        973.2999877929688,
        -55.77313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 56.599998474121094,
      "bbox_min": [
        564.5,
        952.25,
        -57.5
      ],
      "bbox_max": [
        570.5,
        954.25,
        -56.599998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 952.25,
      "bbox_min": [
        564.5,
        952.25,
        -57.5
      ],
      "bbox_max": [
        570.5,
        954.25,
        -56.599998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 564.5,
      "bbox_min": [
        564.5,
        952.25,
        -57.5
      ],
      "bbox_max": [
        564.5,
        954.25,
        -56.599998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 57.0,
      "bbox_min": [
        564.0,
        956.2000122070312,
        -57.5
      ],
      "bbox_max": [
        571.0,
        973.2999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.36376598477363586,
        -0.9314904808998108,
        -0.0
      ],
      "plane_d": 1107.8094482421875,
      "bbox_min": [
        565.025146484375,
        957.1665649414062,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        972.3334350585938,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36376598477363586,
        0.9314904808998108,
        0.0
      ],
      "plane_d": -699.2821655273438,
      "bbox_min": [
        565.025146484375,
        967.6665649414062,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        972.3334350585938,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36376598477363586,
        -0.9314904808998108,
        0.0
      ],
      "plane_d": 694.9349975585938,
      "bbox_min": [
        565.025146484375,
        967.6665649414062,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        972.3334350585938,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36376598477363586,
        0.9314904808998108,
        0.0
      ],
      "plane_d": -1112.156494140625,
      "bbox_min": [
        565.025146484375,
        968.3499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        972.3334350585938,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9155516624450684,
        0.4022006094455719,
        0.0
      ],
      "plane_d": 127.17510986328125,
      "bbox_min": [
        565.025146484375,
        968.3499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        971.6500244140625,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9155516624450684,
        -0.4022006094455719,
        -0.0
      ],
      "plane_d": 907.4442749023438,
      "bbox_min": [
        565.025146484375,
        968.3499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        971.6500244140625,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155516624450684,
        -0.4022006094455719,
        0.0
      ],
      "plane_d": -131.70684814453125,
      "bbox_min": [
        569.25,
        968.3499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        971.6500244140625,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155516624450684,
        0.4022006094455719,
        0.0
      ],
      "plane_d": -911.9760131835938,
      "bbox_min": [
        569.25,
        970.0,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        971.6500244140625,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36376598477363586,
        0.9314904808998108,
        0.0
      ],
      "plane_d": -689.50146484375,
      "bbox_min": [
        565.025146484375,
        957.1665649414062,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        961.8334350585938,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36376598477363586,
        -0.9314904808998108,
        -0.0
      ],
      "plane_d": 1098.02880859375,
      "bbox_min": [
        565.025146484375,
        957.1665649414062,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        961.8334350585938,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36376598477363586,
        -0.9314904808998108,
        0.0
      ],
      "plane_d": 685.1543579101562,
      "bbox_min": [
        565.025146484375,
        957.1665649414062,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        961.8334350585938,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36376598477363586,
        0.9314904808998108,
        0.0
      ],
      "plane_d": -1102.3759765625,
      "bbox_min": [
        565.025146484375,
        957.8499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        961.8334350585938,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9155516624450684,
        0.4022006094455719,
        0.0
      ],
      "plane_d": 131.398193359375,
      "bbox_min": [
        565.025146484375,
        957.8499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        961.1500244140625,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9155516624450684,
        -0.4022006094455719,
        -0.0
      ],
      "plane_d": 903.22119140625,
      "bbox_min": [
        565.025146484375,
        957.8499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        961.1500244140625,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155516624450684,
        -0.4022006094455719,
        0.0
      ],
      "plane_d": -135.92996215820312,
      "bbox_min": [
        569.25,
        957.8499755859375,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        961.1500244140625,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155516624450684,
        0.4022006094455719,
        0.0
      ],
      "plane_d": -907.7529296875,
      "bbox_min": [
        569.25,
        959.5,
        -57.5
      ],
      "bbox_max": [
        569.974853515625,
        961.1500244140625,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2932906448841095,
        -0.7509692907333374,
        -0.5916297435760498
      ],
      "plane_d": 526.5225219726562,
      "bbox_min": [
        564.0,
        956.2000122070312,
        -57.0
      ],
      "bbox_max": [
        571.0,
        973.2999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2932906448841095,
        0.7509692907333374,
        -0.5916297435760498
      ],
      "plane_d": -597.4730224609375,
      "bbox_min": [
        564.0,
        966.7000122070312,
        -57.0
      ],
      "bbox_max": [
        571.0,
        973.2999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.29329603910446167,
        -0.7509831190109253,
        -0.5916094779968262
      ],
      "plane_d": 859.4249877929688,
      "bbox_min": [
        564.0,
        966.7000122070312,
        -57.0
      ],
      "bbox_max": [
        571.0,
        973.2999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.29327067732810974,
        -0.7509741187095642,
        0.5916335582733154
      ],
      "plane_d": 930.3514404296875,
      "bbox_min": [
        564.0,
        967.6665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        973.2999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7271744608879089,
        0.31946906447410583,
        -0.607582688331604
      ],
      "plane_d": 66.35464477539062,
      "bbox_min": [
        564.0,
        967.6665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        972.3334350585938,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7271612882614136,
        -0.3194632828235626,
        -0.6076016426086426
      ],
      "plane_d": 686.1104736328125,
      "bbox_min": [
        564.0,
        967.6665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        972.3334350585938,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7271851897239685,
        -0.3194514811038971,
        0.607579231262207
      ],
      "plane_d": 758.9772338867188,
      "bbox_min": [
        569.25,
        967.6665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        972.3334350585938,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7271663546562195,
        0.3194431960582733,
        0.6076059341430664
      ],
      "plane_d": 139.24017333984375,
      "bbox_min": [
        569.25,
        967.6665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        970.0,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2932906448841095,
        0.7509692907333374,
        -0.5916297435760498
      ],
      "plane_d": -589.5878295898438,
      "bbox_min": [
        564.0,
        956.2000122070312,
        -57.0
      ],
      "bbox_max": [
        571.0,
        962.7999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.293278306722641,
        0.7509936094284058,
        0.5916048288345337
      ],
      "plane_d": -518.6690673828125,
      "bbox_min": [
        564.0,
        956.2000122070312,
        -57.0
      ],
      "bbox_max": [
        571.0,
        962.7999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.29329603910446167,
        -0.7509831190109253,
        -0.5916094779968262
      ],
      "plane_d": 851.5396728515625,
      "bbox_min": [
        564.0,
        956.2000122070312,
        -57.0
      ],
      "bbox_max": [
        571.0,
        962.7999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.29327067732810974,
        -0.7509741187095642,
        0.5916335582733154
      ],
      "plane_d": 922.4661865234375,
      "bbox_min": [
        564.0,
        957.1665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        962.7999877929688,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7271744608879089,
        0.31946906447410583,
        -0.607582688331604
      ],
      "plane_d": 69.70904541015625,
      "bbox_min": [
        564.0,
        957.1665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        961.8334350585938,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7271612882614136,
        -0.3194632828235626,
        -0.6076016426086426
      ],
      "plane_d": 682.756103515625,
      "bbox_min": [
        564.0,
        957.1665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        961.8334350585938,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7271851897239685,
        -0.3194514811038971,
        0.607579231262207
      ],
      "plane_d": 755.6229858398438,
      "bbox_min": [
        569.25,
        957.1665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        961.8334350585938,
        -55.77313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7271663546562195,
        0.3194431960582733,
        0.6076059341430664
      ],
      "plane_d": 142.59432983398438,
      "bbox_min": [
        569.25,
        957.1665649414062,
        -57.0
      ],
      "bbox_max": [
        571.0,
        959.5,
        -55.77313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424241065979,
        0.24253560602664948
      ],
      "plane_d": -884.7941284179688,
      "bbox_min": [
        563.0,
        926.0,
        -57.5
      ],
      "bbox_max": [
        571.5,
        942.0,
        -54.400001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 55.900001525878906,
      "bbox_min": [
        563.0,
        926.0,
        -57.5
      ],
      "bbox_max": [
        571.5,
        942.0,
        -54.400001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6859792470932007,
        -0.6860171556472778,
        0.24251386523246765
      ],
      "plane_d": 266.0910949707031,
      "bbox_min": [
        563.0,
        926.0,
        -57.5
      ],
      "bbox_max": [
        571.5,
        942.0,
        -55.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -942.0,
      "bbox_min": [
        566.5,
        942.0,
        -57.5
      ],
      "bbox_max": [
        571.5,
        942.0,
        -55.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -261.2759704589844,
      "bbox_min": [
        563.0,
        932.5,
        -57.5
      ],
      "bbox_max": [
        566.5,
        936.0,
        -55.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 920.6409912109375,
      "bbox_min": [
        566.914306640625,
        934.5999755859375,
        -57.5
      ],
      "bbox_max": [
        571.5,
        935.0,
        -55.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -567.25,
      "bbox_min": [
        566.75,
        926.0,
        -55.400001525878906
      ],
      "bbox_max": [
        571.5,
        930.8001708984375,
        -54.400001525878906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -54.900001525878906,
      "bbox_min": [
        566.75,
        926.0,
        -55.400001525878906
      ],
      "bbox_max": [
        567.25,
        928.0,
        -54.400001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 566.7499389648438,
      "bbox_min": [
        566.75,
        926.0,
        -54.900001525878906
      ],
      "bbox_max": [
        567.25,
        928.0,
        -54.400001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 54.400001525878906,
      "bbox_min": [
        566.75,
        926.0,
        -54.900001525878906
      ],
      "bbox_max": [
        567.25,
        928.0,
        -54.400001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -617.3749389648438,
      "bbox_min": [
        566.75,
        927.5,
        -54.900001525878906
      ],
      "bbox_max": [
        567.25,
        928.0,
        -54.400001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -928.0,
      "bbox_min": [
        566.75,
        927.5,
        -55.400001525878906
      ],
      "bbox_max": [
        567.25,
        928.0,
        -54.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 566.75,
      "bbox_min": [
        566.75,
        927.5,
        -55.400001525878906
      ],
      "bbox_max": [
        566.75,
        928.0,
        -54.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 930.2999877929688,
      "bbox_min": [
        569.5,
        930.300048828125,
        -55.400001525878906
      ],
      "bbox_max": [
        571.5,
        930.8001708984375,
        -54.400001525878906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        8.138021075865254e-05,
        1.0,
        0.0
      ],
      "plane_d": -930.8465576171875,
      "bbox_min": [
        569.5,
        930.300048828125,
        -55.400001525878906
      ],
      "bbox_max": [
        571.5,
        930.8001708984375,
        -54.400001525878906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 54.400001525878906,
      "bbox_min": [
        569.5,
        930.300048828125,
        -55.400001525878906
      ],
      "bbox_max": [
        571.5,
        930.8001708984375,
        -54.400001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 441.5174560546875,
      "bbox_min": [
        569.5,
        930.300048828125,
        -55.400001525878906
      ],
      "bbox_max": [
        570.0,
        930.8001708984375,
        -54.400001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 569.5,
      "bbox_min": [
        569.5,
        930.300048828125,
        -55.400001525878906
      ],
      "bbox_max": [
        569.5,
        930.7999267578125,
        -54.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 55.900001525878906,
      "bbox_min": [
        560.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        563.0,
        993.0,
        -44.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -261.2759704589844,
      "bbox_min": [
        560.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        563.0,
        932.5,
        -55.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        0.24253565073013306
      ],
      "plane_d": -532.1474609375,
      "bbox_min": [
        562.5,
        926.0,
        -57.900001525878906
      ],
      "bbox_max": [
        563.0,
        931.0859375,
        -55.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -931.0,
      "bbox_min": [
        560.0,
        931.0,
        -60.0
      ],
      "bbox_max": [
        561.5,
        931.0,
        -55.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -702.156982421875,
      "bbox_min": [
        560.0,
        947.0,
        -46.0
      ],
      "bbox_max": [
        563.0,
        993.0,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 947.0,
      "bbox_min": [
        560.0,
        947.0,
        -46.0
      ],
      "bbox_max": [
        563.0,
        948.5,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 562.7433471679688,
      "bbox_min": [
        561.0,
        947.0,
        -45.0
      ],
      "bbox_max": [
        563.0,
        948.5,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 669.6301879882812,
      "bbox_min": [
        560.0,
        991.0,
        -46.0
      ],
      "bbox_max": [
        563.0,
        993.0,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -513.3750610351562,
      "bbox_min": [
        560.0,
        991.5,
        -46.0
      ],
      "bbox_max": [
        563.0,
        993.0,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -993.0,
      "bbox_min": [
        560.0,
        993.0,
        -46.0
      ],
      "bbox_max": [
        560.2124633789062,
        993.0,
        -45.78753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        496.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        560.0,
        1024.218994140625,
        -44.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -47.04999542236328,
      "bbox_min": [
        518.2674560546875,
        1000.0,
        -60.0
      ],
      "bbox_max": [
        535.0,
        1013.392822265625,
        -47.04999542236328
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        518.2674560546875,
        1000.0,
        -60.0
      ],
      "bbox_max": [
        535.0,
        1013.392822265625,
        -47.04999542236328
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.965927004814148,
        0.25881466269493103,
        -0.0
      ],
      "plane_d": -763.167236328125,
      "bbox_min": [
        518.2674560546875,
        1008.0,
        -60.0
      ],
      "bbox_max": [
        520.0,
        1013.392822265625,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -1083.04736328125,
      "bbox_min": [
        518.2674560546875,
        1013.0,
        -60.0
      ],
      "bbox_max": [
        518.6602783203125,
        1013.392822265625,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        526.0716552734375,
        1000.0,
        -60.0
      ],
      "bbox_max": [
        535.0,
        1009.5985717773438,
        -47.04999542236328
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6689653992652893,
        0.0,
        -0.7432936429977417
      ],
      "plane_d": -388.52020263671875,
      "bbox_min": [
        526.0716552734375,
        1001.0,
        -47.5
      ],
      "bbox_max": [
        528.5,
        1009.5985717773438,
        -47.04999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -47.5,
      "bbox_min": [
        526.0716552734375,
        1001.0,
        -47.5
      ],
      "bbox_max": [
        528.5,
        1009.5985717773438,
        -47.04999923706055
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6689653396606445,
        -0.0,
        -0.7432935833930969
      ],
      "plane_d": 317.23828125,
      "bbox_min": [
        526.0716552734375,
        1001.0,
        -47.5
      ],
      "bbox_max": [
        528.5,
        1009.5985717773438,
        -47.04999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6689653992652893,
        -0.7432936429977417
      ],
      "plane_d": 634.6624145507812,
      "bbox_min": [
        526.5,
        1001.0,
        -47.5
      ],
      "bbox_max": [
        528.5,
        1008.760009765625,
        -47.04999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6584476828575134,
        0.176431804895401,
        -0.7316544651985168
      ],
      "plane_d": -560.2572021484375,
      "bbox_min": [
        527.7963256835938,
        1008.0,
        -47.5
      ],
      "bbox_max": [
        528.5,
        1008.760009765625,
        -47.04999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6584915518760681,
        -0.1764415204524994,
        -0.7316128015518188
      ],
      "plane_d": 490.12646484375,
      "bbox_min": [
        526.0716552734375,
        1008.0,
        -47.5
      ],
      "bbox_max": [
        527.0,
        1009.5985717773438,
        -47.04999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        0.7071055769920349,
        -0.0
      ],
      "plane_d": -1074.117431640625,
      "bbox_min": [
        496.0,
        1018.721435546875,
        -60.0
      ],
      "bbox_max": [
        507.30755615234375,
        1024.218994140625,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -47.04999542236328,
      "bbox_min": [
        496.0,
        1018.721435546875,
        -47.04999542236328
      ],
      "bbox_max": [
        507.30755615234375,
        1024.218994140625,
        -47.04999542236328
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -941.5,
      "bbox_min": [
        496.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        560.0,
        996.0,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 50.049991607666016,
      "bbox_min": [
        520.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        560.0,
        941.5,
        -50.04999542236328
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        520.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        560.0,
        941.5,
        -50.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 520.0,
      "bbox_min": [
        520.0,
        940.0,
        -60.0
      ],
      "bbox_max": [
        546.5,
        941.5,
        -50.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -546.5,
      "bbox_min": [
        546.5,
        940.0,
        -60.0
      ],
      "bbox_max": [
        546.5,
        941.5,
        -50.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -546.5,
      "bbox_min": [
        545.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        560.0,
        940.0,
        -50.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 545.0,
      "bbox_min": [
        545.0,
        926.0,
        -60.0
      ],
      "bbox_max": [
        545.0,
        940.0,
        -50.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 55.900001525878906,
      "bbox_min": [
        555.5,
        926.0,
        -60.0
      ],
      "bbox_max": [
        560.0,
        931.0,
        -55.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 555.5,
      "bbox_min": [
        555.5,
        926.0,
        -60.0
      ],
      "bbox_max": [
        560.0,
        931.0,
        -55.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -931.0,
      "bbox_min": [
        555.5,
        931.0,
        -60.0
      ],
      "bbox_max": [
        560.0,
        931.0,
        -55.900001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 534.5,
      "bbox_min": [
        496.0,
        955.0,
        -60.0
      ],
      "bbox_max": [
        544.5,
        996.0,
        -44.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 57.0,
      "bbox_min": [
        534.5,
        955.0,
        -60.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -544.5,
      "bbox_min": [
        534.5,
        955.0,
        -60.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 955.0,
      "bbox_min": [
        534.5,
        955.0,
        -60.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        534.5,
        985.0,
        -60.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -57.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -544.5,
      "bbox_min": [
        534.5,
        955.0,
        -57.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -49.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -50.0,
      "bbox_min": [
        534.5,
        955.0,
        -57.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 49.5,
      "bbox_min": [
        539.25,
        955.0,
        -50.0
      ],
      "bbox_max": [
        544.5,
        975.0,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 539.25,
      "bbox_min": [
        539.25,
        955.0,
        -50.0
      ],
      "bbox_max": [
        544.5,
        975.0,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 955.0,
      "bbox_min": [
        539.25,
        955.0,
        -50.0
      ],
      "bbox_max": [
        544.5,
        975.0,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -975.0,
      "bbox_min": [
        539.25,
        975.0,
        -50.0
      ],
      "bbox_max": [
        544.5,
        975.0,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -53.0,
      "bbox_min": [
        534.5,
        955.0,
        -57.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -50.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 52.5,
      "bbox_min": [
        534.5,
        955.0,
        -53.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -50.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 539.25,
      "bbox_min": [
        534.5,
        955.0,
        -53.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 974.5,
      "bbox_min": [
        539.25,
        955.0,
        -53.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        539.25,
        985.0,
        -53.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 955.0,
      "bbox_min": [
        539.25,
        955.0,
        -53.0
      ],
      "bbox_max": [
        544.5,
        955.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 974.5,
      "bbox_min": [
        534.5,
        974.5,
        -53.0
      ],
      "bbox_max": [
        539.25,
        985.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        534.5,
        985.0,
        -53.0
      ],
      "bbox_max": [
        539.25,
        985.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 974.5,
      "bbox_min": [
        539.25,
        955.0,
        -52.5
      ],
      "bbox_max": [
        544.5,
        975.0,
        -50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -975.0,
      "bbox_min": [
        539.25,
        974.5,
        -52.5
      ],
      "bbox_max": [
        544.5,
        975.0,
        -50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 539.25,
      "bbox_min": [
        539.25,
        974.5,
        -52.5
      ],
      "bbox_max": [
        539.25,
        975.0,
        -50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 955.0,
      "bbox_min": [
        539.25,
        955.0,
        -52.5
      ],
      "bbox_max": [
        544.5,
        955.5,
        -50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -955.5,
      "bbox_min": [
        539.25,
        955.0,
        -52.5
      ],
      "bbox_max": [
        544.5,
        955.5,
        -50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 539.25,
      "bbox_min": [
        539.25,
        955.0,
        -52.5
      ],
      "bbox_max": [
        539.25,
        955.5,
        -50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -539.75,
      "bbox_min": [
        534.5,
        955.0,
        -57.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -53.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 539.25,
      "bbox_min": [
        534.5,
        955.0,
        -57.0
      ],
      "bbox_max": [
        539.75,
        985.0,
        -53.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 974.5,
      "bbox_min": [
        539.25,
        955.0,
        -57.0
      ],
      "bbox_max": [
        539.75,
        975.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -975.0,
      "bbox_min": [
        539.25,
        975.0,
        -57.0
      ],
      "bbox_max": [
        539.75,
        975.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 955.0,
      "bbox_min": [
        539.25,
        955.0,
        -57.0
      ],
      "bbox_max": [
        539.75,
        955.5,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -955.5,
      "bbox_min": [
        539.25,
        955.5,
        -57.0
      ],
      "bbox_max": [
        539.75,
        955.5,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 984.5,
      "bbox_min": [
        534.5,
        974.5,
        -57.0
      ],
      "bbox_max": [
        535.0,
        985.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        534.5,
        984.5,
        -57.0
      ],
      "bbox_max": [
        535.0,
        985.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -535.0,
      "bbox_min": [
        535.0,
        984.5,
        -57.0
      ],
      "bbox_max": [
        535.0,
        985.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 974.5,
      "bbox_min": [
        534.5,
        974.5,
        -57.0
      ],
      "bbox_max": [
        535.0,
        975.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -535.0,
      "bbox_min": [
        534.5,
        974.5,
        -57.0
      ],
      "bbox_max": [
        535.0,
        975.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -975.0,
      "bbox_min": [
        534.5,
        975.0,
        -57.0
      ],
      "bbox_max": [
        535.0,
        975.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 974.5,
      "bbox_min": [
        544.0,
        955.0,
        -57.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 984.5,
      "bbox_min": [
        544.0,
        974.5,
        -57.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 544.0,
      "bbox_min": [
        544.0,
        984.5,
        -57.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        544.0,
        985.0,
        -57.0
      ],
      "bbox_max": [
        544.5,
        985.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 544.0,
      "bbox_min": [
        544.0,
        974.5,
        -57.0
      ],
      "bbox_max": [
        544.5,
        975.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -975.0,
      "bbox_min": [
        544.0,
        975.0,
        -57.0
      ],
      "bbox_max": [
        544.5,
        975.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 544.0,
      "bbox_min": [
        544.0,
        955.0,
        -57.0
      ],
      "bbox_max": [
        544.5,
        955.5,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 955.0,
      "bbox_min": [
        544.0,
        955.0,
        -57.0
      ],
      "bbox_max": [
        544.5,
        955.5,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -955.5,
      "bbox_min": [
        544.0,
        955.5,
        -57.0
      ],
      "bbox_max": [
        544.5,
        955.5,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        496.0,
        955.0,
        -60.0
      ],
      "bbox_max": [
        510.0,
        996.0,
        -44.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 509.0,
      "bbox_min": [
        496.0,
        955.0,
        -60.0
      ],
      "bbox_max": [
        510.0,
        996.0,
        -44.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 955.0,
      "bbox_min": [
        509.0,
        955.0,
        -60.0
      ],
      "bbox_max": [
        510.0,
        986.0,
        -44.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 986.0,
      "bbox_min": [
        509.0,
        967.0,
        -60.0
      ],
      "bbox_max": [
        510.0,
        986.0,
        -44.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 974.0,
      "bbox_min": [
        509.0,
        967.0,
        -60.0
      ],
      "bbox_max": [
        510.0,
        974.0,
        -51.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -967.0,
      "bbox_min": [
        509.0,
        967.0,
        -60.0
      ],
      "bbox_max": [
        510.0,
        974.0,
        -51.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -51.0,
      "bbox_min": [
        509.0,
        967.0,
        -51.0
      ],
      "bbox_max": [
        510.0,
        974.0,
        -51.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 986.0,
      "bbox_min": [
        496.0,
        955.0,
        -60.0
      ],
      "bbox_max": [
        509.0,
        996.0,
        -44.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -990.0,
      "bbox_min": [
        496.0,
        986.0,
        -60.0
      ],
      "bbox_max": [
        502.0,
        996.0,
        -48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -502.0,
      "bbox_min": [
        496.0,
        986.0,
        -60.0
      ],
      "bbox_max": [
        502.0,
        990.0,
        -48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 48.0,
      "bbox_min": [
        496.0,
        986.0,
        -48.0
      ],
      "bbox_max": [
        502.0,
        990.0,
        -48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        496.0,
        990.0,
        -60.0
      ],
      "bbox_max": [
        500.0,
        996.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 54.0,
      "bbox_min": [
        496.0,
        990.0,
        -60.0
      ],
      "bbox_max": [
        500.0,
        996.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -996.0,
      "bbox_min": [
        496.0,
        996.0,
        -60.0
      ],
      "bbox_max": [
        500.0,
        996.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 955.0,
      "bbox_min": [
        496.0,
        955.0,
        -60.0
      ],
      "bbox_max": [
        509.0,
        986.0,
        -44.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -958.0,
      "bbox_min": [
        496.0,
        955.0,
        -60.0
      ],
      "bbox_max": [
        509.0,
        986.0,
        -49.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -52.5,
      "bbox_min": [
        496.0,
        955.0,
        -58.0
      ],
      "bbox_max": [
        509.0,
        958.0,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -49.5,
      "bbox_min": [
        496.0,
        955.0,
        -52.0
      ],
      "bbox_max": [
        509.0,
        958.0,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 49.0,
      "bbox_min": [
        496.0,
        955.0,
        -49.0
      ],
      "bbox_max": [
        509.0,
        958.0,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 52.0,
      "bbox_min": [
        496.0,
        955.0,
        -52.0
      ],
      "bbox_max": [
        509.0,
        958.0,
        -52.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -55.5,
      "bbox_min": [
        496.0,
        955.0,
        -58.0
      ],
      "bbox_max": [
        509.0,
        958.0,
        -55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 55.0,
      "bbox_min": [
        496.0,
        955.0,
        -55.0
      ],
      "bbox_max": [
        509.0,
        958.0,
        -55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 58.0,
      "bbox_min": [
        496.0,
        955.0,
        -58.0
      ],
      "bbox_max": [
        509.0,
        958.0,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 983.0,
      "bbox_min": [
        496.0,
        983.0,
        -60.0
      ],
      "bbox_max": [
        509.0,
        986.0,
        -49.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -52.5,
      "bbox_min": [
        496.0,
        983.0,
        -58.0
      ],
      "bbox_max": [
        509.0,
        986.0,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -49.5,
      "bbox_min": [
        496.0,
        983.0,
        -52.0
      ],
      "bbox_max": [
        509.0,
        986.0,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 49.0,
      "bbox_min": [
        496.0,
        983.0,
        -49.0
      ],
      "bbox_max": [
        509.0,
        986.0,
        -49.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 52.0,
      "bbox_min": [
        496.0,
        983.0,
        -52.0
      ],
      "bbox_max": [
        509.0,
        986.0,
        -52.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -55.5,
      "bbox_min": [
        496.0,
        983.0,
        -58.0
      ],
      "bbox_max": [
        509.0,
        986.0,
        -55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 55.0,
      "bbox_min": [
        496.0,
        983.0,
        -55.0
      ],
      "bbox_max": [
        509.0,
        986.0,
        -55.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 58.0,
      "bbox_min": [
        496.0,
        983.0,
        -58.0
      ],
      "bbox_max": [
        509.0,
        986.0,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 906.0,
      "bbox_min": [
        454.1000061035156,
        840.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        925.0,
        -40.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 49.999996185302734,
      "bbox_min": [
        459.1000061035156,
        906.0,
        -60.0
      ],
      "bbox_max": [
        569.9999389648438,
        925.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -459.1000061035156,
      "bbox_min": [
        459.1000061035156,
        906.0,
        -60.0
      ],
      "bbox_max": [
        569.9999389648438,
        925.0,
        -49.999996185302734
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -908.0,
      "bbox_min": [
        459.1000061035156,
        906.0,
        -60.0
      ],
      "bbox_max": [
        569.9999389648438,
        922.98193359375,
        -49.999996185302734
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -495.0,
      "bbox_min": [
        495.0,
        906.0,
        -60.0
      ],
      "bbox_max": [
        563.5,
        908.0,
        -49.999996185302734
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 56.5,
      "bbox_min": [
        514.0,
        906.0,
        -60.0
      ],
      "bbox_max": [
        563.5,
        908.0,
        -51.20000076293945
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -560.5,
      "bbox_min": [
        560.5,
        906.0,
        -57.0
      ],
      "bbox_max": [
        560.5,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14834009110927582,
        0.0,
        0.9889364838600159
      ],
      "plane_d": 139.21731567382812,
      "bbox_min": [
        556.5,
        906.0,
        -57.29999923706055
      ],
      "bbox_max": [
        558.5,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -556.5,
      "bbox_min": [
        556.5,
        906.0,
        -57.29999923706055
      ],
      "bbox_max": [
        556.5,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -543.0,
      "bbox_min": [
        536.0,
        906.0,
        -60.0
      ],
      "bbox_max": [
        543.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.0,
      "bbox_min": [
        536.0,
        906.0,
        -57.29999923706055
      ],
      "bbox_max": [
        542.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14834009110927582,
        0.0,
        0.9889364838600159
      ],
      "plane_d": -23.734272003173828,
      "bbox_min": [
        540.0,
        906.0,
        -57.29999923706055
      ],
      "bbox_max": [
        542.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 542.0,
      "bbox_min": [
        540.0,
        906.0,
        -57.29999923706055
      ],
      "bbox_max": [
        542.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -540.0,
      "bbox_min": [
        540.0,
        906.0,
        -57.0
      ],
      "bbox_max": [
        540.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14834009110927582,
        0.0,
        0.9889364838600159
      ],
      "plane_d": 136.17636108398438,
      "bbox_min": [
        536.0,
        906.0,
        -57.29999923706055
      ],
      "bbox_max": [
        538.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -536.0,
      "bbox_min": [
        536.0,
        906.0,
        -57.29999923706055
      ],
      "bbox_max": [
        536.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 514.0,
      "bbox_min": [
        514.0,
        906.0,
        -60.0
      ],
      "bbox_max": [
        522.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -522.0,
      "bbox_min": [
        515.0,
        906.0,
        -60.0
      ],
      "bbox_max": [
        522.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 517.0,
      "bbox_min": [
        515.0,
        906.0,
        -57.29999923706055
      ],
      "bbox_max": [
        521.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14834009110927582,
        0.0,
        0.9889364838600159
      ],
      "plane_d": -20.619129180908203,
      "bbox_min": [
        519.0,
        906.0,
        -57.29999923706055
      ],
      "bbox_max": [
        521.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 521.0,
      "bbox_min": [
        519.0,
        906.0,
        -57.29999923706055
      ],
      "bbox_max": [
        521.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -519.0,
      "bbox_min": [
        519.0,
        906.0,
        -57.0
      ],
      "bbox_max": [
        519.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14834009110927582,
        0.0,
        0.9889364838600159
      ],
      "plane_d": 133.06121826171875,
      "bbox_min": [
        515.0,
        906.0,
        -57.29999923706055
      ],
      "bbox_max": [
        517.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -515.0,
      "bbox_min": [
        515.0,
        906.0,
        -57.29999923706055
      ],
      "bbox_max": [
        515.0,
        908.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -52.20000076293945,
      "bbox_min": [
        514.0,
        906.0,
        -54.0
      ],
      "bbox_max": [
        563.5,
        908.0,
        -51.20000076293945
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 51.20000076293945,
      "bbox_min": [
        517.0,
        906.0,
        -52.20000076293945
      ],
      "bbox_max": [
        560.5,
        908.0,
        -51.20000076293945
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.0,
      "bbox_min": [
        517.0,
        906.0,
        -52.20000076293945
      ],
      "bbox_max": [
        560.5,
        908.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 558.5,
      "bbox_min": [
        540.0,
        906.0,
        -52.20000076293945
      ],
      "bbox_max": [
        560.5,
        908.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -560.5,
      "bbox_min": [
        560.5,
        906.0,
        -52.20000076293945
      ],
      "bbox_max": [
        560.5,
        908.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -540.0,
      "bbox_min": [
        540.0,
        906.0,
        -52.20000076293945
      ],
      "bbox_max": [
        540.0,
        908.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 517.0,
      "bbox_min": [
        517.0,
        906.0,
        -52.20000076293945
      ],
      "bbox_max": [
        519.0,
        908.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -519.0,
      "bbox_min": [
        519.0,
        906.0,
        -52.20000076293945
      ],
      "bbox_max": [
        519.0,
        908.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144956111907959,
        0.0,
        0.857492983341217
      ],
      "plane_d": 332.10693359375,
      "bbox_min": [
        514.0,
        908.0,
        -60.0
      ],
      "bbox_max": [
        569.9999389648438,
        922.98193359375,
        -52.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": 29.513671875,
      "bbox_min": [
        565.9999389648438,
        919.51806640625,
        -60.0
      ],
      "bbox_max": [
        569.9999389648438,
        922.98193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        -0.5000253915786743,
        -0.0
      ],
      "plane_d": 950.8104248046875,
      "bbox_min": [
        565.9999389648438,
        919.51806640625,
        -60.0
      ],
      "bbox_max": [
        569.9999389648438,
        922.98193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -954.2745361328125,
      "bbox_min": [
        565.9999389648438,
        919.51806640625,
        -60.0
      ],
      "bbox_max": [
        569.9999389648438,
        922.98193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": -32.977691650390625,
      "bbox_min": [
        565.9999389648438,
        919.51806640625,
        -60.0
      ],
      "bbox_max": [
        569.9999389648438,
        922.98193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 56.0,
      "bbox_min": [
        565.9999389648438,
        919.51806640625,
        -60.0
      ],
      "bbox_max": [
        569.9999389648438,
        922.98193359375,
        -56.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 922.73193359375,
      "bbox_min": [
        566.2885131835938,
        919.76806640625,
        -60.0
      ],
      "bbox_max": [
        569.7113647460938,
        922.73193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -919.76806640625,
      "bbox_min": [
        566.2885131835938,
        919.76806640625,
        -60.0
      ],
      "bbox_max": [
        569.7113647460938,
        922.73193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659955263137817,
        -0.5000517964363098,
        -0.0
      ],
      "plane_d": 954.0402221679688,
      "bbox_min": [
        566.2885131835938,
        919.76806640625,
        -60.0
      ],
      "bbox_max": [
        569.7113647460938,
        922.73193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659955263137817,
        0.5000517964363098,
        0.0
      ],
      "plane_d": 32.69476318359375,
      "bbox_min": [
        566.2885131835938,
        919.76806640625,
        -60.0
      ],
      "bbox_max": [
        569.7113647460938,
        922.73193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659955263137817,
        0.5000517964363098,
        0.0
      ],
      "plane_d": -951.0760498046875,
      "bbox_min": [
        566.2885131835938,
        919.76806640625,
        -60.0
      ],
      "bbox_max": [
        567.1442260742188,
        922.73193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659955263137817,
        -0.5000517964363098,
        0.0
      ],
      "plane_d": -29.7305908203125,
      "bbox_min": [
        566.2885131835938,
        921.25,
        -60.0
      ],
      "bbox_max": [
        567.1442260742188,
        922.73193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5144956111907959,
        0.857492983341217
      ],
      "plane_d": -422.40087890625,
      "bbox_min": [
        555.5,
        908.0,
        -60.0
      ],
      "bbox_max": [
        563.5,
        911.0,
        -52.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 56.5,
      "bbox_min": [
        555.5,
        908.0,
        -60.0
      ],
      "bbox_max": [
        563.5,
        911.0,
        -52.20000076293945
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -563.5,
      "bbox_min": [
        563.5,
        908.0,
        -60.0
      ],
      "bbox_max": [
        563.5,
        910.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144956111907959,
        0.0,
        -0.857492983341217
      ],
      "plane_d": 243.6136474609375,
      "bbox_min": [
        560.5,
        908.0,
        -54.0
      ],
      "bbox_max": [
        563.5,
        911.0,
        -52.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.5144956111907959,
        0.857492983341217
      ],
      "plane_d": -422.40087890625,
      "bbox_min": [
        514.0,
        908.0,
        -60.0
      ],
      "bbox_max": [
        543.0,
        911.0,
        -52.20000076293945
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 56.5,
      "bbox_min": [
        514.0,
        908.0,
        -60.0
      ],
      "bbox_max": [
        543.0,
        911.0,
        -52.20000076293945
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        514.0,
        908.0,
        -60.0
      ],
      "bbox_max": [
        543.0,
        910.0,
        -56.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        514.0,
        908.0,
        -60.0
      ],
      "bbox_max": [
        543.0,
        910.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -543.0,
      "bbox_min": [
        543.0,
        908.0,
        -60.0
      ],
      "bbox_max": [
        543.0,
        910.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 514.0,
      "bbox_min": [
        514.0,
        908.0,
        -60.0
      ],
      "bbox_max": [
        522.0,
        910.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -522.0,
      "bbox_min": [
        522.0,
        908.0,
        -60.0
      ],
      "bbox_max": [
        522.0,
        910.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -459.1000061035156,
      "bbox_min": [
        459.1000061035156,
        906.0,
        -49.999996185302734
      ],
      "bbox_max": [
        459.1000061035156,
        925.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -56.0,
      "bbox_min": [
        455.1000061035156,
        841.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        906.0,
        -55.5
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -876.0,
      "bbox_min": [
        455.1000061035156,
        841.0,
        -56.0
      ],
      "bbox_max": [
        571.5,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 866.0,
      "bbox_min": [
        455.1000061035156,
        841.0,
        -56.0
      ],
      "bbox_max": [
        571.5,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 522.0,
      "bbox_min": [
        455.1000061035156,
        866.0,
        -56.0
      ],
      "bbox_max": [
        554.0,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -554.0,
      "bbox_min": [
        554.0,
        866.0,
        -56.0
      ],
      "bbox_max": [
        554.0,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -455.1000061035156,
      "bbox_min": [
        455.1000061035156,
        866.0,
        -56.0
      ],
      "bbox_max": [
        508.0,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -784.1546630859375,
      "bbox_min": [
        455.1000061035156,
        866.0,
        -56.0
      ],
      "bbox_max": [
        508.0,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -936.350830078125,
      "bbox_min": [
        455.1000061035156,
        866.0,
        -56.0
      ],
      "bbox_max": [
        488.0,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        -0.0
      ],
      "plane_d": 984.9149169921875,
      "bbox_min": [
        458.1000061035156,
        866.0,
        -56.0
      ],
      "bbox_max": [
        488.0,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": -55.905696868896484,
      "bbox_min": [
        478.0,
        866.0,
        -56.0
      ],
      "bbox_max": [
        488.0,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -994.1537475585938,
      "bbox_min": [
        478.0,
        866.0,
        -55.90570068359375
      ],
      "bbox_max": [
        488.0,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -624.4888916015625,
      "bbox_min": [
        478.0,
        866.0,
        -55.90570068359375
      ],
      "bbox_max": [
        488.0,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 615.2501220703125,
      "bbox_min": [
        478.0,
        866.0,
        -55.90570068359375
      ],
      "bbox_max": [
        488.0,
        874.5355224609375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": 108.32241821289062,
      "bbox_min": [
        478.0,
        867.4644775390625,
        -55.90570068359375
      ],
      "bbox_max": [
        488.0,
        874.5355224609375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        -0.0
      ],
      "plane_d": 774.915771484375,
      "bbox_min": [
        478.0,
        867.4644775390625,
        -55.90570068359375
      ],
      "bbox_max": [
        488.0,
        871.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": -117.561279296875,
      "bbox_min": [
        486.53564453125,
        867.4644775390625,
        -55.90570068359375
      ],
      "bbox_max": [
        488.0,
        871.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 482.75,
      "bbox_min": [
        482.75,
        870.75,
        -56.0
      ],
      "bbox_max": [
        483.25,
        871.25,
        -55.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -871.25,
      "bbox_min": [
        482.75,
        870.75,
        -56.0
      ],
      "bbox_max": [
        483.25,
        871.25,
        -55.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -483.25,
      "bbox_min": [
        482.75,
        870.75,
        -56.0
      ],
      "bbox_max": [
        483.25,
        871.25,
        -55.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.75,
      "bbox_min": [
        482.75,
        870.75,
        -56.0
      ],
      "bbox_max": [
        483.25,
        870.75,
        -55.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.3563368156610522e-05,
        1.0,
        -0.0
      ],
      "plane_d": -866.1062622070312,
      "bbox_min": [
        458.1000061035156,
        866.0,
        -56.0
      ],
      "bbox_max": [
        462.6000061035156,
        866.1000366210938,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -462.6000061035156,
      "bbox_min": [
        462.6000061035156,
        866.0,
        -56.0
      ],
      "bbox_max": [
        462.6000061035156,
        866.0999755859375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": -55.905696868896484,
      "bbox_min": [
        498.0,
        866.0,
        -56.0
      ],
      "bbox_max": [
        508.0,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -1001.8072509765625,
      "bbox_min": [
        498.0,
        866.0,
        -55.90570068359375
      ],
      "bbox_max": [
        508.0,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -616.8353271484375,
      "bbox_min": [
        498.0,
        866.0,
        -55.90570068359375
      ],
      "bbox_max": [
        508.0,
        876.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        -0.0
      ],
      "plane_d": 992.5684204101562,
      "bbox_min": [
        498.0,
        866.0,
        -55.90570068359375
      ],
      "bbox_max": [
        508.0,
        874.5355224609375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 607.5965576171875,
      "bbox_min": [
        498.0,
        866.0,
        -55.90570068359375
      ],
      "bbox_max": [
        508.0,
        874.5355224609375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -802.6324462890625,
      "bbox_min": [
        498.0,
        867.4644775390625,
        -55.90570068359375
      ],
      "bbox_max": [
        508.0,
        874.5355224609375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": 126.80020141601562,
      "bbox_min": [
        498.0,
        867.4644775390625,
        -55.90570068359375
      ],
      "bbox_max": [
        508.0,
        874.5355224609375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        -0.0
      ],
      "plane_d": 793.3935546875,
      "bbox_min": [
        498.0,
        867.4644775390625,
        -55.90570068359375
      ],
      "bbox_max": [
        508.0,
        871.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": -136.0390625,
      "bbox_min": [
        506.53564453125,
        867.4644775390625,
        -55.90570068359375
      ],
      "bbox_max": [
        508.0,
        871.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 502.75,
      "bbox_min": [
        502.75,
        870.75,
        -56.0
      ],
      "bbox_max": [
        503.25,
        871.25,
        -55.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -871.25,
      "bbox_min": [
        502.75,
        870.75,
        -56.0
      ],
      "bbox_max": [
        503.25,
        871.25,
        -55.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -503.25,
      "bbox_min": [
        502.75,
        870.75,
        -56.0
      ],
      "bbox_max": [
        503.25,
        871.25,
        -55.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.75,
      "bbox_min": [
        502.75,
        870.75,
        -56.0
      ],
      "bbox_max": [
        503.25,
        870.75,
        -55.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        459.1000061035156,
        841.0,
        -56.0
      ],
      "bbox_max": [
        571.5,
        866.0,
        -55.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -841.0,
      "bbox_min": [
        487.6000061035156,
        841.0,
        -56.0
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -55.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -235.74942016601562,
      "bbox_min": [
        487.6000061035156,
        841.0,
        -56.0
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -966.3321533203125,
      "bbox_min": [
        522.5999755859375,
        841.0,
        -56.0
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -211.00070190429688,
      "bbox_min": [
        522.5999755859375,
        841.0,
        -56.0
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 545.5999755859375,
      "bbox_min": [
        522.5999755859375,
        844.0,
        -56.0
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -522.5999755859375,
      "bbox_min": [
        522.5999755859375,
        844.0,
        -56.0
      ],
      "bbox_max": [
        522.5999755859375,
        845.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -941.58349609375,
      "bbox_min": [
        487.6000061035156,
        841.0,
        -56.0
      ],
      "bbox_max": [
        510.6000061035156,
        845.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 510.6000061035156,
      "bbox_min": [
        487.6000061035156,
        844.0,
        -56.0
      ],
      "bbox_max": [
        510.6000061035156,
        845.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -487.6000061035156,
      "bbox_min": [
        487.6000061035156,
        844.0,
        -56.0
      ],
      "bbox_max": [
        487.6000061035156,
        845.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -459.1000061035156,
      "bbox_min": [
        459.1000061035156,
        845.0,
        -56.0
      ],
      "bbox_max": [
        571.5,
        866.0,
        -55.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 567.0,
      "bbox_min": [
        459.1000061035156,
        845.0,
        -56.0
      ],
      "bbox_max": [
        571.5,
        866.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -855.0,
      "bbox_min": [
        567.0,
        855.0,
        -56.0
      ],
      "bbox_max": [
        571.5,
        855.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        459.1000061035156,
        845.0,
        -56.0
      ],
      "bbox_max": [
        551.5999755859375,
        866.0,
        -55.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 510.6000061035156,
      "bbox_min": [
        481.6000061035156,
        845.0,
        -56.0
      ],
      "bbox_max": [
        551.5999755859375,
        850.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 545.5999755859375,
      "bbox_min": [
        522.5999755859375,
        845.0,
        -56.0
      ],
      "bbox_max": [
        551.5999755859375,
        850.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -551.5999755859375,
      "bbox_min": [
        551.5999755859375,
        845.0,
        -56.0
      ],
      "bbox_max": [
        551.5999755859375,
        850.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -522.5999755859375,
      "bbox_min": [
        522.5999755859375,
        845.0,
        -56.0
      ],
      "bbox_max": [
        522.5999755859375,
        850.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 481.6000061035156,
      "bbox_min": [
        481.6000061035156,
        845.0,
        -56.0
      ],
      "bbox_max": [
        487.6000061035156,
        850.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -487.6000061035156,
      "bbox_min": [
        487.6000061035156,
        845.0,
        -56.0
      ],
      "bbox_max": [
        487.6000061035156,
        850.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -462.6000061035156,
      "bbox_min": [
        459.1000061035156,
        860.0999755859375,
        -56.0
      ],
      "bbox_max": [
        462.6000061035156,
        866.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 860.0999755859375,
      "bbox_min": [
        459.1000061035156,
        860.0999755859375,
        -56.0
      ],
      "bbox_max": [
        462.6000061035156,
        860.0999755859375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -455.1000061035156,
      "bbox_min": [
        455.1000061035156,
        876.0,
        -56.0
      ],
      "bbox_max": [
        559.75,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -459.1000061035156,
      "bbox_min": [
        455.1000061035156,
        886.1000366210938,
        -56.0
      ],
      "bbox_max": [
        559.75,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 304.7630920410156,
      "bbox_min": [
        455.1000061035156,
        886.1000366210938,
        -56.0
      ],
      "bbox_max": [
        459.1000061035156,
        889.1000366210938,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3563368156610522e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 889.1062622070312,
      "bbox_min": [
        458.1000061035156,
        889.1000366210938,
        -56.0
      ],
      "bbox_max": [
        459.1000061035156,
        889.1000366210938,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -462.6000061035156,
      "bbox_min": [
        459.1000061035156,
        887.0,
        -56.0
      ],
      "bbox_max": [
        559.75,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -895.0999755859375,
      "bbox_min": [
        459.1000061035156,
        889.0999755859375,
        -56.0
      ],
      "bbox_max": [
        462.6000061035156,
        895.0999755859375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3563368156610522e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 889.1062622070312,
      "bbox_min": [
        459.1000061035156,
        889.0999755859375,
        -56.0
      ],
      "bbox_max": [
        462.6000061035156,
        889.1000366210938,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 634.651611328125,
      "bbox_min": [
        478.0,
        887.0,
        -56.0
      ],
      "bbox_max": [
        559.75,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -1013.5552978515625,
      "bbox_min": [
        478.0,
        887.0,
        -56.0
      ],
      "bbox_max": [
        518.25,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": -55.905696868896484,
      "bbox_min": [
        478.0,
        887.0,
        -56.0
      ],
      "bbox_max": [
        488.0,
        897.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -643.8904418945312,
      "bbox_min": [
        478.0,
        887.0,
        -55.90570068359375
      ],
      "bbox_max": [
        488.0,
        897.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        -0.0
      ],
      "plane_d": 1004.31640625,
      "bbox_min": [
        478.0,
        887.0,
        -55.90570068359375
      ],
      "bbox_max": [
        488.0,
        895.5355224609375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -792.1905517578125,
      "bbox_min": [
        478.0,
        888.4644775390625,
        -55.90570068359375
      ],
      "bbox_max": [
        488.0,
        895.5355224609375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": 100.28656005859375,
      "bbox_min": [
        478.0,
        888.4644775390625,
        -55.90570068359375
      ],
      "bbox_max": [
        488.0,
        895.5355224609375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        -0.0
      ],
      "plane_d": 782.95166015625,
      "bbox_min": [
        478.0,
        888.4644775390625,
        -55.90570068359375
      ],
      "bbox_max": [
        488.0,
        892.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": -109.52545166015625,
      "bbox_min": [
        486.53564453125,
        888.4644775390625,
        -55.90570068359375
      ],
      "bbox_max": [
        488.0,
        892.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 482.75,
      "bbox_min": [
        482.75,
        891.75,
        -56.0
      ],
      "bbox_max": [
        483.25,
        892.25,
        -55.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -892.25,
      "bbox_min": [
        482.75,
        891.75,
        -56.0
      ],
      "bbox_max": [
        483.25,
        892.25,
        -55.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -483.25,
      "bbox_min": [
        482.75,
        891.75,
        -56.0
      ],
      "bbox_max": [
        483.25,
        892.25,
        -55.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 891.75,
      "bbox_min": [
        482.75,
        891.75,
        -56.0
      ],
      "bbox_max": [
        483.25,
        891.75,
        -55.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 517.75,
      "bbox_min": [
        517.75,
        905.5,
        -56.0
      ],
      "bbox_max": [
        518.25,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 905.5,
      "bbox_min": [
        517.75,
        905.5,
        -56.0
      ],
      "bbox_max": [
        518.25,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -518.25,
      "bbox_min": [
        518.25,
        905.5,
        -56.0
      ],
      "bbox_max": [
        518.25,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 899.75,
      "bbox_min": [
        517.75,
        894.0,
        -56.0
      ],
      "bbox_max": [
        559.75,
        906.0,
        -55.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.25,
      "bbox_min": [
        517.75,
        899.75,
        -56.0
      ],
      "bbox_max": [
        559.75,
        906.0,
        -55.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 538.75,
      "bbox_min": [
        517.75,
        899.75,
        -56.0
      ],
      "bbox_max": [
        559.75,
        900.25,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 559.25,
      "bbox_min": [
        539.25,
        899.75,
        -56.0
      ],
      "bbox_max": [
        559.75,
        900.25,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -559.75,
      "bbox_min": [
        559.75,
        899.75,
        -56.0
      ],
      "bbox_max": [
        559.75,
        900.25,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -539.25,
      "bbox_min": [
        539.25,
        899.75,
        -56.0
      ],
      "bbox_max": [
        539.25,
        900.25,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 517.75,
      "bbox_min": [
        517.75,
        899.75,
        -56.0
      ],
      "bbox_max": [
        518.25,
        900.25,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -518.25,
      "bbox_min": [
        518.25,
        899.75,
        -56.0
      ],
      "bbox_max": [
        518.25,
        900.25,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 559.25,
      "bbox_min": [
        538.75,
        905.5,
        -56.0
      ],
      "bbox_max": [
        559.75,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 905.5,
      "bbox_min": [
        559.25,
        905.5,
        -56.0
      ],
      "bbox_max": [
        559.75,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -559.75,
      "bbox_min": [
        559.75,
        905.5,
        -56.0
      ],
      "bbox_max": [
        559.75,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.75,
      "bbox_min": [
        538.75,
        905.5,
        -56.0
      ],
      "bbox_max": [
        539.25,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 905.5,
      "bbox_min": [
        538.75,
        905.5,
        -56.0
      ],
      "bbox_max": [
        539.25,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -539.25,
      "bbox_min": [
        539.25,
        905.5,
        -56.0
      ],
      "bbox_max": [
        539.25,
        906.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 538.75,
      "bbox_min": [
        517.75,
        894.0,
        -56.0
      ],
      "bbox_max": [
        559.75,
        894.5,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 559.25,
      "bbox_min": [
        538.75,
        894.0,
        -56.0
      ],
      "bbox_max": [
        559.75,
        894.5,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -894.5,
      "bbox_min": [
        559.25,
        894.0,
        -56.0
      ],
      "bbox_max": [
        559.75,
        894.5,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -559.75,
      "bbox_min": [
        559.25,
        894.0,
        -56.0
      ],
      "bbox_max": [
        559.75,
        894.5,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 894.0,
      "bbox_min": [
        559.25,
        894.0,
        -56.0
      ],
      "bbox_max": [
        559.75,
        894.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -894.5,
      "bbox_min": [
        538.75,
        894.0,
        -56.0
      ],
      "bbox_max": [
        539.25,
        894.5,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -539.25,
      "bbox_min": [
        538.75,
        894.0,
        -56.0
      ],
      "bbox_max": [
        539.25,
        894.5,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 894.0,
      "bbox_min": [
        538.75,
        894.0,
        -56.0
      ],
      "bbox_max": [
        539.25,
        894.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 517.75,
      "bbox_min": [
        517.75,
        894.0,
        -56.0
      ],
      "bbox_max": [
        518.25,
        894.5,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -894.5,
      "bbox_min": [
        517.75,
        894.0,
        -56.0
      ],
      "bbox_max": [
        518.25,
        894.5,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -518.25,
      "bbox_min": [
        517.75,
        894.0,
        -56.0
      ],
      "bbox_max": [
        518.25,
        894.5,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 894.0,
      "bbox_min": [
        517.75,
        894.0,
        -56.0
      ],
      "bbox_max": [
        518.25,
        894.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        455.1000061035156,
        841.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        906.0,
        -56.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 58.0,
      "bbox_min": [
        487.6000061035156,
        841.0,
        -60.0
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -56.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -843.0,
      "bbox_min": [
        489.6000061035156,
        843.0,
        -60.0
      ],
      "bbox_max": [
        543.5999755859375,
        845.0,
        -58.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -237.16360473632812,
      "bbox_min": [
        489.6000061035156,
        843.0,
        -60.0
      ],
      "bbox_max": [
        543.5999755859375,
        845.0,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -967.746337890625,
      "bbox_min": [
        524.5999755859375,
        843.0,
        -60.0
      ],
      "bbox_max": [
        543.5999755859375,
        845.0,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -212.4149169921875,
      "bbox_min": [
        524.5999755859375,
        843.0,
        -60.0
      ],
      "bbox_max": [
        543.5999755859375,
        845.0,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 543.5999755859375,
      "bbox_min": [
        524.5999755859375,
        844.0,
        -60.0
      ],
      "bbox_max": [
        543.5999755859375,
        845.0,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -524.5999755859375,
      "bbox_min": [
        524.5999755859375,
        844.0,
        -60.0
      ],
      "bbox_max": [
        524.5999755859375,
        845.0,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -942.9976806640625,
      "bbox_min": [
        489.6000061035156,
        843.0,
        -60.0
      ],
      "bbox_max": [
        508.6000061035156,
        845.0,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 508.6000061035156,
      "bbox_min": [
        489.6000061035156,
        844.0,
        -60.0
      ],
      "bbox_max": [
        508.6000061035156,
        845.0,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -489.6000061035156,
      "bbox_min": [
        489.6000061035156,
        844.0,
        -60.0
      ],
      "bbox_max": [
        489.6000061035156,
        845.0,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -841.0,
      "bbox_min": [
        487.6000061035156,
        841.0,
        -58.0
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -56.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 843.0,
      "bbox_min": [
        487.6000061035156,
        841.0,
        -58.0
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -235.74942016601562,
      "bbox_min": [
        487.6000061035156,
        843.0,
        -58.0
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 524.5999755859375,
      "bbox_min": [
        522.5999755859375,
        843.0,
        -56.5
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -211.00070190429688,
      "bbox_min": [
        543.5999755859375,
        843.0,
        -56.5
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 545.5999755859375,
      "bbox_min": [
        543.5999755859375,
        844.0,
        -56.5
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -543.5999755859375,
      "bbox_min": [
        543.5999755859375,
        844.0,
        -56.5
      ],
      "bbox_max": [
        543.5999755859375,
        845.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -966.3321533203125,
      "bbox_min": [
        522.5999755859375,
        843.0,
        -56.5
      ],
      "bbox_max": [
        523.5999755859375,
        845.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -522.5999755859375,
      "bbox_min": [
        522.5999755859375,
        844.0,
        -56.5
      ],
      "bbox_max": [
        522.5999755859375,
        845.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -522.5999755859375,
      "bbox_min": [
        522.5999755859375,
        844.0,
        -58.0
      ],
      "bbox_max": [
        522.5999755859375,
        845.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 510.6000061035156,
      "bbox_min": [
        508.6000061035156,
        844.0,
        -56.5
      ],
      "bbox_max": [
        510.6000061035156,
        845.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -508.6000061035156,
      "bbox_min": [
        508.6000061035156,
        844.0,
        -56.5
      ],
      "bbox_max": [
        508.6000061035156,
        845.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -941.58349609375,
      "bbox_min": [
        487.6000061035156,
        843.0,
        -56.5
      ],
      "bbox_max": [
        488.6000061035156,
        845.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -487.6000061035156,
      "bbox_min": [
        487.6000061035156,
        844.0,
        -56.5
      ],
      "bbox_max": [
        487.6000061035156,
        845.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 510.6000061035156,
      "bbox_min": [
        487.6000061035156,
        844.0,
        -58.0
      ],
      "bbox_max": [
        510.6000061035156,
        845.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -941.58349609375,
      "bbox_min": [
        488.6000061035156,
        841.0,
        -58.0
      ],
      "bbox_max": [
        490.6000061035156,
        843.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": -56.499996185302734,
      "bbox_min": [
        455.1000061035156,
        845.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        906.0,
        -56.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -455.1000061035156,
      "bbox_min": [
        455.1000061035156,
        845.0,
        -56.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 457.1000061035156,
      "bbox_min": [
        455.1000061035156,
        845.0,
        -56.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -462.6000061035156,
      "bbox_min": [
        457.1000061035156,
        845.0,
        -56.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -56.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -459.1000061035156,
      "bbox_min": [
        457.1000061035156,
        845.0,
        -56.5
      ],
      "bbox_max": [
        462.6000061035156,
        906.0,
        -56.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 937.76513671875,
      "bbox_min": [
        457.1000061035156,
        866.1000366210938,
        -56.5
      ],
      "bbox_max": [
        459.1000061035156,
        889.1000366210938,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.3563368156610522e-05,
        1.0,
        0.0
      ],
      "plane_d": -887.1062622070312,
      "bbox_min": [
        457.1000061035156,
        868.1000366210938,
        -56.5
      ],
      "bbox_max": [
        459.1000061035156,
        889.1000366210938,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3563368156610522e-05,
        -1.0,
        0.0
      ],
      "plane_d": 868.1062622070312,
      "bbox_min": [
        458.1000061035156,
        868.1000366210938,
        -56.5
      ],
      "bbox_max": [
        459.1000061035156,
        868.1000366210938,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 304.7630920410156,
      "bbox_min": [
        457.1000061035156,
        888.1000366210938,
        -56.5
      ],
      "bbox_max": [
        459.1000061035156,
        889.1000366210938,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3563368156610522e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 889.1062622070312,
      "bbox_min": [
        458.1000061035156,
        889.1000366210938,
        -56.5
      ],
      "bbox_max": [
        459.1000061035156,
        889.1000366210938,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -936.350830078125,
      "bbox_min": [
        457.1000061035156,
        866.1000366210938,
        -56.5
      ],
      "bbox_max": [
        459.1000061035156,
        867.1000366210938,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.3563368156610522e-05,
        1.0,
        -0.0
      ],
      "plane_d": -866.1062622070312,
      "bbox_min": [
        458.1000061035156,
        866.1000366210938,
        -56.5
      ],
      "bbox_max": [
        459.1000061035156,
        866.1000366210938,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 860.0999755859375,
      "bbox_min": [
        459.1000061035156,
        847.01806640625,
        -56.5
      ],
      "bbox_max": [
        462.6000061035156,
        895.0999755859375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.3563368156610522e-05,
        1.0,
        0.0
      ],
      "plane_d": -887.1062622070312,
      "bbox_min": [
        459.1000061035156,
        866.0999755859375,
        -56.5
      ],
      "bbox_max": [
        462.6000061035156,
        895.0999755859375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.3563368156610522e-05,
        1.0,
        -0.0
      ],
      "plane_d": -866.1062622070312,
      "bbox_min": [
        459.1000061035156,
        866.0999755859375,
        -56.5
      ],
      "bbox_max": [
        462.6000061035156,
        868.1000366210938,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3563368156610522e-05,
        -1.0,
        0.0
      ],
      "plane_d": 868.1062622070312,
      "bbox_min": [
        459.1000061035156,
        868.0999755859375,
        -56.5
      ],
      "bbox_max": [
        462.6000061035156,
        868.1000366210938,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -895.0999755859375,
      "bbox_min": [
        459.1000061035156,
        889.0999755859375,
        -56.5
      ],
      "bbox_max": [
        462.6000061035156,
        895.0999755859375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3563368156610522e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 889.1062622070312,
      "bbox_min": [
        459.1000061035156,
        889.0999755859375,
        -56.5
      ],
      "bbox_max": [
        462.6000061035156,
        889.1000366210938,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -24.992401123046875,
      "bbox_min": [
        461.1999816894531,
        847.01806640625,
        -56.5
      ],
      "bbox_max": [
        462.6000061035156,
        850.48193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        -0.5000253915786743,
        -0.0
      ],
      "plane_d": 823.8006591796875,
      "bbox_min": [
        461.1999816894531,
        847.01806640625,
        -56.5
      ],
      "bbox_max": [
        462.6000061035156,
        850.48193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659955263137817,
        0.5000517964363098,
        0.0
      ],
      "plane_d": -824.0659790039062,
      "bbox_min": [
        461.4885559082031,
        847.26806640625,
        -56.5
      ],
      "bbox_max": [
        462.6000061035156,
        850.48193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.48193359375,
      "bbox_min": [
        462.1999816894531,
        850.48193359375,
        -56.5
      ],
      "bbox_max": [
        462.6000061035156,
        850.48193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659955263137817,
        -0.5000517964363098,
        0.0
      ],
      "plane_d": 24.771942138671875,
      "bbox_min": [
        461.4885559082031,
        848.75,
        -56.5
      ],
      "bbox_max": [
        462.3442687988281,
        850.23193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        462.6000061035156,
        845.0,
        -56.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -56.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 489.6000061035156,
      "bbox_min": [
        462.6000061035156,
        845.0,
        -56.5
      ],
      "bbox_max": [
        567.0,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 524.5999755859375,
      "bbox_min": [
        508.6000061035156,
        845.0,
        -56.5
      ],
      "bbox_max": [
        567.0,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 545.5999755859375,
      "bbox_min": [
        543.5999755859375,
        845.0,
        -56.5
      ],
      "bbox_max": [
        567.0,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -551.5999755859375,
      "bbox_min": [
        551.5999755859375,
        845.0,
        -56.5
      ],
      "bbox_max": [
        567.0,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 567.0,
      "bbox_min": [
        567.0,
        845.0,
        -56.5
      ],
      "bbox_max": [
        567.0,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -543.5999755859375,
      "bbox_min": [
        543.5999755859375,
        845.0,
        -56.5
      ],
      "bbox_max": [
        543.5999755859375,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 510.6000061035156,
      "bbox_min": [
        508.6000061035156,
        845.0,
        -56.5
      ],
      "bbox_max": [
        522.5999755859375,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -522.5999755859375,
      "bbox_min": [
        522.5999755859375,
        845.0,
        -56.5
      ],
      "bbox_max": [
        522.5999755859375,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -508.6000061035156,
      "bbox_min": [
        508.6000061035156,
        845.0,
        -56.5
      ],
      "bbox_max": [
        508.6000061035156,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 481.6000061035156,
      "bbox_min": [
        462.6000061035156,
        845.0,
        -56.5
      ],
      "bbox_max": [
        487.6000061035156,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -487.6000061035156,
      "bbox_min": [
        487.6000061035156,
        845.0,
        -56.5
      ],
      "bbox_max": [
        487.6000061035156,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": 21.528350830078125,
      "bbox_min": [
        462.6000061035156,
        847.01806640625,
        -56.5
      ],
      "bbox_max": [
        465.1999816894531,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -847.26806640625,
      "bbox_min": [
        462.6000061035156,
        847.01806640625,
        -56.5
      ],
      "bbox_max": [
        465.1999816894531,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -827.2647705078125,
      "bbox_min": [
        464.4782409667969,
        848.75,
        -56.5
      ],
      "bbox_max": [
        465.1999816894531,
        850.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -872.0,
      "bbox_min": [
        462.6000061035156,
        850.0,
        -56.5
      ],
      "bbox_max": [
        525.0,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -483.25,
      "bbox_min": [
        462.6000061035156,
        850.0,
        -56.5
      ],
      "bbox_max": [
        525.0,
        872.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659955263137817,
        -0.5000517964363098,
        -0.0
      ],
      "plane_d": 827.0301513671875,
      "bbox_min": [
        462.6000061035156,
        850.0,
        -56.5
      ],
      "bbox_max": [
        464.4782409667969,
        850.48193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -827.2647705078125,
      "bbox_min": [
        464.1999816894531,
        850.0,
        -56.5
      ],
      "bbox_max": [
        464.4782409667969,
        850.48193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 850.23193359375,
      "bbox_min": [
        462.6000061035156,
        850.23193359375,
        -56.5
      ],
      "bbox_max": [
        464.0556945800781,
        850.23193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -871.25,
      "bbox_min": [
        482.75,
        870.75,
        -56.5
      ],
      "bbox_max": [
        483.25,
        871.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.75,
      "bbox_min": [
        482.75,
        870.75,
        -56.5
      ],
      "bbox_max": [
        483.25,
        870.75,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.0,
      "bbox_min": [
        502.75,
        870.2000122070312,
        -56.5
      ],
      "bbox_max": [
        525.0,
        872.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.2000122070312,
      "bbox_min": [
        524.0,
        870.2000122070312,
        -56.5
      ],
      "bbox_max": [
        525.0,
        870.2000122070312,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 502.75,
      "bbox_min": [
        502.75,
        870.75,
        -56.5
      ],
      "bbox_max": [
        503.25,
        871.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -871.25,
      "bbox_min": [
        502.75,
        870.75,
        -56.5
      ],
      "bbox_max": [
        503.25,
        871.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -503.25,
      "bbox_min": [
        502.75,
        870.75,
        -56.5
      ],
      "bbox_max": [
        503.25,
        871.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.75,
      "bbox_min": [
        502.75,
        870.75,
        -56.5
      ],
      "bbox_max": [
        503.25,
        870.75,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -894.5,
      "bbox_min": [
        482.75,
        891.75,
        -56.5
      ],
      "bbox_max": [
        518.25,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -892.25,
      "bbox_min": [
        482.75,
        891.75,
        -56.5
      ],
      "bbox_max": [
        518.25,
        894.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 482.75,
      "bbox_min": [
        482.75,
        891.75,
        -56.5
      ],
      "bbox_max": [
        483.25,
        892.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -483.25,
      "bbox_min": [
        482.75,
        891.75,
        -56.5
      ],
      "bbox_max": [
        483.25,
        892.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 891.75,
      "bbox_min": [
        482.75,
        891.75,
        -56.5
      ],
      "bbox_max": [
        483.25,
        891.75,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 517.75,
      "bbox_min": [
        517.75,
        894.0,
        -56.5
      ],
      "bbox_max": [
        518.25,
        894.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -518.25,
      "bbox_min": [
        517.75,
        894.0,
        -56.5
      ],
      "bbox_max": [
        518.25,
        894.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 894.0,
      "bbox_min": [
        517.75,
        894.0,
        -56.5
      ],
      "bbox_max": [
        518.25,
        894.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.25,
      "bbox_min": [
        517.75,
        899.75,
        -56.5
      ],
      "bbox_max": [
        518.25,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 517.75,
      "bbox_min": [
        517.75,
        899.75,
        -56.5
      ],
      "bbox_max": [
        518.25,
        900.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -518.25,
      "bbox_min": [
        517.75,
        899.75,
        -56.5
      ],
      "bbox_max": [
        518.25,
        900.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 899.75,
      "bbox_min": [
        517.75,
        899.75,
        -56.5
      ],
      "bbox_max": [
        518.25,
        899.75,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 517.75,
      "bbox_min": [
        517.75,
        905.5,
        -56.5
      ],
      "bbox_max": [
        518.25,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 905.5,
      "bbox_min": [
        517.75,
        905.5,
        -56.5
      ],
      "bbox_max": [
        518.25,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -518.25,
      "bbox_min": [
        518.25,
        905.5,
        -56.5
      ],
      "bbox_max": [
        518.25,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 567.0,
      "bbox_min": [
        538.75,
        850.0,
        -56.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -855.0,
      "bbox_min": [
        567.0,
        855.0,
        -56.5
      ],
      "bbox_max": [
        571.5,
        855.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 551.0,
      "bbox_min": [
        538.75,
        870.2000122070312,
        -56.5
      ],
      "bbox_max": [
        559.75,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -894.5,
      "bbox_min": [
        551.0,
        870.2000122070312,
        -56.5
      ],
      "bbox_max": [
        559.75,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -552.0,
      "bbox_min": [
        551.0,
        870.2000122070312,
        -56.5
      ],
      "bbox_max": [
        559.75,
        894.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -872.0,
      "bbox_min": [
        551.0,
        870.2000122070312,
        -56.5
      ],
      "bbox_max": [
        552.0,
        872.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.2000122070312,
      "bbox_min": [
        551.0,
        870.2000122070312,
        -56.5
      ],
      "bbox_max": [
        552.0,
        870.2000122070312,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 559.25,
      "bbox_min": [
        559.25,
        894.0,
        -56.5
      ],
      "bbox_max": [
        559.75,
        894.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -559.75,
      "bbox_min": [
        559.25,
        894.0,
        -56.5
      ],
      "bbox_max": [
        559.75,
        894.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 894.0,
      "bbox_min": [
        559.25,
        894.0,
        -56.5
      ],
      "bbox_max": [
        559.75,
        894.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.25,
      "bbox_min": [
        559.25,
        899.75,
        -56.5
      ],
      "bbox_max": [
        559.75,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 559.25,
      "bbox_min": [
        559.25,
        899.75,
        -56.5
      ],
      "bbox_max": [
        559.75,
        900.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 899.75,
      "bbox_min": [
        559.25,
        899.75,
        -56.5
      ],
      "bbox_max": [
        559.75,
        900.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -559.75,
      "bbox_min": [
        559.75,
        899.75,
        -56.5
      ],
      "bbox_max": [
        559.75,
        900.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 559.25,
      "bbox_min": [
        559.25,
        905.5,
        -56.5
      ],
      "bbox_max": [
        559.75,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 905.5,
      "bbox_min": [
        559.25,
        905.5,
        -56.5
      ],
      "bbox_max": [
        559.75,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -559.75,
      "bbox_min": [
        559.75,
        905.5,
        -56.5
      ],
      "bbox_max": [
        559.75,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 899.75,
      "bbox_min": [
        538.75,
        894.0,
        -56.5
      ],
      "bbox_max": [
        539.25,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.25,
      "bbox_min": [
        538.75,
        899.75,
        -56.5
      ],
      "bbox_max": [
        539.25,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 538.75,
      "bbox_min": [
        538.75,
        899.75,
        -56.5
      ],
      "bbox_max": [
        539.25,
        900.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -539.25,
      "bbox_min": [
        539.25,
        899.75,
        -56.5
      ],
      "bbox_max": [
        539.25,
        900.25,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.75,
      "bbox_min": [
        538.75,
        905.5,
        -56.5
      ],
      "bbox_max": [
        539.25,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 905.5,
      "bbox_min": [
        538.75,
        905.5,
        -56.5
      ],
      "bbox_max": [
        539.25,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -539.25,
      "bbox_min": [
        539.25,
        905.5,
        -56.5
      ],
      "bbox_max": [
        539.25,
        906.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 538.75,
      "bbox_min": [
        538.75,
        894.0,
        -56.5
      ],
      "bbox_max": [
        539.25,
        894.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -894.5,
      "bbox_min": [
        538.75,
        894.0,
        -56.5
      ],
      "bbox_max": [
        539.25,
        894.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -539.25,
      "bbox_min": [
        538.75,
        894.0,
        -56.5
      ],
      "bbox_max": [
        539.25,
        894.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 894.0,
      "bbox_min": [
        538.75,
        894.0,
        -56.5
      ],
      "bbox_max": [
        539.25,
        894.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 304.7630920410156,
      "bbox_min": [
        455.1000061035156,
        867.1000366210938,
        -56.5
      ],
      "bbox_max": [
        457.1000061035156,
        888.1000366210938,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -936.350830078125,
      "bbox_min": [
        455.1000061035156,
        867.1000366210938,
        -56.5
      ],
      "bbox_max": [
        457.1000061035156,
        869.1000366210938,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        455.1000061035156,
        845.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -543.0,
      "bbox_min": [
        535.0,
        845.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.0,
      "bbox_min": [
        535.0,
        845.25,
        -60.0
      ],
      "bbox_max": [
        543.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -540.0,
      "bbox_min": [
        538.0,
        845.25,
        -60.0
      ],
      "bbox_max": [
        543.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        538.0,
        845.25,
        -60.0
      ],
      "bbox_max": [
        540.0,
        890.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -846.25,
      "bbox_min": [
        538.5999755859375,
        845.25,
        -60.0
      ],
      "bbox_max": [
        539.5999755859375,
        846.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.5999755859375,
      "bbox_min": [
        538.5999755859375,
        845.25,
        -60.0
      ],
      "bbox_max": [
        539.5999755859375,
        846.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -539.5999755859375,
      "bbox_min": [
        538.5999755859375,
        845.25,
        -60.0
      ],
      "bbox_max": [
        539.5999755859375,
        846.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 845.25,
      "bbox_min": [
        538.5999755859375,
        845.25,
        -60.0
      ],
      "bbox_max": [
        539.5999755859375,
        845.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14834009110927582,
        0.0,
        0.9889364838600159
      ],
      "plane_d": -23.734272003173828,
      "bbox_min": [
        540.0,
        890.0,
        -60.0
      ],
      "bbox_max": [
        543.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 542.0,
      "bbox_min": [
        540.0,
        890.0,
        -57.44999313354492
      ],
      "bbox_max": [
        543.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        542.0,
        890.0,
        -57.44999313354492
      ],
      "bbox_max": [
        543.0,
        890.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        540.0,
        890.0,
        -57.29999923706055
      ],
      "bbox_max": [
        542.0,
        892.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        540.0,
        890.0,
        -57.29999542236328
      ],
      "bbox_max": [
        542.0,
        890.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14834009110927582,
        0.0,
        0.9889364838600159
      ],
      "plane_d": 136.17636108398438,
      "bbox_min": [
        535.0,
        890.0,
        -60.0
      ],
      "bbox_max": [
        538.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -536.0,
      "bbox_min": [
        535.0,
        890.0,
        -57.45001220703125
      ],
      "bbox_max": [
        538.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        535.0,
        890.0,
        -57.45001220703125
      ],
      "bbox_max": [
        536.0,
        890.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        536.0,
        890.0,
        -57.300010681152344
      ],
      "bbox_max": [
        538.0,
        892.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        536.0,
        892.0,
        -57.29999923706055
      ],
      "bbox_max": [
        538.0,
        892.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 555.5,
      "bbox_min": [
        543.5999755859375,
        845.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -563.5,
      "bbox_min": [
        555.5,
        845.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 558.5,
      "bbox_min": [
        555.5,
        890.0,
        -60.0
      ],
      "bbox_max": [
        563.5,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14834009110927582,
        0.0,
        0.9889364838600159
      ],
      "plane_d": -26.77524185180664,
      "bbox_min": [
        558.5,
        890.0,
        -60.0
      ],
      "bbox_max": [
        563.5,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 562.5,
      "bbox_min": [
        558.5,
        890.0,
        -57.44999313354492
      ],
      "bbox_max": [
        563.5,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        562.5,
        890.0,
        -57.44999313354492
      ],
      "bbox_max": [
        563.5,
        890.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -560.5,
      "bbox_min": [
        558.5,
        890.0,
        -57.29999923706055
      ],
      "bbox_max": [
        562.5,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        558.5,
        890.0,
        -56.999996185302734
      ],
      "bbox_max": [
        560.5,
        890.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        560.5,
        890.0,
        -57.29999923706055
      ],
      "bbox_max": [
        562.5,
        892.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        560.5,
        890.0,
        -57.29999542236328
      ],
      "bbox_max": [
        562.5,
        890.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14834009110927582,
        0.0,
        0.9889364838600159
      ],
      "plane_d": 139.21731567382812,
      "bbox_min": [
        555.5,
        890.0,
        -60.0
      ],
      "bbox_max": [
        558.5,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -556.5,
      "bbox_min": [
        555.5,
        890.0,
        -57.44999694824219
      ],
      "bbox_max": [
        558.5,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        555.5,
        890.0,
        -57.44999694824219
      ],
      "bbox_max": [
        556.5,
        890.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        556.5,
        890.0,
        -57.29999923706055
      ],
      "bbox_max": [
        558.5,
        892.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        556.5,
        890.0,
        -57.29999542236328
      ],
      "bbox_max": [
        558.5,
        890.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 567.0,
      "bbox_min": [
        567.0,
        845.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        855.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -855.0,
      "bbox_min": [
        567.0,
        855.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        855.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        543.5999755859375,
        845.0,
        -60.0
      ],
      "bbox_max": [
        552.0,
        875.0,
        -56.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -551.5999755859375,
      "bbox_min": [
        543.5999755859375,
        845.0,
        -60.0
      ],
      "bbox_max": [
        551.5999755859375,
        850.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 58.0,
      "bbox_min": [
        543.5999755859375,
        845.0,
        -60.0
      ],
      "bbox_max": [
        545.5999755859375,
        850.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 543.5999755859375,
      "bbox_min": [
        543.5999755859375,
        845.0,
        -60.0
      ],
      "bbox_max": [
        543.5999755859375,
        850.0,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 545.5999755859375,
      "bbox_min": [
        545.5999755859375,
        845.0,
        -58.0
      ],
      "bbox_max": [
        545.5999755859375,
        850.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -875.0,
      "bbox_min": [
        551.0,
        867.2000122070312,
        -60.0
      ],
      "bbox_max": [
        552.0,
        875.0,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 867.2000122070312,
      "bbox_min": [
        551.0,
        867.2000122070312,
        -60.0
      ],
      "bbox_max": [
        552.0,
        867.2000122070312,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 551.0,
      "bbox_min": [
        551.0,
        870.2000122070312,
        -59.0
      ],
      "bbox_max": [
        552.0,
        872.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -872.0,
      "bbox_min": [
        551.0,
        870.2000122070312,
        -59.0
      ],
      "bbox_max": [
        552.0,
        872.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.2000122070312,
      "bbox_min": [
        551.0,
        870.2000122070312,
        -59.0
      ],
      "bbox_max": [
        552.0,
        870.2000122070312,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -455.1000061035156,
      "bbox_min": [
        455.1000061035156,
        845.0,
        -60.0
      ],
      "bbox_max": [
        529.7000732421875,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 514.0,
      "bbox_min": [
        455.1000061035156,
        845.0,
        -60.0
      ],
      "bbox_max": [
        529.7000732421875,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -522.0,
      "bbox_min": [
        514.0,
        845.0,
        -60.0
      ],
      "bbox_max": [
        529.7000732421875,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        514.0,
        850.0,
        -60.0
      ],
      "bbox_max": [
        522.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 517.0,
      "bbox_min": [
        515.0,
        892.0,
        -57.29999923706055
      ],
      "bbox_max": [
        521.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14834009110927582,
        0.0,
        0.9889364838600159
      ],
      "plane_d": -20.619129180908203,
      "bbox_min": [
        519.0,
        892.0,
        -57.29999923706055
      ],
      "bbox_max": [
        521.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 521.0,
      "bbox_min": [
        519.0,
        892.0,
        -57.29999923706055
      ],
      "bbox_max": [
        521.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -519.0,
      "bbox_min": [
        519.0,
        892.0,
        -57.29999923706055
      ],
      "bbox_max": [
        521.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        519.0,
        892.0,
        -57.29999923706055
      ],
      "bbox_max": [
        521.0,
        892.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14834009110927582,
        0.0,
        0.9889364838600159
      ],
      "plane_d": 133.06121826171875,
      "bbox_min": [
        515.0,
        892.0,
        -57.29999923706055
      ],
      "bbox_max": [
        517.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -515.0,
      "bbox_min": [
        515.0,
        892.0,
        -57.29999923706055
      ],
      "bbox_max": [
        517.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        515.0,
        892.0,
        -57.29999923706055
      ],
      "bbox_max": [
        517.0,
        892.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        514.0,
        850.0,
        -60.0
      ],
      "bbox_max": [
        522.0,
        850.0,
        -56.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        522.0,
        845.0,
        -60.0
      ],
      "bbox_max": [
        525.0,
        875.0,
        -56.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -524.5999755859375,
      "bbox_min": [
        524.5999755859375,
        845.0,
        -60.0
      ],
      "bbox_max": [
        524.5999755859375,
        850.0,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -522.5999755859375,
      "bbox_min": [
        522.5999755859375,
        845.0,
        -58.0
      ],
      "bbox_max": [
        522.5999755859375,
        850.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.0,
      "bbox_min": [
        524.0,
        867.2000122070312,
        -60.0
      ],
      "bbox_max": [
        525.0,
        875.0,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -875.0,
      "bbox_min": [
        524.0,
        867.2000122070312,
        -60.0
      ],
      "bbox_max": [
        525.0,
        875.0,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 867.2000122070312,
      "bbox_min": [
        524.0,
        867.2000122070312,
        -60.0
      ],
      "bbox_max": [
        525.0,
        867.2000122070312,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.0,
      "bbox_min": [
        524.0,
        870.2000122070312,
        -59.0
      ],
      "bbox_max": [
        525.0,
        872.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -872.0,
      "bbox_min": [
        524.0,
        870.2000122070312,
        -59.0
      ],
      "bbox_max": [
        525.0,
        872.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.2000122070312,
      "bbox_min": [
        524.0,
        870.2000122070312,
        -59.0
      ],
      "bbox_max": [
        525.0,
        870.2000122070312,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -846.25,
      "bbox_min": [
        528.7000732421875,
        845.25,
        -60.0
      ],
      "bbox_max": [
        529.7000732421875,
        846.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 528.7000732421875,
      "bbox_min": [
        528.7000732421875,
        845.25,
        -60.0
      ],
      "bbox_max": [
        529.7000732421875,
        846.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -529.7000732421875,
      "bbox_min": [
        528.7000732421875,
        845.25,
        -60.0
      ],
      "bbox_max": [
        529.7000732421875,
        846.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 845.25,
      "bbox_min": [
        528.7000732421875,
        845.25,
        -60.0
      ],
      "bbox_max": [
        529.7000732421875,
        845.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -457.1000061035156,
      "bbox_min": [
        455.1000061035156,
        845.0,
        -60.0
      ],
      "bbox_max": [
        514.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -936.350830078125,
      "bbox_min": [
        455.1000061035156,
        867.1000366210938,
        -58.0
      ],
      "bbox_max": [
        457.1000061035156,
        869.1000366210938,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 860.0999755859375,
      "bbox_min": [
        457.1000061035156,
        845.0,
        -60.0
      ],
      "bbox_max": [
        514.0,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -462.6000061035156,
      "bbox_min": [
        457.1000061035156,
        860.0999755859375,
        -60.0
      ],
      "bbox_max": [
        504.75,
        906.0,
        -56.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -895.0999755859375,
      "bbox_min": [
        457.1000061035156,
        866.0999755859375,
        -60.0
      ],
      "bbox_max": [
        462.6000061035156,
        906.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.3563368156610522e-05,
        1.0,
        -0.0
      ],
      "plane_d": -866.1062622070312,
      "bbox_min": [
        457.1000061035156,
        866.0999755859375,
        -60.0
      ],
      "bbox_max": [
        462.6000061035156,
        889.1000366210938,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3563368156610522e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 889.1062622070312,
      "bbox_min": [
        457.1000061035156,
        866.0999755859375,
        -60.0
      ],
      "bbox_max": [
        462.6000061035156,
        889.1000366210938,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.103515625e-05,
        1.0,
        -0.0
      ],
      "plane_d": -873.1280517578125,
      "bbox_min": [
        457.1000061035156,
        866.0999755859375,
        -60.0
      ],
      "bbox_max": [
        462.6000061035156,
        889.1000366210938,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.103515625e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 872.1280517578125,
      "bbox_min": [
        457.1000061035156,
        866.0999755859375,
        -60.0
      ],
      "bbox_max": [
        462.6000061035156,
        873.1000366210938,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -460.3500061035156,
      "bbox_min": [
        459.3500061035156,
        872.0999755859375,
        -60.0
      ],
      "bbox_max": [
        460.3500061035156,
        873.1000366210938,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 459.3500061035156,
      "bbox_min": [
        459.3500061035156,
        872.1000366210938,
        -60.0
      ],
      "bbox_max": [
        459.3500061035156,
        873.1000366210938,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 58.0,
      "bbox_min": [
        457.1000061035156,
        866.0999755859375,
        -60.0
      ],
      "bbox_max": [
        462.6000061035156,
        869.1000366210938,
        -56.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -937.76513671875,
      "bbox_min": [
        457.1000061035156,
        868.1000366210938,
        -60.0
      ],
      "bbox_max": [
        458.1000061035156,
        869.1000366210938,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -936.350830078125,
      "bbox_min": [
        457.1000061035156,
        866.1000366210938,
        -58.0
      ],
      "bbox_max": [
        458.1000061035156,
        867.1000366210938,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.103515625e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 882.0279541015625,
      "bbox_min": [
        459.3500061035156,
        881.9998779296875,
        -60.0
      ],
      "bbox_max": [
        460.3500061035156,
        882.9999389648438,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 459.3500061035156,
      "bbox_min": [
        459.3500061035156,
        881.9999389648438,
        -60.0
      ],
      "bbox_max": [
        459.3500061035156,
        882.9999389648438,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 58.0,
      "bbox_min": [
        457.1000061035156,
        886.1000366210938,
        -60.0
      ],
      "bbox_max": [
        462.6000061035156,
        889.1000366210938,
        -56.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 303.3488464355469,
      "bbox_min": [
        457.1000061035156,
        886.1000366210938,
        -60.0
      ],
      "bbox_max": [
        458.1000061035156,
        887.1000366210938,
        -58.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 304.7630920410156,
      "bbox_min": [
        457.1000061035156,
        888.1000366210938,
        -58.0
      ],
      "bbox_max": [
        458.1000061035156,
        889.1000366210938,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -871.25,
      "bbox_min": [
        502.75,
        869.25,
        -60.0
      ],
      "bbox_max": [
        504.75,
        872.75,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 532.0961303710938,
      "bbox_min": [
        502.75,
        869.25,
        -60.0
      ],
      "bbox_max": [
        504.75,
        870.75,
        -58.66667556762695
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.75,
      "bbox_min": [
        502.75,
        870.75,
        -59.0
      ],
      "bbox_max": [
        503.25,
        870.75,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 327.96649169921875,
      "bbox_min": [
        481.25,
        869.25,
        -60.0
      ],
      "bbox_max": [
        502.75,
        893.75,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -434.1915588378906,
      "bbox_min": [
        501.25,
        869.25,
        -60.0
      ],
      "bbox_max": [
        502.75,
        872.75,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 482.75,
      "bbox_min": [
        481.25,
        869.25,
        -60.0
      ],
      "bbox_max": [
        484.75,
        871.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -483.25,
      "bbox_min": [
        482.75,
        869.25,
        -60.0
      ],
      "bbox_max": [
        484.75,
        871.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.75,
      "bbox_min": [
        482.75,
        869.25,
        -60.0
      ],
      "bbox_max": [
        483.25,
        870.75,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 532.0961303710938,
      "bbox_min": [
        482.75,
        869.25,
        -60.0
      ],
      "bbox_max": [
        483.25,
        870.75,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -218.9678955078125,
      "bbox_min": [
        483.25,
        869.25,
        -60.0
      ],
      "bbox_max": [
        484.75,
        871.25,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -434.1915588378906,
      "bbox_min": [
        481.25,
        871.25,
        -60.0
      ],
      "bbox_max": [
        484.75,
        893.75,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 316.87249755859375,
      "bbox_min": [
        481.25,
        871.25,
        -60.0
      ],
      "bbox_max": [
        484.75,
        872.75,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -892.25,
      "bbox_min": [
        482.75,
        890.25,
        -60.0
      ],
      "bbox_max": [
        484.75,
        893.75,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -483.25,
      "bbox_min": [
        482.75,
        890.25,
        -60.0
      ],
      "bbox_max": [
        484.75,
        892.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 891.75,
      "bbox_min": [
        482.75,
        890.25,
        -60.0
      ],
      "bbox_max": [
        483.25,
        891.75,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 543.744873046875,
      "bbox_min": [
        482.75,
        890.25,
        -60.0
      ],
      "bbox_max": [
        483.25,
        891.75,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -218.9678955078125,
      "bbox_min": [
        483.25,
        890.25,
        -60.0
      ],
      "bbox_max": [
        484.75,
        892.25,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 316.87249755859375,
      "bbox_min": [
        481.25,
        890.25,
        -60.0
      ],
      "bbox_max": [
        482.75,
        893.75,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -445.84027099609375,
      "bbox_min": [
        481.25,
        890.25,
        -60.0
      ],
      "bbox_max": [
        482.75,
        893.75,
        -59.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 481.6000061035156,
      "bbox_min": [
        461.1999816894531,
        845.0,
        -60.0
      ],
      "bbox_max": [
        514.0,
        850.48193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        481.6000061035156,
        845.0,
        -60.0
      ],
      "bbox_max": [
        514.0,
        850.0,
        -56.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 58.0,
      "bbox_min": [
        508.6000061035156,
        845.0,
        -58.0
      ],
      "bbox_max": [
        510.6000061035156,
        850.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 510.6000061035156,
      "bbox_min": [
        510.6000061035156,
        845.0,
        -58.0
      ],
      "bbox_max": [
        510.6000061035156,
        850.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 58.0,
      "bbox_min": [
        487.6000061035156,
        845.0,
        -58.0
      ],
      "bbox_max": [
        489.6000061035156,
        850.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -487.6000061035156,
      "bbox_min": [
        487.6000061035156,
        845.0,
        -58.0
      ],
      "bbox_max": [
        487.6000061035156,
        850.0,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 493.6000061035156,
      "bbox_min": [
        493.6000061035156,
        845.25,
        -60.0
      ],
      "bbox_max": [
        494.6000061035156,
        846.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -846.25,
      "bbox_min": [
        493.6000061035156,
        845.25,
        -60.0
      ],
      "bbox_max": [
        494.6000061035156,
        846.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 845.25,
      "bbox_min": [
        493.6000061035156,
        845.25,
        -60.0
      ],
      "bbox_max": [
        494.6000061035156,
        845.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 503.4999084472656,
      "bbox_min": [
        503.4999084472656,
        845.25,
        -60.0
      ],
      "bbox_max": [
        504.4999084472656,
        846.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -846.25,
      "bbox_min": [
        503.4999084472656,
        845.25,
        -60.0
      ],
      "bbox_max": [
        504.4999084472656,
        846.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -504.4999084472656,
      "bbox_min": [
        503.4999084472656,
        845.25,
        -60.0
      ],
      "bbox_max": [
        504.4999084472656,
        846.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 845.25,
      "bbox_min": [
        503.4999084472656,
        845.25,
        -60.0
      ],
      "bbox_max": [
        504.4999084472656,
        845.25,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.48193359375,
      "bbox_min": [
        461.1999816894531,
        847.01806640625,
        -60.0
      ],
      "bbox_max": [
        465.1999816894531,
        850.48193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 847.01806640625,
      "bbox_min": [
        461.1999816894531,
        847.01806640625,
        -60.0
      ],
      "bbox_max": [
        465.1999816894531,
        850.48193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -827.2647705078125,
      "bbox_min": [
        461.1999816894531,
        847.01806640625,
        -60.0
      ],
      "bbox_max": [
        465.1999816894531,
        850.48193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -24.992401123046875,
      "bbox_min": [
        461.1999816894531,
        847.01806640625,
        -60.0
      ],
      "bbox_max": [
        465.1999816894531,
        850.48193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": 21.528350830078125,
      "bbox_min": [
        461.1999816894531,
        847.01806640625,
        -60.0
      ],
      "bbox_max": [
        465.1999816894531,
        850.23193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        -0.5000253915786743,
        -0.0
      ],
      "plane_d": 823.8006591796875,
      "bbox_min": [
        461.1999816894531,
        847.01806640625,
        -60.0
      ],
      "bbox_max": [
        464.9114074707031,
        850.23193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -847.26806640625,
      "bbox_min": [
        461.4885559082031,
        847.26806640625,
        -60.0
      ],
      "bbox_max": [
        464.9114074707031,
        850.23193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 850.23193359375,
      "bbox_min": [
        461.4885559082031,
        847.26806640625,
        -60.0
      ],
      "bbox_max": [
        464.9114074707031,
        850.23193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659955263137817,
        0.5000517964363098,
        0.0
      ],
      "plane_d": -21.807769775390625,
      "bbox_min": [
        461.4885559082031,
        847.26806640625,
        -60.0
      ],
      "bbox_max": [
        464.9114074707031,
        850.23193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659955263137817,
        0.5000517964363098,
        0.0
      ],
      "plane_d": -824.0659790039062,
      "bbox_min": [
        461.4885559082031,
        847.26806640625,
        -60.0
      ],
      "bbox_max": [
        464.9114074707031,
        850.23193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659955263137817,
        -0.5000517964363098,
        0.0
      ],
      "plane_d": 24.771942138671875,
      "bbox_min": [
        461.4885559082031,
        848.75,
        -60.0
      ],
      "bbox_max": [
        464.9114074707031,
        850.23193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659955263137817,
        -0.5000517964363098,
        -0.0
      ],
      "plane_d": 827.0301513671875,
      "bbox_min": [
        464.0556945800781,
        848.75,
        -60.0
      ],
      "bbox_max": [
        464.9114074707031,
        850.23193359375,
        -56.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        454.1000061035156,
        840.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -454.1000061035156,
      "bbox_min": [
        454.1000061035156,
        840.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5144957900047302,
        -0.857492983341217
      ],
      "plane_d": -469.04864501953125,
      "bbox_min": [
        454.1000061035156,
        840.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5144957900047302,
        0.0,
        -0.857492983341217
      ],
      "plane_d": -270.5047302246094,
      "bbox_min": [
        454.1000061035156,
        840.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        454.1000061035156,
        840.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -40.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 54.0,
      "bbox_min": [
        481.6000061035156,
        840.0,
        -55.5
      ],
      "bbox_max": [
        551.5999755859375,
        845.0,
        -40.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -211.00070190429688,
      "bbox_min": [
        522.5999755859375,
        841.0,
        -55.5
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 545.5999755859375,
      "bbox_min": [
        522.5999755859375,
        844.0,
        -55.5
      ],
      "bbox_max": [
        545.5999755859375,
        845.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -487.6000061035156,
      "bbox_min": [
        487.6000061035156,
        844.0,
        -55.5
      ],
      "bbox_max": [
        487.6000061035156,
        845.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071089744567871,
        0.7071046233177185,
        0.0
      ],
      "plane_d": -232.2109375,
      "bbox_min": [
        481.6000061035156,
        840.0,
        -54.0
      ],
      "bbox_max": [
        516.5999755859375,
        845.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45749571919441223,
        0.45749571919441223,
        -0.7624928951263428
      ],
      "plane_d": -639.7010498046875,
      "bbox_min": [
        481.6000061035156,
        840.0,
        -43.0
      ],
      "bbox_max": [
        516.5999755859375,
        845.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45749789476394653,
        0.4574951231479645,
        -0.7624918818473816
      ],
      "plane_d": -183.02711486816406,
      "bbox_min": [
        511.6000061035156,
        840.0,
        -43.0
      ],
      "bbox_max": [
        516.5999755859375,
        845.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -207.46514892578125,
      "bbox_min": [
        516.5999755859375,
        840.0,
        -54.0
      ],
      "bbox_max": [
        551.5999755859375,
        845.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45749571919441223,
        0.45749571919441223,
        -0.7624928951263428
      ],
      "plane_d": -655.71337890625,
      "bbox_min": [
        516.5999755859375,
        840.0,
        -43.0
      ],
      "bbox_max": [
        551.5999755859375,
        845.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45749571919441223,
        0.45749571919441223,
        -0.7624928951263428
      ],
      "plane_d": -167.01646423339844,
      "bbox_min": [
        546.5999755859375,
        840.0,
        -43.0
      ],
      "bbox_max": [
        551.5999755859375,
        845.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -459.1000061035156,
      "bbox_min": [
        454.1000061035156,
        845.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -40.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 54.0,
      "bbox_min": [
        454.1000061035156,
        860.0999755859375,
        -55.5
      ],
      "bbox_max": [
        459.1000061035156,
        895.0999755859375,
        -40.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -936.350830078125,
      "bbox_min": [
        455.1000061035156,
        866.1000366210938,
        -55.5
      ],
      "bbox_max": [
        459.1000061035156,
        889.1000366210938,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3563368156610522e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 889.1062622070312,
      "bbox_min": [
        458.1000061035156,
        889.1000366210938,
        -55.5
      ],
      "bbox_max": [
        459.1000061035156,
        889.1000366210938,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4575001001358032,
        0.4574945271015167,
        -0.7624908685684204
      ],
      "plane_d": -636.31640625,
      "bbox_min": [
        454.1000061035156,
        860.0999755859375,
        -43.0
      ],
      "bbox_max": [
        459.1000061035156,
        895.0999755859375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45749130845069885,
        -0.45749688148498535,
        -0.7624948024749756
      ],
      "plane_d": 166.68394470214844,
      "bbox_min": [
        454.1000061035156,
        890.0999755859375,
        -43.0
      ],
      "bbox_max": [
        459.1000061035156,
        895.0999755859375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -52.20000076293945,
      "bbox_min": [
        459.1000061035156,
        845.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -51.20000076293945
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 51.20000076293945,
      "bbox_min": [
        517.0,
        892.0,
        -52.20000076293945
      ],
      "bbox_max": [
        560.5,
        906.0,
        -51.20000076293945
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.0,
      "bbox_min": [
        517.0,
        892.0,
        -52.20000076293945
      ],
      "bbox_max": [
        560.5,
        906.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 558.5,
      "bbox_min": [
        538.0,
        892.0,
        -52.20000076293945
      ],
      "bbox_max": [
        560.5,
        906.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -560.5,
      "bbox_min": [
        558.5,
        892.0,
        -52.20000076293945
      ],
      "bbox_max": [
        560.5,
        906.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 892.0,
      "bbox_min": [
        558.5,
        892.0,
        -52.20000076293945
      ],
      "bbox_max": [
        560.5,
        892.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -540.0,
      "bbox_min": [
        538.0,
        892.0,
        -52.20000076293945
      ],
      "bbox_max": [
        540.0,
        906.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 892.0,
      "bbox_min": [
        538.0,
        892.0,
        -52.20000076293945
      ],
      "bbox_max": [
        540.0,
        892.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 517.0,
      "bbox_min": [
        517.0,
        892.0,
        -52.20000076293945
      ],
      "bbox_max": [
        519.0,
        906.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -519.0,
      "bbox_min": [
        517.0,
        892.0,
        -52.20000076293945
      ],
      "bbox_max": [
        519.0,
        906.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 892.0,
      "bbox_min": [
        517.0,
        892.0,
        -52.20000076293945
      ],
      "bbox_max": [
        519.0,
        892.0,
        -51.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144956111907959,
        0.0,
        0.857492983341217
      ],
      "plane_d": 321.5597839355469,
      "bbox_min": [
        459.1000061035156,
        845.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -52.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5144956111907959,
        0.0,
        0.857492983341217
      ],
      "plane_d": 332.10693359375,
      "bbox_min": [
        535.0,
        845.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -52.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5144956111907959,
        0.0,
        -0.857492983341217
      ],
      "plane_d": 243.6136474609375,
      "bbox_min": [
        555.5,
        845.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        906.0,
        -52.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 53.0,
      "bbox_min": [
        567.0,
        845.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        855.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 567.0,
      "bbox_min": [
        567.0,
        845.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        855.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -855.0,
      "bbox_min": [
        567.0,
        855.0,
        -55.5
      ],
      "bbox_max": [
        571.5,
        855.0,
        -53.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 899.75,
      "bbox_min": [
        559.25,
        894.0,
        -55.5
      ],
      "bbox_max": [
        559.75,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.25,
      "bbox_min": [
        559.25,
        899.75,
        -55.5
      ],
      "bbox_max": [
        559.75,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 559.25,
      "bbox_min": [
        559.25,
        899.75,
        -55.5
      ],
      "bbox_max": [
        559.75,
        900.25,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -559.75,
      "bbox_min": [
        559.75,
        899.75,
        -55.5
      ],
      "bbox_max": [
        559.75,
        900.25,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 559.25,
      "bbox_min": [
        559.25,
        905.5,
        -55.5
      ],
      "bbox_max": [
        559.75,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 905.5,
      "bbox_min": [
        559.25,
        905.5,
        -55.5
      ],
      "bbox_max": [
        559.75,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -559.75,
      "bbox_min": [
        559.75,
        905.5,
        -55.5
      ],
      "bbox_max": [
        559.75,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 559.25,
      "bbox_min": [
        559.25,
        894.0,
        -55.5
      ],
      "bbox_max": [
        559.75,
        894.5,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -894.5,
      "bbox_min": [
        559.25,
        894.0,
        -55.5
      ],
      "bbox_max": [
        559.75,
        894.5,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -559.75,
      "bbox_min": [
        559.25,
        894.0,
        -55.5
      ],
      "bbox_max": [
        559.75,
        894.5,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 894.0,
      "bbox_min": [
        559.25,
        894.0,
        -55.5
      ],
      "bbox_max": [
        559.75,
        894.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144956111907959,
        0.0,
        -0.857492983341217
      ],
      "plane_d": 233.06649780273438,
      "bbox_min": [
        535.0,
        845.0,
        -55.5
      ],
      "bbox_max": [
        551.5999755859375,
        906.0,
        -52.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 54.0,
      "bbox_min": [
        545.5999755859375,
        845.0,
        -55.5
      ],
      "bbox_max": [
        551.5999755859375,
        850.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 545.5999755859375,
      "bbox_min": [
        545.5999755859375,
        845.0,
        -55.5
      ],
      "bbox_max": [
        551.5999755859375,
        850.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -551.5999755859375,
      "bbox_min": [
        551.5999755859375,
        845.0,
        -55.5
      ],
      "bbox_max": [
        551.5999755859375,
        850.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5144956111907959,
        -0.857492983341217
      ],
      "plane_d": -503.69122314453125,
      "bbox_min": [
        535.0,
        889.0,
        -55.5
      ],
      "bbox_max": [
        543.0,
        906.0,
        -52.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 899.75,
      "bbox_min": [
        538.75,
        894.0,
        -55.5
      ],
      "bbox_max": [
        539.25,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.25,
      "bbox_min": [
        538.75,
        899.75,
        -55.5
      ],
      "bbox_max": [
        539.25,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 538.75,
      "bbox_min": [
        538.75,
        899.75,
        -55.5
      ],
      "bbox_max": [
        539.25,
        900.25,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -539.25,
      "bbox_min": [
        539.25,
        899.75,
        -55.5
      ],
      "bbox_max": [
        539.25,
        900.25,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 538.75,
      "bbox_min": [
        538.75,
        905.5,
        -55.5
      ],
      "bbox_max": [
        539.25,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 905.5,
      "bbox_min": [
        538.75,
        905.5,
        -55.5
      ],
      "bbox_max": [
        539.25,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -539.25,
      "bbox_min": [
        539.25,
        905.5,
        -55.5
      ],
      "bbox_max": [
        539.25,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 538.75,
      "bbox_min": [
        538.75,
        894.0,
        -55.5
      ],
      "bbox_max": [
        539.25,
        894.5,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -894.5,
      "bbox_min": [
        538.75,
        894.0,
        -55.5
      ],
      "bbox_max": [
        539.25,
        894.5,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -539.25,
      "bbox_min": [
        538.75,
        894.0,
        -55.5
      ],
      "bbox_max": [
        539.25,
        894.5,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 894.0,
      "bbox_min": [
        538.75,
        894.0,
        -55.5
      ],
      "bbox_max": [
        539.25,
        894.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144956111907959,
        0.0,
        0.857492983341217
      ],
      "plane_d": 310.75537109375,
      "bbox_min": [
        459.1000061035156,
        845.0,
        -55.5
      ],
      "bbox_max": [
        522.5999755859375,
        906.0,
        -52.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5144956111907959,
        0.0,
        -0.857492983341217
      ],
      "plane_d": 222.2620849609375,
      "bbox_min": [
        511.5,
        845.0,
        -55.5
      ],
      "bbox_max": [
        522.5999755859375,
        906.0,
        -52.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 54.0,
      "bbox_min": [
        522.0,
        845.0,
        -54.3599853515625
      ],
      "bbox_max": [
        522.5999755859375,
        850.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -522.5999755859375,
      "bbox_min": [
        522.0,
        845.0,
        -54.3599853515625
      ],
      "bbox_max": [
        522.5999755859375,
        850.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        522.0,
        850.0,
        -54.3599853515625
      ],
      "bbox_max": [
        522.5999755859375,
        850.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5144956111907959,
        0.857492983341217
      ],
      "plane_d": 503.69122314453125,
      "bbox_min": [
        511.5,
        845.0,
        -55.5
      ],
      "bbox_max": [
        522.5999755859375,
        906.0,
        -52.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 899.75,
      "bbox_min": [
        517.75,
        894.0,
        -55.5
      ],
      "bbox_max": [
        518.25,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.25,
      "bbox_min": [
        517.75,
        899.75,
        -55.5
      ],
      "bbox_max": [
        518.25,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 517.75,
      "bbox_min": [
        517.75,
        899.75,
        -55.5
      ],
      "bbox_max": [
        518.25,
        900.25,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -518.25,
      "bbox_min": [
        518.25,
        899.75,
        -55.5
      ],
      "bbox_max": [
        518.25,
        900.25,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 517.75,
      "bbox_min": [
        517.75,
        905.5,
        -55.5
      ],
      "bbox_max": [
        518.25,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 905.5,
      "bbox_min": [
        517.75,
        905.5,
        -55.5
      ],
      "bbox_max": [
        518.25,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -518.25,
      "bbox_min": [
        518.25,
        905.5,
        -55.5
      ],
      "bbox_max": [
        518.25,
        906.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 517.75,
      "bbox_min": [
        517.75,
        894.0,
        -55.5
      ],
      "bbox_max": [
        518.25,
        894.5,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -894.5,
      "bbox_min": [
        517.75,
        894.0,
        -55.5
      ],
      "bbox_max": [
        518.25,
        894.5,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -518.25,
      "bbox_min": [
        517.75,
        894.0,
        -55.5
      ],
      "bbox_max": [
        518.25,
        894.5,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 894.0,
      "bbox_min": [
        517.75,
        894.0,
        -55.5
      ],
      "bbox_max": [
        518.25,
        894.0,
        -52.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 54.0,
      "bbox_min": [
        511.5,
        845.0,
        -55.5
      ],
      "bbox_max": [
        522.5999755859375,
        850.0,
        -54.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        511.5,
        845.0,
        -55.5
      ],
      "bbox_max": [
        522.5999755859375,
        850.0,
        -54.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -522.5999755859375,
      "bbox_min": [
        522.5999755859375,
        845.0,
        -55.5
      ],
      "bbox_max": [
        522.5999755859375,
        850.0,
        -54.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 54.0,
      "bbox_min": [
        459.1000061035156,
        845.0,
        -55.5
      ],
      "bbox_max": [
        514.0,
        897.0,
        -54.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -462.6000061035156,
      "bbox_min": [
        459.1000061035156,
        845.0,
        -55.5
      ],
      "bbox_max": [
        514.0,
        897.0,
        -54.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.3563368156610522e-05,
        1.0,
        -0.0
      ],
      "plane_d": -866.1062622070312,
      "bbox_min": [
        459.1000061035156,
        860.0999755859375,
        -55.5
      ],
      "bbox_max": [
        462.6000061035156,
        895.0999755859375,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 860.0999755859375,
      "bbox_min": [
        459.1000061035156,
        860.0999755859375,
        -55.5
      ],
      "bbox_max": [
        462.6000061035156,
        860.0999755859375,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -895.0999755859375,
      "bbox_min": [
        459.1000061035156,
        889.0999755859375,
        -55.5
      ],
      "bbox_max": [
        462.6000061035156,
        895.0999755859375,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3563368156610522e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 889.1062622070312,
      "bbox_min": [
        459.1000061035156,
        889.0999755859375,
        -55.5
      ],
      "bbox_max": [
        462.6000061035156,
        889.1000366210938,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        478.0,
        845.0,
        -55.5
      ],
      "bbox_max": [
        514.0,
        897.0,
        -54.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -487.6000061035156,
      "bbox_min": [
        481.6000061035156,
        845.0,
        -55.5
      ],
      "bbox_max": [
        510.6000061035156,
        850.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 481.6000061035156,
      "bbox_min": [
        481.6000061035156,
        845.0,
        -55.5
      ],
      "bbox_max": [
        481.6000061035156,
        850.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 510.6000061035156,
      "bbox_min": [
        510.6000061035156,
        845.0,
        -55.5
      ],
      "bbox_max": [
        510.6000061035156,
        850.0,
        -54.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": 55.405696868896484,
      "bbox_min": [
        478.0,
        866.0,
        -55.5
      ],
      "bbox_max": [
        508.0,
        897.0,
        -55.40570068359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -1001.8072509765625,
      "bbox_min": [
        478.0,
        866.0,
        -55.5
      ],
      "bbox_max": [
        508.0,
        897.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -784.1546630859375,
      "bbox_min": [
        478.0,
        866.0,
        -55.5
      ],
      "bbox_max": [
        508.0,
        876.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -994.1537475585938,
      "bbox_min": [
        478.0,
        866.0,
        -55.5
      ],
      "bbox_max": [
        488.0,
        876.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -624.4888916015625,
      "bbox_min": [
        478.0,
        866.0,
        -55.5
      ],
      "bbox_max": [
        488.0,
        876.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        -0.0
      ],
      "plane_d": 984.9149169921875,
      "bbox_min": [
        478.0,
        866.0,
        -55.5
      ],
      "bbox_max": [
        488.0,
        874.5355224609375,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 615.2501220703125,
      "bbox_min": [
        478.0,
        866.0,
        -55.5
      ],
      "bbox_max": [
        488.0,
        874.5355224609375,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": 108.32241821289062,
      "bbox_min": [
        478.0,
        867.4644775390625,
        -55.5
      ],
      "bbox_max": [
        488.0,
        874.5355224609375,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        -0.0
      ],
      "plane_d": 774.915771484375,
      "bbox_min": [
        478.0,
        867.4644775390625,
        -55.5
      ],
      "bbox_max": [
        488.0,
        871.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": -117.561279296875,
      "bbox_min": [
        486.53564453125,
        867.4644775390625,
        -55.5
      ],
      "bbox_max": [
        488.0,
        871.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -616.8353271484375,
      "bbox_min": [
        498.0,
        866.0,
        -55.5
      ],
      "bbox_max": [
        508.0,
        876.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        -0.0
      ],
      "plane_d": 992.5684204101562,
      "bbox_min": [
        498.0,
        866.0,
        -55.5
      ],
      "bbox_max": [
        508.0,
        874.5355224609375,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 607.5965576171875,
      "bbox_min": [
        498.0,
        866.0,
        -55.5
      ],
      "bbox_max": [
        508.0,
        874.5355224609375,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -802.6324462890625,
      "bbox_min": [
        498.0,
        867.4644775390625,
        -55.5
      ],
      "bbox_max": [
        508.0,
        874.5355224609375,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": 126.80020141601562,
      "bbox_min": [
        498.0,
        867.4644775390625,
        -55.5
      ],
      "bbox_max": [
        508.0,
        874.5355224609375,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        -0.0
      ],
      "plane_d": 793.3935546875,
      "bbox_min": [
        498.0,
        867.4644775390625,
        -55.5
      ],
      "bbox_max": [
        508.0,
        871.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": -136.0390625,
      "bbox_min": [
        506.53564453125,
        867.4644775390625,
        -55.5
      ],
      "bbox_max": [
        508.0,
        871.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -1013.5552978515625,
      "bbox_min": [
        478.0,
        887.0,
        -55.5
      ],
      "bbox_max": [
        488.0,
        897.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -643.8904418945312,
      "bbox_min": [
        478.0,
        887.0,
        -55.5
      ],
      "bbox_max": [
        488.0,
        897.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 634.651611328125,
      "bbox_min": [
        478.0,
        887.0,
        -55.5
      ],
      "bbox_max": [
        488.0,
        895.5355224609375,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        -0.0
      ],
      "plane_d": 1004.31640625,
      "bbox_min": [
        478.0,
        887.0,
        -55.5
      ],
      "bbox_max": [
        488.0,
        895.5355224609375,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -792.1905517578125,
      "bbox_min": [
        478.0,
        888.4644775390625,
        -55.5
      ],
      "bbox_max": [
        488.0,
        895.5355224609375,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": 100.28656005859375,
      "bbox_min": [
        478.0,
        888.4644775390625,
        -55.5
      ],
      "bbox_max": [
        488.0,
        895.5355224609375,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        -0.0
      ],
      "plane_d": 782.95166015625,
      "bbox_min": [
        478.0,
        888.4644775390625,
        -55.5
      ],
      "bbox_max": [
        488.0,
        892.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": -109.52545166015625,
      "bbox_min": [
        486.53564453125,
        888.4644775390625,
        -55.5
      ],
      "bbox_max": [
        488.0,
        892.0,
        -55.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13233345746994019,
        -0.0643370971083641,
        0.9891150593757629
      ],
      "plane_d": 187.14178466796875,
      "bbox_min": [
        367.0,
        987.5121459960938,
        -60.000038146972656
      ],
      "bbox_max": [
        571.5,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43724507093429565,
        -0.89934241771698,
        1.215229531226214e-06
      ],
      "plane_d": 873.9409790039062,
      "bbox_min": [
        398.95941162109375,
        987.5121459960938,
        -60.000038146972656
      ],
      "bbox_max": [
        571.5,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1298.4000244140625,
      "bbox_min": [
        458.90069580078125,
        1198.053955078125,
        -49.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 43.0,
      "bbox_min": [
        458.90069580078125,
        1198.053955078125,
        -49.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        1.4138863662083168e-06,
        1.0
      ],
      "plane_d": 48.998287200927734,
      "bbox_min": [
        458.90069580078125,
        1198.053955078125,
        -49.0
      ],
      "bbox_max": [
        468.7555847167969,
        1211.5440673828125,
        -47.68153381347656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3713890016078949,
        2.1529244804696646e-06,
        0.9284773468971252
      ],
      "plane_d": 218.3592987060547,
      "bbox_min": [
        465.4593811035156,
        1198.053955078125,
        -49.0
      ],
      "bbox_max": [
        468.7555847167969,
        1211.5440673828125,
        -47.68153381347656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 493.0,
      "bbox_min": [
        463.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        506.0001220703125,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1260.4000244140625,
      "bbox_min": [
        468.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1239.9000244140625,
      "bbox_min": [
        489.9612731933594,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        493.0,
        1239.9000244140625,
        -42.593448638916016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 489.0,
      "bbox_min": [
        468.0,
        1261.0634765625,
        -43.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 41.0,
      "bbox_min": [
        489.0,
        1261.0634765625,
        -43.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1285.9000244140625,
      "bbox_min": [
        489.0,
        1261.0634765625,
        -43.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1270.9000244140625,
      "bbox_min": [
        489.0,
        1261.0634765625,
        -43.0
      ],
      "bbox_max": [
        493.0,
        1270.9000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49323323369026184,
        0.8542128205299377,
        -0.1644429862499237
      ],
      "plane_d": -1329.6009521484375,
      "bbox_min": [
        489.0423889160156,
        1261.0634765625,
        -43.0
      ],
      "bbox_max": [
        492.63812255859375,
        1265.1881103515625,
        -41.06377410888672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4931761622428894,
        0.8542515635490417,
        -0.16441282629966736
      ],
      "plane_d": -845.5188598632812,
      "bbox_min": [
        489.0423889160156,
        1261.0634765625,
        -43.0
      ],
      "bbox_max": [
        490.800048828125,
        1265.1881103515625,
        -41.24290466308594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4931741952896118,
        -0.8542481660842896,
        -0.16443656384944916
      ],
      "plane_d": 1312.4849853515625,
      "bbox_min": [
        489.0423889160156,
        1261.0634765625,
        -43.0
      ],
      "bbox_max": [
        490.800048828125,
        1264.11474609375,
        -41.511199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9863939881324768,
        -0.0,
        -0.16439899802207947
      ],
      "plane_d": 475.5580749511719,
      "bbox_min": [
        489.0423889160156,
        1262.0975341796875,
        -43.0
      ],
      "bbox_max": [
        489.284423828125,
        1264.11474609375,
        -41.547882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1076.358154296875,
      "bbox_min": [
        489.0,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 159.11581420898438,
      "bbox_min": [
        489.0,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1384.87939453125,
      "bbox_min": [
        489.0,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        490.5,
        1296.89697265625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1167.6346435546875,
      "bbox_min": [
        489.0,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        493.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        489.0,
        1285.0999755859375,
        -40.600006103515625
      ],
      "bbox_max": [
        493.0,
        1285.7000732421875,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977863430976868,
        0.0,
        0.06650284677743912
      ],
      "plane_d": 493.2384948730469,
      "bbox_min": [
        489.35260009765625,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        493.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1155.112060546875,
      "bbox_min": [
        491.60009765625,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        493.0,
        1271.7000732421875,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        492.43951416015625,
        1271.0999755859375,
        -40.600006103515625
      ],
      "bbox_max": [
        493.0,
        1271.7000732421875,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        491.60009765625,
        1271.9000244140625,
        -41.0
      ],
      "bbox_max": [
        493.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        491.60009765625,
        1271.9000244140625,
        -41.0
      ],
      "bbox_max": [
        493.0,
        1271.9000244140625,
        -40.51200866699219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1119.341796875,
      "bbox_min": [
        489.35260009765625,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        491.61968994140625,
        1271.9000244140625,
        -40.70623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1155.112060546875,
      "bbox_min": [
        489.8387145996094,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        491.6164855957031,
        1271.02294921875,
        -40.75415802001953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 159.11581420898438,
      "bbox_min": [
        489.0,
        1296.4000244140625,
        -41.0
      ],
      "bbox_max": [
        493.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1384.87939453125,
      "bbox_min": [
        489.0,
        1296.4000244140625,
        -41.0
      ],
      "bbox_max": [
        490.5,
        1296.89697265625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -472.0,
      "bbox_min": [
        468.0,
        1276.8441162109375,
        -43.0
      ],
      "bbox_max": [
        489.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1285.9000244140625,
      "bbox_min": [
        468.0,
        1285.9000244140625,
        -43.0
      ],
      "bbox_max": [
        472.0,
        1298.4000244140625,
        -41.69565963745117
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1378.5894775390625,
      "bbox_min": [
        468.0,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        472.0,
        1298.4000244140625,
        -41.69565963745117
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1082.64794921875,
      "bbox_min": [
        468.0,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        472.0,
        1298.4000244140625,
        -41.69565963745117
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 1012.535400390625,
      "bbox_min": [
        468.0,
        1296.9857177734375,
        -43.0
      ],
      "bbox_max": [
        468.732177734375,
        1298.4000244140625,
        -42.12709426879883
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        472.0,
        1296.89697265625,
        -43.0
      ],
      "bbox_max": [
        489.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 475.0,
      "bbox_min": [
        472.4822998046875,
        1297.4000244140625,
        -43.0
      ],
      "bbox_max": [
        475.0,
        1298.4000244140625,
        -41.19652557373047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        -0.0
      ],
      "plane_d": 1030.29638671875,
      "bbox_min": [
        472.0,
        1296.89697265625,
        -43.0
      ],
      "bbox_max": [
        489.0,
        1297.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1082.64794921875,
      "bbox_min": [
        472.0,
        1296.89697265625,
        -43.0
      ],
      "bbox_max": [
        472.267822265625,
        1296.9857177734375,
        -41.654052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 181.31716918945312,
      "bbox_min": [
        463.0,
        1296.9857177734375,
        -43.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -42.13304901123047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        -0.0
      ],
      "plane_d": 1008.0950927734375,
      "bbox_min": [
        463.0,
        1296.9857177734375,
        -43.0
      ],
      "bbox_max": [
        463.732177734375,
        1298.4000244140625,
        -42.79602813720703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1285.9000244140625,
      "bbox_min": [
        467.59735107421875,
        1285.9000244140625,
        -43.0
      ],
      "bbox_max": [
        468.0,
        1285.9000244140625,
        -42.946128845214844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -531.0,
      "bbox_min": [
        506.0,
        1218.0072021484375,
        -43.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -519.0,
      "bbox_min": [
        506.0,
        1218.0072021484375,
        -43.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1260.4000244140625,
      "bbox_min": [
        506.0,
        1218.0072021484375,
        -43.0
      ],
      "bbox_max": [
        519.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        506.0001220703125,
        1218.0072021484375,
        -43.0
      ],
      "bbox_max": [
        519.0,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 506.5,
      "bbox_min": [
        506.5,
        1218.0072021484375,
        -43.0
      ],
      "bbox_max": [
        506.5,
        1225.0,
        -41.7564697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1239.9000244140625,
      "bbox_min": [
        506.0001220703125,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        519.0,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -41.0,
      "bbox_min": [
        512.0,
        1273.4000244140625,
        -43.0
      ],
      "bbox_max": [
        516.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1283.4000244140625,
      "bbox_min": [
        512.0,
        1273.4000244140625,
        -41.0
      ],
      "bbox_max": [
        516.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.5,
      "bbox_min": [
        512.0,
        1273.4000244140625,
        -41.0
      ],
      "bbox_max": [
        516.0,
        1283.4000244140625,
        -40.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1273.4000244140625,
      "bbox_min": [
        512.0,
        1273.4000244140625,
        -41.0
      ],
      "bbox_max": [
        516.0,
        1273.4000244140625,
        -40.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        513.0,
        1297.4000244140625,
        -41.0
      ],
      "bbox_max": [
        516.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 513.0,
      "bbox_min": [
        513.0,
        1297.4000244140625,
        -41.0
      ],
      "bbox_max": [
        513.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        513.0,
        1274.4000244140625,
        -43.0
      ],
      "bbox_max": [
        516.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 513.0,
      "bbox_min": [
        513.0,
        1297.4000244140625,
        -43.0
      ],
      "bbox_max": [
        513.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1275.4000244140625,
      "bbox_min": [
        513.0,
        1274.4000244140625,
        -43.0
      ],
      "bbox_max": [
        515.0,
        1282.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1274.4000244140625,
      "bbox_min": [
        513.0,
        1274.4000244140625,
        -43.0
      ],
      "bbox_max": [
        515.0,
        1275.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -515.0,
      "bbox_min": [
        513.0,
        1274.4000244140625,
        -43.0
      ],
      "bbox_max": [
        515.0,
        1275.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 513.0,
      "bbox_min": [
        513.0,
        1274.4000244140625,
        -43.0
      ],
      "bbox_max": [
        513.0,
        1275.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1281.4000244140625,
      "bbox_min": [
        513.0,
        1281.4000244140625,
        -43.0
      ],
      "bbox_max": [
        515.0,
        1282.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1282.4000244140625,
      "bbox_min": [
        513.0,
        1281.4000244140625,
        -43.0
      ],
      "bbox_max": [
        515.0,
        1282.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -515.0,
      "bbox_min": [
        515.0,
        1281.4000244140625,
        -43.0
      ],
      "bbox_max": [
        515.0,
        1282.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        516.0,
        1297.4000244140625,
        -43.0
      ],
      "bbox_max": [
        519.0,
        1297.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.9000244140625,
      "bbox_min": [
        506.0,
        1260.7725830078125,
        -43.0
      ],
      "bbox_max": [
        511.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        506.0,
        1270.9000244140625,
        -43.0
      ],
      "bbox_max": [
        511.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 41.0,
      "bbox_min": [
        506.0,
        1270.9000244140625,
        -43.0
      ],
      "bbox_max": [
        510.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1285.9000244140625,
      "bbox_min": [
        506.0,
        1285.9000244140625,
        -43.0
      ],
      "bbox_max": [
        510.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1390.5404052734375,
      "bbox_min": [
        506.0000915527344,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        510.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880849480628967,
        -0.45967939496040344,
        0.0
      ],
      "plane_d": 1046.2188720703125,
      "bbox_min": [
        506.0000915527344,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        510.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1070.6971435546875,
      "bbox_min": [
        508.5,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        510.0,
        1296.89697265625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1155.112060546875,
      "bbox_min": [
        506.0,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        510.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1167.6346435546875,
      "bbox_min": [
        506.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        510.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        506.0,
        1285.0999755859375,
        -40.600006103515625
      ],
      "bbox_max": [
        510.0,
        1285.7000732421875,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977863430976868,
        -0.0,
        0.06650284677743912
      ],
      "plane_d": -503.5500793457031,
      "bbox_min": [
        506.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        510.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        506.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        507.39990234375,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        506.0,
        1284.9000244140625,
        -41.0
      ],
      "bbox_max": [
        507.39990234375,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        506.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        507.39990234375,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        507.37322998046875,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        510.0,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1119.341796875,
      "bbox_min": [
        507.37322998046875,
        1271.7000732421875,
        -41.0
      ],
      "bbox_max": [
        510.0,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1070.6971435546875,
      "bbox_min": [
        508.5,
        1296.4000244140625,
        -41.0
      ],
      "bbox_max": [
        510.0,
        1296.89697265625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 143.130859375,
      "bbox_min": [
        510.0,
        1296.89697265625,
        -43.0
      ],
      "bbox_max": [
        511.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1070.6971435546875,
      "bbox_min": [
        510.0,
        1296.89697265625,
        -43.0
      ],
      "bbox_max": [
        510.267822265625,
        1296.9857177734375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49314722418785095,
        0.8542642593383789,
        -0.16443361341953278
      ],
      "plane_d": -1338.2042236328125,
      "bbox_min": [
        506.1845703125,
        1263.9749755859375,
        -43.0
      ],
      "bbox_max": [
        510.215576171875,
        1265.4273681640625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49319395422935486,
        0.8542417287826538,
        -0.16441093385219574
      ],
      "plane_d": -836.916259765625,
      "bbox_min": [
        506.1845703125,
        1263.9749755859375,
        -43.0
      ],
      "bbox_max": [
        508.199951171875,
        1265.4273681640625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 527.0,
      "bbox_min": [
        519.0,
        1225.0,
        -43.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1270.9000244140625,
      "bbox_min": [
        527.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 41.0,
      "bbox_min": [
        527.0,
        1270.9000244140625,
        -43.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1285.9000244140625,
      "bbox_min": [
        527.0,
        1285.9000244140625,
        -43.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1064.4072265625,
      "bbox_min": [
        527.0,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 125.36978149414062,
      "bbox_min": [
        527.0,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        531.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1396.830322265625,
      "bbox_min": [
        527.0,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        528.5,
        1296.89697265625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1155.112060546875,
      "bbox_min": [
        527.0,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        531.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1167.6346435546875,
      "bbox_min": [
        527.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        531.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        527.0,
        1285.0999755859375,
        -40.600006103515625
      ],
      "bbox_max": [
        531.0,
        1285.7000732421875,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977863430976868,
        0.0,
        0.06650284677743912
      ],
      "plane_d": 531.1543579101562,
      "bbox_min": [
        527.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        531.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        529.60009765625,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        531.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        529.60009765625,
        1284.9000244140625,
        -41.0
      ],
      "bbox_max": [
        531.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        529.60009765625,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        531.0,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        527.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        529.6267700195312,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1119.341796875,
      "bbox_min": [
        527.0,
        1271.7000732421875,
        -41.0
      ],
      "bbox_max": [
        529.6267700195312,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1396.830322265625,
      "bbox_min": [
        527.0,
        1296.4000244140625,
        -41.0
      ],
      "bbox_max": [
        528.5,
        1296.89697265625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 529.0,
      "bbox_min": [
        529.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        531.0,
        1260.4000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1239.9000244140625,
      "bbox_min": [
        529.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        531.0,
        1260.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1396.830322265625,
      "bbox_min": [
        526.732177734375,
        1296.89697265625,
        -43.0
      ],
      "bbox_max": [
        527.0,
        1296.9857177734375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -524.0,
      "bbox_min": [
        524.0,
        1297.4000244140625,
        -43.0
      ],
      "bbox_max": [
        524.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        519.0,
        1225.0,
        -43.0
      ],
      "bbox_max": [
        520.8829956054688,
        1225.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1260.4000244140625,
      "bbox_min": [
        543.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1239.9000244140625,
      "bbox_min": [
        543.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        551.530029296875,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1285.9000244140625,
      "bbox_min": [
        543.0,
        1260.7725830078125,
        -43.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 552.0,
      "bbox_min": [
        551.784423828125,
        1260.7725830078125,
        -43.0
      ],
      "bbox_max": [
        556.0,
        1285.9000244140625,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 41.0,
      "bbox_min": [
        552.0,
        1260.7725830078125,
        -43.0
      ],
      "bbox_max": [
        556.0,
        1285.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1270.9000244140625,
      "bbox_min": [
        552.0,
        1260.965087890625,
        -43.0
      ],
      "bbox_max": [
        556.0,
        1270.9000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49323323369026184,
        0.8542128205299377,
        -0.1644429862499237
      ],
      "plane_d": -1360.6746826171875,
      "bbox_min": [
        552.0,
        1260.965087890625,
        -43.0
      ],
      "bbox_max": [
        555.6487426757812,
        1265.23486328125,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4931741952896118,
        -0.8542481660842896,
        -0.16443656384944916
      ],
      "plane_d": 1343.554931640625,
      "bbox_min": [
        552.0,
        1260.965087890625,
        -43.0
      ],
      "bbox_max": [
        553.800048828125,
        1265.23486328125,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4931761622428894,
        0.8542515635490417,
        -0.16441282629966736
      ],
      "plane_d": -814.44873046875,
      "bbox_min": [
        552.0,
        1262.0606689453125,
        -43.0
      ],
      "bbox_max": [
        553.800048828125,
        1265.23486328125,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9863939881324768,
        -0.0,
        -0.16439899802207947
      ],
      "plane_d": 537.7008666992188,
      "bbox_min": [
        552.0,
        1262.0606689453125,
        -43.0
      ],
      "bbox_max": [
        552.284423828125,
        1264.1392822265625,
        -41.29345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1155.112060546875,
      "bbox_min": [
        552.0,
        1260.7725830078125,
        -41.0
      ],
      "bbox_max": [
        556.0,
        1285.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1131.8643798828125,
      "bbox_min": [
        552.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        556.0,
        1285.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1167.6346435546875,
      "bbox_min": [
        552.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        556.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        552.0,
        1285.0999755859375,
        -40.600006103515625
      ],
      "bbox_max": [
        556.0,
        1285.7000732421875,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977863430976868,
        0.0,
        0.06650284677743912
      ],
      "plane_d": 556.0989990234375,
      "bbox_min": [
        552.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        556.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        554.60009765625,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        556.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        554.60009765625,
        1284.9000244140625,
        -41.0
      ],
      "bbox_max": [
        556.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        554.60009765625,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        556.0,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        552.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        554.6267700195312,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49323323369026184,
        0.8542128205299377,
        -0.1644429862499237
      ],
      "plane_d": -1360.6746826171875,
      "bbox_min": [
        552.0,
        1260.7725830078125,
        -41.0
      ],
      "bbox_max": [
        555.8154296875,
        1265.4273681640625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4931741952896118,
        -0.8542481660842896,
        -0.16443656384944916
      ],
      "plane_d": 1343.554931640625,
      "bbox_min": [
        552.0,
        1260.7725830078125,
        -41.0
      ],
      "bbox_max": [
        553.800048828125,
        1262.004150390625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4931761622428894,
        0.8542515635490417,
        -0.16441282629966736
      ],
      "plane_d": -814.44873046875,
      "bbox_min": [
        551.784423828125,
        1264.1392822265625,
        -41.29345703125
      ],
      "bbox_max": [
        552.0,
        1264.38818359375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        -0.0
      ],
      "plane_d": 1086.243896484375,
      "bbox_min": [
        543.0,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1404.692626953125,
      "bbox_min": [
        551.732177734375,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1056.5447998046875,
      "bbox_min": [
        553.5,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 103.16845703125,
      "bbox_min": [
        555.267822265625,
        1296.9857177734375,
        -43.0
      ],
      "bbox_max": [
        556.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        543.0,
        1297.4000244140625,
        -43.0
      ],
      "bbox_max": [
        549.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -549.0,
      "bbox_min": [
        549.0,
        1297.4000244140625,
        -43.0
      ],
      "bbox_max": [
        549.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -535.0,
      "bbox_min": [
        531.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        543.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.9000244140625,
      "bbox_min": [
        531.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        535.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 41.0,
      "bbox_min": [
        531.0,
        1270.9000244140625,
        -43.0
      ],
      "bbox_max": [
        535.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1285.9000244140625,
      "bbox_min": [
        531.0,
        1285.9000244140625,
        -43.0
      ],
      "bbox_max": [
        535.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1398.40283203125,
      "bbox_min": [
        531.0,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        535.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 1068.4827880859375,
      "bbox_min": [
        531.0,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        535.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1062.834716796875,
      "bbox_min": [
        533.5,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        535.0,
        1296.89697265625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1155.112060546875,
      "bbox_min": [
        531.0,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        535.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1167.6346435546875,
      "bbox_min": [
        531.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        535.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        531.0,
        1285.0999755859375,
        -40.600006103515625
      ],
      "bbox_max": [
        535.0,
        1285.7000732421875,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977863430976868,
        -0.0,
        0.06650284677743912
      ],
      "plane_d": -528.4947509765625,
      "bbox_min": [
        531.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        535.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        531.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        532.39990234375,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        531.0,
        1284.9000244140625,
        -41.0
      ],
      "bbox_max": [
        532.39990234375,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        531.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        532.39990234375,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        532.3732299804688,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        535.0,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1119.341796875,
      "bbox_min": [
        532.3732299804688,
        1271.7000732421875,
        -41.0
      ],
      "bbox_max": [
        535.0,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1062.834716796875,
      "bbox_min": [
        533.5,
        1296.4000244140625,
        -41.0
      ],
      "bbox_max": [
        535.0,
        1296.89697265625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -533.0,
      "bbox_min": [
        531.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        533.0,
        1260.4000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1239.9000244140625,
      "bbox_min": [
        531.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        533.0,
        1260.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1062.834716796875,
      "bbox_min": [
        535.0,
        1296.89697265625,
        -43.0
      ],
      "bbox_max": [
        535.267822265625,
        1296.9857177734375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 538.0,
      "bbox_min": [
        538.0,
        1297.4000244140625,
        -43.0
      ],
      "bbox_max": [
        538.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1211.5439453125,
      "bbox_min": [
        439.98992919921875,
        987.5121459960938,
        -60.000038146972656
      ],
      "bbox_max": [
        571.5,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 43.0,
      "bbox_min": [
        501.73199462890625,
        1211.5440673828125,
        -43.0
      ],
      "bbox_max": [
        571.5,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 506.5,
      "bbox_min": [
        506.5,
        1211.5440673828125,
        -43.0
      ],
      "bbox_max": [
        557.4915161132812,
        1225.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18506789207458496,
        0.9827257990837097,
        0.0
      ],
      "plane_d": -1306.7369384765625,
      "bbox_min": [
        556.0,
        1224.7191162109375,
        -43.0
      ],
      "bbox_max": [
        557.4915161132812,
        1225.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8949131369590759,
        0.44624048471450806,
        0.0
      ],
      "plane_d": -32.612762451171875,
      "bbox_min": [
        570.915283203125,
        1218.025634765625,
        -43.0
      ],
      "bbox_max": [
        571.5,
        1219.1982421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4462319314479828,
        -0.8949174284934998,
        -0.0
      ],
      "plane_d": 1360.3017578125,
      "bbox_min": [
        551.530029296875,
        1235.0638427734375,
        -43.0
      ],
      "bbox_max": [
        571.5,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 999.9999389648438,
      "bbox_min": [
        485.5653991699219,
        987.5121459960938,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1042.2559814453125,
        -45.25708770751953
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.8910040855407715,
        0.4539954662322998,
        0.0
      ],
      "plane_d": -979.3419799804688,
      "bbox_min": [
        552.0,
        1000.0,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1042.2559814453125,
        -45.25708770751953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 558.0,
      "bbox_min": [
        552.0,
        1000.0,
        -60.0
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -552.0,
      "bbox_min": [
        552.0,
        1000.0,
        -60.0
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -52.5,
      "bbox_min": [
        552.0,
        1000.0,
        -52.5
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6178141236305237,
        0.786324143409729,
        0.0
      ],
      "plane_d": -1168.880126953125,
      "bbox_min": [
        569.8525390625,
        1037.4847412109375,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1038.7791748046875,
        -45.25708770751953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588190734386444,
        -0.9659258723258972,
        -0.0
      ],
      "plane_d": 1129.7991943359375,
      "bbox_min": [
        485.5653991699219,
        1005.2578125,
        -60.0
      ],
      "bbox_max": [
        535.0,
        1042.2559814453125,
        -52.05824279785156
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071129679679871,
        -0.7071005702018738,
        -0.0
      ],
      "plane_d": 1088.6036376953125,
      "bbox_min": [
        485.5653991699219,
        1034.272705078125,
        -60.0
      ],
      "bbox_max": [
        505.25,
        1042.2559814453125,
        -54.3295783996582
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659262895584106,
        -0.2588176429271698,
        0.0
      ],
      "plane_d": 753.2635498046875,
      "bbox_min": [
        500.5653991699219,
        1037.75,
        -60.0
      ],
      "bbox_max": [
        501.77276611328125,
        1042.2559814453125,
        -54.43705368041992
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659260511398315,
        0.2588180601596832,
        0.0
      ],
      "plane_d": -738.77490234375,
      "bbox_min": [
        486.3473205566406,
        1005.2578125,
        -60.0
      ],
      "bbox_max": [
        535.0,
        1039.3377685546875,
        -52.05824279785156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        488.7823791503906,
        1005.2578125,
        -60.0
      ],
      "bbox_max": [
        535.0,
        1030.25,
        -52.05824279785156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881466269493103,
        0.965927004814148,
        -0.0
      ],
      "plane_d": -1115.3092041015625,
      "bbox_min": [
        488.7823791503906,
        1013.392822265625,
        -60.0
      ],
      "bbox_max": [
        518.2674560546875,
        1030.25,
        -53.94609832763672
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -1083.04736328125,
      "bbox_min": [
        515.0,
        1013.392822265625,
        -60.0
      ],
      "bbox_max": [
        518.2674560546875,
        1016.6602783203125,
        -53.94609832763672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        0.7071055769920349,
        -0.0
      ],
      "plane_d": -1074.117431640625,
      "bbox_min": [
        488.7823791503906,
        1025.3416748046875,
        -60.0
      ],
      "bbox_max": [
        493.6907043457031,
        1030.25,
        -56.45701217651367
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 50.5,
      "bbox_min": [
        550.0,
        999.0,
        -60.0
      ],
      "bbox_max": [
        560.0,
        1000.0,
        -50.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 999.0,
      "bbox_min": [
        550.0,
        999.0,
        -60.0
      ],
      "bbox_max": [
        560.0,
        1000.0,
        -50.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 57.0,
      "bbox_min": [
        552.0,
        999.0,
        -57.0
      ],
      "bbox_max": [
        558.0,
        1000.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -52.5,
      "bbox_min": [
        552.0,
        999.0,
        -57.0
      ],
      "bbox_max": [
        558.0,
        1000.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 558.0,
      "bbox_min": [
        552.0,
        999.0,
        -57.0
      ],
      "bbox_max": [
        558.0,
        1000.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -552.0,
      "bbox_min": [
        552.0,
        999.0,
        -57.0
      ],
      "bbox_max": [
        552.0,
        1000.0,
        -52.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -990.0,
      "bbox_min": [
        565.699951171875,
        987.5121459960938,
        -60.0
      ],
      "bbox_max": [
        571.5,
        998.48193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 57.5,
      "bbox_min": [
        566.3828735351562,
        987.5121459960938,
        -57.5
      ],
      "bbox_max": [
        571.5,
        990.0,
        -56.599998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -988.5,
      "bbox_min": [
        569.4681396484375,
        987.9983520507812,
        -57.5
      ],
      "bbox_max": [
        570.5,
        988.5,
        -56.599998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 56.599998474121094,
      "bbox_min": [
        569.4681396484375,
        987.9983520507812,
        -56.599998474121094
      ],
      "bbox_max": [
        570.5,
        988.5,
        -56.599998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 995.01806640625,
      "bbox_min": [
        565.699951171875,
        995.01806640625,
        -60.0
      ],
      "bbox_max": [
        569.699951171875,
        998.48193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -998.48193359375,
      "bbox_min": [
        565.699951171875,
        995.01806640625,
        -60.0
      ],
      "bbox_max": [
        569.699951171875,
        998.48193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -8.498046875,
      "bbox_min": [
        565.699951171875,
        995.01806640625,
        -60.0
      ],
      "bbox_max": [
        569.699951171875,
        998.48193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        -0.5000253915786743,
        -0.0
      ],
      "plane_d": 988.3025512695312,
      "bbox_min": [
        565.699951171875,
        995.01806640625,
        -60.0
      ],
      "bbox_max": [
        569.699951171875,
        998.48193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": 5.03399658203125,
      "bbox_min": [
        565.699951171875,
        995.01806640625,
        -60.0
      ],
      "bbox_max": [
        569.699951171875,
        998.48193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 56.0,
      "bbox_min": [
        565.699951171875,
        995.01806640625,
        -60.0
      ],
      "bbox_max": [
        569.699951171875,
        998.48193359375,
        -56.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 998.23193359375,
      "bbox_min": [
        565.988525390625,
        995.26806640625,
        -60.0
      ],
      "bbox_max": [
        569.411376953125,
        998.23193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -995.26806640625,
      "bbox_min": [
        565.988525390625,
        995.26806640625,
        -60.0
      ],
      "bbox_max": [
        569.411376953125,
        998.23193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659955263137817,
        -0.5000517964363098,
        -0.0
      ],
      "plane_d": 991.5343017578125,
      "bbox_min": [
        565.988525390625,
        995.26806640625,
        -60.0
      ],
      "bbox_max": [
        569.411376953125,
        998.23193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8659955263137817,
        0.5000517964363098,
        0.0
      ],
      "plane_d": -5.318939208984375,
      "bbox_min": [
        565.988525390625,
        995.26806640625,
        -60.0
      ],
      "bbox_max": [
        569.411376953125,
        998.23193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659955263137817,
        -0.5000517964363098,
        0.0
      ],
      "plane_d": 8.283111572265625,
      "bbox_min": [
        565.988525390625,
        995.26806640625,
        -60.0
      ],
      "bbox_max": [
        566.84423828125,
        998.23193359375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8659955263137817,
        0.5000517964363098,
        0.0
      ],
      "plane_d": -988.5701904296875,
      "bbox_min": [
        565.988525390625,
        995.26806640625,
        -60.0
      ],
      "bbox_max": [
        566.84423828125,
        996.75,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43724513053894043,
        -0.8993424773216248,
        -2.4261203179776203e-06
      ],
      "plane_d": 1311.18603515625,
      "bbox_min": [
        439.98992919921875,
        1042.2559814453125,
        -60.000038146972656
      ],
      "bbox_max": [
        571.5,
        1211.5440673828125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13233178853988647,
        -0.06434018909931183,
        0.9891151189804077
      ],
      "plane_d": 54.81299591064453,
      "bbox_min": [
        506.7938232421875,
        1180.0848388671875,
        -55.11362838745117
      ],
      "bbox_max": [
        571.5,
        1211.5440673828125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.200197369069348e-13,
        -2.827772959790309e-06,
        1.0
      ],
      "plane_d": 49.00342559814453,
      "bbox_min": [
        531.2444458007812,
        1198.053955078125,
        -49.000038146972656
      ],
      "bbox_max": [
        541.0991821289062,
        1211.5440673828125,
        -47.68156051635742
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37138935923576355,
        -4.305850325181382e-06,
        0.9284772872924805
      ],
      "plane_d": -153.0220947265625,
      "bbox_min": [
        531.2444458007812,
        1198.053955078125,
        -49.000038146972656
      ],
      "bbox_max": [
        534.5405883789062,
        1211.5440673828125,
        -47.68156051635742
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 43.0,
      "bbox_min": [
        506.7938232421875,
        1205.3468017578125,
        -43.0
      ],
      "bbox_max": [
        519.54052734375,
        1211.5440673828125,
        -42.288490295410156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -509.0653991699219,
      "bbox_min": [
        509.0653991699219,
        1210.4395751953125,
        -43.0
      ],
      "bbox_max": [
        509.0653991699219,
        1211.5440673828125,
        -42.288490295410156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1198.053955078125,
      "bbox_min": [
        439.98992919921875,
        1042.2559814453125,
        -60.000038146972656
      ],
      "bbox_max": [
        571.5,
        1211.5440673828125,
        -42.36032485961914
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1209.800048828125,
      "bbox_min": [
        506.5,
        1209.800048828125,
        -43.0
      ],
      "bbox_max": [
        509.0653991699219,
        1211.5440673828125,
        -42.36032485961914
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 506.4999694824219,
      "bbox_min": [
        506.5,
        1209.800048828125,
        -43.0
      ],
      "bbox_max": [
        509.0653991699219,
        1211.5440673828125,
        -42.36032485961914
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8910040855407715,
        0.4539954662322998,
        0.0
      ],
      "plane_d": -979.3419799804688,
      "bbox_min": [
        562.7239990234375,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1057.036376953125,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9553669691085815,
        -0.2954215705394745
      ],
      "plane_d": -1037.5443115234375,
      "bbox_min": [
        455.4723205566406,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        562.7239990234375,
        1069.0306396484375,
        -45.43699645996094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1062.5,
      "bbox_min": [
        455.4723205566406,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        562.7239990234375,
        1068.7000732421875,
        -45.43699645996094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 56.0,
      "bbox_min": [
        462.7425842285156,
        1062.5,
        -60.0
      ],
      "bbox_max": [
        511.1171875,
        1068.7000732421875,
        -56.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 56.70000076293945,
      "bbox_min": [
        462.7425842285156,
        1062.5,
        -60.0
      ],
      "bbox_max": [
        511.1171875,
        1068.7000732421875,
        -56.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.24800020456314087,
        0.9255213737487793,
        -0.2861925959587097
      ],
      "plane_d": -1129.007568359375,
      "bbox_min": [
        462.7425842285156,
        1063.800048828125,
        -60.0
      ],
      "bbox_max": [
        509.52142333984375,
        1068.483642578125,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22157210111618042,
        0.8269203901290894,
        -0.5168255567550659
      ],
      "plane_d": -1023.843505859375,
      "bbox_min": [
        462.7425842285156,
        1063.800048828125,
        -60.0
      ],
      "bbox_max": [
        509.52142333984375,
        1068.13916015625,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6775355339050293,
        0.6775316596031189,
        -0.28617575764656067
      ],
      "plane_d": -1082.2032470703125,
      "bbox_min": [
        462.7425842285156,
        1063.800048828125,
        -60.0
      ],
      "bbox_max": [
        509.52142333984375,
        1068.13916015625,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38270068168640137,
        -0.9238723516464233,
        -0.0
      ],
      "plane_d": 1162.51416015625,
      "bbox_min": [
        462.7425842285156,
        1063.800048828125,
        -60.0
      ],
      "bbox_max": [
        475.5,
        1068.13916015625,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40017983317375183,
        -0.9164366126060486,
        0.0
      ],
      "plane_d": 1164.0621337890625,
      "bbox_min": [
        462.7425842285156,
        1063.800048828125,
        -60.0
      ],
      "bbox_max": [
        475.5,
        1068.13916015625,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13051459193229675,
        -0.9914464950561523,
        -0.0
      ],
      "plane_d": 1116.760498046875,
      "bbox_min": [
        471.72125244140625,
        1063.800048828125,
        -60.0
      ],
      "bbox_max": [
        475.5,
        1064.2974853515625,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -57.20000076293945,
      "bbox_min": [
        471.72125244140625,
        1063.800048828125,
        -57.20000076293945
      ],
      "bbox_max": [
        475.5,
        1064.2974853515625,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -57.20000076293945,
      "bbox_min": [
        468.56170654296875,
        1063.800048828125,
        -57.20000076293945
      ],
      "bbox_max": [
        472.9219665527344,
        1065.6063232421875,
        -57.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -57.20000076293945,
      "bbox_min": [
        469.5542907714844,
        1062.5,
        -60.0
      ],
      "bbox_max": [
        510.8215026855469,
        1063.800048828125,
        -56.70000076293945
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.2588307559490204,
        -0.9659227132797241,
        -0.0
      ],
      "plane_d": 1156.8345947265625,
      "bbox_min": [
        469.5542907714844,
        1062.5,
        -57.20000076293945
      ],
      "bbox_max": [
        510.8215026855469,
        1063.800048828125,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6775355339050293,
        0.6775316596031189,
        -0.28617575764656067
      ],
      "plane_d": -1082.2032470703125,
      "bbox_min": [
        509.31024169921875,
        1062.5,
        -57.20000076293945
      ],
      "bbox_max": [
        510.8215026855469,
        1063.800048828125,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13051842153072357,
        -0.9914458990097046,
        -0.0
      ],
      "plane_d": 1115.4727783203125,
      "bbox_min": [
        469.5542907714844,
        1062.5,
        -57.20000076293945
      ],
      "bbox_max": [
        475.5,
        1063.800048828125,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38270068168640137,
        -0.9238723516464233,
        -0.0
      ],
      "plane_d": 1162.51416015625,
      "bbox_min": [
        469.5542907714844,
        1063.041748046875,
        -57.20000076293945
      ],
      "bbox_max": [
        471.384765625,
        1063.800048828125,
        -56.98911666870117
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053593754768372,
        0.6053476333618164,
        -0.5168114304542542
      ],
      "plane_d": -982.0289306640625,
      "bbox_min": [
        507.2217102050781,
        1062.5,
        -60.0
      ],
      "bbox_max": [
        510.61029052734375,
        1063.800048828125,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6775355339050293,
        0.6775316596031189,
        -0.28617575764656067
      ],
      "plane_d": -1082.2032470703125,
      "bbox_min": [
        509.0145568847656,
        1062.5,
        -57.900001525878906
      ],
      "bbox_max": [
        510.61029052734375,
        1063.800048828125,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1063.800048828125,
      "bbox_min": [
        473.0182189941406,
        1062.5,
        -56.70000076293945
      ],
      "bbox_max": [
        511.1171875,
        1068.7000732421875,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24800020456314087,
        0.9255213737487793,
        -0.2861925959587097
      ],
      "plane_d": -1129.007568359375,
      "bbox_min": [
        473.0182189941406,
        1063.800048828125,
        -56.70000076293945
      ],
      "bbox_max": [
        509.817138671875,
        1068.7000732421875,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6775355339050293,
        0.6775316596031189,
        -0.28617575764656067
      ],
      "plane_d": -1082.2032470703125,
      "bbox_min": [
        473.0182189941406,
        1063.800048828125,
        -56.70000076293945
      ],
      "bbox_max": [
        509.817138671875,
        1066.7171630859375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6775355339050293,
        0.6775316596031189,
        -0.28617575764656067
      ],
      "plane_d": -1082.2032470703125,
      "bbox_min": [
        509.52142333984375,
        1062.5,
        -56.70000076293945
      ],
      "bbox_max": [
        511.1171875,
        1063.800048828125,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4372328221797943,
        0.8993483781814575,
        0.0
      ],
      "plane_d": -702.7651977539062,
      "bbox_min": [
        455.4723205566406,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        562.7239990234375,
        1062.5,
        -45.43699645996094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8993521928787231,
        0.4372249245643616,
        0.0
      ],
      "plane_d": -966.3841552734375,
      "bbox_min": [
        557.7904663085938,
        1050.796142578125,
        -60.0
      ],
      "bbox_max": [
        562.7239990234375,
        1054.5682373046875,
        -45.43699645996094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8993521928787231,
        -0.4372249245643616,
        -0.0
      ],
      "plane_d": 961.8707885742188,
      "bbox_min": [
        557.7904663085938,
        1050.796142578125,
        -60.0
      ],
      "bbox_max": [
        558.6649169921875,
        1052.5948486328125,
        -46.108428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8479981422424316,
        0.0,
        -0.5299991965293884
      ],
      "plane_d": -466.3142395019531,
      "bbox_min": [
        455.4723205566406,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        514.2999877929688,
        1062.5,
        -53.98038101196289
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9553756713867188,
        0.0,
        -0.29539355635643005
      ],
      "plane_d": -507.8917541503906,
      "bbox_min": [
        455.4723205566406,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        514.2999877929688,
        1062.5,
        -53.98038101196289
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9255261421203613,
        0.2479996532201767,
        -0.2861773371696472
      ],
      "plane_d": -753.390869140625,
      "bbox_min": [
        455.4723205566406,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        514.2999877929688,
        1062.5,
        -53.98038101196289
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8269185423851013,
        0.22157764434814453,
        -0.5168259739875793
      ],
      "plane_d": -688.2432861328125,
      "bbox_min": [
        455.4723205566406,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        514.2999877929688,
        1062.5,
        -53.98038101196289
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -471.5,
      "bbox_min": [
        455.4723205566406,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        514.2999877929688,
        1062.5,
        -53.98038101196289
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1047.2559814453125,
      "bbox_min": [
        455.4723205566406,
        1047.2559814453125,
        -60.0
      ],
      "bbox_max": [
        471.5,
        1049.482421875,
        -58.0004768371582
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4372434616088867,
        0.8993433117866516,
        0.0
      ],
      "plane_d": -1142.997314453125,
      "bbox_min": [
        455.4723205566406,
        1047.2559814453125,
        -60.0
      ],
      "bbox_max": [
        460.0517578125,
        1049.482421875,
        -59.53213882446289
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -485.56536865234375,
      "bbox_min": [
        483.0,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        514.2999877929688,
        1062.5,
        -53.98038101196289
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1044.0,
      "bbox_min": [
        483.0,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        485.5653991699219,
        1044.0,
        -56.33045196533203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 483.0,
      "bbox_min": [
        483.0,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        483.0,
        1044.0,
        -56.67368698120117
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 56.0,
      "bbox_min": [
        499.5,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        514.2999877929688,
        1062.5,
        -53.98038101196289
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 509.3999938964844,
      "bbox_min": [
        499.5,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        512.317138671875,
        1062.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053593754768372,
        0.6053476333618164,
        -0.5168114304542542
      ],
      "plane_d": -982.0289306640625,
      "bbox_min": [
        509.3999938964844,
        1060.3499755859375,
        -60.0
      ],
      "bbox_max": [
        512.317138671875,
        1062.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6775355339050293,
        0.6775316596031189,
        -0.28617575764656067
      ],
      "plane_d": -1082.2032470703125,
      "bbox_min": [
        510.3146057128906,
        1061.0062255859375,
        -57.900001525878906
      ],
      "bbox_max": [
        512.317138671875,
        1062.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707109808921814,
        -0.7071038484573364,
        -0.0
      ],
      "plane_d": 1107.980712890625,
      "bbox_min": [
        499.5,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        509.3999938964844,
        1062.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053593754768372,
        0.6053476333618164,
        -0.5168114304542542
      ],
      "plane_d": -982.0289306640625,
      "bbox_min": [
        508.521728515625,
        1061.6217041015625,
        -60.0
      ],
      "bbox_max": [
        509.3999938964844,
        1062.5,
        -58.97128677368164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 56.70000076293945,
      "bbox_min": [
        508.1000061035156,
        1042.2559814453125,
        -57.20000076293945
      ],
      "bbox_max": [
        509.3999938964844,
        1058.7515869140625,
        -56.70000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -57.20000076293945,
      "bbox_min": [
        508.1000061035156,
        1042.2559814453125,
        -57.20000076293945
      ],
      "bbox_max": [
        509.3999938964844,
        1058.7515869140625,
        -57.20000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.5653991699219,
      "bbox_min": [
        500.5653991699219,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        503.13079833984375,
        1044.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -503.1307678222656,
      "bbox_min": [
        503.13079833984375,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        503.13079833984375,
        1044.0,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588307559490204,
        -0.9659227132797241,
        -0.0
      ],
      "plane_d": 1156.8345947265625,
      "bbox_min": [
        499.5,
        1053.9000244140625,
        -60.0
      ],
      "bbox_max": [
        508.1000061035156,
        1062.5,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 56.69999694824219,
      "bbox_min": [
        499.5,
        1053.9000244140625,
        -57.20000076293945
      ],
      "bbox_max": [
        508.1000061035156,
        1062.5,
        -56.70000076293945
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2588008642196655,
        -0.965930700302124,
        -0.0
      ],
      "plane_d": 1155.5723876953125,
      "bbox_min": [
        499.5,
        1058.2000732421875,
        -57.20000076293945
      ],
      "bbox_max": [
        506.94781494140625,
        1062.5,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071102261543274,
        -0.7071033716201782,
        -0.0
      ],
      "plane_d": 1106.724853515625,
      "bbox_min": [
        503.8000183105469,
        1058.2000732421875,
        -57.20000076293945
      ],
      "bbox_max": [
        506.94781494140625,
        1061.347900390625,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1044.0,
      "bbox_min": [
        500.5653991699219,
        1042.2559814453125,
        -56.0
      ],
      "bbox_max": [
        503.13079833984375,
        1044.0,
        -53.98038101196289
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -503.1307678222656,
      "bbox_min": [
        500.5653991699219,
        1042.2559814453125,
        -56.0
      ],
      "bbox_max": [
        503.13079833984375,
        1044.0,
        -53.98038101196289
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.5653991699219,
      "bbox_min": [
        500.5653991699219,
        1042.2559814453125,
        -56.0
      ],
      "bbox_max": [
        500.5653991699219,
        1044.0,
        -54.32361602783203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12481009215116501,
        0.9478961825370789,
        -0.2931131422519684
      ],
      "plane_d": -1088.7781982421875,
      "bbox_min": [
        462.6883850097656,
        1068.112548828125,
        -57.900028228759766
      ],
      "bbox_max": [
        475.5,
        1069.0306396484375,
        -56.07194519042969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40017983317375183,
        -0.9164366126060486,
        0.0
      ],
      "plane_d": 1164.0621337890625,
      "bbox_min": [
        462.6883850097656,
        1068.112548828125,
        -57.900028228759766
      ],
      "bbox_max": [
        462.80364990234375,
        1068.162841796875,
        -57.81378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36587274074554443,
        0.8833051919937134,
        -0.2931027114391327
      ],
      "plane_d": -1133.748046875,
      "bbox_min": [
        472.6441345214844,
        1068.7840576171875,
        -56.82561111450195
      ],
      "bbox_max": [
        472.95770263671875,
        1069.0306396484375,
        -56.396827697753906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36587274074554443,
        0.8833051919937134,
        -0.2931027114391327
      ],
      "plane_d": -1133.748046875,
      "bbox_min": [
        470.35626220703125,
        1068.511474609375,
        -57.900001525878906
      ],
      "bbox_max": [
        473.60797119140625,
        1069.8228759765625,
        -56.43107223510742
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12481009215116501,
        0.9478961825370789,
        -0.2931131422519684
      ],
      "plane_d": -1088.7781982421875,
      "bbox_min": [
        472.8503723144531,
        1068.511474609375,
        -57.73802185058594
      ],
      "bbox_max": [
        473.60797119140625,
        1068.7840576171875,
        -56.82561111450195
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1156.4000244140625,
      "bbox_min": [
        469.70001220703125,
        1066.800048828125,
        -60.0
      ],
      "bbox_max": [
        514.5,
        1156.4000244140625,
        -45.79868698120117
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        -0.6246950626373291,
        0.0
      ],
      "plane_d": 308.146484375,
      "bbox_min": [
        469.70001220703125,
        1066.800048828125,
        -60.0
      ],
      "bbox_max": [
        514.5,
        1156.4000244140625,
        -45.79868698120117
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -514.5,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -60.0
      ],
      "bbox_max": [
        514.5,
        1156.4000244140625,
        -45.79868698120117
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1126.4000244140625,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -60.0
      ],
      "bbox_max": [
        506.5,
        1156.4000244140625,
        -47.95780944824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.6246950626373291,
        0.0
      ],
      "plane_d": -337.03863525390625,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -60.0
      ],
      "bbox_max": [
        493.5,
        1156.4000244140625,
        -47.95780944824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        -0.6246950626373291,
        -0.0
      ],
      "plane_d": 1089.015380859375,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -60.0
      ],
      "bbox_max": [
        493.5,
        1146.4000244140625,
        -49.678585052490234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 485.5,
      "bbox_min": [
        485.5,
        1136.4000244140625,
        -60.0
      ],
      "bbox_max": [
        485.5,
        1146.4000244140625,
        -49.678585052490234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32528290152549744,
        0.7853236198425293,
        -0.526742696762085
      ],
      "plane_d": -1023.3936767578125,
      "bbox_min": [
        469.70001220703125,
        1066.800048828125,
        -60.0
      ],
      "bbox_max": [
        475.5,
        1069.4908447265625,
        -57.11106491088867
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36587274074554443,
        0.8833051919937134,
        -0.2931027114391327
      ],
      "plane_d": -1133.748046875,
      "bbox_min": [
        470.35626220703125,
        1068.463134765625,
        -57.900001525878906
      ],
      "bbox_max": [
        473.76385498046875,
        1069.4908447265625,
        -57.11106491088867
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12481009215116501,
        0.9478961825370789,
        -0.2931131422519684
      ],
      "plane_d": -1088.7781982421875,
      "bbox_min": [
        472.83740234375,
        1068.112548828125,
        -57.900001525878906
      ],
      "bbox_max": [
        475.5,
        1068.56494140625,
        -57.176063537597656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3585740923881531,
        -0.9335013031959534
      ],
      "plane_d": 388.05029296875,
      "bbox_min": [
        499.0940856933594,
        1195.8480224609375,
        -44.5
      ],
      "bbox_max": [
        506.5,
        1198.053955078125,
        -43.50917434692383
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -506.5,
      "bbox_min": [
        506.5,
        1195.8480224609375,
        -44.5
      ],
      "bbox_max": [
        506.5,
        1198.053955078125,
        -43.50917434692383
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43724513053894043,
        -0.8993424773216248,
        0.0
      ],
      "plane_d": 888.94091796875,
      "bbox_min": [
        367.0,
        987.5121459960938,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 43.0,
      "bbox_min": [
        411.799560546875,
        1214.2452392578125,
        -43.0
      ],
      "bbox_max": [
        512.3844604492188,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.18506789207458496,
        0.9827257990837097,
        0.0
      ],
      "plane_d": -1121.9466552734375,
      "bbox_min": [
        441.00848388671875,
        1224.7191162109375,
        -43.0
      ],
      "bbox_max": [
        442.5,
        1225.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949185013771057,
        0.44622984528541565,
        -0.0
      ],
      "plane_d": -915.6727905273438,
      "bbox_min": [
        412.3741455078125,
        1214.2452392578125,
        -43.0
      ],
      "bbox_max": [
        427.584716796875,
        1225.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949130177497864,
        0.44624045491218567,
        0.0
      ],
      "plane_d": -926.1834106445312,
      "bbox_min": [
        427.1334533691406,
        1218.025634765625,
        -43.0
      ],
      "bbox_max": [
        427.584716796875,
        1218.9306640625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8949149250984192,
        -0.44623681902885437,
        0.0
      ],
      "plane_d": 925.6797485351562,
      "bbox_min": [
        425.79339599609375,
        1218.70751953125,
        -43.0
      ],
      "bbox_max": [
        426.6859130859375,
        1220.7205810546875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44623687863349915,
        0.8949148654937744,
        0.0
      ],
      "plane_d": -902.2366333007812,
      "bbox_min": [
        425.79339599609375,
        1220.4974365234375,
        -43.0
      ],
      "bbox_max": [
        426.24090576171875,
        1220.7205810546875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        6.424753337341826e-06
      ],
      "plane_d": -442.9998474121094,
      "bbox_min": [
        411.799560546875,
        1225.0,
        -43.0
      ],
      "bbox_max": [
        512.3844604492188,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4462319314479828,
        -0.8949174284934998,
        0.0
      ],
      "plane_d": 914.7391967773438,
      "bbox_min": [
        411.799560546875,
        1225.0,
        -43.0
      ],
      "bbox_max": [
        443.0001220703125,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1529429405927658,
        -0.9882351160049438,
        0.0
      ],
      "plane_d": 1157.635498046875,
      "bbox_min": [
        411.799560546875,
        1225.0,
        -43.0
      ],
      "bbox_max": [
        443.0001220703125,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4462294578552246,
        -0.8949186205863953,
        0.0
      ],
      "plane_d": 913.5494384765625,
      "bbox_min": [
        411.799560546875,
        1225.0,
        -43.0
      ],
      "bbox_max": [
        443.0001220703125,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.894914984703064,
        -0.4462367296218872,
        -0.0
      ],
      "plane_d": 925.6798095703125,
      "bbox_min": [
        411.799560546875,
        1225.0,
        -43.0
      ],
      "bbox_max": [
        443.0001220703125,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8949162364006042,
        0.44623440504074097,
        -0.0
      ],
      "plane_d": -926.177490234375,
      "bbox_min": [
        421.1961975097656,
        1228.8248291015625,
        -43.0
      ],
      "bbox_max": [
        443.0001220703125,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4462856650352478,
        -0.8948906064033508,
        0.0
      ],
      "plane_d": 911.491455078125,
      "bbox_min": [
        421.64117431640625,
        1228.8248291015625,
        -43.0
      ],
      "bbox_max": [
        422.088623046875,
        1229.0479736328125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1239.89990234375,
      "bbox_min": [
        442.5,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        443.0001220703125,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -468.0,
      "bbox_min": [
        443.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        512.3844604492188,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -456.0,
      "bbox_min": [
        443.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1260.4000244140625,
      "bbox_min": [
        443.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        456.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1239.89990234375,
      "bbox_min": [
        443.0000915527344,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        456.0,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -41.0,
      "bbox_min": [
        449.0,
        1273.4000244140625,
        -43.0
      ],
      "bbox_max": [
        453.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1283.4000244140625,
      "bbox_min": [
        449.0,
        1273.4000244140625,
        -41.0
      ],
      "bbox_max": [
        453.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.5,
      "bbox_min": [
        449.0,
        1273.4000244140625,
        -41.0
      ],
      "bbox_max": [
        453.0,
        1283.4000244140625,
        -40.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1273.4000244140625,
      "bbox_min": [
        449.0,
        1273.4000244140625,
        -41.0
      ],
      "bbox_max": [
        453.0,
        1273.4000244140625,
        -40.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        450.0,
        1297.4000244140625,
        -41.0
      ],
      "bbox_max": [
        453.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 450.0,
      "bbox_min": [
        450.0,
        1297.4000244140625,
        -41.0
      ],
      "bbox_max": [
        450.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        450.0,
        1274.4000244140625,
        -43.0
      ],
      "bbox_max": [
        453.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 450.0,
      "bbox_min": [
        450.0,
        1297.4000244140625,
        -43.0
      ],
      "bbox_max": [
        450.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1281.4000244140625,
      "bbox_min": [
        450.0,
        1274.4000244140625,
        -43.0
      ],
      "bbox_max": [
        452.0,
        1282.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1282.4000244140625,
      "bbox_min": [
        450.0,
        1281.4000244140625,
        -43.0
      ],
      "bbox_max": [
        452.0,
        1282.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -452.0,
      "bbox_min": [
        450.0,
        1281.4000244140625,
        -43.0
      ],
      "bbox_max": [
        452.0,
        1282.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 450.0,
      "bbox_min": [
        450.0,
        1281.4000244140625,
        -43.0
      ],
      "bbox_max": [
        450.0,
        1282.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1274.4000244140625,
      "bbox_min": [
        450.0,
        1274.4000244140625,
        -43.0
      ],
      "bbox_max": [
        452.0,
        1275.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1275.4000244140625,
      "bbox_min": [
        450.0,
        1274.4000244140625,
        -43.0
      ],
      "bbox_max": [
        452.0,
        1275.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -452.0,
      "bbox_min": [
        450.0,
        1274.4000244140625,
        -43.0
      ],
      "bbox_max": [
        452.0,
        1275.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 450.0,
      "bbox_min": [
        450.0,
        1274.4000244140625,
        -43.0
      ],
      "bbox_max": [
        450.0,
        1275.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        453.0,
        1297.4000244140625,
        -43.0
      ],
      "bbox_max": [
        456.0,
        1297.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.9000244140625,
      "bbox_min": [
        443.0,
        1260.7725830078125,
        -43.0
      ],
      "bbox_max": [
        448.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -447.0,
      "bbox_min": [
        443.0,
        1270.9000244140625,
        -43.0
      ],
      "bbox_max": [
        448.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 41.0,
      "bbox_min": [
        443.0,
        1270.9000244140625,
        -43.0
      ],
      "bbox_max": [
        447.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1285.9000244140625,
      "bbox_min": [
        443.0,
        1285.9000244140625,
        -43.0
      ],
      "bbox_max": [
        447.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1370.72705078125,
      "bbox_min": [
        443.0000915527344,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        447.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880849480628967,
        -0.45967939496040344,
        0.0
      ],
      "plane_d": 990.26953125,
      "bbox_min": [
        443.0000915527344,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        447.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1090.5103759765625,
      "bbox_min": [
        445.5,
        1296.4000244140625,
        -43.0
      ],
      "bbox_max": [
        447.0,
        1296.89697265625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1155.112060546875,
      "bbox_min": [
        443.0,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        447.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1167.6346435546875,
      "bbox_min": [
        443.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        447.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        443.0,
        1285.0999755859375,
        -40.600006103515625
      ],
      "bbox_max": [
        447.0,
        1285.7000732421875,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977863430976868,
        -0.0,
        0.06650284677743912
      ],
      "plane_d": -440.6895446777344,
      "bbox_min": [
        443.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        447.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        443.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        444.39990234375,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        443.0,
        1284.9000244140625,
        -41.0
      ],
      "bbox_max": [
        444.39990234375,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        443.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        444.39990234375,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        444.37322998046875,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        447.0,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1119.341796875,
      "bbox_min": [
        444.37322998046875,
        1271.7000732421875,
        -41.0
      ],
      "bbox_max": [
        447.0,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1090.5103759765625,
      "bbox_min": [
        445.5,
        1296.4000244140625,
        -41.0
      ],
      "bbox_max": [
        447.0,
        1296.89697265625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 199.0782470703125,
      "bbox_min": [
        447.0,
        1296.89697265625,
        -43.0
      ],
      "bbox_max": [
        448.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1090.5103759765625,
      "bbox_min": [
        447.0,
        1296.89697265625,
        -43.0
      ],
      "bbox_max": [
        447.267822265625,
        1296.9857177734375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49314722418785095,
        0.8542642593383789,
        -0.16443361341953278
      ],
      "plane_d": -1307.1358642578125,
      "bbox_min": [
        443.1845703125,
        1263.9749755859375,
        -43.0
      ],
      "bbox_max": [
        447.215576171875,
        1265.4273681640625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49319395422935486,
        0.8542417287826538,
        -0.16441093385219574
      ],
      "plane_d": -867.9874267578125,
      "bbox_min": [
        443.1845703125,
        1263.9749755859375,
        -43.0
      ],
      "bbox_max": [
        445.199951171875,
        1265.4273681640625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 464.0,
      "bbox_min": [
        456.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1270.9000244140625,
      "bbox_min": [
        464.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 41.0,
      "bbox_min": [
        464.0,
        1270.9000244140625,
        -43.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1285.9000244140625,
      "bbox_min": [
        464.0,
        1285.9000244140625,
        -43.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1084.220458984375,
      "bbox_min": [
        464.0,
        1296.4000244140625,
        -42.765968322753906
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1377.0169677734375,
      "bbox_min": [
        464.0,
        1296.4000244140625,
        -42.765968322753906
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 181.31716918945312,
      "bbox_min": [
        467.267822265625,
        1296.9857177734375,
        -42.32301330566406
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1131.8643798828125,
      "bbox_min": [
        464.0,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        468.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1155.112060546875,
      "bbox_min": [
        464.0,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        468.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1167.6346435546875,
      "bbox_min": [
        464.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        468.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        464.0,
        1285.0999755859375,
        -40.600006103515625
      ],
      "bbox_max": [
        468.0,
        1285.7000732421875,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977863430976868,
        0.0,
        0.06650284677743912
      ],
      "plane_d": 468.2938232421875,
      "bbox_min": [
        464.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        468.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        466.60009765625,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        468.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        466.60009765625,
        1284.9000244140625,
        -41.0
      ],
      "bbox_max": [
        468.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        466.60009765625,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        468.0,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        464.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        466.62677001953125,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1119.341796875,
      "bbox_min": [
        464.0,
        1271.7000732421875,
        -41.0
      ],
      "bbox_max": [
        466.62677001953125,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1377.0169677734375,
      "bbox_min": [
        464.0,
        1296.4000244140625,
        -41.0
      ],
      "bbox_max": [
        465.5,
        1296.89697265625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 466.0,
      "bbox_min": [
        466.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        468.0,
        1260.4000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1239.9000244140625,
      "bbox_min": [
        466.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        468.0,
        1260.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        -0.0
      ],
      "plane_d": 1377.0169677734375,
      "bbox_min": [
        463.732177734375,
        1296.89697265625,
        -42.79602813720703
      ],
      "bbox_max": [
        464.0,
        1296.9857177734375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        456.0,
        1297.4000244140625,
        -43.0
      ],
      "bbox_max": [
        461.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -461.0,
      "bbox_min": [
        461.0,
        1297.4000244140625,
        -43.0
      ],
      "bbox_max": [
        461.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 493.0,
      "bbox_min": [
        468.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        512.3844604492188,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1239.9000244140625,
      "bbox_min": [
        493.0,
        1239.9000244140625,
        -42.593448638916016
      ],
      "bbox_max": [
        512.3844604492188,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1260.4000244140625,
      "bbox_min": [
        480.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        493.0,
        1297.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1239.9000244140625,
      "bbox_min": [
        480.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        493.0,
        1239.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        480.0,
        1260.7725830078125,
        -41.67622756958008
      ],
      "bbox_max": [
        493.0,
        1297.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977863430976868,
        0.0,
        0.06650284677743912
      ],
      "plane_d": 493.2384948730469,
      "bbox_min": [
        489.0,
        1270.9000244140625,
        -41.112213134765625
      ],
      "bbox_max": [
        493.0,
        1282.5140380859375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        491.61968994140625,
        1271.0999755859375,
        -40.70623779296875
      ],
      "bbox_max": [
        492.7312316894531,
        1271.753173828125,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1119.341796875,
      "bbox_min": [
        491.61968994140625,
        1271.7000732421875,
        -40.70623779296875
      ],
      "bbox_max": [
        492.43951416015625,
        1271.753173828125,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        489.0,
        1270.9000244140625,
        -41.112213134765625
      ],
      "bbox_max": [
        491.62677001953125,
        1272.625244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 489.0,
      "bbox_min": [
        489.0,
        1270.9000244140625,
        -41.112213134765625
      ],
      "bbox_max": [
        491.62677001953125,
        1272.625244140625,
        -40.600006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1119.341796875,
      "bbox_min": [
        489.0,
        1270.9000244140625,
        -41.112213134765625
      ],
      "bbox_max": [
        491.62677001953125,
        1272.625244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1270.9000244140625,
      "bbox_min": [
        489.0,
        1270.9000244140625,
        -41.112213134765625
      ],
      "bbox_max": [
        489.8387145996094,
        1270.9000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 41.0,
      "bbox_min": [
        489.0,
        1271.9000244140625,
        -41.0
      ],
      "bbox_max": [
        489.35260009765625,
        1272.625244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9863939881324768,
        -0.0,
        -0.16439899802207947
      ],
      "plane_d": 475.5580749511719,
      "bbox_min": [
        488.784423828125,
        1260.7725830078125,
        -41.67622756958008
      ],
      "bbox_max": [
        492.8154296875,
        1265.4273681640625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4931741952896118,
        -0.8542481660842896,
        -0.16443656384944916
      ],
      "plane_d": 1312.4849853515625,
      "bbox_min": [
        488.784423828125,
        1260.7725830078125,
        -41.67622756958008
      ],
      "bbox_max": [
        492.8154296875,
        1265.4273681640625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4931761622428894,
        0.8542515635490417,
        -0.16441282629966736
      ],
      "plane_d": -845.5188598632812,
      "bbox_min": [
        488.784423828125,
        1264.11474609375,
        -41.547882080078125
      ],
      "bbox_max": [
        492.8154296875,
        1265.4273681640625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49323323369026184,
        0.8542128205299377,
        -0.1644429862499237
      ],
      "plane_d": -1329.6009521484375,
      "bbox_min": [
        490.800048828125,
        1264.161376953125,
        -41.24290466308594
      ],
      "bbox_max": [
        492.8154296875,
        1265.4273681640625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -472.0,
      "bbox_min": [
        468.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        480.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.9000244140625,
      "bbox_min": [
        468.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        472.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 41.0,
      "bbox_min": [
        468.0,
        1270.9000244140625,
        -42.946128845214844
      ],
      "bbox_max": [
        472.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1285.9000244140625,
      "bbox_min": [
        468.0,
        1285.9000244140625,
        -42.946128845214844
      ],
      "bbox_max": [
        472.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1378.5894775390625,
      "bbox_min": [
        468.0,
        1296.4000244140625,
        -42.13304901123047
      ],
      "bbox_max": [
        472.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        -0.4597398638725281,
        0.0
      ],
      "plane_d": 1012.535400390625,
      "bbox_min": [
        468.0,
        1296.4000244140625,
        -42.13304901123047
      ],
      "bbox_max": [
        472.0,
        1298.4000244140625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1082.64794921875,
      "bbox_min": [
        470.5,
        1296.4000244140625,
        -41.92867660522461
      ],
      "bbox_max": [
        472.0,
        1296.89697265625,
        -41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1131.8643798828125,
      "bbox_min": [
        468.0,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        472.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1155.112060546875,
      "bbox_min": [
        468.0,
        1270.9000244140625,
        -41.0
      ],
      "bbox_max": [
        472.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 1167.6346435546875,
      "bbox_min": [
        468.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        472.0,
        1285.7000732421875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        468.0,
        1285.0999755859375,
        -40.600006103515625
      ],
      "bbox_max": [
        472.0,
        1285.7000732421875,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977863430976868,
        -0.0,
        0.06650284677743912
      ],
      "plane_d": -465.6341857910156,
      "bbox_min": [
        468.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        472.0,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1271.9000244140625,
      "bbox_min": [
        468.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        469.39990234375,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1284.9000244140625,
      "bbox_min": [
        468.0,
        1284.9000244140625,
        -41.0
      ],
      "bbox_max": [
        469.39990234375,
        1284.9000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        468.0,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        469.39990234375,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 40.600006103515625,
      "bbox_min": [
        469.37322998046875,
        1271.0999755859375,
        -41.0
      ],
      "bbox_max": [
        472.0,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -1119.341796875,
      "bbox_min": [
        469.37322998046875,
        1271.7000732421875,
        -41.0
      ],
      "bbox_max": [
        472.0,
        1271.9000244140625,
        -40.600006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1082.64794921875,
      "bbox_min": [
        470.5,
        1296.4000244140625,
        -41.0
      ],
      "bbox_max": [
        472.0,
        1296.89697265625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        468.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        470.0,
        1260.4000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1239.9000244140625,
      "bbox_min": [
        468.0,
        1239.9000244140625,
        -43.0
      ],
      "bbox_max": [
        470.0,
        1260.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        -0.9492585062980652,
        0.0
      ],
      "plane_d": 1082.64794921875,
      "bbox_min": [
        472.0,
        1296.89697265625,
        -41.69565963745117
      ],
      "bbox_max": [
        472.267822265625,
        1296.9857177734375,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1297.4000244140625,
      "bbox_min": [
        475.0,
        1297.4000244140625,
        -41.261566162109375
      ],
      "bbox_max": [
        480.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 475.0,
      "bbox_min": [
        475.0,
        1297.4000244140625,
        -41.261566162109375
      ],
      "bbox_max": [
        475.0,
        1298.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995648622512817,
        -0.4367873966693878,
        0.0
      ],
      "plane_d": 162.07540893554688,
      "bbox_min": [
        367.0,
        987.5121459960938,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1229.17919921875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995648622512817,
        0.4367873966693878,
        -0.0
      ],
      "plane_d": -822.3560180664062,
      "bbox_min": [
        367.0,
        987.5121459960938,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1229.17919921875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 55.5,
      "bbox_min": [
        367.0,
        987.5121459960938,
        -60.0
      ],
      "bbox_max": [
        571.5,
        1229.17919921875,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4148046374320984,
        0.8531911969184875,
        0.3162309527397156
      ],
      "plane_d": -1066.410888671875,
      "bbox_min": [
        382.780517578125,
        1025.3416748046875,
        -60.0
      ],
      "bbox_max": [
        493.6907043457031,
        1159.849853515625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4372434616088867,
        0.8993433117866516,
        0.0
      ],
      "plane_d": -1142.997314453125,
      "bbox_min": [
        392.4007263183594,
        1025.3416748046875,
        -60.0
      ],
      "bbox_max": [
        493.6907043457031,
        1077.976318359375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1042.2559814453125,
      "bbox_min": [
        392.4007263183594,
        1025.3416748046875,
        -60.0
      ],
      "bbox_max": [
        493.6907043457031,
        1077.3651123046875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659260511398315,
        0.2588180601596832,
        0.0
      ],
      "plane_d": -738.77490234375,
      "bbox_min": [
        487.8473815917969,
        1030.25,
        -56.794437408447266
      ],
      "bbox_max": [
        488.7823791503906,
        1033.739501953125,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43678605556488037,
        -0.8995654582977295,
        0.0
      ],
      "plane_d": 794.7662353515625,
      "bbox_min": [
        392.4007263183594,
        1059.6759033203125,
        -60.0
      ],
      "bbox_max": [
        425.3409423828125,
        1077.3651123046875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4367859959602356,
        0.8995655179023743,
        0.0
      ],
      "plane_d": -795.2664184570312,
      "bbox_min": [
        392.4007263183594,
        1074.587158203125,
        -60.0
      ],
      "bbox_max": [
        398.1219482421875,
        1077.3651123046875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8910109400749207,
        0.45398181676864624,
        0.0
      ],
      "plane_d": -104.11300659179688,
      "bbox_min": [
        423.0706481933594,
        1059.6759033203125,
        -60.0
      ],
      "bbox_max": [
        425.3409423828125,
        1064.1317138671875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1047.2559814453125,
      "bbox_min": [
        460.0517578125,
        1042.2559814453125,
        -59.53213882446289
      ],
      "bbox_max": [
        471.568359375,
        1047.2559814453125,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -471.5,
      "bbox_min": [
        471.5,
        1042.2559814453125,
        -58.325706481933594
      ],
      "bbox_max": [
        471.5,
        1042.291748046875,
        -58.22688293457031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 56.0,
      "bbox_min": [
        402.28448486328125,
        1062.73779296875,
        -60.0
      ],
      "bbox_max": [
        478.4091491699219,
        1100.0203857421875,
        -55.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.40017983317375183,
        -0.9164366126060486,
        0.0
      ],
      "plane_d": 1164.0621337890625,
      "bbox_min": [
        402.3877868652344,
        1062.73779296875,
        -57.20000076293945
      ],
      "bbox_max": [
        478.4091491699219,
        1099.8076171875,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08957713842391968,
        0.9585351347923279,
        -0.270529568195343
      ],
      "plane_d": -1094.995849609375,
      "bbox_min": [
        402.3877868652344,
        1063.5242919921875,
        -57.20000076293945
      ],
      "bbox_max": [
        478.4091491699219,
        1099.8076171875,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08757145702838898,
        0.9563911557197571,
        -0.27865228056907654
      ],
      "plane_d": -1092.268798828125,
      "bbox_min": [
        422.9023132324219,
        1063.5242919921875,
        -57.20000076293945
      ],
      "bbox_max": [
        478.4091491699219,
        1086.885498046875,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6158631443977356,
        0.7400243282318115,
        -0.27032670378685
      ],
      "plane_d": -558.0078125,
      "bbox_min": [
        422.9023132324219,
        1063.5242919921875,
        -57.20000076293945
      ],
      "bbox_max": [
        478.4091491699219,
        1086.885498046875,
        -56.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38269972801208496,
        -0.9238728284835815,
        -0.0
      ],
      "plane_d": 1163.8031005859375,
      "bbox_min": [
        468.20001220703125,
        1063.800048828125,
        -57.20000076293945
      ],
      "bbox_max": [
        478.4091491699219,
        1065.756103515625,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1063.800048828125,
      "bbox_min": [
        475.5,
        1063.800048828125,
        -56.38921356201172
      ],
      "bbox_max": [
        478.4091491699219,
        1063.800048828125,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 56.70000076293945,
      "bbox_min": [
        468.20001220703125,
        1064.2974853515625,
        -56.70000076293945
      ],
      "bbox_max": [
        471.72125244140625,
        1065.756103515625,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 56.70000076293945,
      "bbox_min": [
        471.4625244140625,
        1063.5242919921875,
        -56.70000076293945
      ],
      "bbox_max": [
        473.3110656738281,
        1064.33154296875,
        -56.70000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8995651006698608,
        0.4367866814136505,
        -0.0
      ],
      "plane_d": -842.8553466796875,
      "bbox_min": [
        403.09320068359375,
        1092.756591796875,
        -57.20000076293945
      ],
      "bbox_max": [
        406.3673095703125,
        1099.49951171875,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 56.70000076293945,
      "bbox_min": [
        405.66192626953125,
        1062.73779296875,
        -57.20000076293945
      ],
      "bbox_max": [
        473.6935119628906,
        1093.0645751953125,
        -56.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0686374083161354,
        -0.9976416826248169,
        -0.0
      ],
      "plane_d": 1108.826171875,
      "bbox_min": [
        405.66192626953125,
        1062.73779296875,
        -57.20000076293945
      ],
      "bbox_max": [
        473.6935119628906,
        1093.0645751953125,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995651006698608,
        0.4367866814136505,
        -0.0
      ],
      "plane_d": -842.8553466796875,
      "bbox_min": [
        405.66192626953125,
        1084.4593505859375,
        -57.20000076293945
      ],
      "bbox_max": [
        423.2517395019531,
        1093.0645751953125,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995651006698608,
        -0.4367866814136505,
        0.0
      ],
      "plane_d": 842.3553466796875,
      "bbox_min": [
        405.66192626953125,
        1091.2762451171875,
        -57.20000076293945
      ],
      "bbox_max": [
        406.5302429199219,
        1093.0645751953125,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6158631443977356,
        0.7400243282318115,
        -0.27032670378685
      ],
      "plane_d": -558.0078125,
      "bbox_min": [
        421.9971008300781,
        1084.4593505859375,
        -57.20000076293945
      ],
      "bbox_max": [
        423.2517395019531,
        1085.446533203125,
        -56.70000076293945
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38270068168640137,
        -0.9238723516464233,
        -0.0
      ],
      "plane_d": 1162.51416015625,
      "bbox_min": [
        467.54998779296875,
        1062.73779296875,
        -57.20000076293945
      ],
      "bbox_max": [
        473.6935119628906,
        1064.6302490234375,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13051842153072357,
        -0.9914458990097046,
        -0.0
      ],
      "plane_d": 1115.4727783203125,
      "bbox_min": [
        471.384765625,
        1062.73779296875,
        -56.98911666870117
      ],
      "bbox_max": [
        473.6935119628906,
        1063.041748046875,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0686374083161354,
        -0.9976416826248169,
        -0.0
      ],
      "plane_d": 1108.826171875,
      "bbox_min": [
        405.66192626953125,
        1081.756103515625,
        -56.70000076293945
      ],
      "bbox_max": [
        431.55902099609375,
        1093.0645751953125,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995651006698608,
        -0.4367866814136505,
        0.0
      ],
      "plane_d": 842.3553466796875,
      "bbox_min": [
        405.66192626953125,
        1091.2762451171875,
        -56.70000076293945
      ],
      "bbox_max": [
        406.5302429199219,
        1093.0645751953125,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6129900217056274,
        0.7393826842308044,
        -0.27848950028419495
      ],
      "plane_d": -558.9873046875,
      "bbox_min": [
        421.788818359375,
        1084.5220947265625,
        -56.70000076293945
      ],
      "bbox_max": [
        423.10784912109375,
        1085.536376953125,
        -56.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.07438790053129196,
        0.8589897751808167,
        -0.5065600275993347
      ],
      "plane_d": -994.0570678710938,
      "bbox_min": [
        423.2517395019531,
        1065.6063232421875,
        -60.0
      ],
      "bbox_max": [
        468.5616455078125,
        1086.527099609375,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08757145702838898,
        0.9563911557197571,
        -0.27865228056907654
      ],
      "plane_d": -1092.268798828125,
      "bbox_min": [
        423.2517395019531,
        1065.6063232421875,
        -60.0
      ],
      "bbox_max": [
        468.5616455078125,
        1086.527099609375,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08957713842391968,
        0.9585351347923279,
        -0.270529568195343
      ],
      "plane_d": -1094.995849609375,
      "bbox_min": [
        423.2517395019531,
        1065.6063232421875,
        -60.0
      ],
      "bbox_max": [
        468.5616455078125,
        1086.527099609375,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5599265694618225,
        0.6661093831062317,
        -0.49272772669792175
      ],
      "plane_d": -514.3449096679688,
      "bbox_min": [
        423.2517395019531,
        1065.6063232421875,
        -60.0
      ],
      "bbox_max": [
        468.5616455078125,
        1086.527099609375,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6158631443977356,
        0.7400243282318115,
        -0.27032670378685
      ],
      "plane_d": -558.0078125,
      "bbox_min": [
        423.2517395019531,
        1065.6063232421875,
        -57.900001525878906
      ],
      "bbox_max": [
        468.5616455078125,
        1086.527099609375,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6158631443977356,
        0.7400243282318115,
        -0.27032670378685
      ],
      "plane_d": -558.0078125,
      "bbox_min": [
        423.4454040527344,
        1085.295654296875,
        -57.900001525878906
      ],
      "bbox_max": [
        424.6817626953125,
        1086.3179931640625,
        -57.872406005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995651006698608,
        -0.4367866814136505,
        0.0
      ],
      "plane_d": 842.3553466796875,
      "bbox_min": [
        402.6357116699219,
        1092.756591796875,
        -60.0
      ],
      "bbox_max": [
        406.3673095703125,
        1099.2969970703125,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995651006698608,
        0.4367866814136505,
        -0.0
      ],
      "plane_d": -842.8553466796875,
      "bbox_min": [
        403.4858093261719,
        1096.8848876953125,
        -60.0
      ],
      "bbox_max": [
        404.3627624511719,
        1098.69091796875,
        -57.90028762817383
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995651006698608,
        0.4367866814136505,
        -0.0
      ],
      "plane_d": -842.8553466796875,
      "bbox_min": [
        405.66192626953125,
        1083.83349609375,
        -60.0
      ],
      "bbox_max": [
        424.67755126953125,
        1093.0645751953125,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995651006698608,
        -0.4367866814136505,
        0.0
      ],
      "plane_d": 842.3553466796875,
      "bbox_min": [
        405.66192626953125,
        1091.2762451171875,
        -60.0
      ],
      "bbox_max": [
        406.5302429199219,
        1093.0645751953125,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5517900586128235,
        0.6630337834358215,
        -0.5058794617652893
      ],
      "plane_d": -515.220703125,
      "bbox_min": [
        422.14111328125,
        1083.83349609375,
        -60.0
      ],
      "bbox_max": [
        424.67755126953125,
        1085.3836669921875,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6158631443977356,
        0.7400243282318115,
        -0.27032670378685
      ],
      "plane_d": -558.0078125,
      "bbox_min": [
        422.14111328125,
        1084.371337890625,
        -57.900001525878906
      ],
      "bbox_max": [
        423.4533386230469,
        1085.3836669921875,
        -57.20000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5599265694618225,
        0.6661093831062317,
        -0.49272772669792175
      ],
      "plane_d": -514.3449096679688,
      "bbox_min": [
        422.7586975097656,
        1083.83349609375,
        -60.0
      ],
      "bbox_max": [
        424.67755126953125,
        1085.2001953125,
        -58.263404846191406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995651006698608,
        -0.4367866814136505,
        0.0
      ],
      "plane_d": 842.3553466796875,
      "bbox_min": [
        402.28448486328125,
        1090.96826171875,
        -56.0
      ],
      "bbox_max": [
        407.2356262207031,
        1100.0203857421875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995651006698608,
        0.4367866814136505,
        -0.0
      ],
      "plane_d": -842.8553466796875,
      "bbox_min": [
        402.9898986816406,
        1090.96826171875,
        -56.0
      ],
      "bbox_max": [
        407.2356262207031,
        1099.7122802734375,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4367859959602356,
        -0.8995655179023743,
        0.0
      ],
      "plane_d": 1210.1494140625,
      "bbox_min": [
        382.780517578125,
        1067.3690185546875,
        -60.0
      ],
      "bbox_max": [
        476.6740417480469,
        1159.849853515625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43678605556488037,
        0.8995654582977295,
        -0.0
      ],
      "plane_d": -1210.6494140625,
      "bbox_min": [
        382.9989013671875,
        1150.4459228515625,
        -60.0
      ],
      "bbox_max": [
        401.2215881347656,
        1159.849853515625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9449512362480164,
        0.3272113502025604,
        -0.0
      ],
      "plane_d": -755.5738525390625,
      "bbox_min": [
        400.9902038574219,
        1150.4459228515625,
        -60.0
      ],
      "bbox_max": [
        401.2215881347656,
        1151.1141357421875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995646834373474,
        -0.43678760528564453,
        0.0
      ],
      "plane_d": 842.356201171875,
      "bbox_min": [
        389.23297119140625,
        1067.3690185546875,
        -60.0
      ],
      "bbox_max": [
        476.6740417480469,
        1150.664306640625,
        -55.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4367826282978058,
        -0.8995671272277832,
        0.0
      ],
      "plane_d": 824.81396484375,
      "bbox_min": [
        389.23297119140625,
        1097.7974853515625,
        -60.0
      ],
      "bbox_max": [
        403.9196472167969,
        1127.360107421875,
        -55.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8995649814605713,
        0.4367871582508087,
        0.0
      ],
      "plane_d": -142.07510375976562,
      "bbox_min": [
        389.23297119140625,
        1126.9000244140625,
        -60.0
      ],
      "bbox_max": [
        389.4563903808594,
        1127.360107421875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995651006698608,
        0.4367866814136505,
        -0.0
      ],
      "plane_d": -842.8553466796875,
      "bbox_min": [
        401.5788269042969,
        1097.7974853515625,
        -60.0
      ],
      "bbox_max": [
        403.9196472167969,
        1102.618408203125,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4367915689945221,
        0.8995627164840698,
        -0.0
      ],
      "plane_d": -1200.4056396484375,
      "bbox_min": [
        393.1174011230469,
        1130.5321044921875,
        -60.0
      ],
      "bbox_max": [
        405.5119323730469,
        1150.664306640625,
        -55.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.36914896965026855,
        -0.17924267053604126,
        0.9119216799736023
      ],
      "plane_d": 108.915283203125,
      "bbox_min": [
        393.1174011230469,
        1130.5321044921875,
        -60.0
      ],
      "bbox_max": [
        405.5119323730469,
        1141.9000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995651602745056,
        -0.43678659200668335,
        0.0
      ],
      "plane_d": 141.57440185546875,
      "bbox_min": [
        396.51629638671875,
        1141.681640625,
        -60.0
      ],
      "bbox_max": [
        401.2215881347656,
        1150.664306640625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995651602745056,
        0.43678659200668335,
        0.0
      ],
      "plane_d": -142.07437133789062,
      "bbox_min": [
        396.51629638671875,
        1141.9000244140625,
        -60.0
      ],
      "bbox_max": [
        400.7718200683594,
        1150.664306640625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4367915391921997,
        -0.899562656879425,
        0.0
      ],
      "plane_d": 816.4681396484375,
      "bbox_min": [
        389.4563903808594,
        1067.3690185546875,
        -60.0
      ],
      "bbox_max": [
        476.6740417480469,
        1134.9000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4367915689945221,
        0.8995627164840698,
        0.0
      ],
      "plane_d": -824.8055419921875,
      "bbox_min": [
        389.4563903808594,
        1102.636962890625,
        -60.0
      ],
      "bbox_max": [
        410.12469482421875,
        1134.9000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36914917826652527,
        0.17924223840236664,
        0.9119217395782471
      ],
      "plane_d": -295.06146240234375,
      "bbox_min": [
        397.93719482421875,
        1102.636962890625,
        -60.0
      ],
      "bbox_max": [
        410.12469482421875,
        1114.2679443359375,
        -55.72500228881836
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8947203755378723,
        -0.44662681221961975,
        0.0
      ],
      "plane_d": 154.64666748046875,
      "bbox_min": [
        389.4563903808594,
        1126.9000244140625,
        -60.0
      ],
      "bbox_max": [
        393.5671691894531,
        1134.9000244140625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 55.999996185302734,
      "bbox_min": [
        470.5479736328125,
        1067.3690185546875,
        -56.65998840332031
      ],
      "bbox_max": [
        476.6740417480469,
        1069.9996337890625,
        -56.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9553669691085815,
        -0.2954215705394745
      ],
      "plane_d": -1037.5443115234375,
      "bbox_min": [
        475.5,
        1068.6778564453125,
        -56.07194519042969
      ],
      "bbox_max": [
        476.0269470214844,
        1068.7000732421875,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1042.2559814453125,
      "bbox_min": [
        397.6641845703125,
        1033.2313232421875,
        -60.0
      ],
      "bbox_max": [
        487.9835510253906,
        1091.2762451171875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659260511398315,
        0.2588180601596832,
        0.0
      ],
      "plane_d": -738.77490234375,
      "bbox_min": [
        485.5653991699219,
        1033.2313232421875,
        -56.69255447387695
      ],
      "bbox_max": [
        487.9835510253906,
        1042.2559814453125,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4367859959602356,
        0.8995655179023743,
        0.0
      ],
      "plane_d": -795.2664184570312,
      "bbox_min": [
        397.6641845703125,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        485.5653991699219,
        1091.2762451171875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43678605556488037,
        -0.8995654582977295,
        0.0
      ],
      "plane_d": 794.7662353515625,
      "bbox_min": [
        398.2362060546875,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        485.5653991699219,
        1084.6131591796875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9449512362480164,
        -0.3272113502025604,
        0.0
      ],
      "plane_d": -33.678466796875,
      "bbox_min": [
        410.61041259765625,
        1082.873046875,
        -60.0
      ],
      "bbox_max": [
        410.841796875,
        1083.541259765625,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": -975.5841064453125,
      "bbox_min": [
        414.7003173828125,
        1042.2559814453125,
        -60.0
      ],
      "bbox_max": [
        485.5653991699219,
        1084.6131591796875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1047.2559814453125,
      "bbox_min": [
        460.0517578125,
        1042.2559814453125,
        -59.27000045776367
      ],
      "bbox_max": [
        485.5653991699219,
        1047.2559814453125,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -471.5,
      "bbox_min": [
        471.5,
        1042.2559814453125,
        -58.32337951660156
      ],
      "bbox_max": [
        485.5653991699219,
        1047.2559814453125,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 483.0,
      "bbox_min": [
        483.0,
        1042.2559814453125,
        -56.78712463378906
      ],
      "bbox_max": [
        485.5653991699219,
        1044.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -485.56536865234375,
      "bbox_min": [
        485.5653991699219,
        1042.2559814453125,
        -56.44389724731445
      ],
      "bbox_max": [
        485.5653991699219,
        1044.0,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 56.0,
      "bbox_min": [
        414.7003173828125,
        1073.3790283203125,
        -60.0
      ],
      "bbox_max": [
        430.90911865234375,
        1084.6131591796875,
        -56.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660176992416382,
        -0.5000134110450745,
        0.0
      ],
      "plane_d": 174.21609497070312,
      "bbox_min": [
        414.7003173828125,
        1073.3790283203125,
        -60.0
      ],
      "bbox_max": [
        430.90911865234375,
        1084.6131591796875,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5517900586128235,
        0.6630337834358215,
        -0.5058794617652893
      ],
      "plane_d": -515.220703125,
      "bbox_min": [
        414.7003173828125,
        1074.0289306640625,
        -60.0
      ],
      "bbox_max": [
        423.5740966796875,
        1084.6131591796875,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6129900217056274,
        0.7393826842308044,
        -0.27848950028419495
      ],
      "plane_d": -558.9873046875,
      "bbox_min": [
        414.7003173828125,
        1074.0289306640625,
        -60.0
      ],
      "bbox_max": [
        422.3426208496094,
        1084.6131591796875,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7343732118606567,
        0.4240057170391083,
        -0.5300143957138062
      ],
      "plane_d": -182.07806396484375,
      "bbox_min": [
        414.7003173828125,
        1074.0289306640625,
        -60.0
      ],
      "bbox_max": [
        418.94384765625,
        1080.80908203125,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        -0.866020917892456,
        0.0
      ],
      "plane_d": 1139.606689453125,
      "bbox_min": [
        414.7003173828125,
        1074.0289306640625,
        -60.0
      ],
      "bbox_max": [
        418.94384765625,
        1080.80908203125,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8273633122444153,
        0.477695494890213,
        -0.2954268455505371
      ],
      "plane_d": -187.665283203125,
      "bbox_min": [
        414.7003173828125,
        1076.1851806640625,
        -57.900001525878906
      ],
      "bbox_max": [
        417.70916748046875,
        1080.80908203125,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6158631443977356,
        0.7400243282318115,
        -0.27032670378685
      ],
      "plane_d": -558.0078125,
      "bbox_min": [
        417.70916748046875,
        1080.5152587890625,
        -57.900001525878906
      ],
      "bbox_max": [
        422.3426208496094,
        1084.521484375,
        -56.705081939697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5599265694618225,
        0.6661093831062317,
        -0.49272772669792175
      ],
      "plane_d": -514.3449096679688,
      "bbox_min": [
        418.84588623046875,
        1079.8590087890625,
        -60.0
      ],
      "bbox_max": [
        423.5740966796875,
        1084.1895751953125,
        -58.59199905395508
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6569048166275024,
        -0.7539734840393066,
        0.0
      ],
      "plane_d": 536.20556640625,
      "bbox_min": [
        418.9436340332031,
        1073.3790283203125,
        -60.0
      ],
      "bbox_max": [
        430.90911865234375,
        1082.1527099609375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0686374083161354,
        -0.9976416826248169,
        -0.0
      ],
      "plane_d": 1108.826171875,
      "bbox_min": [
        418.9436340332031,
        1073.3790283203125,
        -60.0
      ],
      "bbox_max": [
        430.90911865234375,
        1082.1527099609375,
        -56.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 56.70000076293945,
      "bbox_min": [
        418.9436340332031,
        1073.3790283203125,
        -57.20000076293945
      ],
      "bbox_max": [
        430.90911865234375,
        1082.1527099609375,
        -56.70000076293945
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -57.20000076293945,
      "bbox_min": [
        418.9436340332031,
        1073.3790283203125,
        -57.20000076293945
      ],
      "bbox_max": [
        430.90911865234375,
        1082.1527099609375,
        -56.70000076293945
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.500006914138794,
        -0.8660213947296143,
        0.0
      ],
      "plane_d": 1139.6068115234375,
      "bbox_min": [
        418.9436340332031,
        1073.3790283203125,
        -57.20000076293945
      ],
      "bbox_max": [
        420.0694885253906,
        1074.029052734375,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6665995121002197,
        -0.7454160451889038,
        0.0
      ],
      "plane_d": 521.6570434570312,
      "bbox_min": [
        422.56951904296875,
        1077.7091064453125,
        -57.20000076293945
      ],
      "bbox_max": [
        430.90911865234375,
        1080.89697265625,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05572272464632988,
        -0.9984463453292847,
        -0.0
      ],
      "plane_d": 1102.9630126953125,
      "bbox_min": [
        426.1343078613281,
        1080.6304931640625,
        -57.20000076293945
      ],
      "bbox_max": [
        430.90911865234375,
        1080.89697265625,
        -56.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995651006698608,
        -0.4367866814136505,
        0.0
      ],
      "plane_d": 842.3553466796875,
      "bbox_min": [
        406.5302429199219,
        1083.3228759765625,
        -60.0
      ],
      "bbox_max": [
        410.841796875,
        1091.2762451171875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8995651006698608,
        0.4367866814136505,
        -0.0
      ],
      "plane_d": -842.8553466796875,
      "bbox_min": [
        407.2356262207031,
        1083.541259765625,
        -60.0
      ],
      "bbox_max": [
        410.841796875,
        1090.96826171875,
        -55.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1211.5439453125,
      "bbox_min": [
        374.0,
        987.5121459960938,
        -55.5
      ],
      "bbox_max": [
        571.5,
        1229.17919921875,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -493.5,
      "bbox_min": [
        486.57757568359375,
        1211.5440673828125,
        -43.0
      ],
      "bbox_max": [
        519.6286010742188,
        1225.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 506.5,
      "bbox_min": [
        506.5,
        1211.5440673828125,
        -42.6317024230957
      ],
      "bbox_max": [
        519.6286010742188,
        1225.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        506.5,
        1225.0,
        -41.7564697265625
      ],
      "bbox_max": [
        519.6286010742188,
        1225.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1042.255859375,
      "bbox_min": [
        374.0,
        987.5121459960938,
        -55.5
      ],
      "bbox_max": [
        571.5,
        1211.5440673828125,
        -40.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        485.5653991699219,
        987.5121459960938,
        -55.5
      ],
      "bbox_max": [
        571.5,
        1042.2559814453125,
        -40.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": -47.049991607666016,
      "bbox_min": [
        485.5653991699219,
        1005.2578125,
        -55.5
      ],
      "bbox_max": [
        571.5,
        1042.2559814453125,
        -44.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -44.0,
      "bbox_min": [
        568.0809936523438,
        1037.4847412109375,
        -45.404170989990234
      ],
      "bbox_max": [
        571.5,
        1042.2559814453125,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6178141236305237,
        0.786324143409729,
        0.0
      ],
      "plane_d": -1168.880126953125,
      "bbox_min": [
        569.8525390625,
        1037.4847412109375,
        -45.393306732177734
      ],
      "bbox_max": [
        571.5,
        1038.7791748046875,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1097.536376953125,
      "bbox_min": [
        488.7823791503906,
        1005.2578125,
        -55.5
      ],
      "bbox_max": [
        535.0,
        1042.2559814453125,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258723258972,
        -0.2588190734386444,
        -0.0
      ],
      "plane_d": 777.6599731445312,
      "bbox_min": [
        488.7823791503906,
        1005.2578125,
        -55.5
      ],
      "bbox_max": [
        535.0,
        1042.2559814453125,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        0.7071055769920349,
        -0.0
      ],
      "plane_d": -1074.117431640625,
      "bbox_min": [
        488.7823791503906,
        1005.2578125,
        -55.5
      ],
      "bbox_max": [
        535.0,
        1042.2559814453125,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588190734386444,
        -0.9659258723258972,
        -0.0
      ],
      "plane_d": 1129.7991943359375,
      "bbox_min": [
        492.5653991699219,
        1005.2578125,
        -55.065826416015625
      ],
      "bbox_max": [
        535.0,
        1042.2559814453125,
        -47.04999542236328
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071129679679871,
        -0.7071005702018738,
        -0.0
      ],
      "plane_d": 1088.6036376953125,
      "bbox_min": [
        492.5653991699219,
        1034.272705078125,
        -54.5686149597168
      ],
      "bbox_max": [
        505.25,
        1042.2559814453125,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659262895584106,
        -0.2588176429271698,
        0.0
      ],
      "plane_d": 753.2635498046875,
      "bbox_min": [
        500.5653991699219,
        1037.75,
        -54.5686149597168
      ],
      "bbox_max": [
        501.77276611328125,
        1042.2559814453125,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6584704518318176,
        0.1764346957206726,
        -0.7316333651542664
      ],
      "plane_d": -543.6409301757812,
      "bbox_min": [
        492.5653991699219,
        1036.884033203125,
        -47.5
      ],
      "bbox_max": [
        495.5047912597656,
        1042.2559814453125,
        -47.04999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": -47.499996185302734,
      "bbox_min": [
        492.5653991699219,
        1037.0283203125,
        -47.5
      ],
      "bbox_max": [
        494.96612548828125,
        1042.2559814453125,
        -47.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6584476828575134,
        0.176431804895401,
        -0.7316544651985168
      ],
      "plane_d": -560.2572021484375,
      "bbox_min": [
        493.8887634277344,
        1005.2578125,
        -55.065826416015625
      ],
      "bbox_max": [
        535.0,
        1037.3170166015625,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4820219874382019,
        0.4820219874382019,
        -0.7316486239433289
      ],
      "plane_d": -778.3148193359375,
      "bbox_min": [
        493.8887634277344,
        1008.760009765625,
        -55.065826416015625
      ],
      "bbox_max": [
        527.7963256835938,
        1037.3170166015625,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1764163076877594,
        -0.6584064960479736,
        -0.7316954731941223
      ],
      "plane_d": 730.0834350585938,
      "bbox_min": [
        493.8887634277344,
        1008.760009765625,
        -55.065826416015625
      ],
      "bbox_max": [
        527.7963256835938,
        1037.3170166015625,
        -47.04999542236328
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -47.5,
      "bbox_min": [
        493.8887634277344,
        1022.2225341796875,
        -47.5
      ],
      "bbox_max": [
        520.3659057617188,
        1037.3170166015625,
        -47.04999923706055
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.17643789947032928,
        0.6584704518318176,
        -0.7316325902938843
      ],
      "plane_d": -800.3265991210938,
      "bbox_min": [
        494.96612548828125,
        1023.5884399414062,
        -47.5
      ],
      "bbox_max": [
        519.25,
        1037.0283203125,
        -47.04999923706055
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.48203349113464355,
        0.48203349113464355,
        -0.7316334247589111
      ],
      "plane_d": -772.2448120117188,
      "bbox_min": [
        494.96612548828125,
        1028.2105712890625,
        -47.5
      ],
      "bbox_max": [
        502.0,
        1037.0283203125,
        -47.04999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6584704518318176,
        0.1764346957206726,
        -0.7316333651542664
      ],
      "plane_d": -543.6409301757812,
      "bbox_min": [
        494.96612548828125,
        1034.25,
        -47.5
      ],
      "bbox_max": [
        496.1435852050781,
        1037.0283203125,
        -47.04999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -1083.04736328125,
      "bbox_min": [
        507.30755615234375,
        1008.760009765625,
        -55.065826416015625
      ],
      "bbox_max": [
        527.7963256835938,
        1022.722412109375,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881466269493103,
        0.965927004814148,
        -0.0
      ],
      "plane_d": -1115.3092041015625,
      "bbox_min": [
        507.30755615234375,
        1016.6602783203125,
        -55.065826416015625
      ],
      "bbox_max": [
        515.0,
        1018.721435546875,
        -47.04999542236328
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": -47.499996185302734,
      "bbox_min": [
        518.25,
        1008.760009765625,
        -47.5
      ],
      "bbox_max": [
        527.7963256835938,
        1022.722412109375,
        -47.04999923706055
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6584915518760681,
        -0.1764415204524994,
        -0.7316128015518188
      ],
      "plane_d": 490.12646484375,
      "bbox_min": [
        524.2894287109375,
        1009.3190307617188,
        -47.5
      ],
      "bbox_max": [
        526.6465454101562,
        1016.5,
        -47.04999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        535.0,
        1005.2578125,
        -52.23660659790039
      ],
      "bbox_max": [
        535.0,
        1008.0,
        -47.04999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -513.3750610351562,
      "bbox_min": [
        560.2124633789062,
        990.0,
        -45.0
      ],
      "bbox_max": [
        571.5,
        993.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -990.0,
      "bbox_min": [
        566.3828735351562,
        990.0,
        -43.0
      ],
      "bbox_max": [
        571.5,
        990.0,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -43.0,
      "bbox_min": [
        566.3828735351562,
        987.5121459960938,
        -43.0
      ],
      "bbox_max": [
        571.5,
        990.0,
        -43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 998.9999389648438,
      "bbox_min": [
        550.0,
        999.0,
        -50.636802673339844
      ],
      "bbox_max": [
        551.0225219726562,
        1000.0,
        -50.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 50.5,
      "bbox_min": [
        550.0,
        999.0,
        -50.636802673339844
      ],
      "bbox_max": [
        551.0225219726562,
        1000.0,
        -50.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 550.0,
      "bbox_min": [
        550.0,
        999.0,
        -50.636802673339844
      ],
      "bbox_max": [
        550.0,
        1000.0,
        -50.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4148046374320984,
        0.8531911969184875,
        0.3162309527397156
      ],
      "plane_d": -1066.410888671875,
      "bbox_min": [
        374.0,
        1042.2559814453125,
        -55.5
      ],
      "bbox_max": [
        571.5,
        1211.5440673828125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 50.69999694824219,
      "bbox_min": [
        392.4007263183594,
        1042.2559814453125,
        -55.5
      ],
      "bbox_max": [
        465.76171875,
        1077.142822265625,
        -49.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4367859959602356,
        0.8995655179023743,
        0.0
      ],
      "plane_d": -795.2664184570312,
      "bbox_min": [
        392.4007263183594,
        1074.587158203125,
        -55.5
      ],
      "bbox_max": [
        397.6641845703125,
        1077.142822265625,
        -50.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8910109400749207,
        0.45398181676864624,
        0.0
      ],
      "plane_d": -104.11300659179688,
      "bbox_min": [
        423.07061767578125,
        1059.6759033203125,
        -55.5
      ],
      "bbox_max": [
        425.1593017578125,
        1063.7752685546875,
        -50.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43678605556488037,
        -0.8995654582977295,
        0.0
      ],
      "plane_d": 794.7662353515625,
      "bbox_min": [
        392.4007263183594,
        1074.30908203125,
        -50.70000076293945
      ],
      "bbox_max": [
        396.4053039550781,
        1076.25390625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4367859959602356,
        0.8995655179023743,
        0.0
      ],
      "plane_d": -795.2664184570312,
      "bbox_min": [
        392.4007263183594,
        1074.30908203125,
        -50.70000076293945
      ],
      "bbox_max": [
        395.94757080078125,
        1076.25390625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 43.0,
      "bbox_min": [
        465.4593811035156,
        1198.053955078125,
        -48.99998092651367
      ],
      "bbox_max": [
        510.3056945800781,
        1211.5440673828125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3713890016078949,
        2.1529244804696646e-06,
        0.9284773468971252
      ],
      "plane_d": 218.3592987060547,
      "bbox_min": [
        465.4593811035156,
        1198.053955078125,
        -48.99998092651367
      ],
      "bbox_max": [
        480.45941162109375,
        1211.5440673828125,
        -43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -493.5,
      "bbox_min": [
        490.9346008300781,
        1209.800048828125,
        -43.0
      ],
      "bbox_max": [
        509.0653991699219,
        1211.5440673828125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 490.9345703125,
      "bbox_min": [
        490.9346008300781,
        1209.800048828125,
        -43.0
      ],
      "bbox_max": [
        490.9346008300781,
        1211.5440673828125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 506.4999694824219,
      "bbox_min": [
        506.5,
        1209.800048828125,
        -42.74515151977539
      ],
      "bbox_max": [
        509.0653991699219,
        1211.5440673828125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -509.0653991699219,
      "bbox_min": [
        509.0653991699219,
        1209.800048828125,
        -42.40192413330078
      ],
      "bbox_max": [
        509.0653991699219,
        1211.5440673828125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4372437000274658,
        0.8993430733680725,
        0.0
      ],
      "plane_d": -700.7534790039062,
      "bbox_min": [
        374.0,
        1042.2559814453125,
        -55.5
      ],
      "bbox_max": [
        571.5,
        1198.053955078125,
        -40.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8910040855407715,
        0.4539954662322998,
        0.0
      ],
      "plane_d": -979.3419799804688,
      "bbox_min": [
        562.7239990234375,
        1042.2559814453125,
        -45.43702697753906
      ],
      "bbox_max": [
        568.0809936523438,
        1052.76953125,
        -44.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43678605556488037,
        0.8995654582977295,
        -0.0
      ],
      "plane_d": -1210.6494140625,
      "bbox_min": [
        382.780517578125,
        1126.4000244140625,
        -55.5
      ],
      "bbox_max": [
        514.5,
        1198.053955078125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 49.499996185302734,
      "bbox_min": [
        382.780517578125,
        1150.4459228515625,
        -55.5
      ],
      "bbox_max": [
        401.2215881347656,
        1159.849853515625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9449512362480164,
        0.3272113502025604,
        -0.0
      ],
      "plane_d": -755.5738525390625,
      "bbox_min": [
        400.9902038574219,
        1150.4459228515625,
        -55.5
      ],
      "bbox_max": [
        401.2215881347656,
        1151.1141357421875,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        -0.6246950626373291,
        -0.0
      ],
      "plane_d": 1089.015380859375,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -50.329036712646484
      ],
      "bbox_max": [
        514.5,
        1198.053955078125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3585740923881531,
        -0.9335013031959534
      ],
      "plane_d": 388.05029296875,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -50.329036712646484
      ],
      "bbox_max": [
        514.5,
        1198.053955078125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3585740923881531,
        0.9335013031959534
      ],
      "plane_d": -389.4505615234375,
      "bbox_min": [
        493.5,
        1186.3387451171875,
        -44.5
      ],
      "bbox_max": [
        506.5,
        1198.053955078125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 493.5,
      "bbox_min": [
        493.5,
        1186.3387451171875,
        -44.5
      ],
      "bbox_max": [
        506.5,
        1198.053955078125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -506.5,
      "bbox_min": [
        506.5,
        1186.3387451171875,
        -43.65266036987305
      ],
      "bbox_max": [
        506.5,
        1198.053955078125,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1126.4000244140625,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -50.329036712646484
      ],
      "bbox_max": [
        514.5,
        1156.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.6246950626373291,
        0.0
      ],
      "plane_d": -337.03863525390625,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -50.329036712646484
      ],
      "bbox_max": [
        514.5,
        1156.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1156.4000244140625,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -50.329036712646484
      ],
      "bbox_max": [
        514.5,
        1156.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        -0.6246950626373291,
        0.0
      ],
      "plane_d": 308.146484375,
      "bbox_min": [
        485.5,
        1126.4000244140625,
        -50.329036712646484
      ],
      "bbox_max": [
        514.5,
        1156.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 485.5,
      "bbox_min": [
        485.5,
        1136.4000244140625,
        -50.329036712646484
      ],
      "bbox_max": [
        514.5,
        1156.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.6246950626373291,
        0.0
      ],
      "plane_d": -1117.907470703125,
      "bbox_min": [
        506.5,
        1136.4000244140625,
        -46.44913864135742
      ],
      "bbox_max": [
        514.5,
        1156.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -514.5,
      "bbox_min": [
        514.5,
        1136.4000244140625,
        -46.44913864135742
      ],
      "bbox_max": [
        514.5,
        1146.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995651006698608,
        -0.4367866814136505,
        0.0
      ],
      "plane_d": 842.3553466796875,
      "bbox_min": [
        374.0,
        1042.2559814453125,
        -55.5
      ],
      "bbox_max": [
        562.7239990234375,
        1152.4000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8995651006698608,
        0.4367866814136505,
        -0.0
      ],
      "plane_d": -842.8553466796875,
      "bbox_min": [
        383.0,
        1042.2559814453125,
        -55.5
      ],
      "bbox_max": [
        562.7239990234375,
        1152.4000244140625,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 49.5,
      "bbox_min": [
        389.23297119140625,
        1082.873046875,
        -55.5
      ],
      "bbox_max": [
        410.841796875,
        1127.472412109375,
        -49.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.4367826282978058,
        0.8995671272277832,
        0.0
      ],
      "plane_d": -816.4765625,
      "bbox_min": [
        389.23297119140625,
        1082.873046875,
        -55.5
      ],
      "bbox_max": [
        410.841796875,
        1127.3602294921875,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9449512362480164,
        -0.3272113502025604,
        0.0
      ],
      "plane_d": -33.678466796875,
      "bbox_min": [
        410.39202880859375,
        1082.873046875,
        -55.5
      ],
      "bbox_max": [
        410.841796875,
        1083.541259765625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4367859959602356,
        0.8995655179023743,
        0.0
      ],
      "plane_d": -795.2664184570312,
      "bbox_min": [
        410.39202880859375,
        1083.3228759765625,
        -55.5
      ],
      "bbox_max": [
        410.841796875,
        1083.541259765625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995649814605713,
        0.4367871582508087,
        0.0
      ],
      "plane_d": -142.07510375976562,
      "bbox_min": [
        389.23297119140625,
        1109.9000244140625,
        -55.5
      ],
      "bbox_max": [
        397.9371643066406,
        1127.3602294921875,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4367826282978058,
        -0.8995671272277832,
        0.0
      ],
      "plane_d": 824.81396484375,
      "bbox_min": [
        397.4873962402344,
        1109.9000244140625,
        -55.5
      ],
      "bbox_max": [
        397.9371643066406,
        1110.118408203125,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995649814605713,
        0.4367871582508087,
        0.0
      ],
      "plane_d": -142.07510375976562,
      "bbox_min": [
        389.4564208984375,
        1126.9000244140625,
        -55.5
      ],
      "bbox_max": [
        389.7365417480469,
        1127.472412109375,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8947203755378723,
        -0.44662681221961975,
        0.0
      ],
      "plane_d": 154.64666748046875,
      "bbox_min": [
        389.6827392578125,
        1126.9000244140625,
        -55.5
      ],
      "bbox_max": [
        389.7365417480469,
        1127.0078125,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -485.56536865234375,
      "bbox_min": [
        459.5913391113281,
        1042.2559814453125,
        -55.5
      ],
      "bbox_max": [
        503.13079833984375,
        1046.85595703125,
        -44.54999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 483.0,
      "bbox_min": [
        459.5913391113281,
        1042.2559814453125,
        -55.5
      ],
      "bbox_max": [
        485.5653991699219,
        1046.85595703125,
        -44.54999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1044.0,
      "bbox_min": [
        483.0,
        1042.2559814453125,
        -55.5
      ],
      "bbox_max": [
        485.5653991699219,
        1044.0,
        -44.54999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8201528191566467,
        0.572144627571106
      ],
      "plane_d": -829.3201904296875,
      "bbox_min": [
        483.0,
        1042.2559814453125,
        -47.04999923706055
      ],
      "bbox_max": [
        485.5653991699219,
        1044.0,
        -44.54999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 50.70000076293945,
      "bbox_min": [
        459.5913391113281,
        1042.2559814453125,
        -55.5
      ],
      "bbox_max": [
        471.5,
        1046.85595703125,
        -50.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -471.5,
      "bbox_min": [
        471.5,
        1042.2559814453125,
        -55.5
      ],
      "bbox_max": [
        471.5,
        1046.85595703125,
        -50.70000076293945
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.5653991699219,
      "bbox_min": [
        500.5653991699219,
        1042.2559814453125,
        -54.43705368041992
      ],
      "bbox_max": [
        503.13079833984375,
        1044.0,
        -44.54999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -503.1307678222656,
      "bbox_min": [
        500.5653991699219,
        1042.2559814453125,
        -54.32361602783203
      ],
      "bbox_max": [
        503.13079833984375,
        1044.0,
        -44.54999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1044.0,
      "bbox_min": [
        500.5653991699219,
        1042.2559814453125,
        -54.32361602783203
      ],
      "bbox_max": [
        503.13079833984375,
        1044.0,
        -44.54999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8201528191566467,
        0.572144627571106
      ],
      "plane_d": -829.3201904296875,
      "bbox_min": [
        500.5653991699219,
        1042.2559814453125,
        -47.04999923706055
      ],
      "bbox_max": [
        503.13079833984375,
        1044.0,
        -44.54999923706055
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8995651602745056,
        0.43678659200668335,
        0.0
      ],
      "plane_d": -142.07437133789062,
      "bbox_min": [
        383.0,
        1050.796142578125,
        -55.5
      ],
      "bbox_max": [
        562.7239990234375,
        1152.4000244140625,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8947203755378723,
        -0.44662681221961975,
        0.0
      ],
      "plane_d": 154.64666748046875,
      "bbox_min": [
        389.5108947753906,
        1127.0078125,
        -55.5
      ],
      "bbox_max": [
        401.2215881347656,
        1150.664306640625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 49.5,
      "bbox_min": [
        389.5108947753906,
        1127.0078125,
        -55.5
      ],
      "bbox_max": [
        401.2215881347656,
        1150.664306640625,
        -49.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4367826282978058,
        -0.8995671272277832,
        0.0
      ],
      "plane_d": 1200.4072265625,
      "bbox_min": [
        393.1174011230469,
        1134.681640625,
        -55.5
      ],
      "bbox_max": [
        396.966064453125,
        1141.9000244140625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4367826282978058,
        0.8995671272277832,
        -0.0
      ],
      "plane_d": -1192.6256103515625,
      "bbox_min": [
        393.1174011230469,
        1134.681640625,
        -55.5
      ],
      "bbox_max": [
        393.5671691894531,
        1134.9000244140625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40848979353904724,
        0.8402265906333923,
        0.35658860206604004
      ],
      "plane_d": -640.8765869140625,
      "bbox_min": [
        557.7904663085938,
        1050.796142578125,
        -46.108428955078125
      ],
      "bbox_max": [
        562.7239990234375,
        1054.5682373046875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4372328221797943,
        0.8993483781814575,
        0.0
      ],
      "plane_d": -702.7651977539062,
      "bbox_min": [
        557.7904663085938,
        1050.796142578125,
        -46.108428955078125
      ],
      "bbox_max": [
        562.7239990234375,
        1054.5682373046875,
        -40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8993522524833679,
        -0.43722495436668396,
        1.594967002915837e-08
      ],
      "plane_d": 961.870849609375,
      "bbox_min": [
        557.7904663085938,
        1050.796142578125,
        -46.108428955078125
      ],
      "bbox_max": [
        562.7239990234375,
        1054.5682373046875,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8993522524833679,
        0.43722495436668396,
        -1.594967002915837e-08
      ],
      "plane_d": -966.3842163085938,
      "bbox_min": [
        561.8495483398438,
        1052.76953125,
        -45.43702697753906
      ],
      "bbox_max": [
        562.7239990234375,
        1054.5682373046875,
        -40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": -51.405696868896484,
      "bbox_min": [
        383.0,
        1142.4000244140625,
        -55.5
      ],
      "bbox_max": [
        393.0,
        1152.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": 50.905696868896484,
      "bbox_min": [
        383.0,
        1142.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        393.0,
        1152.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        -0.0
      ],
      "plane_d": 1203.9219970703125,
      "bbox_min": [
        383.0,
        1142.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        393.0,
        1152.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 906.9655151367188,
      "bbox_min": [
        383.0,
        1142.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        393.0,
        1152.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -1213.1607666015625,
      "bbox_min": [
        383.0,
        1143.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        393.0,
        1152.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -916.2042846679688,
      "bbox_min": [
        383.0,
        1143.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        393.0,
        1152.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": 75.97540283203125,
      "bbox_min": [
        383.0,
        1143.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        393.0,
        1150.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -802.1524047851562,
      "bbox_min": [
        383.0,
        1143.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        393.0,
        1150.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -85.21426391601562,
      "bbox_min": [
        383.0,
        1143.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        384.46435546875,
        1150.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        -0.0
      ],
      "plane_d": 792.9135131835938,
      "bbox_min": [
        383.0,
        1143.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        384.46435546875,
        1147.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.1500244140625,
      "bbox_min": [
        386.25,
        1145.6500244140625,
        -55.5
      ],
      "bbox_max": [
        389.75,
        1149.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -388.25,
      "bbox_min": [
        386.25,
        1147.1500244140625,
        -55.5
      ],
      "bbox_max": [
        389.75,
        1149.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 387.75,
      "bbox_min": [
        386.25,
        1147.1500244140625,
        -55.5
      ],
      "bbox_max": [
        388.25,
        1149.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.6500244140625,
      "bbox_min": [
        387.75,
        1147.6500244140625,
        -55.5
      ],
      "bbox_max": [
        388.25,
        1149.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -591.2549438476562,
      "bbox_min": [
        387.75,
        1147.6500244140625,
        -55.5
      ],
      "bbox_max": [
        388.25,
        1149.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 260.4317626953125,
      "bbox_min": [
        386.25,
        1147.1500244140625,
        -55.5
      ],
      "bbox_max": [
        387.75,
        1149.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 681.6710815429688,
      "bbox_min": [
        386.25,
        1145.6500244140625,
        -55.5
      ],
      "bbox_max": [
        389.75,
        1147.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -170.01560974121094,
      "bbox_min": [
        386.25,
        1145.6500244140625,
        -55.5
      ],
      "bbox_max": [
        389.75,
        1147.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 49.499996185302734,
      "bbox_min": [
        395.3755187988281,
        1075.7535400390625,
        -55.5
      ],
      "bbox_max": [
        410.61041259765625,
        1083.3228759765625,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43678605556488037,
        -0.8995654582977295,
        0.0
      ],
      "plane_d": 794.7662353515625,
      "bbox_min": [
        395.94757080078125,
        1075.7535400390625,
        -55.5
      ],
      "bbox_max": [
        410.61041259765625,
        1082.873046875,
        -49.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": -51.405696868896484,
      "bbox_min": [
        374.0,
        1082.4000244140625,
        -55.5
      ],
      "bbox_max": [
        401.5,
        1133.9000244140625,
        -50.90570068359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": 50.905696868896484,
      "bbox_min": [
        374.0,
        1082.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        401.5,
        1133.9000244140625,
        -50.90570068359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -1177.287841796875,
      "bbox_min": [
        374.0,
        1082.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        401.5,
        1133.9000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -1160.98046875,
      "bbox_min": [
        381.0,
        1082.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        401.5,
        1114.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -857.5186157226562,
      "bbox_min": [
        391.5,
        1082.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        401.5,
        1092.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 848.27978515625,
      "bbox_min": [
        391.5,
        1082.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        401.5,
        1090.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -787.0458984375,
      "bbox_min": [
        391.5,
        1083.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        401.5,
        1090.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -54.401641845703125,
      "bbox_min": [
        391.5,
        1083.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        401.5,
        1090.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        -0.0
      ],
      "plane_d": 777.8070068359375,
      "bbox_min": [
        391.5,
        1083.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        401.5,
        1087.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": 45.162750244140625,
      "bbox_min": [
        400.03564453125,
        1083.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        401.5,
        1087.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -881.862060546875,
      "bbox_min": [
        381.0,
        1104.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        391.0,
        1114.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        -0.0
      ],
      "plane_d": 1168.0489501953125,
      "bbox_min": [
        381.0,
        1104.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        391.0,
        1112.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 872.623291015625,
      "bbox_min": [
        381.0,
        1104.4000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        391.0,
        1112.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -785.7635498046875,
      "bbox_min": [
        381.0,
        1105.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        391.0,
        1112.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -72.52099609375,
      "bbox_min": [
        381.0,
        1105.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        391.0,
        1112.935546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        -0.0
      ],
      "plane_d": 776.524658203125,
      "bbox_min": [
        381.0,
        1105.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        391.0,
        1109.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": 63.2821044921875,
      "bbox_min": [
        389.53564453125,
        1105.864501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        391.0,
        1109.4000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        -0.923882782459259,
        -0.0
      ],
      "plane_d": 1183.385986328125,
      "bbox_min": [
        374.0,
        1123.9000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        384.0,
        1133.9000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -1192.624755859375,
      "bbox_min": [
        374.0,
        1123.9000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        384.0,
        1133.9000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267579674720764,
        0.923882782459259,
        0.0
      ],
      "plane_d": -902.5565795898438,
      "bbox_min": [
        374.0,
        1123.9000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        384.0,
        1133.9000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267579674720764,
        -0.923882782459259,
        0.0
      ],
      "plane_d": 893.3178100585938,
      "bbox_min": [
        374.0,
        1123.9000244140625,
        -51.40570068359375
      ],
      "bbox_max": [
        384.0,
        1132.435546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -786.7581787109375,
      "bbox_min": [
        374.0,
        1125.364501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        384.0,
        1132.435546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        0.38265982270240784,
        0.0
      ],
      "plane_d": -86.4500732421875,
      "bbox_min": [
        374.0,
        1125.364501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        384.0,
        1132.435546875,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238893389701843,
        -0.38265982270240784,
        -0.0
      ],
      "plane_d": 777.519287109375,
      "bbox_min": [
        374.0,
        1125.364501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        384.0,
        1128.9000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238893389701843,
        -0.38265982270240784,
        0.0
      ],
      "plane_d": 77.211181640625,
      "bbox_min": [
        382.53564453125,
        1125.364501953125,
        -51.40570068359375
      ],
      "bbox_max": [
        384.0,
        1128.9000244140625,
        -50.90570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 385.75,
      "bbox_min": [
        377.25,
        1085.6500244140625,
        -55.5
      ],
      "bbox_max": [
        398.25,
        1130.6500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1109.1500244140625,
      "bbox_min": [
        385.75,
        1085.6500244140625,
        -55.5
      ],
      "bbox_max": [
        398.25,
        1111.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1109.6500244140625,
      "bbox_min": [
        385.75,
        1109.1500244140625,
        -55.5
      ],
      "bbox_max": [
        387.75,
        1111.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -386.25,
      "bbox_min": [
        386.25,
        1109.1500244140625,
        -55.5
      ],
      "bbox_max": [
        387.75,
        1109.6500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -168.9062042236328,
      "bbox_min": [
        386.25,
        1109.1500244140625,
        -55.5
      ],
      "bbox_max": [
        387.75,
        1109.6500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -570.1763305664062,
      "bbox_min": [
        385.75,
        1109.6500244140625,
        -55.5
      ],
      "bbox_max": [
        387.75,
        1111.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -168.9062042236328,
      "bbox_min": [
        386.25,
        1107.6500244140625,
        -55.5
      ],
      "bbox_max": [
        387.75,
        1109.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -174.73056030273438,
      "bbox_min": [
        394.75,
        1085.6500244140625,
        -55.5
      ],
      "bbox_max": [
        398.25,
        1089.1500244140625,
        -54.16667175292969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 648.3890991210938,
      "bbox_min": [
        394.75,
        1085.6500244140625,
        -55.5
      ],
      "bbox_max": [
        398.25,
        1087.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -396.75,
      "bbox_min": [
        396.75,
        1087.1500244140625,
        -54.5
      ],
      "bbox_max": [
        396.75,
        1087.6500244140625,
        -54.16667175292969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 396.25,
      "bbox_min": [
        396.25,
        1087.1500244140625,
        -54.5
      ],
      "bbox_max": [
        396.75,
        1087.6500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -570.1763305664062,
      "bbox_min": [
        384.25,
        1107.6500244140625,
        -55.5
      ],
      "bbox_max": [
        385.75,
        1111.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1128.6500244140625,
      "bbox_min": [
        378.75,
        1127.1500244140625,
        -55.5
      ],
      "bbox_max": [
        380.75,
        1130.6500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1129.1500244140625,
      "bbox_min": [
        378.75,
        1128.6500244140625,
        -55.5
      ],
      "bbox_max": [
        380.75,
        1130.6500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -379.25,
      "bbox_min": [
        379.25,
        1128.6500244140625,
        -55.5
      ],
      "bbox_max": [
        380.75,
        1129.1500244140625,
        -51.40570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -165.0233154296875,
      "bbox_min": [
        379.25,
        1128.6500244140625,
        -55.5
      ],
      "bbox_max": [
        380.75,
        1129.1500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -580.9929809570312,
      "bbox_min": [
        378.75,
        1129.1500244140625,
        -55.5
      ],
      "bbox_max": [
        380.75,
        1130.6500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 255.43943786621094,
      "bbox_min": [
        377.25,
        1127.1500244140625,
        -55.5
      ],
      "bbox_max": [
        378.75,
        1130.6500244140625,
        -54.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 619.4979858398438,
      "bbox_min": [
        527.75,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1088.596435546875,
        -66.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        527.75,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1088.596435546875,
        -66.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        527.75,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1088.596435546875,
        -66.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        527.75,
        974.6000366210938,
        -75.0
      ],
      "bbox_max": [
        613.9696044921875,
        1088.596435546875,
        -66.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 990.0000610351562,
      "bbox_min": [
        552.0,
        974.6000366210938,
        -70.0
      ],
      "bbox_max": [
        613.9696044921875,
        1004.9035034179688,
        -66.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1004.9035034179688,
      "bbox_min": [
        552.0,
        1000.0,
        -70.0
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -66.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        552.0,
        1000.0,
        -70.0
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -66.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 558.0,
      "bbox_min": [
        552.0,
        1000.0,
        -70.0
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -66.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -552.0,
      "bbox_min": [
        552.0,
        1000.0,
        -70.0
      ],
      "bbox_max": [
        552.0,
        1004.9035034179688,
        -66.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.6000366210938,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -70.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -66.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 613.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -70.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -66.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -70.0
      ],
      "bbox_max": [
        597.9696044921875,
        990.0000610351562,
        -66.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6929634809494019,
        -0.14072294533252716,
        -0.7071057558059692
      ],
      "plane_d": 498.09326171875,
      "bbox_min": [
        527.75,
        974.6000366210938,
        -75.0
      ],
      "bbox_max": [
        613.9696044921875,
        1088.596435546875,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.6000366210938,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -75.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 990.0000610351562,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -75.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 613.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -75.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -75.0
      ],
      "bbox_max": [
        597.9696044921875,
        990.0000610351562,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6929629445075989,
        -0.1407228410243988,
        -0.7071064114570618
      ],
      "plane_d": -271.4425354003906,
      "bbox_min": [
        527.75,
        1000.0,
        -75.0
      ],
      "bbox_max": [
        582.75,
        1088.596435546875,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6929629445075989,
        0.1407228410243988,
        -0.7071064114570618
      ],
      "plane_d": 203.48953247070312,
      "bbox_min": [
        527.75,
        1000.0,
        -75.0
      ],
      "bbox_max": [
        582.75,
        1088.596435546875,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.692962646484375,
        0.14072278141975403,
        -0.7071067094802856
      ],
      "plane_d": -566.0455932617188,
      "bbox_min": [
        527.75,
        1000.0,
        -75.0
      ],
      "bbox_max": [
        577.4979858398438,
        1088.596435546875,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5360549092292786,
        -0.4611365795135498,
        -0.7071054577827454
      ],
      "plane_d": 751.1585693359375,
      "bbox_min": [
        533.0020141601562,
        1000.0,
        -75.0
      ],
      "bbox_max": [
        577.4979858398438,
        1088.596435546875,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5360560417175293,
        -0.461137592792511,
        -0.707103967666626
      ],
      "plane_d": 155.87020874023438,
      "bbox_min": [
        533.0020141601562,
        1000.0,
        -75.0
      ],
      "bbox_max": [
        577.4979858398438,
        1088.596435546875,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -763.6071166992188,
      "bbox_min": [
        533.0020141601562,
        1000.0,
        -75.0
      ],
      "bbox_max": [
        577.4979858398438,
        1088.596435546875,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1004.9035034179688,
      "bbox_min": [
        552.0,
        1000.0,
        -75.0
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        552.0,
        1000.0,
        -75.0
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 558.0,
      "bbox_min": [
        552.0,
        1000.0,
        -75.0
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -552.0,
      "bbox_min": [
        552.0,
        1000.0,
        -75.0
      ],
      "bbox_max": [
        552.0,
        1004.9035034179688,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5360561013221741,
        0.4611358344554901,
        -0.7071052193641663
      ],
      "plane_d": -809.5196533203125,
      "bbox_min": [
        533.0020141601562,
        1004.9035034179688,
        -75.0
      ],
      "bbox_max": [
        577.4979858398438,
        1088.596435546875,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5360546708106995,
        0.4611346423625946,
        -0.7071069478988647
      ],
      "plane_d": -214.22909545898438,
      "bbox_min": [
        545.76123046875,
        1004.9035034179688,
        -75.0
      ],
      "bbox_max": [
        577.4979858398438,
        1088.596435546875,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 716.7208862304688,
      "bbox_min": [
        545.76123046875,
        1037.51123046875,
        -75.0
      ],
      "bbox_max": [
        564.23876953125,
        1088.596435546875,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5359674096107483,
        0.5359771251678467,
        -0.6522786617279053
      ],
      "plane_d": -910.919677734375,
      "bbox_min": [
        545.76123046875,
        1037.51123046875,
        -74.62987518310547
      ],
      "bbox_max": [
        564.23876953125,
        1055.98876953125,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5359757542610168,
        -0.5359854698181152,
        -0.6522650122642517
      ],
      "plane_d": 211.15341186523438,
      "bbox_min": [
        545.76123046875,
        1037.51123046875,
        -74.62987518310547
      ],
      "bbox_max": [
        564.23876953125,
        1055.98876953125,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5359757542610168,
        0.5359854698181152,
        -0.6522650122642517
      ],
      "plane_d": -315.99908447265625,
      "bbox_min": [
        545.76123046875,
        1037.51123046875,
        -74.62987518310547
      ],
      "bbox_max": [
        564.23876953125,
        1055.98876953125,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5359674096107483,
        -0.5359771251678467,
        -0.6522786617279053
      ],
      "plane_d": 806.072265625,
      "bbox_min": [
        545.76123046875,
        1037.51123046875,
        -74.62987518310547
      ],
      "bbox_max": [
        564.23876953125,
        1055.98876953125,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321520447731018,
        -0.19617503881454468,
        -0.6522796154022217
      ],
      "plane_d": -253.42193603515625,
      "bbox_min": [
        545.76123046875,
        1037.51123046875,
        -74.62987518310547
      ],
      "bbox_max": [
        564.23876953125,
        1055.98876953125,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7321520447731018,
        0.19617503881454468,
        -0.6522796154022217
      ],
      "plane_d": 148.57440185546875,
      "bbox_min": [
        545.76123046875,
        1037.51123046875,
        -74.62987518310547
      ],
      "bbox_max": [
        564.23876953125,
        1055.98876953125,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321532368659973,
        0.19617535173892975,
        -0.6522782444953918
      ],
      "plane_d": -664.115234375,
      "bbox_min": [
        545.76123046875,
        1037.51123046875,
        -74.62987518310547
      ],
      "bbox_max": [
        564.23876953125,
        1055.98876953125,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7321532368659973,
        -0.19617535173892975,
        -0.6522782444953918
      ],
      "plane_d": 559.2679443359375,
      "bbox_min": [
        545.76123046875,
        1037.51123046875,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1055.98876953125,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1961846500635147,
        0.7321518063545227,
        -0.6522770524024963
      ],
      "plane_d": -709.9210205078125,
      "bbox_min": [
        547.928955078125,
        1037.51123046875,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1055.98876953125,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961846500635147,
        -0.7321518063545227,
        -0.6522770524024963
      ],
      "plane_d": 605.0737915039062,
      "bbox_min": [
        547.928955078125,
        1037.51123046875,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1055.98876953125,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19618849456310272,
        0.7321661114692688,
        -0.6522597670555115
      ],
      "plane_d": -927.7019653320312,
      "bbox_min": [
        547.928955078125,
        1037.51123046875,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1055.98876953125,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19618849456310272,
        -0.7321661114692688,
        -0.6522597670555115
      ],
      "plane_d": 822.8569946289062,
      "bbox_min": [
        547.928955078125,
        1037.51123046875,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1053.821044921875,
        -70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3256462514400482,
        0.3256385624408722,
        -0.8876452445983887
      ],
      "plane_d": -589.0362548828125,
      "bbox_min": [
        547.928955078125,
        1039.678955078125,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1053.821044921875,
        -72.43317413330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3256462514400482,
        -0.3256385624408722,
        -0.8876452445983887
      ],
      "plane_d": 454.1553955078125,
      "bbox_min": [
        547.928955078125,
        1039.678955078125,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1053.821044921875,
        -72.43317413330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32563725113868713,
        0.3256295621395111,
        -0.8876518607139587
      ],
      "plane_d": -227.5648956298828,
      "bbox_min": [
        547.928955078125,
        1039.678955078125,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1053.821044921875,
        -72.43317413330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32563725113868713,
        -0.3256295621395111,
        -0.8876518607139587
      ],
      "plane_d": 92.68325805664062,
      "bbox_min": [
        547.928955078125,
        1039.678955078125,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1053.821044921875,
        -72.43317413330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11918219178915024,
        0.4448291063308716,
        -0.8876501321792603
      ],
      "plane_d": -466.91943359375,
      "bbox_min": [
        547.928955078125,
        1039.678955078125,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1053.821044921875,
        -72.43317413330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11918219178915024,
        -0.4448291063308716,
        -0.8876501321792603
      ],
      "plane_d": 332.03802490234375,
      "bbox_min": [
        547.928955078125,
        1039.678955078125,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1053.821044921875,
        -72.43317413330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11918091773986816,
        0.44482436776161194,
        -0.8876526951789856
      ],
      "plane_d": -599.2062377929688,
      "bbox_min": [
        547.928955078125,
        1039.678955078125,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1053.821044921875,
        -72.43317413330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11918091773986816,
        -0.44482436776161194,
        -0.8876526951789856
      ],
      "plane_d": 464.3244323730469,
      "bbox_min": [
        547.928955078125,
        1039.678955078125,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1050.5767822265625,
        -72.43317413330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4448353350162506,
        0.11919154226779938,
        -0.8876457214355469
      ],
      "plane_d": -439.08782958984375,
      "bbox_min": [
        547.928955078125,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1050.5767822265625,
        -72.43317413330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4448353350162506,
        -0.11919154226779938,
        -0.8876457214355469
      ],
      "plane_d": 304.2069091796875,
      "bbox_min": [
        547.928955078125,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1050.5767822265625,
        -72.43317413330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4448358714580536,
        -0.11919169127941132,
        -0.8876454830169678
      ],
      "plane_d": -189.5604248046875,
      "bbox_min": [
        547.928955078125,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        562.071044921875,
        1050.5767822265625,
        -72.43317413330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4448358714580536,
        0.11919169127941132,
        -0.8876454830169678
      ],
      "plane_d": 54.6795654296875,
      "bbox_min": [
        547.928955078125,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        558.8268432617188,
        1050.5767822265625,
        -72.43317413330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14743494987487793,
        0.039504099637269974,
        -0.9882825016975403
      ],
      "plane_d": -196.93272399902344,
      "bbox_min": [
        551.1731567382812,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        558.8268432617188,
        1050.5767822265625,
        -74.05897521972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14743494987487793,
        0.039504099637269974,
        -0.9882825016975403
      ],
      "plane_d": -33.27992248535156,
      "bbox_min": [
        551.1731567382812,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        558.8268432617188,
        1050.5767822265625,
        -74.05897521972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14743494987487793,
        -0.039504099637269974,
        -0.9882825016975403
      ],
      "plane_d": 49.42191696166992,
      "bbox_min": [
        551.1731567382812,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        558.8268432617188,
        1050.5767822265625,
        -74.05897521972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14743494987487793,
        -0.039504099637269974,
        -0.9882825016975403
      ],
      "plane_d": -114.23088073730469,
      "bbox_min": [
        551.6858520507812,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        558.8268432617188,
        1050.5767822265625,
        -74.05897521972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10792570561170578,
        0.1079351082444191,
        -0.9882823824882507
      ],
      "plane_d": -246.63522338867188,
      "bbox_min": [
        551.6858520507812,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        558.3141479492188,
        1050.5767822265625,
        -74.05897521972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10792569816112518,
        0.1079351082444191,
        -0.9882823824882507
      ],
      "plane_d": -126.83770751953125,
      "bbox_min": [
        551.6858520507812,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        558.3141479492188,
        1050.5767822265625,
        -74.05897521972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10792570561170578,
        -0.1079351082444191,
        -0.9882823824882507
      ],
      "plane_d": 99.12444305419922,
      "bbox_min": [
        551.6858520507812,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        558.3141479492188,
        1050.5767822265625,
        -74.05897521972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10792569816112518,
        -0.1079351082444191,
        -0.9882823824882507
      ],
      "plane_d": -20.673084259033203,
      "bbox_min": [
        553.0866088867188,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        558.3141479492188,
        1050.5767822265625,
        -74.05897521972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0395059771835804,
        0.14743724465370178,
        -0.9882821440696716
      ],
      "plane_d": -250.01112365722656,
      "bbox_min": [
        553.0866088867188,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        556.9133911132812,
        1050.5767822265625,
        -74.05897521972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0395059809088707,
        0.14743725955486298,
        -0.9882821440696716
      ],
      "plane_d": -206.15951538085938,
      "bbox_min": [
        553.0866088867188,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        556.9133911132812,
        1050.5767822265625,
        -74.05897521972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0395059771835804,
        -0.14743724465370178,
        -0.9882821440696716
      ],
      "plane_d": 102.5003890991211,
      "bbox_min": [
        553.0866088867188,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        556.9133911132812,
        1046.75,
        -74.05897521972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0395059809088707,
        -0.14743725955486298,
        -0.9882821440696716
      ],
      "plane_d": 58.648765563964844,
      "bbox_min": [
        555.0,
        1042.9232177734375,
        -74.62987518310547
      ],
      "bbox_max": [
        556.9133911132812,
        1046.75,
        -74.05897521972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1072.612548828125,
      "bbox_min": [
        527.75,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1088.596435546875,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7580947279930115,
        -0.6521444320678711,
        -0.0
      ],
      "plane_d": 1137.2965087890625,
      "bbox_min": [
        533.0020141601562,
        1072.612548828125,
        -90.0
      ],
      "bbox_max": [
        577.4979858398438,
        1088.596435546875,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7580947279930115,
        -0.6521444320678711,
        0.0
      ],
      "plane_d": 295.4322814941406,
      "bbox_min": [
        533.0020141601562,
        1072.612548828125,
        -90.0
      ],
      "bbox_max": [
        577.4979858398438,
        1088.596435546875,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1088.596435546875,
      "bbox_min": [
        533.0020141601562,
        1072.612548828125,
        -90.0
      ],
      "bbox_max": [
        577.4979858398438,
        1088.596435546875,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 86.0,
      "bbox_min": [
        533.0020141601562,
        1072.612548828125,
        -90.0
      ],
      "bbox_max": [
        577.4979858398438,
        1088.596435546875,
        -86.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1085.096435546875,
      "bbox_min": [
        548.3579711914062,
        1085.096435546875,
        -90.0
      ],
      "bbox_max": [
        562.1420288085938,
        1085.096435546875,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -562.0,
      "bbox_min": [
        527.75,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1072.612548828125,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 548.0,
      "bbox_min": [
        527.75,
        1000.0,
        -90.0
      ],
      "bbox_max": [
        562.0,
        1072.612548828125,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -86.19999694824219,
      "bbox_min": [
        548.0,
        1000.0,
        -90.0
      ],
      "bbox_max": [
        562.0,
        1066.0,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 85.69999694824219,
      "bbox_min": [
        548.0,
        1000.0,
        -86.19999694824219
      ],
      "bbox_max": [
        562.0,
        1066.0,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1027.5,
      "bbox_min": [
        548.0,
        1000.0,
        -86.19999694824219
      ],
      "bbox_max": [
        562.0,
        1066.0,
        -85.69999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1066.0,
      "bbox_min": [
        548.0,
        1066.0,
        -86.19999694824219
      ],
      "bbox_max": [
        562.0,
        1066.0,
        -85.69999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        548.0,
        1000.0,
        -86.19999694824219
      ],
      "bbox_max": [
        562.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 558.0,
      "bbox_min": [
        548.0,
        1000.0,
        -86.19999694824219
      ],
      "bbox_max": [
        562.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1004.9035034179688,
      "bbox_min": [
        558.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      "bbox_max": [
        562.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1005.89990234375,
      "bbox_min": [
        558.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      "bbox_max": [
        560.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        560.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      "bbox_max": [
        560.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -552.0,
      "bbox_min": [
        548.0,
        1000.0,
        -86.19999694824219
      ],
      "bbox_max": [
        552.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1004.9034423828125,
      "bbox_min": [
        548.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      "bbox_max": [
        552.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1005.8999633789062,
      "bbox_min": [
        550.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      "bbox_max": [
        552.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 550.0,
      "bbox_min": [
        550.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      "bbox_max": [
        550.0,
        1005.8999633789062,
        -85.69999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1004.9035034179688,
      "bbox_min": [
        548.0,
        1000.0,
        -85.69999694824219
      ],
      "bbox_max": [
        562.0,
        1005.8999633789062,
        -75.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -552.0,
      "bbox_min": [
        552.0,
        1000.0,
        -85.69999694824219
      ],
      "bbox_max": [
        552.0,
        1004.9035034179688,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 80.5,
      "bbox_min": [
        550.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      "bbox_max": [
        560.0,
        1005.8999633789062,
        -80.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1005.89990234375,
      "bbox_min": [
        550.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      "bbox_max": [
        560.0,
        1005.8999633789062,
        -80.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 550.0,
      "bbox_min": [
        550.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      "bbox_max": [
        560.0,
        1005.8999633789062,
        -80.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        552.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      "bbox_max": [
        560.0,
        1005.8999633789062,
        -80.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -82.5,
      "bbox_min": [
        552.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      "bbox_max": [
        558.0,
        1005.8999633789062,
        -82.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 558.0,
      "bbox_min": [
        552.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      "bbox_max": [
        558.0,
        1005.8999633789062,
        -82.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -552.0,
      "bbox_min": [
        552.0,
        1004.9035034179688,
        -85.69999694824219
      ],
      "bbox_max": [
        552.0,
        1005.8999633789062,
        -82.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1004.9035034179688,
      "bbox_min": [
        548.0,
        1000.0,
        -90.0
      ],
      "bbox_max": [
        562.0,
        1062.5,
        -86.19999694824219
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -552.0,
      "bbox_min": [
        552.0,
        1000.0,
        -90.0
      ],
      "bbox_max": [
        552.0,
        1004.9035034179688,
        -86.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -556.5,
      "bbox_min": [
        550.0,
        1004.9035034179688,
        -90.0
      ],
      "bbox_max": [
        560.0,
        1062.5,
        -86.19999694824219
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 553.5,
      "bbox_min": [
        550.0,
        1004.9035034179688,
        -90.0
      ],
      "bbox_max": [
        556.5,
        1062.5,
        -86.19999694824219
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 88.79999542236328,
      "bbox_min": [
        553.5,
        1004.9035034179688,
        -90.0
      ],
      "bbox_max": [
        556.5,
        1062.5,
        -86.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1038.0,
      "bbox_min": [
        553.5,
        1005.8999633789062,
        -90.0
      ],
      "bbox_max": [
        556.5,
        1055.5,
        -88.79999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1055.5,
      "bbox_min": [
        553.5,
        1055.5,
        -90.0
      ],
      "bbox_max": [
        556.5,
        1055.5,
        -88.79999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1005.8999633789062,
      "bbox_min": [
        553.5,
        1005.8999633789062,
        -90.0
      ],
      "bbox_max": [
        556.5,
        1005.8999633789062,
        -88.79999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3481863737106323,
        -0.9374253749847412
      ],
      "plane_d": 278.1741027832031,
      "bbox_min": [
        553.5,
        1004.9035034179688,
        -88.79999542236328
      ],
      "bbox_max": [
        556.5,
        1062.5,
        -86.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3481863737106323,
        0.9374253749847412
      ],
      "plane_d": 449.88360595703125,
      "bbox_min": [
        553.5,
        1033.5,
        -88.79999542236328
      ],
      "bbox_max": [
        556.5,
        1062.5,
        -86.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3481863737106323,
        -0.9374253749847412
      ],
      "plane_d": -450.75408935546875,
      "bbox_min": [
        553.5,
        1055.5,
        -88.79999542236328
      ],
      "bbox_max": [
        556.5,
        1062.5,
        -86.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3481863737106323,
        0.9374253749847412
      ],
      "plane_d": -279.0445556640625,
      "bbox_min": [
        553.5,
        1033.5,
        -88.79999542236328
      ],
      "bbox_max": [
        556.5,
        1040.5,
        -86.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1005.8999633789062,
      "bbox_min": [
        553.5,
        1004.9035034179688,
        -88.79999542236328
      ],
      "bbox_max": [
        556.5,
        1005.8999633789062,
        -87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 87.0,
      "bbox_min": [
        553.5,
        1004.9035034179688,
        -87.0
      ],
      "bbox_max": [
        556.5,
        1005.8999633789062,
        -87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1005.8999633789062,
      "bbox_min": [
        550.0,
        1004.9035034179688,
        -90.0
      ],
      "bbox_max": [
        553.5,
        1005.8999633789062,
        -86.19999694824219
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 550.0,
      "bbox_min": [
        550.0,
        1004.9035034179688,
        -90.0
      ],
      "bbox_max": [
        553.5,
        1005.8999633789062,
        -86.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 87.0,
      "bbox_min": [
        552.0,
        1004.9035034179688,
        -87.0
      ],
      "bbox_max": [
        553.5,
        1005.8999633789062,
        -86.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -552.0,
      "bbox_min": [
        552.0,
        1004.9035034179688,
        -87.0
      ],
      "bbox_max": [
        552.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1005.8999633789062,
      "bbox_min": [
        556.5,
        1004.9035034179688,
        -90.0
      ],
      "bbox_max": [
        560.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        556.5,
        1004.9035034179688,
        -90.0
      ],
      "bbox_max": [
        560.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 87.0,
      "bbox_min": [
        556.5,
        1004.9035034179688,
        -87.0
      ],
      "bbox_max": [
        558.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 558.0,
      "bbox_min": [
        558.0,
        1004.9035034179688,
        -87.0
      ],
      "bbox_max": [
        558.0,
        1005.8999633789062,
        -86.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9799970388412476,
        -0.19901204109191895,
        0.0
      ],
      "plane_d": -308.8775634765625,
      "bbox_min": [
        527.75,
        1004.9035034179688,
        -90.0
      ],
      "bbox_max": [
        548.0,
        1072.612548828125,
        -75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9799970388412476,
        0.19901204109191895,
        -0.0
      ],
      "plane_d": -725.50927734375,
      "bbox_min": [
        527.75,
        1004.9035034179688,
        -90.0
      ],
      "bbox_max": [
        548.0,
        1072.612548828125,
        -75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.758095920085907,
        0.6521430015563965,
        -0.0
      ],
      "plane_d": -1069.831298828125,
      "bbox_min": [
        533.0020141601562,
        1004.9035034179688,
        -90.0
      ],
      "bbox_max": [
        548.0,
        1072.612548828125,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1004.9034423828125,
      "bbox_min": [
        533.0020141601562,
        1004.9035034179688,
        -90.0
      ],
      "bbox_max": [
        548.0,
        1072.612548828125,
        -75.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6521403789520264,
        -0.7580983638763428,
        -0.0
      ],
      "plane_d": 1160.7379150390625,
      "bbox_min": [
        533.0020141601562,
        1070.330078125,
        -90.0
      ],
      "bbox_max": [
        537.6188354492188,
        1072.612548828125,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7580946087837219,
        -0.6521446108818054,
        0.0
      ],
      "plane_d": 291.9325866699219,
      "bbox_min": [
        533.0020141601562,
        1070.330078125,
        -90.0
      ],
      "bbox_max": [
        537.6188354492188,
        1072.612548828125,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 86.0,
      "bbox_min": [
        533.0020141601562,
        1070.330078125,
        -86.0
      ],
      "bbox_max": [
        537.6188354492188,
        1072.612548828125,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1020.887451171875,
      "bbox_min": [
        562.0,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1072.612548828125,
        -75.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -600.9696044921875,
      "bbox_min": [
        562.0,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        613.9696044921875,
        1020.887451171875,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.758095920085907,
        0.6521430015563965,
        0.0
      ],
      "plane_d": -227.9656982421875,
      "bbox_min": [
        562.0,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        600.9696044921875,
        1020.887451171875,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.9696044921875,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        600.9696044921875,
        990.0000610351562,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.6000366210938,
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        600.9696044921875,
        990.0000610351562,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 990.0000610351562,
      "bbox_min": [
        597.9696044921875,
        990.0000610351562,
        -90.0
      ],
      "bbox_max": [
        600.9696044921875,
        990.0000610351562,
        -75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1004.9035034179688,
      "bbox_min": [
        562.0,
        1004.9035034179688,
        -90.0
      ],
      "bbox_max": [
        563.7479858398438,
        1004.9035034179688,
        -75.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 610.9696044921875,
      "bbox_min": [
        600.9696044921875,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        613.9696044921875,
        1020.887451171875,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 613.9696044921875,
      "bbox_min": [
        610.9696044921875,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.6000366210938,
      "bbox_min": [
        610.9696044921875,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 990.0000610351562,
      "bbox_min": [
        610.9696044921875,
        989.9500732421875,
        -90.0
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 989.9500732421875,
      "bbox_min": [
        611.3800048828125,
        989.9500732421875,
        -87.5
      ],
      "bbox_max": [
        613.5799560546875,
        989.9500732421875,
        -84.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        600.9696044921875,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        610.9696044921875,
        1020.887451171875,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.6000366210938,
      "bbox_min": [
        600.9696044921875,
        974.6000366210938,
        -79.0
      ],
      "bbox_max": [
        610.9696044921875,
        990.0000610351562,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 990.0000610351562,
      "bbox_min": [
        600.9696044921875,
        990.0000610351562,
        -79.0
      ],
      "bbox_max": [
        610.9696044921875,
        990.0000610351562,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -974.6000366210938,
      "bbox_min": [
        600.9696044921875,
        974.6000366210938,
        -90.0
      ],
      "bbox_max": [
        610.9696044921875,
        974.6000366210938,
        -79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9799976944923401,
        -0.19900886714458466,
        -9.301749742007814e-06
      ],
      "plane_d": -364.28179931640625,
      "bbox_min": [
        572.8811645507812,
        1020.887451171875,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1072.612548828125,
        -75.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9799969792366028,
        -0.19901204109191895,
        -1.4590154933102895e-06
      ],
      "plane_d": 779.4089965820312,
      "bbox_min": [
        572.8811645507812,
        1020.887451171875,
        -90.0
      ],
      "bbox_max": [
        584.9406127929688,
        1072.612548828125,
        -75.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9799970388412476,
        0.19901211559772491,
        -4.314161742513534e-06
      ],
      "plane_d": -780.9094848632812,
      "bbox_min": [
        579.028564453125,
        1047.0484619140625,
        -90.0
      ],
      "bbox_max": [
        584.9406127929688,
        1072.612548828125,
        -75.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.19897933304309845,
        0.9800037145614624,
        0.0
      ],
      "plane_d": -918.2821044921875,
      "bbox_min": [
        579.2469482421875,
        1055.0,
        -90.0
      ],
      "bbox_max": [
        582.5446166992188,
        1064.2984619140625,
        -80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19897933304309845,
        -0.9800037145614624,
        0.0
      ],
      "plane_d": 927.4658203125,
      "bbox_min": [
        579.2469482421875,
        1055.0,
        -90.0
      ],
      "bbox_max": [
        582.5446166992188,
        1064.2984619140625,
        -80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        579.2469482421875,
        1055.0,
        -80.0
      ],
      "bbox_max": [
        582.5446166992188,
        1064.2984619140625,
        -80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        580.2255859375,
        1050.0,
        -90.0
      ],
      "bbox_max": [
        584.9406127929688,
        1071.7081298828125,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 87.0,
      "bbox_min": [
        580.2255859375,
        1067.6771240234375,
        -90.0
      ],
      "bbox_max": [
        584.88037109375,
        1071.7081298828125,
        -78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542449474334717,
        -0.4931878447532654,
        -0.16441155970096588
      ],
      "plane_d": 1008.910400390625,
      "bbox_min": [
        580.2255859375,
        1067.6771240234375,
        -90.0
      ],
      "bbox_max": [
        584.88037109375,
        1071.7081298828125,
        -87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": 13.62518310546875,
      "bbox_min": [
        581.3892822265625,
        1067.6771240234375,
        -90.0
      ],
      "bbox_max": [
        584.88037109375,
        1071.7081298828125,
        -87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9863938689231873,
        -0.16439898312091827
      ],
      "plane_d": 1038.847412109375,
      "bbox_min": [
        581.3892822265625,
        1067.6771240234375,
        -90.0
      ],
      "bbox_max": [
        584.88037109375,
        1071.7081298828125,
        -87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -1041.5277099609375,
      "bbox_min": [
        583.427978515625,
        1069.6927490234375,
        -90.0
      ],
      "bbox_max": [
        584.88037109375,
        1071.7081298828125,
        -87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 344.5024108886719,
      "bbox_min": [
        581.0,
        1068.199951171875,
        -87.0
      ],
      "bbox_max": [
        584.0,
        1071.199951171875,
        -78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1168.2818603515625,
      "bbox_min": [
        581.0,
        1068.199951171875,
        -87.0
      ],
      "bbox_max": [
        584.0,
        1071.199951171875,
        -78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -521.8064575195312,
      "bbox_min": [
        581.0,
        1069.699951171875,
        -87.0
      ],
      "bbox_max": [
        584.0,
        1071.199951171875,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001361846924,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 394.669189453125,
      "bbox_min": [
        581.0,
        1068.199951171875,
        -87.0
      ],
      "bbox_max": [
        582.5,
        1071.199951171875,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1168.2818603515625,
      "bbox_min": [
        581.0,
        1068.199951171875,
        -87.0
      ],
      "bbox_max": [
        584.0,
        1071.199951171875,
        -78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -251.5565185546875,
      "bbox_min": [
        582.5,
        1068.199951171875,
        -87.0
      ],
      "bbox_max": [
        584.0,
        1071.199951171875,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 664.9191284179688,
      "bbox_min": [
        581.0,
        1068.199951171875,
        -87.0
      ],
      "bbox_max": [
        584.0,
        1069.699951171875,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9799970388412476,
        0.19901204109191895,
        -2.3922029868117534e-06
      ],
      "plane_d": 362.7772216796875,
      "bbox_min": [
        572.8811645507812,
        1020.887451171875,
        -90.0
      ],
      "bbox_max": [
        582.75,
        1072.612548828125,
        -75.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.19897933304309845,
        0.9800037145614624,
        -0.0
      ],
      "plane_d": -1123.661865234375,
      "bbox_min": [
        579.1454467773438,
        1028.7015380859375,
        -90.0
      ],
      "bbox_max": [
        582.4430541992188,
        1038.0,
        -80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19897933304309845,
        -0.9800037145614624,
        -0.0
      ],
      "plane_d": 1132.845458984375,
      "bbox_min": [
        579.1454467773438,
        1028.7015380859375,
        -90.0
      ],
      "bbox_max": [
        582.4430541992188,
        1038.0,
        -80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        579.1454467773438,
        1028.7015380859375,
        -80.0
      ],
      "bbox_max": [
        582.4430541992188,
        1038.0,
        -80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6521403789520264,
        -0.7580983638763428,
        0.0
      ],
      "plane_d": 436.5360412597656,
      "bbox_min": [
        572.8811645507812,
        1070.330078125,
        -90.0
      ],
      "bbox_max": [
        577.4979858398438,
        1072.612548828125,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7580946087837219,
        -0.6521446108818054,
        -0.0
      ],
      "plane_d": 1133.796630859375,
      "bbox_min": [
        572.8811645507812,
        1070.330078125,
        -90.0
      ],
      "bbox_max": [
        577.4979858398438,
        1072.612548828125,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 86.0,
      "bbox_min": [
        572.8811645507812,
        1070.330078125,
        -86.0
      ],
      "bbox_max": [
        577.4979858398438,
        1072.612548828125,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -75.5,
      "bbox_min": [
        591.5,
        1057.5,
        -75.5
      ],
      "bbox_max": [
        611.0,
        1061.5,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 365.22064208984375,
      "bbox_min": [
        591.5,
        1057.5,
        -75.5
      ],
      "bbox_max": [
        611.0,
        1061.5,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -485.07525634765625,
      "bbox_min": [
        610.5,
        1057.5,
        -75.5
      ],
      "bbox_max": [
        611.0,
        1061.5,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -585.0,
      "bbox_min": [
        580.2255859375,
        1020.887451171875,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1067.0999755859375,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        580.2255859375,
        1021.6771240234375,
        -90.0
      ],
      "bbox_max": [
        585.0,
        1050.0,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1043.5,
      "bbox_min": [
        580.2255859375,
        1021.6771240234375,
        -90.0
      ],
      "bbox_max": [
        585.0,
        1043.5,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 87.0,
      "bbox_min": [
        580.2255859375,
        1021.6771240234375,
        -90.0
      ],
      "bbox_max": [
        584.88037109375,
        1025.7081298828125,
        -78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": -9.06146240234375,
      "bbox_min": [
        580.2255859375,
        1021.6771240234375,
        -90.0
      ],
      "bbox_max": [
        584.88037109375,
        1025.7081298828125,
        -87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9863938689231873,
        -0.16439898312091827
      ],
      "plane_d": -1026.054931640625,
      "bbox_min": [
        580.2255859375,
        1023.6927490234375,
        -90.0
      ],
      "bbox_max": [
        584.88037109375,
        1025.7081298828125,
        -87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -1018.8388671875,
      "bbox_min": [
        580.2255859375,
        1023.6927490234375,
        -90.0
      ],
      "bbox_max": [
        584.88037109375,
        1025.7081298828125,
        -87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542194962501526,
        0.4932328462600708,
        -0.1644088178873062
      ],
      "plane_d": -23.58245849609375,
      "bbox_min": [
        580.2255859375,
        1023.6927490234375,
        -90.0
      ],
      "bbox_max": [
        581.677978515625,
        1025.7081298828125,
        -87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 311.9754943847656,
      "bbox_min": [
        581.0,
        1022.199951171875,
        -87.0
      ],
      "bbox_max": [
        584.0,
        1025.199951171875,
        -78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1135.7550048828125,
      "bbox_min": [
        581.0,
        1022.199951171875,
        -87.0
      ],
      "bbox_max": [
        584.0,
        1025.199951171875,
        -78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -496.29022216796875,
      "bbox_min": [
        581.0,
        1023.699951171875,
        -87.0
      ],
      "bbox_max": [
        584.0,
        1025.199951171875,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001361846924,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 394.669189453125,
      "bbox_min": [
        581.0,
        1022.199951171875,
        -87.0
      ],
      "bbox_max": [
        582.5,
        1025.199951171875,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1135.7550048828125,
      "bbox_min": [
        581.0,
        1022.199951171875,
        -87.0
      ],
      "bbox_max": [
        584.0,
        1025.199951171875,
        -78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -251.5565185546875,
      "bbox_min": [
        582.5,
        1022.199951171875,
        -87.0
      ],
      "bbox_max": [
        584.0,
        1025.199951171875,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 639.4028930664062,
      "bbox_min": [
        581.0,
        1022.199951171875,
        -87.0
      ],
      "bbox_max": [
        584.0,
        1023.699951171875,
        -86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -75.5,
      "bbox_min": [
        586.0,
        1020.887451171875,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1067.0999755859375,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 676.3475952148438,
      "bbox_min": [
        591.5,
        1031.5,
        -75.5
      ],
      "bbox_max": [
        611.0,
        1035.5,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -785.2420654296875,
      "bbox_min": [
        591.5,
        1031.5,
        -75.5
      ],
      "bbox_max": [
        611.0,
        1035.5,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 365.22064208984375,
      "bbox_min": [
        591.5,
        1031.5,
        -75.5
      ],
      "bbox_max": [
        611.0,
        1035.5,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -485.07525634765625,
      "bbox_min": [
        610.5,
        1031.5,
        -75.5
      ],
      "bbox_max": [
        611.0,
        1035.5,
        -75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 615.4979858398438,
      "bbox_min": [
        586.0,
        1020.887451171875,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1067.0999755859375,
        -76.5999984741211
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 88.0,
      "bbox_min": [
        615.4979858398438,
        1026.5999755859375,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1067.0999755859375,
        -85.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1052.0999755859375,
      "bbox_min": [
        615.4979858398438,
        1026.5999755859375,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1067.0999755859375,
        -88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1067.0999755859375,
      "bbox_min": [
        615.4979858398438,
        1067.0999755859375,
        -90.0
      ],
      "bbox_max": [
        619.4979858398438,
        1067.0999755859375,
        -88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1041.5999755859375,
      "bbox_min": [
        615.4979858398438,
        1026.5999755859375,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1050.5,
        -88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1026.5999755859375,
      "bbox_min": [
        615.4979858398438,
        1026.5999755859375,
        -90.0
      ],
      "bbox_max": [
        619.4979858398438,
        1026.5999755859375,
        -88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 616.0,
      "bbox_min": [
        616.0,
        1043.5,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1050.5,
        -88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1043.5,
      "bbox_min": [
        616.0,
        1043.5,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1050.5,
        -88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.5,
      "bbox_min": [
        616.0,
        1050.5,
        -90.0
      ],
      "bbox_max": [
        619.5,
        1050.5,
        -88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 85.0,
      "bbox_min": [
        615.4979858398438,
        1026.5999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1067.0999755859375,
        -85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -902.6168823242188,
      "bbox_min": [
        615.4979858398438,
        1026.5999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1067.0999755859375,
        -85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 980.4176025390625,
      "bbox_min": [
        615.4979858398438,
        1026.5999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1052.9000244140625,
        -85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 87.60000610351562,
      "bbox_min": [
        615.4979858398438,
        1052.2999267578125,
        -87.60000610351562
      ],
      "bbox_max": [
        619.4979858398438,
        1052.9000244140625,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -879.8079833984375,
      "bbox_min": [
        615.4979858398438,
        1026.5999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1041.5999755859375,
        -85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 87.60000610351562,
      "bbox_min": [
        615.4979858398438,
        1026.5999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1027.4000244140625,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 957.6087036132812,
      "bbox_min": [
        615.4979858398438,
        1026.5999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1026.7999267578125,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9977863430976868,
        0.0,
        0.06650284677743912
      ],
      "plane_d": 622.58203125,
      "bbox_min": [
        615.4979858398438,
        1027.5999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1041.5999755859375,
        -85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1040.5999755859375,
      "bbox_min": [
        618.0980224609375,
        1027.5999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1041.5999755859375,
        -85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1027.5999755859375,
      "bbox_min": [
        618.0980834960938,
        1027.5999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1027.5999755859375,
        -85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 87.60000610351562,
      "bbox_min": [
        618.0980224609375,
        1040.5999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1041.5999755859375,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -892.3305053710938,
      "bbox_min": [
        618.0980224609375,
        1040.5999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1041.5999755859375,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 970.1312255859375,
      "bbox_min": [
        618.0980834960938,
        1040.5999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1040.7999267578125,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -892.3305053710938,
      "bbox_min": [
        615.4979858398438,
        1040.5999755859375,
        -88.0
      ],
      "bbox_max": [
        618.124755859375,
        1041.5999755859375,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 970.1312255859375,
      "bbox_min": [
        615.4979858398438,
        1040.5999755859375,
        -88.0
      ],
      "bbox_max": [
        618.124755859375,
        1040.7999267578125,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1066.0999755859375,
      "bbox_min": [
        618.0980224609375,
        1053.0999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1067.0999755859375,
        -85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1053.0999755859375,
      "bbox_min": [
        618.0980834960938,
        1053.0999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1053.0999755859375,
        -85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 87.60000610351562,
      "bbox_min": [
        618.0980224609375,
        1066.0999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1067.0999755859375,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -915.1394653320312,
      "bbox_min": [
        618.0980224609375,
        1066.0999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1067.0999755859375,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 992.940185546875,
      "bbox_min": [
        618.0980834960938,
        1066.0999755859375,
        -88.0
      ],
      "bbox_max": [
        619.4979858398438,
        1066.2999267578125,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -915.1394653320312,
      "bbox_min": [
        615.4979858398438,
        1066.0999755859375,
        -88.0
      ],
      "bbox_max": [
        618.124755859375,
        1067.0999755859375,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 992.940185546875,
      "bbox_min": [
        615.4979858398438,
        1066.0999755859375,
        -88.0
      ],
      "bbox_max": [
        618.124755859375,
        1066.2999267578125,
        -87.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -600.9696044921875,
      "bbox_min": [
        598.7999877929688,
        1020.887451171875,
        -90.0
      ],
      "bbox_max": [
        613.1696166992188,
        1022.0,
        -76.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 598.7999877929688,
      "bbox_min": [
        598.7999877929688,
        1020.887451171875,
        -90.0
      ],
      "bbox_max": [
        600.9696044921875,
        1022.0,
        -76.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9072597026824951,
        0.42057088017463684
      ],
      "plane_d": -893.9942626953125,
      "bbox_min": [
        598.7999877929688,
        1020.887451171875,
        -79.0
      ],
      "bbox_max": [
        600.9696044921875,
        1022.0,
        -76.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 610.9696044921875,
      "bbox_min": [
        610.9696044921875,
        1020.887451171875,
        -90.0
      ],
      "bbox_max": [
        613.1696166992188,
        1022.0,
        -76.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -613.1696166992188,
      "bbox_min": [
        610.9696044921875,
        1020.887451171875,
        -90.0
      ],
      "bbox_max": [
        613.1696166992188,
        1022.0,
        -76.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9072597026824951,
        0.42057088017463684
      ],
      "plane_d": -893.9942626953125,
      "bbox_min": [
        610.9696044921875,
        1020.887451171875,
        -79.0
      ],
      "bbox_max": [
        613.1696166992188,
        1022.0,
        -76.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -86.9000015258789,
      "bbox_min": [
        586.0,
        1044.5,
        -90.0
      ],
      "bbox_max": [
        588.010009765625,
        1049.0,
        -84.55000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 586.7999877929688,
      "bbox_min": [
        586.7999877929688,
        1044.5,
        -86.9000015258789
      ],
      "bbox_max": [
        587.2000122070312,
        1049.0,
        -84.55000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -587.2000122070312,
      "bbox_min": [
        586.7999877929688,
        1044.5,
        -86.9000015258789
      ],
      "bbox_max": [
        587.2000122070312,
        1049.0,
        -84.55000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 84.55000305175781,
      "bbox_min": [
        586.7999877929688,
        1044.5,
        -86.9000015258789
      ],
      "bbox_max": [
        587.2000122070312,
        1049.0,
        -84.55000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1044.5,
      "bbox_min": [
        586.7999877929688,
        1044.5,
        -86.9000015258789
      ],
      "bbox_max": [
        587.2000122070312,
        1049.0,
        -84.55000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1049.0,
      "bbox_min": [
        586.7999877929688,
        1049.0,
        -86.9000015258789
      ],
      "bbox_max": [
        587.2000122070312,
        1049.0,
        -84.55000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 89.5,
      "bbox_min": [
        586.0,
        1045.25,
        -90.0
      ],
      "bbox_max": [
        588.010009765625,
        1048.25,
        -86.9000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 586.0,
      "bbox_min": [
        586.0,
        1045.25,
        -90.0
      ],
      "bbox_max": [
        588.010009765625,
        1048.25,
        -89.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -588.010009765625,
      "bbox_min": [
        586.0,
        1045.25,
        -90.0
      ],
      "bbox_max": [
        588.010009765625,
        1048.25,
        -89.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1045.25,
      "bbox_min": [
        586.0,
        1045.25,
        -90.0
      ],
      "bbox_max": [
        588.010009765625,
        1048.25,
        -89.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1048.25,
      "bbox_min": [
        586.0,
        1048.25,
        -90.0
      ],
      "bbox_max": [
        588.010009765625,
        1048.25,
        -89.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 586.7999877929688,
      "bbox_min": [
        586.7999877929688,
        1046.5999755859375,
        -89.5
      ],
      "bbox_max": [
        587.2000122070312,
        1047.0,
        -86.9000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1046.5999755859375,
      "bbox_min": [
        586.7999877929688,
        1046.5999755859375,
        -89.5
      ],
      "bbox_max": [
        587.2000122070312,
        1047.0,
        -86.9000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1047.0,
      "bbox_min": [
        586.7999877929688,
        1046.5999755859375,
        -89.5
      ],
      "bbox_max": [
        587.2000122070312,
        1047.0,
        -86.9000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -587.2000122070312,
      "bbox_min": [
        587.2000122070312,
        1046.5999755859375,
        -89.5
      ],
      "bbox_max": [
        587.2000122070312,
        1047.0,
        -86.9000015258789
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: nrt01",
      "entity_class": "CGameArea",
      "piece_name": "nrt01",
      "offset": 54,
      "centroid": [
        539.2426452636719,
        803.8999938964844,
        27.0
      ],
      "bbox_min": [
        532.1715698242188,
        799.7999877929688,
        27.0
      ],
      "bbox_max": [
        546.313720703125,
        808.0,
        27.0
      ],
      "dimensions_source": {
        "span_x": 14.14215087890625,
        "span_y": 8.20001220703125,
        "height_z": 0.0,
        "door_width": 14.14215087890625,
        "door_depth": 8.20001220703125,
        "leaf_depth": 8.20001220703125,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          546.313720703125,
          808.0,
          27.0
        ],
        [
          532.1715698242188,
          808.0,
          27.0
        ],
        [
          532.1715698242188,
          799.7999877929688,
          27.0
        ],
        [
          546.313720703125,
          799.7999877929688,
          27.0
        ]
      ],
      "plane_distance": 27.0
    },
    {
      "tag": "CElevator piece: elevl",
      "entity_class": "CElevator",
      "piece_name": "elevl",
      "offset": 7395,
      "centroid": [
        473.0,
        982.2999877929688,
        -19.25
      ],
      "bbox_min": [
        465.0,
        974.5999755859375,
        -19.5
      ],
      "bbox_max": [
        481.0,
        990.0,
        -19.0
      ],
      "dimensions_source": {
        "span_x": 16.0,
        "span_y": 15.4000244140625,
        "height_z": 0.5,
        "door_width": 16.0,
        "door_depth": 15.4000244140625,
        "leaf_depth": 15.4000244140625,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          465.0,
          974.5999755859375,
          -19.0
        ],
        [
          465.0,
          990.0,
          -19.0
        ],
        [
          481.0,
          974.5999755859375,
          -19.0
        ],
        [
          481.0,
          990.0,
          -19.0
        ],
        [
          465.0,
          974.5999755859375,
          -19.5
        ],
        [
          481.0,
          974.5999755859375,
          -19.5
        ],
        [
          481.0,
          990.0,
          -19.5
        ],
        [
          465.0,
          990.0,
          -19.5
        ]
      ],
      "plane_distance": -990.0,
      "authentic_texture": "spkelevfloor1"
    },
    {
      "tag": "CElevator piece: elevr",
      "entity_class": "CElevator",
      "piece_name": "elevr",
      "offset": 8629,
      "centroid": [
        605.9696044921875,
        983.8400512695313,
        -19.2
      ],
      "bbox_min": [
        597.9696044921875,
        974.6000366210938,
        -19.5
      ],
      "bbox_max": [
        613.9696044921875,
        990.0000610351562,
        -19.0
      ],
      "dimensions_source": {
        "span_x": 16.0,
        "span_y": 15.4000244140625,
        "height_z": 0.5,
        "door_width": 16.0,
        "door_depth": 15.4000244140625,
        "leaf_depth": 15.4000244140625,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          -0.0
        ]
      },
      "vertices": [
        [
          613.9696044921875,
          974.6000366210938,
          -19.0
        ],
        [
          597.9696044921875,
          974.6000366210938,
          -19.0
        ],
        [
          597.9696044921875,
          990.0000610351562,
          -19.0
        ],
        [
          597.9696044921875,
          990.0000610351562,
          -19.0
        ],
        [
          613.9696044921875,
          990.0000610351562,
          -19.0
        ],
        [
          613.9696044921875,
          990.0000610351562,
          -19.0
        ],
        [
          597.9696044921875,
          990.0000610351562,
          -19.5
        ],
        [
          597.9696044921875,
          974.6000366210938,
          -19.5
        ],
        [
          613.9696044921875,
          974.6000366210938,
          -19.5
        ],
        [
          613.9696044921875,
          990.0000610351562,
          -19.5
        ]
      ],
      "plane_distance": 974.6,
      "authentic_texture": "spkelevfloor1"
    },
    {
      "tag": "CSlidingDoor piece: dumwtr",
      "entity_class": "CSlidingDoor",
      "piece_name": "dumwtr",
      "offset": 10042,
      "centroid": [
        555.0,
        1001.9517517089844,
        -57.5
      ],
      "bbox_min": [
        552.0,
        999.0,
        -58.0
      ],
      "bbox_max": [
        558.0,
        1004.9035034179688,
        -57.0
      ],
      "dimensions_source": {
        "span_x": 6.0,
        "span_y": 5.90350341796875,
        "height_z": 1.0,
        "door_width": 6.0,
        "door_depth": 5.90350341796875,
        "leaf_depth": 5.86350341796875,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          552.0,
          1004.9035034179688,
          -57.0
        ],
        [
          558.0,
          1004.9035034179688,
          -57.0
        ],
        [
          552.0,
          999.0,
          -57.0
        ],
        [
          558.0,
          999.0,
          -57.0
        ],
        [
          552.0,
          1004.9035034179688,
          -58.0
        ],
        [
          552.0,
          999.0,
          -58.0
        ],
        [
          558.0,
          999.0,
          -58.0
        ],
        [
          558.0,
          1004.9035034179688,
          -58.0
        ]
      ],
      "plane_distance": 57.0,
      "authentic_texture": "spkelevfloor1"
    },
    {
      "tag": "CSlidingDoor piece: clbelev1",
      "entity_class": "CSlidingDoor",
      "piece_name": "clbelev1",
      "offset": 12259,
      "centroid": [
        419.07540554470484,
        1221.5205213758682,
        -43.394445207383896
      ],
      "bbox_min": [
        411.799560546875,
        1214.2452392578125,
        -43.95000076293945
      ],
      "bbox_max": [
        426.6859130859375,
        1230.6146240234375,
        -42.95000076293945
      ],
      "dimensions_source": {
        "span_x": 14.8863525390625,
        "span_y": 16.369384765625,
        "height_z": 1.0,
        "door_width": 16.369384765625,
        "door_depth": 14.8863525390625,
        "leaf_depth": 14.8463525390625,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.8949,
          0.4462,
          0.0
        ]
      },
      "vertices": [
        [
          420.74871826171875,
          1230.6146240234375,
          -42.95000076293945
        ],
        [
          426.6859130859375,
          1218.70751953125,
          -42.95000076293945
        ],
        [
          417.73675537109375,
          1214.2452392578125,
          -42.95000076293945
        ],
        [
          417.73675537109375,
          1214.2452392578125,
          -42.95000076293945
        ],
        [
          411.799560546875,
          1226.15234375,
          -42.95000076293945
        ],
        [
          426.6859130859375,
          1218.70751953125,
          -43.95000076293945
        ],
        [
          420.74871826171875,
          1230.6146240234375,
          -43.95000076293945
        ],
        [
          411.799560546875,
          1226.15234375,
          -43.95000076293945
        ],
        [
          417.73675537109375,
          1214.2452392578125,
          -43.95000076293945
        ]
      ],
      "plane_distance": -925.6727,
      "authentic_texture": "spkelevfloor1"
    },
    {
      "tag": "CSlidingDoor piece: clbelevr",
      "entity_class": "CSlidingDoor",
      "piece_name": "clbelevr",
      "offset": 17832,
      "centroid": [
        578.5806107954545,
        1222.0915305397727,
        -43.31363712657582
      ],
      "bbox_min": [
        571.8140869140625,
        1214.2452392578125,
        -43.95000076293945
      ],
      "bbox_max": [
        586.700439453125,
        1230.6146240234375,
        -42.95000076293945
      ],
      "dimensions_source": {
        "span_x": 14.8863525390625,
        "span_y": 16.369384765625,
        "height_z": 1.0,
        "door_width": 16.369384765625,
        "door_depth": 14.8863525390625,
        "leaf_depth": 14.8463525390625,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          580.7632446289062,
          1214.2452392578125,
          -42.95000076293945
        ],
        [
          580.7632446289062,
          1214.2452392578125,
          -42.95000076293945
        ],
        [
          586.700439453125,
          1226.15234375,
          -42.95000076293945
        ],
        [
          577.7512817382812,
          1230.6146240234375,
          -42.95000076293945
        ],
        [
          577.7512817382812,
          1230.6146240234375,
          -42.95000076293945
        ],
        [
          571.8140869140625,
          1218.70751953125,
          -42.95000076293945
        ],
        [
          571.8140869140625,
          1218.70751953125,
          -42.95000076293945
        ],
        [
          571.8140869140625,
          1218.70751953125,
          -43.95000076293945
        ],
        [
          580.7632446289062,
          1214.2452392578125,
          -43.95000076293945
        ],
        [
          586.700439453125,
          1226.15234375,
          -43.95000076293945
        ],
        [
          577.7512817382812,
          1230.6146240234375,
          -43.95000076293945
        ]
      ],
      "plane_distance": 42.95,
      "authentic_texture": "spkelevfloor1"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 24572,
      "centroid": [
        536.5,
        934.4959716796875,
        -14.75
      ],
      "bbox_min": [
        534.75,
        934.4959716796875,
        -18.0
      ],
      "bbox_max": [
        538.25,
        934.4959716796875,
        -11.5
      ],
      "dimensions_source": {
        "span_x": 3.5,
        "span_y": 0.0,
        "height_z": 6.5,
        "door_width": 3.5,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          -0.0
        ]
      },
      "vertices": [
        [
          534.75,
          934.4959716796875,
          -18.0
        ],
        [
          538.25,
          934.4959716796875,
          -11.5
        ],
        [
          534.75,
          934.4959716796875,
          -11.5
        ],
        [
          538.25,
          934.4959716796875,
          -18.0
        ]
      ],
      "plane_distance": 934.496,
      "authentic_texture": "hospdeco2"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 25160,
      "centroid": [
        499.42857142857144,
        988.2857142857143,
        -44.57142857142857
      ],
      "bbox_min": [
        496.0,
        986.0,
        -48.0
      ],
      "bbox_max": [
        502.0,
        990.0,
        -42.0
      ],
      "dimensions_source": {
        "span_x": 6.0,
        "span_y": 4.0,
        "height_z": 6.0,
        "door_width": 6.0,
        "door_depth": 4.0,
        "leaf_depth": 4.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          496.0,
          990.0,
          -42.0
        ],
        [
          496.0,
          986.0,
          -42.0
        ],
        [
          496.0,
          990.0,
          -48.0
        ],
        [
          502.0,
          986.0,
          -48.0
        ],
        [
          502.0,
          990.0,
          -42.0
        ],
        [
          502.0,
          986.0,
          -42.0
        ],
        [
          502.0,
          990.0,
          -48.0
        ]
      ],
      "plane_distance": 42.0,
      "authentic_texture": "chkcrate-s_h"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 30352,
      "centroid": [
        555.0,
        999.0,
        -54.75
      ],
      "bbox_min": [
        552.0,
        999.0,
        -57.0
      ],
      "bbox_max": [
        558.0,
        999.0,
        -52.5
      ],
      "dimensions_source": {
        "span_x": 6.0,
        "span_y": 0.0,
        "height_z": 4.5,
        "door_width": 6.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          -0.0
        ]
      },
      "vertices": [
        [
          552.0,
          999.0,
          -57.0
        ],
        [
          552.0,
          999.0,
          -52.5
        ],
        [
          558.0,
          999.0,
          -52.5
        ],
        [
          558.0,
          999.0,
          -57.0
        ]
      ],
      "plane_distance": 999.0
    }
  ],
  "tutorial_messages": []
}